var W=900,H=480,FY=400;
var cv,cx;
var hover=null;
var S;
var mouseX=0,mouseY=0;
var BUILD_V='2026-03-03o';
function R(x,y,w,h,c){cx.fillStyle=c;cx.fillRect(x,y,w,h);}
function C(x,y,r,c){cx.fillStyle=c;cx.beginPath();cx.arc(x,y,r,0,Math.PI*2);cx.fill();}
function T(t,x,y,sz,c,a){cx.fillStyle=c||'#f0e6d3';cx.font=(sz||12)+'px Courier New';cx.textAlign=a||'center';cx.fillText(t,x,y);}

// --- COMPETITORS ROSTER ---
function darkenColor(hex,factor){
  var r=parseInt(hex.slice(1,3),16),g=parseInt(hex.slice(3,5),16),b=parseInt(hex.slice(5,7),16);
  r=Math.round(r*factor);g=Math.round(g*factor);b=Math.round(b*factor);
  return '#'+((1<<24)+(r<<16)+(g<<8)+b).toString(16).slice(1);
}
function lightenColor(hex,factor){
  var r=parseInt(hex.slice(1,3),16),g=parseInt(hex.slice(3,5),16),b=parseInt(hex.slice(5,7),16);
  r=Math.min(255,Math.round(r+(255-r)*factor));g=Math.min(255,Math.round(g+(255-g)*factor));b=Math.min(255,Math.round(b+(255-b)*factor));
  return '#'+((1<<24)+(r<<16)+(g<<8)+b).toString(16).slice(1);
}

var COMPETITORS=[
  {id:'pak',name:'PAK CHOL-MIN',country:'North Korea',flag:'\ud83c\uddf0\ud83c\uddf5',tier:'A',
   skin:'#d4a574',hair:'#111',singlet:'#1a4a1a',
   snRange:[255,275],cjRange:[305,330],failBase:0.06,personality:'hothead',
   scouting:'Emotional lifter. Matches your weight to prove dominance. Gets rattled after a miss — his next attempt often crumbles.'},
  {id:'zhang',name:'ZHANG HAO',country:'China',flag:'\ud83c\udde8\ud83c\uddf3',tier:'A',
   skin:'#e8c898',hair:'#111',singlet:'#cc2222',
   snRange:[255,275],cjRange:[305,330],failBase:0.06,personality:'machine'},
  {id:'park',name:'PARK JOON-HYUK',country:'South Korea',flag:'\ud83c\uddf0\ud83c\uddf7',tier:'A',
   skin:'#e0c090',hair:'#111',singlet:'#1a3a8a',
   snRange:[255,275],cjRange:[305,330],failBase:0.06,personality:'intense'},
  {id:'bejanyan',name:'DATO BEJANYAN',country:'Georgia',flag:'\ud83c\uddec\ud83c\uddea',tier:'A',
   skin:'#d8b088',hair:'#3a2a1a',singlet:'#ffffff',
   snRange:[255,275],cjRange:[305,330],failBase:0.05,personality:'veteran',
   scouting:'Old school. Never takes big jumps. Hits what he opens with, grinds out small increases. You won\'t out-steady him — you have to out-lift him.'},
  {id:'sato',name:'TAKUMI SATO',country:'Japan',flag:'\ud83c\uddef\ud83c\uddf5',tier:'B',
   skin:'#e8c898',hair:'#111',singlet:'#eeeeee',
   snRange:[235,260],cjRange:[280,310],failBase:0.10,personality:'precise'},
  {id:'mehrabi',name:'REZA MEHRABI',country:'Iran',flag:'\ud83c\uddee\ud83c\uddf7',tier:'B',
   skin:'#c49060',hair:'#222',singlet:'#22aa44',
   snRange:[235,260],cjRange:[280,310],failBase:0.10,personality:'sandbagger',
   scouting:'Opens light to lull you to sleep. Saves his real numbers for the 3rd attempt. Don\'t be fooled by early rounds — he\'s hiding his hand.'},
  {id:'lin',name:'LIN WEI-CHENG',country:'Chinese Taipei',flag:'\ud83c\uddf9\ud83c\uddfc',tier:'B',
   skin:'#e0c090',hair:'#222',singlet:'#2244aa',
   snRange:[235,260],cjRange:[280,310],failBase:0.10,personality:'technical'},
  {id:'santoso',name:'ARIF SANTOSO',country:'Indonesia',flag:'\ud83c\uddee\ud83c\udde9',tier:'B',
   skin:'#8b6b40',hair:'#111',singlet:'#cc2222',
   snRange:[235,260],cjRange:[280,310],failBase:0.10,personality:'explosive'},
  {id:'sullivan',name:'JAKE SULLIVAN',country:'USA',flag:'\ud83c\uddfa\ud83c\uddf8',tier:'B',
   skin:'#f0d0a0',hair:'#8b4513',singlet:'#1a3a8a',
   snRange:[235,260],cjRange:[280,310],failBase:0.10,personality:'hyped'},
  {id:'bouchard',name:'MARC-ANTOINE BOUCHARD',country:'Canada',flag:'\ud83c\udde8\ud83c\udde6',tier:'C',
   skin:'#f0d0a0',hair:'#5c3317',singlet:'#cc2222',
   snRange:[215,245],cjRange:[260,290],failBase:0.14,personality:'gritty'},
  {id:'ramirez',name:'DIEGO RAM\u00cdREZ',country:'Mexico',flag:'\ud83c\uddf2\ud83c\uddfd',tier:'C',
   skin:'#c49060',hair:'#111',singlet:'#006847',
   snRange:[215,245],cjRange:[260,290],failBase:0.14,personality:'scrappy'},
  {id:'quintero',name:'ANDR\u00c9S QUINTERO',country:'Colombia',flag:'\ud83c\udde8\ud83c\uddf4',tier:'C',
   skin:'#c49060',hair:'#222',singlet:'#fcd116',
   snRange:[215,245],cjRange:[260,290],failBase:0.14,personality:'fiery'}
];

function createRivalState(comp){
  var snBase=comp.snRange[0]+Math.floor(Math.random()*(comp.snRange[1]-comp.snRange[0]));
  var cjBase=comp.cjRange[0]+Math.floor(Math.random()*(comp.cjRange[1]-comp.cjRange[0]));
  return {
    id:comp.id,name:comp.name,country:comp.country,flag:comp.flag,
    tier:comp.tier,personality:comp.personality,
    skin:comp.skin,hair:comp.hair,singlet:comp.singlet,
    skinDark:darkenColor(comp.skin,0.7),
    mouthStrain:darkenColor(comp.skin,0.5),
    shoulderHighlight:lightenColor(comp.skin,0.15),
    technique:85,strength:90,
    snatchAttempts:[null,null,null],cjAttempts:[null,null,null],
    snatchWeights:[0,0,0],cjWeights:[0,0,0],
    bestSnatch:0,bestCJ:0,attempt:0,
    timer:0,nextLiftAt:0,
    pose:'idle',poseT:0,x:750,
    liftType:null,
    snTargets:[snBase,snBase+15+Math.floor(Math.random()*10),snBase+30+Math.floor(Math.random()*15)],
    cjTargets:[cjBase,cjBase+15+Math.floor(Math.random()*10),cjBase+30+Math.floor(Math.random()*15)],
    active:true,
    failBase:comp.failBase,
    declared:0,done:false,currentAttempt:0,
    scoreColor:comp.singlet,
    scouting:comp.scouting||''
  };
}

function swapRival(rivalObj){
  var r=S.rival;
  var keys=['id','name','country','flag','tier','personality','skin','hair','singlet',
    'skinDark','mouthStrain','shoulderHighlight','technique','strength',
    'snatchAttempts','cjAttempts','snatchWeights','cjWeights',
    'bestSnatch','bestCJ','attempt','timer','nextLiftAt',
    'pose','poseT','x','liftType','snTargets','cjTargets','active',
    'failBase','declared','done','currentAttempt','scoreColor'];
  for(var i=0;i<keys.length;i++){
    if(rivalObj[keys[i]]!==undefined)r[keys[i]]=rivalObj[keys[i]];
  }
}

function syncBack(){
  if(!S.rivals||!S.rival.id)return;
  for(var i=0;i<S.rivals.length;i++){
    if(S.rivals[i].id===S.rival.id){
      var r=S.rival,t=S.rivals[i];
      t.snatchAttempts=r.snatchAttempts.slice();t.cjAttempts=r.cjAttempts.slice();
      t.snatchWeights=r.snatchWeights.slice();t.cjWeights=r.cjWeights.slice();
      t.bestSnatch=r.bestSnatch;t.bestCJ=r.bestCJ;t.attempt=r.attempt;
      t.pose=r.pose;t.poseT=r.poseT;t.x=r.x;
      t.declared=r.declared;t.done=r.done;t.currentAttempt=r.currentAttempt;
      break;
    }
  }
}

function is1v1(){return S.rivals&&S.rivals.length===1;}
window.is1v1=is1v1;

function getAnimSpeed(){
  if(!S.rivals||S.rivals.length<=1)return 1;
  if(S.rivals.length===2)return 1.3;
  if(S.rivals.length<=5)return 1.6;
  return 2;
}

// Generic rival messages (for non-Pak competitors)
var RIVAL_SNATCH_MSGS=[
  "NAME snatches WEIGHT. Clean lift.",
  "WEIGHT goes up for NAME. Good lift.",
  "NAME makes WEIGHT look routine. Solid.",
  "WEIGHT. NAME nods to the judges. White lights.",
  "NAME puts WEIGHT overhead with authority."
];
var RIVAL_CJ_MSGS=[
  "NAME cleans WEIGHT and drives it overhead.",
  "WEIGHT. NAME stands it up. Good lift.",
  "NAME jerks WEIGHT with power to spare.",
  "Clean and jerk at WEIGHT for NAME. Three whites.",
  "NAME puts WEIGHT up. The crowd acknowledges."
];
var RIVAL_FAIL_MSGS=[
  "NAME drops WEIGHT. Frustration on the face.",
  "No lift for NAME at WEIGHT. That one got away.",
  "WEIGHT comes crashing down. NAME shakes it off.",
  "NAME misses WEIGHT. The coaches huddle."
];

// --- Layout (global scope so drawing functions can access) ---
var LAYOUT={
  gym:{homeX:200,benchX:100,rackX:350,tableX:550,shakerX:520,cigX:580,chalkX:300,dumbX:500,platformX:300},
  comp:{homeX:150,benchX:80,rackX:250,tableX:120,shakerX:60,cigX:130,chalkX:210,platformX:450,pakHomeX:750,pakBenchX:820},
  backroom:{homeX:300,benchX:80,shakerX:100,cigX:160,coachX:440,tvX:680,tvY:60,tvW:200,tvH:150,doorX:860,doorY:275,doorW:40,doorH:125,platformX:300,chalkX:220},
  apartment:{homeX:450,fridgeX:130,bathroomX:50,wardrobeX:280,cigX:355,tvX:540,phoneX:640,dumbX:720,doorX:850,mattressX:400,benchX:400},
  beach:{homeX:330,couple0X:150,couple1X:480,couple2X:720,exitX:860},
  downtown:{homeX:450,barX:165,bodegaX:425,hotelX:695,exitX:860}
};
function getLayout(){
  if(window.S&&window.S.phase==='apartment')return LAYOUT.apartment;
  if(window.S&&window.S.phase==='beach')return LAYOUT.beach;
  if(window.S&&window.S.phase==='downtown')return LAYOUT.downtown;
  if(window.S&&window.S.scene==='backroom')return LAYOUT.backroom;
  return (window.S&&window.S.phase==='gym')?LAYOUT.gym:LAYOUT.comp;
}
// Outfit color accessors — read by all drawTark*() functions
function getTarkShirtColor(){
  if(window.S&&S.outfit){
    if(S.outfit.shirtStyle==='none')return '#d4a574';
    return S.outfit.shirt||'#f0e6d3';
  }
  return '#f0e6d3';
}
// Powerlifter abs — muscular gut with visible definition
// tx,ty = center x, torso top y. th = torso height.
function drawTarkAbs(tx,ty,th){
  if(!S.outfit||S.outfit.shirtStyle!=='none')return;
  var my=ty+th*0.5;
  // Pec shadow — darker skin tone under the chest
  cx.globalAlpha=0.45;
  cx.fillStyle='#a87848';
  cx.beginPath();cx.arc(tx-6,ty+8,7,0,Math.PI*2);cx.fill();
  cx.beginPath();cx.arc(tx+6,ty+8,7,0,Math.PI*2);cx.fill();
  // Pec highlights
  cx.globalAlpha=0.25;
  cx.fillStyle='#e0b888';
  cx.beginPath();cx.arc(tx-6,ty+5,5,0,Math.PI*2);cx.fill();
  cx.beginPath();cx.arc(tx+6,ty+5,5,0,Math.PI*2);cx.fill();
  // Barrel gut — the powerlifter belly bulge
  cx.globalAlpha=0.3;
  cx.fillStyle='#c49a68';
  cx.beginPath();cx.ellipse(tx,my+6,11,th*0.3,0,0,Math.PI*2);cx.fill();
  // Gut shadow underneath
  cx.globalAlpha=0.2;
  cx.fillStyle='#8a6a40';
  cx.beginPath();cx.ellipse(tx,my+th*0.35,10,4,0,0,Math.PI*2);cx.fill();
  cx.globalAlpha=1;
  // Ab lines — thick and curved for chunky powerlifter look
  cx.strokeStyle='#8a6a3e';cx.lineWidth=1.5;cx.globalAlpha=0.5;
  // Center line (linea alba)
  cx.beginPath();cx.moveTo(tx,ty+12);cx.lineTo(tx,ty+th-4);cx.stroke();
  // Pec line (under chest)
  cx.beginPath();cx.moveTo(tx-10,ty+14);cx.quadraticCurveTo(tx,ty+16,tx+10,ty+14);cx.stroke();
  // Upper abs
  cx.beginPath();cx.moveTo(tx-9,my-2);cx.quadraticCurveTo(tx,my+1,tx+9,my-2);cx.stroke();
  // Lower abs
  cx.beginPath();cx.moveTo(tx-8,my+8);cx.quadraticCurveTo(tx,my+12,tx+8,my+8);cx.stroke();
  cx.globalAlpha=1;
  // Belly button
  cx.globalAlpha=0.5;C(tx,my+16,2,'#8a6a3e');cx.globalAlpha=1;
}
function getTarkHeadbandColor(){
  if(window.S&&S.outfit&&S.outfit.headband)return S.outfit.headband;
  if(window.S&&S.outfit&&S.outfit.headband===null)return null;
  return '#cc3333';
}
window.getLayout=getLayout;window.LAYOUT=LAYOUT;window.log=log;
function log(msg,cls){
  var el=document.getElementById('tl');
  if(!el)return;
  var d=document.createElement('div');
  d.className='e'+(cls?' '+cls:'');
  d.textContent=msg;
  el.prepend(d);
  while(el.children.length>50)el.removeChild(el.lastChild);
}

// --- Scene ---
function drawFloor(){
R(0,FY,W,H-FY,'#1a1a1a');
cx.strokeStyle='#1f1f1f';cx.lineWidth=1;cx.beginPath();cx.moveTo(0,FY);cx.lineTo(W,FY);cx.stroke();
if(S.phase==='gym'){
  R(210,FY-4,200,8,'#181818');
}
}

function drawGymBackground(){
if(S.phase!=='gym')return;
R(0,0,W,FY,'#131313');
T("TARK'S GYM",250,55,18,'#1c1c1c');
T('NO EXCUSES. JUST CIGARETTES.',250,78,9,'#191919');
R(620,70,120,160,'#1a1a1a');
cx.strokeStyle='#222';cx.lineWidth=1;cx.strokeRect(620,70,120,160);
T('LIFT HEAVY',680,130,10,'#252525');T('DIE NEVER',680,148,10,'#252525');
R(790,80,70,200,'#161616');cx.strokeRect(790,80,70,200);
R(846,180,6,10,'#333');T('EXIT',825,70,9,'#333');
R(450,80,80,60,'#0e0e0e');cx.strokeRect(450,80,80,60);
R(451,81,38,28,'#14140e');R(491,81,38,28,'#14140e');
}

function drawApartmentBackground(){
if(S.phase!=='apartment')return;
// === WALLS — 80s wood paneling ===
R(0,0,W,FY,'#2a1f14');
for(var px=0;px<W;px+=35){
  var shade=px%70===0?'#2d2216':'#261c11';
  R(px,0,34,FY,shade);
  cx.strokeStyle='#1a1408';cx.lineWidth=1;
  cx.beginPath();cx.moveTo(px,0);cx.lineTo(px,FY);cx.stroke();
}
R(0,FY-12,W,12,'#1e160d'); // baseboard

// === FLOOR — dingy carpet ===
R(0,FY,W,H-FY,'#2a2420');
for(var fy=FY;fy<H;fy+=6){
  R(0,fy,W,3,fy%12===0?'#282220':'#2c2622');
}

// === WINDOW — morning light ===
R(170,40,100,100,'#1a1408');
R(174,44,92,92,'#445566');
R(174,88,92,4,'#1a1408');R(218,44,4,92,'#1a1408');
cx.save();
var wGrad=cx.createRadialGradient(220,90,10,220,90,150);
wGrad.addColorStop(0,'rgba(255,230,180,0.08)');wGrad.addColorStop(1,'rgba(255,230,180,0)');
cx.fillStyle=wGrad;cx.fillRect(120,20,200,200);cx.restore();
cx.save();cx.globalAlpha=0.04;
cx.beginPath();cx.moveTo(174,136);cx.lineTo(120,FY);cx.lineTo(310,FY);cx.lineTo(266,136);cx.closePath();
cx.fillStyle='#ffe8b0';cx.fill();cx.restore();

// === CEILING + BARE LIGHTBULB ===
R(0,0,W,2,'#181008');
R(449,0,2,16,'#333');C(450,18,4,'#fff8d0');
cx.save();var bGr=cx.createRadialGradient(450,18,4,450,18,100);
bGr.addColorStop(0,'rgba(255,240,200,0.06)');bGr.addColorStop(1,'rgba(255,240,200,0)');
cx.fillStyle=bGr;cx.fillRect(350,0,200,180);cx.restore();

// === MATTRESS ON FLOOR ===
R(360,FY-8,110,18,'#444438');R(362,FY-12,106,14,'#5a5a4a');
R(362,FY-12,106,3,'#4a4a3a');R(362,FY-14,30,8,'#4a4a3a');
R(370,FY-10,60,8,'#666658');

// === MOTIVATIONAL POSTER ===
R(310,55,60,45,'#e8e0d0');
cx.strokeStyle='#c8c0b0';cx.lineWidth=1;cx.strokeRect(310,55,60,45);
T('PAIN IS',340,74,7,'#992222');T('TEMPORARY',340,86,7,'#992222');

// === FRIDGE ===
R(90,FY-140,60,140,'#888880');
R(92,FY-138,56,80,'#7a7a72');R(92,FY-56,56,54,'#7a7a72');
R(148,FY-100,4,10,'#555');R(148,FY-40,4,10,'#555');
cx.strokeStyle='#666';cx.lineWidth=1;cx.strokeRect(90,FY-140,60,140);
if(hover==='fridge'&&!S.busy&&!S.apartment.subMenu){
  cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(86,FY-144,68,148);
}

// === BATHROOM DOOR ===
R(15,FY-160,45,160,'#3a2e20');
R(55,FY-80,4,8,'#aa8844');T('BATH',38,FY-90,7,'#2a2018');
if(hover==='bathroom'&&!S.busy&&!S.apartment.subMenu){
  cx.strokeStyle='#6699ff';cx.lineWidth=2;cx.strokeRect(11,FY-164,53,168);
}

// === WARDROBE / CLOSET ===
R(240,FY-150,55,150,'#3a2e20');R(290,FY-80,4,8,'#aa8844');
R(241,FY-148,20,146,'#1a1408');
R(244,FY-120,3,40,'#cc3333');R(250,FY-115,3,35,'#4466aa');
if(hover==='wardrobe'&&!S.busy&&!S.apartment.subMenu){
  cx.strokeStyle='#ffcc00';cx.lineWidth=2;cx.strokeRect(236,FY-154,63,158);
}

// === NIGHTSTAND + CIG PACK ===
R(340,FY-35,30,35,'#3a2e20');R(338,FY-38,34,5,'#4a3e2a');
// Cig pack on nightstand
R(348,FY-48,14,10,'#cc3333');R(350,FY-52,2,6,'#f5f0e0');R(354,FY-52,2,6,'#f5f0e0');R(358,FY-52,2,6,'#f5f0e0');
if(hover==='cig'&&!S.busy&&!S.apartment.subMenu){
  cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(336,FY-54,38,56);
}

// === OLD TV ===
R(510,FY-120,70,90,'#444438');R(515,FY-115,60,65,'#0a0a0a');
R(530,FY-30,10,30,'#333');R(560,FY-30,10,30,'#333');
R(544,FY-130,2,18,'#666');R(534,FY-148,12,2,'#666');R(546,FY-148,12,2,'#666');
if(!S.apartment.watchedTV){
  // Static / snow on screen
  for(var si=0;si<12;si++){
    var tsx=517+((si*37+Date.now()/50)%56);var tsy=FY-113+((si*23+Date.now()/80)%58);
    R(tsx,tsy,2,2,(si%2)?'#333':'#555');
  }
  // 4 VHS tapes scattered on floor near TV
  // Pumping Iron — gold case
  R(500,FY-6,28,6,'#8b6914');R(502,FY-5,24,4,'#a07a1a');T('PI',514,FY+7,5,'#8b6914');
  // Predator — dark green case
  R(534,FY-4,28,6,'#1a3a1a');R(536,FY-3,24,4,'#2a4a2a');T('P1',548,FY+9,5,'#3a5a3a');
  // Predator 2 — blue case
  R(516,FY+4,28,6,'#1a1a3a');R(518,FY+5,24,4,'#2a2a5a');T('P2',530,FY+17,5,'#4a4a7a');
  // Rumping Iron — pink case
  R(550,FY+2,28,6,'#5a1a3a');R(552,FY+3,24,4,'#7a2a4a');T('RI',564,FY+15,5,'#8a3a5a');
}else{
  // VHS playing — content depends on choice
  var vc=S.apartment.vhsChoice;
  R(518,FY-112,54,58,vc==='rumping'?'#1a0a0a':'#0a1a0a');
  if(vc==='pumping'){
    T('PUMPING',545,FY-100,7,'#7fdb6a');T('IRON',545,FY-90,10,'#ff6b35');
    var bpulse=Math.sin(Date.now()/400)*1.5;
    cx.save();cx.translate(545,FY-66);
    R(-10,4,20,18,'#5a8a5a');C(0,-6,5,'#5a8a5a');
    R(-14,2,5,10,'#5a8a5a');R(-17,-6,7,10,'#5a8a5a');C(-13,-1,3.5+bpulse,'#6a9a6a');
    R(9,2,5,10,'#5a8a5a');R(11,-6,7,10,'#5a8a5a');C(14,-1,3.5+bpulse,'#6a9a6a');
    cx.restore();
  }else if(vc==='predator'){
    T('PREDATOR',545,FY-98,8,'#7fdb6a');
    // Predator face — triangle helmet/dreadlocks
    cx.save();cx.translate(545,FY-70);
    C(0,-4,8,'#3a5a3a');R(-6,4,12,10,'#2a4a2a');
    // Mandibles
    R(-6,8,3,6,'#5a7a5a');R(-2,9,3,5,'#5a7a5a');R(0,9,3,5,'#5a7a5a');R(4,8,3,6,'#5a7a5a');
    // Eyes — red glow
    var eg=Math.sin(Date.now()/300)*0.3+0.7;cx.globalAlpha=eg;C(-3,-6,2,'#ff3333');C(3,-6,2,'#ff3333');cx.globalAlpha=1;
    // Dreadlocks
    for(var dl=0;dl<5;dl++)R(-8+dl*4,-10,2,8,'#4a6a4a');
    cx.restore();
  }else if(vc==='predator2'){
    T('PREDATOR',545,FY-100,7,'#6688aa');T('II',545,FY-90,10,'#8899bb');
    // City skyline silhouette
    cx.save();cx.translate(545,FY-64);
    R(-22,8,8,12,'#334');R(-12,2,10,18,'#334');R(0,-2,8,22,'#334');R(10,4,12,16,'#334');R(-18,14,44,6,'#223');
    // Moon
    C(18,-10,5,'#8899bb');
    cx.restore();
  }else if(vc==='rumping'){
    T('RUMPING',545,FY-100,7,'#ff69b4');T('IRON',545,FY-90,10,'#ff99cc');
    // Suggestive silhouette — just a heart
    var hb=Math.sin(Date.now()/300)*1.5;
    cx.save();cx.translate(545,FY-66);cx.fillStyle='#ff3366';
    cx.beginPath();cx.moveTo(0,6);cx.bezierCurveTo(-2,2,-8,-4,-8,-8);cx.bezierCurveTo(-8,-14,0,-14,0,-8+hb);
    cx.bezierCurveTo(0,-14,8,-14,8,-8);cx.bezierCurveTo(8,-4,2,2,0,6);cx.fill();
    // bow-chicka text
    cx.globalAlpha=0.5;T('bow chicka',545,FY-54,5,'#ff69b4');cx.globalAlpha=1;
    cx.restore();
  }
  // CRT scanlines
  cx.globalAlpha=0.06;for(var scl=0;scl<30;scl++)R(518,FY-112+scl*2,54,1,'#000');cx.globalAlpha=1;
}
if(hover==='tv'&&!S.busy&&!S.apartment.subMenu){
  cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(506,FY-152,78,122);
}

// === ROTARY PHONE ===
R(618,FY-42,30,42,'#3a2e20');R(616,FY-44,34,4,'#4a3e2a');
R(622,FY-54,22,12,'#222');C(633,FY-48,6,'#333');
R(621,FY-62,10,8,'#222');
if(hover==='phone'&&!S.busy&&!S.apartment.subMenu){
  cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(614,FY-66,40,68);
}

// === DUMBBELLS ===
var dbx=710;
if(S.pose!=='pumping'){
R(dbx-8,FY-6,40,6,'#555');C(dbx-8,FY-3,6,'#444');C(dbx+32,FY-3,6,'#444');
R(dbx-4,FY-14,36,6,'#555');C(dbx-4,FY-11,6,'#444');C(dbx+32,FY-11,6,'#444');
}
if(hover==='dumbbells'&&!S.busy&&!S.apartment.subMenu&&S.pose!=='pumping'){
  cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(dbx-16,FY-22,58,28);
}

// === EXIT DOOR ===
R(830,FY-170,60,170,'#5a4a38');R(835,FY-80,4,8,'#aa8844');
T('EXIT',860,FY-140,8,'#4a3a28');
cx.save();cx.globalAlpha=0.06;
R(828,FY-172,64,4,'#ffe8b0');R(890,FY-170,4,170,'#ffe8b0');
cx.globalAlpha=1;cx.restore();
if(hover==='door'&&!S.busy&&!S.apartment.subMenu){
  cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(826,FY-174,68,178);
}

// === ANALOG CLOCK ===
var ckX=545,ckY=FY-145,ckR=12;
C(ckX,ckY,ckR+2,'#222');C(ckX,ckY,ckR,'#eee8d0');
T('12',ckX,ckY-5,4,'#222');T('6',ckX,ckY+9,4,'#222');
T('3',ckX+7,ckY+2,4,'#222');T('9',ckX-7,ckY+2,4,'#222');
var ckt=Date.now()/1000;
var ckMin=(ckt/60)*Math.PI*2-Math.PI/2;
var ckHr=(ckt/720)*Math.PI*2-Math.PI/2;
cx.strokeStyle='#222';cx.lineWidth=1;
cx.beginPath();cx.moveTo(ckX,ckY);cx.lineTo(ckX+Math.cos(ckHr)*6,ckY+Math.sin(ckHr)*6);cx.stroke();
cx.lineWidth=0.7;
cx.beginPath();cx.moveTo(ckX,ckY);cx.lineTo(ckX+Math.cos(ckMin)*9,ckY+Math.sin(ckMin)*9);cx.stroke();
C(ckX,ckY,1.5,'#222');

// === CAT sleeping on mattress ===
var catB=Math.sin(Date.now()/800)*1;
R(430,FY-14+catB,14,6,'#cc7733');C(428,FY-14+catB,4,'#cc7733');
C(427,FY-17+catB,2,'#cc7733');C(430,FY-17+catB,2,'#cc7733');
R(444,FY-12+catB,8,2,'#cc7733');
// Cat eyes (closed)
R(425,FY-14+catB,3,1,'#111');
if(hover==='mattress'&&!S.busy&&!S.apartment.subMenu){
  cx.strokeStyle='#6699cc';cx.lineWidth=2;cx.strokeRect(355,FY-18,120,24);
}
}

function drawVenueBackground(){
if(S.phase==='gym'||S.phase==='intro')return;
// Back wall gradient
var grd=cx.createLinearGradient(0,0,0,FY);
grd.addColorStop(0,'#0a0a0c');grd.addColorStop(0.3,'#111114');grd.addColorStop(1,'#131315');
cx.fillStyle=grd;cx.fillRect(0,0,W,FY);
// Overhead truss/rigging
R(0,12,W,3,'#1a1a1a');
R(40,0,3,15,'#181818');R(W-43,0,3,15,'#181818');R(300,0,3,15,'#181818');R(600,0,3,15,'#181818');
// Side curtains (left)
for(var ci=0;ci<8;ci++){
  var cx1=ci*8;var shade=ci%2===0?'#1a0a0a':'#160808';
  R(cx1,0,8,FY,shade);
}
// Side curtains (right)
for(var ci=0;ci<8;ci++){
  var cx1=W-64+ci*8;var shade=ci%2===0?'#1a0a0a':'#160808';
  R(cx1,0,8,FY,shade);
}
// Spotlight cones aimed at platform
cx.save();
var spotX=[350,450,550];
for(var si=0;si<spotX.length;si++){
  var sx=spotX[si];
  cx.beginPath();cx.moveTo(sx-3,0);cx.lineTo(sx-60,FY);cx.lineTo(sx+60,FY);cx.lineTo(sx+3,0);cx.closePath();
  cx.fillStyle='rgba(255,245,200,0.02)';cx.fill();
}
cx.restore();
// Spotlight housings
for(var si=0;si<spotX.length;si++){
  R(spotX[si]-5,0,10,8,'#222');C(spotX[si],10,4,'#332e1a');
}
// Banner
R(280,20,340,24,'#111');
cx.strokeStyle='#2a2218';cx.lineWidth=1;cx.strokeRect(280,20,340,24);
T('NATIONAL WEIGHTLIFTING CHAMPIONSHIP',450,36,10,'#8b7340');
// Flags flanking banner
R(264,22,12,8,'#2a3a6a');R(264,30,12,8,'#6a2a2a');
R(624,22,12,8,'#2a6a3a');R(624,30,12,8,'#6a6a2a');
// Warm-up area label
T('WARM-UP AREA',150,FY+25,8,'#252525');
// Subtle divider
cx.save();cx.setLineDash([4,4]);cx.strokeStyle='#1c1c1c';cx.lineWidth=1;
cx.beginPath();cx.moveTo(280,300);cx.lineTo(280,FY);cx.stroke();cx.restore();
}

function drawPlatform(){
if(S.phase==='gym'||S.phase==='intro')return;
var px=LAYOUT.comp.platformX,pw=180,ph=14;
var left=px-pw/2,top=FY-ph;
// Platform base
R(left-4,top+2,pw+8,ph+2,'#1a1610');
// Woodgrain surface
for(var wi=0;wi<ph;wi+=2){
  var shade=wi%4===0?'#5a3a1a':'#4d3117';
  R(left,top+wi,pw,2,shade);
}
// White border
cx.strokeStyle='#555';cx.lineWidth=1;cx.strokeRect(left,top,pw,ph);
// Center circle marking
cx.beginPath();cx.arc(px,top+ph/2,10,0,Math.PI*2);cx.strokeStyle='#666';cx.lineWidth=1;cx.stroke();
// Side competition markings (blue left, orange right)
R(left,top,4,ph,'#2a4a7a');R(left+pw-4,top,4,ph,'#7a4a2a');
// Center line
R(px-1,top,2,ph,'#444');
// Label
T('IWF',px,FY+18,8,'#3a3a3a');
}

function drawCrowdSilhouettes(){
if(S.phase==='gym'||S.phase==='intro')return;
// Back row (smaller, further away)
var backY=78;
for(var i=0;i<24;i++){
  var cx2=80+i*30+Math.sin(i*2.1)*8;
  var v=16+((i%3)*2);var shade=v<16?'0'+v.toString(16):v.toString(16);
  var col='#'+shade+shade+shade;
  C(cx2,backY-6,4,col);R(cx2-5,backY-1,10,6,col);
}
// Front row (larger, closer)
var frontY=98;
for(var i=0;i<30;i++){
  var cx2=70+i*26+Math.sin(i*1.7)*6;
  var v=20+((i%4)*2);var shade=v<16?'0'+v.toString(16):v.toString(16);
  var col='#'+shade+shade+shade;
  C(cx2,frontY-10,5+i%3,col);R(cx2-7,frontY-3,14,8,col);
  // Occasional colored accent (hat or collar)
  if(i%7===0){R(cx2-3,frontY-14,6,3,'#2a2a3a');}
  if(i%9===2){R(cx2-4,frontY-3,8,2,'#3a2a2a');}
}
// Crowd reaction — scaled intensity
if(S.pose==='overhead'||S.pose==='overhead_squat'||S.pose==='front_squat'||S.pose==='jerk'||S.compLiftResult==='good'){
  var t=Date.now();
  var numArms=S.compLiftResult==='good'?18:8;
  var ampMult=S.compLiftResult==='good'?1.5:1.0;
  for(var j=0;j<numArms;j++){
    var ax=60+j*46+Math.sin(j*2.3)*20;
    var arm=Math.abs(Math.sin(t/150+j*1.3))*14*ampMult;
    R(ax-1,frontY-18-arm,3,12+arm*0.3,'#1e1e1e');
  }
  // Standing ovation on PR
  if(S.prFlash>0){
    for(var k=0;k<30;k++){
      var sx=55+k*28+Math.sin(k*1.7)*10;
      var bob=Math.abs(Math.sin(t/120+k*0.9))*6;
      C(sx,frontY-14-bob,5,'#1a1a1a');
    }
  }
}
// Failed lift — heads dip, groan posture
if(S.compLiftResult==='no_lift'){
  for(var j=0;j<10;j++){
    var hx=80+j*80+Math.sin(j*3)*25;
    C(hx,frontY-4,5,'#181818');
    // Hands on head gesture
    if(j%3===0){
      R(hx-3,frontY-12,2,8,'#1a1a1a');R(hx+1,frontY-12,2,8,'#1a1a1a');
    }
  }
}
}

function drawJudgesTable(){
if(S.phase==='gym'||S.phase==='intro'||S.phase==='warmup')return;
var L=LAYOUT.comp;var jy=FY+30;
R(L.platformX-60,jy,120,6,'#2a2a2a');
R(L.platformX-55,jy+6,4,16,'#222');R(L.platformX+51,jy+6,4,16,'#222');
for(var j=0;j<3;j++){var jx=L.platformX-30+j*30;R(jx-4,jy-10,8,10,'#2a2a2a');C(jx,jy-16,4,'#c8a882');}
// Judges' lights — show after lift result
if(S.compLiftResult){
  var lightCol=S.compLiftResult==='good'?'#ffffff':'#ff3333';
  var dimCol=S.compLiftResult==='good'?'#444':'#441111';
  for(var j=0;j<3;j++){
    var jx=L.platformX-30+j*30;
    // Light box
    R(jx-5,jy+8,10,8,dimCol);
    C(jx,jy+12,3,lightCol);
  }
}
T('JUDGES',L.platformX,jy+30,7,'#333');
}

function drawScoreboard(){
if(S.phase==='gym'||S.phase==='intro'||S.phase==='warmup'||S.phase==='mode_select'||S.phase==='roster_pick')return;
if(S.rivals&&S.rivals.length>1){
  // Multi-comp: mini leaderboard top-right
  drawLeaderboard();
  return;
}
// 1v1: classic scoreboard
var sbx=380,sby=6,sbw=140,sbh=32;
R(sbx,sby,sbw,sbh,'#0a0a0a');cx.strokeStyle='#2a2a2a';cx.lineWidth=1;cx.strokeRect(sbx,sby,sbw,sbh);
var pakTotal=S.rival.bestSnatch+S.rival.bestCJ;var tarkTotal=S.bestSnatch+S.bestCJ;
T('TARK',sbx+35,sby+11,8,'#f0e6d3');T(tarkTotal>0?tarkTotal+'':'---',sbx+35,sby+24,11,'#ff6b35');
T('vs',sbx+sbw/2,sby+18,8,'#444');
var rName=S.rival.name?S.rival.name.split(' ')[0]:'PAK';
T(rName,sbx+sbw-35,sby+11,8,'#4a8a4a');T(pakTotal>0?pakTotal+'':'---',sbx+sbw-35,sby+24,11,'#7fdb6a');
}

function getOrdinal(n){
  var s=['th','st','nd','rd'];
  var v=n%100;
  return s[(v-20)%10]||s[v]||s[0];
}

function getStandings(){
  var standings=[];
  var tt=(S.bestSnatch||0)+(S.bestCJ||0);
  standings.push({name:'TARK',total:tt,isTark:true,flag:'\ud83c\udde6\ud83c\uddfa'});
  if(S.rivals){
    for(var i=0;i<S.rivals.length;i++){
      var rv=S.rivals[i];
      standings.push({name:rv.name.split(' ')[0],total:rv.bestSnatch+rv.bestCJ,isTark:false,
        flag:rv.flag,singlet:rv.singlet,id:rv.id,declared:rv.declared,done:rv.done,
        currentAttempt:rv.currentAttempt});
    }
  }
  standings.sort(function(a,b){return b.total-a.total;});
  return standings;
}

function drawLeaderboard(){
  var standings=getStandings();
  var lx=720,ly=4,lw=170;
  var rowH=14;
  var lh=20+standings.length*rowH;
  R(lx,ly,lw,lh,'rgba(10,10,10,0.85)');
  cx.strokeStyle='#2a2a2a';cx.lineWidth=1;cx.strokeRect(lx,ly,lw,lh);
  T('LEADERBOARD',lx+lw/2,ly+12,8,'#8b7340');
  for(var i=0;i<standings.length;i++){
    var s=standings[i];
    var ry=ly+20+i*rowH;
    var col=s.isTark?'#ff6b35':s.id===S.rival.id?'#7fdb6a':'#888';
    var pos=(i+1)+'.';
    T(pos,lx+14,ry+10,8,col,'right');
    T(s.flag||'',lx+22,ry+10,8,'#fff','left');
    T(s.name,lx+38,ry+10,8,col,'left');
    T(s.total>0?s.total+'':'---',lx+lw-10,ry+10,9,col,'right');
  }
}

function drawPakArea(){
if(S.phase==='gym'||S.phase==='intro')return;
var L=LAYOUT.comp;
R(L.pakBenchX-18,370,36,5,'#2a2a2a');
R(L.pakBenchX-14,375,4,FY-375,'#222');R(L.pakBenchX+10,375,4,FY-375,'#222');
}

function drawTarkSideTable(){
if(S.phase==='gym'||S.phase==='intro')return;
// Small table for Tark's consumables in competition
var tx=95,ty=370;
R(tx-45,ty,90,4,'#1a1a1a');
R(tx-40,ty+4,4,FY-ty-4,'#151515');
R(tx+36,ty+4,4,FY-ty-4,'#151515');
}

function drawBigScoreboard(){
if(S.phase==='gym'||S.phase==='intro'||S.phase==='mode_select'||S.phase==='roster_pick')return;
var t=S.turn;
var isComp=S.phase==='snatch'||S.phase==='cj';
var isMulti=S.rivals&&S.rivals.length>1;

if(isMulti){
  // --- MULTI-COMP: compact current lifter panel ---
  var sbw=220,sbh=isComp?70:60;
  var left=(W-sbw)/2,top=isComp?118:128;
  R(left,top,sbw,sbh,'rgba(10,10,10,0.9)');
  cx.strokeStyle='#2a2218';cx.lineWidth=1;cx.strokeRect(left,top,sbw,sbh);
  R(left,top,3,8,'#8b7340');R(left,top,8,3,'#8b7340');
  R(left+sbw-3,top,3,8,'#8b7340');R(left+sbw-8,top,8,3,'#8b7340');
  var cx2=left+sbw/2;
  if(isComp){
    var label=S.phase==='snatch'?'SNATCH':'CLEAN & JERK';
    T(label,cx2,top+12,8,'#8b7340');
    R(left+15,top+16,sbw-30,1,'#2a2218');
    // Show whose turn / what's on the bar
    var whoseTurn=t.whose;
    if(whoseTurn==='tark'){
      var tLbl=t.tarkDeclared>0?t.tarkDeclared+'':t.tarkDone?'DONE':'???';
      T('TARK',cx2,top+30,9,'#ff6b35');
      T(tLbl,cx2,top+46,16,t.tarkDeclared>0?'#ff6b35':'#555');
    }else if(whoseTurn==='rival'||whoseTurn==='pak'){
      var rName=S.rival.name.split(' ')[0];
      var rLbl=S.rival.declared>0?S.rival.declared+'':S.rival.done?'DONE':'---';
      T(rName,cx2,top+30,9,'#7fdb6a');
      T(rLbl,cx2,top+46,16,S.rival.declared>0?'#7fdb6a':'#555');
    }else{
      T('BAR: '+t.platformWeight,cx2,top+38,14,'#8b7340');
    }
    T('BAR: '+t.platformWeight+' LBS',cx2,top+62,8,'#666');
  }else{
    var label='WARM-UP';
    if(S.phase==='rest_sn_cj')label='REST PERIOD';
    T(label,cx2,top+12,8,'#8b7340');
    R(left+15,top+16,sbw-30,1,'#2a2218');
    T(S.barWeight+' LBS',cx2,top+38,18,'#ff6b35');
    var tt=(S.bestSnatch||0)+(S.bestCJ||0);
    T('YOUR TOTAL: '+(tt>0?tt:'---'),cx2,top+54,8,'#f0e6d3');
  }
  return;
}

// --- 1v1 MODE: classic TARK vs PAK panel ---
var sbw=260,sbh=isComp?90:75;
var left=(W-sbw)/2,top=isComp?115:125;
// Panel background
R(left,top,sbw,sbh,'#0a0a0a');
cx.strokeStyle='#2a2218';cx.lineWidth=2;cx.strokeRect(left,top,sbw,sbh);
// Gold corner accents
R(left,top,3,10,'#8b7340');R(left,top,10,3,'#8b7340');
R(left+sbw-3,top,3,10,'#8b7340');R(left+sbw-10,top,10,3,'#8b7340');
R(left,top+sbh-10,3,10,'#8b7340');R(left,top+sbh,10,-3,'#8b7340');
R(left+sbw-3,top+sbh-10,3,10,'#8b7340');R(left+sbw-10,top+sbh,10,-3,'#8b7340');
var cx2=left+sbw/2;
if(isComp){
  // Competition scoreboard with declarations
  var label=S.phase==='snatch'?'SNATCH':'CLEAN & JERK';
  T(label,cx2,top+13,9,'#8b7340');
  R(left+20,top+18,sbw-40,1,'#2a2218');
  // TARK side
  var tLbl=t.tarkDeclared>0?t.tarkDeclared+'':t.tarkDone?'DONE':'???';
  var tAtt='ATT '+(Math.min(t.tarkAttempt+1,3))+'/3';
  T('TARK',left+55,top+30,8,'#f0e6d3');
  T(tLbl,left+55,top+46,18,t.tarkDeclared>0?'#ff6b35':'#555');
  T(tAtt,left+55,top+58,7,'#666');
  // VS
  T('vs',cx2,top+42,8,'#444');
  // Rival side
  var rName=S.rival.name?S.rival.name.split(' ')[0]:'PAK';
  var pLbl=t.pakDeclared>0?t.pakDeclared+'':t.pakDone?'DONE':'---';
  var pAtt='ATT '+(Math.min(t.pakAttempt+1,3))+'/3';
  T(rName,left+sbw-55,top+30,8,'#4a8a4a');
  T(pLbl,left+sbw-55,top+46,18,t.pakDeclared>0?'#7fdb6a':'#555');
  T(pAtt,left+sbw-55,top+58,7,'#666');
  // Platform weight at bottom
  R(left+20,top+65,sbw-40,1,'#2a2218');
  T('BAR: '+t.platformWeight+' LBS',cx2,top+80,10,'#8b7340');
}else{
  // Warmup / rest: show totals
  var label='WARM-UP';
  if(S.phase==='rest_sn_cj')label='REST PERIOD';
  T(label,cx2,top+15,9,'#8b7340');
  R(left+20,top+20,sbw-40,1,'#2a2218');
  T(S.barWeight+' LBS',cx2,top+46,22,'#ff6b35');
  R(left+20,top+54,sbw-40,1,'#2a2218');
  var tt=(S.bestSnatch||0)+(S.bestCJ||0);
  var pt=(S.rival.bestSnatch||0)+(S.rival.bestCJ||0);
  var rName=S.rival.name?S.rival.name.split(' ')[0]:'PAK';
  T('TARK  '+(tt>0?tt:'---'),left+65,top+68,10,'#f0e6d3');
  T(rName+'  '+(pt>0?pt:'---'),left+sbw-65,top+68,10,'#4a8a4a');
}
}

// --- BACK ROOM SCENE ---

function drawBackroomScene(){
  R(0,0,W,H,'#111');

  // === LAYER 1: Static background (walls, floor, perspective, lights, posters) ===
  drawBackroomBackground();
  drawBackroomPlatforms();
  drawBackroomEnvironment();

  // === LAYER 2: Far-back extras (y < 260) — always behind everything ===
  if(S.backroomExtras){
    for(var fi=0;fi<S.backroomExtras.length;fi++){
      var fe=S.backroomExtras[fi];
      if(fe.y<260)drawScaledPerson(fe.x,fe.y,fe);
    }
  }

  // === LAYER 3: TV (mounted on wall, always behind characters) ===
  drawBackroomTV();

  // === LAYER 4: Depth-sorted mid/near entities ===
  var drawList=[];
  // Mid/near extras
  if(S.backroomExtras){
    for(var ei=0;ei<S.backroomExtras.length;ei++){
      var ex=S.backroomExtras[ei];
      if(ex.y>=260)drawList.push({y:ex.y,type:'e',data:ex});
    }
  }
  // Real rivals (depth-varied)
  var rivalSpots=assignRivalSpots();
  for(var ri=0;ri<rivalSpots.length;ri++){
    drawList.push({y:rivalSpots[ri].y,type:'r',data:rivalSpots[ri]});
  }
  // Featured rivals now render in Layer 6 alongside Tark (full-size, same hierarchy)
  // Furniture at their y-positions
  drawList.push({y:367,type:'bench'});
  drawList.push({y:369,type:'shaker'});
  drawList.push({y:369,type:'cig'});
  drawList.push({y:369,type:'chalk'});
  drawList.push({y:372,type:'coach'});
  drawList.push({y:LAYOUT.backroom.doorY+LAYOUT.backroom.doorH,type:'door'});

  // Sort back-to-front
  drawList.sort(function(a,b){return a.y-b.y;});

  // Render sorted list
  for(var di=0;di<drawList.length;di++){
    var item=drawList[di];
    try{
      if(item.type==='e')drawScaledPerson(item.data.x,item.data.y,item.data);
      else if(item.type==='r')drawBackroomRivalNew(item.data);
      else if(item.type==='bench')drawBench();
      else if(item.type==='shaker')drawShaker();
      else if(item.type==='cig')drawCigPack();
      else if(item.type==='chalk')drawChalkBucket();
      else if(item.type==='coach'){
        drawCoachNPC(LAYOUT.backroom.coachX,340);
        // Temporary coach bubble (from Talk to Coach action)
        if(S.coachBubble&&S.coachBubble.text){
          var cbAge=Date.now()-S.coachBubble.t;
          var cbDur=S.coachBubble.dur||4000;
          if(cbAge<cbDur){
            var cbAlpha=cbAge>cbDur-800?Math.max(0,1-(cbAge-(cbDur-800))/800):Math.min(1,cbAge/300);
            cx.globalAlpha=cbAlpha;
            drawCoachSpeechBubble(LAYOUT.backroom.coachX,290,S.coachBubble.text);
            cx.globalAlpha=1;
          }else{S.coachBubble=null;}
        }
      }
      else if(item.type==='door')drawBackroomDoor();
    }catch(e){cx.globalAlpha=1;}
  }

  // === LAYER 5: Girls (existing system, near layer) ===
  try{updateGirls();drawGirls();}catch(e){cx.globalAlpha=1;}

  // === LAYER 5b: Wimp NPC (DNF sequence — runs in, gives cigarette, leaves with girl) ===
  if(S.dnf){try{updateWimp();drawWimp();}catch(e){cx.globalAlpha=1;}}

  // === LAYER 6: Walk + Tark (always foreground) ===
  try{updateWalk();}catch(e){}
  if(isNaN(S.tX)||S.tX<-50||S.tX>W+50)S.tX=S.homeX||300;
  checkStuck();
  cx.globalAlpha=1;
  // Featured rivals (same layer as Tark, full size, drawn first so Tark overlaps when walking near)
  if(S.rivals&&S.phase==='warmup'){
    for(var fi=0;fi<S.rivals.length;fi++){
      var fr=S.rivals[fi];
      if(!fr.featured||!fr.active)continue;
      var frLifting=(S.turn&&S.turn.whose==='rival'&&S.rival&&S.rival.id===fr.id);
      if(!frLifting){try{drawFeaturedRival(fr);}catch(e){cx.globalAlpha=1;}}
    }
  }
  // Resting barbell on platform (visible unless barbell is in Tark's hands)
  var liftPoses={pull:1,overhead:1,clean_hold:1,jerk:1};
  if(!liftPoses[S.pose]){
    var bbX=S.homeX||LAYOUT.backroom.homeX||300;
    drawBarbell(bbX,392);
  }
  // Draw Tark (reuse existing pose rendering)
  var x=S.tX,y=328,p=S.pose;
  if(p==='shake'||p==='smoke'||p==='chalking')S.poseT+=0.016;
  if(S.chalked){S.chalkTimer++;if(S.chalkTimer>600)S.chalked=false;}
  if(p==='idle')drawTarkIdle(x,y,S.strength<25);
  else if(p==='walking')drawTarkWalking(x,y);
  else if(p==='sitting')drawTarkSitting(S.tX,360);
  else if(p==='injured')drawTarkInjured(S.tX,360);
  else if(p==='shake')drawTarkShaking(x,y,S.poseT);
  else if(p==='smoke')drawTarkSmoking(x,y,S.poseT);
  else if(p==='chalking')drawTarkChalking(x,y,S.poseT);
  else if(p==='pull'){
    if(S.currentLift==='snatch')drawTarkSnatchPull(x,y);else drawTarkPull(x,y);
    drawBarbell(x,y+30);
  }
  else if(p==='overhead'){
    if(S.currentLift==='snatch')drawTarkSnatchOverhead(x,y);else drawTarkOverhead(x,y);
    drawBarbell(x,y-56);
  }
  else if(p==='overhead_squat'){drawTarkOverheadSquat(x,y);drawBarbell(x,y-40);}
  else if(p==='front_squat'){drawTarkFrontSquat(x,y);drawBarbell(x,y+2);}
  else if(p==='clean_hold'){drawTarkClean(x,y);drawBarbell(x,y-6);}
  else if(p==='jerk'){drawTarkJerk(x,y);drawBarbell(x,y-60);}
  else if(p==='failed'){var sh=Math.sin(Date.now()/80)*6;drawTarkIdle(x+sh,y,true);}
  else drawTarkIdle(x,y,S.strength<25);

  // === LAYER 7: Overlays ===
  // Floating text
  for(var i=S.floats.length-1;i>=0;i--){
    var f=S.floats[i];f.y-=1.2;f.life-=0.018;
    if(f.life>0){cx.globalAlpha=f.life;T(f.text,f.x,f.y,f.sz,f.c);}
  }
  cx.globalAlpha=1;
  S.floats=S.floats.filter(function(f){return f.life>0;});
  // Scene transition overlay
  if(S.sceneTransition)drawSceneTransition();
  // HUD
  drawBackroomHUD();
  drawWallScoreboard();
  // Version stamp
  cx.globalAlpha=0.3;cx.font='9px monospace';cx.textAlign='right';cx.fillStyle='#666';
  cx.fillText('v'+BUILD_V,W-4,H-4);cx.textAlign='center';cx.globalAlpha=1;
}

// === APARTMENT SCENE ===
function drawApartmentScene(){
// Full-screen interior views skip apartment rendering
var _vsub=S.apartment.subMenu;
if(_vsub==='fridge'||_vsub==='bathroom'||_vsub==='vhs'||_vsub==='door'||_vsub==='phone'||_vsub==='pickpocket'||_vsub==='dogChase'){
  if(_vsub==='fridge')drawFridgeInterior();else if(_vsub==='bathroom')drawBathroomInterior();else if(_vsub==='vhs')drawVHSSelection();else if(_vsub==='phone')drawPhoneMenu();else if(_vsub==='pickpocket')drawPickpocketScene();else if(_vsub==='dogChase')drawDogChaseScene();else drawDoorChoice();
  cx.globalAlpha=0.3;cx.font='9px monospace';cx.textAlign='right';cx.fillStyle='#666';cx.fillText('v'+BUILD_V,W-4,H-4);cx.textAlign='center';cx.globalAlpha=1;return;
}

R(0,0,W,H,'#111');
drawApartmentBackground();

// Walk update
try{updateWalk();}catch(e){}
if(isNaN(S.tX)||S.tX<-50||S.tX>W+50)S.tX=S.homeX||450;
try{checkStuck();}catch(e){}
cx.globalAlpha=1;

// Tark
var x=S.tX,y=328,p=S.pose;
if(p==='shake'||p==='smoke'||p==='chalking'||p==='pumping'||p==='eating')S.poseT+=0.016;
if(S.apartment.onCall)drawTarkOnPhone(x,y);
else if(S.facing==='away')drawTarkBack(x,y);
else if(p==='idle')drawTarkIdle(x,y,false);
else if(p==='walking')drawTarkWalking(x,y);
else if(p==='sitting')drawTarkSitting(S.tX,360);
else if(p==='shake')drawTarkShaking(x,y,S.poseT);
else if(p==='smoke')drawTarkSmoking(x,y,S.poseT);
else if(p==='pumping')drawTarkPumping(x,y,S.poseT);
else if(p==='eating')drawTarkEating(x,y,S.poseT,S.apartment.breakfast);
else if(p==='lyingdown')drawTarkLyingDown(x,y);
else drawTarkIdle(x,y,false);

// Floating text
for(var i=S.floats.length-1;i>=0;i--){
  var f=S.floats[i];f.y-=1.2;f.life-=0.018;
  if(f.life>0){cx.globalAlpha=f.life;T(f.text,f.x,f.y,f.sz,f.c);}
}
cx.globalAlpha=1;
S.floats=S.floats.filter(function(f){return f.life>0;});

// Speech bubble now rendered universally in drawSpeechBubbleOverlay()

// HUD
drawApartmentHUD();

// Sub-menu overlay
if(S.apartment.subMenu)drawApartmentSubMenu();

// Scene transition
if(S.sceneTransition)drawSceneTransition();

// Version stamp
cx.globalAlpha=0.3;cx.font='9px monospace';cx.textAlign='right';cx.fillStyle='#666';
cx.fillText('v'+BUILD_V,W-4,H-4);cx.textAlign='center';cx.globalAlpha=1;
}

function drawApartmentHUD(){
// Day label
cx.textAlign='left';
T('DAY '+S.day+(S.day===S.totalDays?' \u2014 MEET DAY':''),14,22,10,'#ff6b35');
cx.textAlign='center';
T("TARK'S APARTMENT",450,22,13,'#4a3e2a');

// Morning checklist
var items=[
  {done:S.apartment.ate,label:'BREAKFAST'},
  {done:S.apartment.showered,label:'SHOWER'},
  {done:S.apartment.dressed,label:'OUTFIT'}
];
cx.textAlign='right';
for(var ci=0;ci<items.length;ci++){
  var itm=items[ci];
  var col=itm.done?'#4a8a4a':'#555';
  T((itm.done?'\u2713':'\u25CB')+' '+itm.label,890,16+ci*14,8,col);
}
cx.textAlign='center';

// Hover tooltip
if(hover&&!S.busy&&!S.apartment.subMenu){
  var tips={fridge:'Open Fridge',bathroom:'Bathroom',wardrobe:'Pick Outfit',
    cig:'Cigarette',tv:'Watch TV',phone:'Phone',
    dumbbells:'Morning Pump',door:'Leave Apartment',mattress:'Go Back to Sleep'};
  if(tips[hover])T(tips[hover],450,FY+25,10,'#f0e6d3');
}
}

function drawApartmentSubMenu(){
var sm=S.apartment.subMenu;
if(sm==='fridge'){drawFridgeInterior();return;}
if(sm==='bathroom'){drawBathroomInterior();return;}
if(sm==='vhs'){drawVHSSelection();return;}
// Wardrobe still uses HTML buttons — just darken bottom
cx.globalAlpha=0.7;R(0,FY-20,W,H-FY+20,'#0a0a0a');cx.globalAlpha=1;
if(sm==='wardrobe')T('PICK YOUR LOOK',450,FY+5,12,'#ffcc00');
}

function drawFridgeInterior(){
// Full-screen fridge interior view
R(0,0,W,H,'#1a1a1a');
// Fridge body — avocado green 70s/80s fridge
R(140,20,620,440,'#6b7a4a');R(145,25,610,430,'#8a9a5a');
// Interior — off-white
R(160,40,440,400,'#e8e4d8');
// Door shelf area — right side
R(610,40,140,400,'#d8d4c8');
// Shelves (wire rack look)
for(var sy=0;sy<3;sy++){
  var shelfY=40+sy*130;
  R(160,shelfY+125,440,5,'#bbb');
  for(var wi=0;wi<12;wi++)R(165+wi*37,shelfY+120,2,5,'#999');
}
R(610,200,140,5,'#bbb');R(610,330,140,5,'#bbb');

// === TOP SHELF: EGGS ===
// Egg carton
R(185,80,110,55,'#8b7355');R(190,75,100,8,'#7a6245');
for(var ei=0;ei<6;ei++){C(205+ei*15,105,7,'#f5f0e0');C(205+ei*15,102,2,'#e8e0d0');}
T('EGGS',240,150,11,'#555');
if(hover==='eggs'){cx.strokeStyle='#ff6b35';cx.lineWidth=3;cx.strokeRect(180,70,120,75);
T('Rocky style',240,160,8,'#ff6b35');}

// === TOP SHELF: PROTEIN SHAKE ===
R(360,70,30,90,'#3a3a3a');R(355,65,40,10,'#444');R(365,55,20,12,'#555');
R(363,80,24,70,'#447744');T('PRO',375,110,7,'#7fdb6a');T('TEI',375,120,7,'#7fdb6a');T('N',375,130,7,'#7fdb6a');
T('SHAKE',375,150,11,'#555');
if(hover==='shake'){cx.strokeStyle='#7fdb6a';cx.lineWidth=3;cx.strokeRect(348,50,50,105);
T('Balanced',375,160,8,'#7fdb6a');}

// === MIDDLE SHELF: COLD PIZZA ===
// Pizza box
R(185,210,140,25,'#d4a070');R(185,215,140,50,'#c49060');
// Pizza slice visible — box slightly open
R(187,212,136,3,'#111');
// Slice peeking out
cx.beginPath();cx.moveTo(210,215);cx.lineTo(260,215);cx.lineTo(235,235);cx.closePath();
cx.fillStyle='#dda030';cx.fill();
C(225,222,3,'#cc3333');C(240,220,2,'#cc3333');C(230,226,2,'#447744');
T('PIZZA',255,280,11,'#555');
if(hover==='pizza'){cx.strokeStyle='#ffcc00';cx.lineWidth=3;cx.strokeRect(180,205,150,70);
T('Comfort food',255,290,8,'#ffcc00');}

// === BOTTOM SHELF: COFFEE ===
// Coffee pot
R(195,350,50,60,'#2a2a2a');R(200,355,40,45,'#3a2a1a');
R(245,370,15,20,'#2a2a2a'); // handle
R(195,340,50,12,'#333');C(220,338,6,'#cc3333'); // hot plate + light
T('COFFEE',220,420,11,'#555');
if(hover==='coffee'){cx.strokeStyle='#cc88ff';cx.lineWidth=3;cx.strokeRect(188,335,80,80);
T('Black, strong',220,430,8,'#cc88ff');}

// === DOOR SHELF: SKIP (empty shelf) ===
T('NOTHING',680,260,10,'#999');T('ELSE',680,274,10,'#999');
if(hover==='skip'){cx.strokeStyle='#ff4444';cx.lineWidth=3;cx.strokeRect(625,210,130,110);
T('Skip breakfast',680,300,8,'#ff4444');}

// Close button — top right
R(720,30,35,35,'#4a3a2a');T('X',738,52,16,'#e8e4d8');
if(hover==='closeFridge'){cx.strokeStyle='#ff6b35';cx.lineWidth=3;cx.strokeRect(716,26,43,43);}

// Title
T("WHAT'S FOR BREAKFAST?",380,25,14,'#ff6b35');
}

function drawBathroomInterior(){
var bp=S.apartment.bathroomPhase;
var bt=S.apartment.bathroomT;
var _sc=getTarkShirtColor(),_hc=getTarkHeadbandColor();
var animating=bp==='showering_cold'||bp==='showering_hot'||bp==='mirror';
var isShowering=bp==='showering_cold'||bp==='showering_hot';

// === BACKGROUND: grimy 1980s bathroom ===
R(0,0,W,H,'#1a1a1a');
// Tile wall
for(var ty=0;ty<19;ty++){for(var tx=0;tx<45;tx++){
  var tc=(tx+ty)%2===0?'#c8c4b8':'#bfbba8';
  if((tx*7+ty*13)%31===0)tc='#a8a498';
  R(tx*20,ty*20,19,19,tc);
}}
cx.strokeStyle='#8a8678';cx.lineWidth=1;
for(var gy=0;gy<=19;gy++){cx.beginPath();cx.moveTo(0,gy*20);cx.lineTo(W,gy*20);cx.stroke();}
for(var gx=0;gx<=45;gx++){cx.beginPath();cx.moveTo(gx*20,0);cx.lineTo(gx*20,380);cx.stroke();}
// Floor — darker tiles
R(0,360,W,120,'#5a5648');
for(var fx=0;fx<15;fx++){R(fx*60,360,58,58,(fx%2)?'#4a4638':'#524e40');}
for(var fx2=0;fx2<15;fx2++){R(fx2*60+30,420,58,58,(fx2%2)?'#524e40':'#4a4638');}

// === SHOWER STALL — LEFT SIDE ===
R(40,60,280,310,'#888878');R(45,65,270,300,'#999988');
// Shower head pipe + head
R(245,70,8,35,'#aaa');R(230,65,36,8,'#bbb');
// Shower knobs on wall (visible when not showering)
if(!isShowering){
  C(280,210,16,'#336699');C(280,210,10,'#4477aa');T('C',280,214,9,'#fff');
  C(280,255,16,'#993333');C(280,255,10,'#aa4444');T('H',280,259,9,'#fff');
  if(hover==='cold'){cx.strokeStyle='#6699ff';cx.lineWidth=3;cx.beginPath();cx.arc(280,210,20,0,Math.PI*2);cx.stroke();}
  if(hover==='hot'){cx.strokeStyle='#ff4444';cx.lineWidth=3;cx.beginPath();cx.arc(280,255,20,0,Math.PI*2);cx.stroke();}
}
// Shower curtain rod
R(35,56,290,5,'#aaa');
for(var ri=0;ri<9;ri++){C(48+ri*30,56,3,'#ccc');}

// === TARK IN SHOWER (full body visible) ===
if(isShowering){
  var wColor=bp==='showering_cold'?'#6699cc':'#cc8866';
  // Tark standing in shower — facing us, full body
  var sx=160,sy=240;
  // Cut-off jean shorts
  R(sx-16,sy+28,32,22,'#4466aa');
  // Denim details — seams + frayed edges
  cx.strokeStyle='#335588';cx.lineWidth=0.5;
  cx.beginPath();cx.moveTo(sx,sy+28);cx.lineTo(sx,sy+50);cx.stroke();
  R(sx-16,sy+28,32,3,'#3a5a99'); // waistband
  // Frayed bottom edges
  for(var fr=0;fr<6;fr++){R(sx-14+fr*5,sy+48,3,3,'#5577bb');}
  // Legs below shorts
  R(sx-12,sy+50,10,40,'#d4a574');R(sx+2,sy+50,10,40,'#d4a574');
  // Feet
  R(sx-14,sy+88,14,6,'#d4a574');R(sx+0,sy+88,14,6,'#d4a574');
  // Torso (no shirt — in the shower)
  R(sx-18,sy-12,36,42,'#d4a574');
  // Chest definition
  cx.globalAlpha=0.15;
  cx.beginPath();cx.arc(sx-6,sy+2,7,0,Math.PI*2);cx.fillStyle='#b8925e';cx.fill();
  cx.beginPath();cx.arc(sx+6,sy+2,7,0,Math.PI*2);cx.fill();
  cx.globalAlpha=1;
  // Abs — 6-pack lines
  cx.strokeStyle='#b8925e';cx.lineWidth=0.8;cx.globalAlpha=0.3;
  cx.beginPath();cx.moveTo(sx,sy+10);cx.lineTo(sx,sy+28);cx.stroke(); // center line
  cx.beginPath();cx.moveTo(sx-10,sy+12);cx.lineTo(sx+10,sy+12);cx.stroke(); // top row
  cx.beginPath();cx.moveTo(sx-9,sy+18);cx.lineTo(sx+9,sy+18);cx.stroke(); // mid row
  cx.beginPath();cx.moveTo(sx-8,sy+24);cx.lineTo(sx+8,sy+24);cx.stroke(); // low row
  cx.globalAlpha=1;
  // Neck
  R(sx-6,sy-10,12,6,'#d4a574');
  // Arms
  if(bp==='showering_cold'){
    // Arms crossed — hugging self, shivering
    var shk=Math.sin(Date.now()/60)*2;
    R(sx-22+shk,sy-6,12,8,'#d4a574');R(sx+10-shk,sy-6,12,8,'#d4a574');
    R(sx-16+shk,sy-2,32,8,'#d4a574');
  }else{
    // Arms up — hands in hair, relaxed
    R(sx-26,sy-10,10,28,'#d4a574');R(sx+16,sy-10,10,28,'#d4a574');
    C(sx-21,sy-14,5,'#d4a574');C(sx+21,sy-14,5,'#d4a574');
  }
  // Head
  C(sx,sy-26,18,'#d4a574');
  // Wet hair — top cap only (NOT covering face)
  cx.save();cx.beginPath();cx.arc(sx,sy-26,18,Math.PI,0);cx.clip();
  cx.globalAlpha=0.6;R(sx-18,sy-44,36,20,'#2a1a0a');cx.globalAlpha=1;
  cx.restore();
  if(_hc){cx.globalAlpha=0.7;R(sx-18,sy-42,36,4,_hc);cx.globalAlpha=1;}
  // Face expression
  if(bp==='showering_cold'){
    // Shocked — wide eyes, open mouth, shaking
    C(sx-6,sy-28,3.5,'#fff');C(sx+6,sy-28,3.5,'#fff');
    C(sx-6,sy-28,2,'#111');C(sx+6,sy-28,2,'#111');
    cx.beginPath();cx.arc(sx,sy-20,4,0,Math.PI);cx.fillStyle='#111';cx.fill();
    // Shiver lines
    var shk2=Math.sin(Date.now()/50)*3;
    R(sx-30+shk2,sy-38,6,2,'#6699ff');R(sx+24+shk2,sy-36,6,2,'#6699ff');
    R(sx-28+shk2,sy-18,5,2,'#6699ff');R(sx+26+shk2,sy-20,5,2,'#6699ff');
  }else{
    // Relaxed — eyes closed, content smile
    cx.strokeStyle='#111';cx.lineWidth=1.5;
    cx.beginPath();cx.arc(sx-6,sy-28,3,0,Math.PI);cx.stroke();
    cx.beginPath();cx.arc(sx+6,sy-28,3,0,Math.PI);cx.stroke();
    cx.beginPath();cx.arc(sx,sy-20,4,0.1*Math.PI,0.9*Math.PI);cx.stroke();
  }

  // Water streams (drawn OVER Tark)
  for(var wi=0;wi<14;wi++){
    var wx=100+wi*12+Math.sin(Date.now()/200+wi)*4;
    var wy=(Date.now()/80+wi*25)%300;
    cx.globalAlpha=0.35;
    cx.beginPath();cx.moveTo(wx,70);cx.lineTo(wx+Math.sin(wy/30)*3,70+wy);cx.strokeStyle=wColor;cx.lineWidth=1.5;cx.stroke();
  }
  cx.globalAlpha=1;
  // Splash at feet
  for(var sp=0;sp<6;sp++){
    var spx=130+sp*12+Math.sin(Date.now()/150+sp)*3;
    cx.globalAlpha=0.25;C(spx,340+Math.sin(Date.now()/200+sp)*3,2,wColor);
  }
  cx.globalAlpha=1;
  // Steam for hot
  if(bp==='showering_hot'){
    for(var si=0;si<8;si++){
      var steamY=340-((Date.now()/40+si*45)%320);
      var steamX=80+si*22+Math.sin(Date.now()/500+si)*12;
      cx.globalAlpha=0.06+Math.sin(Date.now()/600+si)*0.03;
      C(steamX,steamY,12+si*2,'#ffffff');
    }
    cx.globalAlpha=1;
  }
  // Ice particles for cold
  if(bp==='showering_cold'){
    for(var ic=0;ic<6;ic++){
      var icx=100+ic*25+Math.sin(Date.now()/250+ic*2)*10;
      var icy=(Date.now()/100+ic*50)%300+60;
      cx.globalAlpha=0.5;C(icx,icy,2,'#aaddff');cx.globalAlpha=1;
    }
  }
  // Partially transparent curtain on left side
  cx.globalAlpha=0.4;
  R(35,60,55,305,'#667766');
  cx.globalAlpha=1;
  R(38,60,3,305,'#556655');R(52,60,3,305,'#556655');R(66,60,3,305,'#556655');R(80,60,3,305,'#556655');

  // Progress bar
  var prog=Math.min(bt/3,1);
  R(80,440,250,12,'#333');R(80,440,250*prog,12,bp==='showering_cold'?'#6699ff':'#ff6644');
  T(bp==='showering_cold'?'FREEZING...':'RELAXING...',205,436,10,bp==='showering_cold'?'#99ccff':'#ffaa88');
}else{
  // Curtain partially open (idle)
  R(35,60,70,305,'#667766');R(38,60,3,305,'#556655');R(52,60,3,305,'#556655');R(66,60,3,305,'#556655');R(80,60,3,305,'#556655');R(94,60,3,305,'#556655');
  // Dripping water
  for(var di=0;di<3;di++){
    var dripY=(Date.now()/120+di*60)%260;
    cx.globalAlpha=0.35;C(235+di*5,80+dripY,1.5,'#6699cc');
  }
  cx.globalAlpha=1;
}
// Shower label
T('SHOWER',170,385,11,'#888');
if(S.apartment.showered){T('DONE',170,398,9,'#7fdb6a');}

// === MIRROR — RIGHT SIDE ===
R(550,70,230,240,'#5a4a3a');R(555,75,220,230,'#6a5a4a');
R(560,80,210,220,'#aab8cc');
// Mirror gleam
cx.globalAlpha=0.12;R(565,85,25,205,'#fff');cx.globalAlpha=1;
// Mirror reflection — ONLY when Tark is at the mirror
if(bp==='mirror'){
  // Tark's reflection — normal standing, looking at himself
  var mr=665,my=175;
  var mp=Math.sin(bt*3)*1;
  // Head
  C(mr,my-30+mp,15,'#d4a574');
  // Hair — top cap only
  cx.save();cx.beginPath();cx.arc(mr,my-30+mp,15,Math.PI,0);cx.clip();
  cx.globalAlpha=0.5;R(mr-15,my-45+mp,30,16,'#3a2a1a');cx.globalAlpha=1;
  cx.restore();
  if(_hc)R(mr-15,my-43+mp,30,4,_hc);
  // Eyes looking at self
  C(mr-5,my-32+mp,2,'#111');C(mr+5,my-32+mp,2,'#111');
  // Confident smirk
  cx.strokeStyle='#111';cx.lineWidth=1.5;
  cx.beginPath();cx.arc(mr,my-24+mp,4,0.05*Math.PI,0.95*Math.PI);cx.stroke();
  // Neck
  R(mr-5,my-17+mp,10,6,'#d4a574');
  // Torso
  R(mr-16,my-12+mp,32,38,_sc);
  // Arms — pointing at reflection
  if(bt>1.2){
    R(mr+14,my-6+mp,18,8,'#d4a574');C(mr+34,my-2+mp,4,'#d4a574');
  }else{
    R(mr-24,my-8+mp,10,26,'#d4a574');R(mr+14,my-8+mp,10,26,'#d4a574');
  }
  // Left arm at side
  R(mr-24,my-8+mp,10,26,'#d4a574');
  // Legs
  R(mr-10,my+26+mp,9,22,'#2a2a2a');R(mr+1,my+26+mp,9,22,'#2a2a2a');
}
// Mirror hover (only when idle and not already checking)
if(!animating&&hover==='mirror'){
  cx.strokeStyle='#ffcc00';cx.lineWidth=3;cx.strokeRect(548,68,234,246);
  T('Check yourself out',665,330,9,'#ffcc00');
}
T('MIRROR',665,330,11,'#888');
if(S.apartment.mirrorChecked){T('DONE',665,343,9,'#7fdb6a');}

// Mirror progress bar
if(bp==='mirror'){
  var mProg=Math.min(bt/2.5,1);
  R(550,440,230,12,'#333');R(550,440,230*mProg,12,'#ffcc00');
  T('LOOKING GOOD...',665,436,10,'#ffcc00');
}

// === RUBBER DUCK ===
C(350,358,8,'#ddcc00');C(350,351,6,'#ddcc00');R(354,353,6,3,'#dd8800');C(349,349,1.5,'#111');

// === BARE LIGHTBULB ===
R(448,5,4,18,'#666');C(450,25,8,'#fff8e0');cx.globalAlpha=0.06;C(450,25,35,'#fff8e0');cx.globalAlpha=1;

// === TOWEL RACK ===
R(420,280,6,80,'#8a7a6a');R(480,280,6,80,'#8a7a6a');
R(418,275,70,6,'#aaa');
R(430,281,50,55,'#cc8866');R(435,281,8,50,'#bb7755');R(455,281,8,50,'#bb7755');

// === TARK STANDING IN BATHROOM ===
if(!animating){
  var tx=400,ty=300;
  // Tark facing us (front view) — standing in the middle of the bathroom
  // Legs
  R(tx-12,ty+30,10,38,'#2a2a2a');R(tx+2,ty+30,10,38,'#2a2a2a');
  R(tx-14,ty+66,14,6,'#cc3333');R(tx+0,ty+66,14,6,'#cc3333');
  // Torso
  R(tx-16,ty-10,32,42,_sc);
  // Arms at sides
  R(tx-24,ty-6,10,30,'#d4a574');R(tx+14,ty-6,10,30,'#d4a574');
  C(tx-19,ty+26,5,'#d4a574');C(tx+19,ty+26,5,'#d4a574');
  // Neck
  R(tx-6,ty-8,12,6,'#d4a574');
  // Head
  C(tx,ty-22,16,'#d4a574');
  // Hair — top cap only (clipped to top half of head)
  cx.save();cx.beginPath();cx.arc(tx,ty-22,16,Math.PI,0);cx.clip();
  cx.globalAlpha=0.5;R(tx-16,ty-38,32,18,'#3a2a1a');cx.globalAlpha=1;
  cx.restore();
  if(_hc)R(tx-16,ty-36,32,4,_hc);
  // Eyes
  C(tx-5,ty-24,2,'#111');C(tx+5,ty-24,2,'#111');
  // Mouth — slight grimace (bathroom is gross)
  cx.strokeStyle='#111';cx.lineWidth=1;
  cx.beginPath();cx.moveTo(tx-4,ty-16);cx.lineTo(tx+4,ty-16);cx.stroke();
}

// === TARK AT MIRROR (standing in front of it) ===
if(bp==='mirror'){
  var mx=530,my=300;
  // Tark from behind — facing mirror
  R(mx-12,my+30,10,38,'#2a2a2a');R(mx+2,my+30,10,38,'#2a2a2a');
  R(mx-14,my+66,14,6,'#cc3333');R(mx+0,my+66,14,6,'#cc3333');
  R(mx-16,my-10,32,42,_sc);
  // Arms at sides initially, then pointing
  if(bt>1.2){
    // Right arm pointing at mirror
    R(mx+14,my-4,22,8,'#d4a574');C(mx+38,my,4,'#d4a574');
    R(mx-24,my-6,10,28,'#d4a574');
  }else{
    R(mx-24,my-6,10,28,'#d4a574');R(mx+14,my-6,10,28,'#d4a574');
  }
  C(mx-19,my+26,5,'#d4a574');C(mx+19,my+26,5,'#d4a574');
  C(mx,my-22,16,'#d4a574');
  cx.globalAlpha=0.4;C(mx,my-24,14,'#3a2a1a');cx.globalAlpha=1;
  if(_hc)R(mx-16,my-30,32,4,_hc);
  R(mx-6,my-8,12,6,'#d4a574');
}

// Speech bubble for mirror pep talk
if(bp==='mirror'&&bt>0.6){
  var msgs=['TODAY IS YOUR DAY.','LOOKING HUGE.','THEY\'RE NOT READY.','PURE MUSCLE.'];
  var msgIdx=Math.floor(bt*1.2)%msgs.length;
  var bx=530,by=230;
  cx.fillStyle='#fff';cx.beginPath();
  cx.moveTo(bx-70,by-14);cx.lineTo(bx+70,by-14);cx.quadraticCurveTo(bx+78,by-14,bx+78,by-6);
  cx.lineTo(bx+78,by+6);cx.quadraticCurveTo(bx+78,by+14,bx+70,by+14);
  cx.lineTo(bx+10,by+14);cx.lineTo(bx+5,by+24);cx.lineTo(bx,by+14);
  cx.lineTo(bx-70,by+14);cx.quadraticCurveTo(bx-78,by+14,bx-78,by+6);
  cx.lineTo(bx-78,by-6);cx.quadraticCurveTo(bx-78,by-14,bx-70,by-14);
  cx.fill();
  cx.strokeStyle='#ccc';cx.lineWidth=1;cx.stroke();
  T(msgs[msgIdx],bx,by+4,10,'#111');
}

// Speech bubble for cold shower
if(bp==='showering_cold'&&bt>0.5){
  var coldMsgs=['AAAARGH!!!','WHY DO I DO THIS','SO COLD','WAKE UP TARK'];
  var cIdx=Math.floor(bt*1.5)%coldMsgs.length;
  var cbx=160,cby=140;
  cx.fillStyle='#fff';cx.beginPath();
  cx.moveTo(cbx-55,cby-12);cx.lineTo(cbx+55,cby-12);cx.quadraticCurveTo(cbx+62,cby-12,cbx+62,cby-4);
  cx.lineTo(cbx+62,cby+4);cx.quadraticCurveTo(cbx+62,cby+12,cbx+55,cby+12);
  cx.lineTo(cbx+5,cby+12);cx.lineTo(cbx,cby+20);cx.lineTo(cbx-5,cby+12);
  cx.lineTo(cbx-55,cby+12);cx.quadraticCurveTo(cbx-62,cby+12,cbx-62,cby+4);
  cx.lineTo(cbx-62,cby-4);cx.quadraticCurveTo(cbx-62,cby-12,cbx-55,cby-12);
  cx.fill();
  T(coldMsgs[cIdx],cbx,cby+4,9,'#111');
}

// Speech bubble for hot shower
if(bp==='showering_hot'&&bt>0.8){
  var hotMsgs=['Ahhhhhh...','This is nice...','Five more minutes...','Almost falling asleep...'];
  var hIdx=Math.floor(bt)%hotMsgs.length;
  var hbx=160,hby=140;
  cx.fillStyle='#fff';cx.beginPath();
  cx.moveTo(hbx-60,hby-12);cx.lineTo(hbx+60,hby-12);cx.quadraticCurveTo(hbx+67,hby-12,hbx+67,hby-4);
  cx.lineTo(hbx+67,hby+4);cx.quadraticCurveTo(hbx+67,hby+12,hbx+60,hby+12);
  cx.lineTo(hbx+5,hby+12);cx.lineTo(hbx,hby+20);cx.lineTo(hbx-5,hby+12);
  cx.lineTo(hbx-60,hby+12);cx.quadraticCurveTo(hbx-67,hby+12,hbx-67,hby+4);
  cx.lineTo(hbx-67,hby-4);cx.quadraticCurveTo(hbx-67,hby-12,hbx-60,hby-12);
  cx.fill();
  T(hotMsgs[hIdx],hbx,hby+4,9,'#111');
}

// === EXIT BUTTON (always visible) ===
R(830,20,50,35,'#4a3a2a');T('EXIT',855,42,11,'#e8e4d8');
if(!animating&&hover==='closeBathroom'){cx.strokeStyle='#ff6b35';cx.lineWidth=3;cx.strokeRect(826,16,58,43);}

// Title
T('BATHROOM',450,18,14,'#6699ff');
// Instruction hint
if(!animating&&!S.apartment.showered&&!S.apartment.mirrorChecked){
  T('Click the shower knobs or the mirror',450,460,10,'#777');
}
}

function drawVHSSelection(){
// Full-screen VHS tape selection — floor view with 4 tapes
R(0,0,W,H,'#1a1a1a');
// Carpet floor
R(0,0,W,H,'#3a3028');
for(var cy2=0;cy2<16;cy2++)for(var cx2=0;cx2<30;cx2++){
  if((cx2+cy2)%3===0){cx.globalAlpha=0.05;R(cx2*30,cy2*30,28,28,'#000');cx.globalAlpha=1;}
}

// Title
T('PICK A TAPE',450,40,16,'#ff6b35');
T('What are we watching?',450,62,10,'#888');

// 4 VHS cases laid out — big chunky pixel art
var cases=[
  {key:'pumping',x:100,y:100,w:160,h:240,bg:'#8b6914',bg2:'#a07a1a',title:'PUMPING',title2:'IRON',tc:'#fff',tc2:'#ff6b35'},
  {key:'predator',x:280,y:100,w:160,h:240,bg:'#1a3a1a',bg2:'#2a4a2a',title:'PREDATOR',title2:'',tc:'#7fdb6a',tc2:''},
  {key:'predator2',x:460,y:100,w:160,h:240,bg:'#1a1a3a',bg2:'#2a2a5a',title:'PREDATOR',title2:'II',tc:'#6688aa',tc2:'#8899bb'},
  {key:'rumping',x:640,y:100,w:160,h:240,bg:'#5a1a3a',bg2:'#7a2a4a',title:'RUMPING',title2:'IRON',tc:'#ff69b4',tc2:'#ff99cc'}
];
for(var vi=0;vi<cases.length;vi++){
  var vc=cases[vi];
  // Case body
  R(vc.x,vc.y,vc.w,vc.h,vc.bg);R(vc.x+4,vc.y+4,vc.w-8,vc.h-8,vc.bg2);
  // Label area
  R(vc.x+10,vc.y+10,vc.w-20,80,'#111');
  // Title
  T(vc.title,vc.x+vc.w/2,vc.y+45,14,vc.tc);
  if(vc.title2)T(vc.title2,vc.x+vc.w/2,vc.y+65,16,vc.tc2);

  // Case art
  if(vc.key==='pumping'){
    // Flexing bodybuilder
    cx.save();cx.translate(vc.x+vc.w/2,vc.y+160);
    R(-14,6,28,30,'#c49060');C(0,-10,10,'#c49060');
    R(-22,2,10,18,'#c49060');R(-26,-14,12,18,'#c49060');C(-20,-4,6,'#d4a574');
    R(12,2,10,18,'#c49060');R(16,-14,12,18,'#c49060');C(22,-4,6,'#d4a574');
    cx.restore();
  }else if(vc.key==='predator'){
    // Jungle + crosshair
    cx.save();cx.translate(vc.x+vc.w/2,vc.y+155);
    for(var t3=0;t3<5;t3++){R(-30+t3*14,10,4,30,'#2a5a2a');R(-28+t3*14,0,8,10,'#3a6a3a');}
    // Crosshair — triangle dots
    cx.strokeStyle='#ff3333';cx.lineWidth=1.5;
    cx.beginPath();cx.arc(0,0,12,0,Math.PI*2);cx.stroke();
    cx.beginPath();cx.moveTo(-18,0);cx.lineTo(-12,0);cx.moveTo(12,0);cx.lineTo(18,0);
    cx.moveTo(0,-18);cx.lineTo(0,-12);cx.moveTo(0,12);cx.lineTo(0,18);cx.stroke();
    C(0,0,2,'#ff3333');
    cx.restore();
  }else if(vc.key==='predator2'){
    // City skyline at night
    cx.save();cx.translate(vc.x+vc.w/2,vc.y+170);
    R(-50,0,100,20,'#222');
    R(-40,-20,14,30,'#333');R(-20,-35,12,45,'#333');R(-2,-25,16,35,'#333');R(18,-15,14,25,'#333');R(34,-10,10,20,'#333');
    // Windows
    for(var bld=0;bld<4;bld++){for(var fl=0;fl<3;fl++){
      var bx2=-38+bld*20,by2=-8-fl*8;
      if(Math.random()>0.4)R(bx2,by2,3,3,'#ffcc44');
    }}
    C(30,-30,6,'#8899bb');
    cx.restore();
  }else if(vc.key==='rumping'){
    // Heart + suggestive
    cx.save();cx.translate(vc.x+vc.w/2,vc.y+155);
    cx.fillStyle='#ff3366';cx.beginPath();
    cx.moveTo(0,14);cx.bezierCurveTo(-4,6,-18,-6,-18,-14);cx.bezierCurveTo(-18,-24,0,-24,0,-14);
    cx.bezierCurveTo(0,-24,18,-24,18,-14);cx.bezierCurveTo(18,-6,4,6,0,14);cx.fill();
    T('XXX',0,30,10,'#ff69b4');
    cx.restore();
  }

  // VHS tape window on case
  R(vc.x+30,vc.y+200,vc.w-60,20,'#111');
  R(vc.x+40,vc.y+204,20,12,'#f5f0e0');R(vc.x+vc.w-60,vc.y+204,20,12,'#f5f0e0');

  // Hover highlight
  if(hover===vc.key){
    cx.strokeStyle='#ff6b35';cx.lineWidth=3;cx.strokeRect(vc.x-2,vc.y-2,vc.w+4,vc.h+4);
  }
}

// Close button
R(820,20,60,35,'#4a3a2a');T('CANCEL',850,42,10,'#e8e4d8');
if(hover==='closeVHS'){cx.strokeStyle='#ff6b35';cx.lineWidth=3;cx.strokeRect(816,16,68,43);}

// Funny taglines below each case
T('"The greatest movie ever made."',180,355,8,'#cca844');
T('"If it bleeds, we can kill it."',360,355,8,'#7fdb6a');
T('"No Arnold... but Danny Glover',540,350,7,'#8899bb');
T('holds it down."',540,362,7,'#8899bb');
T('"...for research purposes."',720,355,8,'#ff99cc');
// Stat hints
T('TECH+5 STR+3',180,375,7,'#666');
T('FOC+8 RDY+5',360,375,7,'#666');
T('FOC+3 NERV-8',540,375,7,'#666');
T('SWAG+15 NERV+5',720,375,7,'#666');
}

function drawPhoneMenu(){
// Physical Rolodex on desk
R(0,0,W,H,'#1a1510');
// Desk surface — wooden
R(0,370,W,110,'#3a2a1a');R(0,368,W,4,'#5a4a3a');
// Wood grain on desk
cx.globalAlpha=0.08;
for(var gi=0;gi<8;gi++){R(0,375+gi*12,W,1,'#aa8855');}
cx.globalAlpha=1;

// === ROLODEX DEVICE ===
var rdx=450,rdy=210; // center of rolodex

// Shadow under device
cx.globalAlpha=0.3;R(rdx-220,rdy+135,440,20,'#000');cx.globalAlpha=1;

// Metal base plate
R(rdx-210,rdy+130,420,18,'#666');R(rdx-208,rdy+132,416,14,'#777');
// Base shine
cx.globalAlpha=0.2;R(rdx-200,rdy+133,400,3,'#bbb');cx.globalAlpha=1;

// Metal frame — left upright
R(rdx-205,rdy-60,8,195,'#666');R(rdx-203,rdy-58,4,191,'#777');
// Metal frame — right upright
R(rdx+197,rdy-60,8,195,'#666');R(rdx+199,rdy-58,4,191,'#777');

// Spindle rod across top
R(rdx-205,rdy-62,410,6,'#888');R(rdx-205,rdy-60,410,2,'#aaa');

// Card drum — curved stack of cards behind the front ones
// Back cards fanning up (decorative depth)
for(var bc=5;bc>=0;bc--){
  var bcOff=bc*3;
  cx.globalAlpha=0.15+bc*0.04;
  R(rdx-190+bcOff,rdy-50-bcOff,380-bcOff*2,12,'#e8dcc0');
  cx.globalAlpha=1;
}

// === CONTACT CARDS (3 left, 3 right — arranged as rolodex cards) ===
var contacts=[
  {key:'gym',name:'THE GYM',desc:'Check today\'s schedule',idx:0},
  {key:'coach',name:'COACH',desc:'Pre-meet pep talk',idx:1},
  {key:'mother',name:'MOTHER',desc:'She worries',idx:2},
  {key:'r1',name:'???',desc:'Coming soon',idx:3},
  {key:'r2',name:'???',desc:'Coming soon',idx:4},
  {key:'r3',name:'???',desc:'Coming soon',idx:5}
];
var zones=['callGym','callCoach','callMother','callRandom1','callRandom2','callRandom3'];

// Card positions — 3 per column, stacked vertically like a real rolodex display
var cardW=170,cardH=70;
var leftX=rdx-195,rightX=rdx+20;
var startY=rdy-40;

for(var ci=0;ci<contacts.length;ci++){
  var c=contacts[ci];var z=zones[ci];
  var used=S.apartment.phoneUsed[c.key];
  var isRandom=ci>=3;
  var hov=hover===z;
  var cx2=ci<3?leftX:rightX;
  var cy2=startY+(ci%3)*80;

  // Card shadow
  cx.globalAlpha=0.2;R(cx2+3,cy2+3,cardW,cardH,'#000');cx.globalAlpha=1;

  // Card body — cream/off-white like actual rolodex card
  var cardCol=isRandom?'#4a4238':hov?'#f0e4c8':'#e0d4b8';
  R(cx2,cy2,cardW,cardH,cardCol);

  // Lined paper effect
  if(!isRandom){
    cx.globalAlpha=0.12;
    for(var li=0;li<5;li++){R(cx2+10,cy2+16+li*12,cardW-20,1,'#88aacc');}
    cx.globalAlpha=1;
  }

  // Tab at top — protruding tab like a real rolodex card
  var tabW=40,tabH=14;
  var tabX=cx2+10+(ci%3)*((cardW-tabW-20)/2);
  var tabCol=isRandom?'#3a3630':hov?'#ff6b35':'#c8b898';
  R(tabX,cy2-tabH+2,tabW,tabH,tabCol);
  // Tab text — first letter
  var tabLetter=isRandom?'?':c.name.charAt(0);
  T(tabLetter,tabX+tabW/2,cy2-2,8,isRandom?'#555':hov?'#fff':'#5a4a3a');

  // Notch at bottom center (where card clips to the drum)
  R(cx2+cardW/2-8,cy2+cardH-4,16,4,isRandom?'#3a3630':'#c8b898');
  C(cx2+cardW/2,cy2+cardH,3,isRandom?'#333':'#baa888');

  // Card border
  cx.strokeStyle=hov&&!isRandom?'#ff6b35':'rgba(140,120,90,0.4)';
  cx.lineWidth=hov&&!isRandom?2:0.5;
  cx.strokeRect(cx2,cy2,cardW,cardH);

  // Content
  var nameColor=isRandom?'#555':used?'#7a7a6a':hov?'#ff6b35':'#3a2a1a';
  T(c.name,cx2+cardW/2,cy2+28,11,nameColor);
  T(c.desc,cx2+cardW/2,cy2+46,7,isRandom?'#444':'#887755');

  // Checkmark if already called
  if(used){T('\u2713',cx2+cardW-14,cy2+20,14,'#5a8a5a');}

  // Hover glow
  if(hov&&!isRandom){
    cx.globalAlpha=0.08;R(cx2,cy2,cardW,cardH,'#ff6b35');cx.globalAlpha=1;
  }
}

// Knob on top of spindle (center)
C(rdx,rdy-62,8,'#555');C(rdx,rdy-62,5,'#777');
// Shine on knob
cx.globalAlpha=0.4;C(rdx-1,rdy-64,2,'#bbb');cx.globalAlpha=1;

// Rotary phone on desk — right side
R(660,340,100,35,'#cbb88a');R(662,342,96,31,'#ddc9aa');
// Dial
C(710,352,14,'#333');C(710,352,9,'#222');C(710,352,3,'#555');
// Receiver — off hook, cord hanging
R(620,338,45,10,'#222');R(618,336,10,14,'#222');R(663,336,10,14,'#222');
cx.strokeStyle='#333';cx.lineWidth=2;
cx.beginPath();cx.moveTo(618,342);cx.quadraticCurveTo(590,360,580,370);cx.stroke();

// Hang up / Put back button
var hov2=hover==='closePhone';
R(rdx-80,rdy+155,160,24,hov2?'rgba(255,107,53,0.25)':'rgba(80,65,45,0.5)');
cx.strokeStyle=hov2?'#ff6b35':'rgba(170,136,85,0.4)';cx.lineWidth=hov2?2:1;
cx.strokeRect(rdx-80,rdy+155,160,24);
T('HANG UP',rdx,rdy+170,10,hov2?'#ff6b35':'#aa8855');
}

function drawDoorChoice(){
// Exterior: Tark outside his rundown 80s NYC apartment
// Sky — early morning, grey-orange
var skyG=cx.createLinearGradient(0,0,0,180);
skyG.addColorStop(0,'#2a2a3a');skyG.addColorStop(0.5,'#4a3a3a');skyG.addColorStop(1,'#7a5a4a');
cx.fillStyle=skyG;cx.fillRect(0,0,W,180);

// Distant buildings silhouette
R(0,60,55,140,'#1a1a22');R(45,80,40,120,'#1e1e28');R(80,50,50,150,'#1a1a24');
R(810,70,40,130,'#1a1a22');R(845,55,55,145,'#1e1e28');
// Distant windows
cx.globalAlpha=0.25;
for(var db=0;db<3;db++){for(var df=0;df<3;df++){R(8+db*28+df*10,85+db*15,3,3,'#ffcc66');}}
for(var db2=0;db2<2;db2++){for(var df2=0;df2<3;df2++){R(818+db2*35+df2*9,88+db2*12,3,3,'#ffcc66');}}
cx.globalAlpha=1;

// === MAIN BUILDING — grey/brown rundown ===
var bx=200,bw=360,by=20,bh=380;
R(bx,by,bw,bh,'#5a5550');
// Brick texture — grey tones
for(var br=0;br<26;br++){for(var bc=0;bc<12;bc++){
  var bxo=bx+4+bc*30+(br%2)*15,byo=by+4+br*15;
  if(bxo>bx&&bxo+26<bx+bw&&byo<by+bh){
    cx.globalAlpha=0.07;R(bxo,byo,26,12,(br+bc)%3===0?'#000':'#6a6560');cx.globalAlpha=1;
  }
}}
// Grime/water stains
cx.globalAlpha=0.1;R(bx+15,by+60,50,220,'#1a1a0a');R(bx+bw-60,by+40,40,260,'#1a1a0a');
R(bx+120,by+150,80,140,'#2a2a1a');cx.globalAlpha=1;

// === SECOND BUILDING — right side, angled to show side wall + alley ===
var b2x=bx+bw+30,b2w=180,b2y=10,b2h=390;
// Front face (partially visible)
R(b2x,b2y,b2w,b2h,'#4a4844');
// Brick texture
for(var br2=0;br2<27;br2++){for(var bc2=0;bc2<6;bc2++){
  var bxo2=b2x+4+bc2*30+(br2%2)*15,byo2=b2y+4+br2*15;
  if(bxo2>b2x&&bxo2+26<b2x+b2w&&byo2<b2y+b2h){
    cx.globalAlpha=0.06;R(bxo2,byo2,26,12,'#3a3834');cx.globalAlpha=1;
  }
}}
// Windows on second building
for(var wr=0;wr<3;wr++){for(var wc=0;wc<2;wc++){
  var wx2=b2x+30+wc*70,wy2=b2y+50+wr*100;
  R(wx2,wy2,45,50,'#1a2230');R(wx2+1,wy2+1,43,48,'#222e38');
  R(wx2,wy2,45,3,'#555');R(wx2,wy2+47,45,3,'#555');R(wx2,wy2,3,50,'#555');R(wx2+42,wy2,3,50,'#555');
  R(wx2+20,wy2,4,50,'#555');R(wx2,wy2+24,45,3,'#555');
  if(wr===0&&wc===1){cx.fillStyle='#0a0a14';cx.beginPath();cx.moveTo(wx2+6,wy2+5);cx.lineTo(wx2+22,wy2+8);cx.lineTo(wx2+18,wy2+22);cx.lineTo(wx2+8,wy2+18);cx.closePath();cx.fill();}
  else{cx.globalAlpha=0.12;R(wx2+3,wy2+3,16,20,'#ffcc66');cx.globalAlpha=1;}
}}

// === ALLEY between buildings ===
// Dark receding alley
var ax=bx+bw,aw=30,ay=by+60;
// Alley darkness — gradient getting darker toward back
var alG=cx.createLinearGradient(ax,0,ax+aw,0);
alG.addColorStop(0,'#1a1816');alG.addColorStop(0.5,'#0e0d0c');alG.addColorStop(1,'#1a1816');
cx.fillStyle=alG;cx.fillRect(ax,ay,aw,bh-60);
// Perspective lines — alley walls receding
cx.strokeStyle='#2a2a28';cx.lineWidth=1;
cx.beginPath();cx.moveTo(ax,by+bh);cx.lineTo(ax+aw/2,ay);cx.stroke();
cx.beginPath();cx.moveTo(ax+aw,by+bh);cx.lineTo(ax+aw/2,ay);cx.stroke();
// Dumpster deep in alley
R(ax+5,by+bh-60,20,25,'#2a4a2a');
// Steam/mystery
cx.globalAlpha=0.08;C(ax+15,ay+40,12,'#aaa');C(ax+12,ay+60,8,'#aaa');cx.globalAlpha=1;

// Fire escape — main building left side
var fex=bx+25;
cx.strokeStyle='#4a4a4a';cx.lineWidth=2;
for(var fe=0;fe<3;fe++){
  var fey=by+65+fe*95;
  R(fex,fey,75,4,'#505050');R(fex,fey,4,28,'#505050');R(fex+71,fey,4,28,'#505050');
  cx.beginPath();cx.moveTo(fex,fey);cx.lineTo(fex,fey-10);cx.moveTo(fex+75,fey);cx.lineTo(fex+75,fey-10);cx.stroke();
  if(fe<2){cx.beginPath();cx.moveTo(fex+55,fey+4);cx.lineTo(fex+55,fey+95);cx.moveTo(fex+65,fey+4);cx.lineTo(fex+65,fey+95);cx.stroke();
    for(var ru=0;ru<5;ru++){cx.beginPath();cx.moveTo(fex+55,fey+18+ru*15);cx.lineTo(fex+65,fey+18+ru*15);cx.stroke();}
  }
}

// Windows — main building, 3 rows of 3, some broken
var wins=[
  {x:bx+120,y:by+50,broken:true},{x:bx+195,y:by+50,broken:false},{x:bx+270,y:by+50,broken:true},
  {x:bx+120,y:by+145,broken:false},{x:bx+195,y:by+145,broken:true},{x:bx+270,y:by+145,broken:false},
  {x:bx+120,y:by+240,broken:false},{x:bx+195,y:by+240,broken:false},{x:bx+270,y:by+240,broken:true}
];
for(var wi=0;wi<wins.length;wi++){
  var w=wins[wi];
  R(w.x,w.y,50,55,'#1a2230');R(w.x+2,w.y+2,46,51,'#222e38');
  R(w.x,w.y,50,3,'#555');R(w.x,w.y+52,50,3,'#555');R(w.x,w.y,3,55,'#555');R(w.x+47,w.y,3,55,'#555');
  R(w.x+23,w.y,4,55,'#555');R(w.x,w.y+26,50,3,'#555');
  if(w.broken){
    cx.fillStyle='#0a0a14';cx.beginPath();
    cx.moveTo(w.x+8,w.y+6);cx.lineTo(w.x+30,w.y+10);cx.lineTo(w.x+25,w.y+24);
    cx.lineTo(w.x+12,w.y+20);cx.closePath();cx.fill();
    cx.strokeStyle='#8899aa';cx.lineWidth=1;
    cx.beginPath();cx.moveTo(w.x+25,w.y+24);cx.lineTo(w.x+35,w.y+35);cx.stroke();
    cx.beginPath();cx.moveTo(w.x+8,w.y+6);cx.lineTo(w.x+5,w.y+15);cx.stroke();
  }else{
    cx.globalAlpha=0.12;R(w.x+4,w.y+4,18,22,'#ffcc66');cx.globalAlpha=1;
  }
}

// Front door — Tark's apartment entrance
var dx=bx+bw/2-25,dy=by+bh-105;
R(dx-2,dy-6,54,111,'#444');
R(dx,dy,50,105,'#3a3028');R(dx+3,dy+3,44,99,'#4a3a2e');
C(dx+42,dy+55,3,'#aa8844');
T('4B',dx+25,dy+18,10,'#887766');
// Stoop
R(dx-25,dy+105,100,10,'#606060');R(dx-15,dy+115,80,8,'#6a6a6a');R(dx-5,dy+123,60,5,'#707070');

// Graffiti
cx.save();cx.translate(bx+bw-50,by+bh-45);
cx.font='bold 10px monospace';cx.fillStyle='#cc3333';cx.textAlign='center';cx.fillText('TARK',0,0);
cx.font='6px monospace';cx.fillStyle='#44cc44';cx.fillText('WUZ HERE',0,10);
cx.restore();cx.textAlign='center';

// Sidewalk
R(0,FY,W,80,'#585858');
cx.strokeStyle='#4a4a4a';cx.lineWidth=1;
for(var sc=0;sc<9;sc++){cx.beginPath();cx.moveTo(sc*110+20,FY);cx.lineTo(sc*110+40,FY+80);cx.stroke();}
R(0,FY-2,W,4,'#666');
// Street
R(0,FY+55,W,25,'#2a2a2a');
// Road lines
cx.setLineDash([20,15]);cx.strokeStyle='#554';cx.lineWidth=2;
cx.beginPath();cx.moveTo(0,FY+67);cx.lineTo(W,FY+67);cx.stroke();cx.setLineDash([]);

// === HOMELESS DRUNK — sitting against building, left side ===
cx.save();cx.translate(bx+18,FY-4);
// Dirty blanket draped over lap/legs
R(-14,-4,34,14,'#3a4a3a');R(-12,-2,30,10,'#445540');
cx.globalAlpha=0.15;R(-10,0,10,6,'#222');R(8,-2,8,6,'#222');cx.globalAlpha=1;
// Boots/shoes poking out
R(-14,8,10,5,'#2a2218');R(-3,8,10,5,'#2a2218');
// Legs — knees up under blanket
R(-8,-10,10,18,'#3a3828');R(4,-10,10,18,'#3a3828');
// Torso — bulky dirty coat
R(-10,-36,26,30,'#4a4232');R(-8,-34,22,26,'#524a38');
// Coat collar / layers
R(-8,-38,22,6,'#5a5240');R(-6,-36,8,4,'#3a3828');R(6,-36,8,4,'#3a3828');
// Left arm resting on knee
R(-14,-18,8,16,'#4a4232');R(-16,-6,6,4,'#b08a68');
// Right arm holding bottle
R(12,-20,8,14,'#4a4232');R(18,-10,5,4,'#b08a68');
// Brown paper bag with bottle
R(20,-26,10,20,'#8a7040');R(21,-25,8,14,'#9a7a48');
// Bottle neck poking out top
R(23,-32,4,8,'#2a5a2a');C(25,-33,2,'#2a5a2a');
// Head — drooping to one side
C(5,-44,8,'#b08a68');
// Scruffy beard
R(-2,-40,10,6,'#6a5a3a');R(-1,-38,8,5,'#7a6a44');
// Bloodshot/tired eyes
C(2,-46,1.5,'#eee');C(7,-46,1.5,'#eee');C(2,-46,0.8,'#633');C(7,-46,0.8,'#633');
// Mouth slightly open
R(3,-41,3,1.5,'#8a5a4a');
// Beanie — pulled down
cx.fillStyle='#553322';cx.beginPath();
cx.moveTo(-5,-52);cx.quadraticCurveTo(5,-58,15,-52);cx.lineTo(14,-46);cx.lineTo(-4,-46);cx.closePath();cx.fill();
R(-4,-48,18,4,'#664433');
// Stubble on cheeks
cx.globalAlpha=0.2;for(var st=0;st<6;st++){C(-1+st*2,-43+Math.sin(st)*1,0.5,'#444');}cx.globalAlpha=1;
// Cardboard sign leaning against legs
cx.save();cx.rotate(-0.15);
R(-28,-2,24,14,'#8a7a58');R(-27,-1,22,12,'#9a8a64');
cx.font='5px monospace';cx.fillStyle='#3a2a1a';cx.textAlign='center';
cx.fillText('NEED $$',-16,9);
cx.restore();
cx.restore();cx.textAlign='center';

// Trash bags near dumpster in alley
C(bx-15,FY-6,10,'#1a1a1a');C(bx-3,FY-4,8,'#222');
// Fire hydrant
R(b2x+35,FY-20,12,20,'#aa2222');R(b2x+33,FY-24,16,5,'#cc3333');C(b2x+41,FY-10,4,'#cc3333');

// === STRAY DOG — in front of hydrant, with idle animation ===
var dogBaseX=b2x+50,dogBaseY=FY-4;
var dt=Date.now()*0.001;
// Idle cycle: weight shift, tail wag, occasional head bob
var dogShiftX=Math.sin(dt*0.7)*1.5; // subtle side-to-side
var dogBob=Math.sin(dt*1.3)*0.5; // tiny body bob
var tailWag=Math.sin(dt*3)*0.3; // tail wagging
var headBob=Math.sin(dt*0.9)*1; // slight head movement
// Every ~4s the dog looks left briefly (snout direction flip)
var lookCycle=dt%6;var snoutFlip=(lookCycle>4.5&&lookCycle<5.2)?-1:1;
cx.save();cx.translate(dogBaseX+dogShiftX,dogBaseY+dogBob);
// Body
R(-12,-8,24,10,'#8a7a5a');
// Head — bobs slightly
R(12*snoutFlip,-14+headBob,10,10,'#8a7a5a');R(14*snoutFlip,-12+headBob,8,5,'#7a6a4a');
// Snout
R((snoutFlip>0?22:(-22-6)),-10+headBob,6,4,'#6a5a3a');
// Ears
cx.fillStyle='#6a5a3a';
if(snoutFlip>0){
  cx.beginPath();cx.moveTo(14,-14+headBob);cx.lineTo(12,-20+headBob);cx.lineTo(18,-14+headBob);cx.fill();
  cx.beginPath();cx.moveTo(20,-14+headBob);cx.lineTo(19,-20+headBob);cx.lineTo(23,-14+headBob);cx.fill();
}else{
  cx.beginPath();cx.moveTo(-14,-14+headBob);cx.lineTo(-12,-20+headBob);cx.lineTo(-18,-14+headBob);cx.fill();
  cx.beginPath();cx.moveTo(-20,-14+headBob);cx.lineTo(-19,-20+headBob);cx.lineTo(-23,-14+headBob);cx.fill();
}
// Legs — slight weight shift
var legShift=Math.sin(dt*1.1)*0.8;
R(-10,2,4,8-legShift*0.3,'#7a6a4a');R(0,2,4,8+legShift*0.3,'#7a6a4a');R(8,2,4,8-legShift*0.3,'#7a6a4a');
// Tail — wagging
cx.strokeStyle='#8a7a5a';cx.lineWidth=2;
cx.beginPath();cx.moveTo(-12,-6);cx.quadraticCurveTo(-20+tailWag*6,-18,-16+tailWag*4,-22);cx.stroke();
// Eye
C(snoutFlip>0?20:-20,-11+headBob,1,'#111');
cx.restore();

// === STREET SIGN POSTS — these are the clickable nav ===
var pulse=Math.sin(Date.now()/500)*0.12+0.88;

// Left sign post — Venice Beach
var lsH=hover==='doorBeach';
R(68,100,5,300,'#666');R(66,98,9,4,'#777');
// Sign plate — green NYC style
var lsc=lsH?'#ff6b35':'#225522';
R(10,105,120,40,lsc);R(12,107,116,36,lsH?'#ff8855':'#2a6a2a');
// Sign border
cx.strokeStyle=lsH?'#ffaa66':'#4a8a4a';cx.lineWidth=lsH?2:1;cx.strokeRect(10,105,120,40);
// Arrow + text
T('\u2190 VENICE BEACH',70,130,9,'#fff');
// Subtitle below post
T(lsH?'Sun & trouble':'',70,158,7,'#ff6b35');

// Center sign post — Downtown
var csH=hover==='doorDowntown';
R(450,100,5,300,'#666');R(448,98,9,4,'#777');
var csc=csH?'#ff6b35':'#225522';
R(390,105,120,40,csc);R(392,107,116,36,csH?'#ff8855':'#2a6a2a');
cx.strokeStyle=csH?'#ffaa66':'#4a8a4a';cx.lineWidth=csH?2:1;cx.strokeRect(390,105,120,40);
T('DOWNTOWN \u2193',450,130,9,'#fff');
T(csH?'Bars & bodegas':'',450,158,7,'#ff6b35');

// Right sign post — Gym
var rsH=hover==='doorGym';
R(828,100,5,300,'#666');R(826,98,9,4,'#777');
var rsc=rsH?'#ff6b35':'#225522';
R(770,105,120,40,rsc);R(772,107,116,36,rsH?'#ff8855':'#2a6a2a');
cx.strokeStyle=rsH?'#ffaa66':'#4a8a4a';cx.lineWidth=rsH?2:1;cx.strokeRect(770,105,120,40);
T('THE GYM \u2192',830,130,9,'#fff');
T(rsH?'All business':'',830,158,7,'#ff6b35');

// === TARK standing on sidewalk ===
drawTarkIdle(420,358,false);

// Go back inside — small text above door
var gbc=hover==='doorCancel'?'#ff6b35':'#888';
T('GO BACK INSIDE',dx+25,dy-10,8,gbc);
if(hover==='doorCancel'){cx.strokeStyle='#ff6b35';cx.lineWidth=1;cx.strokeRect(dx-15,dy-18,80,14);}
// Homeless man hover
if(hover==='hoboZone'&&!S.apartment.pickpocketAttempted){
  T('Pickpocket',218,340,8,'#ff6b35');
  cx.strokeStyle='#ff6b35';cx.lineWidth=1;cx.strokeRect(178,342,80,55);
}
if(hover==='dogZone'&&!S.apartment.dogChaseAttempted){
  T('Chase dog?',dogBaseX,dogBaseY-28,8,'#ff6b35');
  cx.strokeStyle='#ff6b35';cx.lineWidth=1;cx.strokeRect(620,375,55,30);
}
}

// === PICKPOCKET SCENE ===
var HOBO_MUMBLES=["...no officer...","...five more minutes...","...wasn't me...","...rent's late...","*snore*","...Tark?...","...not the bees...","...I used to be somebody...","...three more stops..."];

function drawPickpocketScene(){
var pk=S.pickpocket;if(!pk)return;
var t=Date.now()*0.001;
var SC=2;

// === BACKGROUND ===
var skyG=cx.createLinearGradient(0,0,0,100);
skyG.addColorStop(0,'#1a1a2e');skyG.addColorStop(1,'#2a2a3e');
R(0,0,W,100,skyG);
var wallG=cx.createLinearGradient(0,80,0,380);
wallG.addColorStop(0,'#6a4a3a');wallG.addColorStop(1,'#5a3a2a');
R(0,80,W,300,wallG);
cx.globalAlpha=0.1;
for(var by=82;by<370;by+=12){
  var off=(Math.floor(by/12)%2)*20;
  for(var bx=off;bx<W;bx+=40){cx.strokeStyle='#3a2a1a';cx.lineWidth=0.5;cx.strokeRect(bx,by,38,10);}
}
cx.globalAlpha=1;
cx.globalAlpha=0.06;for(var gi=0;gi<8;gi++){R(80+gi*110,80,2,30+gi*6,'#2a1a0a');}cx.globalAlpha=1;
R(0,375,W,105,'#6a6a6a');R(0,375,W,3,'#888');
cx.strokeStyle='#555';cx.lineWidth=0.5;
for(var si=0;si<4;si++){var sx=150+si*200;cx.beginPath();cx.moveTo(sx,380);cx.lineTo(sx+15,420);cx.stroke();}
R(0,465,W,15,'#3a3a3a');
cx.globalAlpha=0.05;var lg=cx.createRadialGradient(450,200,10,450,200,300);
lg.addColorStop(0,'#ffeeaa');lg.addColorStop(1,'transparent');cx.fillStyle=lg;cx.fillRect(0,0,W,480);cx.globalAlpha=1;

// === POSITIONS ===
var GY=375;
var HOBO_X=520,HOBO_BY=GY;
var TARK_X=320;
var targetX=HOBO_X,targetY=HOBO_BY-50;
if(pk.targetIdx!==null){targetX=pk.cigarettes[pk.targetIdx].cx;targetY=pk.cigarettes[pk.targetIdx].cy;}

// === CUTSCENE ===
if(pk.phase==='cutscene'){
  pk.cutsceneTimer--;
  if(pk.cutsceneTimer>450)pk.cutsceneStep='sitting';
  else if(pk.cutsceneTimer>330)pk.cutsceneStep='fumble';
  else if(pk.cutsceneTimer>210)pk.cutsceneStep='spill';
  else pk.cutsceneStep='pass_out';
  // Animate cig spill (staggered arcs from pack center to final positions)
  if(pk.cutsceneStep==='spill'){
    for(var si=0;si<pk.cigSpill.length;si++){
      var delay=si*12;var elapsed=(330-pk.cutsceneTimer)-delay;
      if(elapsed>0){pk.cigSpill[si].started=true;pk.cigSpill[si].progress=Math.min(1,elapsed/70);}
    }
  }
  if(pk.cutsceneTimer<=0){pk.phase='intro';pk.introTimer=120;}

  // --- Cutscene hobo rendering ---
  var cs=pk.cutsceneStep;
  var PACK_CX=HOBO_X-10*SC,PACK_CY=HOBO_BY-36*SC; // pack origin for spill arcs
  cx.save();cx.translate(HOBO_X,HOBO_BY);cx.scale(SC,SC);

  if(cs==='sitting'){
    // Upright, rummaging in coat
    var rum=Math.sin(t*2)*2;
    // Legs
    R(-14,-4,34,14,'#3a4a3a');R(-12,-2,30,10,'#445540');
    R(-14,8,10,5,'#2a2218');R(-3,8,10,5,'#2a2218');
    // Body — more upright
    R(-8,-38,22,34,'#4a4232');R(-6,-36,18,28,'#524a38');
    R(-8,-42,22,6,'#5a5240');
    // Head — upright, eyes open
    C(5,-48,8,'#b08a68');
    R(-2,-44,10,6,'#6a5a3a');R(-1,-42,8,5,'#7a6a44');
    // Eyes open — groggy
    C(2,-50,1.5,'#fff');C(7,-50,1.5,'#fff');C(2,-50,0.8,'#633');C(7,-50,0.8,'#633');
    // Hat
    cx.fillStyle='#553322';cx.beginPath();cx.moveTo(-5,-56);cx.quadraticCurveTo(5,-62,15,-56);cx.lineTo(14,-50);cx.lineTo(-4,-50);cx.closePath();cx.fill();
    R(-4,-52,18,4,'#664433');
    // Left arm rummaging in coat
    cx.save();cx.rotate(-0.1);R(-14,-22,8,16,'#4a4232');
    var rHand=-18+rum;R(rHand,-10,5,4,'#b08a68');cx.restore();
    // Right arm at side
    R(12,-24,8,14,'#4a4232');R(18,-14,5,4,'#b08a68');
    // Sign
    cx.save();cx.rotate(-0.15);R(-28,-2,24,14,'#8a7a58');R(-27,-1,22,12,'#9a8a64');
    cx.font='5px monospace';cx.fillStyle='#3a2a1a';cx.textAlign='center';cx.fillText('NEED $$',-16,9);cx.restore();
    // Bottle
    R(20,-30,10,20,'#8a7040');R(21,-29,8,14,'#9a7a48');R(23,-36,4,8,'#2a5a2a');C(25,-37,2,'#2a5a2a');
  }else if(cs==='fumble'){
    // Pulled pack out, fumbling it
    var wobble=Math.sin(t*5)*3;
    // Legs
    R(-14,-4,34,14,'#3a4a3a');R(-12,-2,30,10,'#445540');
    R(-14,8,10,5,'#2a2218');R(-3,8,10,5,'#2a2218');
    // Body
    R(-8,-38,22,34,'#4a4232');R(-6,-36,18,28,'#524a38');
    R(-8,-42,22,6,'#5a5240');
    // Head
    C(5,-48,8,'#b08a68');
    R(-2,-44,10,6,'#6a5a3a');R(-1,-42,8,5,'#7a6a44');
    // Eyes — wider, looking at pack
    C(2,-50,2,'#fff');C(7,-50,2,'#fff');C(2,-50,1,'#633');C(7,-50,1,'#633');
    // Hat
    cx.fillStyle='#553322';cx.beginPath();cx.moveTo(-5,-56);cx.quadraticCurveTo(5,-62,15,-56);cx.lineTo(14,-50);cx.lineTo(-4,-50);cx.closePath();cx.fill();
    R(-4,-52,18,4,'#664433');
    // Left arm out holding pack (wobbling)
    R(-14,-22,8,16,'#4a4232');R(-20,-12+wobble*0.3,5,4,'#b08a68');
    // Cig pack in hand
    var packY=-16+wobble*0.5;
    R(-24,packY,8,5,'#f0f0e8');R(-24,packY,8,1.5,'#cc2222');
    // Right arm batting at it
    R(12,-24,8,14,'#4a4232');
    var batX=wobble>0?-10:-6;
    R(batX,-14,5,4,'#b08a68');
    // Sign
    cx.save();cx.rotate(-0.15);R(-28,-2,24,14,'#8a7a58');R(-27,-1,22,12,'#9a8a64');
    cx.font='5px monospace';cx.fillStyle='#3a2a1a';cx.textAlign='center';cx.fillText('NEED $$',-16,9);cx.restore();
    // Bottle
    R(20,-30,10,20,'#8a7040');R(21,-29,8,14,'#9a7a48');R(23,-36,4,8,'#2a5a2a');C(25,-37,2,'#2a5a2a');
  }else if(cs==='spill'){
    // Arms up in surprise, pack falling
    // Legs
    R(-14,-4,34,14,'#3a4a3a');R(-12,-2,30,10,'#445540');
    R(-14,8,10,5,'#2a2218');R(-3,8,10,5,'#2a2218');
    // Body — startled lean back
    R(-8,-36,22,32,'#4a4232');R(-6,-34,18,26,'#524a38');
    R(-8,-40,22,6,'#5a5240');
    // Head
    C(5,-46,8,'#b08a68');
    R(-2,-42,10,6,'#6a5a3a');R(-1,-40,8,5,'#7a6a44');
    // Eyes — wide shock
    C(2,-48,2.5,'#fff');C(7,-48,2.5,'#fff');C(2,-48,1.2,'#633');C(7,-48,1.2,'#633');
    R(3,-43,4,3,'#8a5a4a');R(4,-42,2,1.5,'#222'); // open mouth
    // Hat
    cx.fillStyle='#553322';cx.beginPath();cx.moveTo(-5,-54);cx.quadraticCurveTo(5,-60,15,-54);cx.lineTo(14,-48);cx.lineTo(-4,-48);cx.closePath();cx.fill();
    R(-4,-50,18,4,'#664433');
    // Arms up
    cx.save();cx.rotate(-0.3);R(-14,-26,8,18,'#4a4232');R(-18,-8,5,4,'#b08a68');cx.restore();
    cx.save();cx.rotate(0.2);R(12,-28,8,18,'#4a4232');R(18,-12,5,4,'#b08a68');cx.restore();
    // Falling pack (tumbling down)
    var fallP=(330-pk.cutsceneTimer)/120;
    var packFallY=-20+fallP*30;var packRot=fallP*2;
    if(fallP<1){cx.save();cx.rotate(packRot);R(-5,packFallY/SC,8,5,'#f0f0e8');R(-5,packFallY/SC,8,1.5,'#cc2222');cx.restore();}
    // Sign
    cx.save();cx.rotate(-0.15);R(-28,-2,24,14,'#8a7a58');R(-27,-1,22,12,'#9a8a64');
    cx.font='5px monospace';cx.fillStyle='#3a2a1a';cx.textAlign='center';cx.fillText('NEED $$',-16,9);cx.restore();
    // Bottle
    R(20,-30,10,20,'#8a7040');R(21,-29,8,14,'#9a7a48');R(23,-36,4,8,'#2a5a2a');C(25,-37,2,'#2a5a2a');
  }else{
    // pass_out — lerp back to sleeping pose
    var pp=Math.min(1,(210-pk.cutsceneTimer)/160); // 0→1 over 160 frames
    var upright=1-pp; // 1=upright, 0=sleeping
    // Legs (same as sleeping)
    R(-14,-4,34,14,'#3a4a3a');R(-12,-2,30,10,'#445540');
    R(-14,8,10,5,'#2a2218');R(-3,8,10,5,'#2a2218');
    // Body — lerp between upright and sleeping
    var bodyY=-36+upright*0;
    R(-8+upright*0,-10-upright*28,22+upright*4,18+upright*16,'#4a4232');
    R(-6+upright*0,-8-upright*26,18+upright*4,14+upright*12,'#524a38');
    R(-8,-38+pp*0,22,6,'#5a5240');
    // Arms settling
    R(-14,-18,8,16,'#4a4232');R(-16,-6,6,4,'#b08a68');
    R(12,-20,8,14,'#4a4232');R(18,-10,5,4,'#b08a68');
    // Head — tilting down
    var headY=-44+pp*0;
    cx.save();cx.rotate(pp*0);
    C(5,-44,8,'#b08a68');
    R(-2,-40,10,6,'#6a5a3a');R(-1,-38,8,5,'#7a6a44');
    // Eyes closing
    if(pp<0.5){
      C(2,-46,1.5,'#fff');C(7,-46,1.5,'#fff');C(2,-46,0.6,'#633');C(7,-46,0.6,'#633');
    }else{
      cx.strokeStyle='#5a4a2a';cx.lineWidth=0.8;cx.beginPath();cx.moveTo(1,-46);cx.lineTo(4,-45);cx.stroke();
      cx.beginPath();cx.moveTo(6,-45);cx.lineTo(9,-46);cx.stroke();
    }
    R(3,-41,3,1.5,'#8a5a4a'); // closed mouth
    cx.restore();
    // Hat
    cx.fillStyle='#553322';cx.beginPath();cx.moveTo(-5,-52);cx.quadraticCurveTo(5,-58,15,-52);cx.lineTo(14,-46);cx.lineTo(-4,-46);cx.closePath();cx.fill();
    R(-4,-48,18,4,'#664433');
    // Stubble
    cx.globalAlpha=0.2;for(var st=0;st<6;st++){C(-1+st*2,-43+Math.sin(st)*1,0.5,'#444');}cx.globalAlpha=1;
    // Sign
    cx.save();cx.rotate(-0.15);R(-28,-2,24,14,'#8a7a58');R(-27,-1,22,12,'#9a8a64');
    cx.font='5px monospace';cx.fillStyle='#3a2a1a';cx.textAlign='center';cx.fillText('NEED $$',-16,9);cx.restore();
    // Bottle
    R(20,-26,10,20,'#8a7040');R(21,-25,8,14,'#9a7a48');R(23,-32,4,8,'#2a5a2a');C(25,-33,2,'#2a5a2a');
    // Z's appearing
    if(pp>0.6){
      var za=Math.min(1,(pp-0.6)/0.4);
      var zt2=(t*0.8)%3;cx.globalAlpha=0.4*za;cx.font='8px monospace';cx.fillStyle='#aaa';cx.fillText('z',18+zt2*3,-52-zt2*6);
      cx.globalAlpha=0.25*za;cx.font='6px monospace';cx.fillText('z',22+zt2*2,-56-zt2*5);
      cx.globalAlpha=0.15*za;cx.font='5px monospace';cx.fillText('z',25+zt2*1.5,-59-zt2*3);cx.globalAlpha=1;
    }
  }
  cx.restore();

  // --- Cutscene: scattered cigs animating ---
  if(cs==='spill'||cs==='pass_out'){
    for(var ci2=0;ci2<pk.cigarettes.length;ci2++){
      var sp=pk.cigSpill[ci2];
      if(!sp.started&&cs!=='pass_out')continue;
      var p2=cs==='pass_out'?1:sp.progress;
      var cig2=pk.cigarettes[ci2];
      // Arc from pack center to final position
      var sx2=PACK_CX,sy2=PACK_CY;
      var ex2=cig2.cx,ey2=cig2.cy;
      var cx2=sx2+(ex2-sx2)*p2;
      var cy2=sy2+(ey2-sy2)*p2-Math.sin(p2*Math.PI)*40; // parabolic arc
      cx.save();cx.translate(cx2,cy2);
      var cigAngle2=(ci2%3===0)?0.15:(ci2%3===1)?-0.1:0.05;
      cx.rotate(cigAngle2+p2*Math.PI*2*(ci2%2===0?1:-1)); // tumble
      R(-6,-1.5,9,3,'#f5f0e0');R(3,-1.5,3,3,'#cc7733');
      cx.globalAlpha=0.15;R(-6,0,9,1.5,'#aa9a80');cx.globalAlpha=1;
      cx.restore();
    }
  }

  // --- Cutscene Tark ---
  cx.save();cx.translate(TARK_X,GY);cx.scale(SC,SC);
  drawTarkIdle(0,0,false);
  cx.restore();

  // --- Cutscene overlays ---
  if(cs==='fumble'){
    var bx3=TARK_X+60,by3=GY-70*SC;
    cx.fillStyle='rgba(255,255,255,0.9)';cx.strokeStyle='#333';cx.lineWidth=1.5;
    cx.beginPath();cx.moveTo(bx3-25,by3-12);cx.lineTo(bx3+25,by3-12);
    cx.quadraticCurveTo(bx3+30,by3-12,bx3+30,by3-6);cx.lineTo(bx3+30,by3+6);
    cx.quadraticCurveTo(bx3+30,by3+12,bx3+25,by3+12);cx.lineTo(bx3-25,by3+12);
    cx.quadraticCurveTo(bx3-30,by3+12,bx3-30,by3+6);cx.lineTo(bx3-30,by3-8);
    cx.quadraticCurveTo(bx3-30,by3-12,bx3-25,by3-12);cx.closePath();cx.fill();cx.stroke();
    C(bx3-20,by3+20,4,'rgba(255,255,255,0.9)');cx.strokeStyle='#333';cx.lineWidth=1;
    cx.beginPath();cx.arc(bx3-20,by3+20,4,0,Math.PI*2);cx.stroke();
    C(bx3-26,by3+28,2.5,'rgba(255,255,255,0.9)');
    cx.beginPath();cx.arc(bx3-26,by3+28,2.5,0,Math.PI*2);cx.stroke();
    cx.font='bold 11px monospace';cx.fillStyle='#222';cx.textAlign='center';
    cx.fillText('Huh?',bx3,by3+4);
  }else if(cs==='spill'){
    // Eyes light up — "!" over Tark
    var exPulse3=Math.sin(t*10)*0.2+0.8;
    cx.globalAlpha=exPulse3;cx.font='bold 20px monospace';cx.fillStyle='#ffcc00';cx.textAlign='center';
    cx.fillText('!',TARK_X,GY-80*SC);cx.globalAlpha=1;
  }else if(cs==='pass_out'){
    var bx4=TARK_X+70,by4=GY-70*SC;
    cx.fillStyle='rgba(255,255,255,0.95)';cx.strokeStyle='#333';cx.lineWidth=1.5;
    cx.beginPath();cx.moveTo(bx4-55,by4-12);cx.lineTo(bx4+55,by4-12);
    cx.quadraticCurveTo(bx4+60,by4-12,bx4+60,by4-6);cx.lineTo(bx4+60,by4+6);
    cx.quadraticCurveTo(bx4+60,by4+12,bx4+55,by4+12);cx.lineTo(bx4-55,by4+12);
    cx.quadraticCurveTo(bx4-60,by4+12,bx4-60,by4+6);cx.lineTo(bx4-60,by4-8);
    cx.quadraticCurveTo(bx4-60,by4-12,bx4-55,by4-12);cx.closePath();cx.fill();cx.stroke();
    C(bx4-45,by4+20,4,'rgba(255,255,255,0.95)');cx.strokeStyle='#333';cx.lineWidth=1;
    cx.beginPath();cx.arc(bx4-45,by4+20,4,0,Math.PI*2);cx.stroke();
    C(bx4-51,by4+28,2.5,'rgba(255,255,255,0.95)');
    cx.beginPath();cx.arc(bx4-51,by4+28,2.5,0,Math.PI*2);cx.stroke();
    cx.font='bold 11px monospace';cx.fillStyle='#222';cx.textAlign='center';
    cx.fillText('Well well well...',bx4,by4+4);
  }
  cx.textAlign='center';
  return; // Skip all normal rendering during cutscene
}

// === HOMELESS MAN ===
var hoboShiftX=0;
if(pk.phase==='caught'){var ct=(200-pk.catchTimer)/200;hoboShiftX=-ct*80;}
cx.save();cx.translate(HOBO_X+hoboShiftX,HOBO_BY);cx.scale(SC,SC);
var stirShift=0,headTilt=0,eyeOpen=0;
if(pk.stirActive){
  var sf=pk.stirFrame/Math.max(1,pk.stirDuration);
  if(pk.stirLevel<=1){stirShift=Math.sin(sf*Math.PI*2)*1.5;headTilt=Math.sin(sf*Math.PI)*0.06;}
  else if(pk.stirLevel===2){stirShift=Math.sin(sf*Math.PI*3)*2;headTilt=Math.sin(sf*Math.PI*2)*0.1;eyeOpen=(sf>0.35&&sf<0.5)?0.4:0;}
  else{stirShift=Math.sin(sf*Math.PI*2)*1.5;headTilt=Math.sin(sf*Math.PI)*0.08;eyeOpen=(pk.stirFrame>=10&&pk.stirFrame<=40)?1:0;}
}
if(pk.phase==='caught')eyeOpen=1;
cx.translate(stirShift,0);
R(-14,-4,34,14,'#3a4a3a');R(-12,-2,30,10,'#445540');
R(-14,8,10,5,'#2a2218');R(-3,8,10,5,'#2a2218');
R(-8,-10,10,18,'#3a3828');R(4,-10,10,18,'#3a3828');
R(-10,-36,26,30,'#4a4232');R(-8,-34,22,26,'#524a38');
R(-8,-38,22,6,'#5a5240');
R(-14,-18,8,16,'#4a4232');R(-16,-6,6,4,'#b08a68');
R(12,-20,8,14,'#4a4232');R(18,-10,5,4,'#b08a68');
R(20,-26,10,20,'#8a7040');R(21,-25,8,14,'#9a7a48');R(23,-32,4,8,'#2a5a2a');C(25,-33,2,'#2a5a2a');
R(-14,-26,8,10,'#4a4232');cx.strokeStyle='#3a3222';cx.lineWidth=0.4;cx.strokeRect(-14,-26,8,10);
cx.save();cx.rotate(headTilt);
C(5,-44,8,'#b08a68');
R(-2,-40,10,6,'#6a5a3a');R(-1,-38,8,5,'#7a6a44');
if(eyeOpen>0.5){
  C(2,-46,2,'#fff');C(7,-46,2,'#fff');C(2,-46,1.2,'#633');C(7,-46,1.2,'#633');C(2,-46,0.5,'#111');C(7,-46,0.5,'#111');
  cx.strokeStyle='#5a4a2a';cx.lineWidth=1;cx.beginPath();cx.moveTo(0,-49);cx.lineTo(4,-50);cx.stroke();cx.beginPath();cx.moveTo(6,-50);cx.lineTo(10,-49);cx.stroke();
}else if(eyeOpen>0.2){
  cx.strokeStyle='#633';cx.lineWidth=0.8;cx.beginPath();cx.moveTo(1,-46);cx.lineTo(4,-46);cx.stroke();cx.beginPath();cx.moveTo(6,-46);cx.lineTo(9,-46);cx.stroke();
}else{
  cx.strokeStyle='#5a4a2a';cx.lineWidth=0.8;cx.beginPath();cx.moveTo(1,-46);cx.lineTo(4,-45);cx.stroke();cx.beginPath();cx.moveTo(6,-45);cx.lineTo(9,-46);cx.stroke();
}
if(pk.phase==='caught'){C(5,-39,3,'#cc6677');C(5,-39,1.5,'#dd7788');}
else if(eyeOpen>0.5){R(3,-40,4,3,'#8a5a4a');R(4,-39,2,1.5,'#222');}
else{R(3,-41,3,1.5,'#8a5a4a');}
cx.restore();
cx.fillStyle='#553322';cx.beginPath();cx.moveTo(-5,-52);cx.quadraticCurveTo(5,-58,15,-52);cx.lineTo(14,-46);cx.lineTo(-4,-46);cx.closePath();cx.fill();
R(-4,-48,18,4,'#664433');
cx.globalAlpha=0.2;for(var st=0;st<6;st++){C(-1+st*2,-43+Math.sin(st)*1,0.5,'#444');}cx.globalAlpha=1;
cx.save();cx.rotate(-0.15);R(-28,-2,24,14,'#8a7a58');R(-27,-1,22,12,'#9a8a64');
cx.font='5px monospace';cx.fillStyle='#3a2a1a';cx.textAlign='center';cx.fillText('NEED $$',-16,9);cx.restore();
if(!pk.stirActive&&pk.phase!=='caught'&&pk.phase!=='escaped'){
  var zt=(t*0.8)%3;cx.globalAlpha=0.4;cx.font='8px monospace';cx.fillStyle='#aaa';cx.fillText('z',18+zt*3,-52-zt*6);
  cx.globalAlpha=0.25;cx.font='6px monospace';cx.fillText('z',22+zt*2,-56-zt*5);
  cx.globalAlpha=0.15;cx.font='5px monospace';cx.fillText('z',25+zt*1.5,-59-zt*3);cx.globalAlpha=1;
}
cx.restore();

// === CIGARETTES ===
for(var ci=0;ci<pk.cigarettes.length;ci++){
  var cig=pk.cigarettes[ci];
  if(cig.floatTimer>0){
    cig.floatTimer--;
    var fy=cig.cy-20-(30-cig.floatTimer);
    cx.globalAlpha=cig.floatTimer/30;
    cx.font='bold 12px monospace';cx.fillStyle='#ffcc00';cx.textAlign='center';
    cx.fillText('+1',cig.cx,fy);
    cx.globalAlpha=1;
  }
  if(cig.grabbed)continue;
  if(pk.phase==='picking'||pk.phase==='intro'){
    var glow=0.25+Math.sin(t*4+ci*1.2)*0.15;
    cx.globalAlpha=glow;C(cig.cx,cig.cy,10,'#ffcc00');cx.globalAlpha=1;
  }
  if(pk.targetIdx===ci){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(cig.cx-10,cig.cy-6,20,12);}
  cx.save();cx.translate(cig.cx,cig.cy);
  var cigAngle=(ci%3===0)?0.15:(ci%3===1)?-0.1:0.05;
  cx.rotate(cigAngle);
  R(-6,-1.5,9,3,'#f5f0e0');R(3,-1.5,3,3,'#cc7733');
  cx.globalAlpha=0.15;R(-6,0,9,1.5,'#aa9a80');cx.globalAlpha=1;
  cx.restore();
}
cx.textAlign='center';

// === TARK ===
var tarkDrawX=TARK_X;
if(pk.phase==='escaped'){var st2=(100-pk.catchTimer)/100;tarkDrawX=TARK_X-st2*(TARK_X+100);}
if(pk.phase==='caught'){var ct2=(200-pk.catchTimer)/200;tarkDrawX=TARK_X+ct2*40;}
cx.save();cx.translate(tarkDrawX,GY);cx.scale(SC,SC);
if(pk.reach>0.02)S._hideRightArm=true;
drawTarkIdle(0,0,false);
S._hideRightArm=false;
if(pk.reach>0.15&&pk.phase!=='escaped'){
  var nd=Math.min(4,Math.floor(pk.reach*5));
  for(var sd=0;sd<nd;sd++){var sdx=-10+sd*4;var sdy=-30+(t*20+sd*15)%10;cx.globalAlpha=0.3+pk.reach*0.3;C(sdx,sdy,1,'#66ccff');}cx.globalAlpha=1;
}
cx.restore();

// === EXTENDING ARM ===
var shoulderX=tarkDrawX+14*SC;var shoulderY=GY-6*SC;
var armReach=pk.reach;
if(pk.phase==='caught'){armReach=Math.max(0,pk.reach*(1-(200-pk.catchTimer)/40));}
if(pk.phase==='escaped'){armReach=Math.max(0,pk.reach*(1-(100-pk.catchTimer)/30));}
var tremAmt=armReach*2.5*SC;var tremY2=Math.sin(t*14)*tremAmt;var tremX2=Math.cos(t*10)*tremAmt*0.15;
var handX=shoulderX,handY=shoulderY;
if(pk.targetIdx!==null){
  handX=shoulderX+armReach*(targetX-shoulderX)+tremX2;
  handY=shoulderY+armReach*(targetY-shoulderY)+tremY2;
}
if(armReach>0.02){
  var elbowSag=Math.sin(Math.min(1,armReach*1.5)*Math.PI)*25*SC;
  var elbowX=shoulderX+(handX-shoulderX)*0.45;
  var elbowY=shoulderY+(handY-shoulderY)*0.45+elbowSag;
  cx.strokeStyle='#d4a574';cx.lineWidth=10*SC;cx.lineCap='round';
  cx.beginPath();cx.moveTo(shoulderX,shoulderY);cx.lineTo(elbowX,elbowY);cx.stroke();
  cx.lineWidth=9*SC;
  cx.beginPath();cx.moveTo(elbowX,elbowY);cx.lineTo(handX,handY);cx.stroke();
  C(handX,handY,5*SC,'#d4a574');
  var ha=pk.targetIdx!==null?Math.atan2(targetY-shoulderY,targetX-shoulderX):0;
  cx.save();cx.translate(handX,handY);cx.rotate(ha);
  R(3*SC,-3*SC,6*SC,2*SC,'#d4a574');R(3*SC,0,7*SC,2*SC,'#d4a574');R(3*SC,3*SC,6*SC,2*SC,'#d4a574');
  R(0,-5*SC,4*SC,2*SC,'#d4a574');
  cx.restore();cx.lineCap='butt';
}

// === CAUGHT: hobo kiss ===
if(pk.phase==='caught'){
  var ct3=(200-pk.catchTimer)/200;
  if(ct3>0.3){
    for(var hi=0;hi<3;hi++){var hx=TARK_X+80+Math.sin(t*3+hi*2)*20;var hy=GY-160-hi*25-(t*15+hi*10)%30;
      cx.globalAlpha=0.5-hi*0.15;cx.font='14px serif';cx.fillStyle='#ff6699';cx.textAlign='center';cx.fillText('\u2764',hx,hy);}
    cx.globalAlpha=1;cx.font='bold 18px monospace';cx.fillStyle='#ff6699';cx.textAlign='center';cx.fillText('*SMOOCH*',TARK_X+80,GY-180);
  }
  cx.textAlign='center';
}

// === MUMBLE ===
if(pk.mumbleTimer>0&&pk.phase!=='caught'&&pk.phase!=='escaped'){
  pk.mumbleTimer--;
  if(pk.mumbleText){var mx2=HOBO_X+50,my2=HOBO_BY-105;var mtxt=pk.mumbleText;cx.font='9px monospace';
    var tw2=mtxt.length*5.5+18;
    cx.fillStyle='#fff';cx.strokeStyle='#333';cx.lineWidth=1;
    cx.beginPath();cx.moveTo(mx2-tw2/2+4,my2-12);cx.lineTo(mx2+tw2/2-4,my2-12);cx.quadraticCurveTo(mx2+tw2/2,my2-12,mx2+tw2/2,my2-8);
    cx.lineTo(mx2+tw2/2,my2+8);cx.quadraticCurveTo(mx2+tw2/2,my2+12,mx2+tw2/2-4,my2+12);
    cx.lineTo(mx2-tw2/2+4,my2+12);cx.quadraticCurveTo(mx2-tw2/2,my2+12,mx2-tw2/2,my2+8);
    cx.lineTo(mx2-tw2/2,my2-8);cx.quadraticCurveTo(mx2-tw2/2,my2-12,mx2-tw2/2+4,my2-12);cx.closePath();cx.fill();cx.stroke();
    cx.fillStyle='#fff';cx.beginPath();cx.moveTo(mx2-10,my2+12);cx.lineTo(mx2-20,my2+22);cx.lineTo(mx2,my2+12);cx.fill();
    cx.fillStyle='#222';cx.textAlign='center';cx.fillText(mtxt,mx2,my2+4);cx.textAlign='center';}
}

// === GAME LOGIC ===
if(pk.phase==='reaching'&&pk.holding&&pk.targetIdx!==null){
  var spd=pk.cigarettes[pk.targetIdx].reachSpeed;
  pk.reach=Math.min(1,pk.reach+spd);pk.tremble=pk.reach*4;
  if(pk.reach>=1){
    pk.cigarettes[pk.targetIdx].grabbed=true;pk.cigarettes[pk.targetIdx].floatTimer=30;
    pk.grabbed++;pk.phase='retracting';pk.holding=false;
    pk.stirTimer=Math.max(20,Math.floor(pk.stirTimer*0.8));
    try{SFX.lighterFlick();}catch(e){}
  }
}
if(pk.phase==='retracting'){
  pk.reach=Math.max(0,pk.reach-0.015);pk.tremble=pk.reach*2;
  if(pk.reach<=0){pk.reach=0;pk.targetIdx=null;
    if(pk.grabbed>=pk.cigarettes.length){pk.phase='escaped';pk.catchTimer=100;}
    else{pk.phase='picking';}
  }
}
if(pk.phase!=='caught'&&pk.phase!=='escaped'&&pk.phase!=='intro'&&pk.phase!=='cutscene'){
  pk.stirTimer--;
  if(pk.stirTimer<=0&&!pk.stirActive){
    pk.stirActive=true;pk.stirFrame=0;pk.stirCount++;pk.stirLevel=Math.min(3,Math.floor(pk.stirCount/3));
    if(pk.stirLevel<=1)pk.stirDuration=50;else if(pk.stirLevel===2)pk.stirDuration=70;else pk.stirDuration=55;
    pk.mumbleText=HOBO_MUMBLES[Math.floor(Math.random()*HOBO_MUMBLES.length)];pk.mumbleTimer=pk.stirDuration;
    var base,range;if(pk.stirLevel===0){base=240;range=120;}else if(pk.stirLevel===1){base=180;range=100;}else if(pk.stirLevel===2){base=140;range=80;}else{base=90;range=50;}
    var grabPenalty=Math.pow(0.92,pk.grabbed);
    pk.stirTimer=Math.floor((base+Math.floor(Math.random()*range))*grabPenalty);
  }
  if(pk.stirActive){pk.stirFrame++;
    if(pk.stirLevel>=3&&pk.stirFrame>=10&&pk.stirFrame<=40&&pk.reach>0.15){pk.phase='caught';pk.catchTimer=200;}
    if(pk.stirFrame>=pk.stirDuration){pk.stirActive=false;}}
}
if(pk.phase==='caught'){pk.catchTimer--;cx.globalAlpha=0.1*Math.abs(Math.sin(t*8));R(0,0,W,H,'#ff0000');cx.globalAlpha=1;if(pk.catchTimer<=0)exitPickpocket('caught');}
if(pk.phase==='escaped'){pk.catchTimer--;cx.globalAlpha=0.06;R(0,0,W,H,'#ffcc00');cx.globalAlpha=1;
  cx.font='bold 18px monospace';cx.fillStyle='#ffcc00';cx.textAlign='center';cx.fillText('GOT AWAY!',450,80);
  cx.font='10px monospace';cx.fillStyle='#aaa';cx.fillText('+'+pk.grabbed+' Cigarette'+(pk.grabbed>1?'s':''),450,98);cx.textAlign='center';
  if(pk.catchTimer<=0)exitPickpocket('escaped');}

// === UI ===
if(pk.phase!=='caught'&&pk.phase!=='escaped'){
  cx.font='bold 12px monospace';cx.fillStyle='#ffcc00';cx.textAlign='left';
  cx.fillText(pk.grabbed+'/'+pk.cigarettes.length+' CIGS',20,25);
  var riskColors=['#44aa44','#88aa44','#aaaa44','#cc4444'];
  var riskLabels=['CALM','RESTLESS','STIRRING','DANGER'];
  var rl=Math.min(3,pk.stirLevel);
  cx.font='9px monospace';cx.fillStyle=riskColors[rl];
  cx.fillText('RISK: '+riskLabels[rl],20,42);
  cx.textAlign='center';
  if(pk.phase==='reaching'||pk.phase==='retracting'){
    R(350,440,200,14,'#333');R(352,442,196,10,'#222');
    var mc2=pk.reach<0.5?'#44aa44':pk.reach<0.8?'#aaaa44':'#cc4444';
    R(352,442,Math.round(196*pk.reach),10,mc2);
    cx.font='8px monospace';cx.fillStyle='#fff';cx.textAlign='center';
    cx.fillText('REACH: '+Math.round(pk.reach*100)+'%',450,450);
  }
}
if(pk.phase==='intro'){
  pk.introTimer--;
  var bx2=tarkDrawX+60,by2=GY-70*SC;
  cx.fillStyle='rgba(255,255,255,0.95)';cx.strokeStyle='#333';cx.lineWidth=1.5;
  cx.beginPath();cx.moveTo(bx2-55,by2-14);cx.lineTo(bx2+55,by2-14);cx.quadraticCurveTo(bx2+60,by2-14,bx2+60,by2-8);
  cx.lineTo(bx2+60,by2+8);cx.quadraticCurveTo(bx2+60,by2+14,bx2+55,by2+14);cx.lineTo(bx2-55,by2+14);
  cx.quadraticCurveTo(bx2-60,by2+14,bx2-60,by2+8);cx.lineTo(bx2-60,by2-8);cx.quadraticCurveTo(bx2-60,by2-14,bx2-55,by2-14);
  cx.closePath();cx.fill();cx.stroke();
  C(bx2-50,by2+20,4,'rgba(255,255,255,0.95)');cx.strokeStyle='#333';cx.lineWidth=1;cx.beginPath();cx.arc(bx2-50,by2+20,4,0,Math.PI*2);cx.stroke();
  C(bx2-58,by2+28,2.5,'rgba(255,255,255,0.95)');cx.beginPath();cx.arc(bx2-58,by2+28,2.5,0,Math.PI*2);cx.stroke();
  cx.font='bold 10px monospace';cx.fillStyle='#222';cx.textAlign='center';cx.fillText("Loose cigs everywhere...",bx2,by2-2);
  cx.font='9px monospace';cx.fillStyle='#555';cx.fillText("Click one to grab it.",bx2,by2+10);
  cx.textAlign='center';
  if(pk.introTimer<=0){pk.phase='picking';}
}
if(pk.phase==='picking'){
  var pulse=0.5+Math.sin(t*3)*0.3;cx.globalAlpha=pulse;
  cx.font='13px monospace';cx.fillStyle='#ffcc00';cx.textAlign='center';
  cx.fillText('CLICK A CIGARETTE',450,50);
  cx.font='9px monospace';cx.fillStyle='#888';cx.fillText('Then hold to reach for it',450,66);
  cx.globalAlpha=1;
  if(pk.grabbed>=1){
    var bHov=mouseX>=300&&mouseX<=600&&mouseY>=455&&mouseY<=475;
    R(300,455,300,20,bHov?'#ffdd44':'#ccaa00');
    cx.font='bold 11px monospace';cx.fillStyle='#222';cx.textAlign='center';
    cx.fillText('TAKE '+pk.grabbed+' AND GO',450,469);
  }
  cx.textAlign='center';
}
if(pk.phase==='reaching'||pk.phase==='retracting'){
  cx.font='9px monospace';cx.fillStyle='#ff8888';cx.textAlign='center';
  cx.fillText('Release if he stirs!',450,50);cx.textAlign='center';
}
}


// === DOG CHASE SCENE ===
function drawDogChaseScene(){
var dc=S.dogChase;if(!dc)return;
var t=Date.now()*0.001;
var SC=2;
var GY=375;

// ================================================================
// GAME LOGIC
// ================================================================
if(dc.phase==='theft'){
  dc.theftTimer--;
  if(dc.theftTimer>110){dc.theftStep='approach';dc.dogX-=2.6;dc.dogStepT+=0.2;}
  else if(dc.theftTimer>70){dc.theftStep='sniff';dc.dogPauseFrame++;}
  else if(dc.theftTimer>50){dc.theftStep='grab';}
  else{dc.theftStep='bolt';dc.dogX+=5.0;dc.dogStepT+=0.4;}
  if(dc.theftTimer<=0){dc.phase='intro';dc.introTimer=180;}
}

if(dc.phase==='intro'){
  dc.introTimer--;
  if(dc.introTimer<=0){dc.phase='chasing';}
}

if(dc.phase==='chasing'){
  dc.frameCount++;
  // Tark movement
  if(dc.sprinting&&dc.stamina>0){
    dc.tarkSpeed=6.3;
    dc.stamina=Math.max(0,dc.stamina-1.2);
    dc.tarkStepT+=0.35;
    if(dc.frameCount%3===0)dc.speedLines.push({x:dc.tarkX-30-Math.random()*20,y:GY-40-Math.random()*60,len:15+Math.random()*20,life:1.0});
    if(dc.frameCount%8===0)dc.sweatDrops.push({x:dc.tarkX+Math.random()*20-10,y:GY-70-Math.random()*10,vy:0.5+Math.random(),life:1.0});
  }else if(dc.stamina>0){
    dc.tarkSpeed=2.625;
    dc.stamina=Math.min(dc.maxStamina,dc.stamina+0.35);
    dc.tarkStepT+=0.18;
  }else{
    dc.phase='exhausted';dc.endTimer=180;dc.tarkSpeed=0;
  }
  dc.tarkX+=dc.tarkSpeed;

  // Dog movement — bolt phase (erratic but fast), then main behavior sequence
  if(!dc.boltDone){
    var bb=dc.boltBehaviors[dc.boltIdx];
    if(bb){
      dc.dogSpeed=bb.speed;
      dc.dogPauseType=bb.pauseType;
      if(bb.type!=='pause')dc.dogStepT+=0.4;
      if(bb.pauseType)dc.dogPauseFrame++;
      dc.boltTimer--;
      if(dc.boltTimer<=0){
        dc.boltIdx++;dc.dogPauseFrame=0;
        if(dc.boltIdx<dc.boltBehaviors.length)dc.boltTimer=dc.boltBehaviors[dc.boltIdx].duration;
        else dc.boltDone=true;
      }
    }else{dc.boltDone=true;}
  }else{
    var beh=dc.behaviors[dc.behaviorIdx];
    if(beh){
      dc.dogSpeed=beh.speed;
      dc.dogPauseType=beh.pauseType;
      if(beh.type!=='pause')dc.dogStepT+=beh.type==='burst'?0.4:0.25;
      dc.dogPauseFrame++;
      dc.behaviorTimer--;
      if(dc.behaviorTimer<=0){
        dc.behaviorIdx++;dc.dogPauseFrame=0;
        if(dc.behaviorIdx<dc.behaviors.length)dc.behaviorTimer=dc.behaviors[dc.behaviorIdx].duration;
        else{dc.dogSpeed=3.5;dc.dogPauseType=null;}
      }
    }else{dc.dogSpeed=3.5;dc.dogPauseType=null;dc.dogStepT+=0.25;}
  }
  dc.dogX+=dc.dogSpeed;

  // Catch check
  if(dc.tarkX>=dc.dogX-20){dc.phase='caught';dc.endTimer=180;dc.dogSpeed=0;dc.tarkSpeed=0;}
}

// End timers
if(dc.phase==='caught'||dc.phase==='exhausted'){
  dc.endTimer--;
  if(dc.endTimer<=0){window.exitDogChase(dc.phase==='caught'?'caught':'exhausted');return;}
}

// Update effects
for(var si2=dc.sweatDrops.length-1;si2>=0;si2--){var sd=dc.sweatDrops[si2];sd.y+=sd.vy;sd.life-=0.02;if(sd.life<=0)dc.sweatDrops.splice(si2,1);}
for(var li2=dc.speedLines.length-1;li2>=0;li2--){var sl=dc.speedLines[li2];sl.life-=0.06;if(sl.life<=0)dc.speedLines.splice(li2,1);}

// Camera
dc.cameraX=dc.tarkX-200;if(dc.cameraX<0)dc.cameraX=0;
var camX=dc.cameraX;

// ================================================================
// RENDERING
// ================================================================

// === FAR PARALLAX (0.1x) — sky + distant buildings ===
var farOff=camX*0.1;
var skyG=cx.createLinearGradient(0,0,0,120);
skyG.addColorStop(0,'#1a1a2e');skyG.addColorStop(0.5,'#2a2a3e');skyG.addColorStop(1,'#4a3a4a');
R(0,0,W,120,skyG);
for(var dbi=0;dbi<15;dbi++){
  var dbx=-farOff%400+dbi*120-60;
  if(dbx>-80&&dbx<W+80){
    var dbh=50+((dbi*37)%50);
    R(dbx,120-dbh,50+((dbi*23)%40),dbh,'#12121a');
    cx.globalAlpha=0.2;
    for(var dwi=0;dwi<3;dwi++){for(var dwj=0;dwj<2;dwj++){
      if((dbi+dwi+dwj)%3===0)R(dbx+8+dwi*14,120-dbh+8+dwj*16,3,3,'#ffcc66');
    }}
    cx.globalAlpha=1;
  }
}

// === MID PARALLAX (0.5x) — brick wall ===
var midOff=camX*0.5;
var wallG=cx.createLinearGradient(0,100,0,GY);
wallG.addColorStop(0,'#5a4a3a');wallG.addColorStop(1,'#4a3a2a');
R(0,100,W,GY-100,wallG);
cx.globalAlpha=0.08;
for(var bry=102;bry<GY;bry+=12){
  var brOff2=(Math.floor(bry/12)%2)*20;
  for(var brx=-midOff%40+brOff2-40;brx<W+40;brx+=40){
    cx.strokeStyle='#2a1a0a';cx.lineWidth=0.5;cx.strokeRect(brx,bry,38,10);
  }
}
cx.globalAlpha=1;
cx.globalAlpha=0.06;
for(var gsi=0;gsi<8;gsi++){var gsx=-midOff%800+gsi*350;if(gsx>-60&&gsx<W+60)R(gsx,120,40+gsi*10,GY-140,'#1a1a0a');}
cx.globalAlpha=1;

// Mid props (doors, graffiti, windows, pipes, AC units)
for(var mpi=0;mpi<dc.midProps.length;mpi++){
  var mp=dc.midProps[mpi];var mpx=mp.x-midOff;
  if(mpx<-100||mpx>W+100)continue;
  if(mp.type==='door'){
    R(mpx,GY-80,40,80,mp.color);R(mpx+2,GY-78,36,76,'#4a3a2e');C(mpx+34,GY-40,3,'#aa8844');
  }else if(mp.type==='graffiti'){
    cx.save();cx.font='bold '+(8+mp.text.length%4)+'px monospace';
    cx.fillStyle=mp.color;cx.textAlign='left';cx.fillText(mp.text,mpx,GY-30-Math.sin(mpi)*20);
    cx.restore();cx.textAlign='center';
  }else if(mp.type==='window'){
    R(mpx,GY-160,45,50,'#1a2230');R(mpx+2,GY-158,41,46,'#222e38');
    R(mpx,GY-160,45,3,'#555');R(mpx,GY-113,45,3,'#555');R(mpx,GY-160,3,50,'#555');R(mpx+42,GY-160,3,50,'#555');
    R(mpx+20,GY-160,4,50,'#555');R(mpx,GY-136,45,3,'#555');
    if(mp.lit){cx.globalAlpha=0.12;R(mpx+4,GY-156,16,20,'#ffcc66');cx.globalAlpha=1;}
  }else if(mp.type==='pipe'){
    R(mpx,GY-mp.h,4,mp.h,'#666');R(mpx-3,GY-mp.h,10,3,'#777');
    if(Math.sin(t*2+mpi)>0.8){C(mpx+2,GY-mp.h+mp.h*0.7+Math.sin(t*3)*5,2,'rgba(100,150,200,0.3)');}
  }else if(mp.type==='ac_unit'){
    R(mpx,GY-130,35,25,'#888');R(mpx+2,GY-128,31,21,'#666');
    for(var aci=0;aci<4;aci++)R(mpx+5+aci*7,GY-126,4,1,'#444');
  }
}

// === GROUND (1.0x) ===
R(0,GY,W,H-GY,'#484848');R(0,GY,W,3,'#666');
cx.strokeStyle='#3a3a3a';cx.lineWidth=0.5;
for(var ci2=0;ci2<20;ci2++){var crx=ci2*120-camX%120;if(crx>-20&&crx<W+20){cx.beginPath();cx.moveTo(crx,GY+3);cx.lineTo(crx+15+ci2%3*5,H);cx.stroke();}}

// === NEAR PROPS (1.0x) ===
for(var npi=0;npi<dc.nearProps.length;npi++){
  var np=dc.nearProps[npi];var npx=np.x-camX;
  if(npx<-80||npx>W+80)continue;
  if(np.type==='dumpster'){
    R(npx,GY-np.h,np.w,np.h,'#2a5a2a');R(npx+2,GY-np.h+2,np.w-4,np.h-4,'#3a6a3a');
    R(npx,GY-np.h-4,np.w,4,'#4a7a4a');
  }else if(np.type==='trashcan'){
    R(npx,GY-np.h,np.w,np.h,'#666');R(npx-2,GY-np.h,np.w+4,3,'#777');
  }else if(np.type==='puddle'){
    cx.globalAlpha=0.25;cx.fillStyle='#4466aa';cx.beginPath();cx.ellipse(npx+np.w/2,GY+8,np.w/2,4,0,0,Math.PI*2);cx.fill();
    cx.globalAlpha=0.1;cx.fillStyle='#aaccff';cx.beginPath();cx.ellipse(npx+np.w/2+Math.sin(t*2)*3,GY+7,np.w*0.3,2,0,0,Math.PI*2);cx.fill();
    cx.globalAlpha=1;
  }else if(np.type==='hydrant'){
    R(npx,GY-np.h,np.w,np.h,'#aa2222');R(npx-2,GY-np.h-4,np.w+4,5,'#cc3333');C(npx+np.w/2,GY-np.h/2,4,'#cc3333');
  }else if(np.type==='crate'){
    R(npx,GY-np.h,np.w,np.h,'#8a7040');R(npx+2,GY-np.h+2,np.w-4,np.h-4,'#9a7a48');
  }else if(np.type==='trashbag'){
    cx.fillStyle='#1a1a1a';cx.beginPath();cx.ellipse(npx+np.w/2,GY-np.h/2,np.w/2,np.h/2,0,0,Math.PI*2);cx.fill();
    R(npx+np.w/2-2,GY-np.h-3,4,5,'#222');
  }
}

// === DOG ===
var dogScreenX=dc.dogX-camX;
var dogScreenY=GY;
cx.save();cx.translate(dogScreenX,dogScreenY);cx.scale(SC,SC);
var dogRunning=dc.dogSpeed>0;
var dogStep=dogRunning?Math.sin(dc.dogStepT)*8:0;
var dogBob=dogRunning?Math.abs(Math.sin(dc.dogStepT))*2:0;
var dogBurst=dc.behaviors[dc.behaviorIdx]&&dc.behaviors[dc.behaviorIdx].type==='burst';
var isCaught=dc.phase==='caught';

if(dc.phase==='theft'){
  var ts=dc.theftStep;
  if(ts==='approach'){
    // Walking left toward Tark
    var fls2=Math.sin(dc.dogStepT)*6;var bls2=-fls2;var db2=Math.abs(fls2)*0.15;
    R(-12,-8+db2,24,10,'#8a7a5a');
    R(-22,-14+db2,10,10,'#8a7a5a');R(-26,-12+db2,8,5,'#7a6a4a');R(-32,-10+db2,6,4,'#6a5a3a');
    C(-28,-15+db2,1,'#111');
    cx.fillStyle='#6a5a3a';
    cx.beginPath();cx.moveTo(-20,-14+db2);cx.lineTo(-18,-22+db2);cx.lineTo(-16,-14+db2);cx.fill();
    cx.beginPath();cx.moveTo(-24,-14+db2);cx.lineTo(-23,-22+db2);cx.lineTo(-21,-14+db2);cx.fill();
    R(-8,2+fls2*0.6,4,8,'#7a6a4a');R(0,2-fls2*0.6,4,8,'#7a6a4a');
    R(6,2+bls2*0.6,4,8,'#7a6a4a');R(10,2-bls2*0.6,4,8,'#7a6a4a');
    cx.strokeStyle='#8a7a5a';cx.lineWidth=2;
    cx.beginPath();cx.moveTo(12,-6+db2);cx.quadraticCurveTo(20+Math.sin(t*3)*3,-14+db2,18,-20+db2);cx.stroke();
  }else if(ts==='sniff'){
    // Facing left, head lowered to Tark's pocket
    R(-12,-6,24,10,'#8a7a5a');
    R(-22,-2,10,8,'#8a7a5a');R(-26,0,8,5,'#7a6a4a');R(-32,2,6,4,'#6a5a3a');
    C(-28,-2,1,'#111');
    var snPh2=dc.dogPauseFrame*0.15;
    cx.globalAlpha=0.4;cx.font='5px monospace';cx.fillStyle='#aaa';cx.textAlign='center';
    cx.fillText('*snf*',-36,4+Math.sin(snPh2)*2);cx.globalAlpha=1;
    cx.fillStyle='#6a5a3a';
    cx.beginPath();cx.moveTo(-20,-2);cx.lineTo(-18,-8);cx.lineTo(-16,-2);cx.fill();
    cx.beginPath();cx.moveTo(-24,-2);cx.lineTo(-23,-8);cx.lineTo(-21,-2);cx.fill();
    R(-8,4,4,8,'#7a6a4a');R(0,4,4,8,'#7a6a4a');R(8,4,4,8,'#7a6a4a');
    cx.strokeStyle='#8a7a5a';cx.lineWidth=2;
    cx.beginPath();cx.moveTo(12,-4);cx.quadraticCurveTo(20+Math.sin(t*5)*5,-10,18+Math.sin(t*5)*3,-16);cx.stroke();
  }else if(ts==='grab'){
    // Lunge + cig pack appearing in mouth
    var gp=(160-50-dc.theftTimer)/20;if(gp<0)gp=0;if(gp>1)gp=1;
    R(-12,-6,24,10,'#8a7a5a');
    R(-22,-8-gp*4,10,10,'#8a7a5a');R(-26,-6-gp*4,8,5,'#7a6a4a');R(-32,-4-gp*4,6,4,'#6a5a3a');
    C(-28,-9-gp*4,1,'#111');
    if(gp>0.3){R(-36,-4-gp*4,8,5,'#f0f0e8');R(-36,-4-gp*4,8,1.5,'#cc2222');}
    cx.fillStyle='#6a5a3a';
    cx.beginPath();cx.moveTo(-20,-8-gp*4);cx.lineTo(-18,-14-gp*4);cx.lineTo(-16,-8-gp*4);cx.fill();
    cx.beginPath();cx.moveTo(-24,-8-gp*4);cx.lineTo(-23,-14-gp*4);cx.lineTo(-21,-8-gp*4);cx.fill();
    R(-8,4,4,8,'#7a6a4a');R(0,4,4,8,'#7a6a4a');R(8,4,4,8,'#7a6a4a');
    cx.strokeStyle='#8a7a5a';cx.lineWidth=2;
    cx.beginPath();cx.moveTo(12,-4);cx.quadraticCurveTo(18,-12,16,-18);cx.stroke();
  }else{
    // Bolt right with cig pack
    var fls3=Math.sin(dc.dogStepT)*8;var bls3=-fls3;var db3=Math.abs(fls3)*0.3;
    R(-12,-8+db3,24,10,'#8a7a5a');
    R(12,-14+db3,10,10,'#8a7a5a');R(16,-12+db3,8,5,'#7a6a4a');R(22,-10+db3,6,4,'#6a5a3a');
    var tf2=Math.sin(dc.dogStepT*2)*2;
    R(26,-8+db3+tf2,3+Math.abs(tf2),3,'#ff6677');
    C(18,-15+db3,1,'#111');
    R(27,-13+db3,7,4,'#f0f0e8');R(27,-13+db3,7,1.5,'#cc2222');
    var ef2=db3*1.5;
    cx.fillStyle='#6a5a3a';
    cx.beginPath();cx.moveTo(14,-14+db3);cx.lineTo(12,-22+db3+ef2);cx.lineTo(16,-14+db3);cx.fill();
    cx.beginPath();cx.moveTo(18,-14+db3);cx.lineTo(17,-22+db3+ef2);cx.lineTo(21,-14+db3);cx.fill();
    R(-8,2+fls3*0.8,4,8-Math.abs(fls3)*0.2,'#7a6a4a');R(0,2-fls3*0.8,4,8-Math.abs(fls3)*0.2,'#7a6a4a');
    R(6,2+bls3*0.8,4,8-Math.abs(bls3)*0.2,'#7a6a4a');R(10,2-bls3*0.8,4,8-Math.abs(bls3)*0.2,'#7a6a4a');
    cx.strokeStyle='#8a7a5a';cx.lineWidth=2;
    cx.beginPath();cx.moveTo(-12,-6+db3);cx.quadraticCurveTo(-20+Math.sin(t*6)*5,-20+db3,-18+Math.sin(t*5)*4,-26+db3);cx.stroke();
    if(dc.theftTimer%4===0){cx.globalAlpha=0.15;C(-14+Math.random()*6,8,3+Math.random()*3,'#aaa');cx.globalAlpha=1;}
  }

}else if(dc.dogPauseType==='sniffing'&&!isCaught){
  R(-12,-6,24,10,'#8a7a5a');
  R(12,-2,10,8,'#8a7a5a');R(14,0,8,5,'#7a6a4a');R(20,2,6,4,'#6a5a3a');
  var snPh=dc.dogPauseFrame*0.15;
  cx.globalAlpha=0.4;cx.font='6px monospace';cx.fillStyle='#aaa';cx.textAlign='center';
  cx.fillText('*snf*',24,-4+Math.sin(snPh)*3);cx.globalAlpha=1;
  R(-10,4,4,8,'#7a6a4a');R(0,4,4,8,'#7a6a4a');R(8,4,4,8,'#7a6a4a');
  cx.strokeStyle='#8a7a5a';cx.lineWidth=2;cx.beginPath();cx.moveTo(-12,-4);cx.quadraticCurveTo(-18,-10+Math.sin(t*4)*3,-16,-16);cx.stroke();
  C(16,-4,1,'#111');
  cx.fillStyle='#6a5a3a';cx.beginPath();cx.moveTo(14,-6);cx.lineTo(12,-12);cx.lineTo(16,-6);cx.fill();
  cx.beginPath();cx.moveTo(18,-6);cx.lineTo(17,-12);cx.lineTo(21,-6);cx.fill();
  R(24,-1,7,4,'#f0f0e8');R(24,-1,7,1.5,'#cc2222');

}else if(dc.dogPauseType==='peeing'&&!isCaught){
  R(-8,-8,20,10,'#8a7a5a');
  R(-14,-14,10,10,'#8a7a5a');R(-18,-12,6,4,'#6a5a3a');C(-16,-16,1,'#111');
  R(-6,2,4,8,'#7a6a4a');R(2,2,4,8,'#7a6a4a');R(10,2,4,8,'#7a6a4a');
  cx.save();cx.translate(-8,0);cx.rotate(-0.8);R(0,-2,4,8,'#7a6a4a');cx.restore();
  if(dc.dogPauseFrame%4<3){cx.globalAlpha=0.3;cx.strokeStyle='#aaaa44';cx.lineWidth=1;cx.beginPath();cx.moveTo(-10,2);cx.lineTo(-14,6);cx.stroke();cx.globalAlpha=1;}
  cx.strokeStyle='#8a7a5a';cx.lineWidth=2;cx.beginPath();cx.moveTo(12,-6);cx.quadraticCurveTo(18,-18,14,-22);cx.stroke();
  cx.fillStyle='#6a5a3a';cx.beginPath();cx.moveTo(-12,-14);cx.lineTo(-10,-20);cx.lineTo(-8,-14);cx.fill();
  R(-24,-14,7,4,'#f0f0e8');R(-24,-14,7,1.5,'#cc2222');

}else if(dc.dogPauseType==='looking_back'&&!isCaught){
  R(-12,-8,24,10,'#8a7a5a');
  R(-18,-14,10,10,'#8a7a5a');R(-22,-12,6,4,'#7a6a4a');R(-26,-10,4,3,'#6a5a3a');
  C(-20,-14,1.2,'#111');
  cx.fillStyle='#6a5a3a';cx.beginPath();cx.moveTo(-16,-14);cx.lineTo(-18,-22);cx.lineTo(-14,-14);cx.fill();
  cx.beginPath();cx.moveTo(-12,-14);cx.lineTo(-13,-22);cx.lineTo(-9,-14);cx.fill();
  R(-10,2,4,8,'#7a6a4a');R(0,2,4,8,'#7a6a4a');R(8,2,4,8,'#7a6a4a');
  cx.strokeStyle='#8a7a5a';cx.lineWidth=2;cx.beginPath();cx.moveTo(12,-6);cx.quadraticCurveTo(18+Math.sin(t*2)*4,-14,16+Math.sin(t*2)*3,-20);cx.stroke();
  cx.fillStyle='rgba(255,255,255,0.8)';C(-30,-24,6,'rgba(255,255,255,0.8)');
  cx.strokeStyle='#333';cx.lineWidth=0.5;cx.beginPath();cx.arc(-30,-24,6,0,Math.PI*2);cx.stroke();
  cx.font='bold 7px monospace';cx.fillStyle='#333';cx.textAlign='center';cx.fillText('?',-30,-22);
  R(-30,-12,7,4,'#f0f0e8');R(-30,-12,7,1.5,'#cc2222');

}else if(dc.dogPauseType==='scratching'&&!isCaught){
  R(-10,-4,20,10,'#8a7a5a');
  R(-16,-14,10,10,'#8a7a5a');R(-20,-12,6,4,'#6a5a3a');C(-18,-16,1,'#111');
  R(-8,6,4,6,'#7a6a4a');R(0,6,4,6,'#7a6a4a');
  var scrAngle=Math.sin(dc.dogPauseFrame*0.3)*0.4;
  cx.save();cx.translate(8,-2);cx.rotate(-1.2+scrAngle);R(0,0,4,10,'#7a6a4a');cx.restore();
  cx.fillStyle='#6a5a3a';cx.beginPath();cx.moveTo(-14,-14);cx.lineTo(-12,-20+Math.sin(dc.dogPauseFrame*0.3)*2);cx.lineTo(-10,-14);cx.fill();
  cx.strokeStyle='#8a7a5a';cx.lineWidth=2;cx.beginPath();cx.moveTo(10,-2);cx.quadraticCurveTo(16,-8,14,-14);cx.stroke();
  R(-26,-14,7,4,'#f0f0e8');R(-26,-14,7,1.5,'#cc2222');

}else if(isCaught){
  // Happy sitting dog facing left (toward Tark)
  R(-10,-4,20,10,'#8a7a5a');
  R(-18,-14,10,10,'#8a7a5a');R(-22,-10,6,4,'#7a6a4a');
  cx.strokeStyle='#111';cx.lineWidth=0.8;cx.beginPath();cx.arc(-16,-14,1.5,0.3,Math.PI-0.3);cx.stroke();
  R(-24,-8,3,5,'#ff6677');C(-22.5,-3,2,'#ff6677');
  cx.fillStyle='#6a5a3a';cx.beginPath();cx.moveTo(-16,-14);cx.lineTo(-18,-20);cx.lineTo(-14,-14);cx.fill();
  cx.beginPath();cx.moveTo(-12,-14);cx.lineTo(-13,-20);cx.lineTo(-9,-14);cx.fill();
  R(-6,6,4,6,'#7a6a4a');R(2,6,4,6,'#7a6a4a');
  cx.strokeStyle='#8a7a5a';cx.lineWidth=2;cx.beginPath();cx.moveTo(10,-2);cx.quadraticCurveTo(18+Math.sin(t*8)*6,-14,14+Math.sin(t*8)*4,-20);cx.stroke();
  // Cig pack on ground (dog dropped it)
  R(18,10,7,4,'#f0f0e8');R(18,10,7,1.5,'#cc2222');

}else{
  // Running dog (facing right, away from Tark)
  var fls=dogStep;var bls=-dogStep;
  R(-12,-8+dogBob,24,10,'#8a7a5a');
  R(12,-14+dogBob,10,10,'#8a7a5a');R(16,-12+dogBob,8,5,'#7a6a4a');R(22,-10+dogBob,6,4,'#6a5a3a');
  if(dogBurst||dc.frameCount>120){
    var tongueFlap=Math.sin(dc.dogStepT*2)*2;
    R(26,-8+dogBob+tongueFlap,3+Math.abs(tongueFlap),3,'#ff6677');
  }
  C(18,-15+dogBob,1,'#111');
  var earFlop=dogBob*1.5;
  cx.fillStyle='#6a5a3a';
  cx.beginPath();cx.moveTo(14,-14+dogBob);cx.lineTo(12,-22+dogBob+earFlop);cx.lineTo(16,-14+dogBob);cx.fill();
  cx.beginPath();cx.moveTo(18,-14+dogBob);cx.lineTo(17,-22+dogBob+earFlop);cx.lineTo(21,-14+dogBob);cx.fill();
  R(-8,2+fls*0.8,4,8-Math.abs(fls)*0.2,'#7a6a4a');R(0,2-fls*0.8,4,8-Math.abs(fls)*0.2,'#7a6a4a');
  R(6,2+bls*0.8,4,8-Math.abs(bls)*0.2,'#7a6a4a');R(10,2-bls*0.8,4,8-Math.abs(bls)*0.2,'#7a6a4a');
  var tailUp=dogBurst?-20:-14;
  cx.strokeStyle='#8a7a5a';cx.lineWidth=2;
  cx.beginPath();cx.moveTo(-12,-6+dogBob);cx.quadraticCurveTo(-20+Math.sin(t*4)*4,tailUp+dogBob,-18+Math.sin(t*3)*3,tailUp-6+dogBob);cx.stroke();
  R(27,-13+dogBob,7,4,'#f0f0e8');R(27,-13+dogBob,7,1.5,'#cc2222');
  if(dogRunning&&dc.frameCount%6===0){cx.globalAlpha=0.15;C(-14+Math.random()*6,8,3+Math.random()*3,'#aaa');cx.globalAlpha=1;}
}
cx.restore();

// === TARK ===
var tarkScreenX=dc.tarkX-camX;
cx.save();cx.translate(tarkScreenX,GY);cx.scale(SC,SC);

if(dc.phase==='theft'){
  // Standing Tark during theft cutscene
  var ts2=dc.theftStep;
  var _sc6=typeof getTarkShirtColor==='function'?getTarkShirtColor():'#f0e6d3';
  var _hc5=typeof getTarkHeadbandColor==='function'?getTarkHeadbandColor():null;
  R(-10,30,10,36,'#2a2a2a');R(2,30,10,36,'#2a2a2a');
  R(-12,64,14,6,'#cc3333');R(0,64,14,6,'#cc3333');
  R(-14,-10,28,42,_sc6);
  C(0,-22,16,'#d4a574');
  if(_hc5)R(-16,-30,32,4,_hc5);
  if(ts2==='approach'){
    // Welcoming — hand slightly out
    R(-20,-4,8,22,'#d4a574');
    cx.save();cx.translate(14,0);cx.rotate(-0.25);R(0,-4,8,18,'#d4a574');C(4,16,4,'#d4a574');cx.restore();
    C(-5,-24,2,'#111');C(5,-24,2,'#111');
    cx.strokeStyle='#111';cx.lineWidth=1;cx.beginPath();cx.arc(0,-16,3,0.2,Math.PI-0.2);cx.stroke();
  }else if(ts2==='sniff'){
    // Looking down at dog — slight bend
    R(-20,-4,8,22,'#d4a574');R(12,-4,8,22,'#d4a574');
    C(-5,-24,2,'#111');C(5,-24,2,'#111');
    cx.strokeStyle='#111';cx.lineWidth=1;cx.beginPath();cx.arc(0,-16,3,0.2,Math.PI-0.2);cx.stroke();
  }else if(ts2==='grab'){
    // Shocked — wide eyes, open mouth
    R(-20,-4,8,22,'#d4a574');R(12,-4,8,22,'#d4a574');
    C(-5,-24,3,'#fff');C(5,-24,3,'#fff');C(-5,-24,1.5,'#111');C(5,-24,1.5,'#111');
    R(-3,-17,6,5,'#111');
  }else{
    // Angry — reaching out, furrowed brow
    R(-20,-4,8,22,'#d4a574');
    cx.save();cx.translate(14,0);cx.rotate(-0.4);R(0,-6,8,22,'#d4a574');C(4,18,4,'#d4a574');cx.restore();
    C(-5,-24,2,'#111');C(5,-24,2,'#111');
    cx.strokeStyle='#111';cx.lineWidth=1.5;
    cx.beginPath();cx.moveTo(-7,-27);cx.lineTo(-3,-29);cx.stroke();
    cx.beginPath();cx.moveTo(7,-27);cx.lineTo(3,-29);cx.stroke();
    cx.strokeStyle='#111';cx.lineWidth=1;cx.beginPath();cx.moveTo(-3,-16);cx.lineTo(3,-16);cx.stroke();
  }

}else if(dc.phase==='exhausted'){
  var pantBob=Math.sin(t*6)*2;
  R(-10,10,10,22,'#2a2a2a');R(2,10,10,22,'#2a2a2a');
  R(-12,30,14,6,'#cc3333');R(0,30,14,6,'#cc3333');
  cx.save();cx.rotate(0.4);
  var _sc2=typeof getTarkShirtColor==='function'?getTarkShirtColor():'#f0e6d3';
  R(-12,-12+pantBob,24,30,_sc2);cx.restore();
  C(16,-6+pantBob,10,'#d4a574');
  cx.strokeStyle='#111';cx.lineWidth=1;cx.beginPath();cx.arc(20,-2+pantBob,3,0.3,Math.PI-0.3);cx.stroke();
  C(12,-18+pantBob+(t*10)%8,1.5,'#66aaff');C(22,-14+pantBob+(t*8+4)%10,1.5,'#66aaff');
  R(-14,2+pantBob,8,16,'#d4a574');R(10,2+pantBob,8,16,'#d4a574');
  cx.font='8px serif';cx.fillStyle='#ffcc00';cx.textAlign='center';
  var starR=t*3;
  cx.fillText('*',10+Math.cos(starR)*12,-20+Math.sin(starR)*8+pantBob);
  cx.fillText('*',10+Math.cos(starR+2)*12,-20+Math.sin(starR+2)*8+pantBob);
  cx.fillText('*',10+Math.cos(starR+4)*12,-20+Math.sin(starR+4)*8+pantBob);

}else if(dc.phase==='caught'){
  var petBob=Math.sin(t*3)*1;
  R(-10,4,10,16,'#2a2a2a');R(2,12,10,12,'#2a2a2a');
  R(-12,18,14,6,'#cc3333');R(0,22,14,6,'#cc3333');
  var _sc3=typeof getTarkShirtColor==='function'?getTarkShirtColor():'#f0e6d3';
  R(-14,-14+petBob,28,28,_sc3);
  R(-20,-8+petBob,8,22,'#d4a574');
  R(10,-6+petBob,8,14,'#d4a574');R(16,2+petBob+Math.sin(t*4)*1,8,6,'#d4a574');
  C(0,-24+petBob,12,'#d4a574');
  var _hc2=typeof getTarkHeadbandColor==='function'?getTarkHeadbandColor():null;
  if(_hc2)R(-12,-30+petBob,24,4,_hc2);
  cx.strokeStyle='#111';cx.lineWidth=1;
  cx.beginPath();cx.arc(-4,-26+petBob,2,0.5,Math.PI-0.5);cx.stroke();
  cx.beginPath();cx.arc(4,-26+petBob,2,0.5,Math.PI-0.5);cx.stroke();
  cx.beginPath();cx.arc(0,-18+petBob,4,0.2,Math.PI-0.2);cx.stroke();
  for(var hi=0;hi<4;hi++){
    var hx=5+Math.sin(t*2+hi*1.5)*15;var hy=-36-hi*14-(t*20+hi*15)%40;
    cx.globalAlpha=0.6-hi*0.12;cx.font=(10+hi*2)+'px serif';cx.fillStyle='#ff6699';cx.textAlign='center';
    cx.fillText('\u2764',hx,hy+petBob);
  }
  cx.globalAlpha=1;

}else{
  // Running Tark
  var step2=Math.sin(dc.tarkStepT)*6;
  var bob2=Math.abs(step2)*0.3;
  var isSprinting=dc.sprinting&&dc.stamina>0;
  if(isSprinting){step2=Math.sin(dc.tarkStepT)*8;bob2=Math.abs(step2)*0.5;}
  var _sc4=typeof getTarkShirtColor==='function'?getTarkShirtColor():'#f0e6d3';
  var _hc3=typeof getTarkHeadbandColor==='function'?getTarkHeadbandColor():null;
  R(-12,30+step2,10,38-bob2,'#2a2a2a');R(2,30-step2,10,38-bob2,'#2a2a2a');
  R(-14,66,14,6,'#cc3333');R(0,66,14,6,'#cc3333');
  var lean=isSprinting?2:0;
  R(-16+lean,-10-bob2,32,42,_sc4);
  var armPump=step2*1.2;
  R(-24+lean,-6-armPump-bob2,10,30,'#d4a574');R(14+lean,-6+armPump-bob2,10,30,'#d4a574');
  C(-19+lean,26-armPump-bob2,5,'#d4a574');C(19+lean,26+armPump-bob2,5,'#d4a574');
  C(lean,-22-bob2,16,'#d4a574');
  if(_hc3)R(-16+lean,-30-bob2,32,4,_hc3);
  C(-5+lean,-24-bob2,2,'#111');C(5+lean,-24-bob2,2,'#111');
  if(isSprinting){cx.strokeStyle='#111';cx.lineWidth=1.5;cx.beginPath();cx.moveTo(-4+lean,-16-bob2);cx.lineTo(4+lean,-16-bob2);cx.stroke();}
  else{R(-4+lean,-16-bob2,8,2,'#111');}
}
cx.restore();

// === SPEED LINES ===
for(var sli=0;sli<dc.speedLines.length;sli++){
  var sl2=dc.speedLines[sli];var slx=sl2.x-camX;
  cx.globalAlpha=sl2.life*0.4;cx.strokeStyle='#fff';cx.lineWidth=1.5;
  cx.beginPath();cx.moveTo(slx,sl2.y);cx.lineTo(slx-sl2.len,sl2.y);cx.stroke();
}
cx.globalAlpha=1;

// === SWEAT DROPS ===
for(var swi=0;swi<dc.sweatDrops.length;swi++){
  var sw2=dc.sweatDrops[swi];var swx=sw2.x-camX;
  cx.globalAlpha=sw2.life*0.5;C(swx,sw2.y,2,'#66aaff');
}
cx.globalAlpha=1;

// === DOG BURST STREAK ===
if(dc.behaviors[dc.behaviorIdx]&&dc.behaviors[dc.behaviorIdx].type==='burst'&&dc.phase==='chasing'){
  cx.globalAlpha=0.08;for(var bi=1;bi<=5;bi++){C(dogScreenX-bi*12,GY-8*SC,6-bi,'#ff6b35');}cx.globalAlpha=1;
}

// ================================================================
// UI OVERLAY
// ================================================================

// === STAMINA BAR ===
if(dc.phase==='chasing'||dc.phase==='intro'){
  var barX2=300,barY2=445,barW2=300,barH2=16;
  R(barX2-2,barY2-2,barW2+4,barH2+4,'#333');R(barX2,barY2,barW2,barH2,'#1a1a1a');
  var stPct=dc.stamina/dc.maxStamina;
  var stColor=stPct>0.5?'#44cc44':stPct>0.25?'#cccc44':'#cc4444';
  if(stPct<=0.25){cx.globalAlpha=0.7+Math.sin(t*8)*0.3;}
  R(barX2+1,barY2+1,Math.round((barW2-2)*stPct),barH2-2,stColor);
  cx.globalAlpha=1;
  cx.font='bold 9px monospace';cx.fillStyle='#fff';cx.textAlign='center';
  cx.fillText('STAMINA',barX2+barW2/2,barY2+barH2-4);
  if(dc.sprinting&&dc.stamina>0&&dc.phase==='chasing'){
    cx.font='bold 10px monospace';cx.fillStyle='#ffcc00';cx.fillText('SPRINTING!',barX2+barW2/2,barY2-6);
  }else if(dc.phase==='chasing'){
    cx.font='9px monospace';cx.fillStyle='#888';cx.fillText('Hold to sprint',barX2+barW2/2,barY2-6);
  }
}

// === DISTANCE GAP ===
if(dc.phase==='chasing'){
  var gap=dc.dogX-dc.tarkX;var maxGap=500;var gapPct=Math.min(1,gap/maxGap);
  var gapBarX=200,gapBarY=18,gapBarW=500,gapBarH=10;
  R(gapBarX-1,gapBarY-1,gapBarW+2,gapBarH+2,'rgba(0,0,0,0.5)');
  R(gapBarX,gapBarY,gapBarW,gapBarH,'#222');
  var tDotX=gapBarX+4;var dDotX=gapBarX+4+gapPct*(gapBarW-8);
  var gapColor=gapPct<0.3?'#44cc44':gapPct<0.6?'#cccc44':'#cc4444';
  R(tDotX,gapBarY+1,dDotX-tDotX,gapBarH-2,gapColor);
  cx.font='bold 7px monospace';cx.fillStyle='#fff';
  cx.textAlign='left';cx.fillText('TARK',tDotX-2,gapBarY-3);
  cx.textAlign='right';cx.fillText('DOG',dDotX+2,gapBarY-3);
  cx.textAlign='center';
}

// === THEFT OVERLAY ===
if(dc.phase==='theft'){
  var ts3=dc.theftStep;
  if(ts3==='approach'){
    // Tark thought bubble: "Hey buddy, come here..."
    var tbx2=tarkScreenX+70,tby2=GY-130;
    cx.fillStyle='rgba(255,255,255,0.9)';cx.strokeStyle='#333';cx.lineWidth=1.5;
    cx.beginPath();cx.moveTo(tbx2-60,tby2-12);cx.lineTo(tbx2+60,tby2-12);
    cx.quadraticCurveTo(tbx2+65,tby2-12,tbx2+65,tby2-6);cx.lineTo(tbx2+65,tby2+6);
    cx.quadraticCurveTo(tbx2+65,tby2+12,tbx2+60,tby2+12);cx.lineTo(tbx2-60,tby2+12);
    cx.quadraticCurveTo(tbx2-65,tby2+12,tbx2-65,tby2+6);cx.lineTo(tbx2-65,tby2-6);
    cx.quadraticCurveTo(tbx2-65,tby2-12,tbx2-60,tby2-12);cx.closePath();cx.fill();cx.stroke();
    C(tbx2-50,tby2+20,4,'rgba(255,255,255,0.9)');cx.strokeStyle='#333';cx.lineWidth=1;cx.beginPath();cx.arc(tbx2-50,tby2+20,4,0,Math.PI*2);cx.stroke();
    C(tbx2-56,tby2+28,2.5,'rgba(255,255,255,0.9)');cx.beginPath();cx.arc(tbx2-56,tby2+28,2.5,0,Math.PI*2);cx.stroke();
    cx.font='bold 11px monospace';cx.fillStyle='#222';cx.textAlign='center';
    cx.fillText("Hey buddy, come here...",tbx2,tby2+4);
  }else if(ts3==='sniff'){
    // Tark thought bubble: "Good boy..."
    var tbx3=tarkScreenX+70,tby3=GY-130;
    cx.fillStyle='rgba(255,255,255,0.9)';cx.strokeStyle='#333';cx.lineWidth=1.5;
    cx.beginPath();cx.moveTo(tbx3-40,tby3-12);cx.lineTo(tbx3+40,tby3-12);
    cx.quadraticCurveTo(tbx3+45,tby3-12,tbx3+45,tby3-6);cx.lineTo(tbx3+45,tby3+6);
    cx.quadraticCurveTo(tbx3+45,tby3+12,tbx3+40,tby3+12);cx.lineTo(tbx3-40,tby3+12);
    cx.quadraticCurveTo(tbx3-45,tby3+12,tbx3-45,tby3+6);cx.lineTo(tbx3-45,tby3-6);
    cx.quadraticCurveTo(tbx3-45,tby3-12,tbx3-40,tby3-12);cx.closePath();cx.fill();cx.stroke();
    C(tbx3-30,tby3+20,4,'rgba(255,255,255,0.9)');cx.strokeStyle='#333';cx.lineWidth=1;cx.beginPath();cx.arc(tbx3-30,tby3+20,4,0,Math.PI*2);cx.stroke();
    C(tbx3-36,tby3+28,2.5,'rgba(255,255,255,0.9)');cx.beginPath();cx.arc(tbx3-36,tby3+28,2.5,0,Math.PI*2);cx.stroke();
    cx.font='bold 11px monospace';cx.fillStyle='#222';cx.textAlign='center';
    cx.fillText("Good boy...",tbx3,tby3+4);
  }else if(ts3==='grab'){
    // "!" over Tark
    var exPulse2=Math.sin(t*10)*0.2+0.8;
    cx.globalAlpha=exPulse2;cx.font='bold 24px monospace';cx.fillStyle='#ff2222';cx.textAlign='center';
    cx.fillText('!',tarkScreenX,GY-80);cx.globalAlpha=1;
    // "!" over dog too
    cx.globalAlpha=exPulse2;cx.font='bold 18px monospace';cx.fillStyle='#ffcc00';
    cx.fillText('!',dogScreenX,GY-50);cx.globalAlpha=1;
  }else{
    // Bolt — Tark thought bubble: "HEY! My smokes!"
    var tbx4=tarkScreenX+80,tby4=GY-130;
    cx.fillStyle='rgba(255,255,255,0.95)';cx.strokeStyle='#cc2222';cx.lineWidth=2;
    cx.beginPath();cx.moveTo(tbx4-65,tby4-14);cx.lineTo(tbx4+65,tby4-14);
    cx.quadraticCurveTo(tbx4+70,tby4-14,tbx4+70,tby4-8);cx.lineTo(tbx4+70,tby4+8);
    cx.quadraticCurveTo(tbx4+70,tby4+14,tbx4+65,tby4+14);cx.lineTo(tbx4-65,tby4+14);
    cx.quadraticCurveTo(tbx4-70,tby4+14,tbx4-70,tby4+8);cx.lineTo(tbx4-70,tby4-8);
    cx.quadraticCurveTo(tbx4-70,tby4-14,tbx4-65,tby4-14);cx.closePath();cx.fill();cx.stroke();
    C(tbx4-55,tby4+22,4,'rgba(255,255,255,0.95)');cx.strokeStyle='#cc2222';cx.lineWidth=1.5;cx.beginPath();cx.arc(tbx4-55,tby4+22,4,0,Math.PI*2);cx.stroke();
    C(tbx4-61,tby4+30,2.5,'rgba(255,255,255,0.95)');cx.beginPath();cx.arc(tbx4-61,tby4+30,2.5,0,Math.PI*2);cx.stroke();
    cx.font='bold 13px monospace';cx.fillStyle='#cc2222';cx.textAlign='center';
    cx.fillText("HEY! My smokes!",tbx4,tby4+5);
  }
}

// === INTRO OVERLAY ===
if(dc.phase==='intro'){
  cx.globalAlpha=0.4;R(0,0,W,H,'#000');cx.globalAlpha=1;
  var tbx=tarkScreenX+80,tby=GY-120;
  cx.fillStyle='rgba(255,255,255,0.95)';cx.strokeStyle='#333';cx.lineWidth=1.5;
  cx.beginPath();cx.moveTo(tbx-70,tby-16);cx.lineTo(tbx+70,tby-16);
  cx.quadraticCurveTo(tbx+75,tby-16,tbx+75,tby-10);cx.lineTo(tbx+75,tby+10);
  cx.quadraticCurveTo(tbx+75,tby+16,tbx+70,tby+16);cx.lineTo(tbx-70,tby+16);
  cx.quadraticCurveTo(tbx-75,tby+16,tbx-75,tby+10);cx.lineTo(tbx-75,tby-10);
  cx.quadraticCurveTo(tbx-75,tby-16,tbx-70,tby-16);cx.closePath();cx.fill();cx.stroke();
  C(tbx-60,tby+24,4,'rgba(255,255,255,0.95)');cx.strokeStyle='#333';cx.lineWidth=1;cx.beginPath();cx.arc(tbx-60,tby+24,4,0,Math.PI*2);cx.stroke();
  C(tbx-66,tby+32,2.5,'rgba(255,255,255,0.95)');cx.beginPath();cx.arc(tbx-66,tby+32,2.5,0,Math.PI*2);cx.stroke();
  cx.font='bold 11px monospace';cx.fillStyle='#cc2222';cx.textAlign='center';
  cx.fillText("That mutt stole my cigs!",tbx,tby-2);
  cx.font='9px monospace';cx.fillStyle='#555';cx.fillText("I gotta catch him!",tbx,tby+12);
  var exPulse=Math.sin(t*6)*0.15+0.85;
  cx.font='bold 16px monospace';cx.fillStyle='#ff4444';cx.globalAlpha=exPulse;
  cx.fillText('!',dogScreenX,GY-40*SC);cx.globalAlpha=1;
  var instPulse=0.5+Math.sin(t*3)*0.3;cx.globalAlpha=instPulse;
  cx.font='bold 13px monospace';cx.fillStyle='#ffcc00';cx.textAlign='center';
  cx.fillText('HOLD to sprint - RELEASE to jog',450,420);
  cx.font='9px monospace';cx.fillStyle='#aaa';cx.fillText("Don't run out of stamina!",450,436);
  cx.globalAlpha=1;
}

// === RESULT OVERLAYS ===
if(dc.phase==='caught'){
  cx.globalAlpha=0.04;R(0,0,W,H,'#44ff44');cx.globalAlpha=1;
  cx.font='bold 20px monospace';cx.fillStyle='#44ff44';cx.textAlign='center';cx.fillText('GOT \'EM BACK!',450,60);
  cx.font='10px monospace';cx.fillStyle='#44ff44';cx.fillText('Nervousness \u2193  Focus \u2191',450,80);
  cx.font='8px monospace';cx.fillStyle='#888';cx.fillText('Tark reclaimed his smokes. Good boy.',450,96);
}
if(dc.phase==='exhausted'){
  cx.globalAlpha=0.06;R(0,0,W,H,'#ff4444');cx.globalAlpha=1;
  cx.font='bold 20px monospace';cx.fillStyle='#ff4444';cx.textAlign='center';cx.fillText('OUT OF GAS',450,60);
  cx.font='10px monospace';cx.fillStyle='#ff6644';cx.fillText('Nervousness \u2191',450,80);
  cx.font='8px monospace';cx.fillStyle='#888';cx.fillText('The dog (and the cigs) vanished into the alley.',450,96);
}
cx.textAlign='center';
}


// === DEPTH SYSTEM ===
function getDepthParams(y){
  var t=(y-180)/(FY-180);
  t=Math.max(0,Math.min(1,t));
  return{scale:0.35+t*0.65,alpha:0.6+t*0.4};
}

function drawScaledPerson(x,y,opts){
  var dp=getDepthParams(y);
  var s=dp.scale;
  var pr=cx.globalAlpha;
  cx.globalAlpha=dp.alpha*(opts.alphaBoost||0.9);
  var sk=opts.skin||'#c8a882',sg=opts.singlet||'#333',hr=opts.hair||'#111';
  var sway=Math.sin((Date.now()+(opts.animOffset||0))/(opts.swaySpeed||1000))*s*1.2;
  var rs=function(v){return Math.round(v*s);};
  var pose=opts.pose||'standing';
  if(pose==='standing'){
    // Legs
    R(x-rs(4),y+rs(18),rs(5),rs(22),sg);R(x+rs(0),y+rs(18),rs(5),rs(22),sg);
    // Shoes
    R(x-rs(5),y+rs(40),rs(7),rs(3),'#111');R(x-rs(1),y+rs(40),rs(7),rs(3),'#111');
    // Torso
    R(x-rs(7)+sway,y-rs(2),rs(14),rs(22),sg);
    // Arms
    R(x-rs(10)+sway,y+rs(0),rs(4),rs(16),sk);
    R(x+rs(6)+sway,y+rs(0),rs(4),rs(16),sk);
    // Head
    C(x+sway,y-rs(10),rs(7),sk);
    R(x-rs(6)+sway,y-rs(18),rs(12),rs(5),hr);
    // Coach variant: clipboard + cap
    if(opts.isCoach){
      R(x+rs(8)+sway,y+rs(10),rs(7),rs(9),'#8b6914');
      R(x+rs(9)+sway,y+rs(11),rs(5),rs(7),'#f0e8d4');
      R(x-rs(8)+sway,y-rs(20),rs(16),rs(5),'#2a2a2a');
    }
  }else if(pose==='sitting'){
    var sy=y;
    // Bent legs
    R(x-rs(6),sy+rs(4),rs(12),rs(5),sg);
    R(x-rs(7),sy+rs(9),rs(5),rs(12),sg);R(x+rs(2),sy+rs(9),rs(5),rs(12),sg);
    // Shoes
    R(x-rs(8),sy+rs(21),rs(6),rs(3),'#111');R(x+rs(1),sy+rs(21),rs(6),rs(3),'#111');
    // Torso (leaning back slightly)
    R(x-rs(6)+sway,sy-rs(8),rs(12),rs(14),sg);
    // Arms resting on knees
    R(x-rs(9)+sway,sy-rs(2),rs(4),rs(10),sk);R(x+rs(5)+sway,sy-rs(2),rs(4),rs(10),sk);
    // Head
    C(x+sway,sy-rs(16),rs(6),sk);
    R(x-rs(5)+sway,sy-rs(23),rs(10),rs(5),hr);
  }else if(pose==='stretching'){
    // Arms overhead stretch — reads clearly at any scale
    R(x-rs(4),y+rs(18),rs(5),rs(22),sg);R(x+rs(0),y+rs(18),rs(5),rs(22),sg);
    R(x-rs(5),y+rs(40),rs(7),rs(3),'#111');R(x-rs(1),y+rs(40),rs(7),rs(3),'#111');
    // Torso
    R(x-rs(7)+sway,y-rs(2),rs(14),rs(22),sg);
    // Arms straight up
    R(x-rs(9)+sway,y-rs(22),rs(4),rs(20),sk);R(x+rs(5)+sway,y-rs(22),rs(4),rs(20),sk);
    // Head
    C(x+sway,y-rs(10),rs(7),sk);
    R(x-rs(6)+sway,y-rs(18),rs(12),rs(5),hr);
  }else if(pose==='chalking'){
    // Standing over chalk bucket, hands together
    R(x-rs(4),y+rs(18),rs(5),rs(22),sg);R(x+rs(0),y+rs(18),rs(5),rs(22),sg);
    R(x-rs(5),y+rs(40),rs(7),rs(3),'#111');R(x-rs(1),y+rs(40),rs(7),rs(3),'#111');
    R(x-rs(7)+sway,y-rs(2),rs(14),rs(22),sg);
    // Arms forward (chalking)
    R(x-rs(3)+sway,y+rs(4),rs(3),rs(14),sk);R(x+rs(1)+sway,y+rs(4),rs(3),rs(14),sk);
    // Chalk bucket
    R(x-rs(4),y+rs(16),rs(8),rs(6),'#666');
    // Head
    C(x+sway,y-rs(10),rs(7),sk);R(x-rs(6)+sway,y-rs(18),rs(12),rs(5),hr);
    // Chalk dust
    if(Math.random()<0.02&&S.chalkParticles.length<8){
      S.chalkParticles.push({x:x+sway,y:y+rs(8),life:1,vx:(Math.random()-0.5)*0.5,vy:-0.4-Math.random()*0.3});
    }
  }else if(pose==='warmup_barbell'){
    var cycle=Math.sin((Date.now()+(opts.animOffset||0))/3000);
    var isPull=cycle<0;
    R(x-rs(4),y+rs(18),rs(5),rs(22),sg);R(x+rs(0),y+rs(18),rs(5),rs(22),sg);
    R(x-rs(5),y+rs(40),rs(7),rs(3),'#111');R(x-rs(1),y+rs(40),rs(7),rs(3),'#111');
    if(isPull){
      // Pulling position — bent forward
      R(x-rs(7)+sway,y+rs(0),rs(14),rs(20),sg);
      R(x-rs(6)+sway,y+rs(14),rs(4),rs(10),sk);R(x+rs(3)+sway,y+rs(14),rs(4),rs(10),sk);
      // Barbell at knee height
      R(x-rs(16),y+rs(22),rs(32),rs(2),'#888');
      R(x-rs(18),y+rs(18),rs(4),rs(8),'#cc3333');R(x+rs(14),y+rs(18),rs(4),rs(8),'#cc3333');
    }else{
      // Overhead position
      R(x-rs(7)+sway,y-rs(2),rs(14),rs(22),sg);
      R(x-rs(10)+sway,y-rs(24),rs(4),rs(18),sk);R(x+rs(6)+sway,y-rs(24),rs(4),rs(18),sk);
      // Barbell overhead
      R(x-rs(16),y-rs(28),rs(32),rs(2),'#888');
      R(x-rs(18),y-rs(32),rs(4),rs(8),'#cc3333');R(x+rs(14),y-rs(32),rs(4),rs(8),'#cc3333');
    }
    C(x+sway,y-rs(10),rs(7),sk);R(x-rs(6)+sway,y-rs(18),rs(12),rs(5),hr);
  }else if(pose==='talking_pair'){
    // Two figures standing together — lifter + companion
    // Lifter (left)
    R(x-rs(4),y+rs(18),rs(5),rs(22),sg);R(x+rs(0),y+rs(18),rs(5),rs(22),sg);
    R(x-rs(5),y+rs(40),rs(7),rs(3),'#111');R(x-rs(1),y+rs(40),rs(7),rs(3),'#111');
    R(x-rs(7)+sway,y-rs(2),rs(14),rs(22),sg);
    R(x-rs(10)+sway,y+rs(0),rs(4),rs(12),sk);
    C(x+sway,y-rs(10),rs(7),sk);R(x-rs(6)+sway,y-rs(18),rs(12),rs(5),hr);
    // Companion (right, facing lifter — sway matches body)
    var cx2=x+rs(24);
    var sw2=-sway*0.5;// gentle counter-sway
    R(cx2-rs(4),y+rs(18),rs(5),rs(22),'#2a2a3a');R(cx2+rs(0),y+rs(18),rs(5),rs(22),'#2a2a3a');
    R(cx2-rs(5),y+rs(40),rs(7),rs(3),'#111');R(cx2-rs(1),y+rs(40),rs(7),rs(3),'#111');
    R(cx2-rs(7)+sw2,y-rs(2),rs(14),rs(22),'#1a3a1a');
    // Arms at sides
    R(cx2-rs(10)+sw2,y+rs(0),rs(4),rs(12),'#c89070');
    R(cx2+rs(6)+sw2,y+rs(0),rs(4),rs(12),'#c89070');
    // Head (same sway direction as body)
    C(cx2+sw2,y-rs(10),rs(7),'#c89070');
    R(cx2-rs(6)+sw2,y-rs(18),rs(12),rs(5),'#333');
  }
  cx.globalAlpha=pr;
}

// === BACKGROUND EXTRAS GENERATION ===
function generateBackroomExtras(){
  var extras=[];
  var seed=S.rivals.length*7+13+(S.compMode||1)*31;
  function rng(){seed=(seed*16807)%2147483647;return seed/2147483647;}
  var SKINS=['#d4a574','#e8c898','#c49060','#f0d0a0','#8b6b40','#e0c090','#b07840','#6b4226'];
  var SINGLETS=['#cc2222','#2244aa','#22aa44','#eeeeee','#fcd116','#1a4a1a','#9944cc','#333','#ff6600','#0088cc'];
  var HAIRS=['#111','#222','#8b6914','#5c3317','#8b4513','#333'];
  // Fixed positions — hand-placed to avoid overlap and look intentional
  var placed=[
    // Far back (small, behind everything)
    {x:130,y:205,pose:'warmup_barbell'},
    {x:310,y:215,pose:'standing'},
    {x:390,y:200,pose:'warmup_barbell'},
    // Mid-depth (spread across room, clear of furniture/rivals corridor)
    {x:100,y:275,pose:'standing'},
    {x:260,y:290,pose:'stretching'},
    {x:460,y:280,pose:'chalking'},
    {x:750,y:270,pose:'standing'},
    // Near edges (sides only — clear of featured rival positions)
    {x:420,y:340,pose:'sitting'},
    {x:820,y:350,pose:'standing'}
  ];
  for(var i=0;i<placed.length;i++){
    var p=placed[i];
    extras.push({
      x:p.x,y:p.y,pose:p.pose,
      skin:SKINS[Math.floor(rng()*SKINS.length)],
      singlet:SINGLETS[Math.floor(rng()*SINGLETS.length)],
      hair:HAIRS[Math.floor(rng()*HAIRS.length)],
      animOffset:Math.round(rng()*6000),
      swaySpeed:900+Math.round(rng()*600),
      isCoach:false
    });
  }
  S.backroomExtras=extras;
  S.chalkParticles=[];
}
window.generateBackroomExtras=generateBackroomExtras;

// === WARM-UP PLATFORMS (far background) ===
function drawBackroomPlatforms(){
  // Simple wooden platform strips on the far back wall
  cx.globalAlpha=0.5;
  R(140,218,80,3,'#4a3018');R(140,221,80,2,'#3d2813');
  R(340,228,80,3,'#4a3018');R(340,231,80,2,'#3d2813');
  cx.globalAlpha=1;
}

// === EXTRA ENVIRONMENT DETAILS ===
function drawBackroomEnvironment(){
  // Chalk dust particles only — no floor clutter
  for(var i=S.chalkParticles.length-1;i>=0;i--){
    var p=S.chalkParticles[i];
    p.x+=p.vx;p.y+=p.vy;p.life-=0.015;
    if(p.life<=0){S.chalkParticles.splice(i,1);continue;}
    cx.globalAlpha=p.life*0.5;
    C(p.x,p.y,1,'#e8e0d0');
  }
  cx.globalAlpha=1;
}

// === DEPTH-AWARE RIVAL SPOTS ===
function assignRivalSpots(){
  if(!S.rivals||S.rivals.length===0)return[];
  var spots=[
    {x:160,y:295,sit:true},{x:480,y:310,sit:false},{x:520,y:345,sit:true},
    {x:700,y:275,sit:false},{x:760,y:355,sit:true},{x:200,y:280,sit:false},
    {x:620,y:300,sit:true},{x:350,y:330,sit:false},{x:440,y:265,sit:true},
    {x:680,y:340,sit:false},{x:580,y:285,sit:true},{x:140,y:355,sit:false}
  ];
  var result=[];
  for(var i=0;i<S.rivals.length&&i<spots.length;i++){
    var r=S.rivals[i];
    if(!r.active)continue;
    if(r.featured)continue;// featured rivals render separately
    var isLifting=(S.turn&&S.turn.whose==='rival'&&S.rival&&S.rival.id===r.id);
    if(isLifting)continue;
    var sp=spots[i];
    result.push({x:sp.x,y:sp.y,sit:sp.sit,skin:r.skin||'#c8a882',singlet:r.singlet||'#333',hair:r.hair||'#111',name:r.name,flag:r.flag,declared:r.declared||0,done:r.done||false});
  }
  return result;
}

function drawBackroomRivalNew(spot){
  var dp=getDepthParams(spot.y);
  var s=dp.scale;
  drawScaledPerson(spot.x,spot.y,{
    skin:spot.skin,singlet:spot.singlet,hair:spot.hair,
    pose:spot.sit?'sitting':'standing',
    alphaBoost:Math.min(1.0,dp.alpha*1.3),
    animOffset:spot.x*7,swaySpeed:1000+spot.x%400
  });
  // Name tag (only if large enough to read)
  if(s>0.45){
    var tagY=spot.y+(spot.sit?Math.round(26*s):Math.round(44*s));
    var pr=cx.globalAlpha;
    cx.globalAlpha=dp.alpha*0.85;
    var nm=spot.name.split(' ')[0].toUpperCase();
    T(nm,spot.x,tagY,Math.max(5,Math.round(7*s)),spot.singlet);
    if(spot.flag){T(spot.flag,spot.x,tagY+Math.round(9*s),Math.round(8*s),'#fff');}
    // Show declared weight during competition (amber, prominent)
    if(spot.declared>0&&!spot.done&&(S.phase==='snatch'||S.phase==='cj')){
      T(spot.declared+'',spot.x,tagY+Math.round(18*s),Math.max(6,Math.round(8*s)),'#ffcc00');
    }
    cx.globalAlpha=pr;
  }
}

function drawFeaturedRival(rival){
  var x=rival.featX,y=rival.featY;
  var pose=rival.featPose||'idle';
  var elapsed=Date.now()-(rival.featPoseT||0);
  var sk=rival.skin||'#c8a882',sg=rival.singlet||'#333',hr=rival.hair||'#111';
  var swSpd=pose==='staredown'?5000:1200;
  var sw=Math.sin((Date.now()+(rival.name?rival.name.charCodeAt(0)*100:0))/swSpd)*1;
  var pr=cx.globalAlpha;
  // Full-size body (matches Tark's proportions from drawTarkIdle/Pull/Overhead)
  if(pose==='pull'){
    // Bent over pull — from drawTarkPull
    R(x-14,y+20,12,30,sg);R(x+2,y+20,12,30,sg);// legs
    R(x-16,y+48,14,6,'#222');R(x+2,y+48,14,6,'#222');// shoes
    R(x-16,y-5,32,28,sg);// torso bent
    R(x-22,y+2,8,26,sk);R(x+14,y+2,8,26,sk);// arms down
    C(x,y-16,16,sk);R(x-16,y-24,32,4,hr);// head+hair
    C(x-5,y-18,2,'#111');C(x+5,y-18,2,'#111');// eyes
    R(x-6,y-12,12,3,'#111');// mouth strain
    drawBarbell(x,y+30,rival._liftPlates||[]);
  }else if(pose==='overhead'){
    // Arms up — from drawTarkOverhead
    R(x-12,y+30,10,38,sg);R(x+2,y+30,10,38,sg);// legs
    R(x-14,y+66,14,6,'#222');R(x+0,y+66,14,6,'#222');// shoes
    R(x-16+sw,y-10,32,42,sg);// torso
    R(x-22+sw,y-50,8,44,sk);R(x+14+sw,y-50,8,44,sk);// arms up
    C(x-18+sw,y-52,5,sk);C(x+18+sw,y-52,5,sk);// fists high
    C(x+sw,y-22,16,sk);R(x-16+sw,y-30,32,4,hr);// head+hair
    C(x-5+sw,y-24,2,'#111');C(x+5+sw,y-24,2,'#111');// eyes
    R(x-4+sw,y-16,8,2,'#111');// mouth
    drawBarbell(x,y-56,rival._liftPlates||[]);
  }else{
    // Idle/standing/staredown/rattled/laughing/flinch/chalking — from drawTarkIdle
    R(x-12,y+30,10,38,sg);R(x+2,y+30,10,38,sg);// legs
    R(x-14,y+66,14,6,'#222');R(x+0,y+66,14,6,'#222');// shoes
    R(x-16+sw,y-10,32,42,sg);// torso
    R(x-24+sw,y-6,10,30,sk);R(x+14+sw,y-6,10,30,sk);// arms
    C(x-19+sw,y+26,5,sk);C(x+19+sw,y+26,5,sk);// fists
    C(x+sw,y-22,16,sk);R(x-16+sw,y-30,32,4,hr);// head+hair
    C(x-5+sw,y-24,2,'#111');C(x+5+sw,y-24,2,'#111');// eyes
    R(x-4+sw,y-16,8,2,'#111');// mouth
    // Resting barbell on floor
    drawBarbell(x,392,rival._liftPlates||[]);
  }
  // Name tag + flag (full size)
  var nm=rival.name.split(' ')[0].toUpperCase();
  T(nm,x,y+78,9,sg);
  if(rival.flag)T(rival.flag,x,y+90,10,'#fff');
  // Weight float during overhead
  if(pose==='overhead'&&rival._liftWeight){
    var fA=Math.min(1,elapsed/300);
    if(elapsed>1500)fA=Math.max(0,1-(elapsed-1500)/500);
    cx.globalAlpha=fA;
    T(rival._liftWeight+' lbs',x,y-70,12,'#ffcc00');
  }
  // Staredown: red glow at eyes
  if(pose==='staredown'){
    cx.globalAlpha=0.3+Math.sin(Date.now()/200)*0.1;
    C(x,y-24,5,'#ff4444');
  }
  // Rattled: sweat droplet
  if(pose==='rattled'&&elapsed<2000){
    cx.globalAlpha=0.6;
    C(x+8,y-14+Math.round(elapsed/200),3,'#6699cc');
  }
  // Laughing: smirk text shake
  if(pose==='laughing'&&elapsed<2000){
    cx.globalAlpha=0.8;
    T('heh',x+Math.sin(elapsed/50)*2,y-40,9,'#aaa');
  }
  // Flinch: brief flash
  if(pose==='flinch'&&elapsed<600){
    cx.globalAlpha=0.15;
    R(x-20,y-35,40,70,'#ffffff');
  }
  // Hover highlight for taunt target
  if(window.hover==='feat_'+rival.id&&!S.busy){
    cx.globalAlpha=0.8;
    cx.strokeStyle='#ff6b35';cx.lineWidth=2;
    cx.strokeRect(x-28,y-35,56,110);
    T('TAUNT',x,y-42,10,'#ff6b35');
  }
  cx.globalAlpha=pr;
}

function updateFeaturedRivals(){
  if(!S.rivals)return;
  for(var i=0;i<S.rivals.length;i++){
    var r=S.rivals[i];
    if(!r.featured)continue;
    var elapsed=Date.now()-(r.featPoseT||0);
    // Lift animation: pull → overhead → idle
    if(r.featPose==='pull'&&elapsed>700){
      r.featPose='overhead';r.featPoseT=Date.now();
    }
    if(r.featPose==='overhead'&&elapsed>2000){
      r.featPose='idle';r.featPoseT=Date.now();r.featAnimDone=true;r._liftWeight=0;
    }
    // Reaction poses auto-reset after 2s
    if((r.featPose==='rattled'||r.featPose==='laughing'||
        r.featPose==='flinch'||r.featPose==='staredown')&&elapsed>2000){
      r.featPose='idle';r.featPoseT=Date.now();
    }
    // Random chalking while idle (rare)
    if(r.featPose==='idle'&&r.featAnimDone&&Math.random()<0.0003){
      r.featPose='chalking';r.featPoseT=Date.now();
      // Auto-reset chalking after 3-5s (use global setTimeout)
      (function(rv){setTimeout(function(){
        if(rv.featPose==='chalking'){rv.featPose='idle';rv.featPoseT=Date.now();}
      },3000+Math.random()*2000);})(r);
    }
  }
}

function drawBackroomBackground(){
  // === WALL — two-tone with clear horizontal structure ===
  // Upper wall (lighter concrete)
  R(0,0,W,160,'#3d3d3d');
  // Lower wall (painted cinder block — darker)
  R(0,160,W,FY-160,'#2f2f2f');
  // Horizontal rail/trim between zones
  R(0,157,W,4,'#444');
  R(0,161,W,1,'#282828');

  // === FLOOR — dark rubber with red competition stripe + mat texture ===
  R(0,FY,W,H-FY,'#181818');
  R(0,FY,W,3,'#8b2020');
  R(0,FY+3,W,1,'#222');
  // Rubber mat seam lines (subtle horizontal)
  cx.strokeStyle='#1e1e1e';cx.lineWidth=0.5;
  cx.beginPath();cx.moveTo(0,FY+20);cx.lineTo(W,FY+20);cx.stroke();
  cx.beginPath();cx.moveTo(0,FY+40);cx.lineTo(W,FY+40);cx.stroke();
  // Vertical mat seams (widely spaced)
  for(var mx=0;mx<W;mx+=120){
    cx.beginPath();cx.moveTo(mx,FY+4);cx.lineTo(mx,H);cx.stroke();
  }

  // === CEILING — fluorescent light bars ===
  var flk=0.93+Math.sin(Date.now()/200)*0.03;
  cx.globalAlpha=flk;
  R(140,2,160,6,'#ddddc8');R(145,0,150,2,'#444');
  R(520,2,160,6,'#ddddc8');R(525,0,150,2,'#444');
  cx.globalAlpha=1;
  // Pipe along ceiling
  R(0,18,W,2,'#484848');

  // === WALL DECORATIONS — bold, readable at game scale ===
  // "WARM-UP ROOM A" banner — bright and clear
  R(330,32,240,20,'#992222');
  R(330,32,240,2,'#bb3333');// highlight edge
  T('WARM-UP ROOM A',450,47,10,'#eeddbb');

  // Poster 1: "LIFT HEAVY" — large, white paper, bold red text
  R(195,60,60,76,'#e8e0d0');
  R(195,60,60,2,'#ccc4b0');// top edge shadow
  T('LIFT',225,88,12,'#bb2222');
  T('HEAVY',225,106,12,'#bb2222');

  // Poster 2: Weight class board — clear black on white
  R(290,70,50,56,'#ddd8c8');
  R(290,70,50,12,'#992222');// red header
  T('85 KG',315,80,7,'#fff');
  T('SESSION A',315,96,5,'#444');
  T('PLATFORM 1',315,106,5,'#444');
  // Tack marks
  C(295,68,2,'#888');C(335,68,2,'#888');

  // Whiteboard — attempt order, clear readable
  R(420,65,70,50,'#e8ece8');
  cx.strokeStyle='#999';cx.lineWidth=1;cx.strokeRect(420,65,70,50);
  R(422,113,66,3,'#999');// tray
  T('ATTEMPT',455,80,6,'#336633');
  T('ORDER',455,90,6,'#336633');
  // Marker scrawl
  cx.globalAlpha=0.5;
  T('SN 3/6',455,102,5,'#555');
  cx.globalAlpha=1;

  // Clock — right wall, between whiteboard and TV
  var clkX=630,clkY=50,clkR=16;
  C(clkX,clkY,clkR+2,'#222');
  C(clkX,clkY,clkR,'#eee8d0');
  T('12',clkX,clkY-9,5,'#222');T('6',clkX,clkY+12,5,'#222');
  T('3',clkX+10,clkY+2,5,'#222');T('9',clkX-10,clkY+2,5,'#222');
  var ct=Date.now()/1000;
  var minA=(ct/60)*Math.PI*2-Math.PI/2;
  var hrA=(ct/720)*Math.PI*2-Math.PI/2;
  cx.strokeStyle='#222';cx.lineWidth=1.5;
  cx.beginPath();cx.moveTo(clkX,clkY);cx.lineTo(clkX+Math.cos(hrA)*8,clkY+Math.sin(hrA)*8);cx.stroke();
  cx.lineWidth=1;
  cx.beginPath();cx.moveTo(clkX,clkY);cx.lineTo(clkX+Math.cos(minA)*11,clkY+Math.sin(minA)*11);cx.stroke();
  C(clkX,clkY,2,'#222');
}

function drawWallScoreboard(){
  // Electronic wall-mounted scoreboard — left side, moved up to avoid overlapping lifters
  if(S.phase==='gym'||S.phase==='intro'||S.phase==='warmup'||S.phase==='mode_select'||S.phase==='roster_pick')return;
  if(!S.rivals||S.rivals.length===0)return;
  var standings=getStandings();
  var bx=10,by=28,bw=160;
  var rowH=15;
  var hdrH=20;
  var bh=hdrH+standings.length*rowH+8;
  // Wall mount bracket
  R(bx+bw/2-18,by-6,36,4,'#444');
  R(bx+bw/2-6,by-9,12,4,'#333');
  // Display frame
  R(bx-3,by-3,bw+6,bh+6,'#1a1a1a');
  R(bx-1,by-1,bw+2,bh+2,'#2a2a2a');
  R(bx,by,bw,bh,'#080808');
  // Header
  var isComp=S.phase==='snatch'||S.phase==='cj';
  var phLbl=S.phase==='snatch'?'SNATCH':S.phase==='cj'?'C&J':S.phase==='rest_sn_cj'?'REST':'STANDINGS';
  T(phLbl,bx+bw/2,by+13,9,'#8b7340');
  R(bx+10,by+hdrH-2,bw-20,1,'#2a2218');
  // Column headers (small)
  if(isComp){
    cx.globalAlpha=0.5;
    T('DECL',bx+bw-42,by+13,5,'#888','right');
    T('TOT',bx+bw-8,by+13,5,'#888','right');
    cx.globalAlpha=1;
  }
  // Standings rows
  for(var i=0;i<standings.length;i++){
    var s=standings[i];
    var ry=by+hdrH+i*rowH;
    var col=s.isTark?'#ff6b35':s.id===S.rival.id?'#7fdb6a':'#999';
    // Highlight current lifter row
    if(S.turn&&S.turn.whose==='rival'&&S.rival&&s.id===S.rival.id){
      R(bx+2,ry,bw-4,rowH-1,'rgba(127,219,106,0.08)');
    }else if(S.turn&&S.turn.whose==='tark'&&s.isTark){
      R(bx+2,ry,bw-4,rowH-1,'rgba(255,107,53,0.08)');
    }
    // Rank
    T((i+1)+'.',bx+14,ry+11,7,col,'right');
    // Flag
    T(s.flag||'',bx+20,ry+11,7,'#fff','left');
    // Name
    T(s.name,bx+36,ry+11,7,col,'left');
    // Declared weight (competition only, amber)
    if(isComp){
      if(s.done){
        T('DONE',bx+bw-42,ry+11,6,'#555','right');
      }else if(s.declared&&s.declared>0){
        T(s.declared+'',bx+bw-42,ry+11,7,'#ffcc00','right');
      }else if(s.isTark&&S.turn&&S.turn.tarkDeclared>0){
        T(S.turn.tarkDeclared+'',bx+bw-42,ry+11,7,'#ffcc00','right');
      }else{
        T('---',bx+bw-42,ry+11,6,'#444','right');
      }
    }
    // Total
    T(s.total>0?s.total+'':'---',bx+bw-8,ry+11,8,col,'right');
  }
  // Scan line effect (subtle, like TV)
  cx.globalAlpha=0.02;
  for(var sli=by;sli<by+bh;sli+=2)R(bx,sli,bw,1,'#fff');
  cx.globalAlpha=1;
}

function drawBackroomDoor(){
  var L=LAYOUT.backroom;
  var dx=L.doorX,dy=L.doorY,dw=L.doorW,dh=L.doorH;
  var isTurn=S.turn&&S.turn.whose==='tark'&&(S.phase==='snatch'||S.phase==='cj');
  // Glow when it's Tark's turn
  if(isTurn){
    var t=Date.now();
    var glow=0.3+Math.sin(t/400)*0.2;
    cx.globalAlpha=glow*0.5;
    R(dx-20,dy-20,dw+40,dh+28,'#ff6b35');
    cx.globalAlpha=glow;
    R(dx-12,dy-12,dw+24,dh+16,'#ff6b35');
    cx.globalAlpha=1;
    // Pulsing "YOUR TURN" text above door
    var pulse=0.7+Math.sin(t/300)*0.3;
    cx.globalAlpha=pulse;
    T('YOUR TURN',dx+dw/2,dy-34,12,'#ffaa00');
    cx.globalAlpha=1;
  }
  // Door frame
  R(dx-4,dy-4,dw+8,dh+4,'#555');
  // Door opening — dark tunnel
  R(dx,dy,dw,dh,'#080808');
  // Light spill from platform (brighter when it's your turn)
  if(isTurn){
    var grad=cx.createLinearGradient(dx,dy,dx+dw,dy);
    grad.addColorStop(0,'rgba(255,150,50,0.15)');
    grad.addColorStop(1,'rgba(255,150,50,0)');
    cx.fillStyle=grad;cx.fillRect(dx,dy,dw,dh);
  }
  // Depth — slight gradient
  cx.globalAlpha=0.15;
  R(dx,dy,8,dh,'#666');
  cx.globalAlpha=1;
  // "PLATFORM" sign above door
  R(dx-12,dy-22,dw+24,18,'#1a1a1a');
  cx.strokeStyle='#333';cx.lineWidth=1;cx.strokeRect(dx-12,dy-22,dw+24,18);
  T('PLATFORM \u2192',dx+dw/2,dy-10,8,isTurn?'#ffcc00':'#ff6b35');
  // Floor threshold
  R(dx-2,dy+dh-2,dw+4,4,'#444');
}

// --- WARMUP UPDATE SYSTEMS ---

var WARMUP_RIVAL_MSGS=[
  {easy:' warms up with $ lbs \u2014 looks effortless.',hard:' grinds out $ lbs. Heavy.'},
  {easy:' hits $ lbs clean.',hard:' struggles with $ lbs.'},
  {easy:' makes $ lbs look like a toy.',hard:' barely locks out $ lbs.'},
  {easy:' floats $ lbs overhead.',hard:' fights hard for $ lbs.'}
];
var WARMUP_DONE_MSGS=[
  ' finishes warming up. Ready to compete.',
  ' is done warming up. Looks dialed in.',
  ' wraps up warmups. All business now.',
  ' finishes his last warmup. Calm and focused.'
];
var WARMUP_COACH_RIVAL_MSGS=[
  '$ is looking sharp. Don\'t let him get in your head.',
  'Keep an eye on $. He\'s moving well.',
  '$ looks strong today. Focus on YOUR lifts.',
  'Watch $ on the TV. Know your competition.'
];

function buildWarmupCard(){
  // Build a 7-step warmup card based on average rival opener
  var sum=0,cnt=0;
  for(var i=0;i<S.rivals.length;i++){
    if(S.rivals[i].snTargets)sum+=S.rivals[i].snTargets[0];cnt++;
  }
  var target=cnt>0?Math.round(sum/cnt):250;
  var r5=function(v){return Math.round(v/5)*5;};
  return [
    {weight:45,reps:3,label:'Bar work',done:false},
    {weight:r5(target*0.35),reps:2,label:'~35%',done:false},
    {weight:r5(target*0.50),reps:2,label:'~50%',done:false},
    {weight:r5(target*0.65),reps:1,label:'~65%',done:false},
    {weight:r5(target*0.75),reps:1,label:'~75%',done:false},
    {weight:r5(target*0.85),reps:1,label:'~85%',done:false},
    {weight:r5(target*0.92),reps:1,label:'~92%',done:false}
  ];
}

function updateWarmupTimer(){
  if(!S.warmup||S.warmup.expired)return;
  var remaining=S.warmup.startTime+S.warmup.duration-Date.now();
  if(remaining<=0){
    S.warmup.expired=true;
    log('TIME\'S UP! Competition is starting NOW.','phase');
    S.coachBubble={text:'We\'re out of time. Let\'s go!',t:Date.now(),dur:3000};
    // Auto-declare opener if not declared
    if(!S.warmup.openerDeclared){
      var autoW=S.warmup.maxWeight>45?Math.round(S.warmup.maxWeight*1.05/5)*5:
        (S.warmup.card?S.warmup.card[S.warmup.card.length-1].weight:200);
      S.warmup.openerDeclared=autoW;
      log('Coach auto-declares '+autoW+' lbs. No time to discuss.','coach');
    }
    setTimeout(function(){if(S.phase==='warmup')beginCompetition();},1500);
    return;
  }
  // Coach warnings at milestones
  if(remaining<=120000&&!S.warmup.warned2min){
    S.warmup.warned2min=true;
    S.coachBubble={text:'Two minutes. You should be on your last heavy single.',t:Date.now(),dur:4000};
    log('COACH: "Two minutes. Get to your heavy singles."','coach');
  }
  if(remaining<=60000&&!S.warmup.warned1min){
    S.warmup.warned1min=true;
    S.coachBubble={text:'One minute! Wrap it up and declare your opener.',t:Date.now(),dur:4000};
    log('COACH: "One minute! Finish up and declare."','coach');
    S.floats.push({text:'1:00 LEFT',x:W/2,y:100,c:'#ffcc00',sz:18,life:1.0});
  }
  if(remaining<=30000&&!S.warmup.warned30s){
    S.warmup.warned30s=true;
    S.coachBubble={text:'30 seconds! We need to declare NOW.',t:Date.now(),dur:3000};
    log('COACH: "30 seconds! Declare your opener NOW!"','coach');
    S.floats.push({text:'DECLARE NOW!',x:W/2,y:100,c:'#ff4444',sz:20,life:1.0});
  }
}

function updateWarmupRivals(){
  if(!S.warmup||S.phase!=='warmup')return;
  if(Date.now()<S.warmup.nextRivalLift)return;
  // Find a rival who hasn't finished warming up
  var pool=[];
  for(var i=0;i<S.rivals.length;i++){
    if(!S.rivals[i].warmupDone&&S.rivals[i].warmupStep<5)pool.push(S.rivals[i]);
  }
  if(pool.length===0)return;
  var rv=pool[Math.floor(Math.random()*pool.length)];
  var w=rv.warmupPlan[rv.warmupStep];
  var rShort=rv.name.split(' ')[0].toUpperCase();
  // Show on TV
  setTVLifting(rv,w);
  S.tv._warmupReturn='warmup_board';
  // Trigger featured rival visual lift
  if(rv.featured){
    // If rattled, 20% chance they miss
    if(rv.tauntRattled&&Math.random()<0.2){
      rv.featPose='pull';rv.featPoseT=Date.now();rv.featAnimDone=false;rv._liftWeight=w;
      SFX.metalClang();
      setTimeout(function(){
        rv.featPose='idle';rv.featAnimDone=true;rv._liftWeight=0;
        SFX.barDrop();
        if(S.tv&&S.tv.mode==='lifting')setTVResult('no_lift');
        var rn=rv.name.split(' ')[0].toUpperCase();
        log(rn+' MISSES '+w+' lbs! He\'s rattled!','phase');
        S.floats.push({text:'NO LIFT!',x:rv.featX,y:rv.featY-50,c:'#ff4444',sz:16,life:1.0});
      },800);
      rv.tauntRattled=false;// consumed
      rv.warmupStep++;
      S.warmup.nextRivalLift=Date.now()+8000+Math.random()*7000;
      return;// skip normal success flow
    }
    rv.featPose='pull';rv.featPoseT=Date.now();rv.featAnimDone=false;rv._liftWeight=w;
    SFX.metalClang();
  }
  // Log message — easy if early steps, hard if late
  var msgSet=WARMUP_RIVAL_MSGS[Math.floor(Math.random()*WARMUP_RIVAL_MSGS.length)];
  var msg=rv.warmupStep<3?msgSet.easy:msgSet.hard;
  log(rShort+msg.replace('$',w),'phase');
  // Advance step
  rv.warmupStep++;
  // Coach comment (30% chance)
  if(Math.random()<0.3){
    var cmsg=WARMUP_COACH_RIVAL_MSGS[Math.floor(Math.random()*WARMUP_COACH_RIVAL_MSGS.length)];
    S.coachBubble={text:cmsg.replace('$',rShort),t:Date.now(),dur:4000};
  }
  // Mark done if finished last warmup
  if(rv.warmupStep>=5){
    rv.warmupDone=true;
    var doneMsg=WARMUP_DONE_MSGS[Math.floor(Math.random()*WARMUP_DONE_MSGS.length)];
    setTimeout(function(){log(rShort+doneMsg,'phase');},3500);
  }
  // TV result after 2s (warmup lifts always good)
  setTimeout(function(){
    if(S.tv&&S.tv.mode==='lifting')setTVResult('good');
  },2000);
  // Schedule next rival lift
  S.warmup.nextRivalLift=Date.now()+8000+Math.random()*7000;
}

// 1v1 platform warmup: animate rival warming up on platform using r.pose (drawn by drawRival())
function updateRivalWarmupPlatform(){
  if(!is1v1()||S.phase!=='warmup'||!S.warmup)return;
  var r=S.rivals[0];
  if(r.warmupDone||!r.warmupPlan)return;
  if(!S.warmup.nextRivalLift)S.warmup.nextRivalLift=Date.now()+5000+Math.random()*5000;
  if(Date.now()<S.warmup.nextRivalLift)return;
  var step=r.warmupStep||0;
  if(step>=r.warmupPlan.length){r.warmupDone=true;return;}
  var w=r.warmupPlan[step];
  var rShort=r.name.split(' ')[0].toUpperCase();
  // If rattled, 20% chance they miss
  if(r.tauntRattled&&Math.random()<0.2){
    r.pose='pull';r.poseT=0;SFX.metalClang();
    setTimeout(function(){
      r.pose='idle';r.poseT=0;SFX.barDrop();
      log(rShort+' MISSES '+w+' lbs! He\'s rattled!','phase');
      S.floats.push({text:'NO LIFT!',x:r.x,y:280,c:'#ff4444',sz:16,life:1.0});
    },800);
    r.tauntRattled=false;
    r.warmupStep++;
    S.warmup.nextRivalLift=Date.now()+8000+Math.random()*7000;
    return;
  }
  // Normal successful warmup lift
  r.pose='pull';r.poseT=0;SFX.metalClang();
  setTimeout(function(){
    r.pose='overhead';r.poseT=0;
    setTimeout(function(){
      r.pose='idle';r.poseT=0;
    },1200);
  },800);
  // CRITICAL: set nextRivalLift and warmupStep IMMEDIATELY (not inside setTimeout)
  // so the function doesn't re-fire every frame for 2s causing 120+ overlapping sounds
  r.warmupStep++;
  S.warmup.nextRivalLift=Date.now()+8000+Math.random()*7000;
  var msgSet=WARMUP_RIVAL_MSGS[Math.floor(Math.random()*WARMUP_RIVAL_MSGS.length)];
  var msg=step<3?msgSet.easy:msgSet.hard;
  log(rShort+msg.replace('$',w),'phase');
  // Coach comment (30% chance)
  if(Math.random()<0.3){
    var cmsg=WARMUP_COACH_RIVAL_MSGS[Math.floor(Math.random()*WARMUP_COACH_RIVAL_MSGS.length)];
    S.coachMsg=cmsg.replace('$',rShort);
    S.coachBubble=Date.now()+4000;
  }
  if(r.warmupStep>=5){
    r.warmupDone=true;
    var doneMsg=WARMUP_DONE_MSGS[Math.floor(Math.random()*WARMUP_DONE_MSGS.length)];
    setTimeout(function(){log(rShort+doneMsg,'phase');},3500);
  }
}

// --- RANDOM WARMUP EVENTS ---

var WARMUP_EVENTS=[
  {id:'bar_drop',fn:function(){
    log('A bar CRASHES nearby. The whole room flinches.','phase');
    S.nervousness=Math.min(100,(S.nervousness||0)+3);
    S.screenShake=2;SFX.metalClang();SFX.barDrop();
    S.floats.push({text:'+3 NERV',x:S.tX+30,y:180,c:'#ff4444',sz:11,life:1.0});
  }},
  {id:'crowd',fn:function(){
    log('The crowd is filing into the stands. Getting real now.','rest');
    log('You can hear the buzz through the walls.','rest');
    if(S.humiliated>0){
      var crowdHum=pick([
        'You overhear someone: "That\'s the beach guy, right?"',
        'A voice from the stands: "Didn\'t he lose at Muscle Beach?"',
        'Someone laughs in the crowd. Tark pretends not to notice.',
        'You catch two guys pointing at you. They saw what happened.'
      ]);
      log(crowdHum,'fail');
      S.nervousness=clamp(S.nervousness+2,0,100);
    }
  }},
  {id:'announcer',fn:function(){
    var rivalsLeft=0;
    for(var i=0;i<S.rivals.length;i++){if(!S.rivals[i].warmupDone)rivalsLeft++;}
    var mins=Math.max(1,rivalsLeft*2);
    log('ANNOUNCER: "Snatches begin in approximately '+mins+' minutes."','phase');
    S.floats.push({text:'~'+mins+' MIN',x:W/2,y:120,c:'#ffcc00',sz:16,life:1.0});
    S.warmup.announcements++;
  }},
  {id:'staredown',fn:function(){
    var rv=S.rivals[Math.floor(Math.random()*S.rivals.length)];
    var rShort=rv.name.split(' ')[0].toUpperCase();
    if(S.humiliated>0&&Math.random()<0.5){
      var humStare=pick([
        rShort+' smirks at Tark. "Heard about the beach. Tough break."',
        rShort+' walks past. "Hey, aren\'t you the beach guy?" He laughs.',
        rShort+' gives Tark a look. The kind that says "I heard."'
      ]);
      log(humStare,'fail');
      S.nervousness=Math.min(100,(S.nervousness||0)+8);
      S.focus=Math.max(0,Math.min(100,S.focus-5));
      S.floats.push({text:'+8 NERV',x:S.tX+30,y:180,c:'#ff4444',sz:11,life:1.0});
      S.floats.push({text:'-5 FOC',x:S.tX+30,y:200,c:'#cc88ff',sz:11,life:1.0});
      S.coachBubble={text:'Block it out. Prove them all wrong.',t:Date.now(),dur:3500};
    }else{
      log(rShort+' walks past and locks eyes with Tark.','phase');
      S.nervousness=Math.min(100,(S.nervousness||0)+5);
      S.focus=Math.max(0,Math.min(100,S.focus-3));
      S.floats.push({text:'+5 NERV',x:S.tX+30,y:180,c:'#ff4444',sz:11,life:1.0});
      S.floats.push({text:'-3 FOC',x:S.tX+30,y:200,c:'#cc88ff',sz:11,life:1.0});
      S.coachBubble={text:'Ignore him. Eyes on your own bar.',t:Date.now(),dur:3500};
    }
  }},
  {id:'free_chalk',fn:function(){
    log('A fellow lifter offers Tark some chalk. Nice gesture.','chalk');
    S.grip=Math.max(0,Math.min(100,S.grip+10));
    S.floats.push({text:'+10 GRIP',x:S.tX,y:180,c:'#ffffff',sz:14,life:1.0});
  }},
  {id:'coach_intel',fn:function(){
    // Find a rival who's done a few warmup lifts
    var best=null;
    for(var i=0;i<S.rivals.length;i++){
      var rv=S.rivals[i];
      if(rv.warmupStep>2&&(!best||rv.warmupStep>best.warmupStep))best=rv;
    }
    if(!best)best=S.rivals[0];
    var rShort=best.name.split(' ')[0];
    var lastW=best.warmupPlan[Math.min(best.warmupStep-1,4)]||0;
    var est=best.snTargets?best.snTargets[0]:lastW+20;
    S.coachBubble={text:rShort+'\'s last warmup was '+lastW+'. I think he opens around '+est+'.',t:Date.now(),dur:5000};
    log('COACH: "'+rShort+' is probably opening around '+est+' lbs."','phase');
  }},
  {id:'equipment_check',fn:function(){
    log('An official checks Tark\'s belt and singlet. All clear.','rest');
    log('"Good luck out there," he nods.','rest');
  }},
  {id:'rival_miss',fn:function(){
    var pool=[];
    for(var i=0;i<S.rivals.length;i++){if(S.rivals[i].warmupStep>=3&&!S.rivals[i].warmupDone)pool.push(S.rivals[i]);}
    if(pool.length===0){for(var i=0;i<S.rivals.length;i++){if(S.rivals[i].warmupStep>=2)pool.push(S.rivals[i]);}}
    if(pool.length===0)return;
    var rv=pool[Math.floor(Math.random()*pool.length)];
    var rShort=rv.name.split(' ')[0].toUpperCase();
    var w=rv.warmupPlan[Math.min(rv.warmupStep,4)];
    log(rShort+' MISSES a warmup rep at '+w+'! His coach looks worried.','fail');
    setTVLifting(rv,w);
    S.tv._warmupReturn='warmup_board';
    setTimeout(function(){if(S.tv&&S.tv.mode==='lifting')setTVResult('no_lift');},1500);
    SFX.barDrop();
  }}
];

// Events safe for 1v1 platform (no backroom-specific sounds/visuals)
var PLATFORM_SAFE_EVENTS=['announcer','free_chalk','coach_intel','equipment_check'];

function updateWarmupEvents(){
  if(!S.warmup||S.phase!=='warmup')return;
  if(Date.now()<S.warmup.nextEvent)return;
  var on1v1Plat=is1v1()&&S.scene==='platform';
  // Find unfired events
  var avail=[];
  for(var i=0;i<WARMUP_EVENTS.length;i++){
    if(S.warmup.firedEvents.indexOf(WARMUP_EVENTS[i].id)===-1){
      // Skip backroom-only events on 1v1 platform
      if(on1v1Plat&&PLATFORM_SAFE_EVENTS.indexOf(WARMUP_EVENTS[i].id)===-1)continue;
      avail.push(WARMUP_EVENTS[i]);
    }
  }
  if(avail.length<=1)return;
  var evt=avail[Math.floor(Math.random()*avail.length)];
  S.warmup.firedEvents.push(evt.id);
  try{evt.fn();}catch(e){}
  S.warmup.nextEvent=Date.now()+15000+Math.random()*15000;
}

// --- COACH WARMUP SUGGESTIONS ---

function getCoachWarmupSuggestion(){
  if(!S.warmup)return{weight:45,message:'Start with the bar. Get loose.'};
  var card=S.warmup.card;
  var step=S.warmup.cardStep;
  var lifts=S.warmup.lifts;
  // If last rep was sloppy at a heavy weight, suggest repeating
  if(S.warmup.lastSloppyWeight>0&&lifts>0){
    var sw=S.warmup.lastSloppyWeight;
    S.warmup.lastSloppyWeight=0;
    return{weight:sw,message:'That was sloppy. Hit '+sw+' again and nail the technique.'};
  }
  // Card-based suggestions
  if(!card||card.length===0)return{weight:45,message:'Start with the bar. Get loose.'};
  if(step>=card.length){
    // Card complete — suggest declaring opener
    var lastW=card[card.length-1].weight;
    var openerSug=Math.round(lastW*1.08/5)*5;
    return{weight:openerSug,message:'Card\'s done. I\'d open at '+openerSug+'. Declare when you\'re ready.'};
  }
  var cur=card[step];
  // First lift
  if(lifts===0)return{weight:cur.weight,message:'Start with the bar. '+cur.reps+(cur.reps>1?' reps':' rep')+'. Get loose.'};
  // Low readiness — stay light
  if(S.readiness<25&&step>0)return{weight:card[Math.max(0,step-1)].weight,
    message:'Stay light. You\'re not warm yet.'};
  // Time pressure — under 1 min, push to finish card
  var remaining=S.warmup.startTime+S.warmup.duration-Date.now();
  if(remaining<60000&&step<card.length-1){
    return{weight:cur.weight,message:'Clock\'s ticking. '+cur.weight+' for a single. Move.'};
  }
  // All rivals done? Add urgency
  var allDone=true;
  for(var i=0;i<S.rivals.length;i++){if(!S.rivals[i].warmupDone)allDone=false;}
  if(allDone&&step>=3)return{weight:cur.weight,
    message:'Everyone\'s ready. '+cur.weight+' next — don\'t fall behind.'};
  // Warm enough — don't burn out
  if(S.readiness>60&&step>=card.length-2)return{weight:cur.weight,
    message:'You\'re warm. '+cur.weight+' for a single — save it for the platform.'};
  // Normal card progression
  var repStr=cur.reps>1?cur.reps+' reps':'a single';
  var msgs=[
    'Next up: '+cur.weight+' for '+repStr+'. '+cur.label+'.',
    'Good. '+cur.weight+' next, '+repStr+'. '+cur.label+'.',
    'Looking smooth. '+cur.weight+' for '+repStr+'.',
    'Solid. Move up to '+cur.weight+'. '+repStr+'.'
  ];
  return{weight:cur.weight,message:msgs[Math.floor(Math.random()*msgs.length)]};
}

// --- STRETCHING ACTION ---

function drawBackroomTV(){
  var L=LAYOUT.backroom;
  var tx=L.tvX,ty=L.tvY,tw=L.tvW,th=L.tvH;
  // TV bezel (outer frame)
  R(tx-5,ty-5,tw+10,th+10,'#1a1a1a');
  R(tx-3,ty-3,tw+6,th+6,'#2a2a2a');
  // Screen background
  R(tx,ty,tw,th,'#0a0a0a');
  // TV content
  updateTV();
  if(!S.tv||S.tv.mode==='off'){
    // Standby screen
    var label=S.phase==='warmup'?'WARMING UP':S.phase==='rest_sn_cj'?'REST PERIOD':'COMPETITION';
    T(label,tx+tw/2,ty+th/2-5,11,'#2a2a2a');
  }else if(S.tv.mode==='lifting'||S.tv.mode==='result'){
    // Live lift feed — clip to TV screen
    cx.save();
    cx.beginPath();cx.rect(tx,ty,tw,th);cx.clip();
    // Mini venue background
    R(tx,ty,tw,th,'#111');
    // Mini crowd silhouette
    cx.globalAlpha=0.3;
    for(var ci=0;ci<tw;ci+=12){
      var ch=6+Math.sin(ci*0.5)*3;
      C(tx+ci+6,ty+th-28+ch,4,'#1a1a1a');
    }
    cx.globalAlpha=1;
    // Mini floor
    R(tx,ty+th-22,tw,22,'#1a1a1a');
    R(tx,ty+th-24,tw,3,'#181818');
    // Mini platform
    R(tx+tw/2-50,ty+th-26,100,4,'#2a2a2a');
    // Mini rival figure
    var rx=tx+tw/2,ry=ty+th-58;
    var mr=S.tv.miniRival||{};
    drawMiniRivalOnTV(rx,ry,mr.singlet||'#333',mr.skin||'#c8a882',mr.hair||'#111',S.tv.miniPose);
    // Header bar: NOW LIFTING
    R(tx,ty,tw,20,'rgba(0,0,0,0.75)');
    var hdr=S.tv.lifterName+' \u2014 '+S.tv.weight+' LBS';
    T(hdr,tx+tw/2,ty+13,9,'#ff6b35');
    // Result overlay
    if(S.tv.mode==='result'){
      var rc=S.tv.result==='good'?'#7fdb6a':'#ff4444';
      var rt=S.tv.result==='good'?'GOOD LIFT':'NO LIFT';
      R(tx,ty+th/2-16,tw,28,'rgba(0,0,0,0.85)');
      T(rt,tx+tw/2,ty+th/2+2,14,rc);
    }
    cx.restore();
  }else if(S.tv.mode==='leaderboard'){
    // Show standings on TV
    cx.save();
    cx.beginPath();cx.rect(tx,ty,tw,th);cx.clip();
    R(tx,ty,tw,th,'#0a0a0a');
    T('STANDINGS',tx+tw/2,ty+16,10,'#8b7340');
    var sts=typeof getStandings==='function'?getStandings():[];
    for(var si=0;si<sts.length&&si<8;si++){
      var se=sts[si];
      var sry=ty+28+si*16;
      var sc=se.isTark?'#ff6b35':se.id===S.rival.id?'#7fdb6a':'#888';
      var medal=si===0?'\uD83E\uDD47':si===1?'\uD83E\uDD48':si===2?'\uD83E\uDD49':'';
      T(medal+(si+1)+'.',tx+20,sry+10,8,sc,'right');
      T(se.name,tx+28,sry+10,8,sc,'left');
      T(se.total>0?se.total+'':'---',tx+tw-10,sry+10,9,sc,'right');
    }
    cx.restore();
  }else if(S.tv.mode==='warmup_board'){
    // Warmup status board — show all rivals and their warmup progress
    cx.save();
    cx.beginPath();cx.rect(tx,ty,tw,th);cx.clip();
    R(tx,ty,tw,th,'#0a0a0a');
    T('WARM-UP ROOM',tx+tw/2,ty+14,9,'#8b7340');
    var rivalsReady=0;
    for(var wi=0;wi<S.rivals.length&&wi<6;wi++){
      var wr=S.rivals[wi];
      var wry=ty+24+wi*20;
      var wShort=wr.name.split(' ')[0];
      var wFlag=wr.flag||'';
      var wDone=wr.warmupDone;
      var wStep=wr.warmupStep||0;
      if(wDone)rivalsReady++;
      // Name + flag
      T(wFlag+' '+wShort,tx+8,wry+10,7,wDone?'#7fdb6a':'#888','left');
      // Progress blocks (5 total)
      for(var wb=0;wb<5;wb++){
        var bx=tx+tw-70+wb*10;
        R(bx,wry+3,8,8,wb<wStep?(wDone?'#7fdb6a':'#ffcc00'):'#222');
      }
      // Weight or READY
      if(wDone){T('RDY',tx+tw-8,wry+10,7,'#7fdb6a','right');}
      else if(wStep>0){T(wr.warmupPlan[wStep-1]+'',tx+tw-8,wry+10,7,'#aaa','right');}
    }
    // Bottom: countdown timer
    var totalR=S.rivals.length;
    if(S.warmup){
      var tvRem=Math.max(0,S.warmup.startTime+S.warmup.duration-Date.now());
      var tvMin=Math.floor(tvRem/60000);
      var tvSec=Math.floor((tvRem%60000)/1000);
      var tvCol=tvRem<=60000?'#ff4444':'#ffcc00';
      T('SNATCHES IN '+tvMin+':'+(tvSec<10?'0':'')+tvSec,tx+tw/2,ty+th-8,8,tvCol);
    }else{
      T(rivalsReady+'/'+totalR+' READY',tx+tw/2,ty+th-8,8,rivalsReady>=totalR?'#7fdb6a':'#ffcc00');
    }
    cx.restore();
  }
  // Scan lines overlay (all modes)
  cx.globalAlpha=0.03;
  for(var sli=ty;sli<ty+th;sli+=2)R(tx,sli,tw,1,'#fff');
  cx.globalAlpha=1;
  // Screen reflection highlight
  cx.globalAlpha=0.04;R(tx,ty,tw,th/4,'#fff');cx.globalAlpha=1;
  // Wall mount bracket
  R(tx+tw/2-20,ty-9,40,5,'#444');
  R(tx+tw/2-8,ty-12,16,4,'#333');
}

function drawMiniRivalOnTV(x,y,singlet,skin,hair,pose){
  // Simplified rival figure for TV display (~50% scale)
  if(pose==='pull'){
    // Bent over pulling
    R(x-4,y+14,4,14,singlet);R(x+0,y+14,4,14,singlet);
    R(x-5,y+28,6,3,'#111');R(x-1,y+28,6,3,'#111');
    R(x-6,y-3,12,19,singlet);
    R(x-9,y+8,4,10,skin);R(x+5,y+8,4,10,skin);
    C(x,y-8,5,skin);R(x-4,y-14,8,4,hair);
    // Barbell at knee level
    R(x-22,y+14,44,2,'#888');
    R(x-24,y+10,6,10,'#cc2222');R(x+18,y+10,6,10,'#cc2222');
  }else if(pose==='overhead'||pose==='jerk'){
    // Standing, arms up
    R(x-4,y+14,4,16,singlet);R(x+0,y+14,4,16,singlet);
    R(x-5,y+30,6,3,'#111');R(x-1,y+30,6,3,'#111');
    R(x-6,y-3,12,19,singlet);
    R(x-8,y-20,4,18,skin);R(x+4,y-20,4,18,skin);
    C(x,y-8,5,skin);R(x-4,y-14,8,4,hair);
    // Barbell overhead
    R(x-22,y-26,44,2,'#888');
    R(x-24,y-30,6,10,'#cc2222');R(x+18,y-30,6,10,'#cc2222');
  }else if(pose==='clean_hold'){
    // Standing, barbell at chest
    R(x-4,y+14,4,16,singlet);R(x+0,y+14,4,16,singlet);
    R(x-5,y+30,6,3,'#111');R(x-1,y+30,6,3,'#111');
    R(x-6,y-3,12,19,singlet);
    R(x-8,y-3,4,12,skin);R(x+4,y-3,4,12,skin);
    C(x,y-8,5,skin);R(x-4,y-14,8,4,hair);
    // Barbell at chest
    R(x-22,y-1,44,2,'#888');
    R(x-24,y-5,6,10,'#cc2222');R(x+18,y-5,6,10,'#cc2222');
  }else if(pose==='failed'){
    // Collapsed forward
    R(x-4,y+18,4,12,singlet);R(x+0,y+18,4,12,singlet);
    R(x-5,y+30,6,3,'#111');R(x-1,y+30,6,3,'#111');
    R(x-6,y+2,12,18,singlet);
    R(x+2,y-3,4,8,skin);
    C(x+2,y-4,5,skin);R(x-1,y-10,8,4,hair);
    // Dropped barbell
    R(x-20,y+26,40,2,'#888');
    R(x-22,y+22,6,10,'#cc2222');R(x+16,y+22,6,10,'#cc2222');
  }else{
    // Idle / default
    R(x-4,y+14,4,16,singlet);R(x+0,y+14,4,16,singlet);
    R(x-5,y+30,6,3,'#111');R(x-1,y+30,6,3,'#111');
    R(x-6,y-3,12,19,singlet);
    R(x-8,y-1,4,14,skin);R(x+4,y-1,4,14,skin);
    C(x,y-8,5,skin);R(x-4,y-14,8,4,hair);
  }
}

function setTVLifting(rivalObj,weight){
  S.tv.mode='lifting';
  S.tv.lifterName=rivalObj.name||'RIVAL';
  S.tv.weight=weight;
  S.tv.miniRival={skin:rivalObj.skin,hair:rivalObj.hair,singlet:rivalObj.singlet};
  S.tv.miniPose='pull';
  S.tv.miniPoseT=0;
  S.tv.result=null;
  S.tv.resultTimer=0;
}

function setTVResult(result){
  S.tv.mode='result';
  S.tv.result=result;
  S.tv.resultTimer=0;
}

function setTVLeaderboard(){
  S.tv.mode='leaderboard';
}

function updateTV(){
  if(!S.tv)return;
  S.tv.miniPoseT++;
  // Mirror current rival pose to TV when lifting
  if(S.tv.mode==='lifting'&&S.rival&&S.rival.pose){
    S.tv.miniPose=S.rival.pose;
  }
  if(S.tv.mode==='result'){
    S.tv.resultTimer++;
    if(S.tv.resultTimer>120){
      // Return to warmup board if we came from warmup, otherwise off
      S.tv.mode=S.tv._warmupReturn||'off';
      S.tv._warmupReturn=null;
    }
  }
}
window.setTVLifting=setTVLifting;
window.setTVResult=setTVResult;
window.setTVLeaderboard=setTVLeaderboard;

function drawCoachNPC(x,y){
  // Subtle idle sway
  var sway=Math.sin(Date.now()/1200)*1.2;
  x+=sway;
  // Legs — dark pants
  R(x-7,y+24,6,26,'#2a2a3a');R(x+1,y+24,6,26,'#2a2a3a');
  // Shoes
  R(x-8,y+50,8,4,'#111');R(x,y+50,8,4,'#111');
  // Body — stocky torso, dark green jacket
  R(x-12,y-2,24,28,'#1a3a1a');
  // White shirt
  R(x-5,y+2,10,10,'#c8c8b8');
  // Jacket lapels
  R(x-12,y-2,5,18,'#153015');R(x+7,y-2,5,18,'#153015');
  // Arms
  R(x-16,y+0,5,20,'#1a3a1a');R(x+11,y+0,5,20,'#1a3a1a');
  // Clipboard in right hand
  R(x+12,y+14,9,12,'#8b6914');R(x+13,y+15,7,10,'#f0e8d4');
  // Head
  C(x,y-10,9,'#c89070');
  // Short cropped grey hair — thin strip on top of head
  R(x-8,y-19,16,5,'#999');
  // Eyes
  R(x-4,y-12,3,2,'#111');R(x+1,y-12,3,2,'#111');
  // Mouth
  R(x-3,y-6,6,1,'#8a6040');
  // Whistle
  C(x+3,y+3,2,'#aaa');R(x+2,y-4,1,7,'#888');
  // Label
  T('COACH',x,y+62,8,'#888');
}

function drawCoachSpeechBubble(x,y,text){
  if(!text)return;
  cx.font='8px Courier New';
  var lines=[];
  var words=text.split(' ');
  var line='';
  for(var i=0;i<words.length;i++){
    var test=line+(line?' ':'')+words[i];
    if(cx.measureText(test).width>120&&line){lines.push(line);line=words[i];}
    else line=test;
  }
  if(line)lines.push(line);
  var lh=11,pad=6;
  var bw=130,bh=lines.length*lh+pad*2;
  var bx=x-bw/2,by=y-bh-8;
  // Bubble background — white with black text
  R(bx,by,bw,bh,'rgba(255,255,255,0.95)');
  cx.strokeStyle='#999';cx.lineWidth=1;cx.strokeRect(bx,by,bw,bh);
  // Tail triangle
  cx.fillStyle='rgba(255,255,255,0.95)';
  cx.beginPath();cx.moveTo(x-5,by+bh);cx.lineTo(x+5,by+bh);cx.lineTo(x,by+bh+6);cx.fill();
  // Text
  for(var j=0;j<lines.length;j++){
    T(lines[j],x,by+pad+j*lh+8,8,'#222');
  }
}

// Universal white speech bubble — works at any position, any phase
function drawWhiteBubble(x,y,text,fontSize){
  if(!text)return;
  fontSize=fontSize||10;
  cx.font=fontSize+'px Courier New';
  var tw=cx.measureText(text).width+20;
  var bx=x-tw/2,by=y-14;
  // White rounded rect
  cx.fillStyle='#fff';cx.strokeStyle='#333';cx.lineWidth=2;
  cx.beginPath();cx.moveTo(bx+6,by);cx.lineTo(bx+tw-6,by);cx.quadraticCurveTo(bx+tw,by,bx+tw,by+6);
  cx.lineTo(bx+tw,by+22);cx.quadraticCurveTo(bx+tw,by+28,bx+tw-6,by+28);
  cx.lineTo(bx+6,by+28);cx.quadraticCurveTo(bx,by+28,bx,by+22);
  cx.lineTo(bx,by+6);cx.quadraticCurveTo(bx,by,bx+6,by);cx.closePath();
  cx.fill();cx.stroke();
  // Tail
  cx.fillStyle='#fff';cx.beginPath();cx.moveTo(x-5,by+28);cx.lineTo(x,by+36);cx.lineTo(x+5,by+28);cx.closePath();cx.fill();
  cx.strokeStyle='#333';cx.beginPath();cx.moveTo(x-5,by+28);cx.lineTo(x,by+36);cx.stroke();
  cx.beginPath();cx.moveTo(x,by+36);cx.lineTo(x+5,by+28);cx.stroke();
  // Text
  T(text,x,by+18,fontSize,'#111');
}

// Render S.speechBubble overlay (called at end of every draw frame)
function drawSpeechBubbleOverlay(){
  if(!S||!S.speechBubble||S.speechBubble.life<=0)return;
  var sb=S.speechBubble;
  sb.life-=0.008;
  cx.globalAlpha=Math.min(1,sb.life*2);
  drawWhiteBubble(sb.x,sb.y,sb.text,sb.fontSize||11);
  cx.globalAlpha=1;
  if(sb.life<=0)S.speechBubble=null;
}

// === THOUGHT BUBBLE NARRATION SYSTEM ===

function narrate(lines,x,y){
  if(typeof lines==='string')lines=[lines];
  var dur=180+lines.length*60; // ~3s base + 1s per line
  S.thought={lines:lines,x:x||450,y:y||100,life:dur,maxLife:dur};
}
window.narrate=narrate;

function narrateScene(){
  var p=S.phase,b=S.beach,d=S.downtown;
  // Beach bathroom exterior
  if(p==='beach'&&b&&b.subMenu==='bathroom'){
    var lines=['Four stalls. Left and right are occupied \u2014','feet under the doors. Middle one\'s open.'];
    if(b.middleFlooded)lines=['Middle stall flooded.'];
    if(!b.rightStallOccupied&&!b.middleFlooded)lines.push('Right stall\'s empty now too.');
    if(b.doorCracked)lines.push('The last door\'s been smashed open.');
    else lines.push('Last one says OUT OF ORDER.');
    if(!b.fountainDrunk&&b.fountainKicks<7)lines.push('Drinking fountain off to the side.');
    narrate(lines,450,60);return;
  }
  if(p==='beach'&&b&&b.subMenu==='middle_stall'){
    if(b.middleFlooded)narrate(['Flooded. Water everywhere.','Better get out of here.'],250,60);
    else narrate(['A toilet. Not clean.','Bet I could flush it... a few times.'],250,60);
    return;
  }
  if(p==='beach'&&b&&b.subMenu==='right_stall'){
    var rl=['Smells terrible in here.'];
    if(b.rightPaperPulls<12)rl.push('Paper towel dispenser on the left.');
    if(b.rightPaperEmpty&&!b.hasPaper)rl.push('Pile of paper on the floor. Could grab that.');
    if(b.hasPaper&&!b.toiletStuffed)rl.push('Got paper. That toilet looks like it needs stuffing.');
    rl.push('Gross clogged toilet on the right.');
    narrate(rl,420,60);return;
  }
  if(p==='beach'&&b&&b.subMenu==='stall'){
    if(!b.holeExamined)narrate(['No toilet. Just a hole in the floor.','Dark down there.'],450,60);
    else narrate(['That hole goes somewhere.','Deep.'],450,60);
    return;
  }
  if(p==='beach'&&b&&b.subMenu==='sewer'){
    narrate(['The sewer. Three tunnels.','Green glow left. Warm light center. Steam right.'],450,60);return;
  }
  if(p==='beach'&&b&&b.subMenu==='sewer_left'){
    narrate(['Green glow. Something\'s alive down here.'],450,60);return;
  }
  if(p==='beach'&&b&&b.subMenu==='sewer_center'){
    narrate(['Warm light ahead. Doesn\'t feel like a sewer anymore.'],450,60);return;
  }
  if(p==='beach'&&b&&b.subMenu==='sewer_right'){
    narrate(['Steam and heat. Pipes hissing.','Dangerous.'],450,60);return;
  }
  if(p==='beach'&&b&&b.subMenu==='boardwalk'){
    narrate(['The boardwalk. Busy.','Gonna have to push through.'],450,60);return;
  }
  if(p==='beach'&&b&&b.subMenu==='couple'){
    narrate(['Couple on the beach.','Could mess with them.'],450,60);return;
  }
  if(p==='beach'&&(!b||!b.subMenu)){
    narrate(['Venice Beach.','Couples everywhere. Boardwalk up ahead.','Bathroom building on the right.'],450,60);return;
  }
  if(p==='downtown'&&d&&d.subMenu==='bar'){
    narrate(['The Dive. Old beer and bad decisions.','Pool table in the back. Jukebox. Dartboard.'],450,60);return;
  }
  if(p==='downtown'&&d&&d.subMenu==='bodega'){
    narrate(['Bodega. Fluorescent lights buzzing.','Snacks, drinks, lottery tickets. Cat on the counter.'],450,60);return;
  }
  if(p==='downtown'&&d&&d.subMenu==='hotel'){
    narrate(['Hotel lobby. Seen better days.','Elevator, staircase, reception desk.'],450,60);return;
  }
  if(p==='downtown'&&d&&d.subMenu==='ma_house'){
    narrate(["Ma's house. Same dump since I was a kid.","Front door's open. It's always open."],450,60);return;
  }
  if(p==='downtown'&&d&&d.subMenu==='ma_living'){
    var _nq=d.maQuest;
    if(_nq.complete){narrate(["Living room. Ma's gone. Couch is still warm."],450,60);return;}
    if(_nq.started){
      var _tasks=[];
      if(!_nq.stoveOff)_tasks.push('Stove is still on.');
      if(!_nq.dressGot)_tasks.push('Dress is in the washer downstairs.');
      if(!_nq.pillsGot)_tasks.push('Pills still needed.');
      if(_nq.purseUnlocked&&!_nq.purseFound)_tasks.push("Purse is MIA.");
      _tasks.unshift("Ma's waiting. Still gotta:");
      narrate(_tasks,450,60);return;
    }
    narrate(["Living room. Ma's on the couch.","Talk to her. She's been waiting."],450,60);return;
  }
  if(p==='downtown'&&d&&d.subMenu==='ma_kitchen'){
    var _nqk=d.maQuest;
    var kLines=["Kitchen. Hasn't changed since '94."];
    if(_nqk.started&&!_nqk.stoveOff)kLines.push('Stove is on. Burner glowing.');
    if(_nqk.started&&!_nqk.pillNoteRead)kLines.push("There's a note on the fridge.");
    if(!_nqk.started)kLines.push("Fridge is humming. Sink's dripping.");
    narrate(kLines,450,60);return;
  }
  if(p==='downtown'&&d&&d.subMenu==='ma_upstairs'){
    narrate(['Upstairs hallway. Three doors.','My room. Her room. Bathroom.','Bulb still flickers. Classic.'],450,60);return;
  }
  if(p==='downtown'&&d&&d.subMenu==='ma_basement'){
    var _nqb=d.maQuest;
    if(_nqb.started&&!_nqb.dressGot){narrate(['The basement. Cold.','Washer has Ma\'s dress trapped in it.','Looks jammed. Might need a kick.'],450,60);return;}
    narrate(['The basement. Cold.','Washer\'s been broken since Clinton.','Boxes of stuff nobody needs.'],450,60);return;
  }
  if(p==='downtown'&&d&&d.subMenu==='ma_tark_room'){
    narrate(['My old room. Arnold poster still up.','Trophies collecting dust.','Mattress on the floor. Some things never change.'],450,60);return;
  }
  if(p==='downtown'&&d&&d.subMenu==='ma_ma_room'){
    var _nqm=d.maQuest;
    if(_nqm.started&&!_nqm.pillsGot){narrate(["Ma's room. Smells like lavender and Vicks.","Medicine bottles on the nightstand.","Which ones does she take?"],450,60);return;}
    narrate(["Ma's room. Smells like lavender and Vicks.","Rocking chair. Medicine bottles.","She's had that quilt since forever."],450,60);return;
  }
  if(p==='downtown'&&d&&d.subMenu==='ma_bath'){
    narrate(['Upstairs bathroom. Mildew central.','Claw-foot tub. Rubber duck.','Faucet drips. Mirror cracked.'],450,60);return;
  }
  if(p==='downtown'&&(!d||!d.subMenu)){
    narrate(S.apartment&&S.apartment.motherMission?['Downtown. The usual spots.','Bar, bodega, hotel. Ma\'s house down the street.']:['Downtown. Three buildings.','A dive bar, a bodega, and a hotel.'],450,60);return;
  }
  if(p==='apartment'&&S.apartment.subMenu==='phone'){
    narrate(['The Rolodex. Who to call?','Gym. Coach. Mother.'],450,60);return;
  }
  if(p==='apartment'){
    narrate(['Home. The essentials:','Fridge. Shower. Wardrobe. TV. Phone.'],450,60);return;
  }
  if(p==='gym'){
    narrate(['The gym. Rack on the right, bench on the left.','Time to train.'],450,60);return;
  }
}
window.narrateScene=narrateScene;

function drawThoughtBubble(){
  if(!S||!S.thought)return;
  var th=S.thought;
  // Tick life counter
  th.life--;
  if(th.life<=0){S.thought=null;return;}
  // Fade: full opacity for most of life, fade out in last 40 frames
  var fade=th.life<40?th.life/40:1;
  var lines=th.lines;
  var fontSize=10;
  var lineH=15;
  var pad=6;
  var barH=lines.length*lineH+pad*2;
  cx.globalAlpha=fade;
  // Dark semi-transparent bar across full width
  R(0,0,W,barH,'rgba(0,0,0,0.75)');
  // Bottom edge line
  R(0,barH-1,W,1,'rgba(255,180,50,0.6)');
  // Text lines — centered, warm white
  cx.font=fontSize+'px Courier New';cx.textAlign='center';
  for(var j=0;j<lines.length;j++){
    cx.fillStyle='#e8dcc8';
    cx.fillText(lines[j],W/2,pad+j*lineH+12);
  }
  cx.textAlign='center';cx.globalAlpha=1;
}

function drawHelpButton(){
  if(!S||S.thought)return;
  var p=S.phase;
  if(p==='snatch'||p==='cj'||p==='rest_sn_cj'||p==='results'||p==='warmup'||p==='intro'||p==='mode_select'||p==='roster_pick')return;
  var hx=W-22,hy=16,hr=12;
  var hov=(mouseX>=hx-hr&&mouseX<=hx+hr&&mouseY>=hy-hr&&mouseY<=hy+hr);
  cx.globalAlpha=hov?0.9:0.5;
  C(hx,hy,hr,hov?'#ff6b35':'#555');
  T('?',hx,hy+5,14,'#fff');
  cx.globalAlpha=1;
}

// === MAP NAVIGATION SYSTEM ===
function drawMapIcon(){
if(!S||S.mapOpen)return;
var p=S.phase;
if(p!=='apartment'&&p!=='beach'&&p!=='downtown'&&p!=='gym')return;
if(S.busy||S.sceneTransition)return;
if(p==='apartment'&&S.apartment.subMenu&&S.apartment.subMenu!=='door')return;
if(p==='downtown'&&S.downtown.subMenu&&S.downtown.subMenu!=='ma_house')return;
if(p==='beach'&&(S.beach.subMenu||(S.beach.gymComp&&S.beach.gymComp.active)))return;
if(S.miniGame&&S.miniGame.active)return;
var hov=(hover==='mapBtn');
cx.globalAlpha=hov?0.95:0.55;
// Folded map icon
R(6,36,24,20,hov?'#ff6b35':'#a09080');
cx.strokeStyle=hov?'#cc5020':'#706050';cx.lineWidth=1;
cx.beginPath();cx.moveTo(18,36);cx.lineTo(18,56);cx.stroke();
cx.beginPath();cx.moveTo(6,46);cx.lineTo(30,46);cx.stroke();
// Dots on the map (locations)
C(11,41,1.5,hov?'#fff':'#555');C(24,41,1.5,hov?'#fff':'#555');
C(14,51,1.5,hov?'#fff':'#555');C(22,51,1.5,hov?'#fff':'#555');
T('MAP',18,66,6,hov?'#ff6b35':'#888');
cx.globalAlpha=1;
}

// --- MAP DATA ---
var MAP_LOCATIONS=[
{id:'beach',label:'VENICE BEACH',x:60,y:70,w:130,h:90,zone:'mapBeach'},
{id:'apartment',label:"TARK'S APT",x:260,y:55,w:140,h:90,zone:'mapApartment'},
{id:'gym',label:'THE GYM',x:320,y:260,w:150,h:90,zone:'mapGym'},
{id:'downtown',label:'DOWNTOWN',x:600,y:55,w:160,h:110,zone:'mapDowntown'},
{id:'ma_house',label:"MA'S HOUSE",x:610,y:310,w:130,h:90,zone:'mapMaHouse'}
];
var MAP_STREETS=[
{name:'VENICE BLVD',x1:50,y1:220,x2:860,y2:220,w:22,major:true,horiz:true},
{name:'PACIFIC AVE',x1:210,y1:25,x2:210,y2:455,w:18,major:true,horiz:false},
{name:'LINCOLN BLVD',x1:550,y1:25,x2:550,y2:455,w:18,major:true,horiz:false},
{name:'',x1:560,y1:310,x2:660,y2:370,w:12,major:false,horiz:false},
{name:'',x1:50,y1:155,x2:210,y2:155,w:12,major:false,horiz:true},
{name:'',x1:210,y1:100,x2:550,y2:100,w:12,major:false,horiz:true},
{name:'',x1:550,y1:140,x2:860,y2:140,w:12,major:false,horiz:true}
];

// --- MAP LOCATION DRAW FUNCTIONS ---
function drawMapBeachLoc(x,y,w,h,cur,hov,lock){
// Sandy boardwalk area
R(x+5,y+5,w-10,h-10,'#c4a876');
// Boardwalk planks
for(var bp=0;bp<6;bp++){R(x+10,y+12+bp*12,w-20,2,'#8a7050');}
// Waves on left edge
cx.strokeStyle='#4488aa';cx.lineWidth=1.2;
var wt=Date.now()/1200;
for(var wv=0;wv<3;wv++){
cx.beginPath();
var wy=y+20+wv*22;
cx.moveTo(x+5,wy);cx.quadraticCurveTo(x+20,wy-6+Math.sin(wt+wv)*3,x+35,wy);cx.quadraticCurveTo(x+50,wy+6+Math.sin(wt+wv+1)*3,x+65,wy);
cx.stroke();
}
// Palm tree
var sway=Math.sin(Date.now()/1500)*2;
R(x+95+sway*0.3,y+15,4,45,'#6a4a2a');
C(x+88+sway,y+15,9,'#2a6a2a');C(x+100+sway,y+12,8,'#3a7a3a');C(x+94+sway,y+10,7,'#2a5a2a');
// Volleyball net
R(x+60,y+40,2,25,'#888');R(x+85,y+40,2,25,'#888');
cx.strokeStyle='#aaa';cx.lineWidth=0.5;cx.beginPath();cx.moveTo(x+62,y+43);cx.lineTo(x+85,y+43);cx.stroke();
// Muscle beach equipment
R(x+40,y+60,3,12,'#555');R(x+48,y+60,3,12,'#555');R(x+40,y+59,11,2,'#666');
}

function drawMapAptLoc(x,y,w,h,cur,hov,lock){
// L-shaped apartment building footprint
R(x+20,y+10,60,h-15,'#4a3a2a');R(x+50,y+10,50,50,'#4a3a2a');
// Roof edge
cx.strokeStyle='#5a4a3a';cx.lineWidth=1;cx.strokeRect(x+20,y+10,60,h-15);cx.strokeRect(x+50,y+10,50,50);
// Windows (lit)
for(var wr=0;wr<3;wr++){for(var wc=0;wc<2;wc++){
var lit=((wr+wc)%3!==0);
R(x+26+wc*18,y+16+wr*20,8,6,lit?'#ffee88':'#2a2a3a');
}}
// Extra wing windows
R(x+70,y+18,8,6,'#ffee88');R(x+85,y+18,8,6,'#2a2a3a');R(x+70,y+36,8,6,'#2a2a3a');
// Entry door
R(x+42,y+h-12,10,8,'#3a2a1a');
// Fire escape (zigzag on left side)
cx.strokeStyle='#666';cx.lineWidth=0.8;
cx.beginPath();cx.moveTo(x+20,y+20);cx.lineTo(x+14,y+20);cx.lineTo(x+14,y+38);cx.lineTo(x+20,y+38);cx.lineTo(x+14,y+38);cx.lineTo(x+14,y+56);cx.lineTo(x+20,y+56);cx.stroke();
// Rooftop water tank
C(x+90,y+70,6,'#555');R(x+87,y+64,6,6,'#444');
// Parking lot
R(x+100,y+30,30,40,'#333');
// Beat-up car
R(x+106,y+40,18,10,'#5a3a3a');R(x+109,y+42,12,6,'#666');
}

function drawMapGymLoc(x,y,w,h,cur,hov,lock){
// Wide commercial building
R(x+10,y+15,w-20,h-25,'#3a3a40');
// Flat roof edge
cx.strokeStyle='#4a4a50';cx.lineWidth=1.5;cx.strokeRect(x+10,y+15,w-20,h-25);
// Entrance
R(x+60,y+h-15,20,10,'#2a2a30');
// Sign on roof — "GYM" with glow
cx.globalAlpha=0.15;C(x+w/2,y+8,20,'#ff6b35');cx.globalAlpha=1;
T('GYM',x+w/2,y+12,9,'#ff6b35');
// Parking lot
R(x+w-35,y+20,25,h-30,'#2a2a30');
// Cars in lot
R(x+w-30,y+28,14,8,'#4a4a5a');R(x+w-30,y+42,14,8,'#5a4a4a');R(x+w-30,y+56,14,8,'#4a5a4a');
// Barbell on ground near entrance
R(x+35,y+h-10,6,3,'#888');R(x+55,y+h-10,6,3,'#888');R(x+40,y+h-9,16,1,'#aaa');
// AC unit on roof
R(x+15,y+18,10,8,'#555');R(x+100,y+18,12,8,'#555');
}

function drawMapDowntownLoc(x,y,w,h,cur,hov,lock){
// Cluster of buildings — varying heights shown by shadow offsets
// Tall building 1
R(x+15,y+8,30,h-12,'#4a3a3a');
cx.strokeStyle='#5a4a4a';cx.lineWidth=0.8;cx.strokeRect(x+15,y+8,30,h-12);
// Drop shadow (height indicator)
cx.globalAlpha=0.3;R(x+45,y+12,4,h-16,'#111');cx.globalAlpha=1;
// Windows
for(var dw=0;dw<5;dw++){
R(x+20,y+14+dw*16,6,5,(dw%2===0)?'#ffee88':'#2a2a3a');
R(x+32,y+14+dw*16,6,5,(dw%3===0)?'#ffee88':'#2a2a3a');
}
// Building 2 — medium
R(x+55,y+20,35,h-24,'#3a3040');
cx.strokeStyle='#4a4050';cx.lineWidth=0.8;cx.strokeRect(x+55,y+20,35,h-24);
cx.globalAlpha=0.3;R(x+90,y+24,3,h-28,'#111');cx.globalAlpha=1;
for(var dw2=0;dw2<4;dw2++){
R(x+60,y+26+dw2*18,8,6,(dw2%2===0)?'#ffee88':'#2a2a3a');
R(x+74,y+26+dw2*18,8,6,(dw2%3===1)?'#ffee88':'#2a2a3a');
}
// Building 3 — tallest
R(x+100,y+5,30,h-8,'#4a4050');
cx.strokeStyle='#5a5060';cx.lineWidth=0.8;cx.strokeRect(x+100,y+5,30,h-8);
cx.globalAlpha=0.3;R(x+130,y+9,4,h-12,'#111');cx.globalAlpha=1;
for(var dw3=0;dw3<6;dw3++){
R(x+105,y+11+dw3*14,6,5,(dw3%2===0)?'#ffee88':'#2a2a3a');
R(x+117,y+11+dw3*14,6,5,(dw3%3===0)?'#ffee88':'#2a2a3a');
}
// Neon bar sign glow
cx.globalAlpha=0.2;C(x+40,y+h-8,12,'#cc3333');cx.globalAlpha=1;
T('BAR',x+40,y+h-5,5,'#cc4444');
// Alley between buildings
R(x+48,y+25,6,h-30,'#1a1a1a');
// Building 4 — short, far right
R(x+138,y+35,20,h-40,'#3a3535');
R(x+142,y+42,6,5,'#ffee88');R(x+142,y+56,6,5,'#2a2a3a');
}

function drawMapMaHouseLoc(x,y,w,h,cur,hov,lock){
if(lock){cx.globalAlpha=0.35;}
// Small house footprint
R(x+25,y+25,w-50,h-35,'#6a5a4a');
// Peaked roof (triangle shadow showing pitch)
cx.fillStyle='#555';
cx.beginPath();cx.moveTo(x+20,y+25);cx.lineTo(x+w/2,y+10);cx.lineTo(x+w-20,y+25);cx.closePath();cx.fill();
// Door
R(x+w/2-6,y+h-18,12,12,'#3a2a1a');
// Window
R(x+35,y+32,12,10,'#445566');R(x+w-47,y+32,12,10,'#445566');
// Scraggly yard
C(x+12,y+h-15,4,'#3a5a2a');C(x+w-12,y+h-12,3,'#4a6a3a');C(x+8,y+h-8,3,'#3a5a2a');
// Broken fence
cx.strokeStyle='#5a4a3a';cx.lineWidth=0.8;
cx.setLineDash([4,3]);
cx.beginPath();cx.moveTo(x+5,y+h-5);cx.lineTo(x+25,y+h-5);cx.stroke();
cx.beginPath();cx.moveTo(x+w-25,y+h-5);cx.lineTo(x+w-5,y+h-5);cx.stroke();
cx.setLineDash([]);
// Fence posts
R(x+5,y+h-10,2,8,'#5a4a3a');R(x+24,y+h-10,2,8,'#5a4a3a');R(x+w-6,y+h-10,2,8,'#5a4a3a');
if(lock){
cx.globalAlpha=1;
T('?',x+w/2,y+h/2+5,22,'#888');
}
}

// --- MAP HELPER DRAW FUNCTIONS ---
function drawMapStreet(st){
var dx=st.x2-st.x1,dy=st.y2-st.y1;
var len=Math.sqrt(dx*dx+dy*dy);
if(st.horiz){
// Horizontal road
R(st.x1,st.y1-st.w/2,st.x2-st.x1,st.w,'#3a3a42');
// Center dashed line
cx.setLineDash([8,6]);cx.strokeStyle=st.major?'#aa8833':'#666';cx.lineWidth=st.major?1:0.6;
cx.beginPath();cx.moveTo(st.x1,st.y1);cx.lineTo(st.x2,st.y1);cx.stroke();cx.setLineDash([]);
// Edge lines
cx.strokeStyle='#4a4a50';cx.lineWidth=0.5;
cx.beginPath();cx.moveTo(st.x1,st.y1-st.w/2);cx.lineTo(st.x2,st.y1-st.w/2);cx.stroke();
cx.beginPath();cx.moveTo(st.x1,st.y1+st.w/2);cx.lineTo(st.x2,st.y1+st.w/2);cx.stroke();
// Street name
if(st.name){T(st.name,((st.x1+st.x2)/2),st.y1+st.w/2+9,5,'#555');}
}else{
// Vertical road
R(st.x1-st.w/2,st.y1,st.w,st.y2-st.y1,'#3a3a42');
cx.setLineDash([8,6]);cx.strokeStyle=st.major?'#aa8833':'#666';cx.lineWidth=st.major?1:0.6;
cx.beginPath();cx.moveTo(st.x1,st.y1);cx.lineTo(st.x1,st.y2);cx.stroke();cx.setLineDash([]);
cx.strokeStyle='#4a4a50';cx.lineWidth=0.5;
cx.beginPath();cx.moveTo(st.x1-st.w/2,st.y1);cx.lineTo(st.x1-st.w/2,st.y2);cx.stroke();
cx.beginPath();cx.moveTo(st.x1+st.w/2,st.y1);cx.lineTo(st.x1+st.w/2,st.y2);cx.stroke();
if(st.name){
cx.save();cx.translate(st.x1-st.w/2-7,(st.y1+st.y2)/2);cx.rotate(-Math.PI/2);T(st.name,0,0,5,'#555');cx.restore();
}
}
// Diagonal/angled minor roads
if(!st.horiz&&st.x1!==st.x2&&!st.major){
cx.strokeStyle='#3a3a42';cx.lineWidth=st.w;
cx.beginPath();cx.moveTo(st.x1,st.y1);cx.lineTo(st.x2,st.y2);cx.stroke();
}
}

function drawMapCityBlocks(){
// Seeded random building footprints between streets for urban atmosphere
var blocks=[
{x:50,y:30,w:150,h:115},{x:225,y:30,w:320,h:60},
{x:225,y:110,w:320,h:95},{x:565,y:30,w:290,h:100},
{x:565,y:150,w:290,h:58},{x:50,y:168,w:150,h:42},
{x:225,y:240,w:320,h:215},{x:50,y:240,w:150,h:215},
{x:565,y:240,w:290,h:60},{x:565,y:410,w:290,h:45}
];
for(var bi=0;bi<blocks.length;bi++){
var b=blocks[bi];
for(var bx=b.x+4;bx<b.x+b.w-8;bx+=16){
for(var by=b.y+4;by<b.y+b.h-8;by+=14){
var seed=(bx*7+by*13+bi*31)%100;
if(seed<45){
var bw=10+(seed%6),bh=8+(seed%5);
R(bx,by,bw,bh,seed<20?'#1e1e24':'#222230');
// Occasional lit window
if(seed<12){C(bx+bw/2,by+bh/2,1,(seed<6)?'#ffee88':'#88aacc');}
}
}}
// Trees along edges
for(var tx=b.x+8;tx<b.x+b.w-8;tx+=30){
var ts=(tx*11+b.y*7)%100;
if(ts<25){C(tx,b.y+b.h-3,3,'#1a3a1a');C(tx+1,b.y+b.h-4,2,'#2a4a2a');}
}
}
}

function drawMapOcean(){
// Ocean gradient on left strip
var og=cx.createLinearGradient(0,0,55,0);
og.addColorStop(0,'#0a1a3a');og.addColorStop(0.5,'#1a3a6a');og.addColorStop(1,'#2266aa');
cx.fillStyle=og;cx.fillRect(0,25,55,430);
// Animated waves
var wt=Date.now()/2000;
cx.strokeStyle='#3388bb';cx.lineWidth=0.8;
for(var wl=0;wl<6;wl++){
cx.beginPath();
var wy=50+wl*70;
for(var wx=0;wx<55;wx+=8){
var yo=Math.sin(wt+wx*0.1+wl)*3;
if(wx===0)cx.moveTo(wx,wy+yo);else cx.lineTo(wx,wy+yo);
}
cx.stroke();
}
// Sand strip
var sg=cx.createLinearGradient(50,0,85,0);
sg.addColorStop(0,'#c4a876');sg.addColorStop(1,'#aa9060');
cx.fillStyle=sg;cx.fillRect(50,25,38,430);
}

function drawMapCompass(cx2,cy){
// Simple compass rose
cx.globalAlpha=0.3;
cx.strokeStyle='#888';cx.lineWidth=1;
// N-S line
cx.beginPath();cx.moveTo(cx2,cy-14);cx.lineTo(cx2,cy+14);cx.stroke();
// E-W line
cx.beginPath();cx.moveTo(cx2-14,cy);cx.lineTo(cx2+14,cy);cx.stroke();
// North arrow
cx.fillStyle='#cc6633';
cx.beginPath();cx.moveTo(cx2,cy-14);cx.lineTo(cx2-3,cy-6);cx.lineTo(cx2+3,cy-6);cx.closePath();cx.fill();
T('N',cx2,cy-18,6,'#888');T('S',cx2,cy+22,5,'#666');
T('W',cx2-20,cy+3,5,'#666');T('E',cx2+20,cy+3,5,'#666');
cx.globalAlpha=1;
}

function drawMapOverlay(){
// Full dark backdrop
cx.globalAlpha=0.93;R(0,0,W,H,'#111118');cx.globalAlpha=1;
// Subtle map border
cx.strokeStyle='#333';cx.lineWidth=2;cx.strokeRect(8,8,W-16,H-16);
cx.strokeStyle='#222';cx.lineWidth=1;cx.strokeRect(12,12,W-24,H-24);
// Ocean and sand
drawMapOcean();
// Draw streets
for(var si=0;si<MAP_STREETS.length;si++){drawMapStreet(MAP_STREETS[si]);}
// Intersection highlights (brighter asphalt at crosses)
cx.globalAlpha=0.08;
C(210,220,14,'#555');C(550,220,14,'#555');C(210,100,10,'#555');C(550,140,10,'#555');C(210,155,10,'#555');
cx.globalAlpha=1;
// City block fill
drawMapCityBlocks();
// Title
T('VENICE BEACH & VICINITY',450,18,11,'#5a5040');
T('LOS ANGELES, CA',450,30,6,'#444');
cx.strokeStyle='#3a3a3a';cx.lineWidth=0.5;
cx.beginPath();cx.moveTo(300,34);cx.lineTo(600,34);cx.stroke();
// Determine current location
var currentPhase=S.phase;
var atMaHouse=(currentPhase==='downtown'&&S.downtown.subMenu&&S.downtown.subMenu.indexOf('ma_')===0);
var maLocked=!(S.apartment&&S.apartment.motherMission);
// Draw location markers
for(var li=0;li<MAP_LOCATIONS.length;li++){
var loc=MAP_LOCATIONS[li];
var isCurrent=(loc.id===currentPhase)||
(loc.id==='downtown'&&currentPhase==='downtown'&&!atMaHouse)||
(loc.id==='ma_house'&&atMaHouse);
// Fix: downtown should match only when not at Ma's house
if(loc.id==='downtown')isCurrent=(currentPhase==='downtown'&&!atMaHouse);
if(loc.id==='apartment')isCurrent=(currentPhase==='apartment');
if(loc.id==='beach')isCurrent=(currentPhase==='beach');
if(loc.id==='gym')isCurrent=(currentPhase==='gym');
var isHov=(hover===loc.zone);
var isLock=(loc.id==='ma_house'&&maLocked);
// Current location pulsing glow
if(isCurrent){
var pulse=Math.sin(Date.now()/400)*0.3+0.7;
cx.globalAlpha=pulse*0.25;
cx.strokeStyle='#ff6b35';cx.lineWidth=4;
cx.strokeRect(loc.x-4,loc.y-4,loc.w+8,loc.h+8);
cx.globalAlpha=pulse*0.08;
R(loc.x-8,loc.y-8,loc.w+16,loc.h+16,'#ff6b35');
cx.globalAlpha=1;
}
// Draw the location
if(loc.id==='beach')drawMapBeachLoc(loc.x,loc.y,loc.w,loc.h,isCurrent,isHov,isLock);
else if(loc.id==='apartment')drawMapAptLoc(loc.x,loc.y,loc.w,loc.h,isCurrent,isHov,isLock);
else if(loc.id==='gym')drawMapGymLoc(loc.x,loc.y,loc.w,loc.h,isCurrent,isHov,isLock);
else if(loc.id==='downtown')drawMapDowntownLoc(loc.x,loc.y,loc.w,loc.h,isCurrent,isHov,isLock);
else if(loc.id==='ma_house')drawMapMaHouseLoc(loc.x,loc.y,loc.w,loc.h,isCurrent,isHov,isLock);
// Hover highlight
if(isHov&&!isLock){
cx.strokeStyle='#ff6b35';cx.lineWidth=2.5;cx.strokeRect(loc.x-2,loc.y-2,loc.w+4,loc.h+4);
cx.globalAlpha=0.08;R(loc.x,loc.y,loc.w,loc.h,'#ff6b35');cx.globalAlpha=1;
}
// Label
var labelCol=isLock?'#444':isHov?'#ff6b35':isCurrent?'#ff6b35':'#aaa098';
var labelSz=isHov?9:7;
T(loc.label,loc.x+loc.w/2,loc.y+loc.h+12,labelSz,labelCol);
if(isCurrent){T('YOU ARE HERE',loc.x+loc.w/2,loc.y-8,6,'#ff6b35');}
}
// Compass
drawMapCompass(850,50);
// Cancel button
var cH=(hover==='mapCancel');
R(370,438,160,32,cH?'#2a2018':'#1a1a20');
cx.strokeStyle=cH?'#ff6b35':'#444';cx.lineWidth=cH?2:1;cx.strokeRect(370,438,160,32);
T('STAY HERE',450,458,10,cH?'#ff6b35':'#888');
}
window.drawMapOverlay=drawMapOverlay;window.drawMapIcon=drawMapIcon;
window.drawMapBeachLoc=drawMapBeachLoc;window.drawMapAptLoc=drawMapAptLoc;
window.drawMapGymLoc=drawMapGymLoc;window.drawMapDowntownLoc=drawMapDowntownLoc;
window.drawMapMaHouseLoc=drawMapMaHouseLoc;

function drawBackroomRivals(){
  if(!S.rivals||S.rivals.length===0)return;
  var spots=[{x:160,sit:true},{x:480,sit:false},{x:520,sit:true},{x:700,sit:false},{x:760,sit:true}];
  for(var i=0;i<S.rivals.length&&i<spots.length;i++){
    var r=S.rivals[i];
    if(!r.active)continue;
    // Skip drawing rival currently lifting (they're on the platform / TV)
    var isLifting=(S.turn&&S.turn.whose==='rival'&&S.rival&&S.rival.id===r.id);
    if(isLifting)continue;
    var sp=spots[i];
    var rx=sp.x,ry=sp.sit?360:340;
    var sk=r.skin||'#c8a882',sg=r.singlet||'#333',hr=r.hair||'#111';
    cx.globalAlpha=0.55;
    if(sp.sit){
      // Sitting on floor/bench
      R(rx-4,ry+8,4,14,sg);R(rx+1,ry+8,4,14,sg);
      R(rx-5,ry+22,6,3,'#111');R(rx,ry+22,6,3,'#111');
      R(rx-6,ry-6,12,16,sg);
      C(rx,ry-12,6,sk);R(rx-5,ry-20,10,5,hr);
    }else{
      // Standing idle
      R(rx-3,ry+18,4,22,sg);R(rx+0,ry+18,4,22,sg);
      R(rx-4,ry+40,6,3,'#111');R(rx-1,ry+40,6,3,'#111');
      R(rx-6,ry-2,12,22,sg);
      R(rx-9,ry,4,16,sk);R(rx+5,ry,4,16,sk);
      C(rx,ry-10,6,sk);R(rx-5,ry-18,10,5,hr);
    }
    cx.globalAlpha=1;
  }
}

function drawBackroomHUD(){
  // Phase indicator (top-left)
  var phaseText='';
  if(S.phase==='warmup')phaseText='WARM-UP';
  else if(S.phase==='snatch')phaseText='SNATCH '+(S.turn.tarkAttempt+1)+'/3';
  else if(S.phase==='cj')phaseText='C&J '+(S.turn.tarkAttempt+1)+'/3';
  else if(S.phase==='rest_sn_cj')phaseText='REST PERIOD';
  if(phaseText){
    R(4,4,120,22,'rgba(10,10,10,0.7)');
    T(phaseText,64,18,10,'#ff6b35');
  }
  // Mute toggle (top-right)
  var mx=868,my=18;
  cx.globalAlpha=hover==='mute'?1:0.5;
  if(SFX.muted)T('\uD83D\uDD07',mx,my+6,16,'#ff4444','left');
  else T('\uD83D\uDD0A',mx,my+6,16,'#7fdb6a','left');
  cx.globalAlpha=1;
  // Warmup update ticks (called every frame, check timestamps internally)
  if(S.phase==='warmup'&&S.warmup){
    updateWarmupTimer();
    updateWarmupRivals();
    updateWarmupEvents();
  }
  // Featured rival animations (all phases with rivals)
  if(S.rivals)try{updateFeaturedRivals();}catch(e){}
  // Danger meter + bar weight in warmup/comp
  if(S.phase==='warmup'){
    var wfc=typeof getFailChance==='function'?getFailChance('snatch'):0;
    var winj=typeof getInjuryChance==='function'?getInjuryChance(wfc):0;
    if(S.barWeight>45)drawDangerMeter(220,16,wfc,winj);
    T(S.barWeight+' LBS',LAYOUT.backroom.homeX,FY+30,10,'#555');
    // Warmup HUD: countdown timer + card progress + rivals ready
    if(S.warmup){
      // Countdown timer — prominent
      var wRem=Math.max(0,S.warmup.startTime+S.warmup.duration-Date.now());
      var wMin=Math.floor(wRem/60000);
      var wSec=Math.floor((wRem%60000)/1000);
      var wTimeTxt=wMin+':'+(wSec<10?'0':'')+wSec;
      var wTimeCol=wRem<=30000?'#ff4444':wRem<=60000?'#ffcc00':'#f0e6d3';
      // Pulse in last 10s
      var wTimeAlpha=1;
      if(wRem<=10000)wTimeAlpha=0.5+Math.sin(Date.now()/150)*0.5;
      R(4,28,160,20,'rgba(10,10,10,0.7)');
      cx.globalAlpha=wTimeAlpha;
      T('COMP STARTS: '+wTimeTxt,84,42,9,wTimeCol);
      cx.globalAlpha=1;
      // Card progress
      var cStep=S.warmup.cardStep;
      var cTotal=S.warmup.card?S.warmup.card.length:7;
      R(4,50,160,16,'rgba(10,10,10,0.6)');
      T('WARMUP: '+cStep+'/'+cTotal,50,61,7,'#aaa');
      // Mini progress bar
      var pbx=105,pby=55,pbw=55,pbh=6;
      R(pbx,pby,pbw,pbh,'#222');
      if(cTotal>0)R(pbx,pby,Math.round(pbw*cStep/cTotal),pbh,'#7fdb6a');
      // Rivals ready
      var rReady=0;
      for(var hri=0;hri<S.rivals.length;hri++){if(S.rivals[hri].warmupDone)rReady++;}
      var rCol=rReady>=S.rivals.length?'#7fdb6a':'#ffcc00';
      R(4,68,100,14,'rgba(10,10,10,0.6)');
      T(rReady+'/'+S.rivals.length+' rivals ready',54,78,7,rCol);
    }
  }else if(S.phase==='snatch'||S.phase==='cj'){
    var fc=typeof getFailChance==='function'?getFailChance(S.phase==='snatch'?'snatch':'cj'):0;
    var ci=typeof getInjuryChance==='function'?getInjuryChance(fc):0;
    if(S.barWeight>45)drawDangerMeter(220,16,fc,ci);
  }else if(S.phase==='rest_sn_cj'){
    T('Best Snatch: '+(S.bestSnatch>0?S.bestSnatch+' lbs':'NONE'),W/2,H-15,11,S.bestSnatch>0?'#7fdb6a':'#ff4444');
  }
  // --- YOUR TURN countdown timer (competition, backroom) ---
  var tt=S.turn;
  if(tt.whose==='tark'&&tt.timerStart&&(S.phase==='snatch'||S.phase==='cj')){
    var elapsed=(Date.now()-tt.timerStart)/1000;
    var remaining=Math.max(0,60-elapsed);
    var secs=Math.ceil(remaining);
    var pct=remaining/60;
    // Timer bar across top
    var barW=300,barH=12,barX=(W-barW)/2,barY=32;
    var col=pct>0.5?'#40a040':pct>0.17?'#cccc33':'#ff4444';
    cx.globalAlpha=0.85;
    R(barX,barY,barW,barH,'#111');
    R(barX,barY,Math.round(barW*pct),barH,col);
    cx.strokeStyle='#333';cx.lineWidth=1;cx.strokeRect(barX,barY,barW,barH);
    // Seconds text
    var timerCol=secs<=10?'#ff4444':'#fff';
    if(secs<=10){cx.globalAlpha=0.5+Math.sin(Date.now()/120)*0.5;}
    else{cx.globalAlpha=1;}
    T(secs+'s',W/2,barY-4,secs<=15?16:12,timerCol);
    T('YOUR TURN \u2014 '+tt.tarkDeclared+' LBS',W/2,barY+barH+14,10,'#ffcc00');
    cx.globalAlpha=1;
  }
  // --- YOUR TURN flash alert (first 2 seconds) ---
  if(S.turnAlert){
    var alertAge=(Date.now()-S.turnAlert)/1000;
    if(alertAge<2.0){
      var pulse=Math.sin(alertAge*8)*0.15+0.15;
      cx.globalAlpha=pulse*(1-alertAge/2.0);
      R(0,0,W,H,'#ffaa00');
      cx.globalAlpha=1;
    }else{S.turnAlert=0;}
  }
}

// --- SCENE TRANSITIONS ---

function drawSceneTransition(){
  if(!S.sceneTransition)return;
  var t=S.sceneTransition;
  t.progress++;
  var half=Math.ceil(t.duration/2);
  if(t.progress<=half){
    // Fade to black
    cx.globalAlpha=t.progress/half;
  }else{
    // Fade from black
    cx.globalAlpha=Math.max(0,1-(t.progress-half)/half);
  }
  R(0,0,W,H,'#000');
  cx.globalAlpha=1;
  // At midpoint, fire scene-swap callback
  if(t.progress===half&&t.midCallback){
    var mid=t.midCallback;
    t.midCallback=null;
    mid();
  }
  // When fully done, fire end callback and clear
  if(t.progress>=t.duration){
    var end=t.endCallback;
    S.sceneTransition=null;
    if(end)try{end();}catch(e){log('ERR sceneTransition end: '+e.message,'fail');S.busy=false;}
  }
}

function transitionToPlatform(callback){
  S.busy=true;
  if(window.resetBusyTimer)window.resetBusyTimer();
  walkTo(LAYOUT.backroom.doorX-10,function(){
    S.sceneTransition={
      progress:0,duration:30,
      midCallback:function(){
        S.scene='platform';
        S.homeX=LAYOUT.comp.homeX;
        S.tX=-30;
        S.pose='idle';
      },
      endCallback:function(){
        walkTo(LAYOUT.comp.homeX,function(){
          S.busy=false;
          if(callback)callback();
        });
      }
    };
  });
}

function transitionToBackroom(callback){
  S.busy=true;
  if(window.resetBusyTimer)window.resetBusyTimer();
  walkTo(-30,function(){
    S.sceneTransition={
      progress:0,duration:30,
      midCallback:function(){
        S.scene='backroom';
        // During competition, rest at central position (not barbell)
        var isComp=S.phase==='snatch'||S.phase==='cj'||S.phase==='rest_sn_cj';
        S.homeX=isComp?420:LAYOUT.backroom.homeX;
        S.tX=LAYOUT.backroom.doorX-10;
        S.pose='idle';
        if(!S.backroomExtras||S.backroomExtras.length===0)generateBackroomExtras();
      },
      endCallback:function(){
        walkTo(S.homeX,function(){
          S.busy=false;
          if(callback)callback();
        });
      }
    };
  });
}
window.transitionToPlatform=transitionToPlatform;
window.transitionToBackroom=transitionToBackroom;

function drawBench(){
if(S.phase==='intro') return;
var L=getLayout();
var bx=L.benchX;
if(S.phase==='gym'){
  var by=360;
  R(bx-40,by,80,10,'#333');
  R(bx-36,by+10,6,FY-by-10,'#2a2a2a');
  R(bx+30,by+10,6,FY-by-10,'#2a2a2a');
  R(bx-42,by-40,8,42,'#333');
  R(bx-48,by-42,20,6,'#3a3a3a');
  T('BENCH',bx,FY+16,9,'#333');
  if(hover==='bench'&&!S.busy){
    cx.strokeStyle='#ff6b35';cx.lineWidth=2;
    cx.strokeRect(bx-55,by-50,120,FY-by+70);
  }
}else{
  // Long bench/table in backroom — items sit on the right end
  var by=368;
  // Table top — solid, clear
  R(bx-30,by,140,5,'#4a4038');
  R(bx-30,by,140,1,'#5a5048');// highlight edge
  // Four legs
  R(bx-26,by+5,4,FY-by-5,'#3a3428');
  R(bx+104,by+5,4,FY-by-5,'#3a3428');
  R(bx+30,by+5,4,FY-by-5,'#3a3428');// middle leg
  // Cross brace
  R(bx-26,by+16,134,2,'#332e26');
}
}

function drawTable(){
if(S.phase!=='gym') return;
var tx=LAYOUT.gym.tableX,ty=300;
R(tx-55,ty,110,8,'#2a2a2a');
R(tx-50,ty+8,6,FY-ty-8,'#222');
R(tx+44,ty+8,6,FY-ty-8,'#222');
T('TABLE',tx,FY+16,9,'#333');
}

function drawShaker(){
var L=typeof getLayout==='function'?getLayout():(S&&S.phase==='gym'?LAYOUT.gym:LAYOUT.comp);
var sx=L.shakerX,sy=S.phase==='gym'?300:368;
if(S.pose==='shake') return;
if(S.shakesLeft<=0){R(sx-8,sy-22,16,22,'#222');T('EMPTY',sx,sy-10,7,'#333');return;}
R(sx-8,sy-22,16,22,'#3a3a3a');
R(sx-6,sy-27,12,6,'#7fdb6a');
T('WHEY',sx,sy-10,7,'#7fdb6a');
if(hover==='shake'&&!S.busy){
cx.strokeStyle='#7fdb6a';cx.lineWidth=2;
cx.strokeRect(sx-14,sy-32,28,38);
}
}

function drawCigPack(){
var L=typeof getLayout==='function'?getLayout():(S&&S.phase==='gym'?LAYOUT.gym:LAYOUT.comp);
var px=L.cigX,py=S.phase==='gym'?300:368;
if(S.cigsLeft<=0){R(px-12,py-16,24,16,'#1a1a1a');T('EMPTY',px,py-8,7,'#333');return;}
R(px-12,py-16,24,16,'#cc2222');
R(px-10,py-20,20,5,'#cc2222');
R(px-8,py-14,16,6,'#eee');
var vis=Math.min(S.cigsLeft,3);
for(var i=0;i<vis;i++){
R(px-4+i*5,py-26,2,8,'#f5f0e0');
C(px-3+i*5,py-26,1,'#ff8844');
}
T('SMOKES',px,FY+16,9,'#333');
if(hover==='cig'&&!S.busy){
cx.strokeStyle='#ffcc00';cx.lineWidth=2;
cx.strokeRect(px-18,py-30,36,40);
}
}

function drawChalkBucket(){
var L=typeof getLayout==='function'?getLayout():(S&&S.phase==='gym'?LAYOUT.gym:LAYOUT.comp);
var ckx=L.chalkX,cky=FY-6;
if(S.chalkUses<=0){R(ckx-12,cky-28,24,28,'#1a1a1a');T('EMPTY',ckx,cky-14,7,'#333');return;}
// Bucket body
R(ckx-12,cky-28,24,28,'#e8e0d0');
R(ckx-10,cky-28,20,4,'#ccc4b0');
// Chalk dust on top
R(ckx-8,cky-30,16,4,'#fff');
C(ckx-4,cky-32,3,'#f5f5f5');C(ckx+5,cky-31,2,'#eee');
// Handle
cx.strokeStyle='#888';cx.lineWidth=1.5;
cx.beginPath();cx.arc(ckx,cky-36,8,Math.PI,0);cx.stroke();
T('CHALK ('+S.chalkUses+')',ckx,FY+16,8,'#aaa');
if(hover==='chalk'&&!S.busy){
cx.strokeStyle='#ffffff';cx.lineWidth=2;
cx.strokeRect(ckx-16,cky-38,32,44);
}
}

function drawWeightRack(){
if(S.phase!=='gym') return;
var rx=LAYOUT.gym.rackX;
// Vertical posts
R(rx-25,230,5,FY-230,'#444');R(rx+20,230,5,FY-230,'#444');
// Top bar
R(rx-27,228,54,4,'#555');
// 5 shelves with plates
var shelves=window.RACK_SHELVES||[];
for(var si=0;si<shelves.length;si++){
  var sh=shelves[si];
  var sy=sh.y+2;
  // Shelf peg
  R(rx-20,sy+20,40,3,'#555');
  // Plate graphics on shelf (varying sizes by weight)
  var pw=sh.size>=45?6:sh.size>=25?5:sh.size>=10?4:3;
  var ph=sh.size>=45?18:sh.size>=35?16:sh.size>=25?14:sh.size>=10?10:6;
  // Draw a few plates on each shelf
  R(rx-14,sy+20-ph,pw,ph,sh.color);R(rx-14+pw+1,sy+20-ph,pw,ph,sh.color);
  R(rx+14-pw,sy+20-ph,pw,ph,sh.color);R(rx+14,sy+20-ph,pw,ph,sh.color);
  // Label
  T(sh.label,rx,sy+10,8,sh.color);
  // Highlight hovered shelf
  if(hover==='rack'&&!S.busy){
    var hShelf=window.getShelfAt?window.getShelfAt(mouseY):null;
    if(hShelf&&hShelf.size===sh.size){
      cx.strokeStyle=sh.color;cx.lineWidth=2;
      cx.strokeRect(rx-27,sh.y,54,sh.h);
      T('+'+sh.size*2+' LBS',rx,sh.y-3,9,sh.color);
      // Competition preview: show projected fail% and injury%
      if(S.phase==='snatch'||S.phase==='cj'||S.phase==='warmup'){
        var projWeight=S.barWeight+sh.size*2;
        if(projWeight<=585){
          // Temporarily calculate projected fail chance
          var oldBar=S.barWeight;var oldStack=S.plateStack.slice();
          S.barWeight=projWeight;S.plateStack=oldStack.concat([sh.size]);
          var projFc=window.getFailChance?window.getFailChance(S.phase==='cj'?'cj':'snatch'):0;
          var projInj=window.getInjuryChance?window.getInjuryChance(projFc):0;
          S.barWeight=oldBar;S.plateStack=oldStack;
          var projPct=Math.round(projFc*100);
          var projCol=projPct<30?'#7fdb6a':projPct<60?'#cccc33':'#ff4444';
          T(projWeight+' LBS \u2192 '+projPct+'% FAIL',rx,sh.y-14,8,projCol);
          if(projInj>0){
            T('\u2620 '+Math.round(projInj*100)+'% INJURY',rx,sh.y-24,8,projInj>0.3?'#ff2222':'#ffaa00');
          }
        }
      }
    }
  }
}
T(S.barWeight+' LBS',rx,FY+16,9,'#888');
}

// --- Barbell ---
function drawBarbell(x,y,plates){
R(x-75,y-2,150,4,'#888');
R(x-77,y-4,5,8,'#666');R(x+72,y-4,5,8,'#666');
// Collars
R(x-85,y-6,8,12,'#555');R(x+77,y-6,8,12,'#555');
// Draw loaded plates from inside out
var stack=plates||S.plateStack||[];
var lOff=86,rOff=86;
for(var pi=0;pi<stack.length;pi++){
  var ps=stack[pi];
  var col=ps>=45?'#cc3333':ps>=35?'#cccc33':ps>=25?'#3355cc':ps>=10?'#40a040':'#aaaaaa';
  var pw=ps>=45?7:ps>=35?6:ps>=25?6:ps>=10?5:3;
  var ph=ps>=45?28:ps>=35?24:ps>=25?20:ps>=10?14:8;
  R(x-lOff-pw,y-ph/2,pw,ph,col);R(x+rOff,y-ph/2,pw,ph,col);
  lOff+=pw+1;rOff+=pw+1;
}
}

// --- Tark poses ---
function drawTarkIdle(x,y,tired){
var sw=tired?Math.sin(Date.now()/300)*3:Math.sin(Date.now()/1200)*1;
var dip=tired?6:0;
var _sc=getTarkShirtColor(),_hc=getTarkHeadbandColor();
R(x-12,y+30,10,38,'#2a2a2a');if(!S._hideRightLeg){R(x+2,y+30,10,38,'#2a2a2a');}
R(x-14,y+66,14,6,'#cc3333');if(!S._hideRightLeg){R(x+0,y+66,14,6,'#cc3333');}
R(x-16+sw,y-10+dip,32,42,_sc);drawTarkAbs(x+sw,y-10+dip,42);
if(!S._hideLeftArm){R(x-24+sw,y-6+dip,10,30,'#d4a574');}
if(!S._hideRightArm){R(x+14+sw,y-6+dip,10,30,'#d4a574');}
if(!S._hideLeftArm){C(x-20+sw,y+4+dip,6,'#c4955e');}
if(!S._hideRightArm){C(x+20+sw,y+4+dip,6,'#c4955e');}
if(!S._hideLeftArm){C(x-19+sw,y+26+dip,5,'#d4a574');}
if(!S._hideRightArm){C(x+19+sw,y+26+dip,5,'#d4a574');}
// Chalk on hands
if(S.chalked){var ca=Math.max(0,1-S.chalkTimer/600)*0.4;cx.globalAlpha=ca;if(!S._hideLeftArm){C(x-19+sw,y+26+dip,6,'#fff');}if(!S._hideRightArm){C(x+19+sw,y+26+dip,6,'#fff');}cx.globalAlpha=1;}
C(x+sw,y-22+dip,16,'#d4a574');
if(_hc)R(x-16+sw,y-30+dip,32,4,_hc);
C(x-5+sw,y-24+dip,2,'#111');C(x+5+sw,y-24+dip,2,'#111');
if(tired){
cx.strokeStyle='#111';cx.lineWidth=1.5;cx.beginPath();cx.arc(x+sw,y-14+dip,4,0.2,Math.PI-0.2);cx.stroke();
var dr=(Date.now()/200)%20;
C(x-18+sw,y-18+dip+dr,2,'#6699cc');C(x+20+sw,y-14+dip+dr*0.7,2,'#6699cc');
}else{
R(x-4+sw,y-16+dip,8,2,'#111');
}
}

function drawTarkOnPhone(x,y){
// Tark holding phone to ear — right arm raised
var sw=Math.sin(Date.now()/1200)*1;
var _sc=getTarkShirtColor(),_hc=getTarkHeadbandColor();
// Legs
R(x-12,y+30,10,38,'#2a2a2a');R(x+2,y+30,10,38,'#2a2a2a');
R(x-14,y+66,14,6,'#cc3333');R(x+0,y+66,14,6,'#cc3333');
// Torso
R(x-16+sw,y-10,32,42,_sc);drawTarkAbs(x+sw,y-10,42);
// Left arm — normal hanging
R(x-24+sw,y-6,10,30,'#d4a574');C(x-19+sw,y+26,5,'#d4a574');
// Right arm — raised, bent at elbow holding phone
// Upper arm: shoulder to elbow (going up-right)
cx.save();cx.fillStyle='#d4a574';
cx.beginPath();cx.moveTo(x+14+sw,y-4);cx.lineTo(x+24+sw,y-4);cx.lineTo(x+28+sw,y-22);cx.lineTo(x+18+sw,y-22);cx.fill();
// Forearm: elbow to ear
cx.beginPath();cx.moveTo(x+18+sw,y-22);cx.lineTo(x+28+sw,y-22);cx.lineTo(x+22+sw,y-34);cx.lineTo(x+14+sw,y-34);cx.fill();
cx.restore();
// Hand near ear
C(x+18+sw,y-35,5,'#d4a574');
// Phone — small dark rectangle at hand
R(x+14+sw,y-44,8,16,'#222');R(x+15+sw,y-42,6,10,'#1a3a5a');
// Head
C(x+sw,y-22,16,'#d4a574');
if(_hc)R(x-16+sw,y-30,32,4,_hc);
// Eyes
C(x-5+sw,y-24,2,'#111');C(x+5+sw,y-24,2,'#111');
// Mouth — talking animation
var mt=Date.now()%800;
if(mt<400){R(x-3+sw,y-16,6,3,'#111');}else{R(x-2+sw,y-15,4,2,'#111');}
}

function drawTarkBack(x,y){
// Tark facing away from camera — watching TV etc.
var sw=Math.sin(Date.now()/1200)*1;
var _sc=getTarkShirtColor(),_hc=getTarkHeadbandColor();
// Legs
R(x-12,y+30,10,38,'#2a2a2a');R(x+2,y+30,10,38,'#2a2a2a');
R(x-14,y+66,14,6,'#cc3333');R(x+0,y+66,14,6,'#cc3333');
// Torso — back view (slightly wider, no shirt detail)
R(x-16+sw,y-10,32,42,_sc);
// Arms at sides
R(x-24+sw,y-6,10,30,'#d4a574');R(x+14+sw,y-6,10,30,'#d4a574');
C(x-19+sw,y+26,5,'#d4a574');C(x+19+sw,y+26,5,'#d4a574');
// Head — back view (no eyes, no mouth, just hair/headband)
C(x+sw,y-22,16,'#d4a574');
// Back of head hair — darker mass
cx.globalAlpha=0.4;C(x+sw,y-24,14,'#3a2a1a');cx.globalAlpha=1;
// Headband wraps around back
if(_hc)R(x-16+sw,y-30,32,4,_hc);
// Neck
R(x-6+sw,y-8,12,6,'#d4a574');
}

function drawTarkLyingDown(x,y){
// Tark lying on mattress — ignore y param, use mattress surface level
var my=388; // mattress surface (FY=400, mattress top ~12px up)
var _sc=getTarkShirtColor(),_hc=getTarkHeadbandColor();
var br=Math.sin(Date.now()/800)*1; // gentle breathing
// Legs — horizontal
R(x-50,my-8,38,10,'#2a2a2a');R(x-50,my+2,38,10,'#2a2a2a');
// Shoes
R(x-56,my-8,8,10,'#cc3333');R(x-56,my+2,8,10,'#cc3333');
// Torso — horizontal
R(x-12,my-14+br,42,24,_sc);
// Arms — one across chest, one out
R(x+2,my-2+br,30,8,'#d4a574');C(x+32,my+2+br,4,'#d4a574');
R(x-4,my-18+br,10,8,'#d4a574');C(x-4,my-14+br,4,'#d4a574');
// Head — on pillow
C(x+40,my-6+br,14,'#d4a574');
if(_hc)R(x+26,my-14+br,28,4,_hc);
// Eyes — closed
R(x+36,my-10+br,4,1.5,'#111');R(x+44,my-10+br,4,1.5,'#111');
// Mouth
R(x+38,my-2+br,4,1.5,'#111');
// Zzz
var bob=Math.sin(Date.now()/400)*3;
T('z',x+56,my-18+bob,10,'#555');
T('z',x+62,my-26+bob,12,'#555');
T('Z',x+68,my-34+bob,15,'#555');
}

function drawTarkEating(x,y,t,food){
// Tark eating/drinking animation
var _sc=getTarkShirtColor(),_hc=getTarkHeadbandColor();
var gulp=Math.sin(t*8)*3;
// Legs
R(x-12,y+30,10,38,'#2a2a2a');R(x+2,y+30,10,38,'#2a2a2a');
R(x-14,y+66,14,6,'#cc3333');R(x+0,y+66,14,6,'#cc3333');
// Torso
R(x-16,y-10,32,42,_sc);
// Left arm at side
R(x-24,y-6,10,30,'#d4a574');C(x-19,y+26,5,'#d4a574');
// Head — drawn BEFORE arm+food so food appears in front of face
C(x,y-22-gulp*0.5,16,'#d4a574');
if(_hc)R(x-16,y-30-gulp*0.5,32,4,_hc);
C(x-5,y-24-gulp*0.5,2,'#111');C(x+5,y-24-gulp*0.5,2,'#111');
// Mouth — open when drinking, closed when chewing pizza
if(food==='pizza'){
  var chew=Math.sin(t*10)*2;
  R(x-3,y-16-gulp*0.5,6,2+chew,'#111');
}else{
  cx.strokeStyle='#111';cx.lineWidth=1.5;cx.beginPath();cx.arc(x,y-14-gulp*0.5,4,0.3,Math.PI-0.3);cx.stroke();
}
// Right arm — raised to mouth (drawn after head so it's in front)
R(x+14,y-6,10,14,'#d4a574');
R(x+10,y-16-gulp,10,20,'#d4a574');
C(x+14,y-16-gulp,5,'#d4a574');
// Food item in hand (drawn last — always in front)
if(food==='eggs'){
  // Blender — Rocky style glass
  R(x+6,y-38-gulp,16,24,'#aaccdd');cx.globalAlpha=0.6;R(x+8,y-36-gulp,12,18,'#ffdd44');cx.globalAlpha=1;
  R(x+4,y-40-gulp,20,4,'#888');
  // Drip
  if(Math.sin(t*12)>0.5){C(x+14,y-12-gulp,2,'#ffdd44');}
}else if(food==='pizza'){
  // Pizza slice
  cx.beginPath();cx.moveTo(x+8,y-36-gulp);cx.lineTo(x+24,y-36-gulp);cx.lineTo(x+16,y-20-gulp);cx.closePath();
  cx.fillStyle='#dda030';cx.fill();C(x+14,y-30-gulp,2,'#cc3333');C(x+18,y-32-gulp,1.5,'#447744');
}else if(food==='coffee'){
  // Coffee mug
  R(x+6,y-34-gulp,14,16,'#f5f0e0');R(x+20,y-30-gulp,6,8,'#f5f0e0');
  R(x+8,y-32-gulp,10,4,'#3a2a1a'); // coffee surface
  // Steam
  for(var si=0;si<3;si++){var sy2=Math.sin(t*4+si*2)*4;cx.globalAlpha=0.3;C(x+10+si*4,y-40-gulp+sy2,2,'#ccc');cx.globalAlpha=1;}
}else if(food==='shake'){
  // Shaker bottle
  R(x+8,y-40-gulp,12,26,'#3a3a3a');R(x+6,y-42-gulp,16,4,'#555');
  R(x+10,y-38-gulp,8,18,'#447744');T('P',x+14,y-28-gulp,6,'#7fdb6a');
}
}

function drawTarkPull(x,y){
var _sc=getTarkShirtColor(),_hc=getTarkHeadbandColor();
R(x-14,y+20,12,30,'#2a2a2a');R(x+2,y+20,12,30,'#2a2a2a');
R(x-16,y+48,14,6,'#cc3333');R(x+2,y+48,14,6,'#cc3333');
R(x-16,y-5,32,28,_sc);drawTarkAbs(x,y-5,28);
R(x-22,y+2,8,26,'#d4a574');R(x+14,y+2,8,26,'#d4a574');
C(x,y-16,16,'#d4a574');if(_hc)R(x-16,y-24,32,4,_hc);
C(x-5,y-18,2,'#111');C(x+5,y-18,2,'#111');
R(x-6,y-12,12,3,'#111');
}

function drawTarkOverhead(x,y){
var _sc=getTarkShirtColor(),_hc=getTarkHeadbandColor();
R(x-12,y+30,10,38,'#2a2a2a');R(x+2,y+30,10,38,'#2a2a2a');
R(x-14,y+66,14,6,'#cc3333');R(x+0,y+66,14,6,'#cc3333');
R(x-16,y-10,32,42,_sc);drawTarkAbs(x,y-10,42);
R(x-22,y-50,8,44,'#d4a574');R(x+14,y-50,8,44,'#d4a574');
C(x-18,y-52,5,'#d4a574');C(x+18,y-52,5,'#d4a574');
C(x-20,y-20,7,'#c4955e');C(x+20,y-20,7,'#c4955e');
C(x,y-22,16,'#d4a574');if(_hc)R(x-16,y-30,32,4,_hc);
C(x-5,y-24,2.5,'#111');C(x+5,y-24,2.5,'#111');
cx.strokeStyle='#111';cx.lineWidth=2;cx.beginPath();cx.moveTo(x-4,y-14);cx.lineTo(x+4,y-14);cx.stroke();
}

function drawTarkSnatchOverhead(x,y){
var _sc=getTarkShirtColor(),_hc=getTarkHeadbandColor();
R(x-12,y+30,10,38,'#2a2a2a');R(x+2,y+30,10,38,'#2a2a2a');
R(x-14,y+66,14,6,'#cc3333');R(x+0,y+66,14,6,'#cc3333');
R(x-16,y-10,32,42,_sc);drawTarkAbs(x,y-10,42);
R(x-30,y-48,10,42,'#d4a574');R(x+20,y-48,10,42,'#d4a574');
C(x-30,y-50,5,'#d4a574');C(x+26,y-50,5,'#d4a574');
C(x-28,y-18,7,'#c4955e');C(x+28,y-18,7,'#c4955e');
C(x,y-22,16,'#d4a574');if(_hc)R(x-16,y-30,32,4,_hc);
C(x-5,y-24,2.5,'#111');C(x+5,y-24,2.5,'#111');
cx.strokeStyle='#111';cx.lineWidth=2;cx.beginPath();cx.moveTo(x-4,y-14);cx.lineTo(x+4,y-14);cx.stroke();
}

function drawTarkOverheadSquat(x,y){
// Deep overhead squat — catching the snatch. Thighs nearly horizontal, butt low, arms locked out wide.
var _sc=getTarkShirtColor(),_hc=getTarkHeadbandColor();
// Thighs (nearly horizontal — wide and short, angled out from hips)
R(x-22,y+34,16,10,'#2a2a2a');R(x+6,y+34,16,10,'#2a2a2a');
// Shins (vertical under knees)
R(x-22,y+44,10,18,'#2a2a2a');R(x+14,y+44,10,18,'#2a2a2a');
// Feet (wide stance, flat on ground)
R(x-24,y+60,14,6,'#cc3333');R(x+12,y+60,14,6,'#cc3333');
// Torso (dropped low — torso top at y+4, bottom at y+36)
R(x-16,y+4,32,32,_sc);drawTarkAbs(x,y+4,32);
// Belt
R(x-16,y+2,32,4,'#cc3333');
// Shoulders (wide, at top of torso)
C(x-20,y+6,6,'#c4955e');C(x+20,y+6,6,'#c4955e');
// Arms (fully extended overhead, wide snatch grip)
R(x-30,y-36,10,44,'#d4a574');R(x+20,y-36,10,44,'#d4a574');
// Hands at top of arms
C(x-30,y-38,5,'#d4a574');C(x+26,y-38,5,'#d4a574');
// Head (centered above torso, lower than standing)
C(x,y-8,16,'#d4a574');if(_hc)R(x-16,y-16,32,4,_hc);
// Eyes
C(x-5,y-10,2.5,'#111');C(x+5,y-10,2.5,'#111');
// Mouth (grimace — straining)
cx.strokeStyle='#111';cx.lineWidth=2;cx.beginPath();cx.moveTo(x-5,y-1);cx.lineTo(x+5,y-1);cx.stroke();
}

function drawTarkFrontSquat(x,y){
// Deep front squat — catching the clean. Same squat as overhead but bar racked on shoulders, elbows high.
var _sc=getTarkShirtColor(),_hc=getTarkHeadbandColor();
// Thighs (nearly horizontal — same as overhead squat)
R(x-22,y+34,16,10,'#2a2a2a');R(x+6,y+34,16,10,'#2a2a2a');
// Shins (vertical under knees)
R(x-22,y+44,10,18,'#2a2a2a');R(x+14,y+44,10,18,'#2a2a2a');
// Feet (wide stance, flat on ground)
R(x-24,y+60,14,6,'#cc3333');R(x+12,y+60,14,6,'#cc3333');
// Torso (dropped low — same as overhead squat)
R(x-16,y+4,32,32,_sc);drawTarkAbs(x,y+4,32);
// Belt
R(x-16,y+2,32,4,'#cc3333');
// Shoulders
C(x-20,y+6,6,'#c4955e');C(x+20,y+6,6,'#c4955e');
// Arms in front rack (upper arms horizontal from shoulders, forearms pointing up — elbows high)
R(x-26,y+2,12,8,'#d4a574');R(x+14,y+2,12,8,'#d4a574');
// Forearms (vertical, angling inward toward bar on shoulders)
R(x-18,y-12,8,16,'#d4a574');R(x+10,y-12,8,16,'#d4a574');
// Head (same as overhead squat)
C(x,y-8,16,'#d4a574');if(_hc)R(x-16,y-16,32,4,_hc);
// Eyes
C(x-5,y-10,2.5,'#111');C(x+5,y-10,2.5,'#111');
// Mouth (grimace)
cx.strokeStyle='#111';cx.lineWidth=2;cx.beginPath();cx.moveTo(x-5,y-1);cx.lineTo(x+5,y-1);cx.stroke();
}

function drawTarkSnatchPull(x,y){
var _sc=getTarkShirtColor(),_hc=getTarkHeadbandColor();
R(x-14,y+20,12,30,'#2a2a2a');R(x+2,y+20,12,30,'#2a2a2a');
R(x-16,y+48,14,6,'#cc3333');R(x+2,y+48,14,6,'#cc3333');
R(x-16,y-5,32,28,_sc);drawTarkAbs(x,y-5,28);
R(x-28,y+2,8,26,'#d4a574');R(x+20,y+2,8,26,'#d4a574');
C(x,y-16,16,'#d4a574');if(_hc)R(x-16,y-24,32,4,_hc);
C(x-5,y-18,2,'#111');C(x+5,y-18,2,'#111');
R(x-6,y-12,12,3,'#111');
}

function drawTarkClean(x,y){
var _sc=getTarkShirtColor(),_hc=getTarkHeadbandColor();
R(x-12,y+28,10,40,'#2a2a2a');R(x+2,y+28,10,40,'#2a2a2a');
R(x-14,y+66,14,6,'#cc3333');R(x+0,y+66,14,6,'#cc3333');
R(x-16,y-10,32,38,_sc);drawTarkAbs(x,y-10,38);
R(x-24,y-10,10,14,'#d4a574');R(x+14,y-10,10,14,'#d4a574');
C(x-20,y-2,6,'#c4955e');C(x+20,y-2,6,'#c4955e');
C(x,y-22,16,'#d4a574');if(_hc)R(x-16,y-30,32,4,_hc);
C(x-5,y-24,2,'#111');C(x+5,y-24,2,'#111');
R(x-4,y-16,8,2,'#111');
}

function drawTarkJerk(x,y){
var _sc=getTarkShirtColor(),_hc=getTarkHeadbandColor();
// Front leg — straight
R(x-8,y+28,10,42,'#2a2a2a');
R(x-10,y+68,14,6,'#cc3333');
// Back leg — rotated as one unit (leg + shoe)
cx.save();cx.translate(x+10,y+28);cx.rotate(0.3);
R(-5,0,10,44,'#2a2a2a');
R(-7,42,14,6,'#cc3333');
cx.restore();
R(x-16,y-10,32,40,_sc);drawTarkAbs(x,y-10,40);
R(x-22,y-55,8,48,'#d4a574');R(x+14,y-55,8,48,'#d4a574');
C(x-18,y-57,5,'#d4a574');C(x+18,y-57,5,'#d4a574');
C(x-20,y-24,7,'#c4955e');C(x+20,y-24,7,'#c4955e');
C(x,y-22,16,'#d4a574');if(_hc)R(x-16,y-30,32,4,_hc);
C(x-5,y-24,2.5,'#111');C(x+5,y-24,2.5,'#111');
R(x-6,y-13,12,3,'#cc3333');
}

function drawTarkSitting(bx,by){
var seatY=by;
var _sc=getTarkShirtColor(),_hc=getTarkHeadbandColor();
R(bx-14,seatY-10,28,10,'#2a2a2a');
R(bx+6,seatY,10,30,'#2a2a2a');R(bx-16,seatY,10,30,'#2a2a2a');
R(bx+4,seatY+28,14,6,'#cc3333');R(bx-18,seatY+28,14,6,'#cc3333');
R(bx-14,seatY-50,28,42,_sc);
R(bx-22,seatY-46,10,30,'#d4a574');R(bx+12,seatY-46,10,30,'#d4a574');
C(bx-18,seatY-14,5,'#d4a574');C(bx+18,seatY-14,5,'#d4a574');
C(bx-20,seatY-30,6,'#c4955e');C(bx+20,seatY-30,6,'#c4955e');
C(bx,seatY-62,14,'#d4a574');if(_hc)R(bx-14,seatY-70,28,4,_hc);
R(bx-6,seatY-64,4,2,'#111');R(bx+2,seatY-64,4,2,'#111');
cx.strokeStyle='#111';cx.lineWidth=1.5;cx.beginPath();cx.arc(bx,seatY-56,4,0.2,Math.PI-0.2);cx.stroke();
var bob=Math.sin(Date.now()/400)*3;
T('z',bx+18,seatY-72+bob,11,'#444');
T('z',bx+26,seatY-80+bob,13,'#444');
T('Z',bx+34,seatY-88+bob,16,'#444');
}

function drawMaSitting(bx,by){
var seatY=by;
var br=Math.sin(Date.now()/1200)*1;
// Legs — housecoat drape
R(bx-14,seatY-10,28,10,'#8b6f8b');
R(bx+6,seatY,10,30,'#8b6f8b');R(bx-16,seatY,10,30,'#8b6f8b');
// Slippers
R(bx+4,seatY+28,16,6,'#6b4f3d');R(bx-18,seatY+28,16,6,'#6b4f3d');
// Torso — housecoat
R(bx-14,seatY-50+br,28,42,'#8b6f8b');
// Collar detail
R(bx-4,seatY-50+br,8,10,'#7a5e7a');
// Arms — sleeves then skin
R(bx-22,seatY-46+br,10,14,'#8b6f8b');R(bx-22,seatY-32+br,10,16,'#d4a574');
R(bx+12,seatY-46+br,10,14,'#8b6f8b');R(bx+12,seatY-32+br,10,16,'#d4a574');
// Hands
C(bx-18,seatY-14+br,5,'#d4a574');C(bx+18,seatY-14+br,5,'#d4a574');
// Coffee mug in right hand
R(bx+14,seatY-22+br,10,12,'#f5f0e0');R(bx+24,seatY-18+br,4,6,'#f5f0e0');
R(bx+15,seatY-21+br,8,3,'#3a2a1a');
// Steam
var st=Math.sin(Date.now()/400)*3;
cx.globalAlpha=0.3;C(bx+18,seatY-28+br+st,2,'#ccc');C(bx+20,seatY-32+br+st,2,'#ccc');cx.globalAlpha=1;
// Head
C(bx+br,seatY-62+br,14,'#d4a574');
// Gray hair — top cap (half circle, above face only)
cx.fillStyle='#aaaaaa';cx.beginPath();cx.arc(bx+br,seatY-62+br,14,Math.PI,0);cx.fill();
// Part line
R(bx-1+br,seatY-76+br,2,10,'#999');
// Side strands — hang from temples, away from face
R(bx-16+br,seatY-68+br,5,38,'#aaaaaa');R(bx-14+br,seatY-66+br,3,42,'#999');
R(bx+11+br,seatY-68+br,5,38,'#aaaaaa');R(bx+13+br,seatY-66+br,3,42,'#999');
// Wispy ends
R(bx-17+br,seatY-30+br,4,6,'#bbb');R(bx+12+br,seatY-30+br,4,6,'#bbb');
// Eyes
R(bx-5+br,seatY-64+br,3,2,'#111');R(bx+3+br,seatY-64+br,3,2,'#111');
// Glasses
cx.strokeStyle='#888';cx.lineWidth=0.8;
cx.beginPath();cx.arc(bx-3+br,seatY-63+br,5,0,Math.PI*2);cx.stroke();
cx.beginPath();cx.arc(bx+4+br,seatY-63+br,5,0,Math.PI*2);cx.stroke();
cx.beginPath();cx.moveTo(bx+1+br,seatY-63+br);cx.lineTo(bx-1+br,seatY-63+br);cx.stroke();
// Nose — small bump
R(bx+br,seatY-60+br,2,3,'#c89a64');
// Mouth — slight frown
R(bx-3+br,seatY-56+br,6,1.5,'#111');
}

function drawTarkInjured(bx,by){
var seatY=by;
var t=Date.now();
var tremble=Math.sin(t/60)*2; // constant trembling
var rock=Math.sin(t/800)*3; // slow rocking forward/back

// Legs splayed out — one straight, one bent awkwardly
R(bx-18,seatY-4,10,34,'#2a2a2a'); // left leg hanging
cx.save();cx.translate(bx+10,seatY);cx.rotate(0.4);R(-5,-4,10,32,'#2a2a2a');cx.restore(); // right leg bent out
R(bx-20,seatY+28,14,6,'#cc3333');R(bx+18,seatY+24,14,6,'#cc3333'); // shoes

// Torso hunched way forward — leaning over knees
var hunchX=bx+rock;
var hunchY=seatY-30+rock*0.5;
cx.save();
cx.translate(hunchX,hunchY);
cx.rotate(0.35+rock*0.01); // tilted forward
R(-14+tremble,-22,28,36,getTarkShirtColor()); // torso (hunched)
cx.restore();

// Left arm clutching right knee in pain
R(hunchX-22+tremble,hunchY-10,10,34,'#d4a574'); // upper arm down
C(hunchX-16+tremble,hunchY+24,5,'#d4a574'); // hand on knee

// Right arm dangling limp
R(hunchX+14+tremble,hunchY-8,10,28,'#d4a574');
C(hunchX+18+tremble,hunchY+20,5,'#d4a574'); // hand dangling

// Elbow patches (pain detail)
C(hunchX-18+tremble,hunchY+2,6,'#c4955e');
C(hunchX+20+tremble,hunchY+0,6,'#c4955e');

// Head hanging down, chin on chest
var headY=hunchY-34+Math.abs(rock)*0.5;
C(hunchX+4+tremble,headY,14,'#d4a574'); // head tilted forward
var _hcI=getTarkHeadbandColor();if(_hcI)R(hunchX-10+tremble,headY-8,28,4,_hcI); // headband

// Grimace face — squinted eyes, gritted teeth
R(hunchX-1+tremble,headY-3,3,1,'#111'); // left eye squinting shut
R(hunchX+6+tremble,headY-3,3,1,'#111'); // right eye squinting shut
// Gritted teeth
cx.strokeStyle='#111';cx.lineWidth=1.5;
cx.beginPath();cx.moveTo(hunchX-1+tremble,headY+5);cx.lineTo(hunchX+7+tremble,headY+6);cx.stroke();
cx.strokeStyle='#fff';cx.lineWidth=0.8;
for(var ti=0;ti<3;ti++){
  var tx2=hunchX+1+ti*2+tremble;
  cx.beginPath();cx.moveTo(tx2,headY+4);cx.lineTo(tx2,headY+7);cx.stroke();
}

// Sweat drops flying off
for(var si=0;si<3;si++){
  var sd=t/200+si*2.1;
  var sx=hunchX-8+si*14+Math.sin(sd)*6+tremble;
  var sy=headY-16-Math.abs(Math.sin(sd*1.3))*12;
  cx.globalAlpha=0.5+Math.sin(sd)*0.3;
  C(sx,sy,2,'#6699cc');
}
cx.globalAlpha=1;

// Pain stars rotating around head
for(var pi=0;pi<4;pi++){
  var pa=t/400+pi*1.57;
  var px=hunchX+4+tremble+Math.cos(pa)*22;
  var py=headY-6+Math.sin(pa)*14;
  cx.globalAlpha=0.6+Math.sin(t/300+pi)*0.3;
  T('*',px,py,12,'#ffcc00');
}
cx.globalAlpha=1;

// Cigarette in right hand if given one
if(S.dnfHasCig){
  var cigX=hunchX+18+tremble,cigY=hunchY+20;
  R(cigX,cigY-1,16,2,'#f5f0e0'); // cigarette
  C(cigX+17,cigY,2,'#ff6600'); // lit end
  // Smoke rising from cig
  for(var ci=0;ci<3;ci++){
    var ct=t/300+ci*1.8;
    var csx=cigX+16+Math.sin(ct)*5;
    var csy=cigY-6-ci*10-Math.abs(Math.sin(ct*1.2))*6;
    cx.globalAlpha=0.2-ci*0.05;
    C(csx,csy,2+ci,'#999');
  }
  cx.globalAlpha=1;
}

// "ugh..." text bobbing (only if no cig yet)
if(!S.dnfHasCig){
  var ughBob=Math.sin(t/500)*3;
  cx.globalAlpha=0.5+Math.sin(t/600)*0.2;
  T('ugh...',hunchX+36,headY-10+ughBob,10,'#cc4444');
  cx.globalAlpha=1;
}
}

function drawTarkChalking(x,y,t){
// Standing, hands clapping together in front
var clap=Math.sin(t*12)*4;
var _sc=getTarkShirtColor(),_hc=getTarkHeadbandColor();
// Legs
R(x-12,y+30,10,38,'#2a2a2a');R(x+2,y+30,10,38,'#2a2a2a');
R(x-14,y+66,14,6,'#cc3333');R(x+0,y+66,14,6,'#cc3333');
// Torso
R(x-16,y-10,32,42,_sc);
// Arms coming together
R(x-18,y-4,10,24,'#d4a574');R(x+8,y-4,10,24,'#d4a574');
// Hands clapping in center
C(x-4+clap,y+20,6,'#eee');C(x+4-clap,y+20,6,'#eee');
// Head
C(x,y-22,16,'#d4a574');
if(_hc)R(x-16,y-30,32,4,_hc);
C(x-5,y-24,2,'#111');C(x+5,y-24,2,'#111');
R(x-4,y-16,8,2,'#111');
// Chalk cloud particles
for(var i=0;i<6;i++){
var age=t*3+i*1.1;
var px=x+Math.sin(age*2+i)*14;
var py=y+10-Math.abs(Math.sin(age))*20-i*4;
var sz=2+Math.sin(age)*1;
cx.globalAlpha=Math.max(0,0.6-i*0.1);
C(px,py,sz,'#fff');
}
cx.globalAlpha=1;
}

function drawTarkPumping(x,y,t){
// Dumbbell curl animation
var curl=Math.sin(t*6)*18; // arm goes up and down
var grunt=Math.abs(Math.sin(t*6))>0.8;
var _sc=getTarkShirtColor(),_hc=getTarkHeadbandColor();
// Legs slightly apart
R(x-14,y+30,10,38,'#2a2a2a');R(x+4,y+30,10,38,'#2a2a2a');
R(x-16,y+66,14,6,'#cc3333');R(x+2,y+66,14,6,'#cc3333');
// Torso — slight lean
R(x-16,y-10,32,42,_sc);
// Left arm — holding dumbbell, curling
R(x-22,y-4-curl*0.3,10,20+curl*0.3,'#d4a574');
C(x-18,y+16-curl,5,'#d4a574');
// Dumbbell in left hand
R(x-28,y+12-curl,24,5,'#555');C(x-28,y+14-curl,5,'#444');C(x-4,y+14-curl,5,'#444');
// Right arm — holding dumbbell at rest (slight motion)
var curl2=Math.sin(t*6+Math.PI)*18;
R(x+12,y-4-curl2*0.3,10,20+curl2*0.3,'#d4a574');
C(x+16,y+16-curl2,5,'#d4a574');
// Dumbbell in right hand
R(x+4,y+12-curl2,24,5,'#555');C(x+4,y+14-curl2,5,'#444');C(x+28,y+14-curl2,5,'#444');
// Head
var bob=Math.sin(t*6)*2;
C(x,y-22+bob,16,'#d4a574');
if(_hc)R(x-16,y-30+bob,32,4,_hc);
C(x-5,y-24+bob,2,'#111');C(x+5,y-24+bob,2,'#111');
// Mouth — grimace when curling hard
if(grunt){cx.strokeStyle='#111';cx.lineWidth=1.5;cx.beginPath();cx.arc(x,y-14+bob,4,0.2,Math.PI-0.2);cx.stroke();}
else{R(x-4,y-16+bob,8,2,'#111');}
// Sweat drops
for(var i=0;i<3;i++){
var dy=(t*40+i*80)%60;
cx.globalAlpha=Math.max(0,1-dy/60);
C(x-20+i*20,y-30+dy,1.5,'#6699cc');
}
cx.globalAlpha=1;
}

function drawTarkShaking(x,y,t){
var off=Math.sin(t*20)*5;
drawTarkIdle(x,y,false);
R(x+14,y-30+off,12,20,'#3a3a3a');
R(x+15,y-34+off,10,5,'#7fdb6a');
cx.strokeStyle='#7fdb6a44';cx.lineWidth=1;
for(var i=0;i<3;i++){
var sx=x+10+off+i*8,sy=y-38-i*3+Math.sin(t*18+i)*2;
cx.beginPath();cx.moveTo(sx,sy);cx.lineTo(sx+4,sy-4);cx.stroke();
}
}

function drawTarkSmoking(x,y,t){
drawTarkIdle(x,y,false);
R(x+4,y-18,14,2,'#f5f0e0');
C(x+19,y-17,2,'#ff6600');
for(var i=0;i<4;i++){
var sx=x+17+Math.sin(t*4+i)*8,sy=y-24-i*14-t*15;
cx.globalAlpha=0.25-i*0.05;
C(sx,sy,3+i*2,'#777');
}
cx.globalAlpha=1;
}

function drawTarkWalking(x,y){
S.stepT+=0.18;
var step=Math.sin(S.stepT)*6;
var bob=Math.abs(step)*0.3;
var _sc=getTarkShirtColor(),_hc=getTarkHeadbandColor();
R(x-12,y+30+step,10,38-bob,'#2a2a2a');R(x+2,y+30-step,10,38-bob,'#2a2a2a');
R(x-14,y+66,14,6,'#cc3333');R(x,y+66,14,6,'#cc3333');
R(x-16,y-10-bob,32,42,_sc);drawTarkAbs(x,y-10-bob,42);
R(x-24,y-6-step*0.5-bob,10,30,'#d4a574');if(!S._hideRightArm){R(x+14,y-6+step*0.5-bob,10,30,'#d4a574');}
C(x-20,y+4-bob,6,'#c4955e');if(!S._hideRightArm){C(x+20,y+4-bob,6,'#c4955e');}
C(x-19,y+26-step*0.5-bob,5,'#d4a574');if(!S._hideRightArm){C(x+19,y+26+step*0.5-bob,5,'#d4a574');}
C(x,y-22-bob,16,'#d4a574');if(_hc)R(x-16,y-30-bob,32,4,_hc);
C(x-5,y-24-bob,2,'#111');C(x+5,y-24-bob,2,'#111');
R(x-4,y-16-bob,8,2,'#111');
}

// --- Wimp ---
var WIMP_ACTS=[
{name:'curls',stopX:655,dur:240,msg:'Some guy in khakis picked up the 2lb dumbbells. He is curling them like his life depends on it.'},
{name:'selfie',stopX:645,dur:180,msg:'Someone just walked in and took a gym selfie. He did not do a single rep.'},
{name:'jacks',stopX:620,dur:200,msg:'A man is doing the world\'s most halfhearted jumping jacks.'},
{name:'jog',stopX:635,dur:160,msg:'A guy is jogging in place. He is drenched in sweat and it has been 8 seconds.'}
];

function drawDumbbells(){
if(S.phase!=='gym')return;
if(S.wimp.phase==='acting'&&S.wimp.act==='curls')return;
var L=typeof getLayout==='function'?getLayout():(S&&S.phase==='gym'?LAYOUT.gym:LAYOUT.comp);
var dx=L.dumbX||500,dy=386;
R(dx,dy,14,4,'#aaa');R(dx-2,dy-2,4,8,'#ff69b4');R(dx+12,dy-2,4,8,'#ff69b4');
R(dx+20,dy,14,4,'#aaa');R(dx+18,dy-2,4,8,'#ff69b4');R(dx+32,dy-2,4,8,'#ff69b4');
T('2 LB',dx+16,dy-7,7,'#ff69b4');
}

function drawWimp(){
var w=S.wimp;
if(w.phase==='inactive')return;
var wx=w.x,wy=340,at=w.actT;
var walking=(w.phase==='entering'||w.phase==='leaving'||w.phase==='dnf_running'||w.phase==='dnf_toGirl'||w.phase==='dnf_exit');
var legStep=walking?(w.phase==='dnf_running'?Math.sin(at*0.3)*7:Math.sin(at*0.18)*5):0;
var act=w.phase==='acting'?w.act:(w.phase==='dnf_giving'?'cig_handoff':'');
var jb=0,legSpread=0,jp=0;
if(act==='jog'){jb=Math.abs(Math.sin(at*0.2))*12;}
if(w.phase==='dnf_running'){jb=Math.abs(Math.sin(at*0.25))*10;}
if(act==='jacks'){jp=(Math.sin(at*0.15)+1)/2;jb=jp*6;legSpread=jp*10;}
R(wx-9-legSpread,wy+20+legStep-jb,9,28,'#8B7D6B');
R(wx+1+legSpread,wy+20-legStep-jb,9,28,'#8B7D6B');
R(wx-11-legSpread,wy+46+legStep-jb,13,6,'#cccccc');
R(wx-1+legSpread,wy+46-legStep-jb,13,6,'#cccccc');
R(wx-13,wy-10-jb,26,32,'#446688');
R(wx-6,wy-12-jb,12,4,'#3a5a7a');
C(wx,wy+10-jb,8,'#4a6a8a');
R(wx-13,wy+18-jb,26,3,'#5a4a3a');
C(wx,wy+19-jb,2,'#aa9944');
if(act==='curls'){
var cyc=Math.sin(at*0.08);
var lUp=Math.max(0,cyc)*28;
var rUp=Math.max(0,-cyc)*28;
R(wx-20,wy-4,8,14,'#d4a574');R(wx+13,wy-4,8,14,'#d4a574');
R(wx-20,wy+10-lUp,8,Math.max(4,12-lUp*0.3),'#d4a574');
R(wx+13,wy+10-rUp,8,Math.max(4,12-rUp*0.3),'#d4a574');
R(wx-28,wy+16-lUp,22,6,'#ff69b4');R(wx-30,wy+14-lUp,4,10,'#e05599');R(wx-8,wy+14-lUp,4,10,'#e05599');
R(wx+7,wy+16-rUp,22,6,'#ff69b4');R(wx+5,wy+14-rUp,4,10,'#e05599');R(wx+27,wy+14-rUp,4,10,'#e05599');
if(Math.abs(cyc)>0.6){T('HNGG',wx,wy-42,9,'#ff6666');}
}else if(act==='selfie'){
R(wx-20,wy-2,8,20,'#d4a574');C(wx-16,wy+18,4,'#d4a574');
R(wx+13,wy-28,8,26,'#d4a574');
R(wx+12,wy-46,14,18,'#222');R(wx+13,wy-44,12,14,'#4488ff');
C(wx+19,wy-38,3,'#d4a574');C(wx+19,wy-46,1.5,'#666');
var flashPhase=Math.sin(at*0.035);
if(flashPhase>0.85){cx.globalAlpha=0.35;C(wx+19,wy-37,30,'#ffffff');cx.globalAlpha=0.6;C(wx+19,wy-37,14,'#ffffff');cx.globalAlpha=1;}
}else if(act==='jacks'){
var armOutX=jp*16;var armUpY=jp*32;
R(wx-20-armOutX,wy-4-armUpY-jb,8,Math.max(6,20-armUpY*0.3),'#d4a574');
R(wx+13+armOutX,wy-4-armUpY-jb,8,Math.max(6,20-armUpY*0.3),'#d4a574');
C(wx-16-armOutX*1.2,wy+14-armUpY*1.1-jb,4,'#d4a574');
C(wx+17+armOutX*1.2,wy+14-armUpY*1.1-jb,4,'#d4a574');
}else if(act==='jog'){
var pump=Math.sin(at*0.2)*12;
R(wx-20,wy-4+pump-jb,8,18,'#d4a574');R(wx+13,wy-4-pump-jb,8,18,'#d4a574');
C(wx-16,wy+14+pump-jb,4,'#d4a574');C(wx+17,wy+14-pump-jb,4,'#d4a574');
if(at>20){for(var si=0;si<4;si++){var sd=(at*2+si*30)%80;var sdx=wx+8+sd*0.8;var sdy=wy-18-sd*0.5-jb;if(sd<65)C(sdx,sdy,2.5,'#6699cc');}}
if(at>40){C(wx-4,wy-18-jb,4,'rgba(255,80,80,0.25)');C(wx+4,wy-18-jb,4,'rgba(255,80,80,0.25)');}
}else if(act==='cig_handoff'){
// Left arm extended toward Tark holding a cigarette
R(wx-20,wy-4,8,14,'#d4a574'); // upper left arm
R(wx-32,wy+2,14,7,'#d4a574'); // forearm reaching out
C(wx-36,wy+5,4,'#d4a574'); // hand
// Only show cig in wimp's hand until Tark takes it
if(!S.dnfHasCig){
R(wx-50,wy+3,16,2,'#f5f0e0'); // cigarette
C(wx-51,wy+4,2,'#ff6600'); // lit end
}
// Right arm on hip (casual)
R(wx+13,wy-2,8,16,'#d4a574');C(wx+17,wy+14,4,'#d4a574');
// Little speech prompt
if(at<60){cx.globalAlpha=0.8;T('"Here bro."',wx,wy-42,9,'#aaaaaa');cx.globalAlpha=1;}
}else if(w.phase==='dnf_exit'){
// Right arm around girl (reaching right)
R(wx-20,wy-4,8,22,'#d4a574');C(wx-16,wy+18,4,'#d4a574'); // left arm normal
R(wx+13,wy-6,8,10,'#d4a574');R(wx+20,wy-8,12,7,'#d4a574');C(wx+32,wy-5,4,'#d4a574'); // right arm around
}else{
R(wx-20,wy-4-jb,8,22,'#d4a574');R(wx+13,wy-4-jb,8,22,'#d4a574');
C(wx-16,wy+18-jb,4,'#d4a574');C(wx+17,wy+18-jb,4,'#d4a574');
}
C(wx,wy-22-jb,12,'#d4a574');
R(wx-9,wy-25-jb,7,5,'#555');R(wx+3,wy-25-jb,7,5,'#555');
cx.strokeStyle='#555';cx.lineWidth=1;cx.beginPath();cx.moveTo(wx-2,wy-23-jb);cx.lineTo(wx+3,wy-23-jb);cx.stroke();
C(wx-6,wy-23-jb,1.5,'#111');C(wx+6,wy-23-jb,1.5,'#111');
R(wx-10,wy-32-jb,4,5,'#8B6B4B');R(wx-5,wy-33-jb,3,4,'#8B6B4B');R(wx+6,wy-32-jb,4,5,'#8B6B4B');
cx.strokeStyle='#c4955e';cx.lineWidth=1.5;cx.beginPath();cx.arc(wx,wy-15-jb,3,0.3,Math.PI-0.3);cx.stroke();
if(act==='selfie'){C(wx,wy-15-jb,3,'#d4a574');C(wx,wy-14-jb,2.5,'#c4955e');}
}

function updateWimp(){
var w=S.wimp;
// Wimp only does normal cycles in gym; DNF phases always proceed
var isDnf=w.phase==='dnf_running'||w.phase==='dnf_giving'||w.phase==='dnf_toGirl'||w.phase==='dnf_exit';
if(S.phase!=='gym'&&!isDnf){
  // In competition: if mid-cycle, send him off-screen
  if(w.phase!=='inactive'){w.phase='inactive';w.timer=9999;}
  return;
}
if(w.phase==='inactive'){
w.timer--;
if(w.timer<=0){
var a=WIMP_ACTS[Math.floor(Math.random()*WIMP_ACTS.length)];
w.act=a.name;w.destX=a.stopX;w.dur=a.dur;w.msg=a.msg;
w.x=-30;w.actT=0;w.phase='entering';
log(w.msg,'rest');
}
return;
}
w.actT++;
if(w.phase==='entering'){w.x+=1.5;if(w.x>=w.destX){w.x=w.destX;w.phase='acting';w.actT=0;}return;}
if(w.phase==='acting'){if(w.actT>=w.dur){w.phase='leaving';var exits=['He left. Thank God.','He wandered off looking confused.','He checked his phone and walked out.','He muttered something about leg day and left.'];log(exits[Math.floor(Math.random()*exits.length)],'rest');}return;}
if(w.phase==='leaving'){w.x+=2;if(w.x>W+40){w.phase='inactive';w.timer=1800+Math.floor(Math.random()*1200);}}
// DNF sequence phases
if(w.phase==='dnf_running'){w.x-=5;if(w.x<=w.destX){w.x=w.destX;w.phase='dnf_giving';w.actT=0;log('"Here bro... you need this." He hands Tark a cigarette.','rest');}return;}
if(w.phase==='dnf_giving'){
  // Tark takes the cig partway through (wimp holds it out first)
  if(w.actT>=60&&!S.dnfHasCig)S.dnfHasCig=true;
  if(w.actT>=120){
    // Wimp walks toward the girls
    w.phase='dnf_toGirl';w.actT=0;
    w.destX=S.girls.x2-10; // walk to girl 2 (purple)
  }
  return;
}
if(w.phase==='dnf_toGirl'){
  w.x+=3;
  if(w.x>=w.destX){
    w.x=w.destX;
    w.phase='dnf_exit';w.actT=0;
    S.girls.wimpExit=true;
    log('He puts his arm around the girl in purple. They walk out together.','rest');
    log('The other girl follows, still laughing.','rest');
    S.girls.phase='leaving';S.girls.reactT=0;
  }
  return;
}
if(w.phase==='dnf_exit'){
  w.x+=2;
  // Girl 2 walks with the wimp, shoulder to shoulder
  if(S.girls.wimpExit){S.girls.x2=w.x+20;}
  if(w.x>W+50){
    w.phase='inactive';w.timer=9999;
    if(!S._pakAutoStarted){
      S._pakAutoStarted=true;
      console.log('[DNF] wimp exit fired, pakAttempt='+S.turn.pakAttempt+', pakDone='+S.turn.pakDone+', liftType='+S.turn.liftType);
      // Show leaderboard on TV while rivals finish
      S.tv.mode='leaderboard';
      setTimeout(function(){
        try{
          log('===============================','injury');
          log('The remaining lifts play out on the TV...','phase');
          autoCompletePakLifts(function(){
            log('===============================','phase');
            log('The competition is over.','phase');
            try{unlock();showResults();}catch(e2){console.error('showResults error:',e2);setPhase('results');}
          });
        }catch(e){
          console.error('DNF->results error:',e);
          try{showResults();}catch(e3){setPhase('results');}
        }
      },1500);
    }
  }
}
}

// --- Girls ---
function drawOneGirl(gx,gy,color,color2,hairColor,hairHL,ponySide,phase,reactT,girlIdx){
var skin='#f0c4a8',skinSh='#dba88a';
var jb=0,armMode='idle',laughBend=0,shakeX=0;
if(phase==='entering'||phase==='leaving'){var walkT=reactT;var legStep=Math.sin(walkT*0.2)*4;var hipSway=Math.sin(walkT*0.15)*2;}else{var legStep=0;var hipSway=0;}
if(phase==='reacting'){var rr=S.girls.result;if(rr==='success'){jb=Math.abs(Math.sin(reactT*0.2))*8;armMode='cheer';}else if(rr==='fail'){armMode='laugh';var shakeEase=Math.min(1,reactT/30);shakeX=Math.sin(reactT*0.18+girlIdx*2)*1.5*shakeEase;if(girlIdx===1)laughBend=Math.min(8,reactT*0.15);}}
var dx=gx,dy=gy;
var upperX=gx+shakeX;
// Legs — long, slim, skin-colored with dark jeans/skirt
if(girlIdx===0){
// Girl 1: tight jeans
R(dx-5,dy+14+legStep-jb,5,22,'#1a2a4a');R(dx+1,dy+14-legStep-jb,5,22,'#1a2a4a');
R(dx-5,dy+34+legStep-jb,5,14,skin);
R(dx+1,dy+34-legStep-jb,5,14,skin);
}else{
// Girl 2: short skirt
R(dx-8,dy+10-legStep*0.2-jb,16,10,color2);
R(dx-5,dy+18+legStep-jb,5,28,skin);R(dx+1,dy+18-legStep-jb,5,28,skin);
}
// Shoes — cute heels
R(dx-7,dy+46+legStep-jb,9,4,girlIdx===0?'#ff4466':'#222');
R(dx-7,dy+48+legStep-jb,3,2,girlIdx===0?'#ff4466':'#222');
R(dx,dy+46-legStep-jb,9,4,girlIdx===0?'#ff4466':'#222');
R(dx,dy+48-legStep-jb,3,2,girlIdx===0?'#ff4466':'#222');
// Torso — crop top with shape (upper body uses upperX for subtle sway)
var ux=upperX;
R(ux-8,dy-14-jb+laughBend,16,26+hipSway*0.5,color);
// Neckline detail
R(ux-4,dy-14-jb+laughBend,8,4,skin);
// Waist — exposed midriff
R(ux-7,dy+10-jb+laughBend,14,5,skin);
R(ux-6,dy+10-jb+laughBend,12,2,skinSh);
// Chest shape
C(ux-3,dy-4-jb+laughBend,4,color);C(ux+3,dy-4-jb+laughBend,4,color);
// Arms
if(armMode==='cheer'){
// Both arms up celebrating
R(ux-13,dy-26-jb,5,20,skin);R(ux+8,dy-26-jb,5,20,skin);
C(ux-11,dy-30-jb,3,skin);C(ux+10,dy-30-jb,3,skin);
if(reactT>20){var hOff=reactT*0.8;var hAlpha=Math.max(0,1-reactT/120);cx.globalAlpha=hAlpha;T('\u2665',ux+ponySide*8,dy-38-hOff-jb,14,'#ff4488');cx.globalAlpha=1;}
}else if(armMode==='laugh'){
if(girlIdx===0){
// Girl 1: one hand covering mouth, other holding phone out recording
R(ux-11,dy-12+laughBend,5,8,skin);R(ux-11,dy-16+laughBend,5,6,skin);C(ux-9,dy-18+laughBend,3,skin);
// Phone in right hand, held out
R(ux+8,dy-18+laughBend,5,14,skin);
R(ux+12,dy-26+laughBend,6,10,'#222');R(ux+13,dy-25+laughBend,4,7,'#4488ff');
}else{
// Girl 2: doubled over, both hands on knees
R(ux-12,dy-2+laughBend,5,16,skin);C(ux-10,dy+14+laughBend,3,skin);
R(ux+8,dy-2+laughBend,5,16,skin);C(ux+10,dy+14+laughBend,3,skin);
}
}else if(phase==='gym_idle'){
if(girlIdx===0){
// Girl 1: checking phone
R(ux-12,dy-8-jb,5,22,skin);C(ux-10,dy+14-jb,3,skin);
R(ux+8,dy-14-jb,5,14,skin);
R(ux+6,dy-24-jb,10,14,'#222');R(ux+7,dy-23-jb,8,11,'#4488ff');
}else{
// Girl 2: hand on hip, other arm relaxed
R(ux-12,dy-8-jb,5,22,skin);C(ux-10,dy+14-jb,3,skin);
R(ux+8,dy-2-jb,5,12,skin);C(ux+12,dy+8-jb,3,skin);
}
}else{
// Idle: arms at sides, relaxed
R(ux-12,dy-8-jb,5,22,skin);R(ux+8,dy-8-jb,5,22,skin);
C(ux-10,dy+14-jb,3,skin);C(ux+10,dy+14-jb,3,skin);
}
// Hair back layer — long flowing hair behind the head
var hb=laughBend*0.3;
R(ux+ponySide*9,dy-28-jb+hb,4,28,hairColor);
R(ux+ponySide*10,dy-20-jb+hb,3,24,hairColor);
C(ux+ponySide*10,dy+2-jb+hb,2,hairColor);
// Hair volume — crown area (behind face)
C(ux,dy-28-jb+hb,11,hairColor);
R(ux-10,dy-30-jb+hb,20,5,hairColor);
C(ux+3,dy-30-jb+hb,4,hairHL);
// Head — face skin ON TOP of hair so face is clearly visible
C(ux,dy-22-jb+hb,9,skin);
// Bangs — sit on forehead over the skin
R(ux-7,dy-30-jb+hb,14,4,hairColor);
R(ux-8,dy-28-jb+hb,6,3,hairColor);
// Blush
cx.globalAlpha=0.3;C(ux-5,dy-19-jb+hb,3,'#ff8888');C(ux+5,dy-19-jb+hb,3,'#ff8888');cx.globalAlpha=1;
// Earrings
C(ux-8,dy-16-jb+hb,1.5,girlIdx===0?'#ffd700':'#c0c0c0');
C(ux+8,dy-16-jb+hb,1.5,girlIdx===0?'#ffd700':'#c0c0c0');
// Face — drawn on top of skin circle
if(phase==='reacting'&&S.girls.result==='success'){
// Big sparkly eyes
C(ux-3,dy-22-jb+hb,2.5,'#fff');C(ux+3,dy-22-jb+hb,2.5,'#fff');
C(ux-3,dy-22-jb+hb,1.5,'#4a3020');C(ux+3,dy-22-jb+hb,1.5,'#4a3020');
C(ux-2,dy-23-jb+hb,0.7,'#fff');C(ux+4,dy-23-jb+hb,0.7,'#fff');
// Eyelashes
cx.strokeStyle='#2a1a10';cx.lineWidth=1;
cx.beginPath();cx.moveTo(ux-5,dy-23-jb+hb);cx.lineTo(ux-6,dy-25-jb+hb);cx.stroke();
cx.beginPath();cx.moveTo(ux+5,dy-23-jb+hb);cx.lineTo(ux+6,dy-25-jb+hb);cx.stroke();
// Open smile
cx.fillStyle='#cc4455';cx.beginPath();cx.arc(ux,dy-16-jb+hb,3,0,Math.PI);cx.fill();
cx.fillStyle='#fff';cx.fillRect(ux-2,dy-16.5-jb+hb,4,1.5);
// Lipstick
cx.strokeStyle=girlIdx===0?'#ee3355':'#cc3366';cx.lineWidth=0.8;cx.beginPath();cx.arc(ux,dy-16-jb+hb,3.5,0.3,Math.PI-0.3);cx.stroke();
}else if(phase==='reacting'&&S.girls.result==='fail'){
// Squinting laugh eyes — curved happy arcs
cx.strokeStyle='#4a3020';cx.lineWidth=1.5;
cx.beginPath();cx.arc(ux-3,dy-21-jb+hb,3,Math.PI+0.3,2*Math.PI-0.3);cx.stroke();
cx.beginPath();cx.arc(ux+3,dy-21-jb+hb,3,Math.PI+0.3,2*Math.PI-0.3);cx.stroke();
// Laugh tears on girl 2
if(girlIdx===1&&reactT>30){
cx.globalAlpha=Math.min(1,(reactT-30)/20);
C(ux-6,dy-18-jb+hb+Math.sin(reactT*0.1)*2,1.5,'#66ccff');
C(ux+6,dy-17-jb+hb+Math.cos(reactT*0.1)*2,1.5,'#66ccff');
cx.globalAlpha=1;
}
// Wide open laughing mouth
cx.fillStyle='#aa3344';cx.beginPath();cx.arc(ux,dy-15-jb+hb,4,0,Math.PI*2);cx.fill();
cx.fillStyle='#fff';cx.fillRect(ux-3,dy-17-jb+hb,6,2);
// Lipstick
cx.strokeStyle=girlIdx===0?'#ee3355':'#cc3366';cx.lineWidth=0.6;cx.beginPath();cx.arc(ux,dy-15-jb+hb,4.5,0.5,Math.PI-0.5);cx.stroke();
}else{
// Resting pretty face
C(ux-3,dy-22-jb,2,'#fff');C(ux+3,dy-22-jb,2,'#fff');
C(ux-3,dy-22-jb,1,'#4a3020');C(ux+3,dy-22-jb,1,'#4a3020');
// Eyelashes
cx.strokeStyle='#2a1a10';cx.lineWidth=0.8;
cx.beginPath();cx.moveTo(ux-5,dy-23-jb);cx.lineTo(ux-6,dy-24.5-jb);cx.stroke();
cx.beginPath();cx.moveTo(ux+5,dy-23-jb);cx.lineTo(ux+6,dy-24.5-jb);cx.stroke();
// Slight smile with lipstick
cx.strokeStyle=girlIdx===0?'#ee3355':'#cc3366';cx.lineWidth=1;
cx.beginPath();cx.arc(ux,dy-16-jb,2.5,0.2,Math.PI-0.2);cx.stroke();
}
}

function drawGirls(){
var g=S.girls;
if(g.phase==='absent')return;
var gy=350;
// Girl 1: pink crop top, blonde hair with light highlights, gold earrings
drawOneGirl(g.x1,gy,'#ff6b8a','#ff4466','#f0d060','#fff0a0',-1,g.phase,g.reactT,0);
// Girl 2: purple crop top, dark hair with auburn highlights, silver earrings
drawOneGirl(g.x2,gy,'#9966cc','#7744aa','#3a2a1a','#6a4a3a',1,g.phase,g.reactT,1);
// Gym idle — girls chatting among themselves (white speech bubbles)
if(g.phase==='gym_idle'){
var idleTexts=['So anyway...','Did you see that?','lol','Omg','No way','Ugh men','Slay','Whatever'];
var idxCycle=Math.floor(g.reactT/180)%idleTexts.length;
var tInCycle=g.reactT%180;
if(tInCycle<120){
var bubAlpha=tInCycle<10?tInCycle/10:tInCycle>100?Math.max(0,1-(tInCycle-100)/20):1;
cx.globalAlpha=bubAlpha;
var speaker=(Math.floor(g.reactT/180)%2===0)?g.x2:g.x1;
drawWhiteBubble(speaker,gy-65,idleTexts[idxCycle],8);
cx.globalAlpha=1;
}
}
if(g.phase==='reacting'){
if(g.result==='fail'){
// Cycling laugh texts — white speech bubbles
var laughTexts=['LMAOOO','IM DEAD','HAHAHA','STOOOP','NO WAY','BYE','I CANT'];
var laughIdx=Math.floor(g.reactT/12)%laughTexts.length;
// Girl 1 laugh bubble
if(g.reactT>8&&g.reactT<110){
var la1=Math.max(0,1-(g.reactT-8)/102);
cx.globalAlpha=la1;
var bob1=Math.sin(g.reactT*0.3)*3;
drawWhiteBubble(g.x1,gy-65+bob1,laughTexts[laughIdx],9);
cx.globalAlpha=1;
}
// Girl 2 laugh bubble — offset timing
if(g.reactT>18&&g.reactT<115){
var la2=Math.max(0,1-(g.reactT-18)/97);
cx.globalAlpha=la2;
var laughIdx2=(laughIdx+3)%laughTexts.length;
var bob2=Math.sin(g.reactT*0.35+1)*3;
drawWhiteBubble(g.x2,gy-65+bob2,laughTexts[laughIdx2],9);
cx.globalAlpha=1;
}
// Shared big text — keep as emoji float (not dialogue)
if(g.reactT>25&&g.reactT<90){
var bigAlpha=Math.max(0,Math.min(1,(g.reactT-25)/10)*Math.max(0,1-(g.reactT-60)/30));
cx.globalAlpha=bigAlpha;
var shake=Math.sin(g.reactT*0.6)*3;
T('\uD83D\uDE02 \uD83D\uDE02 \uD83D\uDE02',(g.x1+g.x2)/2+shake,gy-80,14,'#ffaa00');
cx.globalAlpha=1;
}
}
if(g.result==='success'&&g.reactT>10&&g.reactT<80){var cheerAlpha=Math.max(0,1-(g.reactT-10)/70);cx.globalAlpha=cheerAlpha;drawWhiteBubble((g.x1+g.x2)/2,gy-60-g.reactT*0.3,'OMG!!',12);cx.globalAlpha=1;}
}
}

function updateGirls(){
var g=S.girls;
if(g.phase==='absent')return;
if(g.phase==='gym_idle'){g.reactT++;if(g.chatCooldown>0)g.chatCooldown--;return;}
g.reactT++;
if(g.phase==='entering'){g.x1-=3.5;g.x2-=3.5;if(g.x1<=770){g.x1=770;g.x2=810;g.phase='watching';g.reactT=0;}return;}
if(g.phase==='watching'){if(g.result){g.phase='reacting';g.reactT=0;if(g.result==='success'){log('The girls are losing their minds. They\'ve never seen anything like this.','lift');}else{var laughMsgs=['One of them is literally recording this on her phone.','The blonde one is crying laughing. The other one can\'t even stand up straight.','One of them wheezed "STOOOP" but she clearly didn\'t mean it.','They\'re both doubled over. One of them said "I can\'t breathe."','The dark-haired one is slapping her knee. The blonde just said "BYE."'];log(laughMsgs[Math.floor(Math.random()*laughMsgs.length)],'fail');}}return;}
if(g.phase==='reacting'){if(!S.dnf&&g.reactT>=120){g.phase='leaving';var exitMsgs=['The girls left. One of them was still wheezing.','They walked away. The blonde one yelled "GOOD LUCK" without looking back.','The girls headed out. Tark heard one of them go "oh my god" in the hallway.','They left still giggling. Tark will think about this moment at 3am for years.'];log(exitMsgs[Math.floor(Math.random()*exitMsgs.length)],'rest');}return;}
if(g.phase==='leaving'){g.x1+=2.5;if(!g.wimpExit){g.x2+=2.5;}if(g.x1>W+40&&g.x2>W+40){g.phase='absent';g.result=null;g.wimpExit=false;}}
}

// --- Walk engine ---
function walkTo(destX,cb){
if(typeof destX!=='number'||isNaN(destX)){destX=S.homeX||300;}
S.walkDest=destX;S.walkCb=cb;S.pose='walking';S.stepT=0;
}
function walkBack(cb){walkTo(S.homeX,cb);}
function updateWalk(){
if(S.pose!=='walking')return;
// Safety: fix NaN position
if(isNaN(S.tX)){S.tX=S.homeX||300;}
if(isNaN(S.walkDest)){S.walkDest=S.homeX||300;}
var dx=S.walkDest-S.tX;var speed=4;
if(Math.abs(dx)<=speed+1){S.tX=S.walkDest;var cb=S.walkCb;S.walkCb=null;if(cb)cb();}
else{S.tX+=(dx>0)?speed:-speed;}
}

// ============================================================
// PART 3 — GAME LOGIC: State, Actions, UI, Boot
// "The Meet" — Tark Farley's Weightlifting Competition
// Wrapped in IIFE, exposes window.G
// ============================================================

window.G=(function(){

// --- SOUND ENGINE (Web Audio API, procedural) ---
var SFX=(function(){
var ctx=null,master=null,muted=false;
function init(){
  if(ctx)return;
  try{ctx=new(window.AudioContext||window.webkitAudioContext)();
  master=ctx.createGain();master.connect(ctx.destination);}catch(e){ctx=null;}
}
function osc(freq,type,dur,vol,ramp){
  if(!ctx||muted)return;
  var o=ctx.createOscillator(),g=ctx.createGain();
  o.type=type||'sine';o.frequency.value=freq;
  g.gain.value=vol||0.15;
  if(ramp)g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+dur);
  o.connect(g);g.connect(master);
  o.start(ctx.currentTime);o.stop(ctx.currentTime+dur);
}
function noise(dur,vol,filter){
  if(!ctx||muted)return;
  var buf=ctx.createBuffer(1,ctx.sampleRate*dur,ctx.sampleRate);
  var d=buf.getChannelData(0);
  for(var i=0;i<d.length;i++)d[i]=(Math.random()*2-1);
  var src=ctx.createBufferSource();src.buffer=buf;
  var g=ctx.createGain();g.gain.value=vol||0.08;
  g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+dur);
  if(filter){
    var f=ctx.createBiquadFilter();f.type=filter.type||'lowpass';f.frequency.value=filter.freq||800;
    src.connect(f);f.connect(g);
  }else{src.connect(g);}
  g.connect(master);src.start();
}
function metalClang(){
  if(!ctx||muted)return;
  osc(220,'square',0.08,0.2,true);
  osc(440,'square',0.06,0.12,true);
  osc(880,'triangle',0.04,0.08,true);
  noise(0.1,0.15,{type:'highpass',freq:2000});
}
function barDrop(){
  if(!ctx||muted)return;
  noise(0.3,0.2,{type:'lowpass',freq:400});
  osc(60,'sine',0.2,0.15,true);
  osc(45,'sine',0.35,0.1,true);
}
function crowdCheer(){
  if(!ctx||muted)return;
  noise(1.2,0.12,{type:'bandpass',freq:1200});
  noise(0.8,0.08,{type:'bandpass',freq:2400});
  setTimeout(function(){noise(0.6,0.06,{type:'bandpass',freq:1800});},200);
}
function crowdGroan(){
  if(!ctx||muted)return;
  noise(0.8,0.1,{type:'lowpass',freq:500});
  osc(120,'sine',0.6,0.06,true);
}
function sadTrombone(){
  if(!ctx||muted)return;
  var notes=[311,277,261,233];
  for(var i=0;i<notes.length;i++){
    (function(n,d){setTimeout(function(){osc(n,'sawtooth',0.35,0.08,true);},d);})(notes[i],i*350);
  }
}
function triumph(){
  if(!ctx||muted)return;
  var notes=[261,329,392,523];
  for(var i=0;i<notes.length;i++){
    (function(n,d){setTimeout(function(){osc(n,'triangle',0.3,0.1,true);osc(n*2,'sine',0.2,0.04,true);},d);})(notes[i],i*200);
  }
}
function siren(){
  if(!ctx||muted)return;
  var o=ctx.createOscillator(),g=ctx.createGain();
  o.type='sine';o.frequency.value=400;
  o.frequency.linearRampToValueAtTime(900,ctx.currentTime+0.5);
  o.frequency.linearRampToValueAtTime(400,ctx.currentTime+1.0);
  g.gain.value=0.1;g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+1.2);
  o.connect(g);g.connect(master);o.start();o.stop(ctx.currentTime+1.2);
}
function lighterFlick(){
  if(!ctx||muted)return;
  noise(0.06,0.12,{type:'highpass',freq:4000});
  setTimeout(function(){osc(1800,'sine',0.08,0.04,true);},60);
}
function glug(){
  if(!ctx||muted)return;
  for(var i=0;i<4;i++){
    (function(d){setTimeout(function(){osc(200+Math.random()*100,'sine',0.08,0.06,true);},d);})(i*100);
  }
}
function benchCreak(){
  if(!ctx||muted)return;
  osc(80,'sawtooth',0.15,0.05,true);
  osc(120,'sawtooth',0.1,0.03,true);
}
function heartbeat(bpm){
  if(!ctx||muted)return;
  osc(50,'sine',0.08,0.12,true);
  setTimeout(function(){osc(40,'sine',0.1,0.1,true);},120);
}
function plateClack(){
  if(!ctx||muted)return;
  osc(800,'square',0.03,0.08,true);
  noise(0.05,0.06,{type:'highpass',freq:3000});
}
function chalkClap(){
  if(!ctx||muted)return;
  noise(0.08,0.1,{type:'highpass',freq:2000});
  setTimeout(function(){noise(0.06,0.08,{type:'highpass',freq:2500});},100);
}
function toggleMute(){muted=!muted;if(master)master.gain.value=muted?0:1;return muted;}
function crowdRoar(){
  // Massive crowd eruption — for PRs and huge lifts
  if(!ctx||muted)return;
  noise(1.8,0.18,{type:'bandpass',freq:1200});
  noise(1.4,0.14,{type:'bandpass',freq:2400});
  setTimeout(function(){noise(1.0,0.12,{type:'bandpass',freq:1800});},150);
  setTimeout(function(){noise(0.8,0.08,{type:'bandpass',freq:3000});},300);
}
function lockoutImpact(){
  // Deep thud at lockout moment — sense of weight stopping
  if(!ctx||muted)return;
  osc(55,'sine',0.12,0.18,true);
  osc(110,'triangle',0.06,0.08,true);
  noise(0.04,0.1,{type:'lowpass',freq:300});
}
function psycheScream(){
  if(!ctx||muted)return;
  // Low sawtooth roar
  osc(120,'sawtooth',0.12,0.6,true);
  osc(180,'sawtooth',0.08,0.5,true);
  // Higher square yell
  setTimeout(function(){osc(350,'square',0.06,0.4,true);},80);
  // Breath noise
  setTimeout(function(){noise(0.07,0.35,{type:'bandpass',freq:800});},50);
}
function turnBuzzer(){
  // Competition buzzer — sharp double-beep like a gym timer
  if(!ctx||muted)return;
  osc(880,'square',0.15,0.12,false);
  osc(440,'square',0.08,0.12,false);
  setTimeout(function(){
    osc(880,'square',0.15,0.12,false);
    osc(440,'square',0.08,0.12,false);
  },180);
}
// --- 8-BIT MUSIC ENGINE ---
var _m={playing:false,track:null,step:0,timer:null,vol:1.0,fade:null};
var _C3=131,_D3=147,_E3=165,_F3=175,_G3=196,_A3=220,_B3=247,
_C4=262,_D4=294,_E4=330,_F4=349,_G4=392,_A4=440,_B4=494,
_C5=523,_D5=587,_E5=659,_F5=698,_G5=784,_A5=880;
var MT={
apartment:{bpm:80,loop:true,lv:0.03,bv:0.035,lt:'triangle',
lead:[_C4,0,0,0,_E4,0,0,0,_G4,0,0,0,_E4,0,0,0,_A4,0,0,0,_G4,0,0,0,_E4,0,0,0,_D4,0,0,0],
bass:[_C3,0,0,0,0,0,0,0,_F3,0,0,0,0,0,0,0,_A3,0,0,0,0,0,0,0,_G3,0,0,0,0,0,0,0],
drum:[1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},
beach:{bpm:95,loop:true,lv:0.035,bv:0.04,lt:'triangle',
lead:[_E4,0,_G4,0,_A4,0,_G4,0,_E4,0,_D4,0,_E4,0,_G4,0,_C5,0,0,0,_B4,0,_A4,0,_G4,0,0,0,0,0,0,0],
bass:[_A3,0,0,0,_A3,0,0,0,_D3,0,0,0,_D3,0,0,0,_E3,0,0,0,_E3,0,0,0,_A3,0,0,0,0,0,0,0],
drum:[1,0,0,0,2,0,0,0,1,0,3,0,2,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,2,0,1,0]},
gym:{bpm:110,loop:true,lv:0.04,bv:0.045,lt:'square',
lead:[_E4,0,_G4,0,_A4,0,_G4,0,_E4,0,_D4,0,_C4,0,0,0,_D4,0,_E4,0,_G4,0,_A4,0,_C5,0,_A4,0,_G4,0,0,0],
bass:[_C3,0,0,_C3,0,0,_G3,0,_A3,0,0,_A3,0,0,_E3,0,_F3,0,0,_F3,0,0,_C3,0,_G3,0,0,_G3,0,0,_C3,0],
drum:[1,0,3,0,2,0,3,0,1,0,3,0,2,0,1,3,1,0,3,0,2,0,3,0,1,0,3,0,2,0,1,3]},
warmup:{bpm:120,loop:true,lv:0.045,bv:0.05,lt:'square',
lead:[_G4,0,_B4,0,_D5,0,_B4,0,_A4,0,_G4,0,_A4,0,_B4,0,_C5,0,_B4,0,_A4,0,_G4,0,_A4,0,_B4,0,_G4,0,0,0],
bass:[_G3,0,0,_G3,0,0,_D3,0,_E3,0,0,_E3,0,0,_G3,0,_C3,0,0,_C3,0,0,_D3,0,_G3,0,0,0,_G3,0,0,0],
drum:[1,0,3,0,2,0,3,0,1,0,3,0,2,0,3,0,1,0,3,0,2,0,3,0,1,0,3,0,2,0,1,0]},
comp:{bpm:140,loop:true,lv:0.05,bv:0.055,lt:'square',
lead:[_E5,0,_E5,0,_D5,0,_B4,0,_C5,0,_B4,0,_A4,0,_B4,0,_E5,0,_G5,0,_E5,0,_D5,0,_B4,0,_A4,0,_B4,0,0,0],
bass:[_E3,0,0,_E3,0,0,_E3,0,_A3,0,0,_A3,0,0,_E3,0,_C3,0,0,_C3,0,0,_D3,0,_E3,0,0,0,_E3,0,_E3,0],
drum:[1,0,2,0,1,0,2,0,1,0,2,0,1,1,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,1]},
rest:{bpm:90,loop:true,lv:0.035,bv:0.04,lt:'triangle',
lead:[_C4,0,0,_E4,0,0,_G4,0,0,0,_A4,0,0,_G4,0,0,_E4,0,0,_D4,0,0,_C4,0,0,0,0,0,0,0,0,0],
bass:[_C3,0,0,0,_C3,0,0,0,_F3,0,0,0,_F3,0,0,0,_G3,0,0,0,_G3,0,0,0,_C3,0,0,0,0,0,0,0],
drum:[1,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},
results:{bpm:100,loop:true,lv:0.05,bv:0.05,lt:'square',
lead:[_C4,0,_E4,0,_G4,0,0,0,_C5,0,0,0,_G4,0,0,0,_A4,0,_C5,0,_E5,0,0,0,_G5,0,0,0,_C5,0,0,0],
bass:[_C3,0,0,0,_E3,0,0,0,_F3,0,0,0,_C3,0,0,0,_F3,0,0,0,_A3,0,0,0,_G3,0,0,0,_C3,0,0,0],
drum:[1,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,2,0,0,0,1,0,2,0,1,0,2,1]},
intro:{bpm:100,loop:true,lv:0.04,bv:0.045,lt:'square',
lead:[_A4,0,0,0,_E4,0,0,0,_F4,0,_E4,0,_D4,0,0,0,_A4,0,0,0,_C5,0,0,0,_B4,0,_A4,0,_E4,0,0,0],
bass:[_A3,0,0,0,_A3,0,0,0,_F3,0,0,0,_F3,0,0,0,_A3,0,0,0,_A3,0,0,0,_E3,0,0,0,_E3,0,0,0],
drum:[1,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0]}
};
function mNote(f,type,dur,vol){if(!ctx||muted||!f)return;var v=vol*_m.vol;if(v<0.001)return;
var o=ctx.createOscillator(),g=ctx.createGain();o.type=type;o.frequency.value=f;
g.gain.setValueAtTime(v,ctx.currentTime);g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+dur);
o.connect(g);g.connect(master);o.start(ctx.currentTime);o.stop(ctx.currentTime+dur+0.02);}
function mKick(){if(!ctx||muted)return;var v=0.06*_m.vol;if(v<0.001)return;
var o=ctx.createOscillator(),g=ctx.createGain();o.type='sine';
o.frequency.setValueAtTime(150,ctx.currentTime);o.frequency.exponentialRampToValueAtTime(40,ctx.currentTime+0.08);
g.gain.setValueAtTime(v,ctx.currentTime);g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+0.1);
o.connect(g);g.connect(master);o.start(ctx.currentTime);o.stop(ctx.currentTime+0.12);}
function mSnare(){if(!ctx||muted)return;noise(0.06,0.03*_m.vol,{type:'highpass',freq:2000});}
function mHat(){if(!ctx||muted)return;noise(0.03,0.015*_m.vol,{type:'highpass',freq:6000});}
function mTick(){if(!_m.playing||!_m.track)return;var t=MT[_m.track];if(!t)return;
var s=_m.step,sd=60/t.bpm/4,nd=sd*0.75;
if(t.lead[s])mNote(t.lead[s],t.lt||'square',nd,t.lv||0.04);
if(t.bass[s])mNote(t.bass[s],'triangle',nd*1.3,t.bv||0.05);
var d=t.drum[s];if(d===1)mKick();else if(d===2)mSnare();else if(d===3)mHat();
_m.step++;if(_m.step>=t.lead.length){if(t.loop)_m.step=0;else{mStop();return;}}
_m.timer=setTimeout(mTick,sd*1000);}
function mPlay(name){if(!ctx)return;if(_m.track===name&&_m.playing)return;
mStop();if(!MT[name])return;_m.playing=true;_m.track=name;_m.step=0;_m.vol=1.0;mTick();}
function mStop(){_m.playing=false;_m.track=null;_m.step=0;
if(_m.timer){clearTimeout(_m.timer);_m.timer=null;}
if(_m.fade){clearInterval(_m.fade);_m.fade=null;}_m.vol=1.0;}
function mFade(dur,cb){if(!_m.playing){if(cb)cb();return;}
var n=Math.max(1,Math.floor(dur*15)),ms=dur/n*1000,sv=_m.vol,i=0;
if(_m.fade)clearInterval(_m.fade);
_m.fade=setInterval(function(){i++;_m.vol=sv*(1-i/n);
if(i>=n){clearInterval(_m.fade);_m.fade=null;mStop();if(cb)cb();}},ms);}
function mSwitch(name){if(!ctx)return;if(_m.track===name&&_m.playing)return;
if(!name){mFade(0.5);return;}
if(_m.playing){mFade(0.4,function(){mPlay(name);});}else{mPlay(name);}}
return{init:init,metalClang:metalClang,barDrop:barDrop,crowdCheer:crowdCheer,
crowdGroan:crowdGroan,sadTrombone:sadTrombone,triumph:triumph,siren:siren,
lighterFlick:lighterFlick,glug:glug,benchCreak:benchCreak,heartbeat:heartbeat,
plateClack:plateClack,chalkClap:chalkClap,psycheScream:psycheScream,crowdRoar:crowdRoar,lockoutImpact:lockoutImpact,turnBuzzer:turnBuzzer,toggleMute:toggleMute,musicPlay:mPlay,musicStop:mStop,musicFade:mFade,musicSwitch:mSwitch,get muted(){return muted;}};
})();
window.SFX=SFX;

// --- CONSTANTS ---
// W, H, FY are in global scope (line 504). DO NOT redeclare here —
// Shopify's minifier renames IIFE-local vars, breaking cross-scope refs.
// LAYOUT and getLayout are also in global scope (before drawing functions)
function getZones(){
  // MAP overlay zones — highest priority (generated from MAP_LOCATIONS)
  if(S&&S.mapOpen){
    var mz={};
    for(var mi=0;mi<MAP_LOCATIONS.length;mi++){var ml=MAP_LOCATIONS[mi];mz[ml.zone]={x:ml.x,y:ml.y,w:ml.w,h:ml.h};}
    mz.mapCancel={x:370,y:438,w:160,h:32};
    return mz;
  }
  // Phone menu zones (rolodex card positions)
  if(S&&S.phase==='apartment'&&S.apartment.subMenu==='phone'){
    return {
      callGym:{x:255,y:170,w:170,h:70},
      callCoach:{x:255,y:250,w:170,h:70},
      callMother:{x:255,y:330,w:170,h:70},
      callRandom1:{x:470,y:170,w:170,h:70},
      callRandom2:{x:470,y:250,w:170,h:70},
      callRandom3:{x:470,y:330,w:170,h:70},
      closePhone:{x:370,y:365,w:160,h:24},
      helpBtn:{x:W-34,y:4,w:24,h:24}
    };
  }
  // Fridge interior zones
  if(S&&S.phase==='apartment'&&S.apartment.subMenu==='fridge'){
    return {
      eggs:{x:180,y:70,w:120,h:75},
      shake:{x:348,y:50,w:50,h:105},
      pizza:{x:180,y:205,w:150,h:70},
      coffee:{x:188,y:335,w:80,h:80},
      skip:{x:625,y:210,w:130,h:110},
      closeFridge:{x:716,y:26,w:43,h:43}
    };
  }
  // Bathroom interior zones
  if(S&&S.phase==='apartment'&&S.apartment.subMenu==='bathroom'){
    // Block interaction clicks during shower/mirror animation (but allow EXIT)
    if(S.apartment.bathroomPhase)return {closeBathroom:{x:826,y:16,w:58,h:43}};
    return {
      cold:{x:260,y:190,w:40,h:40},
      hot:{x:260,y:235,w:40,h:40},
      mirror:{x:548,y:68,w:234,h:246},
      closeBathroom:{x:826,y:16,w:58,h:43}
    };
  }
  // VHS selection zones
  if(S&&S.phase==='apartment'&&S.apartment.subMenu==='vhs'){
    return {
      pumping:{x:100,y:100,w:160,h:240},
      predator:{x:280,y:100,w:160,h:240},
      predator2:{x:460,y:100,w:160,h:240},
      rumping:{x:640,y:100,w:160,h:240},
      closeVHS:{x:816,y:16,w:68,h:43}
    };
  }
  // Door choice zones — street signs + go back + map
  if(S&&S.phase==='apartment'&&S.apartment.subMenu==='door'){
    var dz={
      doorBeach:{x:5,y:95,w:135,h:60},
      doorDowntown:{x:385,y:95,w:135,h:60},
      doorGym:{x:765,y:95,w:135,h:60},
      doorCancel:{x:340,y:277,w:100,h:20},
      mapBtn:{x:4,y:34,w:28,h:28}
    };
    if(!S.apartment.pickpocketAttempted)dz.hoboZone={x:178,y:342,w:80,h:55};
    if(!S.apartment.dogChaseAttempted)dz.dogZone={x:620,y:375,w:55,h:30};
    return dz;
  }
  // Downtown zones
  if(S&&S.phase==='downtown'){
    if(S.downtown.subMenu==='ma_house'){
      return {maFrontDoor:{x:380,y:230,w:80,h:95},maBack:{x:400,y:420,w:60,h:60},mapBtn:{x:4,y:34,w:28,h:28},helpBtn:{x:W-34,y:4,w:24,h:24}};
    }
    if(S.downtown.subMenu==='ma_living'){
      var _lz={maKitchenDoor:{x:820,y:200,w:80,h:140},maStaircase:{x:590,y:100,w:120,h:242},maBasementDoor:{x:558,y:278,w:44,h:64},maBack:{x:8,y:198,w:64,h:144},helpBtn:{x:W-34,y:4,w:24,h:24}};
      var _lq=S.downtown.maQuest;
      if(!_lq.complete)_lz.maTalkToMa={x:370,y:240,w:60,h:80};
      if(_lq.purseUnlocked&&!_lq.purseFound&&!_lq.purseChecked.couch)_lz.maPurseCouch={x:300,y:290,w:200,h:50};
      return _lz;
    }
    if(S.downtown.subMenu==='ma_kitchen'){
      var _kz={maBack:{x:0,y:200,w:55,h:142},helpBtn:{x:W-34,y:4,w:24,h:24}};
      var _kqz=S.downtown.maQuest;
      if(_kqz.started&&!_kqz.stoveOff)_kz.maStove={x:348,y:148,w:104,h:30};
      if(_kqz.started&&!_kqz.pillNoteRead)_kz.maFridgeNote={x:808,y:153,w:24,h:22};
      if(_kqz.purseUnlocked&&!_kqz.purseFound&&!_kqz.purseChecked.kitchen)_kz.maPurseTable={x:178,y:293,w:134,h:22};
      return _kz;
    }
    if(S.downtown.subMenu==='ma_upstairs'){
      return {maTarkDoor:{x:160,y:180,w:80,h:140},maMaDoor:{x:400,y:180,w:80,h:140},maBathDoor:{x:640,y:180,w:80,h:140},maBack:{x:0,y:240,w:72,h:100},helpBtn:{x:W-34,y:4,w:24,h:24}};
    }
    if(S.downtown.subMenu==='ma_basement'){
      var _bz={maBack:{x:0,y:90,w:80,h:220},helpBtn:{x:W-34,y:4,w:24,h:24}};
      var _bqz=S.downtown.maQuest;
      if(_bqz.started&&!_bqz.dressGot)_bz.maWasher={x:178,y:278,w:84,h:84};
      return _bz;
    }
    if(S.downtown.subMenu==='ma_tark_room'){
      var _tz={maBack:{x:8,y:178,w:74,h:164},helpBtn:{x:W-34,y:4,w:24,h:24}};
      var _tqz=S.downtown.maQuest;
      if(_tqz.purseUnlocked&&!_tqz.purseFound&&!_tqz.purseChecked.tarkRoom)_tz.maPurseLaundry={x:195,y:385,w:45,h:30};
      return _tz;
    }
    if(S.downtown.subMenu==='ma_ma_room'){
      var _mmz={maBack:{x:8,y:178,w:74,h:164},helpBtn:{x:W-34,y:4,w:24,h:24}};
      var _mmqz=S.downtown.maQuest;
      if(_mmqz.started&&!_mmqz.pillsGot)_mmz.maPills={x:588,y:280,w:35,h:32};
      return _mmz;
    }
    if(S.downtown.subMenu==='ma_bath'){
      var _bathz={maBack:{x:8,y:178,w:69,h:164},helpBtn:{x:W-34,y:4,w:24,h:24}};
      var _bathqz=S.downtown.maQuest;
      if(_bathqz.purseUnlocked&&!_bathqz.purseFound)_bathz.maPurseToilet={x:125,y:278,w:65,h:65};
      return _bathz;
    }
    if(S.downtown.subMenu==='bar'||S.downtown.subMenu==='bodega'||S.downtown.subMenu==='hotel'){
      return {dtBack:{x:20,y:H-32,w:100,h:20},helpBtn:{x:W-34,y:4,w:24,h:24}};
    }
    if(S.downtown.subMenu==='exit'){
      return {exitApt:{x:35,y:145,w:130,h:60},exitBeach:{x:385,y:145,w:130,h:60},exitGym:{x:735,y:145,w:130,h:60},exitCancel:{x:380,y:338,w:140,h:20}};
    }
    var dtz={downtownBar:{x:30,y:180,w:230,h:220},downtownBodega:{x:310,y:195,w:230,h:205},downtownHotel:{x:590,y:120,w:240,h:280},downtownExit:{x:850,y:350,w:50,h:50},helpBtn:{x:W-34,y:4,w:24,h:24},mapBtn:{x:4,y:34,w:28,h:28}};
    return dtz;
  }
  // Beach zones
  if(S&&S.phase==='beach'){
    // Couple close-up sub-menu
    if(S.beach.subMenu==='couple'){
      if(S.beach.closeupAnim)return {}; // no clicks during animation
      var cz={closeCouple:{x:838,y:10,w:52,h:30}};
      if(!S.beach.couples[S.beach.activeCouple].cowered){
        cz.beachManZone={x:590,y:348,w:65,h:120};
        cz.beachWomanZone={x:706,y:356,w:50,h:112};
        cz.beachShirtZone={x:162,y:366,w:36,h:44};
      }
      if(S.beach.beersLeft>0)cz.beachBeerZone={x:150,y:380,w:30,h:44};
      return cz;
    }
    // Beach gym competition
    if(S.beach.gymComp.active){
      var bg=S.beach.gymComp;
      var itemTblX=110,floorY2=380;
      if(bg.turn==='tark_declare'){
        var zn={};
        var tblY=floorY2-30;
        if(S.beach.beersLeft>0&&bg.beersUsed<3)zn.beerZone={x:itemTblX-32,y:tblY-22,w:24,h:30};
        if(S.cigsLeft>0&&bg.smokesUsed<3)zn.cigZone={x:itemTblX-12,y:tblY-18,w:24,h:28};
        if(S.chalkUses>0&&bg.chalksUsed<3)zn.chalkZone={x:itemTblX+12,y:tblY-28,w:26,h:36};
        if(bg.hasGirlfriend&&!bg.girlUsed)zn.girlZone={x:750-12,y:328-8,w:24,h:38};
        if(!bg.tauntUsed)zn.tauntZone={x:650-30,y:318,w:60,h:60};
        return zn;
      }
      return {};
    }
    // Main beach view
    var bz={beachExit:{x:825,y:230,w:70,h:170},mute:{x:860,y:8,w:30,h:30},helpBtn:{x:W-34,y:4,w:24,h:24},mapBtn:{x:4,y:34,w:28,h:28}};
    var cs=S.beach.couples;
    if(!cs[0].gone&&!cs[0].cowered)bz.couple0={x:105,y:265,w:90,h:70};
    if(!cs[1].gone&&!cs[1].cowered)bz.couple1={x:440,y:248,w:80,h:64};
    if(!cs[2].gone&&!cs[2].cowered)bz.couple2={x:685,y:232,w:70,h:56};
    if(!S.beach.boardwalkAttempted&&!S.beach.subMenu&&!S.beach.gymComp.active)bz.boardwalkZone={x:220,y:210,w:590,h:25};
    if(!S.beach.subMenu&&!S.beach.gymComp.active)bz.beachBathroom={x:638,y:176,w:74,h:60};
    // Beach bathroom sub-menu — just the back button zone
    if(S.beach.subMenu==='sewer'){
      return {sewerBack:{x:20,y:440,w:120,h:30},helpBtn:{x:W-34,y:4,w:24,h:24}};
    }
    if(S.beach.subMenu==='sewer_left'||S.beach.subMenu==='sewer_center'||S.beach.subMenu==='sewer_right'){
      return {sewerSubBack:{x:20,y:440,w:120,h:30},helpBtn:{x:W-34,y:4,w:24,h:24}};
    }
    if(S.beach.subMenu==='middle_stall'){
      return {middleStallBack:{x:20,y:440,w:120,h:30},helpBtn:{x:W-34,y:4,w:24,h:24}};
    }
    if(S.beach.subMenu==='right_stall'){
      return {rightStallBack:{x:20,y:440,w:120,h:30},helpBtn:{x:W-34,y:4,w:24,h:24}};
    }
    if(S.beach.subMenu==='stall'){
      return {beachStallBack:{x:20,y:440,w:120,h:30},helpBtn:{x:W-34,y:4,w:24,h:24}};
    }
    if(S.beach.subMenu==='bathroom'){
      return {beachBathroomBack:{x:20,y:440,w:120,h:30},helpBtn:{x:W-34,y:4,w:24,h:24}};
    }
    return bz;
  }
  // Apartment zones
  if(S&&S.phase==='apartment'){
    return {
      fridge:{x:80,y:260,w:80,h:140},
      bathroom:{x:10,y:240,w:55,h:160},
      wardrobe:{x:235,y:250,w:65,h:150},
      cig:{x:330,y:362,w:40,h:38},
      tv:{x:505,y:280,w:80,h:100},
      phone:{x:612,y:356,w:44,h:44},
      dumbbells:{x:695,y:378,w:55,h:28},
      door:{x:825,y:230,w:70,h:170},
      mattress:{x:355,y:382,w:120,h:24},
      mute:{x:860,y:8,w:30,h:30},
      helpBtn:{x:W-34,y:4,w:24,h:24},
      mapBtn:{x:4,y:34,w:28,h:28}
    };
  }
  var L=getLayout();
  var itemY=(S&&S.phase==='gym')?268:338;
  var z={
    bench:{x:L.benchX-55,y:340,w:120,h:80},
    shake:{x:L.shakerX-30,y:itemY-10,w:70,h:60},
    cig:{x:L.cigX-30,y:itemY-10,w:70,h:60},
    rack:{x:L.rackX-32,y:232,w:65,h:168},
    chalk:{x:L.chalkX-25,y:340,w:50,h:55},
    coach:(S&&is1v1()&&S.scene==='platform')?{x:(S.platformCoachX||25)-20,y:300,w:50,h:90}:{x:L.coachX-30,y:300,w:60,h:90},
    mute:{x:860,y:8,w:30,h:30}
  };
  if(S&&S.phase==='gym'){z.helpBtn={x:W-34,y:4,w:24,h:24};z.mapBtn={x:4,y:34,w:28,h:28};z.gymExit={x:850,y:370,w:50,h:40};}
  // Dynamic featured rival zones (warmup only, full-size)
  if(S&&S.phase==='warmup'&&S.rivals){
    // 1v1 platform: rival click zone for taunt
    if(is1v1()&&S.scene==='platform'&&S.rival&&S.rival.active){
      z['platform_rival']={x:S.rival.x-30,y:298,w:60,h:110};
    }else{
      for(var fi=0;fi<S.rivals.length;fi++){
        var fr=S.rivals[fi];
        if(!fr.featured||!fr.active)continue;
        z['feat_'+fr.id]={x:fr.featX-30,y:fr.featY-35,w:60,h:110};
      }
    }
  }
  // 1v1 competition: rival click zone for comp taunts
  if(S&&is1v1()&&S.scene==='platform'&&(S.phase==='snatch'||S.phase==='cj')&&S.rival&&S.rival.active){
    z['comp_rival']={x:S.rival.x-30,y:298,w:60,h:110};
  }
  return z;
}
var ZONES=getZones();

// Rack shelves from top to bottom: 1s, 10s, 25s, 35s, 45s
var RACK_SHELVES=[
  {size:1,  label:'1 LB',  color:'#aaaaaa', y:232, h:30},
  {size:10, label:'10 LB', color:'#40a040', y:264, h:30},
  {size:25, label:'25 LB', color:'#3355cc', y:296, h:30},
  {size:35, label:'35 LB', color:'#cccc33', y:328, h:30},
  {size:45, label:'45 LB', color:'#cc3333', y:360, h:30}
];
var MAX_BAR_WEIGHT=585;
// mouseY is in global scope (line 504b). DO NOT redeclare.

// Funny messages
var GYM_LIFT_MSGS=[
  'Tark throws it up like it owes him money.',
  'Clean. Press. Nasty look at the mirror.',
  'That barbell didn\'t stand a chance.',
  'Somewhere a gym bro felt a disturbance.',
  'Tark grunts. The walls shake.',
  'He lifted it. He put it down. He stared at it menacingly.',
  'The barbell begs for mercy. Tark does not negotiate.',
  'A flawless rep. Nobody was watching.'
];
var GYM_BENCH_MSGS=[
  'Tark sits down. He thinks about protein.',
  'Just a guy and his bench. Romance isn\'t dead.',
  'Tark contemplates his existence. He decides to keep lifting.',
  'He\'s resting. Don\'t talk to him.',
  'Tark stares at the wall. The wall stares back.'
];
var SLOPPY_MSGS=[
  'Sloppy rep. Tark\'s elbows went rogue.',
  'That was ugly. The barbell is filing a complaint.',
  'Technique? Never heard of her. — Tark, probably.',
  'The bar path looked like a drunk snake.'
];
var DNF_MSGS=[
  'CRACK. Something in Tark\'s back just gave up on life.',
  'His knee buckles sideways. That\'s not how knees work.',
  'A pop. A scream. The bar crashes down. It\'s over.',
  'Tark\'s shoulder makes a sound like a gunshot. He drops everything.',
  'Something tore. Tark knows immediately. The meet is done.',
  'His hamstring rolls up like a window shade. He crumples.',
  'The weight shifts wrong. Tark\'s elbow bends the other way. Done.'
];
var CIG_RUSH_MSGS=[
  'NICOTINE RUSH! Tark sees through time itself.',
  'NICOTINE RUSH! His pupils dilate. He feels invincible.',
  'NICOTINE RUSH! Every cell in his body is screaming YES.'
];
var CIG_SMOOTH_MSGS=[
  'Smooth drag. Tark exhales cool as hell.',
  'Nice pull. The smoke curls artfully.',
  'That one hit different. In a good way.'
];
var CIG_COUGH_MSGS=[
  'Tark coughs violently. A child nearby starts crying.',
  '*COUGH COUGH* That one bit back.',
  'His lungs file a formal grievance.'
];
var CIG_BAD_MSGS=[
  'Bad reaction. Tark turns green.',
  'His body rejected that one. Aggressively.',
  'Tark dry heaves. Dignity: gone.'
];
var CIG_CLARITY_MSGS=[
  'Existential clarity. Tark understands the universe. It doesn\'t matter. He lifts anyway.',
  'For one moment, Tark sees it all clearly. Then it\'s gone. But the focus remains.',
  'A philosophical cigarette. Tark whispers "we are all just weight waiting to be lifted."'
];

// --- STATE ---
// S, hover are in global scope. DO NOT redeclare — minifier renames IIFE locals.
var readinessDecayId=null;

function initState(){
  S={
    phase:'gym',
    currentLift:null,
    attempt:0,
    snatchAttempts:[null,null,null],
    cjAttempts:[null,null,null],
    snatchWeights:[0,0,0],
    cjWeights:[0,0,0],
    bestSnatch:0, bestCJ:0,
    lastMadeSnatch:0, lastMadeCJ:0,

    // 4 main stats
    strength:80,
    technique:15,
    readiness:10,
    focus:40,

    // Hidden stats
    mult:1.0,
    lungDamage:0,
    adrenaline:0,
    fatigue:0,
    grip:70,
    nervousness:0,
    lastLiftOverload:0,
    warmupScore:50,
    dnf:false,
    dnfPhase:null,
    dnfHasCig:false,

    // Consumables
    cigsLeft:3,
    shakesLeft:3,
    chalkUses:4,
    chalked:false,
    chalkTimer:0,

    // Bar
    barWeight:45,
    plateStack:[],
    minNextWeight:45,

    // Animation
    busy:false,
    pose:'idle',
    poseT:0,
    tX:200, homeX:200,
    walkDest:200, walkCb:null,
    stepT:0,
    floats:[],

    // NPCs
    wimp:{active:false,x:-30,destX:600,act:null,actT:0,dur:200,timer:800+Math.floor(Math.random()*600),phase:'inactive',msg:''},
    girls:{phase:'gym_idle',x1:740,x2:775,reactT:0,result:null,wimpExit:false,chatCooldown:0},

    // Onboarding
    hints:{rack:false,bench:false,meet:false},
    thought:null, // {lines:['line1','line2'], x:450, y:100}
    thoughtSeen:{}, // auto-narration tracking: {'bathroom':true, ...}
    firstGame:!localStorage.getItem('tark_played'),
    gymIdleTimer:0,

    // Intro sequence
    intro:{step:0,t:0,started:false,skipped:false,titleSlam:false},
    screenShake:0,
    tauntCooldown:0,
    turnAlert:0, // timestamp when YOUR TURN buzzer fired
    hitstop:0, // frames to freeze for impact
    confetti:[], // {x,y,vx,vy,c,life} particles for PR celebration
    prFlash:0, // countdown for PR white flash overlay

    // Scene system (back room / platform)
    scene:'none',
    sceneTransition:null,
    tv:{mode:'off',lifterName:'',weight:0,result:null,resultTimer:0,miniRival:null,miniPose:'idle',miniPoseT:0},
    coachMsg:'',
    coachBubble:null, // {text,t,dur} — temporary speech from Talk to Coach
    backroomExtras:[],
    chalkParticles:[],

    // Multi-competitor
    compMode:1,         // 1=1v1, 3=3-man, 12=world championship
    rivals:[],          // Runtime rival objects (filled at enterMeet)
    selectedRivals:[],  // COMPETITORS ids selected on roster screen
    rosterSelections:{}, // {id:true} for roster_pick UI

    // Rival — display slot (swapped to active competitor)
    rival:{
      id:'pak',
      name:'PAK CHOL-MIN',
      country:'North Korea',flag:'\ud83c\uddf0\ud83c\uddf5',
      tier:'A',personality:'stoic',
      // Appearance
      skin:'#d4a574',hair:'#111',singlet:'#1a4a1a',
      skinDark:'#947346',mouthStrain:'#6a523a',shoulderHighlight:'#dbb68a',
      scoreColor:'#1a4a1a',
      // Stats
      technique:85,
      strength:90,
      failBase:0.06,
      // Competition state
      snatchAttempts:[null,null,null],
      cjAttempts:[null,null,null],
      snatchWeights:[0,0,0],
      cjWeights:[0,0,0],
      bestSnatch:0,bestCJ:0,
      attempt:0,
      // Turn tracking
      declared:0,done:false,currentAttempt:0,
      // AI timer
      timer:0,nextLiftAt:0,
      // Animation
      pose:'idle',poseT:0,
      x:750,
      liftType:null,
      // Target weights (set when competition starts)
      snTargets:[0,0,0],
      cjTargets:[0,0,0],
      active:false
    },

    compLiftResult:null, // 'good' | 'no_lift' | null — for judges' lights

    // Turn-based competition — declaration system (Olympic rules: bar never drops)
    turn:{
      whose:null,        // 'tark' | 'pak' | null
      timer:0,           // seconds remaining
      timerStart:0,      // Date.now() when timer started
      phase:'idle',      // 'declaring' | 'idle' | 'tark_lifting' | 'pak_walking' | 'pak_lifting' | 'pak_returning' | 'between'
      tarkOnPlatform:false,
      pakOnPlatform:false,
      liftType:null,     // 'snatch' | 'cj'
      platformWeight:45, // bar on platform never drops below this
      tarkDeclared:0,    // Tark's declared weight (0 = not yet declared)
      pakDeclared:0,     // Pak's declared weight
      tarkAttempt:0,     // 0-2, increments after each lift
      pakAttempt:0,
      tarkDone:false,    // true when 3 attempts used
      pakDone:false,
      rituals:{chalk:false,coach:false,psyche:false}
    },

    // Platform ritual state
    ritualCoachVisible:false,
    ritualCoachX:80,
    ritualCoachMsg:'',

    // compat: drawing code references S.energy
    energy:80,

    // Day system (multi-day future support)
    day:1,
    totalDays:1,

    // Apartment phase
    apartment:{
      ate:false,showered:false,dressed:false,pumped:false,
      watchedTV:false,mirrorChecked:false,
      phoneUsed:{}, // {gym:true, coach:true, mother:true}
      onCall:false, // true during phone call animation (shows Tark in apt with phone)
      motherMission:false, // true after calling mother — unlocks breakfast mission
      subMenu:null, // 'fridge'|'bathroom'|'wardrobe'|'vhs'|'phone'|null
      breakfast:null, // 'eggs'|'pizza'|'coffee'|'shake'|'skip'
      shower:null, // 'cold'|'hot'|null
      vhsChoice:null, // 'pumping'|'predator'|'predator2'|'rumping'
      bathroomPhase:null, // null|'showering_cold'|'showering_hot'|'mirror'
      bathroomT:0,
      pickpocketAttempted:false,
      dogChaseAttempted:false
    },

    // Outfit (persists across all phases, read by drawTark*())
    outfit:{
      headband:'#cc3333',headbandName:'red',
      shirt:'#f0e6d3',shirtStyle:'cutoff',shirtName:'White Cutoff'
    },

    // Beach phase
    beach:{
      beersLeft:3,
      subMenu:null, // null | 'couple' | 'boardwalk'
      activeCouple:null, // 0|1|2
      canLeave:false,
      boardwalkAttempted:false,
      // Bathroom puzzle - multi-step
      middleFlushes:0, // 0-3, toilet floods at 3
      middleFlooded:false, // true after 3 flushes
      rightStallOccupied:true, // man leaves when middle floods
      rightPaperPulls:0, // 0-12, paper towel in right stall
      rightPaperPulling:false,
      rightPaperPullT:0,
      rightPaperEmpty:false,
      hasPaper:false, // pocketed paper from right stall
      toiletStuffed:false, // stuffed paper into right toilet
      rightToiletFlushed:false, // flushed stuffed right toilet
      holdingPiece:false, // carrying fountain basin overhead
      fountainDrunk:false, // drank from fountain once
      fountainKicks:0, // 0-7, breaks at 7
      fountainKicking:false, // animation in progress
      fountainKickT:0, // kick animation timer
      doorCracked:false, // out-of-order door smashed
      stallEntered:false, // entered out-of-order stall
      towelPulls:0, // 0-12, out-of-order stall dispenser
      towelPulling:false,
      towelPullT:0,
      towelEmpty:false,
      holeExamined:false, // true after first click on hole
      holeDescending:false, // Tark descend animation
      holeDescendT:0, // descend animation timer
      sewer:{visited:false,leftVisited:false,centerVisited:false,rightVisited:false},
      closeupAnim:null, // animation state for couple closeup
      closeupAnimT:0,   // 0→1 animation progress
      closeupDebris:[],  // persistent items on ground [{type:'cig'|'can',x,y}]
      couples:[
        {toughness:0.25,cowered:false,challenged:false,gone:false,lady:false,intimidation:0,actionCount:0},
        {toughness:0.50,cowered:false,challenged:false,gone:false,lady:false,intimidation:0,actionCount:0},
        {toughness:0.80,cowered:false,challenged:false,gone:false,lady:false,intimidation:0,actionCount:0}
      ],
      gymComp:{
        active:false,rivalIdx:null,
        turn:'declare', // 'tark_declare'|'tark_lifting'|'rival_lifting'|'result'
        round:0,
        currentBar:0, // weight that must be beaten
        lastLifter:null,
        liftLog:[], // [{who,weight,made}]
        declaredWeight:135,minWeight:135,
        tarkAttempts:[],bestTark:0,
        rivalAttempts:[],bestRival:0,
        rivalNextWeight:0,
        animPhase:null,animT:0,result:null,
        hasGirlfriend:false,
        rivalSpeech:null,girlSpeech:null,
        // Position & walking
        tarkX:200,rivalX:650,
        walkTarget:null,walkWho:null,walkCb:null,
        prepUsed:false,beersUsed:0,smokesUsed:0,chalksUsed:0,girlUsed:false,tauntUsed:false,
        // Walkoff animation after rival wins
        walkoffPhase:null, // null|'rival_to_girl'|'arm_around'|'walking_off'|'done'
        walkoffT:0,walkoffGirlX:750
      }
    },

    // Downtown state
    downtown:{
      subMenu:null, // null|'bar'|'bodega'|'hotel'|'exit'|'ma_house'|'ma_living'|'ma_kitchen'|'ma_upstairs'|'ma_basement'|'ma_tark_room'|'ma_ma_room'|'ma_bath'
      barVisited:false,
      bodegaVisited:false,
      hotelVisited:false,
      maHouseVisited:false,
      maQuest:{
        started:false,
        stoveOff:false,stoveClicks:0,
        dressGot:false,washerKicking:false,washerMeter:0,washerOpen:false,washerStart:0,
        pillNoteRead:false,pillsGot:false,
        purseUnlocked:false,purseFound:false,
        purseChecked:{couch:false,kitchen:false,tarkRoom:false},
        complete:false,maAtMeet:false
      }
    },

    // Hidden apartment stats
    swagger:0,
    humiliated:0, // 0-3 severity. Set when losing beach gym comp. Carries into meet.
    humiliatedBy:null, // name of who beat you (e.g. 'The Big Dude')
    hungry:false,
    caffeinated:false,
    speechBubble:null,
    facing:'left',
    miniGame:null,
    mapOpen:false
  };
  // expose globally for drawing functions
  window.S=S;
  window.hover=hover;
  window.RACK_SHELVES=RACK_SHELVES;
  window.mouseY=mouseY;
  window.getShelfAt=getShelfAt;
  window.getFailChance=getFailChance;
  window.getInjuryChance=getInjuryChance;
  // expose IIFE functions for global-scope drawing/NPC functions
  window.getLayout=getLayout;
  window.LAYOUT=LAYOUT;
  window.log=log;
  window.unlock=unlock;
  window.showResults=showResults;
  window.lock=lock;
  window.updUI=updUI;
  window.checkStuck=checkStuck;
  window.drawDangerMeter=drawDangerMeter;
  window.handleMiniGameClick=handleMiniGameClick;
  window.resolveMiniGameResult=resolveMiniGameResult;
  window.transitionToJerkPhase=transitionToJerkPhase;
  window.getMiniGameParams=getMiniGameParams;
  window.startSnatchMiniGame=startSnatchMiniGame;
  window.startCJMiniGame=startCJMiniGame;
  window.resolveGymMiniGame=resolveGymMiniGame;
  window.resolveBeachMiniGame=resolveBeachMiniGame;
  window.resolveWarmupMiniGame=resolveWarmupMiniGame;
}

// --- HELPERS ---

function pick(arr){return arr[Math.floor(Math.random()*arr.length)];}
function clamp(v,lo,hi){return v<lo?lo:v>hi?hi:v;}

// Effective plate count for formulas (preserves old difficulty curve)
function ep(){return Math.max(0,(S.barWeight-45)/90);}

function recalcBar(){
  var t=45;
  for(var i=0;i<S.plateStack.length;i++)t+=S.plateStack[i]*2;
  S.barWeight=t;
}

function getShelfAt(my){
  for(var i=0;i<RACK_SHELVES.length;i++){
    var s=RACK_SHELVES[i];
    if(my>=s.y&&my<s.y+s.h)return s;
  }
  return null;
}

function log(msg,cls){
  var el=document.getElementById('tl');
  if(!el)return;
  var d=document.createElement('div');
  d.className='e'+(cls?' '+cls:'');
  d.textContent=msg;
  el.prepend(d);
  while(el.children.length>50)el.removeChild(el.lastChild);
}

function float(text,x,y,color,size){
  S.floats.push({text:text,x:x||S.tX,y:y||180,c:color||'#fff',sz:size||16,life:1.0});
}

var busyStartTime=0;
function lock(){S.busy=true;busyStartTime=Date.now();updUI();}
function unlock(){S.busy=false;busyStartTime=0;updUI();}
function resetBusyTimer(){if(S.busy)busyStartTime=Date.now();}
window.resetBusyTimer=resetBusyTimer;
function checkStuck(){
  // If busy for more than 8 seconds, force unlock (prevents permanent freeze)
  // But never during DNF sequence — that takes much longer by design
  if(S.dnf)return;
  if(S.busy&&busyStartTime>0&&(Date.now()-busyStartTime)>8000){
    S.pose='idle';S.poseT=0;S.currentLift=null;
    S.tX=S.homeX||300;
    unlock();
  }
  // Stuck "between" detector: if phase is between with nobody lifting for 5+ sec, auto-resolve
  var t=S.turn;
  if(!S.busy&&t&&t.phase==='between'&&t.whose===null&&(S.phase==='snatch'||S.phase==='cj')){
    if(!S._betweenStuckT)S._betweenStuckT=Date.now();
    if(Date.now()-S._betweenStuckT>5000){
      S._betweenStuckT=0;
      log('Auto-resolving stuck turn...','rest');
      try{resolveNextLifter();}catch(e){log('ERR auto-resolve: '+e.message,'fail');}
    }
  }else{
    S._betweenStuckT=0;
  }
}

// --- PHASE MANAGEMENT ---

function setPhase(p){
  S.phase=p;
  // Dynamic layout positions (scene-aware)
  var L=p==='apartment'?LAYOUT.apartment:p==='beach'?LAYOUT.beach:p==='downtown'?LAYOUT.downtown:(S.scene==='backroom')?LAYOUT.backroom:(p==='gym'?LAYOUT.gym:LAYOUT.comp);
  S.homeX=L.homeX;
  if(S.rival&&L.pakHomeX)S.rival.x=L.pakHomeX;
  var statBars=document.getElementById('statBars');
  var scoreBar=document.getElementById('scoreBar');
  var primaryAction=document.getElementById('primaryAction');
  var results=document.getElementById('results');
  var attemptTracker=document.getElementById('attemptTracker');

  // Visibility by phase
  if(p==='intro'){
    if(statBars)statBars.style.display='none';
    if(scoreBar)scoreBar.style.display='none';
    if(primaryAction)primaryAction.style.display='none';
    if(results)results.style.display='none';
    if(attemptTracker)attemptTracker.innerHTML='';
    stopReadinessDecay();
  }else if(p==='apartment'){
    if(statBars)statBars.style.display='none';
    if(scoreBar)scoreBar.style.display='none';
    if(primaryAction)primaryAction.style.display='flex';
    if(results)results.style.display='none';
    if(attemptTracker)attemptTracker.innerHTML='';
    stopReadinessDecay();
  }else if(p==='beach'){
    if(statBars)statBars.style.display='none';
    if(scoreBar)scoreBar.style.display='none';
    if(primaryAction)primaryAction.style.display='flex';
    if(results)results.style.display='none';
    if(attemptTracker)attemptTracker.innerHTML='';
    stopReadinessDecay();
  }else if(p==='gym'){
    if(statBars)statBars.style.display='none';
    if(scoreBar)scoreBar.style.display='none';
    if(primaryAction)primaryAction.style.display='flex';
    if(results)results.style.display='none';
    if(attemptTracker)attemptTracker.innerHTML='';
    stopReadinessDecay();
  }else if(p==='downtown'){
    if(statBars)statBars.style.display='none';
    if(scoreBar)scoreBar.style.display='none';
    if(primaryAction)primaryAction.style.display='flex';
    if(results)results.style.display='none';
    if(attemptTracker)attemptTracker.innerHTML='';
    stopReadinessDecay();
  }else if(p==='warmup'){
    if(statBars)statBars.style.display='flex';
    if(scoreBar)scoreBar.style.display='none';
    if(primaryAction)primaryAction.style.display='flex';
    if(results)results.style.display='none';
    if(attemptTracker)attemptTracker.innerHTML='';
    startReadinessDecay();
  }else if(p==='snatch'||p==='cj'){
    if(statBars)statBars.style.display='flex';
    if(scoreBar)scoreBar.style.display='flex';
    if(primaryAction)primaryAction.style.display='flex';
    if(results)results.style.display='none';
    startReadinessDecay();
  }else if(p==='rest_sn_cj'){
    if(statBars)statBars.style.display='flex';
    if(scoreBar)scoreBar.style.display='flex';
    if(primaryAction)primaryAction.style.display='flex';
    if(results)results.style.display='none';
    startReadinessDecay();
  }else if(p==='mode_select'||p==='roster_pick'){
    if(statBars)statBars.style.display='none';
    if(scoreBar)scoreBar.style.display='none';
    if(primaryAction)primaryAction.style.display='none';
    if(results)results.style.display='none';
    if(attemptTracker)attemptTracker.innerHTML='';
    stopReadinessDecay();
  }else if(p==='results'){
    if(statBars)statBars.style.display='none';
    if(scoreBar)scoreBar.style.display='none';
    if(primaryAction)primaryAction.style.display='none';
    if(results)results.style.display='block';
    stopReadinessDecay();
  }

  // Music switching per phase
  var _mt={intro:'intro',apartment:'apartment',beach:'beach',downtown:'apartment',gym:'gym',mode_select:'gym',roster_pick:'gym',warmup:'warmup',snatch:'comp',cj:'comp',rest_sn_cj:'rest',results:'results'};
  SFX.musicSwitch(_mt[p]||null);

  renderPrimaryButton();
  renderControls();
  updatePhaseBanner();
  updateAttemptTracker();
  updUI();
  // Auto-narrate on first visit to exploration phases
  if((p==='apartment'||p==='beach'||p==='downtown'||p==='gym')&&!S.thoughtSeen[p]){
    S.thoughtSeen[p]=true;narrateScene();
  }
}

function updatePhaseBanner(){
  var el=document.getElementById('phaseBanner');
  if(!el)return;
  var txt={
    intro:'',
    apartment:"TARK'S APARTMENT \u2014 MEET DAY MORNING",
    beach:'VENICE BEACH \u2014 MEET DAY MORNING',
    gym:"TARK'S GYM",
    warmup:'WARM-UP \u2014 Prepare for Competition',
    snatch:'SNATCH \u2014 Attempt '+(S.turn.tarkAttempt+1)+' of 3',
    rest_sn_cj:'REST PERIOD \u2014 Snatches Complete',
    cj:'CLEAN & JERK \u2014 Attempt '+(S.turn.tarkAttempt+1)+' of 3',
    results:'COMPETITION COMPLETE'
  };
  el.textContent=txt[S.phase]||S.phase.toUpperCase();
}

function updateAttemptTracker(){
  var el=document.getElementById('attemptTracker');
  if(!el)return;
  if(S.phase!=='snatch'&&S.phase!=='cj'&&S.phase!=='rest_sn_cj'){el.innerHTML='';return;}

  var html='';
  // Snatch attempts
  html+='<span style="font-size:9px;color:#555;letter-spacing:2px">SN:</span> ';
  for(var i=0;i<3;i++){
    var r=S.snatchAttempts[i];
    var cls='att';
    var txt='--';
    if(r===true){cls+=' made';txt=S.snatchWeights[i]+'\u2713';}
    else if(r===false){cls+=' missed';txt=S.snatchWeights[i]+'\u2717';}
    else if(S.phase==='snatch'&&i===S.turn.tarkAttempt){cls+=' current';txt=S.barWeight+'?';}
    html+='<span class="'+cls+'">'+txt+'</span> ';
  }
  html+='&nbsp;&nbsp;';
  // C&J attempts
  html+='<span style="font-size:9px;color:#555;letter-spacing:2px">C&J:</span> ';
  for(var i=0;i<3;i++){
    var r=S.cjAttempts[i];
    var cls='att';
    var txt='--';
    if(r===true){cls+=' made';txt=S.cjWeights[i]+'\u2713';}
    else if(r===false){cls+=' missed';txt=S.cjWeights[i]+'\u2717';}
    else if(S.phase==='cj'&&i===S.turn.tarkAttempt){cls+=' current';txt=S.barWeight+'?';}
    html+='<span class="'+cls+'">'+txt+'</span> ';
  }
  el.innerHTML=html;
}

// --- READINESS DECAY ---
function startReadinessDecay(){
  stopReadinessDecay();
  readinessDecayId=setInterval(function(){
    if(S.busy)return;
    if(S.phase==='gym'||S.phase==='results')return;
    S.readiness=Math.max(0,S.readiness-0.3);
    // don't call full updUI to avoid flicker, just update readiness bar
    var fill=document.getElementById('readyFill');
    var val=document.getElementById('readyVal');
    if(fill)fill.style.width=clamp(S.readiness,0,100)+'%';
    if(val)val.textContent=Math.round(S.readiness);
  },1000);
}
function stopReadinessDecay(){
  if(readinessDecayId){clearInterval(readinessDecayId);readinessDecayId=null;}
}

// --- BUTTON HELPERS ---

function btn(id,label,sub,onclick,disabled){
  return '<button class="tg-btn" id="'+id+'"'
    +(disabled?' disabled':'')
    +' onclick="'+onclick+'">'
    +label
    +(sub?'<span class="sub">'+sub+'</span>':'')
    +'</button>';
}

function bigBtn(label,sub,onclick,disabled){
  return '<button class="tg-btn-big"'
    +(disabled?' disabled':'')
    +' onclick="'+onclick+'">'
    +label
    +(sub?'<span class="sub">'+sub+'</span>':'')
    +'</button>';
}

// --- RENDER CONTROLS ---

function renderPrimaryButton(){
  var el=document.getElementById('primaryAction');
  if(!el)return;
  var h='';
  var d=S.busy;

  // DNF — no controls, just show status
  if(S.dnf){
    var dnfMsg=S.rivals.length>1?'watching rivals finish...':'watching '+S.rival.name+' finish...';
    h+=bigBtn('INJURY \u2014 DNF',dnfMsg,'',true);
    el.innerHTML=h;
    return;
  }

  if(S.phase==='apartment'){
    if(S.apartment.subMenu){
      h+=bigBtn('CHOOSING...','','',true);
    }else{
      h+=bigBtn('HEAD OUT','leave apartment','G.doApartmentDoor()',d);
    }
  }else if(S.phase==='beach'){
    if(S.beach.subMenu||S.beach.gymComp.active){
      h+=bigBtn('...',' ','',true);
    }else{
      h+=bigBtn('HEAD TO THE GYM','leave beach','G.doBeachExit()',d||!S.beach.canLeave);
    }
  }else if(S.phase==='downtown'){
    if(S.downtown.subMenu){
      h+=bigBtn('...',' ','',true);
    }else{
      h+=bigBtn('LEAVE DOWNTOWN','pick destination','G.doDowntownExit()',d);
    }
  }else if(S.phase==='gym'){
    h+=bigBtn('ENTER THE MEET','','G.enterMeet()',d);
  }else if(S.phase==='warmup'){
    if(S.scene==='backroom'){
      // Card-aware button label
      var cardInfo='type weight below';
      if(S.warmup&&S.warmup.card&&S.warmup.cardStep<S.warmup.card.length){
        var cs=S.warmup.card[S.warmup.cardStep];
        cardInfo=cs.weight+' lbs x'+cs.reps+' ('+cs.label+')';
      }else if(S.warmup&&S.warmup.card&&S.warmup.cardStep>=S.warmup.card.length){
        cardInfo='card complete';
      }
      h+=bigBtn('WARM-UP LIFT',cardInfo,'G.doWarmupLift()',d);
      showWeightDeclare(true);
      var wInp=document.getElementById('weightInput');
      if(wInp&&!wInp._warmupInit){
        var initW=S.warmup?S.warmup.coachSuggestion:S.barWeight||45;
        wInp.value=initW;wInp._warmupInit=true;
      }
      var csTxt=document.getElementById('coachSuggestion');
      if(csTxt){
        var csMsg=S.warmup&&S.warmup.lifts>0?getCoachWarmupSuggestion().message:'Start with the bar. Get loose.';
        csTxt.textContent='Coach: "'+csMsg+'"';
      }
    }else{
      h+=bigBtn('WARM-UP LIFT',S.barWeight+' lbs','G.doWarmupLift()',d);
    }
    // Show DECLARE OPENER when card complete or time running low, otherwise BEGIN SNATCHES
    var wRem2=S.warmup?(S.warmup.startTime+S.warmup.duration-Date.now()):999999;
    var cardDone=S.warmup&&S.warmup.card&&S.warmup.cardStep>=S.warmup.card.length;
    if(cardDone||wRem2<30000){
      h+=bigBtn('DECLARE OPENER','declare & begin','G.declareOpener()',d);
    }else{
      h+=bigBtn('BEGIN SNATCHES','start competition','G.declareOpener()',d);
    }
  }else if(S.phase==='snatch'||S.phase==='cj'){
    // Show humiliation debuff indicator
    if(S.humiliated>0){
      var humLvl=Math.ceil(S.humiliated);
      var humPenalty='+'+Math.round(S.humiliated*1.2)+'% fail';
      h+='<div style="color:#ff4444;font-size:9px;padding:2px 6px;background:rgba(255,50,50,0.15);border:1px solid #ff4444;border-radius:3px;margin-bottom:4px;display:inline-block">';
      h+='HUMILIATED';
      for(var hi=0;hi<humLvl;hi++)h+=' \u2716';
      h+=' ('+humPenalty+')';
      h+='</div><br>';
    }
    var t=S.turn;
    var inBR=(S.scene==='backroom');
    if(t.whose==='rival'||t.whose==='pak'){
      var rName=S.rival.name||'RIVAL';
      if(inBR){
        h+=bigBtn(rName+'\'S TURN','watch the TV','',true);
      }else{
        h+=bigBtn(rName+'\'S TURN',S.rival.declared+' lbs','',true);
      }
      if(inBR)showWeightDeclare(false);
    }else if(t.whose==='tark'&&t.phase==='declaring'){
      if(inBR){
        // Weight input handles declaration — no primary button needed
      }else{
        var lightest=getLightestRivalDeclared?getLightestRivalDeclared():null;
        var rivalInfo=allRivalsDone()?'All rivals done':lightest?'Lightest: '+lightest.declared+' lbs':'---';
        var tooLow=S.barWeight<t.platformWeight;
        h+=bigBtn('DECLARE '+S.barWeight+' LBS',rivalInfo,'G.declareWeight()',d||tooLow);
      }
    }else if(t.whose==='tark'&&t.phase==='platform_ritual'){
      var fc=getFailChance(S.phase==='snatch'?'snatch':'cj');
      var fcPct=Math.round(fc*100);
      var secs=Math.ceil(t.timer);
      h+=bigBtn('ATTEMPT LIFT',t.tarkDeclared+' lbs ('+fcPct+'% fail) \u2014 '+secs+'s','G.doCompLift()',d);
    }else if(t.whose==='tark'&&t.phase==='idle'){
      if(inBR){
        var secs=Math.ceil(t.timer);
        h+=bigBtn('WALK TO PLATFORM',t.tarkDeclared+' lbs \u2014 60s','G.walkToPlatformAndLift()',d);
        showWeightDeclare(false);
      }else{
        var fc=getFailChance(S.phase==='snatch'?'snatch':'cj');
        var fcPct=Math.round(fc*100);
        var secs=Math.ceil(t.timer);
        h+=bigBtn('ATTEMPT LIFT',t.tarkDeclared+' lbs ('+fcPct+'% fail) \u2014 '+secs+'s','G.doCompLift()',d);
      }
    }else{
      h+=bigBtn('WAITING...','','',true);
      if(inBR)showWeightDeclare(false);
    }
  }else if(S.phase==='rest_sn_cj'){
    h+=bigBtn('BEGIN CLEAN & JERK','','G.beginCJ()',d);
  }

  el.innerHTML=h;
}

function renderControls(){
  var el=document.getElementById('controls');
  if(!el)return;
  // DNF — hide all controls
  if(S.dnf){el.innerHTML='';return;}
  var h='';
  var d=S.busy;

  var maxed=S.barWeight>=MAX_BAR_WEIGHT;
  var empty=S.plateStack.length===0;

  if(S.phase==='apartment'){
    var sm=S.apartment.subMenu;
    if(sm==='fridge'||sm==='bathroom'){
      // These use canvas interior views — no HTML buttons needed
    }else if(sm==='door'){
      h+=btn('bBeach','Venice Beach','sun & trouble','G.doApartmentDoorChoice("beach")',d);
      h+=btn('bDowntown','Downtown','bars & bodegas','G.doApartmentDoorChoice("downtown")',d);
      h+=btn('bGym','Straight to Gym','all business','G.doApartmentDoorChoice("gym")',d);
      h+=btn('bCancel','Cancel','stay here','G.cancelSubMenu()',d);
    }else if(sm==='wardrobe'){
      h+='<div style="color:#666;font-size:8px;letter-spacing:2px;text-align:center;padding:2px;text-transform:uppercase">HEADBAND:</div>';
      for(var hi=0;hi<HEADBAND_OPTS.length;hi++){
        h+=btn('bHB'+hi,HEADBAND_OPTS[hi].name,HEADBAND_OPTS[hi].desc,'G.doHeadbandChoice('+hi+')',d);
      }
      h+='<div style="color:#666;font-size:8px;letter-spacing:2px;text-align:center;padding:2px;margin-top:4px;text-transform:uppercase">SHIRT:</div>';
      for(var si=0;si<SHIRT_OPTS.length;si++){
        h+=btn('bSH'+si,SHIRT_OPTS[si].name,SHIRT_OPTS[si].desc,'G.doShirtChoice('+si+')',d);
      }
      h+=btn('bCancel','Cancel','nevermind','G.cancelSubMenu()',d);
    }else{
      h+=btn('bFridge','Open Fridge','breakfast','G.doApartmentFridge()',d||S.apartment.ate);
      h+=btn('bBath','Bathroom','shower / mirror','G.doApartmentBathroom()',d);
      h+=btn('bWardrobe','Wardrobe','pick outfit','G.doApartmentWardrobe()',d||S.apartment.dressed);
      h+=btn('bSmoke','Cigarette','morning vibes','G.doApartmentSmoke()',d);
      h+=btn('bTV','Watch TV','technique tips','G.doApartmentTV()',d||S.apartment.watchedTV);
      h+=btn('bPhone','Phone','make some calls','G.doApartmentPhone()',d);
      h+=btn('bDumbbells','Morning Pump','quick curls','G.doApartmentDumbbells()',d||S.apartment.pumped);
      h+=btn('bMattress','Back to Bed','don\'t do it','G.doApartmentMattress()',d);
    }
  }else if(S.phase==='beach'){
    if(S.beach.subMenu==='couple'){
      var bci=S.beach.activeCouple;
      var animD=d||!!S.beach.closeupAnim;
      h+=btn('bBSmoke','Smoke','light one up','G.doBeachSmoke('+bci+')',animD);
      h+=btn('bBBack','Walk Away','back to beach','G.doBeachCancelSubMenu()',animD);
    }else if(S.beach.gymComp.active){
      var bg=S.beach.gymComp;
      if(bg.result){
        // Only show Continue after walkoff finishes (or if Tark won, no walkoff)
        var walkoffDone=(!bg.walkoffPhase||bg.walkoffPhase==='done');
        if(walkoffDone){
          h+=btn('bBDone','Continue','back to beach','G.doBeachGymDone()',false);
        }else{
          h+='<span style="color:#888;font-size:10px">...</span>';
        }
      }else if(bg.turn==='tark_declare'){
        // Show what rival just did
        h+='<span style="color:#7fdb6a;font-size:10px">'+BEACH_COUPLE_NAMES[bg.rivalIdx]+' made '+bg.currentBar+' lbs. You must beat it.</span><br>';
        // Items row
        h+=btn('bCBeer','Beer ('+(3-bg.beersUsed)+')','ADR+4 SWAG+6 FOC-5','G.doBeachCompBeer()',d||S.beach.beersLeft<=0||bg.beersUsed>=3);
        h+=btn('bCSmoke','Smoke ('+(3-bg.smokesUsed)+')','FOC+6 NERV-4 GRIP-3','G.doBeachCompSmoke()',d||S.cigsLeft<=0||bg.smokesUsed>=3);
        h+=btn('bCChalk','Chalk ('+(3-bg.chalksUsed)+')','GRIP+15','G.doBeachChalk()',d||S.chalkUses<=0||bg.chalksUsed>=3);
        // Fail chance
        var savedBW=S.barWeight;S.barWeight=bg.declaredWeight;
        var fc=Math.round(getFailChance('cj')*100);
        S.barWeight=savedBW;
        var fcCol=fc<20?'#7fdb6a':fc<40?'#ffcc00':fc<60?'#ff8844':'#ff4444';
        h+='<span style="color:#f0e6d3;font-size:10px">Your weight: '+bg.declaredWeight+' lbs (min '+bg.minWeight+')</span> <span style="color:'+fcCol+';font-size:10px">('+fc+'% fail)</span><br>';
        var adjs=[{lbl:'+5',val:5},{lbl:'+10',val:10},{lbl:'+25',val:25},{lbl:'+45',val:45}];
        for(var ai=0;ai<adjs.length;ai++){
          var a=adjs[ai];
          var canClick=(bg.declaredWeight+a.val)>=bg.minWeight&&(bg.declaredWeight+a.val)>=45;
          h+=btn('wAdj'+ai,a.lbl,'','G.doBeachAdjustWeight('+a.val+')',!canClick);
        }
        h+='<br>';
        h+=bigBtn('LIFT '+bg.declaredWeight+' LBS','','G.doBeachLift()',d);
      }else if(bg.turn==='rival_lifting'){
        var rivalW=bg.rivalNextWeight||'???';
        h+='<span style="color:#aaa;font-size:11px">'+BEACH_COUPLE_NAMES[bg.rivalIdx]+' is lifting '+rivalW+' lbs...</span>';
      }else if(bg.turn==='tark_lifting'){
        h+='<span style="color:#aaa;font-size:11px">Tark is lifting '+bg.declaredWeight+' lbs...</span>';
      }else{
        h+='<span style="color:#888;font-size:10px">...</span>';
      }
    }else{
      h+=btn('bBExit','Head to Gym','leave beach','G.doBeachExit()',d||!S.beach.canLeave);
    }
  }else if(S.phase==='gym'){
    h+=btn('bBench','Have a Sit','sit & think','G.doBench()',d);
    h+=btn('bDrop','Drop Plate','strip outermost','G.dropPlate()',d||empty);
    h+=btn('bSnatch','Snatch','balance test',"G.doGymLift('snatch')",d);
    h+=btn('bCJ','Clean & Jerk','power test',"G.doGymLift('cj')",d);
    h+=btn('bShake','Protein Shake','pre-game fuel','G.doShake()',d);
    h+=btn('bSmoke','Cigarette','just vibes','G.doSmoke()',d);
    var chatOk=S.girls&&S.girls.phase==='gym_idle'&&(!S.girls.chatCooldown||S.girls.chatCooldown<=0);
    h+=btn('bChat','Chat Up Ladies','shoot your shot','G.doChatUp()',d||!chatOk);
  }else if(S.phase==='warmup'){
    if(is1v1()&&S.scene==='platform'){
      // 1v1 platform warmup — plate buttons + warmup actions + taunt
      h+=btn('bP45','+45','load 45s','G.addPlate(45)',d||maxed);
      h+=btn('bP25','+25','load 25s','G.addPlate(25)',d||maxed);
      h+=btn('bP10','+10','load 10s','G.addPlate(10)',d||maxed);
      h+=btn('bP5','+5','load 5s','G.addPlate(5)',d||maxed);
      h+=btn('bP1','+1','load 1s','G.addPlate(1)',d||maxed);
      h+=btn('bDrop','Drop Plate','strip outermost','G.dropPlate()',d||empty);
      h+=btn('bLift','Lift','warm-up set','G.doWarmupLift()',d);
      h+=btn('bBench','Rest','STR+2 FOC+12 RDY-8','G.doBench()',d);
      h+=btn('bCoach','Talk to Coach','FOC+8 NERV-5','G.doTalkToCoach()',d);
      h+=btn('bShake','Protein Shake','STR+12 ('+S.shakesLeft+' left)','G.doShake()',d||S.shakesLeft<=0);
      h+=btn('bSmoke','Cigarette','risky focus ('+S.cigsLeft+' left)','G.doSmoke()',d||S.cigsLeft<=0);
      h+=btn('bChalk','Chalk Up','GRIP+20 ('+S.chalkUses+' left)','G.doChalk()',d||S.chalkUses<=0);
      var tCd=S.tauntCooldown?Math.max(0,Math.ceil((S.tauntCooldown-Date.now())/1000)):0;
      var tSub=tCd>0?'cooldown '+tCd+'s':'intimidate a rival';
      h+=btn('bTaunt','Taunt Rival',tSub,'G.doTaunt()',d||tCd>0);
    }else if(S.scene==='backroom'){
      // Back room warmup — no plate buttons, weight input instead
      h+=btn('bBench','Rest','STR+2 FOC+12 RDY-8','G.doBench()',d);
      h+=btn('bStretch','Stretch','RDY+'+(S.warmup?Math.max(1,8-S.warmup.stretchCount*2):8)+' FOC+3','G.doStretch()',d);
      h+=btn('bShake','Protein Shake','STR+12 ('+S.shakesLeft+' left)','G.doShake()',d||S.shakesLeft<=0);
      h+=btn('bSmoke','Cigarette','risky focus ('+S.cigsLeft+' left)','G.doSmoke()',d||S.cigsLeft<=0);
      var tCd=S.tauntCooldown?Math.max(0,Math.ceil((S.tauntCooldown-Date.now())/1000)):0;
      var tSub=tCd>0?'cooldown '+tCd+'s':'intimidate a rival';
      h+=btn('bTaunt','Taunt Rival',tSub,'G.doTaunt()',d||tCd>0);
    }else{
      h+=btn('bP45','+45','load 45s','G.addPlate(45)',d||maxed);
      h+=btn('bP25','+25','load 25s','G.addPlate(25)',d||maxed);
      h+=btn('bP10','+10','load 10s','G.addPlate(10)',d||maxed);
      h+=btn('bP5','+5','load 5s','G.addPlate(5)',d||maxed);
      h+=btn('bP1','+1','load 1s','G.addPlate(1)',d||maxed);
      h+=btn('bDrop','Drop Plate','strip outermost','G.dropPlate()',d||empty);
      h+=btn('bBench','Rest','STR+2 FOC+12 RDY-8','G.doBench()',d);
      h+=btn('bShake','Protein Shake','STR+12 ('+S.shakesLeft+' left)','G.doShake()',d||S.shakesLeft<=0);
      h+=btn('bSmoke','Cigarette','risky focus ('+S.cigsLeft+' left)','G.doSmoke()',d||S.cigsLeft<=0);
      h+=btn('bChalk','Chalk Up','GRIP+20 ('+S.chalkUses+' left)','G.doChalk()',d||S.chalkUses<=0);
    }
  }else if(S.phase==='snatch'||S.phase==='cj'){
    if(S.scene==='backroom'){
      // Back room — no plate buttons, just activities
      h+=btn('bBench','Rest','FOC+5 RDY-5','G.doBench()',d);
      h+=btn('bShake','Protein Shake','STR+10 ('+S.shakesLeft+' left)','G.doShake()',d||S.shakesLeft<=0);
      h+=btn('bSmoke','Cigarette','('+S.cigsLeft+' left)','G.doSmoke()',d||S.cigsLeft<=0);
      // 1v1 comp taunt in backroom (unlikely but safe)
      if(is1v1()&&(!S.turn||!S.turn.whose)){
        var ctCd=S.tauntCooldown?Math.max(0,Math.ceil((S.tauntCooldown-Date.now())/1000)):0;
        h+=btn('bCompTaunt','Taunt',ctCd>0?'cooldown '+ctCd+'s':'get in their head','G.doCompTaunt()',d||ctCd>0);
      }
    }else if(S.turn.whose==='tark'&&S.turn.phase==='platform_ritual'){
      // Platform ritual — 3 optional pre-lift actions
      var r=S.turn.rituals;
      h+=btn('bRitChalk','\uD83E\uDDF1 Chalk Up','GRIP+20 TECH+3 FOC+5','G.doRitualChalk()',d||r.chalk||S.chalkUses<=0);
      h+=btn('bRitCoach','\uD83D\uDDE3 Talk to Coach','FOC+10 NERV-5','G.doRitualCoach()',d||r.coach);
      h+=btn('bRitPsyche','\uD83D\uDCA2 Psyche Up','ADR+15 NERV-10 STR-2','G.doRitualPsyche()',d||r.psyche);
    }else{
      var canLoad=S.turn.whose==='tark'&&S.turn.phase==='declaring';
      var ld=d||!canLoad;
      h+=btn('bP45','+45','load 45s','G.addPlate(45)',ld||maxed);
      h+=btn('bP25','+25','load 25s','G.addPlate(25)',ld||maxed);
      h+=btn('bP10','+10','load 10s','G.addPlate(10)',ld||maxed);
      h+=btn('bP5','+5','load 5s','G.addPlate(5)',ld||maxed);
      h+=btn('bP1','+1','load 1s','G.addPlate(1)',ld||maxed);
      h+=btn('bDrop','Drop Plate','strip outermost','G.dropPlate()',ld||empty||S.barWeight<=S.minNextWeight);
      h+=btn('bBench','Rest','FOC+5 RDY-5','G.doBench()',d);
      h+=btn('bSmoke','Cigarette','('+S.cigsLeft+' left)','G.doSmoke()',d||S.cigsLeft<=0);
      h+=btn('bShake','Protein Shake','STR+10 ('+S.shakesLeft+' left)','G.doShake()',d||S.shakesLeft<=0);
      h+=btn('bChalk','Chalk Up','GRIP+20 ('+S.chalkUses+' left)','G.doChalk()',d||S.chalkUses<=0);
      // 1v1 comp taunt on platform
      if(is1v1()&&(!S.turn||!S.turn.whose)){
        var ctCd2=S.tauntCooldown?Math.max(0,Math.ceil((S.tauntCooldown-Date.now())/1000)):0;
        h+=btn('bCompTaunt','Taunt',ctCd2>0?'cooldown '+ctCd2+'s':'get in their head','G.doCompTaunt()',d||ctCd2>0);
      }
    }
  }else if(S.phase==='rest_sn_cj'){
    h+=btn('bBench','Rest','recover','G.doBench()',d);
    h+=btn('bShake','Protein Shake','('+S.shakesLeft+' left)','G.doShake()',d||S.shakesLeft<=0);
    h+=btn('bSmoke','Cigarette','('+S.cigsLeft+' left)','G.doSmoke()',d||S.cigsLeft<=0);
    if(S.scene!=='backroom'){
      h+=btn('bChalk','Chalk Up','GRIP+20 ('+S.chalkUses+' left)','G.doChalk()',d||S.chalkUses<=0);
      h+=btn('bP45','+45','load 45s','G.addPlate(45)',d||maxed);
      h+=btn('bP25','+25','load 25s','G.addPlate(25)',d||maxed);
      h+=btn('bP10','+10','load 10s','G.addPlate(10)',d||maxed);
      h+=btn('bP5','+5','load 5s','G.addPlate(5)',d||maxed);
      h+=btn('bP1','+1','load 1s','G.addPlate(1)',d||maxed);
    }
    h+=btn('bDrop','Drop Plate','strip outermost','G.dropPlate()',d||empty);
  }

  el.innerHTML=h;
}

// --- UI UPDATE ---

function updUI(){
  // Sync S.energy for drawing code compat
  S.energy=S.strength;

  // Stat bars
  var strFill=document.getElementById('strFill');
  var techFill=document.getElementById('techFill');
  var readyFill=document.getElementById('readyFill');
  var focFill=document.getElementById('focFill');
  var strVal=document.getElementById('strVal');
  var techVal=document.getElementById('techVal');
  var readyVal=document.getElementById('readyVal');
  var focVal=document.getElementById('focVal');

  if(strFill){
    strFill.style.width=clamp(S.strength,0,100)+'%';
    var sc=S.strength>50?'#cc3333':'#ff4444';
    strFill.style.background='linear-gradient(90deg,'+sc+',#ff6b35)';
  }
  if(techFill){
    techFill.style.width=clamp(S.technique,0,100)+'%';
    techFill.style.background='linear-gradient(90deg,#3355cc,#6699ff)';
  }
  if(readyFill){
    readyFill.style.width=clamp(S.readiness,0,100)+'%';
    readyFill.style.background='linear-gradient(90deg,#40a040,#7fdb6a)';
  }
  if(focFill){
    focFill.style.width=clamp(S.focus,0,100)+'%';
    focFill.style.background='linear-gradient(90deg,#9944cc,#cc88ff)';
  }
  if(strVal)strVal.textContent=Math.round(S.strength);
  if(techVal)techVal.textContent=Math.round(S.technique);
  if(readyVal)readyVal.textContent=Math.round(S.readiness);
  if(focVal)focVal.textContent=Math.round(S.focus);

  // Score bar
  var sBestSn=document.getElementById('sBestSn');
  var sBestCJ=document.getElementById('sBestCJ');
  var sTotal=document.getElementById('sTotal');
  var sWeight=document.getElementById('sWeight');
  if(sBestSn)sBestSn.textContent=S.bestSnatch>0?S.bestSnatch+' lbs':'---';
  if(sBestCJ)sBestCJ.textContent=S.bestCJ>0?S.bestCJ+' lbs':'---';
  if(sTotal)sTotal.textContent=(S.bestSnatch+S.bestCJ)||'0';
  if(sWeight)sWeight.textContent=S.barWeight+' lbs';

  // Attempt tracker
  updateAttemptTracker();
  updatePhaseBanner();

  // Controls re-render when not busy
  if(!S.busy)renderControls();
  renderPrimaryButton();
}

// --- FAIL CHANCE ---

function getFailChance(liftType){
  var p=ep();
  // Weight scaling: stats don't matter at light weights, full effect at ~200 lbs
  var ws=Math.min(1.0,p/1.7);
  var base=p*p*0.020;
  var strMod=Math.max(0,(70-S.strength)*0.008)*ws;
  var techMod=Math.max(0,(70-S.technique)*0.005)*ws;
  var readyMod=Math.max(0,(50-S.readiness)*0.004)*ws;
  var focusMod=S.focus*-0.002*ws;
  var lungMod=S.lungDamage*0.8*ws;
  var fatigueMod=S.fatigue*0.015*ws;
  var gripMod=(liftType==='snatch'?Math.max(0,(70-S.grip)*0.006):Math.max(0,(70-S.grip)*0.003))*ws;
  var nerveMod=S.nervousness*0.003*ws;
  var adrenMod=S.adrenaline*-0.002*ws;
  // Beach humiliation debuff: lingers into the meet, makes everything harder
  var humiliatedMod=(S.humiliated||0)*0.012*ws; // severity 1=+1.2%, 2=+2.4%, 3=+3.6%

  var total=base+strMod+techMod+readyMod+focusMod+lungMod+fatigueMod+gripMod+nerveMod+adrenMod+humiliatedMod;
  return Math.max(0.02,Math.min(0.92,total));
}

function getMiniGameParams(liftType,failChance){
  var d=Math.min(1,failChance/0.80);
  var techBonus=Math.max(0,(S.technique-40)/60);
  var focusBonus=Math.max(0,S.focus/100);
  var strBonus=Math.max(0,(S.strength-30)/70);
  var gripBonus=Math.max(0,(S.grip-30)/70);
  if(liftType==='snatch'){
    var speed=(0.4+d*1.4)*1.20;
    speed*=(1-focusBonus*0.25);
    var greenW=(0.12-d*0.08)*0.80;
    greenW+=techBonus*0.03;
    greenW=Math.max(0.025,Math.min(0.15,greenW));
    var yellowW=greenW+0.06+(1-d)*0.04;
    yellowW=Math.min(0.25,yellowW);
    return{type:'balance',markerSpeed:speed,greenWidth:greenW,yellowWidth:yellowW};
  }else{
    var drain=(0.06+d*0.14)*0.90;
    drain*=(1-strBonus*0.25);
    var clickPow=(0.08-d*0.04)*1.10;
    clickPow+=gripBonus*0.01;
    var target=(0.60+d*0.25)*0.90;
    var dur=(4000-d*1500)*1.10;
    var jSpeed=(0.35+d*0.85)*0.90;
    jSpeed*=(1-focusBonus*0.20);
    var jZone=(0.12-d*0.08)*1.10;
    jZone+=techBonus*0.025;
    jZone=Math.max(0.025,Math.min(0.15,jZone));
    var jCenter=0.35+Math.random()*0.30;
    return{type:'power_pump',meterDrain:drain,clickPower:clickPow,meterTarget:target,
      cleanDuration:dur,jerkSpeed:jSpeed,jerkZoneWidth:jZone,jerkZoneCenter:jCenter};
  }
}

function getLiftCost(){
  return Math.max(2,Math.round(ep()*6));
}

// --- INJURY / DNF ---
function getInjuryChance(failChance){
  // No injury possible below 200 lbs
  if(S.barWeight<200)return 0;
  var overload=Math.max(0,(failChance-0.40)/0.50);
  if(overload<=0)return 0;
  var chance=overload*0.20;
  if(S.lastLiftOverload>0){
    chance=0.50+overload*0.40;
  }
  return Math.min(0.90,chance);
}

function triggerDNF(phase){
  console.log('[DNF] triggerDNF start, phase='+phase+', pakAttempt='+S.turn.pakAttempt+', pakDone='+S.turn.pakDone);
  S.dnf=true;
  S.dnfPhase=phase;
  S._pakAutoStarted=false;
  // Lock game and clear turn state — no more player actions
  S.busy=true;
  S.turn.tarkDone=true;
  S.turn.tarkDeclared=0;
  S.turn.whose=null;
  S.turn.phase='dnf';
  S.pose='failed';S.poseT=0;
  S.currentLift=null;
  // Immediately update UI to hide controls
  updUI();
  SFX.siren();SFX.barDrop();
  float('INJURY!',S.tX,130,'#ff2222',28);
  setTimeout(function(){float('DNF',S.tX,170,'#ff4444',24);},400);
  log('===============================','injury');
  log(pick(DNF_MSGS),'injury');
  var phaseLabel=phase==='warmup'?'warm-up':phase==='snatch'?'snatches':'clean & jerk';
  log('It\'s over. DNF during '+phaseLabel+'.','injury');

  // After shaking, hobble to the bench and collapse
  setTimeout(function(){
    function dnfCollapse(){
      log('Tark limps to the bench and keels over.','rest');
      walkTo(getLayout().benchX,function(){
        S.pose='injured';S.poseT=0;

        // Girls come in to laugh at him
        S.girls.phase='entering';
      S.girls.x1=930;S.girls.x2=960;
      S.girls.reactT=0;
      S.girls.result='fail';
      log('Two girls walk in. They take one look and start laughing.','rest');

      // Let the laughing play out
      setTimeout(function(){
        // Wimp runs over with a cigarette
        S.wimp.phase='dnf_running';
        S.wimp.x=W+30;
        S.wimp.destX=190;
        S.wimp.actT=0;
        S.wimp.act='cig_handoff';
        log('That dud from earlier comes sprinting over with a cigarette.','rest');

        // Stop girls from leaving during wimp scene — freeze their reactT
        S.girls.reactT=80;
        S.girls.phase='reacting';

      },4000);

      // Safety: if wimp cinematic breaks, skip to rival lifts after 20s
      setTimeout(function(){
        if(S.phase!=='results'&&S.dnf&&!S._pakAutoStarted){
          S._pakAutoStarted=true;
          S.tv.mode='leaderboard';
          log('===============================','injury');
          log('The remaining lifts play out on the TV...','phase');
          try{
            autoCompletePakLifts(function(){
              log('===============================','phase');
              log('The competition is over.','phase');
              try{unlock();showResults();}catch(e2){console.error('showResults err:',e2);setPhase('results');}
            });
          }catch(e){console.error('autoComplete err:',e);try{showResults();}catch(e3){setPhase('results');}}
        }
      },20000);

      // NUCLEAR SAFETY: if NOTHING worked after 45s, force results no matter what
      setTimeout(function(){
        if(S.phase!=='results'&&S.dnf){
          console.error('NUCLEAR SAFETY: forcing results after 45s');
          log('The competition is over.','phase');
          try{unlock();showResults();}catch(e){try{setPhase('results');}catch(e2){}}
        }
      },45000);
    });
    }
    // If on platform, transition back to backroom first, then collapse
    if(S.scene==='platform'){
      S.scene='backroom';
      S.homeX=LAYOUT.backroom.homeX;
      S.tX=LAYOUT.backroom.homeX;
      S.coachMsg='Oh no... that\'s bad.';
      S.tv.mode='leaderboard';
      dnfCollapse();
    }else{
      dnfCollapse();
    }
  },1500);
}

// --- ACTIONS ---

// BENCH REST
function doBench(){
  if(S.busy)return;
  S.hints.bench=true;S.gymIdleTimer=0;
  lock();

  if(S.phase==='gym'){
    // Fun sit, no stats
    SFX.benchCreak();
    log(pick(GYM_BENCH_MSGS),'rest');
    walkTo(getLayout().benchX,function(){
      S.pose='sitting';S.poseT=0;
      setTimeout(function(){
        S.pose='idle';S.poseT=0;
        walkBack(function(){unlock();});
      },1500);
    });
    return;
  }

  if(S.phase==='warmup'){
    SFX.benchCreak();
    log('Tark takes a seat in the warm-up area. Deep thoughts incoming.','rest');
    walkTo(getLayout().benchX,function(){
      S.pose='sitting';S.poseT=0;
      setTimeout(function(){
        S.strength=clamp(S.strength+2,0,100);
        S.readiness=clamp(S.readiness-8,0,100);
        S.focus=clamp(S.focus+12,0,100);
        float('+2 STR',S.tX-20,180,'#ff6b35',12);
        float('+12 FOC',S.tX+20,180,'#cc88ff',12);
        float('-8 RDY',S.tX,200,'#ff4444',11);
        log('Rested. STR+2, FOC+12, RDY-8. His brain is awake. His body is not.','rest');
        S.pose='idle';S.poseT=0;
        walkBack(function(){unlock();updUI();});
      },3000);
    });
    return;
  }

  // Competition phases — walk to bench, sit, walk back
  if(S.phase==='snatch'||S.phase==='cj'||S.phase==='rest_sn_cj'){
    SFX.benchCreak();
    log('Tark takes a breather on the bench.','rest');
    walkTo(getLayout().benchX,function(){
      S.pose='sitting';S.poseT=0;
      setTimeout(function(){
        S.strength=clamp(S.strength+2,0,100);
        S.focus=clamp(S.focus+5,0,100);
        S.readiness=clamp(S.readiness-5,0,100);
        S.grip=clamp(S.grip-8,0,100);
        S.fatigue=Math.max(0,S.fatigue-0.5);
        float('+2 STR',S.tX-20,180,'#ff6b35',11);
        float('+5 FOC',S.tX+20,180,'#cc88ff',11);
        float('-5 RDY',S.tX,200,'#ff4444',10);
        float('-8 GRIP',S.tX,215,'#ffaa00',10);
        log('Rested. STR+2, FOC+5, RDY-5, GRIP-8. Hands getting cold.','rest');
        S.pose='idle';S.poseT=0;
        walkBack(function(){unlock();updUI();});
      },2500);
    });
    return;
  }

  unlock();
}

// PROTEIN SHAKE
function doShake(){
  if(S.busy)return;

  if(S.phase==='gym'){
    // Cosmetic only — no shake consumed, no stats
    lock();
    SFX.glug();
    var gymShakeMsgs=[
      'Tark chugs a protein shake. It tastes like vanilla concrete.',
      'Pre-game shake. 47 grams of protein. 0 grams of self-doubt.',
      'He drinks the entire thing in one gulp. Impressive and disgusting.',
      'Tark shakes the shaker first. Like a maraca. Then he drinks.',
      '"This isn\'t even my final shake." \u2014 Tark, foreshadowing.',
      'He chugs it. A little dribbles down his chin. He doesn\'t care.'
    ];
    log(pick(gymShakeMsgs),'shake');
    walkTo(getLayout().shakerX,function(){
      S.pose='shake';S.poseT=0;
      setTimeout(function(){
        float('PROTEIN',S.tX,160,'#7fdb6a',14);
        S.pose='idle';S.poseT=0;
        walkBack(function(){unlock();});
      },2000);
    });
    return;
  }

  if(S.shakesLeft<=0){log('All out of protein. Should\'ve bought more.','fail');return;}
  lock();
  S.shakesLeft--;
  SFX.glug();

  if(S.phase==='warmup'){
    log('Tark chugs a protein shake. It tastes like chalk and ambition.','shake');
    walkTo(getLayout().shakerX,function(){
      S.pose='shake';S.poseT=0;
      setTimeout(function(){
        S.strength=clamp(S.strength+12,0,100);
        S.technique=clamp(S.technique+3,0,100);
        S.readiness=clamp(S.readiness+5,0,100);
        S.mult=Math.round((S.mult+0.1)*100)/100;
        float('+12 STR',S.tX-20,170,'#ff6b35',14);
        float('+3 TECH',S.tX+20,170,'#6699ff',12);
        float('+5 RDY',S.tX,190,'#7fdb6a',12);
        float('+0.1x MULT',S.tX,210,'#ffcc00',11);
        log('Shake down. STR+12, TECH+3, RDY+5, MULT+0.1x. ('+S.shakesLeft+' left)','shake');
  
        S.pose='idle';S.poseT=0;
        walkBack(function(){unlock();});
      },2500);
    });
    return;
  }

  // Competition
  log('Quick shake between attempts. Tark doesn\'t even taste it.','shake');
  walkTo(getLayout().shakerX,function(){
    S.pose='shake';S.poseT=0;
    setTimeout(function(){
      S.strength=clamp(S.strength+10,0,100);
      S.mult=Math.round((S.mult+0.1)*100)/100;
      float('+10 STR',S.tX,180,'#ff6b35',14);
      float('+0.1x MULT',S.tX,200,'#ffcc00',12);
      log('Shake. STR+10, MULT+0.1x. ('+S.shakesLeft+' left)','shake');

      S.pose='idle';S.poseT=0;
      walkBack(function(){unlock();});
    },2000);
  });
}

// CHALK
var CHALK_MSGS=[
  'Tark slaps his hands together. A cloud of white.',
  'Chalk up. Grip locked. Mind locked.',
  'The chalk dust rises like a prayer.',
  'Hands white. Bar won\'t slip now.',
  'Tark chalks up. The ritual before the war.'
];
function doChalk(){
  if(S.busy)return;
  if(S.chalkUses<=0){log('No chalk left. Tark wipes his hands on his singlet. It doesn\'t help.','fail');return;}
  // Chalk works in gym and competition
  lock();
  S.chalkUses--;
  SFX.chalkClap();
  log(pick(CHALK_MSGS),'chalk');
  walkTo(getLayout().chalkX,function(){
    S.pose='chalking';S.poseT=0;
    setTimeout(function(){
      S.grip=clamp(S.grip+20,0,100);
      S.technique=clamp(S.technique+3,0,100);
      S.focus=clamp(S.focus+5,0,100);
      S.chalked=true;S.chalkTimer=0;
      float('+20 GRIP',S.tX-20,170,'#ffffff',14);
      float('+3 TECH',S.tX,190,'#44bbff',11);
      float('+5 FOC',S.tX+20,210,'#cc88ff',11);
      log('Chalked up. GRIP+20, TECH+3, FOC+5. ('+S.chalkUses+' left)','chalk');
      S.pose='idle';S.poseT=0;
      walkBack(function(){unlock();});
    },1500);
  });
}

// --- PLATFORM RITUALS ---
function doRitualChalk(){
  if(S.busy)return;
  if(S.turn.phase!=='platform_ritual')return;
  if(S.turn.rituals.chalk){log('Already chalked up this turn.','rest');return;}
  if(S.chalkUses<=0){log('No chalk left.','fail');return;}
  lock();
  S.turn.rituals.chalk=true;
  S.chalkUses--;
  SFX.chalkClap();
  walkTo(LAYOUT.comp.chalkX,function(){
    S.pose='chalking';S.poseT=0;
    setTimeout(function(){
      S.grip=clamp(S.grip+20,0,100);
      S.technique=clamp(S.technique+3,0,100);
      S.focus=clamp(S.focus+5,0,100);
      S.chalked=true;S.chalkTimer=0;
      float('+20 GRIP',S.tX-20,170,'#ffffff',14);
      float('+3 TECH',S.tX,190,'#44bbff',11);
      float('+5 FOC',S.tX+20,210,'#cc88ff',11);
      log('Chalked up on the platform. GRIP+20, TECH+3, FOC+5.','chalk');
      S.pose='idle';S.poseT=0;
      walkTo(LAYOUT.comp.homeX,function(){unlock();updUI();});
    },1200);
  });
}

function doRitualCoach(){
  if(S.busy)return;
  if(S.turn.phase!=='platform_ritual')return;
  if(S.turn.rituals.coach){log('Already talked to coach.','rest');return;}
  lock();
  S.turn.rituals.coach=true;
  S.ritualCoachVisible=true;
  S.ritualCoachX=LAYOUT.comp.benchX;
  var advice=getRitualCoachAdvice();
  S.ritualCoachMsg=advice;
  walkTo(S.ritualCoachX+30,function(){
    S.pose='idle';S.poseT=0;
    S.focus=clamp(S.focus+10,0,100);
    S.nervousness=clamp(S.nervousness-5,0,100);
    float('+10 FOC',S.tX-10,170,'#cc88ff',14);
    float('-5 NERV',S.tX+10,190,'#88ff88',11);
    log('Coach: "'+advice+'" FOC+10, NERV-5.','coach');
    setTimeout(function(){
      S.ritualCoachVisible=false;
      S.ritualCoachMsg='';
      walkTo(LAYOUT.comp.homeX,function(){unlock();updUI();});
    },2000);
  });
}

function doRitualPsyche(){
  if(S.busy)return;
  if(S.turn.phase!=='platform_ritual')return;
  if(S.turn.rituals.psyche){log('Already psyched up.','rest');return;}
  lock();
  S.turn.rituals.psyche=true;
  SFX.psycheScream();
  S.pose='idle';S.poseT=0;
  // Screen shake using existing system
  S.screenShake=10;
  S.speechBubble={text:'AAAARGH!',x:S.tX,y:140,life:1.5,fontSize:16};
  S.adrenaline=clamp(S.adrenaline+15,0,100);
  S.nervousness=clamp(S.nervousness-10,0,100);
  S.strength=clamp(S.strength-2,0,100);
  float('+15 ADR',S.tX-20,170,'#ff8844',14);
  float('-10 NERV',S.tX,190,'#88ff88',11);
  float('-2 STR',S.tX+20,210,'#ff6666',11);
  log('Tark lets out a primal roar! The crowd goes wild. ADR+15, NERV-10, STR-2.','hype');
  setTimeout(function(){SFX.crowdCheer();},400);
  setTimeout(function(){unlock();updUI();},1000);
}

// CIGARETTE
function doSmoke(){
  if(S.busy)return;

  if(S.phase==='gym'){
    // Cosmetic only — no cig consumed, no stats
    lock();
    SFX.lighterFlick();
    var gymSmokeMsgs=[
      'Tark lights one up in the gym. Nobody cares.',
      'A pre-meet cigarette. For the vibes.',
      'Tark smokes indoors. The fire alarm is broken anyway.',
      'He exhales. The gym gets hazier. He gets calmer.',
      'One for the road. Or the platform. Whatever.',
      '"I\'ll quit after this meet." He won\'t.'
    ];
    log(pick(gymSmokeMsgs),'smoke');
    walkTo(getLayout().cigX,function(){
      S.pose='smoke';S.poseT=0;
      setTimeout(function(){
        float('VIBES',S.tX,160,'#aaaaaa',14);
        S.pose='idle';S.poseT=0;
        walkBack(function(){unlock();});
      },2500);
    });
    return;
  }

  if(S.cigsLeft<=0){log('No cigs left. Tark is in withdrawal.','fail');return;}
  lock();
  S.cigsLeft--;
  SFX.lighterFlick();

  var isComp=(S.phase==='snatch'||S.phase==='cj'||S.phase==='rest_sn_cj');

  log('Tark lights one up. The ref pretends not to see.','smoke');
  walkTo(getLayout().cigX,function(){
    S.pose='smoke';S.poseT=0;
    setTimeout(function(){
      // Strength boost
      var strBoost=isComp?5:8;
      S.strength=clamp(S.strength+strBoost,0,100);
      float('+'+strBoost+' STR',S.tX-20,170,'#ff6b35',12);

      if(isComp){
        S.readiness=clamp(S.readiness-3,0,100);
        float('-3 RDY',S.tX+20,190,'#ff4444',10);
      }else{
        S.readiness=clamp(S.readiness-5,0,100);
        float('-5 RDY',S.tX+20,190,'#ff4444',10);
      }

      // Focus roll
      var roll=Math.random();
      if(roll<0.20){
        // NICOTINE RUSH (20%)
        S.focus=clamp(S.focus+25,0,100);
        S.mult=Math.round((S.mult+0.5)*100)/100;
        float('NICOTINE RUSH!',S.tX,140,'#ff00ff',20);
        float('+25 FOC',S.tX,160,'#cc88ff',14);
        float('+0.5x MULT!',S.tX,220,'#ffcc00',14);
        log(pick(CIG_RUSH_MSGS)+' FOC+25, MULT+0.5x! ('+S.cigsLeft+' left)','smoke');
      }else if(roll<0.45){
        // Smooth (25%)
        S.focus=clamp(S.focus+8,0,100);
        float('+8 FOC',S.tX,160,'#cc88ff',13);
        log(pick(CIG_SMOOTH_MSGS)+' FOC+8. ('+S.cigsLeft+' left)','smoke');
      }else if(roll<0.70){
        // Cough (25%)
        S.focus=clamp(S.focus-10,0,100);
        S.lungDamage=Math.min(0.5,S.lungDamage+0.08);
        float('-10 FOC',S.tX,160,'#ff4444',13);
        float('LUNG DMG',S.tX,205,'#ff2222',11);
        log(pick(CIG_COUGH_MSGS)+' FOC-10, lung damage +0.08. ('+S.cigsLeft+' left)','fail');
      }else if(roll<0.88){
        // Bad reaction (18%)
        S.focus=clamp(S.focus-15,0,100);
        S.lungDamage=Math.min(0.5,S.lungDamage+0.12);
        float('-15 FOC',S.tX,160,'#ff4444',14);
        float('LUNG DMG!',S.tX,205,'#ff2222',12);
        log(pick(CIG_BAD_MSGS)+' FOC-15, lung damage +0.12. ('+S.cigsLeft+' left)','fail');
      }else{
        // Existential clarity (12%)
        S.focus=clamp(S.focus+30,0,100);
        S.nervousness=Math.max(0,S.nervousness-20);
        S.lungDamage=Math.min(0.5,S.lungDamage+0.03);
        float('+30 FOC',S.tX,155,'#cc88ff',16);
        float('CLARITY',S.tX,140,'#ffffff',14);
        float('-20 NERVES',S.tX,210,'#7fdb6a',11);
        log(pick(CIG_CLARITY_MSGS)+' FOC+30, NERVES-20. ('+S.cigsLeft+' left)','smoke');
      }


      S.pose='idle';S.poseT=0;
      walkBack(function(){unlock();});
    },3500);
  });
}

// === PICKPOCKET MINI-GAME ===
function doPickpocket(){
  lock();
  S.apartment.subMenu='pickpocket';
  S.apartment.pickpocketAttempted=true;
  var HX=520,HBY=375,SC=2;
  // 6 cigarettes scattered on/around the hobo
  var cigs=[
    {lx:25,ly:8,label:'ground',reachSpeed:0.010},      // on ground near blanket — easy
    {lx:18,ly:2,label:'blanket',reachSpeed:0.008},      // blanket edge — easy
    {lx:-12,ly:-18,label:'coat pocket',reachSpeed:0.006},// coat pocket — medium
    {lx:-5,ly:-32,label:'chest',reachSpeed:0.005},       // shirt/chest — medium
    {lx:-8,ly:-8,label:'lap',reachSpeed:0.005},          // pants/lap — medium-hard
    {lx:8,ly:-50,label:'behind ear',reachSpeed:0.004}    // behind ear — hard
  ];
  for(var i=0;i<cigs.length;i++){
    cigs[i].cx=HX+cigs[i].lx*SC;
    cigs[i].cy=HBY+cigs[i].ly*SC;
    cigs[i].grabbed=false;
    cigs[i].floatTimer=0;
  }
  // Randomized starting difficulty
  var patterns=[
    {timer:300,level:0,count:0}, // generous 5s grace
    {timer:240,level:0,count:0}, // 4s grace
    {timer:200,level:0,count:0}, // 3.3s grace
    {timer:180,level:0,count:0}, // 3s grace
    {timer:150,level:0,count:1}, // 2.5s, one prior stir
    {timer:200,level:0,count:1}, // 3.3s, one prior stir
    {timer:120,level:0,count:0}, // 2s grace
    {timer:160,level:0,count:0}  // 2.7s grace
  ];
  var pat=patterns[Math.floor(Math.random()*patterns.length)];
  S.pickpocket={
    cigarettes:cigs,targetIdx:null,grabbed:0,
    reach:0,holding:false,
    phase:'cutscene', // cutscene|intro|picking|reaching|retracting|caught|escaped
    stirLevel:pat.level,stirTimer:pat.timer,stirCount:pat.count,
    stirActive:false,stirFrame:0,stirDuration:0,
    mumbleText:null,mumbleTimer:0,
    catchTimer:0,tremble:0,
    introTimer:120,
    cutsceneTimer:600,cutsceneStep:'sitting',
    cigSpill:cigs.map(function(){return{progress:0,started:false};})
  };
  log("A homeless man stirs in the alley...","warn");
}

function exitPickpocket(result){
  var pk=S.pickpocket;
  var grabbed=pk?pk.grabbed:0;
  if(result==='escaped'){
    if(grabbed>0){
      S.cigsLeft=Math.min((S.cigsLeft||0)+grabbed,10);
      log("Swiped "+grabbed+" cig"+(grabbed>1?"s":"")+". Tark's hands are quick.","good");
      float('+'+grabbed+' CIG'+(grabbed>1?'S':''),450,200,'#ffcc00',14);
      if(grabbed>=6){
        float('CLEAN SWEEP!',450,170,'#ff6b35',16);
        S.focus=Math.min(100,(S.focus||50)+10);
        S.nervousness=Math.max(0,(S.nervousness||0)-10);
        log("CLEAN SWEEP! FOC+10, NERV-10. Ice cold.","good");
        float('+10 FOC',450,145,'#44aaff',11);
        float('-10 NERV',450,125,'#44ff44',11);
      }
    }else{
      log("Chickened out. No cigs.","info");
    }
  }else{
    S.nervousness=Math.min(100,(S.nervousness||0)+20);
    S.focus=Math.max(0,(S.focus||50)-10);
    log("CAUGHT! He woke up screaming. NERV+20, FOC-10","fail");
    float('+20 NERV',450,200,'#ff4444',14);
    float('-10 FOC',450,220,'#ff6666',11);
  }
  S.pickpocket=null;
  S.apartment.subMenu='door';
  unlock();updUI();
}
window.exitPickpocket=exitPickpocket;

// === DOG CHASE MINI-GAME ===
function generateAlleyProps(){
  var props=[];var x=300;
  while(x<6000){
    var r=Math.random();
    if(r<0.2){props.push({type:'dumpster',x:x,w:60,h:40});x+=100+Math.random()*120;}
    else if(r<0.4){props.push({type:'trashcan',x:x,w:20,h:30});x+=100+Math.random()*100;}
    else if(r<0.55){props.push({type:'puddle',x:x,w:40+Math.random()*30,h:0});x+=70+Math.random()*100;}
    else if(r<0.7){props.push({type:'hydrant',x:x,w:12,h:20});x+=112+Math.random()*150;}
    else if(r<0.85){props.push({type:'crate',x:x,w:25,h:20});x+=85+Math.random()*80;}
    else{props.push({type:'trashbag',x:x,w:18,h:14});x+=108+Math.random()*110;}
  }
  return props;
}
window.generateAlleyProps=generateAlleyProps;

function generateAlleyMidProps(){
  var props=[];var x=100;
  while(x<12000){
    var r=Math.random();
    if(r<0.2){props.push({type:'door',x:x,color:'#3a3028'});x+=200+Math.random()*300;}
    else if(r<0.45){
      var texts=['TARK','NYC','1984','NO PARKING','LIFT BIG','GYM RAT'];
      var cols=['#cc3333','#44cc44','#4488ff','#ff6b35','#ffcc00','#ff69b4'];
      var gi=Math.floor(Math.random()*6);
      props.push({type:'graffiti',x:x,text:texts[gi],color:cols[gi]});
      x+=150+Math.random()*250;
    }
    else if(r<0.7){props.push({type:'window',x:x,lit:Math.random()<0.3});x+=120+Math.random()*200;}
    else if(r<0.85){props.push({type:'pipe',x:x,h:80+Math.random()*120});x+=80+Math.random()*200;}
    else{props.push({type:'ac_unit',x:x});x+=100+Math.random()*250;}
  }
  return props;
}
window.generateAlleyMidProps=generateAlleyMidProps;

function doDogChase(){
  lock();
  S.apartment.subMenu='dogChase';
  S.apartment.dogChaseAttempted=true;
  // Bolt phase (~300 frames / 5 sec): dog is erratic but fast on average
  // Fast runs + brief pauses = avg ~4.5 px/frame, faster than sprint can close meaningfully
  var boltBehaviors=[];var boltFrames=0;
  var boltPauses=['sniffing','looking_back','scratching','peeing'];
  var bpi=0;
  while(boltFrames<300){
    var rd=50+Math.floor(Math.random()*40);
    boltBehaviors.push({type:'burst',speed:6.2,duration:rd,pauseType:null});boltFrames+=rd;
    if(boltFrames>=300)break;
    var pd=25+Math.floor(Math.random()*15);
    boltBehaviors.push({type:'pause',speed:0,duration:pd,pauseType:boltPauses[bpi%4]});
    bpi++;boltFrames+=pd;
  }

  // Main phase (~600 frames): slower runs with longer pauses = catchable
  var behaviors=[];var totalFrames=0;var TARGET=600;
  var pauseTypes=['sniffing','peeing','looking_back','scratching'];
  for(var si=pauseTypes.length-1;si>0;si--){var sj=Math.floor(Math.random()*(si+1));var tmp=pauseTypes[si];pauseTypes[si]=pauseTypes[sj];pauseTypes[sj]=tmp;}
  var pauseIdx=0;
  while(totalFrames<TARGET){
    var runDur=80+Math.floor(Math.random()*60);
    behaviors.push({type:'run',speed:3.5,duration:runDur,pauseType:null});totalFrames+=runDur;
    if(totalFrames>=TARGET)break;
    if(pauseIdx<3&&Math.random()<0.65){
      var pDur=50+Math.floor(Math.random()*40);
      behaviors.push({type:'pause',speed:0,duration:pDur,pauseType:pauseTypes[pauseIdx%4]});
      pauseIdx++;totalFrames+=pDur;
    }else{
      var bDur=40+Math.floor(Math.random()*30);
      behaviors.push({type:'burst',speed:7.0,duration:bDur,pauseType:null});totalFrames+=bDur;
    }
  }
  S.dogChase={
    phase:'theft',theftTimer:160,theftStep:'approach',
    tarkX:200,dogX:380,
    sprinting:false,tarkSpeed:0,dogSpeed:0,
    stamina:100,maxStamina:100,
    boltBehaviors:boltBehaviors,boltIdx:0,boltTimer:boltBehaviors[0].duration,boltDone:false,
    behaviors:behaviors,behaviorIdx:0,behaviorTimer:behaviors[0].duration,
    dogPauseType:null,dogPauseFrame:0,
    tarkStepT:0,dogStepT:0,frameCount:0,
    cameraX:0,
    sweatDrops:[],speedLines:[],
    nearProps:generateAlleyProps(),
    midProps:generateAlleyMidProps(),
    endTimer:0
  };
  log("A stray dog approaches Tark...","warn");
}
window.doDogChase=doDogChase;

function exitDogChase(result){
  if(result==='caught'){
    S.nervousness=Math.max(0,(S.nervousness||0)-15);
    S.focus=Math.min(100,(S.focus||50)+5);
    log("Tark snatched his cigs back. The dog licked his face anyway.","good");
    float('CALM \u2193 NERV',450,200,'#44ff44',14);
    float('SHARP \u2191 FOC',450,220,'#44ff44',11);
  }else{
    S.nervousness=Math.min(100,(S.nervousness||0)+5);
    log("Tark collapsed in an alley. The dog took his smokes.","fail");
    float('NERV \u2191 WORSE',450,200,'#ff4444',14);
  }
  S.dogChase=null;
  S.apartment.subMenu='door';
  unlock();updUI();
}
window.exitDogChase=exitDogChase;

// === APARTMENT ACTIONS ===
var BREAKFAST_MSGS={
  eggs:['Tark cracks 6 raw eggs into a glass. Like Rocky, but worse.','Down the hatch. Tark doesn\'t gag. Barely.','Raw eggs. The breakfast of champions who can\'t cook.'],
  pizza:['Day-old pepperoni. Still good. Probably.','Cold pizza for breakfast. Tark is a man of culture.','He eats it over the sink like a king.'],
  coffee:['Black coffee. No sugar. No cream. No joy.','The coffee is so strong it files its own tax return.','Tark takes a sip. His eyes snap open.'],
  shake:['Morning protein shake. 50 grams. Zero flavor.','He blends it. The blender screams. The cat leaves.','Balanced nutrition. Tark is briefly responsible.'],
  skip:['Tark decides to skip breakfast. His stomach protests.','Empty stomach, full attitude.','No breakfast. He\'ll regret this later.']
};
var SHOWER_MSGS={
  cold:['COLD SHOWER. Tark screams. The cat hides.','The water is freezing. Tark is now fully awake.','Ice water for 30 seconds. Regret and readiness.'],
  hot:['Hot shower. Steam fills the bathroom.','Tark stands under hot water for way too long.','The warmth melts the pre-meet anxiety.'],
  mirror:['Tark stares into the mirror. The mirror stares back.','He points at his reflection. "Today is YOUR day."','Mirror check. Looking good. Looking slightly worried.']
};
var HEADBAND_OPTS=[
  {name:'Red',color:'#cc3333',desc:'Classic Tark'},
  {name:'Blue',color:'#3355cc',desc:'TECH+3'},
  {name:'Gold',color:'#ccaa33',desc:'SWAGGER+10'},
  {name:'Black',color:'#222222',desc:'FOC+5'},
  {name:'None',color:null,desc:'Nothing to prove'}
];
var SHIRT_OPTS=[
  {name:'White Cutoff',style:'cutoff',color:'#f0e6d3',desc:'STR+3'},
  {name:'Black Stringer',style:'stringer',color:'#1a1a1a',desc:'SWAGGER+15'},
  {name:'Grey Tee',style:'tee',color:'#888888',desc:'TECH+5'},
  {name:'No Shirt',style:'none',color:null,desc:'SWAGGER+20 NERV+5'}
];

function doApartmentFridge(){
  if(S.busy)return;
  if(S.apartment.ate){log('Already ate. One breakfast per morning.','fail');return;}
  lock();
  walkTo(LAYOUT.apartment.fridgeX,function(){
    S.pose='idle';S.poseT=0;
    try{SFX.benchCreak();}catch(e){}
    S.apartment.subMenu='fridge';
    unlock();
  });
}
function doBreakfastChoice(choice){
  if(S.busy)return;
  lock();
  S.apartment.subMenu=null;
  S.apartment.ate=true;
  S.apartment.breakfast=choice;
  log(pick(BREAKFAST_MSGS[choice]),choice==='skip'?'fail':'shake');
  if(choice==='skip'){
    // Skip — no eating animation
    setTimeout(function(){
      S.hungry=true;S.strength=clamp(S.strength-5,0,100);
      float('-5 STR',S.tX,180,'#ff4444',12);float('HUNGRY',S.tX,160,'#ff4444',14);
      walkBack(function(){unlock();updUI();renderControls();});
    },800);
    return;
  }
  // Eating animation
  S.pose='eating';S.poseT=0;
  setTimeout(function(){
    if(choice==='eggs'){
      S.strength=clamp(S.strength+10,0,100);S.focus=clamp(S.focus-3,0,100);
      float('+10 STR',S.tX-10,180,'#ff6b35',14);float('-3 FOC',S.tX+10,200,'#ff4444',10);
    }else if(choice==='pizza'){
      S.focus=clamp(S.focus+5,0,100);S.swagger=clamp(S.swagger+10,0,100);
      float('+5 FOC',S.tX,180,'#cc88ff',12);float('+10 SWAGGER',S.tX,200,'#ffcc00',12);
    }else if(choice==='coffee'){
      S.focus=clamp(S.focus+15,0,100);S.readiness=clamp(S.readiness+5,0,100);S.nervousness=clamp(S.nervousness+8,0,100);S.caffeinated=true;
      float('+15 FOC',S.tX-10,180,'#cc88ff',14);float('+5 RDY',S.tX+10,200,'#7fdb6a',12);float('CAFFEINATED',S.tX,160,'#ffcc00',11);
    }else if(choice==='shake'){
      S.strength=clamp(S.strength+5,0,100);S.technique=clamp(S.technique+3,0,100);S.readiness=clamp(S.readiness+3,0,100);
      float('+5 STR',S.tX-15,180,'#ff6b35',12);float('+3 TECH',S.tX+15,180,'#6699ff',12);float('+3 RDY',S.tX,200,'#7fdb6a',12);
    }
    S.pose='idle';
    walkBack(function(){unlock();updUI();renderControls();});
  },2500);
}

function doApartmentBathroom(){
  if(S.busy)return;
  lock();
  walkTo(LAYOUT.apartment.bathroomX,function(){
    S.pose='idle';S.poseT=0;
    S.apartment.subMenu='bathroom';
    unlock();
  });
}
function doBathroomChoice(choice){
  if(S.busy)return;
  if(S.apartment.bathroomPhase)return; // already animating
  lock();
  log(pick(SHOWER_MSGS[choice]),'rest');
  // Start animation phase inside the bathroom
  if(choice==='cold'){
    S.apartment.bathroomPhase='showering_cold';
  }else if(choice==='hot'){
    S.apartment.bathroomPhase='showering_hot';
  }else{
    S.apartment.bathroomPhase='mirror';
  }
  S.apartment.bathroomT=0;
  // Tick animation timer
  var dur=choice==='mirror'?2500:3000;
  var startT=Date.now();
  var bathroomTick=setInterval(function(){
    S.apartment.bathroomT=(Date.now()-startT)/1000;
  },50);
  // After animation completes, apply stats but STAY in bathroom
  setTimeout(function(){
    clearInterval(bathroomTick);
    if(choice==='cold'){
      S.apartment.showered=true;S.apartment.shower='cold';
      S.focus=clamp(S.focus+12,0,100);S.readiness=clamp(S.readiness+10,0,100);S.nervousness=Math.max(0,S.nervousness-5);
      float('+12 FOC',200,120,'#cc88ff',14);float('+10 RDY',200,140,'#7fdb6a',14);float('ICE COLD',200,100,'#6699ff',16);
    }else if(choice==='hot'){
      S.apartment.showered=true;S.apartment.shower='hot';
      S.focus=clamp(S.focus+5,0,100);S.readiness=clamp(S.readiness+5,0,100);S.nervousness=Math.max(0,S.nervousness-15);
      float('+5 FOC',200,120,'#cc88ff',12);float('+5 RDY',200,140,'#7fdb6a',12);float('RELAXED',200,100,'#7fdb6a',16);
    }else if(choice==='mirror'){
      S.apartment.mirrorChecked=true;
      S.swagger=clamp(S.swagger+15,0,100);S.focus=clamp(S.focus+5,0,100);
      float('+15 SWAGGER',665,120,'#ffcc00',14);float('+5 FOC',665,140,'#cc88ff',12);
    }
    // Reset animation phase — back to idle bathroom view
    S.apartment.bathroomPhase=null;S.apartment.bathroomT=0;
    // Stay in bathroom — user clicks EXIT when ready
    unlock();updUI();
  },dur);
}

function doApartmentWardrobe(){
  if(S.busy)return;
  if(S.apartment.dressed){log('Already dressed. Looking good.','fail');return;}
  lock();
  walkTo(LAYOUT.apartment.wardrobeX,function(){
    S.pose='idle';S.poseT=0;
    S.apartment.subMenu='wardrobe';
    renderControls();
    unlock();
  });
}
function doHeadbandChoice(idx){
  var opt=HEADBAND_OPTS[idx];
  S.outfit.headband=opt.color;S.outfit.headbandName=opt.name;
  if(opt.name==='Blue')S.technique=clamp(S.technique+3,0,100);
  if(opt.name==='Gold')S.swagger=clamp(S.swagger+10,0,100);
  if(opt.name==='Black')S.focus=clamp(S.focus+5,0,100);
  float(opt.name+' HEADBAND',S.tX,180,'#ffcc00',12);
  log(opt.name+' headband selected. '+opt.desc+'.','shake');
  updUI();renderControls();
}
function doShirtChoice(idx){
  if(S.busy)return;
  lock();
  var opt=SHIRT_OPTS[idx];
  S.outfit.shirt=opt.color;S.outfit.shirtStyle=opt.style;S.outfit.shirtName=opt.name;
  S.apartment.dressed=true;S.apartment.subMenu=null;
  if(opt.style==='cutoff'){S.strength=clamp(S.strength+3,0,100);float('+3 STR',S.tX,200,'#ff6b35',12);}
  if(opt.style==='stringer'){S.swagger=clamp(S.swagger+15,0,100);float('+15 SWAGGER',S.tX,200,'#ffcc00',12);}
  if(opt.style==='tee'){S.technique=clamp(S.technique+5,0,100);float('+5 TECH',S.tX,200,'#6699ff',12);}
  if(opt.style==='none'){S.swagger=clamp(S.swagger+20,0,100);S.nervousness=clamp(S.nervousness+5,0,100);float('+20 SWAGGER',S.tX,200,'#ffcc00',14);}
  float(opt.name.toUpperCase(),S.tX,180,'#ffcc00',14);
  log(opt.name+' equipped. '+opt.desc+'.','shake');
  walkBack(function(){unlock();updUI();renderControls();});
}

function doApartmentTV(){
  if(S.busy)return;
  if(S.apartment.watchedTV){log('Already watched TV. Get moving, Tark.','fail');return;}
  lock();
  walkTo(LAYOUT.apartment.tvX,function(){
    S.pose='idle';S.poseT=0;
    S.apartment.subMenu='vhs';
    unlock();
  });
}
function doVHSChoice(choice){
  if(S.busy)return;
  lock();
  S.apartment.subMenu=null;
  S.apartment.watchedTV=true;
  S.apartment.vhsChoice=choice;
  // Speech bubble per choice
  var bubbles={
    pumping:'"The greatest movie ever made."',
    predator:'"Get to the chopper..."',
    predator2:'"No Arnold... but it\'ll do."',
    rumping:'"...research purposes."'
  };
  var logs={
    pumping:'Tark slides in Pumping Iron. The only tape that matters.',
    predator:'Tark loads Predator. Time to get in killer mode.',
    predator2:'Tark puts on Predator 2. Danny Glover holds it down.',
    rumping:'Tark hesitates... then puts in Rumping Iron. No judgement.'
  };
  S.speechBubble={text:bubbles[choice],x:S.tX,y:280,life:2.2};
  log(logs[choice],'hype');
  try{SFX.benchCreak();}catch(e){}
  setTimeout(function(){
    S.facing='away';
    setTimeout(function(){
      // Stats per choice
      if(choice==='pumping'){
        S.technique=clamp(S.technique+5,0,100);S.strength=clamp(S.strength+3,0,100);
        float('+5 TECH',S.tX-10,180,'#6699ff',14);float('+3 STR',S.tX+10,200,'#ff6b35',12);
        float('PUMPING IRON',S.tX,160,'#ff6b35',13);
      }else if(choice==='predator'){
        S.focus=clamp(S.focus+8,0,100);S.readiness=clamp(S.readiness+5,0,100);
        float('+8 FOC',S.tX-10,180,'#cc88ff',14);float('+5 RDY',S.tX+10,200,'#7fdb6a',12);
        float('PREDATOR',S.tX,160,'#7fdb6a',13);
      }else if(choice==='predator2'){
        S.focus=clamp(S.focus+3,0,100);S.nervousness=Math.max(0,S.nervousness-8);
        float('+3 FOC',S.tX-10,180,'#cc88ff',12);float('-8 NERVES',S.tX+10,200,'#7fdb6a',12);
        float('PREDATOR II',S.tX,160,'#6688aa',13);
      }else if(choice==='rumping'){
        S.swagger=clamp(S.swagger+15,0,100);S.nervousness=clamp(S.nervousness+5,0,100);
        float('+15 SWAGGER',S.tX-10,180,'#ffcc00',14);float('+5 NERVES',S.tX+10,200,'#ff4444',10);
        float('RUMPING IRON',S.tX,160,'#ff69b4',13);
      }
      setTimeout(function(){
        S.facing='left';
        walkBack(function(){unlock();updUI();renderControls();});
      },2000);
    },1500);
  },1000);
}

function doApartmentPhone(){
  if(S.busy)return;
  lock();
  walkTo(LAYOUT.apartment.phoneX,function(){
    S.pose='idle';S.poseT=0;
    S.apartment.subMenu='phone';
    log('Tark picks up the rotary phone. Who to call?','info');
    if(!S.thoughtSeen['phone']){S.thoughtSeen['phone']=true;narrateScene();}
    unlock();updUI();renderControls();
  });
}

function doCallGym(){
  if(S.busy)return;
  if(S.apartment.phoneUsed.gym){float('Already called.',S.tX,200,'#888',11);return;}
  lock();S.apartment.phoneUsed.gym=true;
  S.apartment.subMenu=null;S.apartment.onCall=true;
  log('Tark dials the gym.','rest');
  var bx=S.tX,by=240;
  S.speechBubble={text:'"Ring ring..."',x:bx,y:by,life:1.5,fontSize:10};
  setTimeout(function(){
    S.speechBubble={text:'"Gold\'s Gym Venice. We\'re open."',x:bx,y:by,life:2.0,fontSize:10};
    log('"Gold\'s Gym Venice. We\'re open."','rest');
  },1600);
  setTimeout(function(){
    S.speechBubble={text:'"Just checking. I\'ll be there."',x:bx,y:by,life:2.0,fontSize:10};
    log('Tark: "Just checking. I\'ll be there."','rest');
  },3800);
  setTimeout(function(){
    S.apartment.onCall=false;
    S.focus=clamp(S.focus+5,0,100);
    float('+5 FOCUS',bx,160,'#cc88ff',12);
    log('Tark hangs up. Feeling focused.','hype');
    S.pose='idle';unlock();updUI();renderControls();
  },6000);
}

function doCallCoach(){
  if(S.busy)return;
  if(S.apartment.phoneUsed.coach){float('Already called.',S.tX,200,'#888',11);return;}
  lock();S.apartment.phoneUsed.coach=true;
  S.apartment.subMenu=null;S.apartment.onCall=true;
  log('Tark dials Coach.','rest');
  var bx=S.tX,by=240;
  S.speechBubble={text:'"Ring ring..."',x:bx,y:by,life:1.5,fontSize:10};
  setTimeout(function(){
    S.speechBubble={text:'"Yeah."',x:bx,y:by,life:1.5,fontSize:10};
    log('Coach picks up: "Yeah."','rest');
  },1600);
  setTimeout(function(){
    S.speechBubble={text:'"Coach, it\'s Tark. Today\'s the day."',x:bx,y:by,life:2.0,fontSize:10};
  },3200);
  setTimeout(function(){
    S.speechBubble={text:'"Listen to me. You\'re the strongest guy in that room."',x:bx,y:by,life:2.5,fontSize:9};
    log('Coach: "You\'re the strongest guy in that room."','hype');
  },5400);
  setTimeout(function(){
    S.speechBubble={text:'"Don\'t think. Just lift. I\'ll be there."',x:bx,y:by,life:2.5,fontSize:9};
    log('Coach: "Don\'t think. Just lift."','hype');
  },8000);
  setTimeout(function(){
    S.apartment.onCall=false;
    S.focus=clamp(S.focus+5,0,100);S.nervousness=Math.max(0,S.nervousness-5);
    float('+5 FOCUS',S.tX-20,160,'#cc88ff',12);float('-5 NERVES',S.tX+20,160,'#7fdb6a',11);
    log('Click. Tark hangs up. Ready.','hype');
    S.pose='idle';unlock();updUI();renderControls();
  },10800);
}

function doCallMother(){
  if(S.busy)return;
  if(S.apartment.phoneUsed.mother){float('Already called Ma.',S.tX,200,'#888',11);return;}
  lock();S.apartment.phoneUsed.mother=true;
  S.apartment.subMenu=null;S.apartment.onCall=true;
  log('Tark dials Ma.','rest');
  var bx=S.tX,by=240;
  S.speechBubble={text:'"Ring ring..."',x:bx,y:by,life:1.5,fontSize:10};
  setTimeout(function(){
    S.speechBubble={text:'"Hello?"',x:bx,y:by,life:1.5,fontSize:10};
    log('Ma picks up: "Hello?"','rest');
  },1600);
  setTimeout(function(){
    S.speechBubble={text:'"Ma, it\'s Tark."',x:bx,y:by,life:1.8,fontSize:10};
  },3200);
  setTimeout(function(){
    S.speechBubble={text:'"TARKY! Oh my God, you never call!"',x:bx,y:by,life:2.2,fontSize:9};
    log('Ma: "TARKY! Oh my God, you never call!"','rest');
  },5200);
  setTimeout(function(){
    S.speechBubble={text:'"I called last week, Ma."',x:bx,y:by,life:1.8,fontSize:10};
  },7600);
  setTimeout(function(){
    S.speechBubble={text:'"Last week?! LAST WEEK?! That was two months ago!"',x:bx,y:by,life:2.5,fontSize:8};
    log('Ma: "That was two months ago!"','rest');
  },9600);
  setTimeout(function(){
    S.speechBubble={text:'"Ma\u2014"',x:bx,y:by,life:1.2,fontSize:10};
  },12300);
  setTimeout(function(){
    S.speechBubble={text:'"I want breakfast with my son. Is that too much to ask?"',x:bx,y:by,life:2.8,fontSize:8};
    log('Ma: "I want breakfast with my son!"','rest');
  },13700);
  setTimeout(function(){
    S.speechBubble={text:'"Fine, Ma. I\'ll take you to breakfast."',x:bx,y:by,life:2.2,fontSize:9};
    log('Tark: "Fine, Ma. I\'ll take you to breakfast."','rest');
  },16700);
  setTimeout(function(){
    S.speechBubble={text:'"Somewhere NICE, Tark. Not that gas station again."',x:bx,y:by,life:2.5,fontSize:8};
    log('Ma: "Somewhere NICE, Tark."','rest');
  },19100);
  setTimeout(function(){
    S.speechBubble={text:'"I know a place, Ma. Real classy."',x:bx,y:by,life:2.2,fontSize:9};
    log('Tark: "I know a place. Real classy."','hype');
  },21800);
  setTimeout(function(){
    S.apartment.onCall=false;
    S.speechBubble={text:'Continental breakfast. Free.',x:bx,y:by,life:2.5,fontSize:10};
    log('Tark\'s inner monologue: "Continental breakfast. Free."','hype');
    S.nervousness=Math.max(0,S.nervousness-5);S.swagger=clamp(S.swagger+5,0,100);
    float('-5 NERVES',S.tX-20,160,'#7fdb6a',11);float('+5 SWAG',S.tX+20,160,'#ff6b35',11);
    S.apartment.motherMission=true;
    S.pose='idle';unlock();updUI();renderControls();
  },24200);
}

window.doApartmentPhone=doApartmentPhone;
window.doCallGym=doCallGym;
window.doCallCoach=doCallCoach;
window.doCallMother=doCallMother;

function doApartmentDumbbells(){
  if(S.busy)return;
  if(S.apartment.pumped){log('Already did a morning pump. Save it for the meet.','fail');return;}
  lock();
  walkTo(LAYOUT.apartment.dumbX,function(){
    S.pose='pumping';S.poseT=0;S.apartment.pumped=true;
    try{SFX.metalClang();}catch(e){}
    log('Quick morning curls. Just to get the blood flowing.','hype');
    setTimeout(function(){
      S.strength=clamp(S.strength+5,0,100);S.readiness=clamp(S.readiness+5,0,100);
      float('+5 STR',S.tX-15,180,'#ff6b35',14);float('+5 RDY',S.tX+15,180,'#7fdb6a',14);float('MORNING PUMP',S.tX,160,'#ffcc00',12);
      S.pose='idle';
      walkBack(function(){unlock();updUI();renderControls();});
    },3000);
  });
}

function doApartmentSmoke(){
  if(S.busy)return;
  lock();
  try{SFX.lighterFlick();}catch(e){}
  var msgs=['Morning cigarette. Tark\'s daily ritual.','He lights up before the sun is fully up. Dedication.','First smoke of the day. Technically a warm-up.'];
  log(pick(msgs),'rest');
  walkTo(LAYOUT.apartment.cigX,function(){
    S.pose='smoke';S.poseT=0;
    setTimeout(function(){
      S.focus=clamp(S.focus+5,0,100);
      float('+5 FOC',S.tX,180,'#cc88ff',12);float('MORNING VIBES',S.tX,160,'#aaaaaa',11);
      S.pose='idle';S.poseT=0;
      walkBack(function(){unlock();updUI();});
    },2500);
  });
}

function doApartmentMattress(){
  if(S.busy)return;
  lock();
  log('Tark lies back down. Just five more minutes...','rest');
  walkTo(LAYOUT.apartment.mattressX,function(){
    S.pose='lyingdown';S.poseT=0;
    setTimeout(function(){
      S.readiness=clamp(S.readiness-5,0,100);S.focus=clamp(S.focus-3,0,100);
      float('-5 RDY',S.tX,350,'#ff4444',11);float('-3 FOC',S.tX,365,'#ff4444',11);float('SLEEPY',S.tX,340,'#6699cc',12);
      log('Can\'t afford to be lazy on meet day.','fail');
      S.pose='idle';S.poseT=0;
      walkBack(function(){unlock();updUI();});
    },2500);
  });
}

function doApartmentDoor(){
  if(S.busy)return;
  lock();
  walkTo(LAYOUT.apartment.doorX,function(){
    S.apartment.subMenu='door';
    unlock();updUI();renderControls();
  });
}
function doApartmentDoorChoice(dest){
  if(S.busy)return;
  // Convert swagger to nervousness reduction on leaving
  if(S.swagger>0){
    var nervRed=Math.round(S.swagger*0.3);
    S.nervousness=Math.max(0,S.nervousness-nervRed);
    if(nervRed>0)log('Swagger converted: NERVES-'+nervRed+'.','hype');
  }
  if(S.hungry){S.fatigue=clamp(S.fatigue+0.1,0,1);log('Empty stomach. Fatigue will hit harder today.','fail');}
  lock();
  S.apartment.subMenu=null;
  if(dest==='beach'){
    log('Tark heads to Venice Beach. Sun and trouble.','phase');
    S.sceneTransition={
      progress:0,duration:40,
      midCallback:function(){
        setPhase('beach');
        S.homeX=LAYOUT.beach.homeX;
        S.tX=-30;S.pose='idle';
      },
      endCallback:function(){
        walkTo(LAYOUT.beach.homeX,function(){
          unlock();
          log('Venice Beach. Sun, sand, strangers. Three beers left.','phase');
          log('Click on a couple to approach them.','rest');
        });
      }
    };
  }else if(dest==='downtown'){
    log('Tark heads downtown. Concrete and neon.','phase');
    S.sceneTransition={
      progress:0,duration:40,
      midCallback:function(){
        setPhase('downtown');
        S.homeX=LAYOUT.downtown.homeX;
        S.tX=-30;S.pose='idle';
      },
      endCallback:function(){
        walkTo(LAYOUT.downtown.homeX,function(){
          unlock();
          log('Downtown. A dive bar, a bodega, and a hotel nobody checks into sober.','phase');
          log('Click on a building to go inside.','rest');
        });
      }
    };
  }else{
    log('Tark heads straight to the gym. All business.','phase');
    S.sceneTransition={
      progress:0,duration:40,
      midCallback:function(){
        setPhase('gym');
        S.homeX=LAYOUT.gym.homeX;
        S.tX=-30;S.pose='idle';
      },
      endCallback:function(){
        walkTo(LAYOUT.gym.homeX,function(){
          unlock();
          log('Tark Farley stands in his gym. The barbell awaits.','phase');
          log('Click the bench, rack, shaker, or cig pack. Or use the buttons.','rest');
          log("When you're ready, enter the meet.",'rest');
        });
      }
    };
  }
}

function cancelSubMenu(){
  S.apartment.subMenu=null;
  // Clean up bathroom animation state if exiting mid-animation
  S.apartment.bathroomPhase=null;S.apartment.bathroomT=0;
  walkBack(function(){unlock();updUI();renderControls();});
}

// ============================================================
// BEACH PHASE — Venice Beach scene with couples & beach gym
// ============================================================

var BEACH_COUPLE_NAMES=['The Khaki Guy','The Surfer','The Big Dude'];
var BEACH_COUPLE_COLORS=[
  // Khaki Guy: light tan, blond surfer hair, pink bikini blonde girlfriend
  {man:'#f0c888',shirt:'#f0c888',hair:'#c8a848',shorts:'#e8cc88',
   w:'#f5d8b0',wshirt:'#ff5588',whair:'#f0d060',wshorts:'#ff88aa',wsandal:'#d4a574'},
  // Surfer: olive tan, dark hair, brunette girlfriend in teal bikini
  {man:'#e8b870',shirt:'#e8b870',hair:'#222',shorts:'#2288aa',
   w:'#f0c4a8',wshirt:'#22ccaa',whair:'#3a2a1a',wshorts:'#22ccaa',wsandal:'#c8956e'},
  // Big Dude: dark tan, bald/buzzcut, black-haired girlfriend in red bikini
  {man:'#d4a060',shirt:'#d4a060',hair:'#111',shorts:'#cc2222',
   w:'#e8c898',wshirt:'#dd2244',whair:'#111',wshorts:'#dd2244',wsandal:'#b8855e'}
];
// Rival trash talk between rounds (by toughness tier)
var COMP_TRASH_LOW=['"Lucky pull, bro."','"I can do this all day... maybe."','"*nervous laugh* Not bad."','"Y-you got lucky."'];
var COMP_TRASH_MED=['"Not bad. Let\'s see you match this."','"Getting heavy, huh?"','"I do this every morning."','"You\'re sweating already."'];
var COMP_TRASH_HIGH=['"You\'re done."','"Walk away while you can."','"Cute attempt."','"That all you got?"'];
// Girlfriend reactions (cheering / sad)
var GIRL_CHEER=['"Go baby!"','"That\'s my man!"','"You got this!"','"YES!"','"COME ON!"'];
var GIRL_SAD=['"Oh no..."','"*covers eyes*"','"It\'s okay..."','"Babe..."'];

function drawBeachBackground(){
  // Sky gradient — morning gold/blue
  var grad=cx.createLinearGradient(0,0,0,200);
  grad.addColorStop(0,'#1a3a6a');grad.addColorStop(0.5,'#4488bb');grad.addColorStop(1,'#ff9955');
  cx.fillStyle=grad;cx.fillRect(0,0,W,200);
  // Sun
  cx.globalAlpha=0.6;C(120,60,35,'#ffe866');cx.globalAlpha=0.3;C(120,60,50,'#ffe866');cx.globalAlpha=1;
  // Ocean
  R(0,160,W,60,'#2266aa');
  var t=Date.now()*0.001;
  cx.strokeStyle='#3388cc';cx.lineWidth=1;
  for(var wi=0;wi<5;wi++){
    cx.beginPath();
    for(var wx=0;wx<W;wx+=3){
      var wy=170+wi*10+Math.sin(t*1.5+wx*0.02+wi)*3;
      if(wx===0)cx.moveTo(wx,wy);else cx.lineTo(wx,wy);
    }
    cx.stroke();
  }

  // Surfer on the water (left side)
  var sx=280+Math.sin(t*0.4)*15,sy=185+Math.sin(t*1.2)*2;
  R(sx-2,sy,4,12,'#c49060'); // body
  C(sx,sy-4,3,'#c49060'); // head
  R(sx-8,sy+10,16,2,'#f0e6d3'); // surfboard
  // wave splash
  cx.globalAlpha=0.3;C(sx-6,sy+12,3,'#aaddff');C(sx+6,sy+12,3,'#aaddff');cx.globalAlpha=1;

  // Jetski on the water (right side)
  var jx=650+Math.sin(t*0.6)*20,jy=178+Math.sin(t*0.9)*2;
  R(jx-10,jy,20,8,'#dd4444'); // jetski body
  R(jx-12,jy+2,4,4,'#cc3333'); // nose
  R(jx+8,jy-2,4,6,'#cc3333'); // rear
  R(jx-4,jy-8,6,10,'#c49060'); // rider body
  C(jx-1,jy-12,3,'#c49060'); // rider head
  // wake spray
  cx.globalAlpha=0.4;
  C(jx+16,jy+4,4,'#aaddff');C(jx+20,jy+2,3,'#aaddff');C(jx+24,jy+5,2,'#aaddff');
  cx.globalAlpha=1;

  // Foam line
  R(0,218,W,4,'#aaddff');
  // Sand
  R(0,220,W,H-220,'#d4b896');
  // Sand texture
  cx.globalAlpha=0.05;
  for(var sy2=222;sy2<H;sy2+=8)R(0,sy2,W,2,'#000');
  cx.globalAlpha=1;
  // Boardwalk (top of sand, Y=214-232)
R(220,214,600,18,'#b8956a');
for(var bwi=0;bwi<15;bwi++){R(220+bwi*40,214,2,18,'#9a7a55');}
R(220,231,600,2,'#8a6a4a');
R(220,212,600,3,'#9a8060');
for(var bri=0;bri<7;bri++){R(240+bri*85,210,3,22,'#8a7050');}
// Background cyclists on boardwalk
var bwt2=Date.now()*0.001;
var bc1x2=(bwt2*30)%650+230;if(bc1x2>220&&bc1x2<810){R(bc1x2,210,7,5,'#444');C(bc1x2+3,207,2.5,'#d4a574');C(bc1x2-2,215,2.5,'#333');C(bc1x2+7,215,2.5,'#333');}
var bc2x2=800-(bwt2*22)%650;if(bc2x2>220&&bc2x2<810){R(bc2x2,211,6,4,'#cc3366');C(bc2x2+3,208,2.5,'#e8c898');C(bc2x2-2,215,2.5,'#333');C(bc2x2+6,215,2.5,'#333');}
if(hover==='boardwalkZone'&&!S.busy&&!S.beach.subMenu&&!S.beach.gymComp.active){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(220,210,590,25);}

  // === MUSCLE BEACH OUTDOOR GYM (left background) ===
  // Concrete platform
  R(20,225,180,12,'#999');R(20,224,180,2,'#aaa');
  // Main squat rack / pull-up structure
  R(30,175,8,50,'#555');R(180,175,8,50,'#555'); // tall uprights
  R(28,172,162,6,'#666'); // top crossbar
  R(28,195,162,4,'#555'); // mid crossbar
  // Pull-up bar
  R(60,178,4,18,'#444');R(140,178,4,18,'#444');
  R(58,176,86,4,'#666');
  // Bench press station
  R(50,218,50,8,'#777'); // bench pad
  R(45,214,6,14,'#555');R(100,214,6,14,'#555'); // bench uprights
  R(43,212,64,4,'#666'); // barbell
  R(38,210,8,6,'#888');R(102,210,8,6,'#888'); // plates
  // Dumbbell rack (front)
  R(130,218,40,8,'#666');
  R(132,214,6,6,'#888');R(140,214,6,6,'#888');R(148,214,6,6,'#888');R(156,214,6,6,'#888');
  // Tiny gym-goer silhouettes
  cx.globalAlpha=0.5;
  // Guy doing pull-ups
  R(96,180,4,10,'#333');C(98,177,3,'#c49060');
  R(92,182,4,6,'#c49060');R(100,182,4,6,'#c49060'); // arms up
  // Guy at bench
  R(70,214,6,8,'#333');C(73,210,3,'#c49060');
  cx.globalAlpha=1;
  // "MUSCLE BEACH" sign
  R(55,166,100,10,'#cc3333');
  T('MUSCLE BEACH',105,174,6,'#fff');

  // Palm tree 1 (near gym)
  R(208,100,8,140,'#6b4226');R(210,102,4,136,'#7a5030');
  drawPalmFronds(212,95);
  // Palm tree 2 (right area)
  R(618,100,8,140,'#6b4226');R(620,102,4,136,'#7a5030');
  drawPalmFronds(622,95);

  // Beach bathroom / restroom building (concrete block near boardwalk)
  R(640,180,70,55,'#b0a898'); // main building
  R(640,178,70,4,'#8a7a6a'); // roof edge
  R(636,175,78,5,'#9a8a7a'); // roof overhang
  R(652,195,18,38,'#5a4a3a'); // door 1 (men's)
  R(678,195,18,38,'#5a4a3a'); // door 2 (women's)
  R(668,195,12,38,'#a09888'); // divider wall
  // Door handles
  C(666,214,1.5,'#cc9944');C(692,214,1.5,'#cc9944');
  // Signs
  R(654,188,14,6,'#fff');T('M',661,193,5,'#333'); // Men's
  R(682,188,14,6,'#fff');T('W',689,193,5,'#333'); // Women's
  // "RESTROOMS" text on top
  R(648,179,44,6,'#6a5a4a');
  cx.font='4px monospace';cx.fillStyle='#ddd';cx.textAlign='center';cx.fillText('RESTROOMS',675,184);cx.textAlign='center';
  // Grungy details
  cx.globalAlpha=0.1;R(642,210,20,22,'#4a3a2a');R(690,215,15,18,'#4a3a2a');cx.globalAlpha=1;
  // Hover highlight
  if(hover==='beachBathroom'&&!S.busy&&!S.beach.subMenu&&!S.beach.gymComp.active){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(638,176,74,60);}

  // Lifeguard tower (right background)
  R(770,140,6,80,'#cc8844');R(810,140,6,80,'#cc8844');
  R(765,130,56,14,'#dd6644');R(768,108,50,24,'#ffcc66');
  R(780,112,8,12,'#88ccff');R(798,112,8,12,'#88ccff');
  R(785,128,16,4,'#dd4422');

  // Background beachgoers (scattered, small, adds life)
  // Sunbather (towel + lying figure)
  R(300,260,25,5,'#ff6699'); // pink towel
  R(303,257,18,4,'#c49060'); // lying body
  C(301,257,3,'#c49060'); // head
  // Walking couple (far background, near water)
  cx.globalAlpha=0.6;
  R(500,232,4,10,'#2244aa');C(502,228,3,'#e8c898'); // person 1
  R(510,232,4,10,'#cc4488');C(512,228,3,'#f0c4a8'); // person 2
  cx.globalAlpha=1;
  // Jogger (right side)
  var jogX=380+((Date.now()*0.02)%200);if(jogX>580)jogX-=200;
  R(jogX,248,4,8,'#444');C(jogX+2,244,3,'#d4a574');
  R(jogX-2,248+Math.sin(Date.now()*0.01)*2,3,4,'#d4a574'); // moving leg
  // Guy with dog (mid-right)
  R(560,270,4,10,'#336644');C(562,265,3,'#e8c898');
  R(572,274,8,5,'#8b6914');C(580,273,2,'#8b6914'); // small dog

  // Beach exit — boardwalk path leading off-screen right
  // Wooden boardwalk planks going to the right
  R(830,FY-20,70,FY-220+20,'#b8956a');
  for(var pi=0;pi<8;pi++){
    var py=225+pi*22;
    R(830,py,70,2,'#9a7a55'); // plank gap lines
  }
  // Railing posts
  R(830,230,4,40,'#8a7050');R(870,230,4,40,'#8a7050');
  R(828,228,48,4,'#9a8060'); // top rail
  // Arrow sign on post
  R(835,238,35,14,'#3a6a3a');
  T('GYM \u2192',852,248,7,'#f0e6d3');
  // Hover highlight handled in draw loop
}

function drawPalmFronds(x,y){
  cx.fillStyle='#2a7a2a';
  var fronds=[[-35,-15,30,8],[30,-15,-25,8],[-25,-25,20,6],[20,-25,-15,6],[-10,-30,10,5],[5,-30,-5,5]];
  for(var i=0;i<fronds.length;i++){
    var f=fronds[i];
    cx.beginPath();cx.moveTo(x,y);
    cx.quadraticCurveTo(x+f[0]*0.5,y+f[1]-10,x+f[0],y+f[1]);
    cx.lineTo(x+f[0]+f[2],y+f[1]+f[3]);
    cx.quadraticCurveTo(x+f[0]*0.3,y+f[1]+5,x,y+4);
    cx.fill();
  }
}

function drawBeerPack(bx,by,remaining){
  // 6-pack: plastic rings on TOP, cans hanging BELOW. 3x2 grid.
  var sp=11; // spacing between cans
  // Plastic ring carrier (top part Tark holds)
  for(var row=0;row<2;row++){
    for(var col=0;col<3;col++){
      cx.strokeStyle='#bbb';cx.lineWidth=1;
      cx.beginPath();cx.arc(bx+col*sp+3,by+row*sp+3,4,0,Math.PI*2);cx.stroke();
    }
  }
  // Connector bars between rings
  cx.strokeStyle='#aaa';cx.lineWidth=0.5;
  for(var col=0;col<2;col++){cx.beginPath();cx.moveTo(bx+col*sp+7,by+3);cx.lineTo(bx+(col+1)*sp-1,by+3);cx.stroke();
    cx.beginPath();cx.moveTo(bx+col*sp+7,by+sp+3);cx.lineTo(bx+(col+1)*sp-1,by+sp+3);cx.stroke();}
  for(var col2=0;col2<3;col2++){cx.beginPath();cx.moveTo(bx+col2*sp+3,by+7);cx.lineTo(bx+col2*sp+3,by+sp-1);cx.stroke();}
  // Cans hanging below the rings
  var canIdx=0;
  for(var row=0;row<2;row++){
    for(var col=0;col<3;col++){
      var ccx=bx+col*sp,ccy=by+row*sp+7;
      if(canIdx<remaining){
        // Aluminum can — tall narrow cylinder
        R(ccx,ccy,7,16,'#c0c0c0'); // silver body
        R(ccx+1,ccy+3,5,10,'#cc2222'); // red label band
        R(ccx+1,ccy+1,5,2,'#d0d0d0'); // rim top
        R(ccx+1,ccy+14,5,2,'#a0a0a0'); // rim bottom
        // Pull tab
        R(ccx+2,ccy,3,1,'#888');
        // Label highlight
        cx.globalAlpha=0.2;R(ccx+1,ccy+5,2,6,'#fff');cx.globalAlpha=1;
      }else{
        // Empty ring — just show the ring outline
        cx.strokeStyle='#999';cx.lineWidth=0.5;
        cx.beginPath();cx.arc(ccx+3,ccy+8,3,0,Math.PI*2);cx.stroke();
      }
      canIdx++;
    }
  }
}

function drawBeachCoupleSmall(ci,cx2,cy2,scale){
  var cc=BEACH_COUPLE_COLORS[ci];
  var couple=S.beach.couples[ci];
  if(couple.gone)return;
  var s=scale||1;
  // Man (unless cowered) — shirtless with board shorts
  if(!couple.cowered){
    var mx=cx2-12*s,my=cy2;
    // Board shorts
    R(mx-5*s,my+14*s,4*s,10*s,cc.shorts);R(mx+1*s,my+14*s,4*s,10*s,cc.shorts);
    // Bare calves
    R(mx-4*s,my+24*s,3*s,6*s,cc.man);R(mx+2*s,my+24*s,3*s,6*s,cc.man);
    // Bare feet
    R(mx-5*s,my+30*s,4*s,2*s,cc.man);R(mx+1*s,my+30*s,4*s,2*s,cc.man);
    // Shirtless torso (skin color)
    R(mx-6*s,my,12*s,16*s,cc.man);
    // Couple 2 (Big Dude) is drawn wider
    if(ci===2){
      R(mx-8*s,my,16*s,18*s,cc.man);
      R(mx-10*s,my+2*s,6*s,14*s,cc.man);
      R(mx+4*s,my+2*s,6*s,14*s,cc.man);
    }
    // Waistband
    R(mx-6*s,my+14*s,12*s,2*s,cc.shorts);
    if(ci===2)R(mx-8*s,my+16*s,16*s,2*s,cc.shorts);
    // Pec/abs hint
    cx.globalAlpha=0.1;R(mx-1*s,my+2*s,2*s,8*s,'#000');cx.globalAlpha=1;
    // hair (behind head — just top cap)
    cx.beginPath();cx.arc(mx,my-8*s,6*s,Math.PI,0);cx.closePath();
    cx.fillStyle=cc.hair;cx.fill();
    // head (on top of hair)
    C(mx,my-6*s,6*s,cc.man);
    // eyes
    C(mx-2*s,my-7*s,1*s,'#111');C(mx+2*s,my-7*s,1*s,'#111');
  }
  // Woman — bikini top with beach shorts
  var wx=cx2+12*s,wy=cy2;
  // Beach shorts (short, colorful)
  R(wx-4*s,wy+12*s,3*s,8*s,cc.wshorts);R(wx+1*s,wy+12*s,3*s,8*s,cc.wshorts);
  // Bare legs
  R(wx-3*s,wy+20*s,2*s,6*s,cc.w);R(wx+2*s,wy+20*s,2*s,6*s,cc.w);
  // Sandals
  R(wx-4*s,wy+26*s,3*s,2*s,cc.wsandal);R(wx+1*s,wy+26*s,3*s,2*s,cc.wsandal);
  // Torso (skin midriff)
  R(wx-5*s,wy+4*s,10*s,10*s,cc.w);
  // Bikini top
  R(wx-5*s,wy,10*s,6*s,cc.wshirt);
  // hair behind head
  cx.beginPath();cx.arc(wx,wy-7*s,5*s,Math.PI,0);cx.closePath();
  cx.fillStyle=cc.whair;cx.fill();
  R(wx-5*s,wy-6*s,2*s,10*s,cc.whair);R(wx+3*s,wy-6*s,2*s,10*s,cc.whair);
  if(ci===0)R(wx+4*s,wy-8*s,2*s,10*s,cc.whair);
  // head on top
  C(wx,wy-5*s,5*s,cc.w);
  // Eyes (prettier — white + iris)
  C(wx-2*s,wy-6*s,1.2*s,'#fff');C(wx+2*s,wy-6*s,1.2*s,'#fff');
  C(wx-2*s,wy-6*s,0.6*s,'#336');C(wx+2*s,wy-6*s,0.6*s,'#336');
  // Tiny lips
  cx.fillStyle='#cc6666';cx.beginPath();cx.arc(wx,wy-3*s,1.5*s,0,Math.PI);cx.fill();
  // Heart if lady won
  if(couple.lady){
    cx.fillStyle='#ff3366';cx.font=(8*s)+'px Courier New';cx.textAlign='center';
    cx.fillText('\u2665',wx,wy-14*s);
  }
}

function drawBeachCouples(){
  var positions=[
    {x:150,y:300,s:0.95},  // couple 0: left
    {x:480,y:280,s:0.85},  // couple 1: center-right
    {x:720,y:260,s:0.7}    // couple 2: far right
  ];
  for(var i=0;i<3;i++){
    var p=positions[i];
    var couple=S.beach.couples[i];
    if(couple.gone&&!couple.lady)continue;
    drawBeachCoupleSmall(i,p.x,p.y,p.s);
    // Hover highlight
    if(hover==='couple'+i&&!S.busy&&!S.beach.subMenu&&!S.beach.gymComp.active&&!couple.gone&&!couple.cowered){
      var hw=60*p.s,hh=40*p.s;
      cx.strokeStyle='#ff6b35';cx.lineWidth=2;
      cx.strokeRect(p.x-hw/2,p.y-10*p.s,hw,hh);
    }
  }
}

function drawTarkWithBeers(x,y){
  // Draw Tark idle, then overlay beer pack in his left hand
  var p=S.pose;
  if(p==='smoke')drawTarkSmoking(x,y,S.poseT);
  else if(p==='walking')drawTarkWalking(x,y);
  else if(p==='drinking')drawTarkDrinking(x,y,S.poseT);
  else if(p==='slapping')drawTarkSlapping(x,y,S.poseT);
  else if(p==='pull')drawTarkSnatchPull(x,y);
  else if(p==='overhead')drawTarkSnatchOverhead(x,y);
  else if(p==='overhead_squat'){drawTarkOverheadSquat(x,y);drawBarbell(x,y-40);}
  else if(p==='front_squat'){drawTarkFrontSquat(x,y);drawBarbell(x,y+2);}
  else if(p==='failed'){drawTarkIdle(x,y,false);T('X',x,y-40,20,'#ff4444');}
  else drawTarkIdle(x,y,false);
  // Beer pack dangling from left hand
  if(S.beach.beersLeft>0&&p!=='drinking'&&p!=='slapping'&&p!=='pull'&&p!=='overhead'){
    drawBeerPack(x-38,y+10,S.beach.beersLeft);
  }
}

function drawTarkDrinking(x,y,t){
  // Base body
  var _sc=getTarkShirtColor(),_hc=getTarkHeadbandColor();
  R(x-12,y+30,10,38,'#2a2a2a');R(x+2,y+30,10,38,'#2a2a2a');
  R(x-14,y+66,14,6,'#cc3333');R(x,y+66,14,6,'#cc3333');
  R(x-16,y-10,32,42,_sc);drawTarkAbs(x,y-10,42);
  // Left arm down
  R(x-24,y-6,10,30,'#d4a574');C(x-20,y+24,5,'#d4a574');
  // Right arm raising beer
  var tilt=Math.min(1,t*0.8);
  var armUp=Math.round(tilt*25);
  if(!S._hideRightArm){R(x+14,y-6-armUp/2,10,24-armUp/3,'#d4a574');
  C(x+18,y+14-armUp,5,'#d4a574');
  // Beer can (aluminium with label)
  R(x+13,y-2-armUp,8,16,'#ccc');         // aluminium body
  R(x+14,y+1-armUp,6,10,'#cc8800');      // gold label stripe
  R(x+14,y-3-armUp,6,2,'#bbb');          // rim top
  C(x+17,y-4-armUp,1.5,'#999');          // pull tab
  // Foam when tilted
  if(tilt>0.6){cx.globalAlpha=0.5;C(x+17,y-5-armUp,3,'#fff');cx.globalAlpha=1;}
  }
  // Head
  C(x,y-22,16,'#d4a574');
  // Eyes — happy squint
  R(x-6,y-23,5,2,'#111');R(x+2,y-23,5,2,'#111');
  // Mouth — drinking
  if(tilt>0.3)C(x+1,y-15,3,'#333');else R(x-3,y-16,6,2,'#111');
  // Headband
  if(_hc)R(x-16,y-30,32,4,_hc);
  // Hair
  cx.save();cx.beginPath();cx.arc(x,y-22,16,Math.PI,0);cx.clip();
  cx.globalAlpha=0.5;R(x-16,y-38,32,18,'#3a2a1a');cx.globalAlpha=1;cx.restore();
}

function drawTarkSlapping(x,y,t){
  var _sc=getTarkShirtColor(),_hc=getTarkHeadbandColor();
  var swipe=Math.sin(Math.min(t*10,Math.PI))*35;
  R(x-12,y+30,10,38,'#2a2a2a');R(x+2,y+30,10,38,'#2a2a2a');
  R(x-14,y+66,14,6,'#cc3333');R(x,y+66,14,6,'#cc3333');
  R(x-16,y-10,32,42,_sc);
  // Left arm back
  R(x-24,y-6,10,30,'#d4a574');
  // Right arm — slapping motion
  var armX=Math.round(swipe);
  if(!S._hideRightArm){R(x+14+armX,y-8,10,20,'#d4a574');C(x+22+armX,y+8,6,'#d4a574');}
  // Impact flash at peak
  if(t>0.15&&t<0.4){
    cx.globalAlpha=0.7;T('SLAP!',x+50,y-10,14,'#ff4444');cx.globalAlpha=1;
  }
  // Head
  C(x,y-22,16,'#d4a574');
  R(x-6,y-24,5,3,'#111');R(x+2,y-24,5,3,'#111');
  R(x-4,y-16,8,3,'#111'); // gritted teeth
  if(_hc)R(x-16,y-30,32,4,_hc);
  cx.save();cx.beginPath();cx.arc(x,y-22,16,Math.PI,0);cx.clip();
  cx.globalAlpha=0.5;R(x-16,y-38,32,18,'#3a2a1a');cx.globalAlpha=1;cx.restore();
}

function drawBeachHUD(){
  // Beer count top-right
  T('BEERS: '+S.beach.beersLeft,840,30,9,'#4a3e2a');
  drawBeerPack(825,35,S.beach.beersLeft);
  // Hover tooltips
  if(hover&&!S.busy&&!S.beach.subMenu&&!S.beach.gymComp.active){
    var tips={couple0:'APPROACH',couple1:'APPROACH',couple2:'APPROACH',beachExit:'Head to Gym',boardwalkZone:'TRASH TOSS',beachBathroom:'RESTROOMS'};
    if(tips[hover]){
      var ci=hover.match(/couple(\d)/);
      var label=ci?'APPROACH '+BEACH_COUPLE_NAMES[+ci[1]]:tips[hover];
      T(label,450,FY+25,10,'#f0e6d3');
    }
  }
}

// --- COUPLE CLOSE-UP SUB-MENU ---

function drawCloseupMan(mx,my,cc,ci,intimLvl){
  // Draw a large man character for closeup with intimidation-based posture
  var s=ci===2?1.15:1.0;
  var il=intimLvl||0;
  var slouch=il>40?Math.min((il-40)*0.08,3):0;
  var tremble=il>65?Math.sin(Date.now()/80)*1.5:0;
  cx.save();cx.translate(mx,my);cx.scale(s,s);
  // Legs
  R(-8+tremble,20,11,30,'#3a3a5a');R(3+tremble,20,11,30,'#3a3a5a');
  R(-9+tremble,50,13,5,'#222');R(2+tremble,50,13,5,'#222');
  // Body — slouch when scared
  R(-14+tremble,-2+slouch,28,26,cc.shirt);
  // Arms — posture based on intimidation
  if(il>55){
    // Arms up defensively
    R(-20+tremble,-8+slouch,8,22,cc.man);R(12+tremble,-8+slouch,8,22,cc.man);
  }else if(il<-10){
    // Fists clenched at sides (angry)
    R(-20,-1,8,28,cc.man);R(12,-1,8,28,cc.man);
    R(-21,26,10,7,'#b89060');R(11,26,10,7,'#b89060');
  }else{
    R(-20+tremble,-1+slouch,8,28,cc.man);R(12+tremble,-1+slouch,8,28,cc.man);
    R(-20+tremble,26,8,6,cc.man);R(12+tremble,26,8,6,cc.man);
  }
  // Hair (drawn BEHIND head — just the top cap)
  cx.beginPath();cx.arc(0+tremble,-18+slouch,13,Math.PI,0);cx.closePath();
  cx.fillStyle=cc.hair;cx.fill();
  // Head (drawn ON TOP so face is visible)
  C(0+tremble,-14+slouch,13,cc.man);
  // Ears
  C(-13+tremble,-14+slouch,3,cc.man);C(13+tremble,-14+slouch,3,cc.man);
  // Eyes
  var ey=-16+slouch;
  C(-5+tremble,ey,2.5,'#fff');C(5+tremble,ey,2.5,'#fff');
  if(il>55){
    // Wide scared eyes
    C(-5+tremble,ey,1.8,'#111');C(5+tremble,ey,1.8,'#111');
  }else if(il<-10){
    // Angry narrow eyes
    R(-7,ey-0.5,4,2,'#111');R(3,ey-0.5,4,2,'#111');
  }else{
    C(-5+tremble,ey,1.2,'#111');C(5+tremble,ey,1.2,'#111');
  }
  // Eyebrows
  if(il<-10){
    // Angry V brows
    cx.strokeStyle='#444';cx.lineWidth=2;
    cx.beginPath();cx.moveTo(-8+tremble,ey-5);cx.lineTo(-3+tremble,ey-3);cx.stroke();
    cx.beginPath();cx.moveTo(8+tremble,ey-5);cx.lineTo(3+tremble,ey-3);cx.stroke();
  }else if(il>40){
    // Worried raised brows
    cx.strokeStyle='#444';cx.lineWidth=1.5;
    cx.beginPath();cx.moveTo(-8+tremble,ey-5+slouch);cx.lineTo(-3+tremble,ey-6+slouch);cx.stroke();
    cx.beginPath();cx.moveTo(8+tremble,ey-5+slouch);cx.lineTo(3+tremble,ey-6+slouch);cx.stroke();
  }
  // Mouth / expression
  if(il>65){
    // Scared open mouth
    cx.fillStyle='#111';cx.beginPath();cx.arc(0+tremble,-7+slouch,4,0,Math.PI*2);cx.fill();
    cx.fillStyle='#cc4444';cx.beginPath();cx.arc(0+tremble,-7+slouch,2.5,0,Math.PI*2);cx.fill();
  }else if(il>35){
    // Worried grimace
    cx.strokeStyle='#111';cx.lineWidth=1.5;
    cx.beginPath();cx.arc(0+tremble,-7+slouch,3.5,0.3,Math.PI-0.3);cx.stroke();
  }else if(il<-10){
    // Angry gritted teeth
    R(-4+tremble,-9,8,4,'#fff');
    R(-3+tremble,-7,6,1,'#111');
  }else{
    // Neutral
    R(-4+tremble,-8+slouch,8,2,'#111');
  }
  // Sweat drops when intimidated
  if(il>30){
    var swA=Math.min((il-30)/50,0.8);
    cx.globalAlpha=swA;
    cx.fillStyle='#88ccff';
    C(-12+tremble,-10+slouch,1.8,'#88ccff');
    if(il>50)C(13+tremble,-6+slouch,1.5,'#88ccff');
    if(il>70)C(-8+tremble,0+slouch,1.5,'#88ccff');
    cx.globalAlpha=1;
  }
  cx.restore();
}
function drawCloseupWoman(wx,wy,cc){
  cx.save();cx.translate(wx,wy);
  // Beach shorts (short, colorful)
  R(-6,18,9,12,cc.wshorts||cc.wshirt);R(3,18,9,12,cc.wshorts||cc.wshirt);
  // Bare legs below shorts
  R(-5,30,7,16,cc.w);R(4,30,7,16,cc.w);
  // Sandals (strappy)
  R(-6,46,9,4,cc.wsandal||'#c89060');R(3,46,9,4,cc.wsandal||'#c89060');
  cx.strokeStyle=cc.wsandal||'#c89060';cx.lineWidth=1;
  cx.beginPath();cx.moveTo(-3,46);cx.lineTo(-1,42);cx.stroke();
  cx.beginPath();cx.moveTo(6,46);cx.lineTo(8,42);cx.stroke();
  // Midriff (skin showing between bikini and shorts)
  R(-11,8,22,12,cc.w);
  // Bikini top
  R(-12,-2,24,12,cc.wshirt);
  // Bikini shape — two triangle cups + string
  cx.fillStyle=cc.wshirt;
  cx.beginPath();cx.moveTo(-10,0);cx.lineTo(-2,8);cx.lineTo(-10,8);cx.closePath();cx.fill();
  cx.beginPath();cx.moveTo(10,0);cx.lineTo(2,8);cx.lineTo(10,8);cx.closePath();cx.fill();
  // String across top
  cx.strokeStyle=cc.wshirt;cx.lineWidth=1.5;
  cx.beginPath();cx.moveTo(-12,0);cx.lineTo(12,0);cx.stroke();
  // Arms
  R(-17,0,7,24,cc.w);R(9,0,7,24,cc.w);
  // Hair BEHIND head — top cap + side strands that fall behind
  cx.beginPath();cx.arc(0,-18,11,Math.PI,0);cx.closePath();
  cx.fillStyle=cc.whair;cx.fill();
  // Side hair — behind the face, starts at ear level and goes down
  R(-12,-16,5,24,cc.whair);R(7,-16,5,24,cc.whair);
  // Head ON TOP — face is visible
  C(0,-14,11,cc.w);
  // Ears
  C(-11,-14,2.5,cc.w);C(11,-14,2.5,cc.w);
  // Eyes (bigger, prettier — white + colored iris + pupil + shine)
  C(-4,-15,2.8,'#fff');C(4,-15,2.8,'#fff');
  C(-4,-15,1.3,'#4488aa');C(4,-15,1.3,'#4488aa');
  C(-4,-15,0.6,'#111');C(4,-15,0.6,'#111');
  // Eye shine
  cx.globalAlpha=0.5;C(-3.2,-15.8,0.5,'#fff');C(4.8,-15.8,0.5,'#fff');cx.globalAlpha=1;
  // Eyelashes (thicker, more feminine)
  cx.strokeStyle='#222';cx.lineWidth=1.2;
  cx.beginPath();cx.moveTo(-6.5,-17);cx.lineTo(-7,-19.5);cx.stroke();
  cx.beginPath();cx.moveTo(-5,-17.5);cx.lineTo(-5.5,-19.5);cx.stroke();
  cx.beginPath();cx.moveTo(6.5,-17);cx.lineTo(7,-19.5);cx.stroke();
  cx.beginPath();cx.moveTo(5,-17.5);cx.lineTo(5.5,-19.5);cx.stroke();
  // Eyebrows (thin, arched)
  cx.strokeStyle='#664433';cx.lineWidth=0.8;
  cx.beginPath();cx.moveTo(-7,-18);cx.quadraticCurveTo(-4,-20,-1,-18.5);cx.stroke();
  cx.beginPath();cx.moveTo(7,-18);cx.quadraticCurveTo(4,-20,1,-18.5);cx.stroke();
  // Nose hint (small, cute)
  cx.globalAlpha=0.15;C(0,-11,1.8,cc.w);cx.globalAlpha=1;
  cx.fillStyle='#000';cx.globalAlpha=0.08;R(-1,-10,2,1,'#000');cx.globalAlpha=1;
  // Lips (fuller, colored)
  cx.fillStyle='#dd5566';cx.beginPath();cx.arc(0,-7.5,3.5,0,Math.PI);cx.fill();
  cx.fillStyle='#ee7788';cx.beginPath();cx.arc(0,-8,2.8,Math.PI,0);cx.fill();
  // Lip shine
  cx.globalAlpha=0.3;C(-1,-8.5,1,'#fff');cx.globalAlpha=1;
  // Light blush
  cx.globalAlpha=0.12;C(-7,-12,3,'#ff6666');C(7,-12,3,'#ff6666');cx.globalAlpha=1;
  cx.restore();
}
function drawBathroomScene(anim,t,ci,cc){
  var CS=1.3,GY=468;
  var tarkOY=GY-Math.round(72*CS);
  var manOY=GY-Math.round(55*CS);
  var womanOY=GY-Math.round(52*CS);
  var BF_X=120,DOOR_X=442,TARK_EXIT=W+60,GIRL_DEST=180;
  var now=Date.now();
  // === HARD CUT — brief black flash ===
  if(anim==='bathroomCut'&&t<0.08){R(0,0,W,H,'#000');return;}
  // === SKY (flat, overcast — different mood) ===
  var skyG=cx.createLinearGradient(0,0,0,120);
  skyG.addColorStop(0,'#6a8899');skyG.addColorStop(1,'#8899aa');
  cx.fillStyle=skyG;cx.fillRect(0,0,W,120);
  // Faded sun
  cx.globalAlpha=0.25;C(750,40,18,'#ddcc88');cx.globalAlpha=1;
  // Wispy clouds
  cx.globalAlpha=0.2;C(200,35,12,'#bbc');C(220,30,16,'#bbc');C(245,36,10,'#bbc');cx.globalAlpha=1;
  // === SAND GROUND ===
  var sandG=cx.createLinearGradient(0,395,0,H);
  sandG.addColorStop(0,'#d4b896');sandG.addColorStop(1,'#c8a880');
  cx.fillStyle=sandG;cx.fillRect(0,395,W,H-395);
  // Sand texture
  cx.globalAlpha=0.04;for(var sg=0;sg<20;sg++){R(sg*48+10,400+sg%3*4,30,2,'#000');}cx.globalAlpha=1;
  // === CONCRETE BUILDING ===
  // Main wall — sits on sand, roof near top of screen
  var bldgY=100,bldgH=300;
  R(120,bldgY,700,bldgH,'#8a8a80');
  // Subtle wall gradient (darker at bottom)
  cx.globalAlpha=0.08;
  var wallG=cx.createLinearGradient(0,bldgY,0,bldgY+bldgH);
  wallG.addColorStop(0,'#fff');wallG.addColorStop(1,'#000');
  cx.fillStyle=wallG;cx.fillRect(120,bldgY,700,bldgH);
  cx.globalAlpha=1;
  // Roof overhang — flat concrete slab
  R(110,bldgY-16,720,20,'#666660');
  R(110,bldgY-18,720,4,'#555550');
  // Drip edge shadow under roof
  cx.globalAlpha=0.12;R(120,bldgY,700,6,'#000');cx.globalAlpha=1;
  // Grunge / cracks / water stains
  cx.globalAlpha=0.1;
  R(220,bldgY+40,50,1,'#555');R(480,bldgY+80,35,1,'#555');R(600,bldgY+60,40,1,'#555');
  // Water stain streaks (vertical)
  R(300,bldgY+20,3,60,'#666');R(550,bldgY+10,2,50,'#666');R(680,bldgY+30,3,40,'#666');
  // Mold patches
  R(250,bldgY+30,30,20,'#333');R(620,bldgY+50,25,18,'#333');
  cx.globalAlpha=1;
  // Sign — weathered
  R(310,bldgY+2,280,26,'#606058');
  cx.strokeStyle='#505048';cx.lineWidth=1;cx.strokeRect(310,bldgY+2,280,26);
  T('BEACH FACILITIES',450,bldgY+19,9,'#aaa8a0');
  // === 4 STALL DOORS — bottoms at ground level ===
  var doorW=84,doorH=210;
  var doorY=bldgY+bldgH-doorH;
  var doorXs=[200,340,480,620];
  var actionDoor=1; // used for cinematic anim compatibility
  var doorOpen=(anim==='tarkExit'||anim==='girlExit'||(anim==='bathroomEnter'&&t<0.6));
  var fb_d=S.beach||{};
  for(var di=0;di<4;di++){
    var dx=doorXs[di];
    var isAct=(di===actionDoor);
    R(dx-5,doorY-5,doorW+10,doorH+5,'#555550');
    // Door 0 — left stall: always locked/occupied
    if(di===0){
      R(dx,doorY,doorW,doorH,'#8a7a60');
      cx.globalAlpha=0.1;R(dx+8,doorY+12,doorW-16,doorH/2-20,'#000');R(dx+8,doorY+doorH/2+4,doorW-16,doorH/2-20,'#000');cx.globalAlpha=1;
      R(dx+6,doorY+doorH/2-4,doorW-12,6,'#786a50');
      C(dx+doorW-14,doorY+doorH/2+10,4,'#aaa890');
      cx.globalAlpha=0.3;C(dx+doorW-14,doorY+doorH/2+10,2,'#ddd');cx.globalAlpha=1;
      R(dx,doorY+doorH-8,doorW,8,'#555550');
      // Feet under door
      R(dx+20,doorY+doorH-12,14,6,'#443322');R(dx+42,doorY+doorH-12,14,6,'#443322');
      // "OCCUPIED" scratch
      cx.globalAlpha=0.3;cx.font='bold 5px monospace';cx.textAlign='center';cx.fillStyle='#444';
      cx.fillText('OCCUPIED',dx+doorW/2,doorY+40);cx.textAlign='center';cx.globalAlpha=1;
    }
    // Door 1 — middle stall: open from start, flooded after
    else if(di===1){
      if(isAct&&doorOpen){
        // Cinematic open
        R(dx,doorY,8,doorH,'#7a6a50');R(dx+8,doorY,doorW-8,doorH,'#1a1a1a');R(dx+8,doorY+doorH-20,doorW-8,20,'#3a3a3a');
      }else{
        // Ajar — dark interior visible
        R(dx,doorY,20,doorH,'#1a1a1a');R(dx,doorY+doorH-12,20,12,'#3a3a3a');
        R(dx+18,doorY,doorW-18,doorH,'#8a7a60');
        cx.globalAlpha=0.1;R(dx+24,doorY+12,doorW-32,doorH/2-20,'#000');R(dx+24,doorY+doorH/2+4,doorW-32,doorH/2-20,'#000');cx.globalAlpha=1;
        R(dx+22,doorY+doorH/2-4,doorW-28,6,'#786a50');
        C(dx+doorW-8,doorY+doorH/2+10,4,'#aaa890');
        R(dx+18,doorY+doorH-8,doorW-18,8,'#555550');
      }
      // Water seeping under after flooded
      if(fb_d.middleFlooded){
        cx.globalAlpha=0.3;
        cx.beginPath();cx.ellipse(dx+doorW/2,doorY+doorH+4,40,6,0,0,Math.PI*2);cx.fillStyle='#4488bb';cx.fill();
        cx.globalAlpha=1;
      }
      // Graffiti on middle door during cinematic
      if(isAct&&(anim==='bathroomCut'||anim==='bathroomBubble')){
        cx.globalAlpha=0.3;cx.font='bold 8px monospace';cx.textAlign='center';cx.fillStyle='#444';
        cx.fillText('TARK WAS',dx+doorW/2,doorY+40);cx.fillText('HERE',dx+doorW/2,doorY+52);cx.textAlign='center';cx.globalAlpha=1;
      }
    }
    // Door 2 — right stall: occupied until flooding
    else if(di===2){
      if(!fb_d.rightStallOccupied){
        // Man left — door ajar
        R(dx,doorY,20,doorH,'#1a1a1a');R(dx,doorY+doorH-12,20,12,'#3a3a3a');
        R(dx+18,doorY,doorW-18,doorH,'#6a7a60');
        cx.globalAlpha=0.1;R(dx+24,doorY+12,doorW-32,doorH/2-20,'#000');R(dx+24,doorY+doorH/2+4,doorW-32,doorH/2-20,'#000');cx.globalAlpha=1;
        R(dx+22,doorY+doorH/2-4,doorW-28,6,'#5a6a50');
        C(dx+doorW-8,doorY+doorH/2+10,4,'#aaa890');
        R(dx+18,doorY+doorH-8,doorW-18,8,'#555550');
      }else{
        // Closed, occupied
        R(dx,doorY,doorW,doorH,'#6a7a60');
        cx.globalAlpha=0.1;R(dx+8,doorY+12,doorW-16,doorH/2-20,'#000');R(dx+8,doorY+doorH/2+4,doorW-16,doorH/2-20,'#000');cx.globalAlpha=1;
        R(dx+6,doorY+doorH/2-4,doorW-12,6,'#5a6a50');
        C(dx+doorW-14,doorY+doorH/2+10,4,'#aaa890');
        cx.globalAlpha=0.3;C(dx+doorW-14,doorY+doorH/2+10,2,'#ddd');cx.globalAlpha=1;
        R(dx,doorY+doorH-8,doorW,8,'#555550');
        // Feet under door
        R(dx+18,doorY+doorH-12,16,6,'#2a2a2a');R(dx+44,doorY+doorH-12,16,6,'#2a2a2a');
      }
    }
    // Door 3 — out-of-order: locked until smashed
    else if(di===3){
      var door3Cracked=fb_d.doorCracked;
      if(door3Cracked){
        R(dx,doorY,20,doorH,'#1a1a1a');R(dx,doorY+doorH-12,20,12,'#3a3a3a');
        R(dx+18,doorY,doorW-18,doorH,'#8a7a60');
        cx.globalAlpha=0.1;R(dx+24,doorY+12,doorW-32,doorH/2-20,'#000');R(dx+24,doorY+doorH/2+4,doorW-32,doorH/2-20,'#000');cx.globalAlpha=1;
        R(dx+22,doorY+doorH/2-4,doorW-28,6,'#786a50');
        C(dx+doorW-8,doorY+doorH/2+10,4,'#aaa890');
        R(dx+18,doorY+doorH-8,doorW-18,8,'#555550');
        // Sign fallen on ground
        cx.save();cx.translate(dx+20,doorY+doorH+2);cx.rotate(0.3);
        R(0,0,doorW-24,22,'#fff');cx.globalAlpha=0.5;
        cx.font='bold 6px monospace';cx.textAlign='center';cx.fillStyle='#cc2222';
        cx.fillText('OUT OF ORDER',24,14);cx.textAlign='center';
        cx.globalAlpha=1;cx.restore();
      }else{
        R(dx,doorY,doorW,doorH,'#8a7a60');
        cx.globalAlpha=0.1;R(dx+8,doorY+12,doorW-16,doorH/2-20,'#000');R(dx+8,doorY+doorH/2+4,doorW-16,doorH/2-20,'#000');cx.globalAlpha=1;
        R(dx+6,doorY+doorH/2-4,doorW-12,6,'#786a50');
        C(dx+doorW-14,doorY+doorH/2+10,4,'#aaa890');
        cx.globalAlpha=0.3;C(dx+doorW-14,doorY+doorH/2+10,2,'#ddd');cx.globalAlpha=1;
        R(dx,doorY+doorH-8,doorW,8,'#555550');
        // "OUT OF ORDER" taped sign
        R(dx+12,doorY+30,doorW-24,22,'#fff');
        cx.globalAlpha=0.7;
        cx.save();cx.translate(dx+doorW/2,doorY+44);cx.rotate(-0.08);
        cx.font='bold 6px monospace';cx.textAlign='center';cx.fillStyle='#cc2222';
        cx.fillText('OUT OF ORDER',0,0);
        cx.textAlign='center';cx.restore();cx.globalAlpha=1;
        cx.globalAlpha=0.3;R(dx+14,doorY+28,20,3,'#cccc88');R(dx+doorW-34,doorY+50,20,3,'#cccc88');cx.globalAlpha=1;
      }
    }
  }
  // === CONCRETE WALKWAY in front of building ===
  R(110,bldgY+bldgH-4,720,12,'#777770');
  // === OUTDOOR DRINKING FOUNTAIN / WASHING STATION ===
  var fkx=730,fky=bldgY+bldgH; // base position
  var fk=S.beach?S.beach.fountainKicks:0;
  var fkAnim=(S.beach&&S.beach.fountainKicking)?S.beach.fountainKickT:0;
  if(fk>=7){
    // Broken off — just pipe stub and water geyser
    R(fkx+2,fky-18,12,18,'#777'); // pipe stub
    R(fkx+4,fky-20,8,4,'#888'); // pipe flange
    // Water geyser from broken pipe
    var gt=Date.now()*0.003;
    for(var gi=0;gi<8;gi++){
      var gx=fkx+8+Math.sin(gt+gi*0.8)*6;
      var gy=fky-20-gi*18-Math.random()*8;
      var gr=4-gi*0.3;
      cx.globalAlpha=0.6-gi*0.06;
      C(gx,gy,Math.max(1,gr),'#66aadd');
    }
    cx.globalAlpha=1;
    // Pooling water on ground
    cx.globalAlpha=0.35;
    cx.beginPath();cx.ellipse(fkx+8,fky+4,25+Math.sin(gt)*3,6,0,0,Math.PI*2);cx.fillStyle='#4488bb';cx.fill();
    cx.globalAlpha=0.2;
    cx.beginPath();cx.ellipse(fkx+8,fky+6,35+Math.sin(gt+1)*4,8,0,0,Math.PI*2);cx.fillStyle='#4488bb';cx.fill();
    cx.globalAlpha=1;
    // Broken fountain basin on ground — clickable piece (before picked up)
    if(!S.beach.holdingPiece&&!S.beach.doorCracked){
      R(fkx-18,fky-6,30,10,'#b0b0a8'); // basin chunk on ground
      R(fkx-14,fky-4,22,6,'#ccccc0'); // inner surface
      R(fkx+14,fky-3,8,5,'#999'); // small pipe fragment
      C(fkx-22,fky-1,3,'#888'); // small debris
    }
    // Small debris always stays
    R(fkx+22,fky-2,6,4,'#777');C(fkx-26,fky,2,'#888');
  }else{
    // Fountain intact (with damage)
    var tilt=fk*0.04; // progressively tilting
    var wobble=fkAnim>0?Math.sin(fkAnim*20)*3*(1-fkAnim):0;
    cx.save();cx.translate(fkx+8,fky);cx.rotate(tilt+wobble*0.02);
    // Pipe from ground
    R(-4,-50,8,50,'#777');R(-2,-52,4,4,'#888'); // pipe
    // Basin (tilts with damage)
    R(-14,-60,28,12,'#b0b0a8'); // basin
    R(-12,-58,24,8,'#ccccc0'); // inner
    // Faucet
    R(2,-70,4,12,'#999');R(-2,-72,12,4,'#aaa');
    C(8,-72,2,'#bbb');
    // Progressive damage cracks
    if(fk>=1){cx.strokeStyle='#555';cx.lineWidth=1;cx.beginPath();cx.moveTo(-8,-56);cx.lineTo(-4,-50);cx.stroke();}
    if(fk>=2){cx.beginPath();cx.moveTo(6,-58);cx.lineTo(10,-52);cx.stroke();R(-12,-59,3,3,'#888');}
    if(fk>=3){cx.lineWidth=1.5;cx.beginPath();cx.moveTo(-6,-55);cx.lineTo(2,-48);cx.lineTo(4,-42);cx.stroke();R(10,-57,4,3,'#777');}
    if(fk>=4){cx.beginPath();cx.moveTo(-10,-52);cx.lineTo(-14,-46);cx.stroke();R(-15,-56,4,4,'#999');cx.lineWidth=1;cx.beginPath();cx.moveTo(0,-58);cx.lineTo(-2,-62);cx.stroke();}
    if(fk>=5){
      // Basin cracked badly, piece hanging
      R(-16,-54,5,6,'#999');
      cx.lineWidth=2;cx.beginPath();cx.moveTo(-10,-58);cx.lineTo(8,-48);cx.stroke();
      // Water dripping from crack
      var drip=Date.now()*0.005;
      cx.globalAlpha=0.5;C(-6,-48+((drip%20)*1.5),2,'#66aadd');cx.globalAlpha=1;
    }
    if(fk>=6){
      // Almost off — big chunk missing, lots of dripping
      R(10,-54,6,6,'#aaa'); // loose chunk
      cx.lineWidth=2;cx.strokeStyle='#444';cx.beginPath();cx.moveTo(-12,-60);cx.lineTo(12,-48);cx.stroke();
      var drip2=Date.now()*0.004;
      cx.globalAlpha=0.5;
      C(-4,-46+((drip2%15)*2),2,'#66aadd');
      C(4,-44+((drip2*1.3%15)*2),2,'#66aadd');
      cx.globalAlpha=0.25;
      cx.beginPath();cx.ellipse(0,2,10,3,0,0,Math.PI*2);cx.fillStyle='#4488bb';cx.fill();
      cx.globalAlpha=1;
    }
    cx.restore();
  }
  // Scattered litter on ground
  cx.globalAlpha=0.3;R(160,405,8,3,'#ddd');R(650,410,6,3,'#ccc');R(450,408,5,2,'#bbb');cx.globalAlpha=1;
  // === CHARACTERS PER PHASE ===
  // Standalone mode — Tark standing outside, can kick fountain
  if(anim==='standalone'){
    var fb=S.beach;
    // Kick animation
    if(fb.fountainKicking){
      fb.fountainKickT+=0.008; // ~125 frames, ~2.1 seconds total
      // Phases: walk-to 0-40%, windup 40-50%, kick 50-65%, recover 65-75%, walk-back 75-100%
      var fkT=fb.fountainKickT;
      var fkDone=fkT>=1;
      if(fkDone){
        fb.fountainKicking=false;fb.fountainKickT=0;
        fb.fountainKicks++;
        if(fb.fountainKicks>=7){
          float('DESTROYED!',730,280,'#ff4444',16);
          log("The fountain snaps clean off. Water geysers everywhere.","good");
          S.swagger=clamp(S.swagger+10,0,100);
          float('+10 SWAGGER',450,320,'#ffcc00',12);
          try{SFX.metalClang();}catch(e){}
        }else{
          var dmgMsgs=['Tark gives it a boot.','Another solid kick.','The basin cracks a little more.','It\'s wobbling now.','Almost there...','One more should do it.'];
          float('KICK! ('+fb.fountainKicks+'/7)',730,300,'#ff6b35',11);
          log(dmgMsgs[Math.min(fb.fountainKicks-1,5)],"info");
          try{SFX.plateClack();}catch(e){}
        }
      }
      // Position: walk to fountain, stay for kick, walk back
      var tX2;
      if(fkT<0.40){
        // Walk to fountain
        var walkT=fkT/0.40;
        tX2=450+(680-450)*walkT;
      }else if(fkT<0.75){
        // At fountain (windup, kick, recover)
        tX2=680;
      }else{
        // Walk back to start
        var walkBackT=(fkT-0.75)/0.25;
        tX2=680-(680-450)*walkBackT;
      }
      // Walking bob during walk phases only
      var walkBob=(fkT<0.40||fkT>=0.75)?Math.sin(fkT*40)*2:0;
      cx.save();cx.translate(tX2,tarkOY+walkBob);cx.scale(CS,CS);
      if(fkT>=0.40&&fkT<0.75){
        // Windup + kick + recovery — hide right leg, draw it ourselves rotated
        var kickSwing=0;
        if(fkT<0.50){
          // Windup: leg pulls back slightly
          kickSwing=-0.3*((fkT-0.40)/0.10);
        }else if(fkT<0.65){
          // Kick: leg swings forward and UP
          var kp=(fkT-0.50)/0.15;
          kickSwing=-0.3+1.7*kp; // from -0.3 to 1.4 radians forward (higher kick)
        }else{
          // Recovery: leg comes back down
          var rp=(fkT-0.65)/0.10;
          kickSwing=1.4*(1-rp);
        }
        // Lean body back during the actual kick swing
        var leanBack=(fkT>=0.50&&fkT<0.65)?-0.08:0;
        S._hideRightLeg=true;
        cx.save();cx.rotate(leanBack);
        drawTarkIdle(0,0,false);
        cx.restore();
        S._hideRightLeg=false;
        // Draw the right leg rotated from hip pivot — higher pivot for higher kick
        cx.save();
        cx.translate(2,26); // hip pivot (slightly higher than normal y+30 for higher kick)
        cx.rotate(-kickSwing);
        R(0,0,10,38,'#2a2a2a'); // leg — same 10x38 as original
        R(-1,36,14,6,'#cc3333'); // shoe — same 14x6 as original
        cx.restore();
      }else{
        // Walking phases — just drawTarkIdle
        drawTarkIdle(0,0,false);
      }
      cx.restore();
    }else if(fb.holdingPiece){
      // Holding piece overhead — arms up, basin chunk on top
      cx.save();cx.translate(450,tarkOY);cx.scale(CS,CS);
      S._hideRightArm=true;S._hideLeftArm=true;
      drawTarkIdle(0,0,false);
      S._hideRightArm=false;S._hideLeftArm=false;
      // Both arms raised overhead
      cx.save();cx.translate(-14,-6);cx.rotate(-1.4);
      R(0,0,10,30,'#d4a574');C(5,30,5,'#d4a574');
      cx.restore();
      cx.save();cx.translate(14,-6);cx.rotate(1.4);
      R(-10,0,10,30,'#d4a574');C(-5,30,5,'#d4a574');
      cx.restore();
      // Basin chunk above head
      R(-15,-52,30,10,'#b0b0a8');R(-11,-50,22,6,'#ccccc0');
      cx.restore();
    }else{
      // Normal idle
      cx.save();cx.translate(450,tarkOY);cx.scale(CS,CS);
      drawTarkIdle(0,0,false);
      cx.restore();
    }
    // === HOVER HIGHLIGHTS (standalone mode) ===
    if(!fb.fountainKicking){
      // Fountain: drink (before drunk, before broken)
      if(!fb.fountainDrunk&&fb.fountainKicks<7&&mouseX>=710&&mouseX<=760&&mouseY>=280&&mouseY<=410){
        cx.strokeStyle='#66aadd';cx.lineWidth=2;cx.strokeRect(710,280,50,120);
        T('DRINK',735,420,9,'#66aadd');
      }
      // Fountain: kick (before broken, not holding piece)
      else if(fb.fountainKicks<7&&!fb.holdingPiece&&mouseX>=710&&mouseX<=760&&mouseY>=280&&mouseY<=410){
        cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(710,280,50,120);
        T('KICK',735,420,9,'#ff6b35');
      }
      // Broken fountain piece: pick up
      if(fb.fountainKicks>=7&&!fb.holdingPiece&&!fb.doorCracked&&mouseX>=700&&mouseX<=750&&mouseY>=388&&mouseY<=410){
        cx.strokeStyle='#ffcc00';cx.lineWidth=2;cx.strokeRect(700,388,50,22);
        T('PICK UP',725,418,8,'#ffcc00');
      }
      // Middle stall door hover (enter — before flooded)
      if(!fb.middleFlooded&&mouseX>=340&&mouseX<=424&&mouseY>=190&&mouseY<=400){
        cx.strokeStyle='#ffcc00';cx.lineWidth=2;cx.strokeRect(340,190,84,210);
        T('ENTER',382,410,9,'#ffcc00');
      }
      // Right stall door hover (enter — after man left)
      if(!fb.rightStallOccupied&&mouseX>=480&&mouseX<=564&&mouseY>=190&&mouseY<=400){
        cx.strokeStyle='#ffcc00';cx.lineWidth=2;cx.strokeRect(480,190,84,210);
        T('ENTER',522,410,9,'#ffcc00');
      }
      // Out-of-order door: smash (holding piece) or enter (cracked)
      if(fb.holdingPiece&&!fb.doorCracked&&mouseX>=620&&mouseX<=704&&mouseY>=190&&mouseY<=400){
        cx.strokeStyle='#ff4444';cx.lineWidth=2;cx.strokeRect(620,190,84,210);
        T('SMASH!',662,410,9,'#ff4444');
      }else if(fb.doorCracked&&mouseX>=620&&mouseX<=704&&mouseY>=190&&mouseY<=400){
        cx.strokeStyle='#ffcc00';cx.lineWidth=2;cx.strokeRect(620,190,84,210);
        T('ENTER',662,410,9,'#ffcc00');
      }
    }
    return;
  }
  // Boyfriend — always visible (until coupleReunite walkoff replaces him)
  var drawBF=true;
  if(anim==='coupleReunite'){drawBF=false;} // handled below
  if(drawBF){
    var bfA=(anim==='bathroomCut')?Math.min(1,t*3):1;
    cx.globalAlpha=bfA;
    cx.save();cx.translate(BF_X,manOY);cx.scale(CS,CS);
    drawCloseupMan(0,0,cc,ci,60);
    cx.restore();
    cx.globalAlpha=1;
    // Dejected posture cues
    if(anim==='bathroomBubble'){
      var bob=Math.sin(now/600)*1.5;
      cx.globalAlpha=0.5;T('...',BF_X,manOY-60+bob,14,'#777');cx.globalAlpha=1;
    }
    if(anim==='tarkExit'){
      cx.globalAlpha=0.5;T('...',BF_X,manOY-60,12,'#777');cx.globalAlpha=1;
    }
    if(anim==='girlExit'){
      cx.globalAlpha=0.5;
      var hopeBob=Math.sin(now/400)*1;
      T('?',BF_X,manOY-60+hopeBob,14,'#999');
      cx.globalAlpha=1;
    }
  }
  // Couple reunite — girl arrives, pause, then both walk off right
  if(anim==='coupleReunite'){
    var walkStart=0.3; // pause for 30% of phase, then walk
    var walkT2=(t>=walkStart)?Math.max(0,(t-walkStart)/(1-walkStart)):0;
    var bfRX=Math.round(BF_X+walkT2*(W+80-BF_X));
    var gRX=Math.round(GIRL_DEST+walkT2*(W+80-GIRL_DEST));
    // Boyfriend (less dejected now)
    cx.save();cx.translate(bfRX,manOY);cx.scale(CS,CS);
    drawCloseupMan(0,0,cc,ci,20);
    cx.restore();
    // Girl
    cx.save();cx.translate(gRX,womanOY);cx.scale(CS,CS);
    drawCloseupWoman(0,0,cc);
    cx.restore();
  }
  // Tark+girl approaching bathroom from right
  if(anim==='bathroomApproach'){
    var appStart=W+60; // start offscreen right
    var appEnd=DOOR_X+10; // stop just right of door
    var trkX=Math.round(appStart+t*(appEnd-appStart));
    var grlX=trkX+30; // girl slightly behind
    // Tark walking left toward stall
    cx.save();cx.translate(trkX,tarkOY);cx.scale(-CS,CS);
    drawTarkIdle(0,0,false);
    cx.restore();
    // Girl walking with him
    cx.save();cx.translate(grlX,womanOY);cx.scale(-CS,CS);
    drawCloseupWoman(0,0,cc);
    cx.restore();
  }
  // Tark+girl entering the stall
  if(anim==='bathroomEnter'){
    // First half: step into doorway. Second half: inside (disappear).
    if(t<0.5){
      var enterT=t/0.5; // 0→1 over first half
      var etX=Math.round(DOOR_X+10-enterT*30); // walk into door
      var eAlpha=1-enterT*0.6; // fade as they step in
      cx.globalAlpha=eAlpha;
      cx.save();cx.translate(etX,tarkOY);cx.scale(-CS,CS);
      drawTarkIdle(0,0,false);
      cx.restore();
      cx.save();cx.translate(etX+30,womanOY);cx.scale(-CS,CS);
      drawCloseupWoman(0,0,cc);
      cx.restore();
      cx.globalAlpha=1;
    }
    // door closes in second half (doorOpen flag handles the open state)
  }
  // Tark exiting stall — walks RIGHT slowly, smoking (away from boyfriend)
  if(anim==='tarkExit'){
    var tSlow=Math.min(1,t*0.65); // slower walk — doesn't rush
    var tX=Math.round(DOOR_X+tSlow*(TARK_EXIT-DOOR_X));
    cx.save();cx.translate(tX,tarkOY);cx.scale(CS,CS);
    drawTarkSmoking(0,0,Date.now()*0.001);
    cx.restore();
  }
  // Girl exiting stall — walks right toward boyfriend
  if(anim==='girlExit'){
    var gX2=Math.round(DOOR_X+t*(GIRL_DEST-DOOR_X));
    cx.save();cx.translate(gX2,womanOY);cx.scale(CS,CS);
    drawCloseupWoman(0,0,cc);
    cx.restore();
  }
  // Girl standing at boyfriend position during coupleReunite pause
  if(anim==='coupleReunite'&&t<0.3){
    cx.save();cx.translate(GIRL_DEST,womanOY);cx.scale(CS,CS);
    drawCloseupWoman(0,0,cc);
    cx.restore();
  }
  // === SPEECH BUBBLES FROM BEHIND THE DOOR ===
  if(anim==='bathroomBubble'){
    var adx=doorXs[actionDoor]+doorW/2;
    var ady=doorY-15;
    // Floating hearts
    var h1y=ady-Math.sin(now/500)*10;
    var h2y=ady-18-Math.sin(now/400+1.5)*8;
    var h3y=ady-8-Math.sin(now/600+3)*7;
    cx.fillStyle='#ff6688';cx.font='14px serif';cx.textAlign='center';
    cx.globalAlpha=0.5+Math.sin(now/300)*0.2;
    cx.fillText('\u2665',adx-18,h1y);
    cx.globalAlpha=0.4+Math.sin(now/350+1)*0.2;
    cx.fillText('\u2665',adx+20,h2y);
    cx.globalAlpha=0.3+Math.sin(now/450+2)*0.2;
    cx.fillText('\u2665',adx+5,h3y);
    cx.globalAlpha=1;
    // Sound waves (concentric arcs above door)
    cx.strokeStyle='#ff88aa';cx.lineWidth=1.5;
    for(var sw2=0;sw2<3;sw2++){
      var sr=10+sw2*10;
      var swAlpha=0.3-sw2*0.08+Math.sin(now/250+sw2)*0.1;
      cx.globalAlpha=Math.max(0,swAlpha);
      cx.beginPath();
      cx.arc(adx,ady+20,sr,-Math.PI*0.7,-Math.PI*0.3);
      cx.stroke();
    }
    cx.globalAlpha=1;
  }
}
function drawCoupleCloseup(){
  var ci=S.beach.activeCouple;
  if(ci===null)return;
  var couple=S.beach.couples[ci];
  var cc=BEACH_COUPLE_COLORS[ci];
  var anim=S.beach.closeupAnim;
  if(anim)S.beach.closeupAnimT=Math.min(1,S.beach.closeupAnimT+0.02);
  var t=S.beach.closeupAnimT;
  var il=couple.intimidation||0;
  // === BATHROOM SCENE GUARD ===
  var BATH_PHASES={bathroomCut:1,bathroomApproach:1,bathroomEnter:1,bathroomBubble:1,tarkExit:1,girlExit:1,coupleReunite:1};
  if(anim&&BATH_PHASES[anim]){drawBathroomScene(anim,t,ci,cc);return;}
  // === BEACH BACKGROUND ===
  var skyG=cx.createLinearGradient(0,0,0,180);
  skyG.addColorStop(0,'#4488cc');skyG.addColorStop(1,'#88bbdd');
  cx.fillStyle=skyG;cx.fillRect(0,0,W,180);
  C(760,55,28,'#ffdd44');cx.globalAlpha=0.2;C(760,55,42,'#ffee88');cx.globalAlpha=1;
  cx.globalAlpha=0.3;C(180,50,18,'#fff');C(200,44,22,'#fff');C(222,50,16,'#fff');
  C(480,65,14,'#fff');C(496,60,18,'#fff');cx.globalAlpha=1;
  var oG=cx.createLinearGradient(0,170,0,260);
  oG.addColorStop(0,'#2266aa');oG.addColorStop(1,'#3388bb');
  cx.fillStyle=oG;cx.fillRect(0,170,W,90);
  for(var wv=0;wv<12;wv++){cx.globalAlpha=0.12;R(wv*80-10,180+wv*7+Math.sin(Date.now()/900+wv)*2,65,2,'#88ccee');}
  cx.globalAlpha=1;
  cx.globalAlpha=0.4;R(0,256,W,4,'#ddeeff');cx.globalAlpha=1;
  var sandG=cx.createLinearGradient(0,258,0,H);
  sandG.addColorStop(0,'#d4b896');sandG.addColorStop(1,'#c8a880');
  cx.fillStyle=sandG;cx.fillRect(0,258,W,H-258);
  cx.globalAlpha=0.03;for(var sg=0;sg<25;sg++){R(Math.sin(sg*7)*400+450,265+sg*7,Math.cos(sg*3)*30+30,3,'#000');}cx.globalAlpha=1;
  // Beach details
  R(80,420,45,18,'#cc4444');R(80,420,22,18,'#dd5555'); // towel
  C(750,430,3,'#eee');C(400,440,2.5,'#ddd'); // shells
  // Title
  T(BEACH_COUPLE_NAMES[ci],450,18,12,'#fff');
  var diff=['EASY','MEDIUM','HARD'][ci];
  T(diff,450,32,8,['#7fdb6a','#ffcc00','#ff4444'][ci]);
  // === TENSION BAR ===
  if(!anim||anim==='manReact'){
    var barX=300,barY=46,barW=300,barH=8;
    R(barX,barY,barW,barH,'rgba(0,0,0,0.4)');
    cx.strokeStyle='rgba(255,255,255,0.3)';cx.lineWidth=1;cx.strokeRect(barX,barY,barW,barH);
    var pct=Math.max(0,Math.min(il/80,1));
    var fillW=pct*barW;
    if(fillW>0){
      var bc=il<25?'#55aa55':il<50?'#ccaa33':il<65?'#dd7733':'#dd3333';
      R(barX+1,barY+1,fillW-2,barH-2,bc);
    }
    // Negative (angry) — fill from right in dark red
    if(il<0){
      var negPct=Math.min(Math.abs(il)/30,1);
      var negW=negPct*barW;
      R(barX+barW-negW,barY+1,negW-1,barH-2,'#8833aa');
    }
    // Labels
    var stateLabel=il<10?'CALM':il<30?'UNEASY':il<50?'NERVOUS':il<65?'SWEATING':'BREAKING';
    if(il<-10)stateLabel='ANGRY';
    T(stateLabel,450,barY+barH+12,8,il<-10?'#cc66ff':il<30?'#aaa':il<50?'#ccaa33':'#dd3333');
    T('INTIMIDATION',450,barY-4,7,'rgba(255,255,255,0.5)');
  }
  // === ALL CHARACTERS ON SAME GROUND PLANE ===
  var CS=1.3; // common scale for all characters
  var GY=468; // ground line — all feet align here
  // Tark feet offset: ~72 below origin. Man: ~55. Woman: ~52.
  var tarkOY=GY-Math.round(72*CS); // ~374
  var manOY=GY-Math.round(55*CS);  // ~396
  var womanOY=GY-Math.round(52*CS);// ~400
  var tarkX=180,manX=620,womanX=730;
  var manA=1,showMan=!couple.cowered;
  if(anim==='tarkRunning'){tarkX=180+t*(manX-100-180);}
  else if(anim==='tarkSlap'){tarkX=manX-100;}
  else if(anim==='manCower'){showMan=true;manX=620+t*400;manA=Math.max(0,1-t*1.3);}
  else if(anim==='womanApproach'){showMan=false;womanX=730-t*495;} // ends at ~235, next to Tark
  else if(anim==='coupleWalkOff'){showMan=false;tarkX=180-t*380;womanX=235-t*380;}
  else if(anim==='manChallenge'){manX=620-t*60;}
  else if(anim==='manReact'){} // man stays in place
  // === DRAW MAN ===
  if(showMan&&manA>0.01){
    cx.globalAlpha=manA;
    cx.save();cx.translate(manX,manOY);cx.scale(CS,CS);
    drawCloseupMan(0,0,cc,ci,il);
    cx.restore();
    cx.globalAlpha=1;
    if(!anim&&!S.busy&&hover==='beachManZone'){
      cx.strokeStyle='#ff6b35';cx.lineWidth=2;
      cx.strokeRect(manX-30,manOY-45,60,GY-manOY+50);
      T('INSULT',manX,manOY-52,10,'#ff6b35');
    }
  }
  // === DRAW TARK + WOMAN (order depends on animation) ===
  var shirtBefore=S.outfit?S.outfit.shirtStyle:null;
  if(anim==='shirtoff')S.outfit.shirtStyle='none';
  var tarkOnTop=!(anim==='womanApproach'||anim==='coupleWalkOff');
  // Draw woman first if Tark should be on top (default), or Tark first if woman should be on top
  if(tarkOnTop){
    // Normal order: Woman behind, then Tark in front
    cx.save();cx.translate(womanX,womanOY);cx.scale(CS,CS);
    drawCloseupWoman(0,0,cc);
    cx.restore();
    if(!anim&&!S.busy&&hover==='beachWomanZone'&&showMan){
      cx.strokeStyle='#ff69b4';cx.lineWidth=2;
      cx.strokeRect(womanX-22,womanOY-40,44,GY-womanOY+44);
      T('FLIRT',womanX,womanOY-48,10,'#ff69b4');
    }
    cx.save();cx.translate(tarkX,tarkOY);cx.scale(CS,CS);
    drawTarkWithBeers(0,0);
    cx.restore();
  }else{
    // Woman approaching/walking off: Tark first, then arm behind woman, then woman, then hand on far shoulder
    var _armClose=Math.abs(womanX-tarkX)<80;
    if(_armClose)S._hideRightArm=true;
    cx.save();cx.translate(tarkX,tarkOY);cx.scale(CS,CS);
    drawTarkWithBeers(0,0);
    cx.restore();
    S._hideRightArm=false;
    // Arm behind woman (drawn before her so she covers it)
    if(_armClose){
      var shoulderX=tarkX+Math.round(14*CS);
      var shoulderY=tarkOY-Math.round(6*CS);
      var wShoulderX=womanX+Math.round(10*CS);
      var wShoulderY=womanOY-Math.round(6*CS);
      if(wShoulderX>shoulderX){
        cx.save();
        cx.strokeStyle='#d4a574';
        cx.lineWidth=Math.round(6*CS);
        cx.lineCap='round';
        cx.beginPath();
        cx.moveTo(shoulderX,shoulderY);
        var midX=(shoulderX+wShoulderX)*0.5;
        var midY=(shoulderY+wShoulderY)*0.5+Math.round(3*CS);
        cx.quadraticCurveTo(midX,midY,wShoulderX,wShoulderY);
        cx.stroke();
        cx.restore();
      }
    }
    // Woman drawn on top of arm
    cx.save();cx.translate(womanX,womanOY);cx.scale(CS,CS);
    drawCloseupWoman(0,0,cc);
    cx.restore();
    // Hand on far shoulder (drawn after woman, wraps around her)
    if(_armClose){
      var wShoulderX2=womanX+Math.round(10*CS);
      var wShoulderY2=womanOY-Math.round(6*CS);
      if(wShoulderX2>tarkX+Math.round(14*CS)){
        C(wShoulderX2,wShoulderY2,Math.round(4*CS),'#d4a574');
      }
    }
  }
  if(anim==='shirtoff'&&shirtBefore)S.outfit.shirtStyle=shirtBefore;
  // Beer zone hover
  if(!anim&&!S.busy&&S.beach.beersLeft>0&&hover==='beachBeerZone'){
    T('DRINK BEER ('+S.beach.beersLeft+')',tarkX-10,tarkOY-50,9,'#ff6b35');
    cx.strokeStyle='#ff6b35';cx.lineWidth=1;cx.strokeRect(tarkX-30,tarkOY+5,30,40);
  }
  // Shirt zone hover
  if(!anim&&!S.busy&&hover==='beachShirtZone'&&showMan){
    T('TAKE SHIRT OFF',tarkX+5,tarkOY-58,9,'#ff6b35');
    cx.strokeStyle='#ff6b35';cx.lineWidth=1;cx.strokeRect(tarkX-18,tarkOY-10,36,40);
  }
  // Cigarette flick animation
  if(anim==='cigFlick'){
    var fx=tarkX+t*(manX-tarkX);
    var fy=tarkOY+t*(GY-tarkOY)-Math.sin(t*Math.PI)*60;
    R(fx-3,fy-1,6,2,'#f5f0e0'); // cigarette butt
    C(fx+3,fy,2,'#ff6622');      // ember glow
    if(t>0.85){
      // Sparks on landing
      C(fx-2,fy+1,3,'#ff8844');C(fx+3,fy-2,2,'#ffaa44');C(fx-4,fy-3,1.5,'#ffcc66');
    }
  }
  // Beer can chuck animation
  if(anim==='beerChuck'){
    var bx=tarkX+t*(manX-60-tarkX);
    var by=tarkOY-20+t*(GY-tarkOY+20)-Math.sin(t*Math.PI)*80;
    // Spinning can
    cx.save();cx.translate(bx,by);cx.rotate(t*Math.PI*4);
    R(-4,-6,8,12,'#cc8800');R(-3,-8,6,3,'#aaa');
    cx.restore();
    if(t>0.8){
      // Beer splash on landing
      cx.globalAlpha=0.6;
      C(bx-4,GY-3,2,'#cc8800');C(bx+3,GY-5,2,'#cc8800');C(bx,GY-1,3,'#cc8800');
      cx.globalAlpha=1;
    }
  }
  // Man challenge puff-up
  if(anim==='manChallenge'){
    T('"THE RACK. NOW."',manX,manOY-60,14,'#fff');
  }
  // Persistent debris on the ground (cig butts, beer cans)
  if(S.beach.closeupDebris&&S.beach.closeupDebris.length>0){
    for(var di=0;di<S.beach.closeupDebris.length;di++){
      var db=S.beach.closeupDebris[di];
      if(db.type==='cig'){
        // Cigarette butt on sand
        R(db.x-3,db.y-2,6,2,'#e8e0c8');
        C(db.x+3,db.y-1,1.5,'#884422'); // burnt end
      }else if(db.type==='can'){
        // Crushed can on its side
        R(db.x-5,db.y-5,10,6,'#bbb');     // aluminium body (sideways)
        R(db.x-4,db.y-4,8,4,'#cc8800');   // label
        R(db.x-6,db.y-4,2,4,'#999');      // rim
      }
    }
  }
  // Back button
  if(!anim){
    R(840,12,48,26,'rgba(0,0,0,0.4)');T('BACK',864,30,9,'#e8e4d8');
    if(hover==='closeCouple'){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(838,10,52,30);}
  }
}

// --- BEACH GYM COMPETITION (CLEAN & JERK) ---

// Draw beach rival in C&J poses — shirtless, board shorts, flip flops
function drawBeachRivalCJ(x,y,phase,skinC,shirtC,hairC,shortsC){
  var sw=Math.sin(Date.now()/1200)*0.5;
  var sc=shortsC||'#cc8844';
  if(phase==='pull'){
    // Board shorts + bare calves
    R(x-12,y+20,10,18,sc);R(x+2,y+20,10,18,sc);
    R(x-10,y+36,8,14,skinC); R(x+4,y+36,8,14,skinC); // calves
    R(x-11,y+48,10,3,skinC); R(x+3,y+48,10,3,skinC); // bare feet
    // Shirtless torso
    R(x-15,y-2,30,34,skinC);
    // Pecs + abs hint
    cx.globalAlpha=0.15;R(x-12,y+2,11,8,'#000');R(x+1,y+2,11,8,'#000');
    R(x-8,y+14,6,4,'#000');R(x+2,y+14,6,4,'#000');R(x-8,y+20,6,4,'#000');R(x+2,y+20,6,4,'#000');cx.globalAlpha=1;
    // Arms
    R(x-23,y-2,8,20,skinC);R(x+15,y-2,8,20,skinC);
    C(x-19,y+10,5,skinC);C(x+19,y+10,5,skinC);
    cx.beginPath();cx.arc(x,y-18,9,Math.PI,0);cx.closePath();cx.fillStyle=hairC;cx.fill();
    C(x,y-14,10,skinC);
    cx.globalAlpha=0.25;C(x,y-14,9,'#ff4444');cx.globalAlpha=1;
    C(x-3,y-16,1.5,'#111');C(x+3,y-16,1.5,'#111');
    R(x-3,y-10,6,2,'#111');
    cx.globalAlpha=0.5;C(x+8,y-12,1.5,'#88ccff');C(x-7,y-8,1,'#88ccff');cx.globalAlpha=1;
  }else if(phase==='clean_hold'){
    R(x-10,y+28,9,20,sc);R(x+1,y+28,9,20,sc);
    R(x-8,y+46,7,18,skinC);R(x+3,y+46,7,18,skinC);
    R(x-10,y+62,10,3,skinC);R(x+2,y+62,10,3,skinC);
    R(x-14,y-10,28,36,skinC);
    cx.globalAlpha=0.15;R(x-11,y-4,10,8,'#000');R(x+1,y-4,10,8,'#000');cx.globalAlpha=1;
    R(x-22,y-10,9,13,skinC);R(x+13,y-10,9,13,skinC);
    C(x-18,y-2,5,skinC);C(x+18,y-2,5,skinC);
    cx.beginPath();cx.arc(x,y-22,9,Math.PI,0);cx.closePath();cx.fillStyle=hairC;cx.fill();
    C(x,y-18,10,skinC);
    cx.globalAlpha=0.2;C(x,y-18,9,'#ff4444');cx.globalAlpha=1;
    C(x-3,y-20,1.5,'#111');C(x+3,y-20,1.5,'#111');
    R(x-3,y-13,6,2,'#111');
    cx.globalAlpha=0.5;C(x+9,y-16,1.5,'#88ccff');cx.globalAlpha=1;
  }else if(phase==='jerk'){
    // Front leg — straight
    R(x-7,y+28,9,22,sc);
    R(x-5,y+48,7,18,skinC);
    R(x-7,y+64,9,3,skinC);
    // Back leg — rotated as one unit (shorts + calf + foot)
    cx.save();cx.translate(x+9,y+28);cx.rotate(0.3);
    R(-4,0,9,22,sc);      // shorts
    R(-3,20,7,18,skinC);   // calf
    R(-4,36,9,3,skinC);    // foot
    cx.restore();
    R(x-14,y-10,28,38,skinC);
    cx.globalAlpha=0.15;R(x-11,y-4,10,8,'#000');R(x+1,y-4,10,8,'#000');cx.globalAlpha=1;
    R(x-20,y-53,7,46,skinC);R(x+13,y-53,7,46,skinC);
    C(x-16,y-55,4,skinC);C(x+16,y-55,4,skinC);
    C(x-18,y-22,6,skinC);C(x+18,y-22,6,skinC);
    cx.beginPath();cx.arc(x,y-22,9,Math.PI,0);cx.closePath();cx.fillStyle=hairC;cx.fill();
    C(x,y-18,10,skinC);
    cx.globalAlpha=0.3;C(x,y-18,9,'#ff4444');cx.globalAlpha=1;
    C(x-3,y-20,1.5,'#111');C(x+3,y-20,1.5,'#111');
    R(x-3,y-12,6,2,'#111');
    var sd=Math.sin(Date.now()*0.005)*2;
    cx.globalAlpha=0.6;C(x+9,y-16+sd,1.5,'#88ccff');C(x-8,y-10+sd*0.7,1,'#88ccff');C(x+6,y-6+sd*1.2,1,'#88ccff');cx.globalAlpha=1;
  }else if(phase==='failed'){
    var by=y+14;
    R(x-12,by+8,10,16,sc);R(x+2,by+8,10,16,sc);
    R(x-10,by+22,8,12,skinC);R(x+4,by+22,8,12,skinC);
    R(x-11,by+32,10,3,skinC);R(x+3,by+32,10,3,skinC);
    R(x-14,by-10,28,22,skinC);
    R(x-20,by-2,7,16,skinC);R(x+13,by-2,7,16,skinC);
    cx.beginPath();cx.arc(x+sw,by-20,9,Math.PI,0);cx.closePath();cx.fillStyle=hairC;cx.fill();
    C(x+sw,by-16,10,skinC);C(x-3+sw,by-18,1.5,'#111');C(x+3+sw,by-18,1.5,'#111');
    cx.strokeStyle='#111';cx.lineWidth=1;cx.beginPath();cx.arc(x+sw,by-10,3,0,Math.PI*2);cx.stroke();
  }else if(phase==='walking'){
    var step=Math.sin(Date.now()*0.008)*0.6;
    var bob=Math.abs(step)*1.5;
    // Board shorts
    cx.save();cx.translate(x-4,y+28-bob);cx.rotate(step*0.3);R(-4,0,8,16,sc);R(-3,14,7,10,skinC);cx.restore();
    cx.save();cx.translate(x+4,y+28-bob);cx.rotate(-step*0.3);R(-4,0,8,16,sc);R(-3,14,7,10,skinC);cx.restore();
    R(x-10,y+46,10,3,skinC);R(x+0,y+46,10,3,skinC); // bare feet
    // Shirtless torso
    R(x-10,y-2-bob,20,30,skinC);
    cx.globalAlpha=0.12;R(x-8,y+2-bob,7,6,'#000');R(x+1,y+2-bob,7,6,'#000');cx.globalAlpha=1;
    R(x-16,y+0-bob,7,18,skinC);R(x+9,y+0-bob,7,18,skinC);
    cx.beginPath();cx.arc(x,y-14-bob,9,Math.PI,0);cx.closePath();cx.fillStyle=hairC;cx.fill();
    C(x,y-10-bob,10,skinC);C(x-3,y-11-bob,1.5,'#111');C(x+3,y-11-bob,1.5,'#111');
    R(x-4,y-6-bob,8,2,'#111');
  }else{
    // Idle — shirtless, board shorts, bare feet
    R(x-8,y+28,8,16,sc);R(x+1,y+28,8,16,sc); // board shorts (wider gap)
    R(x-7,y+42,7,12,skinC);R(x+2,y+42,7,12,skinC); // calves
    R(x-8,y+52,9,3,skinC);R(x+1,y+52,9,3,skinC); // bare feet
    R(x-11,y-4,22,34,skinC); // shirtless torso
    // Pec + abs hints
    cx.globalAlpha=0.12;R(x-8,y+2,7,6,'#000');R(x+2,y+2,7,6,'#000');
    R(x-5,y+12,4,3,'#000');R(x+2,y+12,4,3,'#000');R(x-5,y+17,4,3,'#000');R(x+2,y+17,4,3,'#000');cx.globalAlpha=1;
    // Waistband
    R(x-11,y+26,22,3,sc);
    // Arms (wider from body)
    R(x-18,y-2,8,22,skinC);R(x+10,y-2,8,22,skinC);
    C(x-14,y+20,4,skinC);C(x+14,y+20,4,skinC); // hands
    // Head
    cx.beginPath();cx.arc(x,y-16,9,Math.PI,0);cx.closePath();cx.fillStyle=hairC;cx.fill();
    C(x,y-12,10,skinC);
    C(x-3,y-13,1.5,'#111');C(x+3,y-13,1.5,'#111');
    R(x-4,y-8,8,2,'#111');
  }
}

// Tark C&J poses — reuse existing drawing functions
function drawBeachTarkCJ(x,y,phase){
  if(phase==='pull')drawTarkPull(x,y);
  else if(phase==='front_squat')drawTarkFrontSquat(x,y);
  else if(phase==='clean_hold')drawTarkClean(x,y);
  else if(phase==='jerk')drawTarkJerk(x,y);
  else if(phase==='walking')drawTarkWalking(x,y);
  else if(phase==='failed'){
    var sw=Math.sin(Date.now()/80)*4;
    drawTarkIdle(x+sw,y,true);
  }
  else if(S.pose==='drinking')drawTarkDrinking(x,y,S.poseT);
  else if(S.pose==='smoke')drawTarkSmoking(x,y,S.poseT);
  else if(S.pose==='chalking')drawTarkChalking(x,y,S.poseT);
  else drawTarkIdle(x,y,false);
}

function drawBeachGymComp(){
  var bg=S.beach.gymComp;
  var ci=bg.rivalIdx;
  var cc=BEACH_COUPLE_COLORS[ci];
  var t=Date.now()*0.001;

  // === CONSTANTS ===
  var platX=450,platW=200,floorY=380,charY=328;
  var itemTblX=110,girlX=750,rackX=platX;
  var padY=166;
  var isTarkTurn=(bg.turn==='tark_declare'||bg.turn==='tark_lifting');

  // === WALK TICK ===
  if(bg.walkTarget!==null){
    var wx=bg.walkWho==='tark'?bg.tarkX:bg.rivalX;
    var dx=bg.walkTarget-wx;
    var spd=4;
    if(Math.abs(dx)<=spd){
      if(bg.walkWho==='tark')bg.tarkX=bg.walkTarget;else bg.rivalX=bg.walkTarget;
      bg.walkTarget=null;var cb=bg.walkCb;bg.walkCb=null;if(cb)cb();
    }else{
      if(bg.walkWho==='tark')bg.tarkX+=(dx>0?spd:-spd);else bg.rivalX+=(dx>0?spd:-spd);
    }
  }

  // === WALKOFF ANIMATION TICK (rival wins → walks to girl → arm around → walk offscreen) ===
  if(bg.walkoffPhase==='rival_to_girl'){
    var gdx=girlX-20-bg.rivalX; // stop just left of girl
    if(Math.abs(gdx)<=3){
      bg.rivalX=girlX-20;
      bg.walkoffPhase='arm_around';bg.walkoffT=0;
      bg.rivalSpeech=null;
      log(BEACH_COUPLE_NAMES[ci]+' puts his arm around his girl.','fail');
    }else{
      bg.rivalX+=(gdx>0?3:-3);
    }
  }else if(bg.walkoffPhase==='arm_around'){
    bg.walkoffT++;
    if(bg.walkoffT>90){ // ~1.5 sec pause with arm around
      bg.walkoffPhase='walking_off';bg.walkoffT=0;
      log('They walk off together. Laughing.','fail');
      log('Tark stands there alone. The crowd disperses.','fail');
    }
  }else if(bg.walkoffPhase==='walking_off'){
    bg.rivalX+=2;bg.walkoffGirlX+=2;
    if(bg.rivalX>960){
      bg.walkoffPhase='done';
      renderControls();
    }
  // === TARK WINS WALKOFF: Tark walks to girl → arm around → walk off LEFT ===
  }else if(bg.walkoffPhase==='tark_to_girl'){
    var tgdx=girlX-20-bg.tarkX; // walk to just left of girl
    if(Math.abs(tgdx)<=4){
      bg.tarkX=girlX-20;
      bg.walkoffGirlX=girlX; // lock girl position relative to Tark
      bg.walkoffPhase='tark_arm_around';bg.walkoffT=0;
      log('Tark walks over. Puts his arm around her. "You\'re coming with me."','hype');
    }else{
      bg.tarkX+=(tgdx>0?4:-4);
    }
  }else if(bg.walkoffPhase==='tark_arm_around'){
    bg.walkoffT++;
    if(bg.walkoffT>90){
      bg.walkoffPhase='tark_walking_off';bg.walkoffT=0;
      log('Tark walks off with her. '+BEACH_COUPLE_NAMES[ci]+' stands there, stunned.','hype');
    }
  }else if(bg.walkoffPhase==='tark_walking_off'){
    bg.tarkX-=2;bg.walkoffGirlX=bg.tarkX+20; // girl stays to Tark's right
    if(bg.tarkX<-60){
      bg.walkoffPhase='done';
      renderControls();
    }
  }

  // === SKY + OCEAN + SAND ===
  var skyG=cx.createLinearGradient(0,0,0,140);
  skyG.addColorStop(0,'#3388cc');skyG.addColorStop(0.6,'#66aadd');skyG.addColorStop(1,'#ffbb66');
  cx.fillStyle=skyG;cx.fillRect(0,0,W,140);
  C(800,45,22,'#ffdd44');cx.globalAlpha=0.2;C(800,45,35,'#ffee88');cx.globalAlpha=1;
  cx.globalAlpha=0.25;C(120,40,14,'#fff');C(140,36,18,'#fff');C(160,42,12,'#fff');cx.globalAlpha=1;
  R(60,30,6,130,'#5a4030');R(840,20,6,140,'#5a4030');
  for(var pf=0;pf<5;pf++){
    cx.save();cx.translate(63,28);cx.rotate(-0.8+pf*0.4);R(0,-2,35,4,'#338833');cx.restore();
    cx.save();cx.translate(843,18);cx.rotate(-0.8+pf*0.4);R(0,-2,30,4,'#338833');cx.restore();
  }
  R(0,130,W,20,'#2266aa');
  cx.globalAlpha=0.15;for(var ww=0;ww<15;ww++){R(ww*65,132+Math.sin(t*1.5+ww)*2,40,2,'#88ccee');}cx.globalAlpha=1;
  R(0,148,W,20,'#d4b896');

  // === GYM AREA (concrete pad) ===
  var gymG=cx.createLinearGradient(0,padY,0,H);
  gymG.addColorStop(0,'#8a8a8a');gymG.addColorStop(1,'#7a7a7a');
  cx.fillStyle=gymG;cx.fillRect(0,padY,W,H-padY);
  cx.globalAlpha=0.04;for(var cg=0;cg<30;cg++){R(Math.random()*W,padY+Math.random()*(H-padY),Math.random()*6+1,Math.random()*3+1,'#000');}cx.globalAlpha=1;

  // === MUSCLE BEACH SIGN — big wooden board ===
  var signX=200,signW=500,signY=padY-30,signH=36;
  R(signX,signY,signW,signH,'#5a3a1a');
  R(signX+2,signY+2,signW-4,signH-4,'#6a4422');
  R(signX+4,signY+4,signW-8,signH-8,'#7a5030');
  cx.strokeStyle='#4a2a10';cx.lineWidth=2;cx.strokeRect(signX,signY,signW,signH);
  // Neon-style text
  cx.shadowColor='#ff6644';cx.shadowBlur=8;
  T('MUSCLE BEACH',450,signY+signH/2+5,16,'#ffcc44');
  cx.shadowBlur=0;
  // Support chains
  R(signX+10,signY-8,3,10,'#888');R(signX+signW-13,signY-8,3,10,'#888');

  // === GYM WALLS ===
  R(20,padY+4,6,floorY-padY-4,'#555');R(874,padY+4,6,floorY-padY-4,'#555');
  R(18,padY+2,864,4,'#666');

  // === SCOREBOARD — thin panel on gym wall ===
  var sbY=padY+8,sbH=32;
  R(100,sbY,700,sbH,'rgba(10,10,12,0.85)');
  cx.strokeStyle='#444';cx.lineWidth=1;cx.strokeRect(100,sbY,700,sbH);
  // Left: TARK + best
  T('TARK',150,sbY+13,10,'#ff6b35');
  if(bg.bestTark>0)T(bg.bestTark+' LBS',150,sbY+25,8,'#7fdb6a');
  // Center: current bar + lift log dots
  var barTxt=bg.currentBar>0?'BAR: '+bg.currentBar+' LBS':'C&J \u2022 OUTDO EACH OTHER';
  T(barTxt,450,sbY+13,9,bg.currentBar>0?'#ffcc00':'#888');
  // Lift log as colored dots (green=made, red=failed, T=tark, R=rival)
  var logLen=Math.min(bg.liftLog.length,16);
  var dotStart=450-logLen*9/2;
  for(var li=0;li<logLen;li++){
    var le=bg.liftLog[bg.liftLog.length-logLen+li];
    var dotC=le.made?'#7fdb6a':'#ff4444';
    var dotBorder=le.who==='tark'?'#ff6b35':'#aaa';
    cx.strokeStyle=dotBorder;cx.lineWidth=1.5;
    cx.beginPath();cx.arc(dotStart+li*9,sbY+26,3,0,Math.PI*2);cx.fillStyle=dotC;cx.fill();cx.stroke();
  }
  // Right: Rival + best
  T(BEACH_COUPLE_NAMES[ci],740,sbY+13,10,'#7fdb6a');
  if(bg.bestRival>0)T(bg.bestRival+' LBS',740,sbY+25,8,'#7fdb6a');

  // === BACKGROUND GYM EQUIPMENT (detailed) ===
  // Left side: squat rack
  R(30,padY+30,6,80,'#555');R(68,padY+30,6,80,'#555');R(28,padY+28,48,4,'#666');
  R(36,padY+50,4,3,'#777');R(60,padY+50,4,3,'#777'); // J-hooks
  R(34,padY+52,30,3,'#444'); // barbell
  C(32,padY+53,4,'#333');C(66,padY+53,4,'#333'); // plates
  // Cable machine behind
  R(80,padY+20,4,90,'#444');R(110,padY+20,4,90,'#444');R(80,padY+18,34,4,'#555');
  R(88,padY+24,16,8,'#333'); // weight stack
  for(var ws=0;ws<5;ws++){R(89,padY+26+ws*6,14,4,'#3a3a3a');cx.globalAlpha=0.3;R(89,padY+26+ws*6,14,1,'#666');cx.globalAlpha=1;}
  // Right side: dumbbell rack
  R(770,padY+50,70,8,'#444');R(770,padY+62,70,8,'#444');R(770,padY+74,70,8,'#444');
  R(768,padY+40,4,46,'#555');R(842,padY+40,4,46,'#555');
  // Dumbbells on rack
  for(var di=0;di<4;di++){
    var dbx=778+di*16;
    R(dbx,padY+46,10,4,'#333');R(dbx+2,padY+44,6,2,'#555');
    R(dbx,padY+58,10,4,'#333');
    R(dbx,padY+70,12,4,'#333');
  }
  // Bench press in back-right
  R(850,padY+60,4,50,'#444');R(870,padY+60,4,50,'#444');R(848,padY+58,28,4,'#555');
  R(840,padY+80,40,6,'#3a3a3a'); // bench pad
  // Wall decorations
  cx.globalAlpha=0.4;R(130,padY+10,50,35,'#443322');T('RULES',155,padY+30,7,'#887766');cx.globalAlpha=1;
  cx.globalAlpha=0.3;R(680,padY+10,60,30,'#223344');T('RECORDS',710,padY+28,7,'#778899');cx.globalAlpha=1;
  // Floor mats / rubber tiles pattern
  cx.globalAlpha=0.06;for(var fm=0;fm<8;fm++){R(fm*115,floorY-12,110,12,fm%2?'#5a5a5a':'#4a4a4a');}cx.globalAlpha=1;

  // === SPECTATORS (more of them, animated) ===
  var specDat=[
    {x:35,c:'#cc4444',hc:'#d4a574'},{x:55,c:'#4488cc',hc:'#e8b870'},
    {x:780,c:'#4444cc',hc:'#e8b870'},{x:800,c:'#44cc44',hc:'#c49060'},
    {x:820,c:'#cccc44',hc:'#d4a574'},{x:840,c:'#cc44cc',hc:'#d4a574'},
    {x:860,c:'#dd8844',hc:'#c49060'}
  ];
  for(var sp=0;sp<specDat.length;sp++){var sd=specDat[sp];
    var sb=Math.sin(t*1.2+sp*1.1)*1.5;
    C(sd.x,padY+100+sb,5,sd.hc);R(sd.x-4,padY+105+sb,8,14,sd.c);
    // Cheering arms for some
    if(sp%3===0&&bg.animPhase){
      var chA=Math.sin(t*6+sp)*3;
      R(sd.x-6,padY+100+sb-6+chA,3,8,sd.hc);R(sd.x+3,padY+100+sb-6-chA,3,8,sd.hc);
    }
  }

  // === WOODEN PLATFORM ===
  var platLeft=rackX-platW/2,platTop=floorY-12;
  R(platLeft-2,platTop+2,platW+4,14,'rgba(0,0,0,0.15)');
  for(var wi=0;wi<12;wi+=2){R(platLeft,platTop+wi,platW,2,wi%4===0?'#5a3a1a':'#4d3117');}
  cx.strokeStyle='#3a2a0a';cx.lineWidth=1;cx.strokeRect(platLeft,platTop,platW,12);
  R(platLeft,platTop,4,12,'#2a4a7a');R(platLeft+platW-4,platTop,4,12,'#7a4a2a');

  // === FLOOR LINE ===
  R(0,floorY,W,2,'#666');

  // === BARBELL (sits on platform floor, no rack — this is a clean & jerk) ===
  var showWeight=bg.declaredWeight||135;
  if(bg.turn==='rival_lifting'||bg.animPhase&&bg.animPhase.indexOf('rival')===0)showWeight=bg.rivalNextWeight||135;
  var plates=calcPlatesForWeight(showWeight);
  var barX=rackX,barY=floorY-10; // resting on platform floor
  if(bg.animPhase==='tark_pull'){barX=bg.tarkX;barY=charY+30;}
  else if(bg.animPhase==='tark_front_squat'){barX=bg.tarkX;barY=charY+2;}
  else if(bg.animPhase==='tark_clean'){barX=bg.tarkX;barY=charY-6;}
  else if(bg.animPhase==='tark_jerk'){barX=bg.tarkX;barY=charY-60;}
  else if(bg.animPhase==='tark_fail'){barX=rackX;barY=floorY-10;}
  else if(bg.animPhase==='rival_pull'){barX=bg.rivalX;barY=charY+30;}
  else if(bg.animPhase==='rival_clean'){barX=bg.rivalX;barY=charY-6;}
  else if(bg.animPhase==='rival_jerk'){barX=bg.rivalX;barY=charY-60;}
  else if(bg.animPhase==='rival_fail'){barX=rackX;barY=floorY-10;}
  drawBarbell(barX,barY,plates);
  // Weight label near barbell when on floor
  if(!bg.animPhase){
    cx.globalAlpha=0.5;T(showWeight+' LBS',rackX,floorY-20,8,'#aaa');cx.globalAlpha=1;
  }

  // === SIDE TABLE + ITEMS (always visible) ===
  {
    var tblX=itemTblX,tblY=floorY-30;
    R(tblX-40,tblY,80,4,'#4a3a2a');R(tblX-40,tblY,80,1,'#5a4a38');
    R(tblX-36,tblY+4,4,floorY-tblY-4,'#3a2a1a');R(tblX+32,tblY+4,4,floorY-tblY-4,'#3a2a1a');
    var beerX=tblX-22,beerY=tblY-18;
    if(S.beach.beersLeft>0){
      var beerDim=bg.beersUsed>=3;
      cx.globalAlpha=beerDim?0.35:1;
      R(beerX-6,beerY,12,18,'#cc8800');R(beerX-5,beerY-2,10,3,'#aaa');
      T('BEER('+S.beach.beersLeft+')',beerX,beerY+24,6,'#cc8800');
      cx.globalAlpha=1;
      if(!beerDim&&hover==='beerZone'){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(beerX-10,beerY-4,20,28);}
    }
    var cigX=tblX,cigY=tblY-14;
    if(S.cigsLeft>0){
      var cigDim=bg.smokesUsed>=3;
      cx.globalAlpha=cigDim?0.35:1;
      R(cigX-8,cigY,16,14,'#cc2222');R(cigX-6,cigY-4,12,5,'#cc2222');
      var vis=Math.min(S.cigsLeft,3);
      for(var ci2=0;ci2<vis;ci2++){R(cigX-3+ci2*4,cigY-10,2,7,'#f5f0e0');C(cigX-2+ci2*4,cigY-10,1,'#ff8844');}
      T('SMOKES('+S.cigsLeft+')',cigX,cigY+20,6,'#cc6666');
      cx.globalAlpha=1;
      if(!cigDim&&hover==='cigZone'){cx.strokeStyle='#ffcc00';cx.lineWidth=2;cx.strokeRect(cigX-12,cigY-12,24,30);}
    }
    var chkX=tblX+24,chkY=tblY-24;
    if(S.chalkUses>0){
      var chkDim=bg.chalksUsed>=3;
      cx.globalAlpha=chkDim?0.35:1;
      R(chkX-10,chkY,20,24,'#e8e0d0');R(chkX-8,chkY,16,3,'#ccc4b0');
      R(chkX-6,chkY-2,12,3,'#fff');C(chkX-2,chkY-4,2,'#f5f5f5');C(chkX+4,chkY-3,2,'#eee');
      cx.strokeStyle='#888';cx.lineWidth=1.5;cx.beginPath();cx.arc(chkX,chkY-8,6,Math.PI,0);cx.stroke();
      T('CHALK('+S.chalkUses+')',chkX,chkY+30,6,'#aaa');
      cx.globalAlpha=1;
      if(!chkDim&&hover==='chalkZone'){cx.strokeStyle='#fff';cx.lineWidth=2;cx.strokeRect(chkX-14,chkY-10,28,38);}
    }
    T('\u2190 Items (3 max each)',itemTblX+60,floorY-14,7,'#888');
  }

  // === DRAW CHARACTERS ===
  var tarkPhase='idle';
  var tarkWalkoff=(bg.walkoffPhase==='tark_to_girl'||bg.walkoffPhase==='tark_walking_off');
  if(tarkWalkoff)tarkPhase='walking';
  else if(bg.walkTarget!==null&&bg.walkWho==='tark')tarkPhase='walking';
  else if(bg.animPhase==='tark_pull')tarkPhase='pull';
  else if(bg.animPhase==='tark_front_squat')tarkPhase='front_squat';
  else if(bg.animPhase==='tark_clean')tarkPhase='clean_hold';
  else if(bg.animPhase==='tark_jerk')tarkPhase='jerk';
  else if(bg.animPhase==='tark_fail')tarkPhase='failed';
  var tarkArmAround=(bg.walkoffPhase==='tark_arm_around'||bg.walkoffPhase==='tark_walking_off');
  // Don't draw Tark if he's walked offscreen
  if(bg.walkoffPhase!=='done'||bg.result==='rival_wins'){
    if(tarkArmAround)S._hideRightArm=true;
    drawBeachTarkCJ(bg.tarkX,charY,tarkPhase);
    S._hideRightArm=false;
    // Draw arm curve from Tark to girl (same pattern as beach closeup)
    if(tarkArmAround){
      var shoulderX=bg.tarkX+14;
      var shoulderY=charY-6;
      var wShoulderX=bg.walkoffGirlX;
      var wShoulderY=charY-6;
      cx.save();
      cx.strokeStyle='#d4a574';
      cx.lineWidth=6;
      cx.lineCap='round';
      cx.beginPath();
      cx.moveTo(shoulderX,shoulderY);
      var midX=(shoulderX+wShoulderX)*0.5;
      var midY=(shoulderY+wShoulderY)*0.5+4;
      cx.quadraticCurveTo(midX,midY,wShoulderX,wShoulderY);
      cx.stroke();
      cx.restore();
    }
  }

  var rivalPhase='idle';
  if(bg.walkoffPhase==='rival_to_girl')rivalPhase='walking';
  else if(bg.walkoffPhase==='walking_off')rivalPhase='walking';
  else if(bg.walkTarget!==null&&bg.walkWho==='rival')rivalPhase='walking';
  else if(bg.animPhase==='rival_pull')rivalPhase='pull';
  else if(bg.animPhase==='rival_clean')rivalPhase='clean_hold';
  else if(bg.animPhase==='rival_jerk')rivalPhase='jerk';
  else if(bg.animPhase==='rival_fail')rivalPhase='failed';
  var manSc=ci===2?1.5:1.3;
  // Don't draw rival if he's walked offscreen
  if(bg.walkoffPhase!=='done'){
    cx.save();cx.translate(bg.rivalX,charY-10);cx.scale(manSc,manSc);
    drawBeachRivalCJ(0,0,rivalPhase,cc.man,cc.shirt,cc.hair,cc.shorts);
    // Draw arm-around-girl overlay during arm_around and walking_off
    if(bg.walkoffPhase==='arm_around'||bg.walkoffPhase==='walking_off'){
      // Extended right arm draped over girl's shoulder
      cx.fillStyle=cc.man;
      cx.fillRect(8,-6,14,5); // upper arm reaching right
      cx.fillRect(18,-4,6,8); // forearm draping down over shoulder
      C(21,2,3,cc.man);       // hand resting on her arm
    }
    cx.restore();
  }

  // === RIVAL REACTIONS (watching during Tark's turn) ===
  if(bg.rivalX>500&&rivalPhase==='idle'){
    var rrx=bg.rivalX,rry=charY-10;
    // Watching — arms crossed pose
    if(bg.turn==='tark_declare'||bg.turn==='tark_lifting'){
      // Crossed arms overlay
      cx.globalAlpha=0.6;
      T(bg.turn==='tark_lifting'?'\u{1F440}':'...', rrx, rry-Math.round(40*manSc), 10, '#888');
      cx.globalAlpha=1;
    }
    // Reaction to Tark's lift result
    if(bg.animPhase==='tark_jerk'){
      // Tark made it — rival is nervous
      var nrb=Math.sin(t*4)*2;
      T('!!!', rrx, rry-Math.round(45*manSc)+nrb, 12, '#ff4444');
    }
    if(bg.animPhase==='tark_fail'){
      // Tark failed — rival is laughing
      var lb=Math.sin(t*8)*3;
      T('HA HA!', rrx, rry-Math.round(45*manSc)+lb, 11, '#ffcc00');
    }
  }

  // Rival speech bubble
  if(bg.rivalSpeech){
    var rsx=bg.rivalX;
    R(rsx-55,charY-95,110,20,'rgba(255,255,255,0.9)');
    cx.fillStyle='#333';cx.font='8px monospace';cx.textAlign='center';cx.fillText(bg.rivalSpeech,rsx,charY-82);cx.textAlign='center';
  }
  // Taunt hover
  if(bg.turn==='tark_declare'&&!bg.tauntUsed&&hover==='tauntZone'){
    cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(bg.rivalX-30,charY-30,60,60);
    T('TAUNT',bg.rivalX,charY-38,9,'#ff6b35');
  }

  // === RIVAL'S GIRLFRIEND — same girl from the beach, full-sized on same plane ===
  // During walkoff, girl position tracks walkoffGirlX
  var anyWalkoff=(bg.walkoffPhase==='walking_off'||bg.walkoffPhase==='arm_around'||bg.walkoffPhase==='tark_arm_around'||bg.walkoffPhase==='tark_walking_off');
  var gx=anyWalkoff?bg.walkoffGirlX:girlX;
  var gy=charY; // same Y as rival and Tark
  // Don't draw her if she's walked offscreen
  if(bg.walkoffPhase!=='done'){
  var girlSc=1.2; // same scale as the men
  var walkoffActive=(bg.walkoffPhase==='arm_around'||bg.walkoffPhase==='walking_off'||bg.walkoffPhase==='tark_arm_around'||bg.walkoffPhase==='tark_walking_off');
  cx.save();cx.translate(gx,gy);cx.scale(girlSc,girlSc);
  // Determine reaction
  var tarkWalkingOff=(bg.walkoffPhase==='tark_arm_around'||bg.walkoffPhase==='tark_walking_off');
  var rivalWalkingOff=(bg.walkoffPhase==='arm_around'||bg.walkoffPhase==='walking_off');
  var girlCheering=(bg.animPhase==='rival_jerk'||bg.animPhase==='tark_jerk'||tarkWalkingOff);
  var girlLaughing=(bg.animPhase==='tark_fail'||rivalWalkingOff);
  var girlWorried=bg.animPhase==='rival_fail';
  if(walkoffActive){girlWorried=false;if(tarkWalkingOff)girlLaughing=false;if(rivalWalkingOff)girlCheering=false;}
  var isWalkingOff=(bg.walkoffPhase==='walking_off'||bg.walkoffPhase==='tark_walking_off');
  var gWB=isWalkingOff?Math.sin(t*6)*1.5:0; // walk bob
  var gStep=isWalkingOff?Math.sin(t*8)*4:0;
  // Beach shorts (short, colorful)
  R(-6,18+gWB,9,12-gStep*0.2,cc.wshorts||cc.wshirt);R(3,18+gWB,9,12+gStep*0.2,cc.wshorts||cc.wshirt);
  // Bare legs below shorts
  R(-5,30+gWB,7,16-gStep*0.2,cc.w);R(4,30+gWB,7,16+gStep*0.2,cc.w);
  // Sandals
  R(-6,46+gWB,9,4,cc.wsandal||'#c89060');R(3,46+gWB,9,4,cc.wsandal||'#c89060');
  // Midriff (skin showing)
  R(-11,8+gWB,22,12,cc.w);
  // Bikini top
  R(-12,-2+gWB,24,12,cc.wshirt);
  // Bikini triangle cups
  cx.fillStyle=cc.wshirt;
  cx.beginPath();cx.moveTo(-10,0+gWB);cx.lineTo(-2,8+gWB);cx.lineTo(-10,8+gWB);cx.closePath();cx.fill();
  cx.beginPath();cx.moveTo(10,0+gWB);cx.lineTo(2,8+gWB);cx.lineTo(10,8+gWB);cx.closePath();cx.fill();
  cx.strokeStyle=cc.wshirt;cx.lineWidth=1.5;
  cx.beginPath();cx.moveTo(-12,0+gWB);cx.lineTo(12,0+gWB);cx.stroke();
  // Arms
  if(rivalWalkingOff){
    // Rival walkoff: left arm at side, right arm hidden (rival's arm around her from right)
    R(-17,0+gWB,7,24,cc.w);
  }else if(tarkWalkingOff){
    // Tark walkoff: right arm at side, left arm hidden (Tark's arm around her from left)
    R(9,0+gWB,7,24,cc.w);
  }else if(girlCheering){
    var wa=Math.sin(t*8)*0.5;
    cx.save();cx.translate(-14,-2+gWB);cx.rotate(-1.2+wa);R(0,0,6,20,cc.w);cx.restore();
    cx.save();cx.translate(14,-2+gWB);cx.rotate(1.2-wa);R(-6,0,6,20,cc.w);cx.restore();
  }else if(girlLaughing){
    // Hands on belly
    R(-15,4+gWB,7,16,cc.w);R(8,4+gWB,7,16,cc.w);
  }else if(girlWorried){
    // Hands to face
    R(-12,-10+gWB,7,14,cc.w);R(5,-10+gWB,7,14,cc.w);
  }else{
    // Normal — arms at sides
    R(-17,0+gWB,7,24,cc.w);R(9,0+gWB,7,24,cc.w);
  }
  // Hair BEHIND head
  cx.beginPath();cx.arc(0,-18+gWB,11,Math.PI,0);cx.closePath();cx.fillStyle=cc.whair;cx.fill();
  // Side hair strands
  R(-12,-16+gWB,5,22,cc.whair);R(7,-16+gWB,5,22,cc.whair);
  // Head
  C(0,-14+gWB,11,cc.w);
  // Ears
  C(-11,-14+gWB,2.5,cc.w);C(11,-14+gWB,2.5,cc.w);
  // Face
  if(girlLaughing){
    // Laughing: squint eyes + open mouth + blush
    R(-5,-16+gWB,4,1.5,'#222');R(2,-16+gWB,4,1.5,'#222');
    // Eyelashes even when squinting
    cx.strokeStyle='#222';cx.lineWidth=1;
    cx.beginPath();cx.moveTo(-6,-17+gWB);cx.lineTo(-6.5,-19+gWB);cx.stroke();
    cx.beginPath();cx.moveTo(6,-17+gWB);cx.lineTo(6.5,-19+gWB);cx.stroke();
    cx.beginPath();cx.arc(0,-9+gWB,3,0,Math.PI);cx.fillStyle='#cc4466';cx.fill();
    // Blush
    cx.globalAlpha=0.3;C(-7,-12+gWB,3,'#ff6666');C(7,-12+gWB,3,'#ff6666');cx.globalAlpha=1;
  }else if(girlWorried){
    // Wide worried eyes + eyebrows up + frown
    C(-4,-15+gWB,2.8,'#fff');C(4,-15+gWB,2.8,'#fff');
    C(-4,-15+gWB,1.3,'#4488aa');C(4,-15+gWB,1.3,'#4488aa');
    C(-4,-15+gWB,0.6,'#111');C(4,-15+gWB,0.6,'#111');
    cx.strokeStyle='#222';cx.lineWidth=1;
    cx.beginPath();cx.moveTo(-6.5,-17+gWB);cx.lineTo(-7,-19+gWB);cx.stroke();
    cx.beginPath();cx.moveTo(6.5,-17+gWB);cx.lineTo(7,-19+gWB);cx.stroke();
    // Eyebrows up (worried)
    cx.strokeStyle='#664433';cx.lineWidth=0.8;
    cx.beginPath();cx.moveTo(-6,-18+gWB);cx.lineTo(-2,-20+gWB);cx.stroke();
    cx.beginPath();cx.moveTo(6,-18+gWB);cx.lineTo(2,-20+gWB);cx.stroke();
    R(-2,-8+gWB,4,1.5,'#cc6666');
  }else if(girlCheering){
    // Excited eyes + big smile
    C(-4,-15+gWB,2.8,'#fff');C(4,-15+gWB,2.8,'#fff');
    C(-4,-15+gWB,1.3,'#4488aa');C(4,-15+gWB,1.3,'#4488aa');
    C(-4,-15+gWB,0.6,'#111');C(4,-15+gWB,0.6,'#111');
    cx.globalAlpha=0.5;C(-3.2,-15.8+gWB,0.5,'#fff');C(4.8,-15.8+gWB,0.5,'#fff');cx.globalAlpha=1;
    cx.strokeStyle='#222';cx.lineWidth=1;
    cx.beginPath();cx.moveTo(-6.5,-17+gWB);cx.lineTo(-7,-19+gWB);cx.stroke();
    cx.beginPath();cx.moveTo(6.5,-17+gWB);cx.lineTo(7,-19+gWB);cx.stroke();
    cx.beginPath();cx.arc(0,-8+gWB,3.5,0,Math.PI);cx.fillStyle='#dd5566';cx.fill();
    cx.globalAlpha=0.15;C(-7,-12+gWB,3,'#ff6666');C(7,-12+gWB,3,'#ff6666');cx.globalAlpha=1;
  }else{
    // Neutral — pretty face
    C(-4,-15+gWB,2.8,'#fff');C(4,-15+gWB,2.8,'#fff');
    C(-4,-15+gWB,1.3,'#4488aa');C(4,-15+gWB,1.3,'#4488aa');
    C(-4,-15+gWB,0.6,'#111');C(4,-15+gWB,0.6,'#111');
    // Eye shine
    cx.globalAlpha=0.5;C(-3.2,-15.8+gWB,0.5,'#fff');C(4.8,-15.8+gWB,0.5,'#fff');cx.globalAlpha=1;
    // Eyelashes (thicker, more feminine)
    cx.strokeStyle='#222';cx.lineWidth=1.2;
    cx.beginPath();cx.moveTo(-6.5,-17+gWB);cx.lineTo(-7,-19.5+gWB);cx.stroke();
    cx.beginPath();cx.moveTo(-5,-17.5+gWB);cx.lineTo(-5.5,-19.5+gWB);cx.stroke();
    cx.beginPath();cx.moveTo(6.5,-17+gWB);cx.lineTo(7,-19.5+gWB);cx.stroke();
    cx.beginPath();cx.moveTo(5,-17.5+gWB);cx.lineTo(5.5,-19.5+gWB);cx.stroke();
    // Eyebrows (thin, arched)
    cx.strokeStyle='#664433';cx.lineWidth=0.8;
    cx.beginPath();cx.moveTo(-7,-18+gWB);cx.quadraticCurveTo(-4,-20+gWB,-1,-18.5+gWB);cx.stroke();
    cx.beginPath();cx.moveTo(7,-18+gWB);cx.quadraticCurveTo(4,-20+gWB,1,-18.5+gWB);cx.stroke();
    // Nose (subtle)
    cx.globalAlpha=0.15;C(0,-11+gWB,1.8,cc.w);cx.globalAlpha=1;
    cx.globalAlpha=0.08;R(-1,-10+gWB,2,1,'#000');cx.globalAlpha=1;
    // Lips (full, colored)
    cx.fillStyle='#dd5566';cx.beginPath();cx.arc(0,-7.5+gWB,3.5,0,Math.PI);cx.fill();
    cx.fillStyle='#ee7788';cx.beginPath();cx.arc(0,-8+gWB,2.8,Math.PI,0);cx.fill();
    cx.globalAlpha=0.3;C(-1,-8.5+gWB,1,'#fff');cx.globalAlpha=1;
    // Light blush
    cx.globalAlpha=0.12;C(-7,-12+gWB,3,'#ff6666');C(7,-12+gWB,3,'#ff6666');cx.globalAlpha=1;
  }
  cx.restore();
  // Tark's hand on girl's far shoulder (drawn after girl so it wraps around)
  if(tarkWalkingOff){
    var handX=gx-10*girlSc; // left shoulder
    var handY=gy-6*girlSc;
    C(handX,handY,4,'#d4a574');
  }
  }
  // Speech/reaction text (use cached girlReact to avoid picking every frame)
  // Don't render speech if offscreen
  if(bg.walkoffPhase==='done'){girlCheering=false;girlLaughing=false;girlWorried=false;}
  if(girlCheering||girlLaughing||girlWorried){
    var reactKey=(girlCheering?'c':'')+(girlLaughing?'l':'')+(girlWorried?'w':'');
    if(bg._girlReactKey!==reactKey){
      bg._girlReactKey=reactKey;
      if(girlCheering)bg._girlReactText=bg.animPhase==='rival_jerk'?pick(['"YES!"','"BABY!"','"WOOO!"']):pick(['"Oh wow!"','"Omg!"','"!!!"']);
      else if(girlLaughing)bg._girlReactText=pick(['"HAHA!"','"LOL"','"Loser!"']);
      else bg._girlReactText=pick(['"Oh no..."','"Babe..."','"*gasp*"']);
    }
  }else{bg._girlReactKey=null;}
  if(girlCheering&&bg._girlReactText){
    var cheerBob=Math.sin(t*6)*2;
    R(gx-40,gy-50+cheerBob,80,16,'rgba(255,200,255,0.9)');
    cx.fillStyle='#993366';cx.font='bold 8px monospace';cx.textAlign='center';cx.fillText(bg._girlReactText,gx,gy-39+cheerBob);cx.textAlign='center';
  }
  if(girlLaughing&&bg._girlReactText){
    var laughBob=Math.sin(t*10)*2;
    R(gx-40,gy-50+laughBob,80,16,'rgba(255,200,200,0.9)');
    cx.fillStyle='#993333';cx.font='bold 8px monospace';cx.textAlign='center';cx.fillText(bg._girlReactText,gx,gy-39+laughBob);cx.textAlign='center';
  }
  if(girlWorried&&bg._girlReactText){
    R(gx-30,gy-50,60,16,'rgba(200,200,255,0.9)');
    cx.fillStyle='#334466';cx.font='8px monospace';cx.textAlign='center';cx.fillText(bg._girlReactText,gx,gy-39);cx.textAlign='center';
  }
  // Girl speech from item interactions (Tark's girlfriend only)
  if(bg.hasGirlfriend&&bg.girlSpeech){
    R(gx-50,gy-68,100,16,'rgba(255,200,255,0.9)');
    cx.fillStyle='#663366';cx.font='8px monospace';cx.textAlign='center';cx.fillText(bg.girlSpeech,gx,gy-57);cx.textAlign='center';
  }
  if(bg.hasGirlfriend&&bg.turn==='tark_declare'&&!bg.girlUsed&&hover==='girlZone'){
    cx.strokeStyle='#ff69b4';cx.lineWidth=2;cx.strokeRect(gx-16,gy-30,32,80);
  }

  // === LIFTING STATUS (grunt bubbles) ===
  if(bg.animPhase==='rival_pull'||bg.animPhase==='rival_clean'){
    var grx=bg.rivalX;
    R(grx-20,charY-95,40,16,'rgba(255,255,255,0.85)');
    cx.fillStyle='#cc3333';cx.font='bold 9px monospace';cx.textAlign='center';
    cx.fillText('HRRGH!',grx,charY-84);cx.textAlign='center';
  }
  if(bg.animPhase==='tark_pull'||bg.animPhase==='tark_clean'){
    var gtx=bg.tarkX;
    R(gtx-20,charY-95,40,16,'rgba(255,255,255,0.85)');
    cx.fillStyle='#ff6b35';cx.font='bold 9px monospace';cx.textAlign='center';
    cx.fillText('NNGH!',gtx,charY-84);cx.textAlign='center';
  }

  // === RESULT BANNER (blends with gym wall) ===
  if(bg.result){
    var banY=padY+10,banH=80;
    R(60,banY,780,banH,'rgba(10,10,12,0.85)');
    cx.strokeStyle=bg.result==='tark_wins'?'#ffcc00':'#ff4444';cx.lineWidth=2;cx.strokeRect(60,banY,780,banH);
    var rmsg=bg.result==='tark_wins'?'TARK WINS!':'TARK LOSES';
    var mc=bg.result==='tark_wins'?'#ffcc00':'#ff4444';
    T(rmsg,platX,banY+28,22,mc);
    T('Tark: '+(bg.bestTark>0?bg.bestTark+' lbs':'DNL'),platX-120,banY+55,11,bg.bestTark>0?'#7fdb6a':'#ff4444');
    T(BEACH_COUPLE_NAMES[ci]+': '+(bg.bestRival>0?bg.bestRival+' lbs':'DNL'),platX+120,banY+55,11,bg.bestRival>0?'#7fdb6a':'#ff4444');
    var rounds=bg.liftLog.length;
    if(bg.result==='tark_wins'){
      T(rounds+' lifts. The crowd goes wild.',platX,banY+72,9,'#ccc');
    }else{
      T(rounds+' lifts. Humiliated.',platX,banY+72,9,'#ff6666');
      // Pulsing HUMILIATED text
      var pulse=0.5+Math.sin(Date.now()/300)*0.3;
      cx.globalAlpha=pulse;
      T('DEBUFF: Carries into the meet',platX,banY+banH+16,8,'#ff4444');
      cx.globalAlpha=1;
    }
  }

  // Version stamp
  cx.globalAlpha=0.3;cx.font='9px monospace';cx.textAlign='right';cx.fillStyle='#666';
  cx.fillText('v'+BUILD_V,W-4,H-4);cx.textAlign='center';cx.globalAlpha=1;
}

// --- STALL INTERIOR (inside out-of-order bathroom stall) ---

function drawStallInterior(){
var CS=1.3,GY=468;
var tarkOY=GY-Math.round(72*CS);
var fb=S.beach;
var now=Date.now();

// === BACK WALL — grimy tile grid ===
R(0,0,W,H,'#8a8278');
for(var ty=0;ty<18;ty++){for(var tx=0;tx<45;tx++){
  var tc=(tx+ty)%2===0?'#9a9688':'#8f8b78';
  if((tx*7+ty*13)%31===0)tc='#7a7668';
  R(tx*20,ty*20,19,19,tc);
}}
// Grout lines
cx.strokeStyle='#5a5648';cx.lineWidth=0.5;
for(var gy2=0;gy2<=18;gy2++){cx.beginPath();cx.moveTo(0,gy2*20);cx.lineTo(W,gy2*20);cx.stroke();}
for(var gx2=0;gx2<=45;gx2++){cx.beginPath();cx.moveTo(gx2*20,0);cx.lineTo(gx2*20,360);cx.stroke();}

// Floor — dark filthy tile
R(0,360,W,120,'#3a3630');
for(var fx=0;fx<15;fx++){R(fx*60,360,58,58,(fx%2)?'#332e28':'#3e3a32');}
for(var fx2=0;fx2<15;fx2++){R(fx2*60+30,418,58,58,(fx2%2)?'#3e3a32':'#332e28');}

// Stall partition walls
R(0,0,60,H,'#706858');R(840,0,60,H,'#706858');
cx.globalAlpha=0.1;R(0,0,60,H,'#000');R(840,0,60,H,'#000');cx.globalAlpha=1;
// Partition edge detail
R(58,0,4,H,'#5a5040');R(838,0,4,H,'#5a5040');

// Mold and water stains
cx.globalAlpha=0.12;
R(70,40,60,50,'#2a3a2a');R(720,80,50,40,'#2a3a2a');R(400,30,40,30,'#2a3a2a');
R(350,20,3,80,'#444');R(600,30,2,70,'#444');R(200,10,2,90,'#444');
cx.globalAlpha=1;

// Graffiti on back wall
cx.globalAlpha=0.4;
cx.font='bold 9px monospace';cx.textAlign='left';cx.fillStyle='#555';
cx.fillText('TARK WUZ HERE',300,55);
cx.font='6px monospace';cx.fillStyle='#664433';
cx.fillText('FOR A GOOD TIME CALL...',310,80);
cx.font='italic 7px monospace';cx.fillStyle='#446644';
cx.fillText('CLEAN & JERK > SNATCH',270,110);
cx.font='5px monospace';cx.fillStyle='#554444';
cx.fillText('REPS FOR JESUS',340,135);
cx.textAlign='center';cx.globalAlpha=1;

// Puddle near hole
cx.globalAlpha=0.2;
cx.beginPath();cx.ellipse(580,400,40,8,0,0,Math.PI*2);cx.fillStyle='#4488bb';cx.fill();
cx.globalAlpha=1;

// === HOLE IN FLOOR (where toilet should be) ===
// Cracked tile edge around hole
cx.strokeStyle='#2a2a2a';cx.lineWidth=2;
cx.beginPath();cx.ellipse(620,385,62,36,0,0,Math.PI*2);cx.stroke();
// Broken tile fragments at edge
R(570,368,8,6,'#5a5648');R(665,372,6,8,'#5a5648');R(595,408,10,5,'#4a4638');
// Dark void
var holeG=cx.createRadialGradient(620,385,5,620,385,55);
holeG.addColorStop(0,'#000');holeG.addColorStop(1,'#1a1a0a');
cx.fillStyle=holeG;
cx.beginPath();cx.ellipse(620,385,55,30,0,0,Math.PI*2);cx.fill();
// Broken pipe stubs
R(588,370,8,22,'#666');R(591,367,4,5,'#888');
R(645,375,6,18,'#555');R(648,373,3,4,'#777');
// Drip from pipe
var drpT=now*0.004;
cx.globalAlpha=0.5;C(592,392+(drpT%12)*2,2,'#4488bb');cx.globalAlpha=1;

// === TARK ===
if(fb.holeDescending){
  fb.holeDescendT+=0.008;
  if(fb.holeDescendT>=1){
    fb.holeDescending=false;fb.holeDescendT=0;
    enterSewer();
  }
  var sinkT=fb.holeDescendT;
  // Walk to hole (0-40%), then sink (40-100%)
  var holeX,holeY;
  if(sinkT<0.4){
    var hwp=sinkT/0.4;
    holeX=450+(580-450)*hwp;
    holeY=tarkOY+Math.sin(sinkT*50)*2;
  }else{
    holeX=580;
    var sinkP=(sinkT-0.4)/0.6;
    holeY=tarkOY+sinkP*130;
  }
  // Clip Tark above floor for sinking effect
  cx.save();
  cx.beginPath();cx.rect(0,0,W,395);cx.clip();
  cx.save();cx.translate(holeX,holeY);cx.scale(CS,CS);
  cx.globalAlpha=1-Math.max(0,(fb.holeDescendT-0.5)*2); // fade in second half
  drawTarkIdle(0,0,false);
  cx.globalAlpha=1;
  cx.restore();
  cx.restore();
}else{
  // Normal idle center
  cx.save();cx.translate(450,tarkOY);cx.scale(CS,CS);
  drawTarkIdle(0,0,false);
  cx.restore();
}

// === HOVER HIGHLIGHTS ===
if(!fb.holeDescending){
  // Hole in floor
  if(mouseX>=560&&mouseX<=680&&mouseY>=350&&mouseY<=420){
    cx.strokeStyle='#ffcc00';cx.lineWidth=2;cx.strokeRect(560,350,120,70);
    T(fb.holeExamined?'GO DOWN':'LOOK DOWN',620,435,9,'#ffcc00');
  }
}

// === BACK BUTTON ===
var bailHov=mouseX>=20&&mouseX<=140&&mouseY>=440&&mouseY<=470;
R(20,440,120,30,bailHov?'#884422':'#663311');
cx.strokeStyle='#aa7744';cx.lineWidth=1;cx.strokeRect(20,440,120,30);
T('BACK',80,460,12,'#f0e6d3');

// Version stamp
cx.globalAlpha=0.3;cx.font='9px monospace';cx.textAlign='right';cx.fillStyle='#666';
cx.fillText('v'+BUILD_V,W-4,H-4);cx.textAlign='center';cx.globalAlpha=1;
}

// --- MIDDLE STALL INTERIOR (toilet to flush & flood) ---

function drawMiddleStallInterior(){
var CS=1.3,GY=468;
var tarkOY=GY-Math.round(72*CS);
var fb=S.beach;
var now=Date.now();

// === BACK WALL — grimy tile grid ===
R(0,0,W,H,'#8a8278');
for(var ty=0;ty<18;ty++){for(var tx=0;tx<45;tx++){
  var tc=(tx+ty)%2===0?'#9a9688':'#8f8b78';
  if((tx*7+ty*13)%31===0)tc='#7a7668';
  R(tx*20,ty*20,19,19,tc);
}}
cx.strokeStyle='#5a5648';cx.lineWidth=0.5;
for(var gy2=0;gy2<=18;gy2++){cx.beginPath();cx.moveTo(0,gy2*20);cx.lineTo(W,gy2*20);cx.stroke();}
for(var gx2=0;gx2<=45;gx2++){cx.beginPath();cx.moveTo(gx2*20,0);cx.lineTo(gx2*20,360);cx.stroke();}

// Floor — dark filthy tile
R(0,360,W,120,'#3a3630');
for(var fx=0;fx<15;fx++){R(fx*60,360,58,58,(fx%2)?'#332e28':'#3e3a32');}
for(var fx2=0;fx2<15;fx2++){R(fx2*60+30,418,58,58,(fx2%2)?'#3e3a32':'#332e28');}

// Stall partition walls
R(0,0,60,H,'#706858');R(840,0,60,H,'#706858');
cx.globalAlpha=0.1;R(0,0,60,H,'#000');R(840,0,60,H,'#000');cx.globalAlpha=1;
R(58,0,4,H,'#5a5040');R(838,0,4,H,'#5a5040');

// Mold and stains
cx.globalAlpha=0.12;
R(70,40,60,50,'#2a3a2a');R(720,80,50,40,'#2a3a2a');
R(350,20,3,80,'#444');R(600,30,2,70,'#444');
cx.globalAlpha=1;

// Graffiti
cx.globalAlpha=0.4;
cx.font='bold 8px monospace';cx.textAlign='center';cx.fillStyle='#664433';
cx.fillText('FLUSH ME',450,60);
cx.font='6px monospace';cx.fillStyle='#446644';
cx.fillText('do it. I dare you.',450,80);
cx.font='italic 5px monospace';cx.fillStyle='#555';
cx.fillText('3x = magic',460,100);
cx.textAlign='center';cx.globalAlpha=1;

// === TOILET ===
var toiletX=450,toiletY=320;
// Base/pedestal
R(toiletX-30,toiletY+20,60,40,'#d4d0c8');
R(toiletX-28,toiletY+22,56,36,'#e0dcd4');
// Bowl
cx.beginPath();cx.ellipse(toiletX,toiletY+10,35,20,0,0,Math.PI*2);
cx.fillStyle='#d8d4cc';cx.fill();
cx.strokeStyle='#aaa8a0';cx.lineWidth=1.5;cx.stroke();
// Inner bowl — water level rises with flushes
var waterLevel=fb.middleFlushes;
var innerColor=waterLevel>=2?'#6699bb':'#88aacc';
cx.beginPath();cx.ellipse(toiletX,toiletY+10,28,14,0,0,Math.PI*2);
cx.fillStyle=innerColor;cx.fill();
// Water surface shimmer
var shm=Math.sin(now*0.003)*2;
cx.globalAlpha=0.3;
cx.beginPath();cx.ellipse(toiletX+shm,toiletY+8,20,8,0,0,Math.PI*2);
cx.fillStyle='#aaddee';cx.fill();cx.globalAlpha=1;
// Tank behind
R(toiletX-25,toiletY-50,50,55,'#ccc8c0');
R(toiletX-23,toiletY-48,46,51,'#d8d4cc');
// Flush handle
R(toiletX+22,toiletY-30,18,4,'#999');C(toiletX+40,toiletY-30,3,'#aaa');
// Stains on bowl
cx.globalAlpha=0.15;
R(toiletX-20,toiletY+15,12,8,'#886644');
R(toiletX+10,toiletY+18,8,6,'#776633');
cx.globalAlpha=1;
// Seat (up, leaning against tank)
R(toiletX-22,toiletY-50,44,6,'#ccc8c0');

// Water puddle on floor (grows with flushes)
if(fb.middleFlushes>=1){
  var puddleSize=10+fb.middleFlushes*20;
  cx.globalAlpha=0.3;
  cx.beginPath();cx.ellipse(toiletX,toiletY+65,puddleSize,puddleSize*0.3,0,0,Math.PI*2);
  cx.fillStyle='#4488bb';cx.fill();cx.globalAlpha=1;
}
if(fb.middleFlushes>=2){
  cx.globalAlpha=0.25;
  cx.beginPath();cx.ellipse(toiletX-40,toiletY+70,25,8,0,0,Math.PI*2);
  cx.fillStyle='#4488bb';cx.fill();cx.globalAlpha=1;
}
if(fb.middleFlooded){
  // Massive flood
  cx.globalAlpha=0.35;
  cx.beginPath();cx.ellipse(toiletX,toiletY+70,120,25,0,0,Math.PI*2);
  cx.fillStyle='#4488bb';cx.fill();
  cx.beginPath();cx.ellipse(toiletX+60,toiletY+75,80,15,0,0,Math.PI*2);
  cx.fillStyle='#5599cc';cx.fill();
  cx.globalAlpha=1;
}

// === TARK ===
cx.save();cx.translate(250,tarkOY);cx.scale(CS,CS);
drawTarkIdle(0,0,false);
cx.restore();

// Hover highlights
if(!fb.middleFlooded){
  if(mouseX>=380&&mouseX<=520&&mouseY>=280&&mouseY<=420){
    cx.strokeStyle='#4488bb';cx.lineWidth=2;cx.strokeRect(415,270,70,100);
    T('FLUSH ('+(fb.middleFlushes)+'/3)',450,265,9,'#4488bb');
  }
}else{
  T('FLOODED',450,265,12,'#4488bb');
}

// === BACK BUTTON ===
var bailHov=mouseX>=20&&mouseX<=140&&mouseY>=440&&mouseY<=470;
R(20,440,120,30,bailHov?'#884422':'#663311');
cx.strokeStyle='#aa7744';cx.lineWidth=1;cx.strokeRect(20,440,120,30);
T('BACK',80,460,12,'#f0e6d3');

cx.globalAlpha=0.3;cx.font='9px monospace';cx.textAlign='right';cx.fillStyle='#666';
cx.fillText('v'+BUILD_V,W-4,H-4);cx.textAlign='center';cx.globalAlpha=1;
}

// --- RIGHT STALL INTERIOR (paper towel + gross toilet) ---

function drawRightStallInterior(){
var CS=1.3,GY=468;
var tarkOY=GY-Math.round(72*CS);
var fb=S.beach;
var now=Date.now();

// === BACK WALL — grimy tile grid ===
R(0,0,W,H,'#8a8278');
for(var ty=0;ty<18;ty++){for(var tx=0;tx<45;tx++){
  var tc=(tx+ty)%2===0?'#9a9688':'#8f8b78';
  if((tx*7+ty*13)%31===0)tc='#7a7668';
  R(tx*20,ty*20,19,19,tc);
}}
cx.strokeStyle='#5a5648';cx.lineWidth=0.5;
for(var gy2=0;gy2<=18;gy2++){cx.beginPath();cx.moveTo(0,gy2*20);cx.lineTo(W,gy2*20);cx.stroke();}
for(var gx2=0;gx2<=45;gx2++){cx.beginPath();cx.moveTo(gx2*20,0);cx.lineTo(gx2*20,360);cx.stroke();}

// Floor — dark filthy tile
R(0,360,W,120,'#3a3630');
for(var fx=0;fx<15;fx++){R(fx*60,360,58,58,(fx%2)?'#332e28':'#3e3a32');}
for(var fx2=0;fx2<15;fx2++){R(fx2*60+30,418,58,58,(fx2%2)?'#3e3a32':'#332e28');}

// Stall partition walls
R(0,0,60,H,'#706858');R(840,0,60,H,'#706858');
cx.globalAlpha=0.1;R(0,0,60,H,'#000');R(840,0,60,H,'#000');cx.globalAlpha=1;
R(58,0,4,H,'#5a5040');R(838,0,4,H,'#5a5040');

// Mold
cx.globalAlpha=0.12;
R(70,40,60,50,'#2a3a2a');R(720,80,50,40,'#2a3a2a');
R(200,10,2,90,'#444');R(550,30,2,70,'#444');
cx.globalAlpha=1;

// Graffiti
cx.globalAlpha=0.4;
cx.font='bold 7px monospace';cx.textAlign='left';cx.fillStyle='#555';
cx.fillText('PREVIOUS OCCUPANT:',300,55);
cx.font='6px monospace';cx.fillStyle='#664433';
cx.fillText('smelled like defeat',310,70);
cx.font='italic 5px monospace';cx.fillStyle='#554444';
cx.fillText('and tuna',360,85);
cx.textAlign='center';cx.globalAlpha=1;

// === PAPER TOWEL DISPENSER (left wall) ===
R(120,100,120,65,'#8a8a8a');
R(122,102,116,61,'#999');
cx.strokeStyle='#666';cx.lineWidth=1;cx.strokeRect(120,100,120,65);
C(128,108,2,'#777');C(232,108,2,'#777');C(128,158,2,'#777');C(232,158,2,'#777');
cx.globalAlpha=0.5;cx.font='bold 5px monospace';cx.textAlign='center';cx.fillStyle='#444';
cx.fillText('PAPER TOWELS',180,125);cx.textAlign='center';cx.globalAlpha=1;
R(150,160,60,6,'#333');
cx.globalAlpha=0.15;R(140,115,30,20,'#555');cx.globalAlpha=1;

// Hanging paper towel
var paperLen=fb.rightPaperPulls*22;
var pullExtra=fb.rightPaperPulling?Math.sin(fb.rightPaperPullT*Math.PI)*18:0;
var totalPaper=paperLen+pullExtra;
if(totalPaper>0){
  var maxHang=200;
  var hangLen=Math.min(totalPaper,maxHang);
  R(162,166,36,hangLen,'#f5f0e8');
  cx.globalAlpha=0.06;R(162,166,36,hangLen,'#000');cx.globalAlpha=1;
  for(var te=0;te<6;te++){R(162+te*6,166+hangLen-3,5,4,'#e8e0d0');}
  if(fb.rightPaperPulling){
    var sway=Math.sin(fb.rightPaperPullT*12)*3;
    R(162+sway,166+hangLen*0.7,36,hangLen*0.3,'#f0ebe0');
  }
}
// Paper pile on floor (after 7 pulls)
if(fb.rightPaperPulls>7){
  for(var pi=0;pi<fb.rightPaperPulls-7;pi++){
    var px=100+pi*18+(pi%2)*12;
    var py=388+pi*3;
    cx.globalAlpha=0.85;
    cx.save();cx.translate(px+15,py+4);cx.rotate((pi%3-1)*0.2);
    R(-14,-4,28+pi*2,8+pi,'#f0ebe0');
    cx.restore();cx.globalAlpha=1;
  }
}
if(fb.rightPaperEmpty){
  cx.globalAlpha=0.4;T('EMPTY',180,140,10,'#cc2222');cx.globalAlpha=1;
}

// === GROSS CLOGGED TOILET (right side) ===
var gtX=650,gtY=310;
// Base
R(gtX-30,gtY+20,60,40,'#c8c4b8');
R(gtX-28,gtY+22,56,36,'#d0ccbf');
// Bowl — stained brown
cx.beginPath();cx.ellipse(gtX,gtY+10,35,20,0,0,Math.PI*2);
cx.fillStyle='#b8b0a0';cx.fill();
cx.strokeStyle='#8a8478';cx.lineWidth=1.5;cx.stroke();
// Inner — brown murky water with visible clog
cx.beginPath();cx.ellipse(gtX,gtY+10,28,14,0,0,Math.PI*2);
cx.fillStyle='#7a6644';cx.fill();
// Clog (visible mass)
cx.beginPath();cx.ellipse(gtX+3,gtY+12,12,8,0.2,0,Math.PI*2);
cx.fillStyle='#5a4422';cx.fill();
cx.globalAlpha=0.3;
cx.beginPath();cx.ellipse(gtX-5,gtY+8,8,5,0,0,Math.PI*2);
cx.fillStyle='#443311';cx.fill();cx.globalAlpha=1;
// Tank
R(gtX-25,gtY-50,50,55,'#bbb8ac');
R(gtX-23,gtY-48,46,51,'#c8c4b8');
// Flush handle
R(gtX+22,gtY-30,18,4,'#888');C(gtX+40,gtY-30,3,'#999');
// Heavy stains
cx.globalAlpha=0.2;
R(gtX-25,gtY+10,15,15,'#664422');R(gtX+12,gtY+15,10,10,'#553311');
R(gtX-18,gtY+25,50,8,'#5a4422');
cx.globalAlpha=1;
// Seat (down, stained)
cx.beginPath();cx.ellipse(gtX,gtY+6,32,16,0,0,Math.PI*2);
cx.fillStyle='#c0b8a8';cx.fill();cx.strokeStyle='#8a8478';cx.lineWidth=1;cx.stroke();
cx.globalAlpha=0.15;
cx.beginPath();cx.ellipse(gtX-8,gtY+4,10,6,0,0,Math.PI*2);
cx.fillStyle='#664422';cx.fill();cx.globalAlpha=1;

// Stuffed paper visible in toilet
if(fb.toiletStuffed){
  cx.globalAlpha=0.7;
  cx.beginPath();cx.ellipse(gtX+2,gtY+8,14,8,0.1,0,Math.PI*2);
  cx.fillStyle='#e8e0d0';cx.fill();cx.globalAlpha=1;
}
// Flushed aftermath — brown water overflowing
if(fb.rightToiletFlushed){
  cx.globalAlpha=0.35;
  cx.beginPath();cx.ellipse(gtX,gtY+65,50,12,0,0,Math.PI*2);
  cx.fillStyle='#6a5533';cx.fill();
  cx.beginPath();cx.ellipse(gtX+30,gtY+70,30,8,0,0,Math.PI*2);
  cx.fillStyle='#7a6644';cx.fill();
  cx.globalAlpha=1;
}

// Puddle near toilet
cx.globalAlpha=0.2;
cx.beginPath();cx.ellipse(gtX-20,gtY+55,30,8,0,0,Math.PI*2);
cx.fillStyle='#7a6644';cx.fill();cx.globalAlpha=1;

// === TARK ===
if(fb.rightPaperPulling){
  fb.rightPaperPullT+=0.015;
  if(fb.rightPaperPullT>=1){
    fb.rightPaperPulling=false;fb.rightPaperPullT=0;
    fb.rightPaperPulls++;
    if(fb.rightPaperPulls>=12){
      fb.rightPaperEmpty=true;
      float('EMPTY!',180,190,'#ff4444',12);
      log("The dispenser is empty. Paper towels everywhere.","info");
    }else{
      var tMsgs=['*riiip*','More paper...','Still going.','What a mess.','Paper on the floor now.',
        'This is getting ridiculous.','Almost out.','Tark keeps pulling.','Why though?',
        'The pile grows.','Nearly empty...'];
      float('PULL ('+(fb.rightPaperPulls+1)+'/12)',180,185,'#ff6b35',9);
      log(tMsgs[Math.min(fb.rightPaperPulls,tMsgs.length-1)],"info");
      try{SFX.plateClack();}catch(e){}
    }
  }
  // Tark near dispenser
  cx.save();cx.translate(220,tarkOY);cx.scale(CS,CS);
  S._hideRightArm=true;
  drawTarkIdle(0,0,false);
  S._hideRightArm=false;
  var armAngle=-1.2+fb.rightPaperPullT*1.8;
  cx.save();cx.translate(14,-6);cx.rotate(armAngle);
  R(0,0,10,30,'#d4a574');C(5,30,5,'#d4a574');
  cx.restore();
  cx.restore();
}else{
  cx.save();cx.translate(420,tarkOY);cx.scale(CS,CS);
  drawTarkIdle(0,0,false);
  cx.restore();
}

// === HOVER HIGHLIGHTS ===
if(!fb.rightPaperPulling){
  // Paper towel dispenser
  if(mouseX>=110&&mouseX<=250&&mouseY>=90&&mouseY<=175&&fb.rightPaperPulls<12){
    cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(115,95,130,75);
    T('PULL',180,185,10,'#ff6b35');
  }
  // Paper pile — pocket it (after empty, before pocketed)
  if(fb.rightPaperEmpty&&!fb.hasPaper&&mouseX>=80&&mouseX<=230&&mouseY>=380&&mouseY<=420){
    cx.strokeStyle='#ffcc00';cx.lineWidth=2;cx.strokeRect(80,380,150,40);
    T('POCKET PAPER',155,375,9,'#ffcc00');
  }
  // Gross toilet — stuff it (after hasPaper, before stuffed)
  if(fb.hasPaper&&!fb.toiletStuffed&&mouseX>=580&&mouseX<=720&&mouseY>=280&&mouseY<=420){
    cx.strokeStyle='#884422';cx.lineWidth=2;cx.strokeRect(615,260,70,110);
    T('STUFF PAPER',650,255,9,'#884422');
  }
  // Flush stuffed toilet
  if(fb.toiletStuffed&&!fb.rightToiletFlushed&&mouseX>=580&&mouseX<=720&&mouseY>=280&&mouseY<=420){
    cx.strokeStyle='#884422';cx.lineWidth=2;cx.strokeRect(615,260,70,110);
    T('FLUSH',650,255,9,'#884422');
  }
}

// === BACK BUTTON ===
var bailHov=mouseX>=20&&mouseX<=140&&mouseY>=440&&mouseY<=470;
R(20,440,120,30,bailHov?'#884422':'#663311');
cx.strokeStyle='#aa7744';cx.lineWidth=1;cx.strokeRect(20,440,120,30);
T('BACK',80,460,12,'#f0e6d3');

cx.globalAlpha=0.3;cx.font='9px monospace';cx.textAlign='right';cx.fillStyle='#666';
cx.fillText('v'+BUILD_V,W-4,H-4);cx.textAlign='center';cx.globalAlpha=1;
}

// --- SEWER HUB (underground, accessed from bathroom stall hole) ---

function drawSewerHub(){
var CS=1.3,GY=460;
var tarkOY=GY-Math.round(72*CS);
var t=Date.now()*0.001;

// === BACKGROUND ===
R(0,0,W,H,'#1a1812');

// === ARCHED BRICK CEILING ===
cx.save();
cx.beginPath();cx.arc(450,300,320,Math.PI,0);cx.clip();
for(var by=0;by<20;by++){for(var bx=0;bx<30;bx++){
  var bc2=(bx+by)%3===0?'#3a3028':(bx+by)%3===1?'#342c22':'#2e2820';
  if((bx*7+by*11)%17===0)bc2='#262018';
  R(bx*32+(by%2)*16,-20+by*16,30,14,bc2);
}}
cx.strokeStyle='#1a1610';cx.lineWidth=0.5;
for(var my=0;my<20;my++){cx.beginPath();cx.moveTo(0,-20+my*16);cx.lineTo(W,-20+my*16);cx.stroke();}
for(var mx=0;mx<30;mx++){cx.beginPath();cx.moveTo(mx*32,-20);cx.lineTo(mx*32,300);cx.stroke();}
cx.restore();

// === BACK WALL (y=220-300) ===
R(0,220,W,80,'#252018');
for(var wy=0;wy<3;wy++){for(var wx2=0;wx2<15;wx2++){
  var wc=(wx2+wy)%2===0?'#2a2620':'#222018';
  R(wx2*62+(wy%2)*31,222+wy*26,60,24,wc);
}}

// === LEFT TUNNEL — green glow, mossy, broken EXIT sign ===
var ltG=cx.createRadialGradient(130,180,5,130,180,60);
ltG.addColorStop(0,'#0a1a0a');ltG.addColorStop(1,'#1a2a1a');
cx.fillStyle=ltG;
cx.beginPath();cx.arc(130,220,60,Math.PI,0);cx.lineTo(190,220);cx.lineTo(70,220);cx.closePath();cx.fill();
R(70,160,120,60,'#0a1a0a');
// Moss
cx.globalAlpha=0.15;R(75,130,8,70,'#2a4a2a');R(170,140,6,60,'#2a4a2a');R(120,125,10,50,'#1a3a1a');cx.globalAlpha=1;
// Broken EXIT sign
R(95,108,70,14,'#1a3a1a');cx.strokeStyle='#224422';cx.lineWidth=1;cx.strokeRect(95,108,70,14);
cx.globalAlpha=0.7;T('EXI--',130,119,8,'#44ff44');cx.globalAlpha=1;
// Green glow
cx.globalAlpha=0.08;
var glG=cx.createRadialGradient(130,180,10,130,180,80);
glG.addColorStop(0,'#44ff44');glG.addColorStop(1,'rgba(0,0,0,0)');
cx.fillStyle=glG;cx.fillRect(50,100,160,140);cx.globalAlpha=1;

// === CENTER TUNNEL — amber glow, deeper, "?" graffiti ===
var ctG=cx.createRadialGradient(450,170,5,450,170,90);
ctG.addColorStop(0,'#0a0800');ctG.addColorStop(1,'#1a1408');
cx.fillStyle=ctG;
cx.beginPath();cx.arc(450,220,90,Math.PI,0);cx.lineTo(540,220);cx.lineTo(360,220);cx.closePath();cx.fill();
R(360,140,180,80,'#0a0800');
// Depth rings
cx.strokeStyle='#2a2418';cx.lineWidth=2;cx.beginPath();cx.arc(450,220,70,Math.PI,0);cx.stroke();
cx.strokeStyle='#1a1810';cx.lineWidth=1.5;cx.beginPath();cx.arc(450,220,50,Math.PI,0);cx.stroke();
cx.strokeStyle='#141008';cx.lineWidth=1;cx.beginPath();cx.arc(450,220,30,Math.PI,0);cx.stroke();
// Amber glow
cx.globalAlpha=0.06;
var amG=cx.createRadialGradient(450,170,5,450,170,100);
amG.addColorStop(0,'#ffaa44');amG.addColorStop(1,'rgba(0,0,0,0)');
cx.fillStyle=amG;cx.fillRect(350,60,200,180);cx.globalAlpha=1;
// "?" graffiti
cx.globalAlpha=0.4;T('?',450,150,28,'#aa8833');cx.globalAlpha=1;
// Distant light
cx.globalAlpha=0.25;C(450,195,3,'#aa8844');cx.globalAlpha=1;

// === RIGHT TUNNEL — red glow, danger tape, steam ===
var rtG=cx.createRadialGradient(770,180,5,770,180,60);
rtG.addColorStop(0,'#1a0a0a');rtG.addColorStop(1,'#2a1010');
cx.fillStyle=rtG;
cx.beginPath();cx.arc(770,220,60,Math.PI,0);cx.lineTo(830,220);cx.lineTo(710,220);cx.closePath();cx.fill();
R(710,160,120,60,'#1a0a0a');
// Danger tape
cx.save();cx.translate(770,160);cx.rotate(-0.3);
for(var dt=0;dt<4;dt++){R(-50+dt*28,-20,14,80,(dt%2)?'#111':'#ccaa00');}
cx.restore();
// Cracked pipe + steam
R(740,95,10,60,'#555');R(743,92,4,8,'#777');R(735,130,6,4,'#444');
cx.globalAlpha=0.2;
C(742,88+Math.sin(t*2)*4,5,'#aaa');C(738,78+Math.sin(t*2+1)*3,4,'#999');C(746,70+Math.sin(t*2+2)*5,3,'#888');
cx.globalAlpha=1;
// Red glow
cx.globalAlpha=0.06;
var rdG=cx.createRadialGradient(770,170,5,770,170,80);
rdG.addColorStop(0,'#ff2222');rdG.addColorStop(1,'rgba(0,0,0,0)');
cx.fillStyle=rdG;cx.fillRect(690,90,160,150);cx.globalAlpha=1;

// === HORIZONTAL PIPES ===
R(0,78,W,12,'#4a4a4a');R(0,78,W,3,'#666');R(0,87,W,1,'#333');
R(198,78,10,40,'#555');R(648,78,10,40,'#555');
R(195,76,16,4,'#666');R(645,76,16,4,'#666');R(195,116,16,4,'#666');R(645,116,16,4,'#666');

// === WALKWAYS ===
R(0,300,316,180,'#3a3630');
for(var sy=0;sy<6;sy++){for(var sx2=0;sx2<6;sx2++){
  R(sx2*55+(sy%2)*28,302+sy*30,53,28,(sx2+sy)%2===0?'#44403a':'#3e3a32');
}}
R(0,300,316,2,'#555');R(314,300,4,180,'#2a2620');
R(582,300,318,180,'#3a3630');
for(var sy2=0;sy2<6;sy2++){for(var sx3=0;sx3<6;sx3++){
  R(584+sx3*55+(sy2%2)*28,302+sy2*30,53,28,(sx3+sy2)%2===0?'#44403a':'#3e3a32');
}}
R(582,300,318,2,'#555');R(580,300,4,180,'#2a2620');

// === WATER CHANNEL ===
R(318,300,264,180,'#0e2a3a');
cx.strokeStyle='#1a4455';cx.lineWidth=1;
for(var wi=0;wi<6;wi++){
  cx.globalAlpha=0.4+wi*0.05;cx.beginPath();
  for(var wx=318;wx<582;wx+=3){
    var wy2=310+wi*25+Math.sin(t*2.5+wx*0.025+wi*0.8)*4;
    if(wx===318)cx.moveTo(wx,wy2);else cx.lineTo(wx,wy2);
  }
  cx.stroke();
}
cx.globalAlpha=1;
// Ripple highlights
cx.strokeStyle='#2a6677';cx.lineWidth=0.5;
for(var rh=0;rh<3;rh++){
  cx.globalAlpha=0.15;cx.beginPath();
  for(var rx=318;rx<582;rx+=4){
    var ry=320+rh*40+Math.sin(t*3+rx*0.04+rh*2)*2;
    if(rx===318)cx.moveTo(rx,ry);else cx.lineTo(rx,ry);
  }
  cx.stroke();
}
cx.globalAlpha=1;
// Floating debris
var d1x=318+((t*18)%264);
var d2x=582-((t*12+80)%264);
var d3x=318+((t*15+150)%264);
R(d1x,340,14,2,'#5a4a3a');
R(d2x,370,6,5,'#777');R(d2x+1,369,4,2,'#999');
C(d3x,395,3,'#2a4a2a');
// Water edge foam
cx.globalAlpha=0.15;
for(var fe=0;fe<20;fe++){
  var fex=318+fe*14+Math.sin(t+fe)*3;
  R(fex,300,8,3,'#667766');
}
cx.globalAlpha=1;

// === DRIPPING WATER ===
var dripXs=[200,500,650];
var dripPhases=[0,1.7,3.2];
for(var di=0;di<3;di++){
  var ddx=dripXs[di],dPhase=dripPhases[di];
  var dripCycle=(t*1.2+dPhase)%2;
  if(dripCycle<1.5){
    var dy=90+dripCycle*140;
    cx.globalAlpha=0.5;C(ddx,dy,2,'#4488bb');cx.globalAlpha=1;
  }else{
    var splashT2=(dripCycle-1.5)/0.5;
    cx.globalAlpha=0.3*(1-splashT2);cx.strokeStyle='#4488bb';cx.lineWidth=1;
    cx.beginPath();cx.arc(ddx,300,splashT2*8,0,Math.PI*2);cx.stroke();cx.globalAlpha=1;
  }
  if(dripCycle>1.8||dripCycle<0.3){cx.globalAlpha=0.3;C(ddx,89,1.5,'#4488bb');cx.globalAlpha=1;}
}

// === RATS ===
var rat1x=80+Math.sin(t*0.5)*10;
R(rat1x,430,12,6,'#4a4040');C(rat1x+13,432,3,'#4a4040');C(rat1x+14,431,1,'#ff4444');
C(rat1x+11,429,1.5,'#5a5050');C(rat1x+13,429,1.5,'#5a5050');
cx.strokeStyle='#5a5050';cx.lineWidth=1;cx.beginPath();cx.moveTo(rat1x,433);cx.quadraticCurveTo(rat1x-10,425,rat1x-15,431);cx.stroke();
R(rat1x+2,435,2,3,'#3a3030');R(rat1x+8,435,2,3,'#3a3030');
var rat2x=620+Math.sin(t*0.8+2)*6;
R(rat2x,350,8,4,'#3a3535');C(rat2x+9,351,2,'#3a3535');C(rat2x+10,350,0.7,'#cc3333');
cx.strokeStyle='#4a4545';cx.lineWidth=0.8;cx.beginPath();cx.moveTo(rat2x,352);cx.quadraticCurveTo(rat2x-6,346,rat2x-9,351);cx.stroke();

// === LADDER (back to stall) ===
R(830,160,4,240,'#8a7040');R(858,160,4,240,'#8a7040');
for(var ri=0;ri<7;ri++){R(832,180+ri*32,28,4,'#7a6030');cx.globalAlpha=0.1;R(832,184+ri*32,28,2,'#000');cx.globalAlpha=1;}
cx.globalAlpha=0.08;
var ladG=cx.createRadialGradient(844,160,5,844,160,50);
ladG.addColorStop(0,'#ffffff');ladG.addColorStop(1,'rgba(0,0,0,0)');
cx.fillStyle=ladG;cx.fillRect(810,120,70,80);cx.globalAlpha=1;
cx.beginPath();cx.ellipse(844,158,18,8,0,0,Math.PI*2);cx.fillStyle='#4a4638';cx.fill();
cx.beginPath();cx.ellipse(844,158,15,6,0,0,Math.PI*2);cx.fillStyle='#222';cx.fill();

// === GRAFFITI ===
cx.globalAlpha=0.25;cx.font='bold 7px monospace';cx.textAlign='left';
cx.fillStyle='#555';cx.fillText('TARK WAS HERE',40,340);
cx.fillStyle='#664433';cx.fillText('SNATCH OR DIE',620,330);
cx.fillStyle='#446644';cx.fillText('LIFT HEAVY',160,380);
cx.font='italic 5px monospace';cx.fillStyle='#554444';cx.fillText('no one can hear you clean',380,250);
cx.textAlign='center';cx.globalAlpha=1;

// === ATMOSPHERE — vignette ===
cx.globalAlpha=0.12;R(0,0,W,H,'#000');cx.globalAlpha=1;
var vigG=cx.createRadialGradient(450,280,100,450,280,500);
vigG.addColorStop(0,'rgba(0,0,0,0)');vigG.addColorStop(1,'rgba(0,0,0,0.2)');
cx.fillStyle=vigG;cx.fillRect(0,0,W,H);

// === TARK ===
cx.save();cx.translate(250,tarkOY);cx.scale(CS,CS);
drawTarkIdle(0,0,false);
cx.restore();

// === HOVER HIGHLIGHTS ===
if(!S.busy){
  if(mouseX>=70&&mouseX<=190&&mouseY>=100&&mouseY<=220){
    cx.strokeStyle='#44ff44';cx.lineWidth=2;cx.strokeRect(70,100,120,120);
    T('LEFT TUNNEL',130,235,9,'#44ff44');
  }
  if(mouseX>=360&&mouseX<=540&&mouseY>=60&&mouseY<=220){
    cx.strokeStyle='#ffaa44';cx.lineWidth=2;cx.strokeRect(360,60,180,160);
    T('CENTER TUNNEL',450,235,9,'#ffaa44');
  }
  if(mouseX>=710&&mouseX<=830&&mouseY>=100&&mouseY<=220){
    cx.strokeStyle='#ff4444';cx.lineWidth=2;cx.strokeRect(710,100,120,120);
    T('RIGHT TUNNEL',770,235,9,'#ff4444');
  }
  if(mouseX>=815&&mouseX<=865&&mouseY>=160&&mouseY<=400){
    cx.strokeStyle='#ffcc00';cx.lineWidth=2;cx.strokeRect(815,155,55,250);
    T('CLIMB UP',844,415,9,'#ffcc00');
  }
}

// === BACK BUTTON ===
var bailHov=mouseX>=20&&mouseX<=140&&mouseY>=440&&mouseY<=470;
R(20,440,120,30,bailHov?'#884422':'#663311');
cx.strokeStyle='#aa7744';cx.lineWidth=1;cx.strokeRect(20,440,120,30);
T('CLIMB UP',80,460,12,'#f0e6d3');
cx.globalAlpha=0.3;cx.font='9px monospace';cx.textAlign='right';cx.fillStyle='#666';
cx.fillText('v'+BUILD_V,W-4,H-4);cx.textAlign='center';cx.globalAlpha=1;
}

// --- SEWER TUNNEL PLACEHOLDER ---

function drawSewerTunnel(which){
var CS=1.3,GY=460;
var tarkOY=GY-Math.round(72*CS);
var t=Date.now()*0.001;
R(0,0,W,H,'#111008');
// Brick texture hint
for(var ty=0;ty<24;ty++){for(var tx=0;tx<30;tx++){
  var tc2=(tx+ty)%3===0?'#1e1a14':'#1a1610';
  R(tx*32+(ty%2)*16,ty*20,30,18,tc2);
}}
var names={sewer_left:'LEFT TUNNEL',sewer_center:'CENTER TUNNEL',sewer_right:'RIGHT TUNNEL'};
var colors={sewer_left:'#44ff44',sewer_center:'#ffaa44',sewer_right:'#ff4444'};
T(names[which]||'TUNNEL',450,180,22,colors[which]||'#fff');
T('(COMING SOON)',450,220,11,'#555');
// Water on floor
R(0,360,W,120,'#0e2a3a');
cx.strokeStyle='#1a4455';cx.lineWidth=1;
for(var wi=0;wi<4;wi++){
  cx.globalAlpha=0.3;cx.beginPath();
  for(var wx=0;wx<W;wx+=4){
    var wy2=370+wi*22+Math.sin(t*2+wx*0.03+wi)*3;
    if(wx===0)cx.moveTo(wx,wy2);else cx.lineTo(wx,wy2);
  }
  cx.stroke();
}
cx.globalAlpha=1;
// Tark
cx.save();cx.translate(450,tarkOY-10);cx.scale(CS,CS);
drawTarkIdle(0,0,false);cx.restore();
// Back button
var bailHov=mouseX>=20&&mouseX<=140&&mouseY>=440&&mouseY<=470;
R(20,440,120,30,bailHov?'#884422':'#663311');
cx.strokeStyle='#aa7744';cx.lineWidth=1;cx.strokeRect(20,440,120,30);
T('BACK',80,460,12,'#f0e6d3');
cx.globalAlpha=0.3;cx.font='9px monospace';cx.textAlign='right';cx.fillStyle='#666';
cx.fillText('v'+BUILD_V,W-4,H-4);cx.textAlign='center';cx.globalAlpha=1;
}

// --- BEACH SCENE (main render) ---

function drawBoardwalkScene(){
var bw=S.boardwalk;if(!bw)return;
var t=Date.now()*0.001;

// ================================================================
// GAME LOGIC
// ================================================================
if(bw.phase==='intro'){
  bw.introTimer--;
  // Start reaching into garbage near end of intro
  if(bw.introTimer===50){bw.tarkPose='reaching';bw.reachTimer=40;}
  if(bw.introTimer<=0){bw.phase='playing';if(bw.tarkPose==='reaching'){bw.tarkPose='holding';}unlock();}
}

// Spawn cyclists continuously — keep coming until all throws used and last projectile lands
if(bw.phase==='intro'||bw.phase==='playing'){
  // Only spawn if game is still active (throws remaining or projectile in flight)
  if(bw.throwsLeft>0||bw.throwing||bw.phase==='intro'){
    bw.spawnTimer--;
    if(bw.spawnTimer<=0){
      var skinnyJeans=['#222233','#1a1a2a','#2a2233','#332222'];
      var flannel=['#cc4444','#44aa44','#aa6633','#336699','#995533','#558844'];
      var dir=Math.random()<0.5?1:-1;
      var spd=0.8+Math.random()*1.2; // 0.8-2.0 px/frame
      var shirt=flannel[Math.floor(Math.random()*flannel.length)];
      var pants=skinnyJeans[Math.floor(Math.random()*skinnyJeans.length)];
      var hipster={
        manBun:Math.random()<0.5,beanie:Math.random()<0.4,
        beard:Math.random()<0.6,glasses:Math.random()<0.5,
        messenger:Math.random()<0.4,fixie:true,
        shirtColor:shirt,pantsColor:pants
      };
      bw.cyclists.push({x:dir===1?-50:950,y:196+Math.random()*10,vx:spd*dir,color:shirt,label:'hipster',wheelR:10,hit:false,falling:false,fallT:0,pedalT:Math.random()*6.28,hipster:hipster});
      bw.spawnTimer=210+Math.floor(Math.random()*120); // 3.5-5.5 seconds between spawns
      bw.totalCyclists++;
    }
  }
}

// Update cyclists
for(var ci=bw.cyclists.length-1;ci>=0;ci--){
  var cyc=bw.cyclists[ci];
  if(!cyc.hit&&!cyc.falling){
    cyc.x+=cyc.vx;
    cyc.pedalT+=Math.abs(cyc.vx)*0.1;
    if(cyc.x<-60||cyc.x>960){bw.cyclists.splice(ci,1);continue;}
  }
  if(cyc.falling&&!cyc.wrecked){cyc.fallT+=0.015;if(cyc.fallT>=1){cyc.wrecked=true;cyc.wreckY=240+Math.random()*40;cyc.wreckX=cyc.x+(cyc.vx>0?1:-1)*(20+Math.random()*30);cyc.twitchT=0;}}
  if(cyc.wrecked){cyc.twitchT+=0.05;}
}

// Update projectile in flight (SLOW arc — ~120 frames / 2 seconds)
if(bw.throwing&&bw.projectile){
  var proj=bw.projectile;
  proj.progress+=proj.speed; // speed ~0.008 = ~125 frames
  proj.spin+=0.15;
  var p=proj.progress;
  proj.x=proj.startX+(proj.targetX-proj.startX)*p;
  // High parabolic arc: peaks at ~160px above midpoint
  var arcH=-160*4*p*(1-p);
  proj.y=proj.startY+(proj.targetY-proj.startY)*p+arcH;
  // Shadow on ground tracks X position
  proj.shadowX=proj.x;
  proj.shadowY=proj.targetY+12;

  // Check for hit when projectile is in landing zone (last 15% of arc)
  if(p>=0.85){
    for(var hi=0;hi<bw.cyclists.length;hi++){
      var hc=bw.cyclists[hi];
      if(hc.hit||hc.falling)continue;
      var dx=proj.x-hc.x,dy=proj.y-hc.y;
      if(Math.sqrt(dx*dx+dy*dy)<30){
        hc.hit=true;hc.falling=true;hc.fallT=0;
        bw.hits++;bw.throwing=false;bw.projectile=null;
        bw.tarkPose='celebrating';bw.celebTimer=50;
        // Crash debris
        var parts=[];
        parts.push({x:hc.x-8,y:hc.y,vx:-3+Math.random()*2,vy:-4-Math.random()*3,type:'wheel'});
        parts.push({x:hc.x+8,y:hc.y,vx:2+Math.random()*2,vy:-3-Math.random()*2,type:'wheel'});
        parts.push({x:hc.x,y:hc.y-4,vx:-1+Math.random()*2,vy:-5-Math.random()*2,type:'frame',color:'#666'});
        parts.push({x:hc.x-4,y:hc.y-10,vx:-2,vy:-6,type:'body',color:'#d4a574'});
        parts.push({x:hc.x,y:hc.y,vx:Math.random()*2-1,vy:-2,type:'item',color:proj.color||'#888'});
        bw.crashes.push({x:hc.x,y:hc.y,timer:80,parts:parts});
        try{SFX.metalClang();}catch(e){}
        float('+HIT!',hc.x,hc.y-30,'#ff6b35',14);
        break;
      }
    }
  }
  // Miss — projectile lands on boardwalk
  if(p>=1.0&&bw.throwing){
    bw.throwing=false;bw.projectile=null;
    if(bw.throwsLeft>0){bw.tarkPose='reaching';bw.reachTimer=40;}else{bw.tarkPose='idle';}
    bw.crashes.push({x:proj.targetX,y:proj.targetY,timer:40,parts:[
      {x:proj.targetX,y:proj.targetY,vx:-1,vy:-2,type:'item',color:proj.color||'#888'},
      {x:proj.targetX+3,y:proj.targetY,vx:1,vy:-1,type:'spark'}
    ]});
    float('MISS',proj.targetX,proj.targetY-20,'#888',10);
    try{SFX.plateClack();}catch(e){}
  }
}

// Throw arm animation timer — arm swings then Tark watches
if(bw.tarkPose==='throwing'){bw.throwAnim+=0.016;if(bw.throwAnim>=0.3){bw.tarkPose='watching';}}
// Celebrate timer
if(bw.tarkPose==='celebrating'){bw.celebTimer--;if(bw.celebTimer<=0){if(bw.throwsLeft>0){bw.tarkPose='reaching';bw.reachTimer=40;}else{bw.tarkPose='idle';}}}
// Reach timer (reaching into garbage)
if(bw.tarkPose==='reaching'){bw.reachTimer--;if(bw.reachTimer<=0){bw.tarkPose='holding';}}

// Update crashes
for(var cri=bw.crashes.length-1;cri>=0;cri--){
  var cr=bw.crashes[cri];cr.timer--;
  for(var pi=0;pi<cr.parts.length;pi++){var pt=cr.parts[pi];pt.x+=pt.vx;pt.y+=pt.vy;pt.vy+=0.25;}
  if(cr.timer<=0)bw.crashes.splice(cri,1);
}

// Auto-end when all throws used and no projectile in flight
if(bw.phase==='playing'&&bw.throwsLeft<=0&&!bw.throwing&&bw.crashes.length===0){bw.phase='ending';bw.endTimer=180;}
if(bw.phase==='ending'){bw.endTimer--;if(bw.endTimer<=0){window.exitBoardwalk();return;}}

// ================================================================
// RENDERING
// ================================================================

// Background — sunset boardwalk scene
var skyG=cx.createLinearGradient(0,0,0,160);
skyG.addColorStop(0,'#1a3a6a');skyG.addColorStop(0.5,'#4488bb');skyG.addColorStop(1,'#ff9955');
cx.fillStyle=skyG;cx.fillRect(0,0,W,160);
cx.globalAlpha=0.6;C(120,50,30,'#ffe866');cx.globalAlpha=0.3;C(120,50,45,'#ffe866');cx.globalAlpha=1;
// Ocean
R(0,130,W,55,'#2266aa');
for(var wi=0;wi<3;wi++){
  cx.strokeStyle='#3388cc';cx.lineWidth=1;cx.beginPath();
  for(var wx=0;wx<W;wx+=5){var wy=140+wi*15+Math.sin(t*1.5+wx*0.02+wi)*3;if(wx===0)cx.moveTo(wx,wy);else cx.lineTo(wx,wy);}
  cx.stroke();
}
// Sand
R(0,185,W,H-185,'#d4b896');
cx.globalAlpha=0.04;for(var sy=187;sy<H;sy+=10)R(0,sy,W,2,'#000');cx.globalAlpha=1;

// Boardwalk (prominent, Y=185-225)
R(0,185,W,40,'#b8956a');
for(var bpi=0;bpi<23;bpi++){R(bpi*40,185,2,40,'#9a7a55');}
cx.globalAlpha=0.05;for(var py2=187;py2<223;py2+=8){R(0,py2,W,2,'#000');}cx.globalAlpha=1;
R(0,222,W,4,'#8a6a4a');
for(var rp=0;rp<11;rp++){R(40+rp*85,218,4,12,'#7a5a3a');}
R(0,218,W,3,'#9a8060');
R(0,184,W,2,'#7a5a3a');

// Click target zone highlight (where projectile will land)
if(bw.phase==='playing'&&!bw.throwing&&bw.throwsLeft>0){
  // Show a faint target line on the boardwalk
  if(mouseY>=170&&mouseY<=230&&mouseX>=180&&mouseX<=850){
    cx.globalAlpha=0.3;
    cx.strokeStyle='#ff6b35';cx.lineWidth=2;
    cx.setLineDash([4,4]);
    cx.beginPath();cx.moveTo(mouseX,190);cx.lineTo(mouseX,220);cx.stroke();
    cx.setLineDash([]);
    // Landing X marker
    C(mouseX,205,4,'rgba(255,107,53,0.4)');
    cx.globalAlpha=1;
  }
}

// Palm trees (framing)
R(30,80,8,140,'#6b4226');R(32,82,4,136,'#7a5030');
R(850,90,8,130,'#6b4226');R(852,92,4,126,'#7a5030');

// Cyclists — hipster doofuses on fixies
for(var ci2=0;ci2<bw.cyclists.length;ci2++){
  var cyc2=bw.cyclists[ci2];
  var h=cyc2.hipster||{};
  var sc=1.4; // scale up 40%
  if(cyc2.wrecked){
    // Wrecked on the sand — sprawled out, twitching
    var wx=cyc2.wreckX,wy=cyc2.wreckY;
    var tw=Math.sin(cyc2.twitchT*3)*2; // twitch
    var tw2=Math.sin(cyc2.twitchT*2.3+1)*1.5;
    var sc2=sc*0.9;
    cx.save();cx.translate(wx,wy);cx.scale(sc2,sc2);
    // Mangled bike nearby
    cx.globalAlpha=0.7;
    R(-25,4,30,2,h.fixie?'#cc6633':'#666'); // bent frame
    cx.strokeStyle='#333';cx.lineWidth=1;
    cx.beginPath();cx.arc(-30,8,6,0,Math.PI*2);cx.stroke(); // wheel 1 bent
    cx.beginPath();cx.arc(-8,6,7,0.5,Math.PI*1.8);cx.stroke(); // wheel 2 taco'd
    R(-20,2,4,6,'#888'); // handlebar sticking up
    cx.globalAlpha=1;
    // Body sprawled face-down, twitching
    cx.rotate(0.15);
    // Legs splayed
    R(8,2+tw,4,14,h.pantsColor||'#222');
    R(14,4-tw*0.5,4,12,h.pantsColor||'#222');
    R(7,14+tw,5,3,'#fff'); // shoe
    R(14,14-tw*0.5,5,3,'#fff'); // shoe
    // Torso
    R(-2,-10+tw2,14,16,h.shirtColor||'#cc4444');
    // Arms out
    R(-10,-6+tw,12,3,'#d4a574'); // left arm sprawled
    R(12,-8-tw2,10,3,'#d4a574'); // right arm
    C(-12,-5+tw,3,'#d4a574'); // left hand
    C(22,-7-tw2,3,'#d4a574'); // right hand
    // Head (face down)
    C(0,-16+tw2,6,'#d4a574');
    if(h.beanie&&!h.manBun){R(-5,-20+tw2,10,5,'#aa3333');} // beanie askew
    if(h.manBun){C(2,-22+tw2,2.5,'#4a3a2a');} // man bun disheveled
    if(h.glasses){R(3,-17+tw2,4,2,'#222');} // glasses knocked off nearby
    // Messenger bag spilled
    if(h.messenger){R(16,-4,7,5,'#8a6a4a');R(20,-2,3,3,'#666');} // bag + contents
    // Spilled coffee
    cx.globalAlpha=0.4;
    cx.beginPath();cx.ellipse(-16,4,8,4,0.3,0,Math.PI*2);cx.fillStyle='#4a2a10';cx.fill();
    cx.globalAlpha=0.8;R(-18,0,4,6,'#fff'); // cup on its side
    cx.globalAlpha=1;
    // Pain stars/indicators
    if(Math.sin(cyc2.twitchT*5)>0.3){
      T('*',5+tw,-22+tw2,8,'#ff4444');
      T('*',-8-tw,-14-tw2,6,'#ff4444');
    }
    cx.restore();
  }else if(cyc2.falling){
    // Tumbling off bike animation
    var ft=cyc2.fallT;
    cx.save();cx.translate(cyc2.x,cyc2.y);cx.scale(sc,sc);
    cx.rotate(ft*2.5*(cyc2.vx>0?1:-1));
    cx.globalAlpha=1-ft*0.3;
    // Bike frame
    R(-14,-4,28,3,h.fixie?'#cc6633':'#666');
    // Wheels flying off
    cx.strokeStyle='#333';cx.lineWidth=1.5;
    cx.beginPath();cx.arc(-12+ft*18,8+ft*30,8,0,Math.PI*2);cx.stroke();
    cx.beginPath();cx.arc(12-ft*12,6+ft*22,8,0,Math.PI*2);cx.stroke();
    // Body tumbling
    R(-5,-22-ft*30,10,18,h.shirtColor||'#cc4444');
    R(-4,0-ft*10,8,12,h.pantsColor||'#222');
    C(0,-28-ft*40,6,'#d4a574');
    // Messenger bag flying
    if(h.messenger){R(4,-14-ft*35,6,8,'#8a6a4a');}
    // Coffee cup flying
    R(-8+ft*20,-30-ft*50,4,6,'#fff');
    cx.globalAlpha=1;cx.restore();
  }else{
    cx.save();cx.translate(cyc2.x,cyc2.y);cx.scale(sc,sc);
    var facing=cyc2.vx>0?1:-1;
    var pedal=Math.sin(cyc2.pedalT)*5;
    // Fixie bike — colored frame, big thin wheels
    // Wheels (fixie = thin tires, big rims)
    cx.strokeStyle='#333';cx.lineWidth=2;
    cx.beginPath();cx.arc(-14*facing,12,9,0,Math.PI*2);cx.stroke();
    cx.beginPath();cx.arc(14*facing,12,9,0,Math.PI*2);cx.stroke();
    // Colored rims
    cx.strokeStyle=h.fixie?'#cc6633':'#888';cx.lineWidth=1;
    cx.beginPath();cx.arc(-14*facing,12,7,0,Math.PI*2);cx.stroke();
    cx.beginPath();cx.arc(14*facing,12,7,0,Math.PI*2);cx.stroke();
    // Spokes
    cx.strokeStyle='#555';cx.lineWidth=0.5;
    for(var sp=0;sp<6;sp++){var sa=t*3+sp*1.047;
      cx.beginPath();cx.moveTo(-14*facing,12);cx.lineTo(-14*facing+Math.cos(sa)*8,12+Math.sin(sa)*8);cx.stroke();
      cx.beginPath();cx.moveTo(14*facing,12);cx.lineTo(14*facing+Math.cos(sa+0.3)*8,12+Math.sin(sa+0.3)*8);cx.stroke();
    }
    // Frame
    R(-14,0,28,3,h.fixie?'#cc6633':'#666');
    // Seat post + tiny hipster seat
    R(-7*facing,-2,2,6,'#555');R(-9*facing,-3,6,2,'#222');
    // Handlebars — drop bars
    R(12*facing,-8,3,10,'#888');
    R(12*facing,-10,6*facing,2,'#888');
    // Skinny jeans legs (pedaling)
    R(-4,2+pedal,4,12,h.pantsColor||'#222');
    R(1,2-pedal,4,12,h.pantsColor||'#222');
    // Shoes — trendy sneakers
    R(-5,12+pedal,6,3,'#fff');R(0,12-pedal,6,3,'#fff');
    // Torso — flannel or band tee
    R(-6,-22,12,20,h.shirtColor||'#cc4444');
    // Rolled up sleeves
    R(-9,-18,4,4,'#d4a574');R(5,-18,4,4,'#d4a574');
    // Arms gripping handlebars
    cx.strokeStyle='#d4a574';cx.lineWidth=2;
    cx.beginPath();cx.moveTo(5,-16);cx.lineTo(12*facing,-6);cx.stroke();
    cx.beginPath();cx.moveTo(-5,-16);cx.lineTo(12*facing,-4);cx.stroke();
    // Messenger bag (slung across)
    if(h.messenger){
      R(-8,-18,16,3,'#6a4a2a');
      R(5,-14,5,10,'#8a6a4a');R(5,-13,4,8,'#7a5a3a');
      R(5,-5,4,2,'#5a3a1a'); // buckle
    }
    // Head
    C(0,-28,7,'#d4a574');
    // Beard
    if(h.beard){
      R(-4,-24,8,5,'#6a4a2a');R(-3,-20,6,3,'#7a5a3a');
      // Handlebar mustache
      cx.strokeStyle='#6a4a2a';cx.lineWidth=1.5;
      cx.beginPath();cx.moveTo(-2,-25);cx.quadraticCurveTo(-6,-23,-7,-26);cx.stroke();
      cx.beginPath();cx.moveTo(2,-25);cx.quadraticCurveTo(6,-23,7,-26);cx.stroke();
    }
    // Man bun
    if(h.manBun){
      C(0,-35,3,'#4a3a2a');C(0,-37,2.5,'#5a4a3a');
      R(-2,-33,4,2,'#4a3a2a'); // bun base
    }
    // Beanie (in summer, of course)
    if(h.beanie&&!h.manBun){
      R(-7,-36,14,8,'#aa3333');R(-6,-37,12,4,'#cc4444');
      R(-5,-38,10,2,'#aa3333');C(0,-39,2,'#aa3333');
    }
    // Glasses (thick frames)
    if(h.glasses){
      cx.strokeStyle='#222';cx.lineWidth=1.5;
      cx.beginPath();cx.arc(-3,-29,3,0,Math.PI*2);cx.stroke();
      cx.beginPath();cx.arc(3,-29,3,0,Math.PI*2);cx.stroke();
      R(-1,-29.5,2,1,'#222'); // bridge
    }
    // Eyes (behind glasses or not)
    C(-3,-29,1,'#111');C(3,-29,1,'#111');
    // Smug expression
    cx.strokeStyle='#111';cx.lineWidth=0.7;
    cx.beginPath();cx.arc(0,-25,2.5,0.3,Math.PI-0.3);cx.stroke();
    // Coffee in one hand (because of course)
    R(12*facing-2,-8,4,7,'#fff');R(12*facing-1,-9,2,1,'#8B4513');
    cx.restore();
  }
}

// Projectile in flight
if(bw.projectile){
  var proj2=bw.projectile;
  // Shadow on boardwalk
  cx.globalAlpha=0.25;
  cx.beginPath();cx.ellipse(proj2.shadowX,proj2.shadowY,6,3,0,0,Math.PI*2);cx.fillStyle='#000';cx.fill();
  cx.globalAlpha=1;
  // Trail
  for(var tr=1;tr<6;tr++){
    var tp=proj2.progress-tr*0.02;if(tp<0)continue;
    var trx=proj2.startX+(proj2.targetX-proj2.startX)*tp;
    var trArc=-160*4*tp*(1-tp);
    var trBaseY=proj2.startY+(proj2.targetY-proj2.startY)*tp;
    cx.globalAlpha=0.1;C(trx,trBaseY+trArc,2,'#999');cx.globalAlpha=1;
  }
  // Draw the item
  cx.save();cx.translate(proj2.x,proj2.y);cx.rotate(proj2.spin);
  var it=proj2.itemType;
  if(it==='crushed_can'){R(-4,-5,8,10,'#c0c0c0');R(-3,-2,6,5,'#aa3333');R(-3,-4,6,2,'#d0d0d0');cx.globalAlpha=0.3;R(-2,-1,4,3,'#888');cx.globalAlpha=1;}
  else if(it==='rotten_apple'){C(0,0,5,'#5a7a30');C(1,-1,4,'#6a8a38');R(-1,-6,2,3,'#4a2a10');}
  else if(it==='old_shoe'){R(-6,-3,12,6,'#5a4a3a');R(-6,-5,8,4,'#6a5a4a');R(4,-2,3,4,'#3a3a3a');}
  else if(it==='banana_peel'){cx.beginPath();cx.moveTo(-5,0);cx.quadraticCurveTo(0,-8,5,0);cx.quadraticCurveTo(0,4,-5,0);cx.fillStyle='#ccaa22';cx.fill();R(-2,0,4,2,'#aa8811');}
  else if(it==='fish_bone'){R(-6,0,12,2,'#e8e0d0');for(var fb=0;fb<4;fb++){R(-4+fb*3,-3,1,6,'#ddd8c8');}C(-7,0,2,'#e8e0d0');}
  else if(it==='soggy_newspaper'){R(-5,-4,10,8,'#d4cbb8');R(-4,-3,8,6,'#c8bfaa');cx.globalAlpha=0.3;for(var nl=0;nl<3;nl++){R(-3,-2+nl*2,6,1,'#666');}cx.globalAlpha=1;}
  else if(it==='broken_bottle'){R(-3,-5,6,10,'#4a8a4a');cx.globalAlpha=0.4;R(-2,-4,4,8,'#6aaa6a');cx.globalAlpha=1;R(-4,-5,2,3,'#3a7a3a');}
  else if(it==='tin_can'){R(-3,-5,6,10,'#b0b0b0');R(-2,-3,4,6,'#c0c0c0');R(-3,-5,6,1,'#909090');}
  else if(it==='pizza_crust'){cx.beginPath();cx.moveTo(-5,2);cx.lineTo(0,-5);cx.lineTo(5,2);cx.closePath();cx.fillStyle='#d4a860';cx.fill();R(-3,0,6,2,'#cc8833');}
  else{R(-4,-5,8,10,'#888');} // fallback
  cx.restore();
}

// Crash debris
for(var cri2=0;cri2<bw.crashes.length;cri2++){
  var cr2=bw.crashes[cri2];
  cx.globalAlpha=cr2.timer/80;
  for(var p2i=0;p2i<cr2.parts.length;p2i++){
    var pt2=cr2.parts[p2i];
    if(pt2.type==='wheel'){cx.strokeStyle='#333';cx.lineWidth=1;cx.beginPath();cx.arc(pt2.x,pt2.y,5,0,Math.PI*2);cx.stroke();}
    else if(pt2.type==='spark'){C(pt2.x,pt2.y,2,'#ffcc00');}
    else if(pt2.type==='item'){R(pt2.x-3,pt2.y-3,6,6,pt2.color||'#888');}
    else{R(pt2.x-2,pt2.y-2,4,4,pt2.color||'#888');}
  }
  cx.globalAlpha=1;
}

// Tark + garbage can (bottom-left)
var TX=120,TY=390;
var SC2=2;

// Garbage can (right next to Tark)
var gcx=TX+38,gcy=TY+10;
R(gcx-14,gcy-40,28,40,'#556655');R(gcx-12,gcy-38,24,36,'#667766');
R(gcx-16,gcy-42,32,4,'#445544'); // lid rim
R(gcx-10,gcy-44,20,4,'#556655'); // lid top
// Trash poking out (jiggles when reaching)
var trashJig=bw.tarkPose==='reaching'?Math.sin(Date.now()*0.02)*3:0;
R(gcx-6,gcy-48+trashJig,4,8,'#d4cbb8');
R(gcx+2,gcy-50-trashJig*0.5,3,6,'#5a7a30');
R(gcx-2,gcy-46+trashJig*0.7,2,5,'#b0b0b0');

// Tark — drawTarkIdle body, custom right arm for animation
cx.save();cx.translate(TX,TY);cx.scale(SC2,SC2);
var sw=Math.sin(Date.now()/1200)*1;
if(bw.tarkPose==='reaching'||bw.tarkPose==='holding'||bw.tarkPose==='throwing'){
  S._hideRightArm=true;
  drawTarkIdle(0,0,false);
  S._hideRightArm=false;
  // Custom right arm overlay
  if(bw.tarkPose==='reaching'){
    // Arm reaching right toward garbage can
    var rp2=bw.reachTimer/40; // 1→0 as reaching progresses
    var armAngle=0.3+rp2*0.5; // tilts more as reaching
    cx.save();cx.translate(14+sw,-6);cx.rotate(armAngle);
    R(0,0,10,30,'#d4a574');C(5,28,5,'#d4a574');
    cx.restore();
  }else if(bw.tarkPose==='holding'){
    // Arm raised up, holding item
    R(6+sw,-24,10,20,'#d4a574');C(11+sw,-26,5,'#d4a574');
    // Item in hand
    var ci3=bw.items[bw.currentItem];
    if(ci3){R(7+sw,-34,8,6,ci3.color||'#888');}
  }else if(bw.tarkPose==='throwing'){
    // Arm swinging forward — animated from back to forward
    var thr2=Math.min(bw.throwAnim*4,1);
    var throwAngle=-1.5+thr2*2.2; // winds up then throws forward
    cx.save();cx.translate(14+sw,-6);cx.rotate(throwAngle);
    R(0,0,10,30,'#d4a574');C(5,28,5,'#d4a574');
    cx.restore();
  }
}else if(bw.tarkPose==='celebrating'){
  S._hideRightArm=true;
  drawTarkIdle(0,0,false);
  S._hideRightArm=false;
  // Fist pump
  var pump=Math.sin(Date.now()*0.01)*3;
  R(6+sw,-30+pump,10,22,'#d4a574');C(11+sw,-32+pump,5,'#d4a574');
}else{
  drawTarkIdle(0,0,false);
}
cx.restore();

// HUD
cx.textAlign='center';
T('BOARDWALK TRASH TOSS',450,20,14,'#f0e6d3');
cx.textAlign='left';
var itemName=bw.items[bw.currentItem]?bw.items[bw.currentItem].name:'---';
T('THROWS: '+bw.throwsLeft+'/10',20,25,11,'#f0e6d3');
T('NEXT: '+itemName,20,42,9,'#aaa');
cx.textAlign='right';
T('HITS: '+bw.hits,880,25,12,'#ff6b35');
cx.textAlign='center';

// Instructions
if(bw.phase==='playing'&&!bw.throwing&&bw.throwsLeft>0){
  cx.globalAlpha=0.5;
  T('Click on the boardwalk to throw',450,470,9,'#f0e6d3');
  cx.globalAlpha=1;
}

// Bail button
if(bw.phase==='playing'){
  var bailHov=mouseX>=740&&mouseX<=870&&mouseY>=440&&mouseY<=470;
  R(740,440,130,30,bailHov?'#884422':'#663311');
  cx.strokeStyle='#aa7744';cx.lineWidth=1;cx.strokeRect(740,440,130,30);
  T('DONE',805,460,12,'#f0e6d3');
}

// Intro overlay
if(bw.phase==='intro'){
  cx.globalAlpha=0.6;R(0,0,W,H,'#000');cx.globalAlpha=1;
  T('BOARDWALK TRASH TOSS',450,180,22,'#ff6b35');
  T('Click a spot on the boardwalk to lob garbage at cyclists!',450,220,10,'#f0e6d3');
  T('Time it right — the arc is slow and high.',450,245,9,'#aaa');
  T('10 throws. Make them count.',450,268,9,'#aaa');
  var instPulse=0.5+Math.sin(t*3)*0.3;cx.globalAlpha=instPulse;
  T('Tark rummages through the trash...',450,310,10,'#ffcc00');
  cx.globalAlpha=1;
}

// End overlay
if(bw.phase==='ending'){
  cx.globalAlpha=0.5;R(0,0,W,H,'#000');cx.globalAlpha=1;
  T('GAME OVER',450,160,20,'#f0e6d3');
  var hitColor=bw.hits>=4?'#44ff44':bw.hits>=2?'#ffcc00':'#ff4444';
  T(bw.hits+' HIT'+(bw.hits!==1?'S':''),450,200,18,hitColor);
  if(bw.hits>=5)T('PERFECT! Absolute menace.',450,240,14,'#ff6b35');
  else if(bw.hits>=4)T('Nice arm, champ.',450,240,11,'#aaa');
  else if(bw.hits>=2)T('Decent aim.',450,240,11,'#aaa');
  else if(bw.hits>=1)T('Could be worse.',450,240,11,'#aaa');
  else T('Maybe stick to lifting.',450,240,11,'#888');
}

// Floating text
for(var fi=0;fi<S.floats.length;fi++){
  var f=S.floats[fi];f.y-=1.2;f.life-=0.018;
  cx.globalAlpha=Math.max(0,f.life);
  T(f.text,f.x,f.y,f.sz,f.c);
}
S.floats=S.floats.filter(function(f){return f.life>0;});
cx.globalAlpha=1;
cx.textAlign='center';
}


function drawBeachScene(){
  // Sub-menu takeover
  if(S.beach.subMenu==='sewer'){
    drawSewerHub();
    return;
  }
  if(S.beach.subMenu==='sewer_left'||S.beach.subMenu==='sewer_center'||S.beach.subMenu==='sewer_right'){
    drawSewerTunnel(S.beach.subMenu);
    return;
  }
  if(S.beach.subMenu==='middle_stall'){
    drawMiddleStallInterior();
    return;
  }
  if(S.beach.subMenu==='right_stall'){
    drawRightStallInterior();
    return;
  }
  if(S.beach.subMenu==='stall'){
    drawStallInterior();
    return;
  }
  if(S.beach.subMenu==='bathroom'){
    drawBathroomScene('standalone',0,0,null);
    // Back button
    var bailHov2=mouseX>=20&&mouseX<=140&&mouseY>=440&&mouseY<=470;
    R(20,440,120,30,bailHov2?'#884422':'#663311');
    cx.strokeStyle='#aa7744';cx.lineWidth=1;cx.strokeRect(20,440,120,30);
    T('BACK',80,460,12,'#f0e6d3');
    cx.globalAlpha=0.3;cx.font='9px monospace';cx.textAlign='right';cx.fillStyle='#666';
    cx.fillText('v'+BUILD_V,W-4,H-4);cx.textAlign='center';cx.globalAlpha=1;
    return;
  }
  if(S.beach.subMenu==='boardwalk'){
    drawBoardwalkScene();
    cx.globalAlpha=0.3;cx.font='9px monospace';cx.textAlign='right';cx.fillStyle='#666';
    cx.fillText('v'+BUILD_V,W-4,H-4);cx.textAlign='center';cx.globalAlpha=1;
    return;
  }
  if(S.beach.subMenu==='couple'){
    drawCoupleCloseup();
    cx.globalAlpha=0.3;cx.font='9px monospace';cx.textAlign='right';cx.fillStyle='#666';
    cx.fillText('v'+BUILD_V,W-4,H-4);cx.textAlign='center';cx.globalAlpha=1;
    return;
  }
  // Beach gym competition takeover
  if(S.beach.gymComp.active){
    if(S.beach.gymComp.animPhase){S.beach.gymComp.animT+=0.016;}
    if(S.pose==='smoke'||S.pose==='drinking'||S.pose==='chalking')S.poseT+=0.016;
    drawBeachGymComp();
    // Floating text
    for(var fi=0;fi<S.floats.length;fi++){
      var f=S.floats[fi];f.y-=1.2;f.life-=0.018;
      cx.globalAlpha=Math.max(0,f.life);
      T(f.text,f.x,f.y,f.sz,f.c);
    }
    S.floats=S.floats.filter(function(f){return f.life>0;});
    cx.globalAlpha=1;
    cx.globalAlpha=0.3;cx.font='9px monospace';cx.textAlign='right';cx.fillStyle='#666';
    cx.fillText('v'+BUILD_V,W-4,H-4);cx.textAlign='center';cx.globalAlpha=1;
    return;
  }

  // Normal beach view
  R(0,0,W,H,'#111');
  drawBeachBackground();
  try{updateWalk();}catch(e){}
  if(isNaN(S.tX)||S.tX<-50||S.tX>W+50)S.tX=S.homeX||450;
  try{checkStuck();}catch(e){}

  // Couples (drawn first so Tark appears in front)
  drawBeachCouples();

  // Tark
  var x=S.tX,y=328;
  if(S.pose==='smoke'||S.pose==='drinking'||S.pose==='slapping')S.poseT+=0.016;
  drawTarkWithBeers(x,y);

  // Floating text
  for(var fi=0;fi<S.floats.length;fi++){
    var f=S.floats[fi];f.y-=1.2;f.life-=0.018;
    cx.globalAlpha=Math.max(0,f.life);
    T(f.text,f.x,f.y,f.sz,f.c);
  }
  S.floats=S.floats.filter(function(f){return f.life>0;});
  cx.globalAlpha=1;

  // HUD
  drawBeachHUD();

  // Scene transition overlay
  if(S.sceneTransition)drawSceneTransition();
}

// === DOWNTOWN DRAWING FUNCTIONS ===

function drawDowntownBackground(){
var FY=400;
// Sky — early morning urban, grey-blue with hint of orange
var skyG=cx.createLinearGradient(0,0,0,200);
skyG.addColorStop(0,'#2a3040');skyG.addColorStop(0.6,'#4a5568');skyG.addColorStop(1,'#8a6040');
cx.fillStyle=skyG;cx.fillRect(0,0,W,200);

// Distant buildings silhouette
R(0,60,60,140,'#1a1e28');R(55,80,40,120,'#1e222e');R(90,50,50,150,'#222633');
R(750,70,50,130,'#1e222e');R(795,55,55,145,'#1a1e28');R(845,75,60,125,'#222633');

// === BUILDING 1: DIVE BAR (x=30-260) ===
var barH=hover==='downtownBar';
// Main structure — dark brick
R(30,180,230,FY-180,'#3a2820');
// Brick pattern
for(var by=185;by<FY;by+=12){for(var bx=32;bx<258;bx+=24){
R(bx+(by%24===5?12:0),by,22,10,'#432e24');
cx.strokeStyle='#2a1a14';cx.lineWidth=0.5;cx.strokeRect(bx+(by%24===5?12:0),by,22,10);
}}
// Flat roof edge
R(25,175,240,8,'#2a1e18');
// Door
R(120,320,50,FY-320,'#1a1208');R(122,322,46,FY-324,'#0d0a06');
// Door handle
C(162,360,3,'#aa8844');
// Awning — weathered red
R(105,310,80,12,'#6a2222');R(105,310,80,3,'#8a3333');
// Window — grimy with flicker
var wFlicker=Math.sin(Date.now()/300)*0.1+0.4;
R(60,240,60,50,'#0a0a0a');
cx.globalAlpha=wFlicker;R(62,242,56,46,'#443322');cx.globalAlpha=1;
R(60,240,60,2,'#555');R(60,288,60,2,'#555');R(60,240,2,50,'#555');R(118,240,2,50,'#555');R(89,240,2,50,'#555');
// Neon sign — "THE DIVE" — red glow
var neonPulse=Math.sin(Date.now()/400)*0.15+0.85;
cx.globalAlpha=neonPulse*0.3;R(58,210,110,28,'#ff2222');cx.globalAlpha=1;
cx.globalAlpha=neonPulse;
T('THE DIVE',113,230,11,'#ff4444');
cx.globalAlpha=1;
// Beer keg outside
R(200,FY-30,20,30,'#555');C(210,FY-32,12,'#666');
// Trash bags
C(230,FY-10,12,'#222');C(242,FY-8,10,'#1a1a1a');C(224,FY-5,8,'#282828');
// Hover highlight
if(barH){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(28,178,234,FY-176);}

// === BUILDING 2: BODEGA (x=310-540) ===
var bodH=hover==='downtownBodega';
// Main structure — cream/beige stucco
R(310,200,230,FY-200,'#c8b898');
// Stucco texture — subtle horizontal lines
for(var sy=205;sy<FY;sy+=8){cx.strokeStyle='#b8a888';cx.lineWidth=0.3;cx.beginPath();cx.moveTo(312,sy);cx.lineTo(538,sy);cx.stroke();}
// Flat roof
R(305,195,240,8,'#8a7a6a');
// Striped awning
for(var ai=0;ai<12;ai++){
R(305+ai*20,255,20,18,ai%2===0?'#cc4444':'#eeeeee');
}
R(305,255,240,3,'#aa3333');
// Store window — lit inside
R(330,275,80,70,'#ffe8a0');
cx.strokeStyle='#8a7a6a';cx.lineWidth=2;cx.strokeRect(330,275,80,70);
// Window grid
R(369,275,2,70,'#8a7a6a');
// Shelf silhouettes inside window
R(334,290,32,6,'#c8a060');R(334,305,32,6,'#c8a060');R(334,320,32,6,'#c8a060');
R(374,290,32,6,'#c8a060');R(374,305,32,6,'#c8a060');
// Door
R(440,285,40,FY-285,'#6a5a4a');R(442,287,36,FY-289,'#5a4a3a');
// Door handle
C(472,340,3,'#aa8844');
// Sign — hand painted
R(340,210,150,35,'#2a6a2a');
cx.strokeStyle='#4a8a4a';cx.lineWidth=1;cx.strokeRect(340,210,150,35);
T('BODEGA',415,233,12,'#fff');
// Produce crates
R(315,FY-25,30,25,'#8a6a3a');R(315,FY-22,28,4,'#aa4444');R(315,FY-16,28,4,'#44aa44');R(315,FY-10,28,4,'#ddaa22');
R(348,FY-20,25,20,'#7a5a2a');R(350,FY-18,21,4,'#ff8844');R(350,FY-12,21,4,'#ff8844');
// Newspaper rack
R(490,FY-35,30,35,'#555');R(492,FY-33,26,10,'#ddd');R(492,FY-22,26,10,'#eee');
// Cat on windowsill
C(400,272,6,'#ff8833');C(400,266,4,'#ff8833');
C(398,264,1.5,'#1a1a1a');C(402,264,1.5,'#1a1a1a');
// Ears
cx.fillStyle='#ff8833';cx.beginPath();cx.moveTo(396,260);cx.lineTo(398,255);cx.lineTo(400,260);cx.fill();
cx.beginPath();cx.moveTo(400,260);cx.lineTo(402,255);cx.lineTo(404,260);cx.fill();
// Tail
cx.strokeStyle='#ff8833';cx.lineWidth=2;cx.beginPath();cx.moveTo(406,272);cx.quadraticCurveTo(415,265,412,258);cx.stroke();
// Hover highlight
if(bodH){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(308,198,234,FY-196);}

// === BUILDING 3: HOTEL (x=590-830) ===
var htlH=hover==='downtownHotel';
// Main structure — taller, faded grey
R(590,120,240,FY-120,'#6a6a72');
// Window grid (3 floors)
for(var fy=0;fy<3;fy++){for(var fx=0;fx<3;fx++){
var wx=610+fx*70,wy=145+fy*70;
var lit=Math.sin(Date.now()/800+fx*2+fy*3)>0.3;
R(wx,wy,50,45,lit?'#ccaa55':'#3a3a42');
cx.strokeStyle='#555';cx.lineWidth=1;cx.strokeRect(wx,wy,50,45);
R(wx+24,wy,2,45,'#555');R(wx,wy+22,50,1,'#555');
}}
// Roof edge with small ledge
R(585,115,250,8,'#555');R(585,110,250,5,'#4a4a52');
// Fire escape (right side)
R(815,145,12,FY-145,'#444');
for(var fe=0;fe<3;fe++){R(800,160+fe*70,30,4,'#555');R(800,160+fe*70,4,20,'#555');}
// Front entrance
R(680,330,60,FY-330,'#3a3a3a');R(682,332,56,FY-334,'#2a2a2a');
// Glass door panels
R(684,334,25,FY-340,'#445566');R(711,334,25,FY-340,'#445566');
// Awning
R(665,325,90,8,'#883333');
// Vertical HOTEL sign
var htlNeon=Math.sin(Date.now()/500)*0.12+0.88;
cx.globalAlpha=htlNeon*0.25;R(600,130,28,160,'#4444ff');cx.globalAlpha=1;
cx.globalAlpha=htlNeon;
var htlLetters=['H','O','T','E','L'];
for(var hi=0;hi<5;hi++){T(htlLetters[hi],614,152+hi*28,12,'#6666ff');}
cx.globalAlpha=1;
// Potted plant
R(755,FY-30,20,30,'#5a3a2a');C(765,FY-35,12,'#2a5a2a');C(760,FY-40,8,'#3a6a3a');C(770,FY-38,9,'#2a5a2a');
// Cracked facade detail
cx.strokeStyle='#5a5a62';cx.lineWidth=0.5;
cx.beginPath();cx.moveTo(620,200);cx.lineTo(630,230);cx.lineTo(625,260);cx.stroke();
cx.beginPath();cx.moveTo(780,170);cx.lineTo(785,200);cx.lineTo(778,220);cx.stroke();
// Hover highlight
if(htlH){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(588,118,244,FY-116);}

// === STREET / SIDEWALK ===
// Sidewalk
R(0,FY,W,20,'#888');
for(var sx=0;sx<W;sx+=60){cx.strokeStyle='#777';cx.lineWidth=0.5;cx.beginPath();cx.moveTo(sx,FY);cx.lineTo(sx,FY+20);cx.stroke();}
// Curb
R(0,FY+18,W,4,'#666');
// Road
R(0,FY+22,W,60,'#333');
// Road markings
for(var rx=50;rx<W;rx+=80){R(rx,FY+48,40,4,'#aa8822');}
// Parked car bumper (left edge)
R(-20,FY+25,60,30,'#2a2a3a');R(-15,FY+28,15,8,'#aa3333');C(25,FY+45,8,'#222');
// Fire hydrant
R(278,FY-20,12,20,'#cc3333');C(284,FY-22,8,'#dd4444');R(280,FY-15,8,4,'#aa2222');
// Street lamp
R(555,100,4,FY-100,'#555');R(545,98,24,6,'#666');
cx.globalAlpha=0.15;C(557,105,20,'#ffee88');cx.globalAlpha=1;
C(557,102,4,'#ffee88');
// Manhole cover
cx.fillStyle='#555';cx.beginPath();cx.ellipse(450,FY+35,18,6,0,0,Math.PI*2);cx.fill();
cx.strokeStyle='#444';cx.lineWidth=1;cx.beginPath();cx.ellipse(450,FY+35,18,6,0,0,Math.PI*2);cx.stroke();
// Steam vent
if(Math.sin(Date.now()/600)>0){
cx.globalAlpha=0.15;
for(var vi=0;vi<3;vi++){C(285+vi*4,FY-25-vi*10,5+vi*3,'#ccc');}
cx.globalAlpha=1;
}
// Litter
R(380,FY+5,8,4,'#ddd');R(520,FY+8,6,3,'#aaa');C(680,FY+6,3,'#cc6644');
// Exit arrow sign (right edge)
var exH=hover==='downtownExit';
T(exH?'EXIT \u2192':'',870,FY-5,8,exH?'#ff6b35':'#888');
// Ma's House sign removed — map handles navigation now
}

function drawDowntownHUD(){
T('DOWNTOWN',450,22,13,'#8899aa');
T('DAY '+S.day+(S.day===S.totalDays?' \u2014 MEET DAY':''),14,22,10,'#ff6b35');
// Hover tooltips
if(hover&&!S.busy&&!S.downtown.subMenu){
var tips={downtownBar:'Enter the bar',downtownBodega:'Enter the bodega',downtownHotel:'Enter the hotel',downtownExit:'Leave downtown',mapBtn:'MAP'};
if(tips[hover])T(tips[hover],450,FY+55,10,'#f0e6d3');
}
}
var FY=400; // floor Y for downtown (global ref for HUD)

function drawDowntownScene(){
var _vsub=S.downtown.subMenu;
if(_vsub==='bar'){drawBarInterior();return;}
if(_vsub==='bodega'){drawBodegaInterior();return;}
if(_vsub==='hotel'){drawHotelInterior();return;}
if(_vsub==='ma_house'){drawMaHouseExterior();return;}
if(_vsub==='ma_living'){drawMaLivingRoom();return;}
if(_vsub==='ma_kitchen'){drawMaKitchen();return;}
if(_vsub==='ma_upstairs'){drawMaUpstairs();return;}
if(_vsub==='ma_basement'){drawMaBasement();return;}
if(_vsub==='ma_tark_room'){drawMaTarkRoom();return;}
if(_vsub==='ma_ma_room'){drawMaMaRoom();return;}
if(_vsub==='ma_bath'){drawMaBath();return;}
if(_vsub==='exit'){drawDowntownExitChoice();return;}

R(0,0,W,H,'#111');
drawDowntownBackground();
// Character walk update
try{updateWalk();}catch(e){}
if(isNaN(S.tX)||S.tX<-50||S.tX>W+50)S.tX=S.homeX||450;
// Draw Tark
drawTarkIdle(S.tX,370,S.pose==='walking');
// Floating text
try{drawFloats();}catch(e){}
drawDowntownHUD();
if(S.sceneTransition)drawSceneTransition();
}

// === DOWNTOWN INTERIOR: BAR ===
function drawBarInterior(){
// Dark room
R(0,0,W,H,'#1a1008');
// Wood floor
for(var fy=360;fy<H;fy+=8){
R(0,fy,W,7,fy%16===0?'#3a2a1a':'#2e2014');
}
// Back wall — dark wood paneling
for(var px=0;px<W;px+=30){
var shade=px%60===0?'#2a1e14':'#241a10';
R(px,0,29,360,shade);
cx.strokeStyle='#1a1208';cx.lineWidth=0.5;cx.beginPath();cx.moveTo(px,0);cx.lineTo(px,360);cx.stroke();
}
// Bar counter
R(100,280,600,15,'#4a3020');R(100,295,600,65,'#3a2418');
R(100,280,600,4,'#5a3a28');
// Bar surface sheen
cx.globalAlpha=0.1;R(100,280,600,10,'#ffddaa');cx.globalAlpha=1;
// Bar stools
for(var si=0;si<5;si++){
var sx=160+si*110;
R(sx-8,340,16,40,'#333');R(sx-12,335,24,8,'#444');
R(sx-2,370,4,20,'#333');
}
// Bottles on back shelf
R(150,80,500,8,'#3a2a1a');R(150,140,500,8,'#3a2a1a');R(150,200,500,8,'#3a2a1a');
var bottleColors=['#884422','#228844','#aa6622','#882244','#445588','#cc8833','#226644','#884444','#668822','#aa4422'];
for(var bi=0;bi<10;bi++){
var bx=170+bi*48;
R(bx,60,10,22,bottleColors[bi]);R(bx+2,54,6,8,bottleColors[bi]);
R(bx,130,10,12,bottleColors[bi%5+5]);
R(bx+20,190,10,12,bottleColors[(bi+3)%10]);
}
// Neon beer sign — left wall
var beerNeon=Math.sin(Date.now()/350)*0.15+0.85;
cx.globalAlpha=beerNeon*0.25;R(30,100,60,30,'#3333ff');cx.globalAlpha=1;
cx.globalAlpha=beerNeon;T('BEER',60,120,10,'#4488ff');cx.globalAlpha=1;
// Neon beer sign — right wall
cx.globalAlpha=beerNeon*0.2;R(780,140,80,25,'#ff3333');cx.globalAlpha=1;
cx.globalAlpha=beerNeon;T('OPEN',820,158,9,'#ff4444');cx.globalAlpha=1;
// Pool table (background)
R(720,250,140,90,'#1a4a1a');R(722,252,136,86,'#2a6a2a');
cx.strokeStyle='#4a3020';cx.lineWidth=3;cx.strokeRect(720,250,140,90);
// Pool balls
C(770,280,4,'#fff');C(785,290,4,'#ff2222');C(800,285,4,'#222');C(775,300,4,'#ffcc00');C(810,300,4,'#3333ff');
// Cue stick
cx.strokeStyle='#c8a060';cx.lineWidth=2;cx.beginPath();cx.moveTo(740,340);cx.lineTo(800,270);cx.stroke();
// Jukebox
R(30,230,50,130,'#4a3a5a');R(32,232,46,50,'#6a4a8a');
cx.globalAlpha=0.4;var jbPulse=Math.sin(Date.now()/250)*0.5+0.5;
R(34,234,42,46,jbPulse>0.5?'#aa44aa':'#6644aa');cx.globalAlpha=1;
R(32,285,46,8,'#333');
// Jukebox buttons
for(var ji=0;ji<4;ji++){C(42+ji*10,300,3,'#888');}
// Bartender silhouette
R(400,200,30,80,'#1a1208');C(415,195,14,'#1a1208');
R(395,240,40,8,'#1a1208');
// Dartboard on right wall
C(820,100,20,'#222');C(820,100,16,'#cc3333');C(820,100,12,'#eee');C(820,100,8,'#cc3333');C(820,100,4,'#2a6a2a');
// Ceiling fan (slow rotate)
var fanAngle=Date.now()/2000;
cx.save();cx.translate(450,30);cx.rotate(fanAngle);
R(-40,-3,80,6,'#555');R(-3,-40,6,80,'#555');
cx.restore();C(450,30,6,'#666');
// Back button
T('\u2190 BACK',70,H-20,10,hover==='dtBack'?'#ff6b35':'#888');
if(hover==='dtBack'){cx.strokeStyle='#ff6b35';cx.lineWidth=1;cx.strokeRect(20,H-32,100,20);}
}

// === DOWNTOWN INTERIOR: BODEGA ===
function drawBodegaInterior(){
// Bright fluorescent interior
R(0,0,W,H,'#f0e8d0');
// Floor — checkered linoleum
for(var fy=0;fy<6;fy++){for(var fx=0;fx<15;fx++){
R(fx*64,360+fy*20,64,20,(fx+fy)%2===0?'#c8b898':'#b8a888');
}}
// Ceiling — drop tiles
R(0,0,W,40,'#e8e0d0');
for(var tx=0;tx<W;tx+=80){cx.strokeStyle='#d0c8b8';cx.lineWidth=0.5;cx.beginPath();cx.moveTo(tx,0);cx.lineTo(tx,40);cx.stroke();}
// Fluorescent lights
R(150,10,200,6,'#fff');R(500,10,200,6,'#fff');
cx.globalAlpha=0.05;R(100,0,300,H,'#fff');R(450,0,300,H,'#fff');cx.globalAlpha=1;
// Left shelving unit
for(var sh=0;sh<4;sh++){
R(30,80+sh*65,180,8,'#8a7a6a');
// Products on shelf
for(var pi=0;pi<6;pi++){
var pc=['#cc3333','#3366cc','#44aa44','#ffaa22','#aa44aa','#cc6633'][pi];
R(40+pi*28,80+sh*65-25,20,25,pc);
}}
// Right shelving unit
for(var sh2=0;sh2<4;sh2++){
R(550,80+sh2*65,180,8,'#8a7a6a');
for(var pi2=0;pi2<6;pi2++){
var pc2=['#ffcc00','#ff6644','#44ccaa','#8844cc','#cc8844','#4488cc'][pi2];
R(560+pi2*28,80+sh2*65-25,20,25,pc2);
}}
// Counter with register — front
R(300,290,200,20,'#6a5a4a');R(300,310,200,90,'#5a4a3a');
// Register
R(370,260,60,30,'#333');R(372,262,56,20,'#2a4a2a');
T('$0.00',400,275,7,'#44ff44');
R(380,255,40,6,'#444');
// Plexiglass (subtle)
cx.strokeStyle='rgba(200,200,220,0.3)';cx.lineWidth=1;
cx.beginPath();cx.moveTo(300,200);cx.lineTo(300,290);cx.lineTo(500,290);cx.lineTo(500,200);cx.stroke();
// Clerk silhouette
R(390,200,30,80,'#4a3a2a');C(405,195,12,'#4a3a2a');
// Snack rack (front)
R(200,340,60,50,'#888');
for(var sr=0;sr<3;sr++){R(205,345+sr*15,50,4,'#666');
R(208,345+sr*15-10,14,10,['#cc3333','#ffaa22','#4488cc'][sr]);
R(228,345+sr*15-10,14,10,['#44aa44','#aa44aa','#ffcc00'][sr]);}
// Drink cooler (back wall center)
R(350,80,100,130,'#ddd');R(352,82,96,126,'#88ccee');
cx.strokeStyle='#aaa';cx.lineWidth=1;cx.strokeRect(350,80,100,130);
R(350,142,100,2,'#aaa');
// Drinks inside cooler
for(var di=0;di<4;di++){R(360+di*22,92,16,45,'#'+['ff4444','44aaff','ffcc00','44ff44'][di]);
R(360+di*22,150,16,45,'#'+['ff8844','4488ff','ffaa44','88ff44'][di]);}
// Lottery sign
R(550,45,120,25,'#ffcc00');T('LOTTO',610,62,10,'#222');
// Cat on counter
C(320,278,7,'#ff8833');C(320,271,5,'#ff8833');
C(318,269,1.5,'#1a1a1a');C(322,269,1.5,'#1a1a1a');
cx.fillStyle='#ff8833';cx.beginPath();cx.moveTo(316,265);cx.lineTo(318,260);cx.lineTo(320,265);cx.fill();
cx.beginPath();cx.moveTo(320,265);cx.lineTo(322,260);cx.lineTo(324,265);cx.fill();
cx.strokeStyle='#ff8833';cx.lineWidth=2;cx.beginPath();cx.moveTo(326,280);cx.quadraticCurveTo(335,272,332,264);cx.stroke();
// Back button
T('\u2190 BACK',70,H-20,10,hover==='dtBack'?'#ff6b35':'#888');
if(hover==='dtBack'){cx.strokeStyle='#ff6b35';cx.lineWidth=1;cx.strokeRect(20,H-32,100,20);}
}

// === DOWNTOWN INTERIOR: HOTEL ===
function drawHotelInterior(){
// Faded lobby
R(0,0,W,H,'#3a3028');
// Carpet — faded pattern
for(var cy=340;cy<H;cy+=20){for(var cx2=0;cx2<W;cx2+=40){
R(cx2,cy,40,20,(cx2+cy)%80===0?'#6a3030':'#5a2828');
}}
// Carpet border
R(0,340,W,3,'#8a6a3a');
// Back wall — wallpaper with faded stripes
for(var wp=0;wp<W;wp+=25){
R(wp,0,25,340,wp%50===0?'#4a4038':'#443a30');
}
// Wainscoting
R(0,250,W,90,'#3a2a1a');R(0,248,W,4,'#5a4a3a');
// Reception desk
R(500,260,250,30,'#5a3a20');R(500,290,250,60,'#4a2a18');
R(500,258,250,4,'#6a4a30');
// Desk lamp
R(700,230,6,28,'#444');C(703,228,10,'#ffee88');cx.globalAlpha=0.15;C(703,228,25,'#ffee88');cx.globalAlpha=1;
// Bell on desk
C(600,254,5,'#cc9944');R(595,256,10,3,'#aa8833');
// Key hooks behind desk
R(580,100,120,80,'#3a2a1a');
for(var ki=0;ki<4;ki++){for(var kj=0;kj<3;kj++){
C(595+ki*28,115+kj*25,3,'#aa8833');
if(Math.random()>0.5)R(592+ki*28,118+kj*25,6,12,'#888'); // key
}}
// Receptionist silhouette
R(620,180,25,70,'#2a2018');C(632,175,11,'#2a2018');
// Chandelier
R(300,0,4,40,'#888');
for(var ch=0;ch<5;ch++){
cx.strokeStyle='#aa8833';cx.lineWidth=1;
cx.beginPath();cx.moveTo(302,40);cx.quadraticCurveTo(260+ch*20,55,250+ch*20,65);cx.stroke();
C(250+ch*20,67,3,'#ffee88');
}
cx.globalAlpha=0.08;C(302,50,60,'#ffee88');cx.globalAlpha=1;
// Staircase (background left)
for(var st=0;st<8;st++){
R(30+st*22,280-st*15,24,st*15+60,'#3a2a1a');
}
R(28,280,180,4,'#5a4a3a'); // railing base
cx.strokeStyle='#5a4a3a';cx.lineWidth=2;
cx.beginPath();cx.moveTo(30,280);cx.lineTo(200,160);cx.stroke();
// Railing posts
for(var rp=0;rp<6;rp++){R(40+rp*30,280-rp*20-30,3,30,'#5a4a3a');}
// Elevator doors (right side)
R(800,100,70,240,'#666');R(802,102,33,236,'#777');R(837,102,31,236,'#777');
R(834,200,4,40,'#888'); // gap between doors
// Elevator indicator
R(820,85,20,12,'#222');T('3',830,95,8,'#ff4444');
// Potted palm
R(440,310,20,30,'#5a3a2a');
cx.fillStyle='#2a6a2a';
cx.beginPath();cx.moveTo(450,310);cx.quadraticCurveTo(430,280,410,260);cx.lineTo(420,265);cx.quadraticCurveTo(440,290,450,310);cx.fill();
cx.beginPath();cx.moveTo(450,310);cx.quadraticCurveTo(460,275,480,255);cx.lineTo(472,258);cx.quadraticCurveTo(455,280,450,310);cx.fill();
cx.beginPath();cx.moveTo(450,310);cx.quadraticCurveTo(450,275,440,250);cx.lineTo(448,252);cx.quadraticCurveTo(455,280,450,310);cx.fill();
// Luggage rack
R(250,300,50,10,'#555');R(255,310,4,30,'#555');R(291,310,4,30,'#555');
R(260,285,15,20,'#884422');R(280,290,12,15,'#445588');
// Back button
T('\u2190 BACK',70,H-20,10,hover==='dtBack'?'#ff6b35':'#888');
if(hover==='dtBack'){cx.strokeStyle='#ff6b35';cx.lineWidth=1;cx.strokeRect(20,H-32,100,20);}
}

// === DOWNTOWN EXIT CHOICE ===
function drawDowntownExitChoice(){
// Draw the downtown street in background
R(0,0,W,H,'#111');
drawDowntownBackground();
// Dim overlay
cx.globalAlpha=0.6;R(0,0,W,H,'#000');cx.globalAlpha=1;
// Title
T('WHERE TO?',450,60,16,'#f0e6d3');
T('Pick a destination',450,85,9,'#888');
// Three sign posts — same style as apartment door choice
var pulse=Math.sin(Date.now()/500)*0.12+0.88;
// Left — Apartment
var lsH=hover==='exitApt';
R(100,150,5,200,'#666');R(98,148,9,4,'#777');
var lsc=lsH?'#ff6b35':'#225522';
R(40,155,120,40,lsc);R(42,157,116,36,lsH?'#ff8855':'#2a6a2a');
cx.strokeStyle=lsH?'#ffaa66':'#4a8a4a';cx.lineWidth=lsH?2:1;cx.strokeRect(40,155,120,40);
T('\u2190 APARTMENT',100,180,9,'#fff');
T(lsH?'Back home':'',100,208,7,'#ff6b35');
// Center — Venice Beach
var csH=hover==='exitBeach';
R(450,150,5,200,'#666');R(448,148,9,4,'#777');
var csc=csH?'#ff6b35':'#225522';
R(390,155,120,40,csc);R(392,157,116,36,csH?'#ff8855':'#2a6a2a');
cx.strokeStyle=csH?'#ffaa66':'#4a8a4a';cx.lineWidth=csH?2:1;cx.strokeRect(390,155,120,40);
T('VENICE BEACH',450,180,9,'#fff');
T(csH?'Sun & trouble':'',450,208,7,'#ff6b35');
// Right — Gym
var rsH=hover==='exitGym';
R(800,150,5,200,'#666');R(798,148,9,4,'#777');
var rsc=rsH?'#ff6b35':'#225522';
R(740,155,120,40,rsc);R(742,157,116,36,rsH?'#ff8855':'#2a6a2a');
cx.strokeStyle=rsH?'#ffaa66':'#4a8a4a';cx.lineWidth=rsH?2:1;cx.strokeRect(740,155,120,40);
T('THE GYM \u2192',800,180,9,'#fff');
T(rsH?'All business':'',800,208,7,'#ff6b35');
// Cancel — go back
var gbH=hover==='exitCancel';
T('STAY DOWNTOWN',450,350,10,gbH?'#ff6b35':'#888');
if(gbH){cx.strokeStyle='#ff6b35';cx.lineWidth=1;cx.strokeRect(380,338,140,20);}
// Tark standing
drawTarkIdle(450,410,false);
}

// === MA'S HOUSE DRAW FUNCTIONS ===

function drawMaHouseExterior(){
// Rundown 2-story house exterior
// Sky — overcast, depressing
var grd=cx.createLinearGradient(0,0,0,200);
grd.addColorStop(0,'#8a8a8a');grd.addColorStop(1,'#a0998a');
cx.fillStyle=grd;R(0,0,W,200,'#8a8a8a');cx.fillRect(0,0,W,200);
// Distant trees
C(50,160,30,'#3a5a2a');C(120,150,25,'#2a4a1a');C(820,155,28,'#3a5a2a');C(870,145,22,'#2a4a1a');
// Dying lawn
R(0,340,W,140,'#6a7b4a');
// Brown patches
R(100,360,60,20,'#8a7a4a');R(500,370,40,15,'#8a7a4a');R(700,355,50,18,'#8a7a4a');
R(250,380,30,12,'#7a6a3a');R(600,390,45,10,'#8a7a4a');
// Cracked walkway from bottom center to porch
R(410,340,40,140,'#888');R(412,342,36,136,'#999');
// Cracks in walkway
cx.strokeStyle='#666';cx.lineWidth=1;
cx.beginPath();cx.moveTo(420,360);cx.lineTo(430,380);cx.lineTo(425,400);cx.stroke();
cx.beginPath();cx.moveTo(440,420);cx.lineTo(435,440);cx.stroke();
// House main structure — 2 stories
// Foundation
R(180,340,540,6,'#666');
// First floor walls — peeling beige stucco
R(180,220,540,120,'#c8b898');
// Peeling paint patches
cx.globalAlpha=0.3;
R(200,240,30,20,'#b8a080');R(350,250,40,15,'#baa888');R(550,230,25,30,'#b0a078');R(650,260,35,18,'#baa888');
cx.globalAlpha=1;
// Second floor walls
R(180,80,540,140,'#c8b898');
cx.globalAlpha=0.3;
R(220,100,35,25,'#b8a080');R(450,110,30,20,'#baa888');R(600,90,40,25,'#b0a078');
cx.globalAlpha=1;
// Horizontal divider between floors
R(180,218,540,5,'#8a7a6a');
// Roof — sagging
cx.fillStyle='#555';
cx.beginPath();cx.moveTo(160,80);cx.lineTo(450,60);cx.lineTo(740,80);cx.lineTo(740,90);cx.lineTo(160,90);cx.closePath();cx.fill();
R(160,88,580,6,'#666');
// Gutters — rusty
R(180,88,2,252,'#8a5a3a');R(718,88,2,252,'#8a5a3a');
// Porch
R(240,320,380,22,'#6a5a4a');R(242,322,376,18,'#5a4a3a');
// Porch posts — slightly crooked
cx.save();cx.translate(260,230);cx.rotate(0.02);R(0,0,8,90,'#7a6a5a');cx.restore();
cx.save();cx.translate(600,230);cx.rotate(-0.015);R(0,0,8,90,'#7a6a5a');cx.restore();
// Porch roof overhang
R(235,225,400,8,'#5a4a3a');
// Front door
var dH=hover==='maFrontDoor';
R(380,260,80,62,'#5a3a2a');R(382,262,76,58,'#4a2a1a');
// Door panels
R(386,268,32,24,'#3a1a0a');R(422,268,32,24,'#3a1a0a');
R(386,298,32,18,'#3a1a0a');R(422,298,32,18,'#3a1a0a');
// Door handle
C(450,292,3,'#aa8844');
// Door highlight
if(dH){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(378,258,84,66);}
// Windows — first floor (2)
R(230,250,60,45,'#445566');R(570,250,60,45,'#445566');
cx.strokeStyle='#888';cx.lineWidth=1;
cx.strokeRect(230,250,60,45);cx.strokeRect(570,250,60,45);
R(259,250,2,45,'#888');R(599,250,2,45,'#888');
R(230,272,60,1,'#888');R(570,272,60,1,'#888');
// Curtains — left window
R(232,252,12,41,'#aa8866');R(278,252,10,41,'#aa8866');
// Crack in right window
cx.strokeStyle='#aabbcc';cx.lineWidth=0.8;
cx.beginPath();cx.moveTo(580,255);cx.lineTo(600,275);cx.lineTo(590,290);cx.stroke();
// Windows — second floor (3)
for(var wi=0;wi<3;wi++){
  var wx=230+wi*150;
  R(wx,110,60,45,'#445566');
  cx.strokeStyle='#888';cx.lineWidth=1;cx.strokeRect(wx,110,60,45);
  R(wx+29,110,2,45,'#888');R(wx,132,60,1,'#888');
}
// Tattered curtain on middle 2nd floor window
R(382,112,8,41,'#996666');
// Broken mailbox — tilted
cx.save();cx.translate(160,365);cx.rotate(-0.15);
R(0,-20,6,30,'#666');R(-10,-28,26,12,'#555');R(-8,-26,22,8,'#444');
cx.restore();
// Dead shrubs by door
C(350,335,8,'#5a4a2a');C(345,330,6,'#6a5a3a');C(355,332,5,'#4a3a1a');
C(510,335,8,'#5a4a2a');C(515,330,6,'#6a5a3a');C(505,332,5,'#4a3a1a');
// Water stain streaks under gutters
cx.globalAlpha=0.2;
R(180,92,8,140,'#5a4a2a');R(714,92,8,140,'#5a4a2a');
R(400,92,6,80,'#5a4a2a');
cx.globalAlpha=1;
// More wall cracks
cx.strokeStyle='#a09878';cx.lineWidth=0.8;
cx.beginPath();cx.moveTo(300,100);cx.lineTo(310,140);cx.lineTo(305,170);cx.stroke();
cx.beginPath();cx.moveTo(650,240);cx.lineTo(660,270);cx.lineTo(655,295);cx.stroke();
cx.beginPath();cx.moveTo(220,280);cx.lineTo(240,310);cx.stroke();
// Boarded-up bottom-left window
R(233,253,54,39,'#7a6a4a');
cx.strokeStyle='#5a4a2a';cx.lineWidth=2;
cx.beginPath();cx.moveTo(234,254);cx.lineTo(286,291);cx.stroke();
cx.beginPath();cx.moveTo(286,254);cx.lineTo(234,291);cx.stroke();
// Broken porch step
R(400,340,50,4,'#6a5a4a');R(410,340,20,4,'#333');
// Missing chunk in porch
R(290,324,20,10,'#333');
// Weeds poking through walkway
cx.strokeStyle='#5a7a3a';cx.lineWidth=1.5;
cx.beginPath();cx.moveTo(425,400);cx.lineTo(422,385);cx.stroke();
cx.beginPath();cx.moveTo(435,430);cx.lineTo(438,418);cx.stroke();
cx.beginPath();cx.moveTo(415,450);cx.lineTo(412,438);cx.stroke();
// Trash in yard
R(150,390,6,4,'#ccc');R(650,380,8,3,'#aaa');C(750,370,3,'#cc6644');
R(550,400,10,5,'#886644');
// Satellite dish — crooked
cx.save();cx.translate(710,80);cx.rotate(0.3);
cx.strokeStyle='#777';cx.lineWidth=1.5;cx.beginPath();cx.arc(0,0,12,-0.5,2.5);cx.stroke();
R(-2,-2,4,20,'#666');
cx.restore();
// House number — crooked, missing a digit
T('74_',400,245,8,'#666');
cx.strokeStyle='#8a7a6a';cx.lineWidth=0.5;
cx.beginPath();cx.moveTo(424,238);cx.lineTo(428,248);cx.stroke();
// Sidewalk exit at bottom — back to downtown
var backH=hover==='maBack';
// Arrow on walkway pointing out
cx.fillStyle=backH?'#ff6b35':'#888';
cx.beginPath();cx.moveTo(430,440);cx.lineTo(420,425);cx.lineTo(440,425);cx.closePath();cx.fill();
T(backH?'LEAVE':'',430,460,7,'#ff6b35');
if(backH){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(400,420,60,50);}
// Tark standing on walkway
drawTarkIdle(430,380,false);
}

function drawMaLivingRoom(){
// Living room interior
// Walls — faded wallpaper
R(0,0,W,H,'#c8b8a0');
for(var wp=0;wp<W;wp+=30){R(wp,0,1,340,'#baa888');}
// Floor — worn carpet
R(0,340,W,140,'#8a6a4a');
R(100,350,80,8,'#7a5a3a');R(400,360,60,6,'#7a5a3a');R(650,370,50,5,'#7a5a3a');
// Wainscoting
R(0,260,W,80,'#7a5a3a');R(0,258,W,4,'#8a6a4a');
// Front door (back exit) — far left
var backH=hover==='maBack';
R(10,200,60,140,'#5a3a2a');R(12,202,56,136,'#4a2a1a');
// Door panels
R(16,210,22,50,'#3a1a0a');R(42,210,22,50,'#3a1a0a');
R(16,268,22,60,'#3a1a0a');R(42,268,22,60,'#3a1a0a');
C(60,285,3,'#aa8844');
// Daylight glow under door
cx.globalAlpha=0.15;R(15,335,50,5,'#ffee88');cx.globalAlpha=1;
if(backH){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(8,198,64,144);T('OUTSIDE',40,350,7,'#ff6b35');}
// Old CRT TV — center left on stand
R(170,290,65,50,'#333');R(172,292,61,40,'#222');
// Static screen
var flicker=Math.sin(Date.now()/100)*0.1+0.3;
cx.globalAlpha=flicker;R(174,294,57,36,'#5577aa');cx.globalAlpha=1;
// TV antenna
R(195,275,3,15,'#555');R(185,260,6,3,'#555');R(207,260,6,3,'#555');
cx.strokeStyle='#555';cx.lineWidth=1;
cx.beginPath();cx.moveTo(188,262);cx.lineTo(197,277);cx.stroke();
cx.beginPath();cx.moveTo(210,262);cx.lineTo(197,277);cx.stroke();
// TV stand
R(165,340,75,12,'#5a4a3a');R(170,352,4,20,'#5a4a3a');R(230,352,4,20,'#5a4a3a');
// Couch — center
R(300,290,200,50,'#7a5a3a');R(300,260,200,30,'#6a4a2a');
R(290,270,20,70,'#6a4a2a');R(490,270,20,70,'#6a4a2a');
// Cushion detail
R(305,295,90,10,'#8a6a4a');R(400,295,90,10,'#8a6a4a');
// Ma sitting on couch (gone after quest complete)
var _mq=S.downtown.maQuest;
if(!_mq.complete){
drawMaSitting(400,310);
// Talk highlight
var maH=hover==='maTalkToMa';
if(maH){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(370,240,60,80);T('TALK',400,330,7,'#ff6b35');}
}
// Purse search — couch
if(_mq.purseUnlocked&&!_mq.purseFound&&!_mq.purseChecked.couch){
var pcH=hover==='maPurseCouch';
if(pcH){cx.strokeStyle='#cc88ff';cx.lineWidth=2;cx.strokeRect(300,290,200,50);}
// Subtle sparkle on couch
var _spk=Math.sin(Date.now()/300)*0.3+0.5;
cx.globalAlpha=_spk*0.4;C(350,300,3,'#ffee88');C(450,305,2,'#ffee88');cx.globalAlpha=1;
}
// Staircase — right of center
var stH=hover==='maStaircase';
for(var si=0;si<8;si++){
  R(600+si*14,300-si*18,16,si*18+42,'#5a4a3a');
}
R(598,300,130,4,'#6a5a4a');
cx.strokeStyle='#6a5a4a';cx.lineWidth=2;
cx.beginPath();cx.moveTo(600,300);cx.lineTo(712,156);cx.stroke();
for(var rp=0;rp<5;rp++){R(610+rp*22,300-rp*25-25,3,25,'#6a5a4a');}
if(stH){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(590,100,120,242);T('UPSTAIRS',650,310,7,'#ff6b35');}
// Kitchen doorway — far right
var kH=hover==='maKitchenDoor';
R(820,200,80,140,'#3a3028');R(822,202,76,136,'#2a2018');
// Glimpse of kitchen (bright yellow)
R(824,204,72,132,'#e8dcc0');
T('KITCHEN',860,280,7,kH?'#ff6b35':'#666');
if(kH){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(818,198,84,144);}
// Basement door — under staircase, clearly separate from TV
var bsH=hover==='maBasementDoor';
R(560,280,40,60,'#3a2a1a');R(562,282,36,56,'#2a1a0a');
C(592,310,3,'#aa8844');
T('BSMT',580,350,5,bsH?'#ff6b35':'#555');
if(bsH){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(558,278,44,64);}
// Family photos on wall
for(var pi=0;pi<3;pi++){
  R(250+pi*80,180,30,25,'#5a4a3a');R(252+pi*80,182,26,21,'#ddd');
  C(265+pi*80,188,3,'#d4a574');R(263+pi*80,192,4,8,'#888');
}
// Lamp on side table
R(520,310,30,28,'#5a4a3a');R(530,282,6,28,'#444');C(533,278,10,'#ffee88');
cx.globalAlpha=0.1;C(533,278,20,'#ffee88');cx.globalAlpha=1;
// Old newspapers on coffee table
R(340,340,80,8,'#5a4a3a');R(350,332,30,8,'#ddd');R(352,334,26,4,'#bbb');
// Water stain on ceiling
cx.globalAlpha=0.2;C(350,20,40,'#8a7a5a');C(355,18,25,'#7a6a4a');cx.globalAlpha=1;
// Peeling wallpaper curl — top right
cx.fillStyle='#d0c0a0';cx.beginPath();cx.moveTo(780,0);cx.quadraticCurveTo(770,20,780,40);cx.lineTo(790,40);cx.lineTo(790,0);cx.closePath();cx.fill();
cx.fillStyle='#e8d8b8';cx.beginPath();cx.moveTo(780,0);cx.quadraticCurveTo(775,15,780,30);cx.lineTo(785,30);cx.lineTo(785,0);cx.closePath();cx.fill();
// Crack in wall
cx.strokeStyle='#a09878';cx.lineWidth=0.8;
cx.beginPath();cx.moveTo(500,40);cx.lineTo(510,80);cx.lineTo(505,120);cx.stroke();
// Dust on TV
cx.globalAlpha=0.15;R(172,290,63,4,'#999');cx.globalAlpha=1;
// Ashtray on side table
R(528,305,12,4,'#555');C(534,304,2,'#aaa');
// Baseboard — scuffed
R(0,338,W,4,'#6a5a4a');R(200,338,30,4,'#555');R(600,338,20,4,'#555');
// Tark standing near couch
drawTarkIdle(250,280,false);
}

function drawMaKitchen(){
// Yellowed kitchen
R(0,0,W,H,'#e8dcc0');
// Checkered floor
for(var fy=0;fy<6;fy++){for(var fx2=0;fx2<15;fx2++){
  R(fx2*64,360+fy*20,64,20,(fx2+fy)%2===0?'#c8b898':'#b8a888');
}}
// Doorway back to living room — left wall (smaller arch)
var backH=hover==='maBack';
R(0,220,55,120,'#3a3028');R(2,222,51,116,'#2a2018');
R(4,224,47,112,'#c8b8a0');
// Archway top
cx.fillStyle='#3a3028';cx.beginPath();cx.arc(27,224,26,Math.PI,0);cx.fill();
cx.fillStyle='#c8b8a0';cx.beginPath();cx.arc(27,224,24,Math.PI,0);cx.fill();
if(backH){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(0,200,55,142);T('LIVING RM',27,350,6,'#ff6b35');}
// Cabinets — upper row (5 smaller cabinets, tighter spacing)
for(var ci=0;ci<5;ci++){
  R(100+ci*110,80,95,55,'#7a6a5a');R(102+ci*110,82,91,51,'#6a5a4a');
  C(149+ci*110,108,3,'#aa8844');
}
// Counter
R(80,135,680,15,'#8a7a6a');R(80,150,680,25,'#6a5a4a');
// Fridge — far right, covered in magnets
R(790,80,70,280,'#ddd');R(792,82,66,135,'#ccc');R(792,222,66,135,'#ccc');
C(850,150,3,'#555');C(850,290,3,'#555');
// Magnets
C(810,100,4,'#cc3333');C(830,110,4,'#3366cc');C(815,130,3,'#44aa44');C(835,95,3,'#ffaa22');
C(820,140,4,'#aa44aa');C(805,115,3,'#ff6633');
// Sticky note on fridge — "CALL DOCTOR"
R(810,155,20,18,'#ffff88');T('DR.',820,167,4,'#333');
// Quest: note glow when unread
var _kq2=S.downtown.maQuest;
if(_kq2.started&&!_kq2.pillNoteRead){
var _ng=Math.sin(Date.now()/400)*0.3+0.5;
cx.globalAlpha=_ng*0.6;C(820,164,14,'#ffff44');cx.globalAlpha=1;
R(810,155,20,18,'#ffff88');T('DR.',820,167,4,'#333');
var noteH=hover==='maFridgeNote';
if(noteH){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(808,153,24,22);}
}else if(_kq2.pillNoteRead){
// Show expanded note after read
R(808,150,35,28,'#ffff88');T('DR.',820,162,4,'#333');T('Rx',820,172,3,'#555');
}
// Stove (shorter — doesn't extend below floor line)
R(350,150,100,25,'#555');R(350,175,100,165,'#444');
C(375,162,8,'#333');C(400,162,8,'#333');C(425,162,8,'#333');
// Burner rings
cx.strokeStyle='#666';cx.lineWidth=0.5;
cx.beginPath();cx.arc(375,162,6,0,Math.PI*2);cx.stroke();
cx.beginPath();cx.arc(400,162,6,0,Math.PI*2);cx.stroke();
// Quest: animated flame on first burner
var _kq=S.downtown.maQuest;
if(_kq.started&&!_kq.stoveOff){
var _fl=Math.sin(Date.now()/120)*0.15+0.85;
cx.globalAlpha=_fl*0.7;C(375,162,8,'#ff4400');cx.globalAlpha=_fl*0.4;C(375,162,12,'#ff6600');cx.globalAlpha=_fl*0.15;C(375,158,16,'#ff8800');cx.globalAlpha=1;
// Stove hover
var stoveH=hover==='maStove';
if(stoveH){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(348,148,104,30);T('STOVE',400,145,7,'#ff6b35');}
}else if(_kq.stoveOff){
// Knob turned indicator
R(356,175,8,8,'#555');T('OFF',360,180,4,'#7fdb6a');
}
// Oven door detail
R(358,210,84,50,'#3a3a3a');R(360,212,80,46,'#333');C(400,235,3,'#555');
// Sink under window
R(520,150,100,18,'#888');R(535,138,70,14,'#aaa');R(540,140,60,10,'#667788');
// Dripping faucet
R(570,125,8,13,'#888');R(567,122,14,5,'#888');
var drip=(Date.now()/300)%30;
if(drip<15)C(574,140+drip,2,'#88aacc');
// Window above sink
R(525,55,90,70,'#88aacc');cx.strokeStyle='#888';cx.lineWidth=2;cx.strokeRect(525,55,90,70);
R(569,55,2,70,'#888');R(525,89,90,2,'#888');
// Faded curtains
R(527,57,18,66,'#cc9966');R(595,57,18,66,'#cc9966');
// Kitchen table
R(180,305,130,10,'#7a5a3a');R(188,315,4,35,'#5a4a3a');R(302,315,4,35,'#5a4a3a');
// Coffee mug and newspaper on table
R(220,298,10,7,'#f5f0e0');R(230,301,4,4,'#f5f0e0');
R(250,298,35,7,'#ddd');R(252,300,31,3,'#bbb');
// Quest: purse search spot on table
var _kq3=S.downtown.maQuest;
if(_kq3.purseUnlocked&&!_kq3.purseFound&&!_kq3.purseChecked.kitchen){
var _sp2=Math.sin(Date.now()/350)*0.3+0.5;
cx.globalAlpha=_sp2*0.4;C(245,302,3,'#ffee88');C(210,302,2,'#ffee88');cx.globalAlpha=1;
var ptH=hover==='maPurseTable';
if(ptH){cx.strokeStyle='#cc88ff';cx.lineWidth=2;cx.strokeRect(178,293,134,22);}
}
// Crack in ceiling
cx.strokeStyle='#c8b898';cx.lineWidth=1;
cx.beginPath();cx.moveTo(300,5);cx.lineTo(350,15);cx.lineTo(380,8);cx.stroke();
// Roach
var roachX=700+Math.sin(Date.now()/800)*3;
R(roachX,355,4,2,'#2a1a0a');C(roachX+3,355,1,'#2a1a0a');
// Second roach near stove
R(510,358,3,2,'#2a1a0a');
// Grease stain above stove
cx.globalAlpha=0.15;C(440,140,25,'#8a7a4a');cx.globalAlpha=1;
// Yellow stain on ceiling near fridge
cx.globalAlpha=0.2;C(825,15,20,'#aa9944');cx.globalAlpha=1;
// More ceiling cracks
cx.strokeStyle='#c8b898';cx.lineWidth=0.8;
cx.beginPath();cx.moveTo(500,2);cx.lineTo(550,18);cx.lineTo(600,12);cx.stroke();
// Peeling linoleum at edge
R(100,358,40,6,'#aa9966');R(105,360,15,3,'#666');
// Mouse hole in baseboard
C(760,357,5,'#222');cx.strokeStyle='#444';cx.lineWidth=0.5;cx.beginPath();cx.arc(760,358,5,Math.PI,0);cx.stroke();
// Tark standing near table
drawTarkIdle(180,280,false);
}

function drawMaUpstairs(){
// Upstairs hallway — 3 doors
R(0,0,W,H,'#b8a888');
// Wooden floor planks
for(var fy=340;fy<H;fy+=12){for(var fx2=0;fx2<W;fx2+=80){
  R(fx2,fy,78,10,fy%24===0?'#7a5a3a':'#6a4a2a');
}}
// Worn carpet runner
R(0,355,W,40,'#8a4a4a');R(0,355,W,2,'#aa6a6a');R(0,393,W,2,'#aa6a6a');
// Ceiling
R(0,0,W,40,'#c8b8a0');
// Bare bulb — flickering
var bulbFlicker=Math.sin(Date.now()/300)*0.15+0.85;
R(448,40,4,20,'#444');
cx.globalAlpha=bulbFlicker;C(450,65,6,'#ffee88');cx.globalAlpha=bulbFlicker*0.1;C(450,65,30,'#ffee88');cx.globalAlpha=1;
// Water stain on ceiling
cx.globalAlpha=0.2;C(300,20,25,'#aa8844');C(310,18,15,'#998833');cx.globalAlpha=1;
// Staircase going down — far left (back navigation)
var backH=hover==='maBack';
// Stairwell opening
R(0,280,70,60,'#2a2018');
// Steps going down
for(var ds=0;ds<5;ds++){
  R(0,290+ds*10,65-ds*8,8,'#5a4a3a');
}
// Railing post
R(65,240,6,100,'#6a5a4a');C(68,238,5,'#6a5a4a');
// Railing going down
cx.strokeStyle='#6a5a4a';cx.lineWidth=3;
cx.beginPath();cx.moveTo(68,240);cx.lineTo(10,320);cx.stroke();
if(backH){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(0,240,72,100);T('DOWN',36,350,7,'#ff6b35');}
// Door 1 — Tark's room (left)
var d1H=hover==='maTarkDoor';
R(160,180,80,140,'#5a4a3a');R(162,182,76,136,'#4a3a2a');
C(230,250,3,'#aa8844');
// Stickers on door
R(170,200,20,10,'#cc3333');T('ARNOLD',180,207,4,'#fff');
R(195,220,25,8,'#3366cc');T('GYM',207,226,4,'#fff');
T("TARK'S\nROOM",200,185,6,d1H?'#ff6b35':'#888');
if(d1H){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(158,178,84,144);}
// Door 2 — Ma's room (center)
var d2H=hover==='maMaDoor';
R(400,180,80,140,'#5a4a3a');R(402,182,76,136,'#4a3a2a');
C(410,250,3,'#aa8844');
// Wreath on door
cx.strokeStyle='#3a6a3a';cx.lineWidth=3;
cx.beginPath();cx.arc(440,210,12,0,Math.PI*2);cx.stroke();
C(440,198,3,'#cc3333');
T("MA'S ROOM",440,185,6,d2H?'#ff6b35':'#888');
if(d2H){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(398,178,84,144);}
// Door 3 — Bathroom (right, slightly ajar)
var d3H=hover==='maBathDoor';
R(640,180,80,140,'#5a4a3a');R(642,182,72,136,'#4a3a2a');
// Ajar — light strip
R(712,182,4,136,'#ffee88');cx.globalAlpha=0.05;R(708,182,8,136,'#ffee88');cx.globalAlpha=1;
T('BATH',680,185,6,d3H?'#ff6b35':'#888');
if(d3H){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(638,178,84,144);}
// Wall details — frames between doors
R(290,160,40,30,'#5a4a3a');R(292,162,36,26,'#ddd');C(310,175,4,'#d4a574');R(306,180,8,6,'#888');
R(540,160,40,30,'#5a4a3a');R(542,162,36,26,'#ddd');C(560,175,4,'#d4a574');R(556,180,8,6,'#8b6f8b');
// Tark standing in hallway
drawTarkIdle(770,290,false);
}

function drawMaBasement(){
// Dark sketchy basement
R(0,0,W,H,'#1a1a1a');
// Concrete floor
R(0,360,W,120,'#3a3a3a');
// Cracks in floor
cx.strokeStyle='#2a2a2a';cx.lineWidth=1;
cx.beginPath();cx.moveTo(200,380);cx.lineTo(250,400);cx.lineTo(240,430);cx.stroke();
cx.beginPath();cx.moveTo(600,370);cx.lineTo(580,410);cx.stroke();
// Stairs going up — far left (back navigation)
var backH=hover==='maBack';
// Stair wall
R(0,100,80,240,'#2a2018');
// Steps going up
for(var bs=0;bs<8;bs++){
  R(5+bs*4,290-bs*22,65,20,'#5a4a3a');
  R(7+bs*4,290-bs*22,61,2,'#6a5a4a');
}
// Door frame at top of stairs — light leaking through
R(30,90,45,50,'#3a2a1a');R(32,92,41,46,'#1a1a0a');
cx.globalAlpha=0.3;R(34,94,37,42,'#ffee88');cx.globalAlpha=1;
// Railing
cx.strokeStyle='#6a5a4a';cx.lineWidth=2;
cx.beginPath();cx.moveTo(70,300);cx.lineTo(65,110);cx.stroke();
R(68,108,5,5,'#6a5a4a');
if(backH){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(0,90,80,220);T('UP',40,325,7,'#ff6b35');}
// Bare bulb swinging
var swing=Math.sin(Date.now()/1500)*5;
cx.save();cx.translate(450,0);cx.rotate(swing*Math.PI/180);
R(-2,0,4,40,'#444');
var bulbG=Math.sin(Date.now()/400)*0.1+0.7;
cx.globalAlpha=bulbG;C(0,46,5,'#ffee88');cx.globalAlpha=bulbG*0.08;C(0,46,80,'#ffee88');cx.globalAlpha=1;
cx.restore();
// Washer — center left
var _bq=S.downtown.maQuest;
R(180,280,80,80,'#888');R(182,282,76,50,'#666');C(220,307,20,'#555');C(220,307,15,'#444');
// Quest: washer door states
if(_bq.washerOpen||_bq.dressGot){
// Door open — dark interior showing
R(182,282,76,50,'#222');R(184,284,72,46,'#1a1a1a');
// Hinge
R(182,282,4,50,'#888');
}
if(_bq.dressGot){
// Dress draped over open washer
R(230,270,30,15,'#8b6f8b');R(235,265,20,10,'#7a5e7a');
}else if(_bq.washerOpen){
// Dress visible inside
R(200,295,30,15,'#8b6f8b');
var wGrabH=hover==='maWasher';
if(wGrabH){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(178,278,84,84);T('GRAB',220,370,7,'#ff6b35');}
}else if(_bq.started&&!_bq.dressGot){
// Jammed washer — hover highlight
var wH=hover==='maWasher';
if(wH){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(178,278,84,84);T('WASHER',220,370,7,'#ff6b35');}
}
// Quest: washer kick power meter
if(_bq.washerKicking){
updateWasherKick();
// Meter background
R(150,240,160,16,'#333');R(152,242,156,12,'#222');
// Meter fill
var mFill=_bq.washerMeter;
var mColor=mFill>=0.8?'#7fdb6a':(mFill>=0.5?'#ffcc00':'#ff6b35');
R(152,242,Math.floor(156*mFill),12,mColor);
// Threshold line at 80%
R(152+Math.floor(156*0.8),240,2,16,'#fff');
// Label
T('KICK!',230,235,8,'#ff6b35');
// Time remaining
var tLeft=Math.max(0,6000-(Date.now()-_bq.washerStart));
T(Math.ceil(tLeft/1000)+'s',320,252,7,'#888');
}
// Dryer — right of washer, vibrating
var vib=Math.sin(Date.now()/50)*1;
R(280+vib,280+vib*0.5,80,80,'#888');R(282+vib,282+vib*0.5,76,50,'#777');C(320+vib,307+vib*0.5,18,'#666');
// Stacked boxes
R(600,250,60,50,'#8a6a3a');T('XMAS',630,280,7,'#555');
R(610,210,50,40,'#7a5a2a');T('JUNK',635,235,6,'#555');
R(670,280,50,40,'#8a7a4a');
R(580,290,40,30,'#6a5a3a');T('TARK',600,310,5,'#555');
// Water heater — far right
R(750,150,60,210,'#666');R(752,152,56,206,'#555');
// Pipes going left from heater
R(730,160,20,4,'#555');R(730,200,20,4,'#555');
// Pipes going right from heater — stay on screen
R(810,160,50,4,'#555');R(810,200,50,4,'#555');
// Pipe going up to ceiling
R(830,0,4,160,'#555');R(850,0,4,200,'#555');
// Cobwebs
cx.strokeStyle='rgba(200,200,200,0.15)';cx.lineWidth=0.5;
cx.beginPath();cx.moveTo(100,0);cx.quadraticCurveTo(140,30,180,0);cx.stroke();
cx.beginPath();cx.moveTo(100,0);cx.quadraticCurveTo(120,50,100,80);cx.stroke();
cx.beginPath();cx.moveTo(W,0);cx.quadraticCurveTo(W-40,30,W-80,0);cx.stroke();
cx.beginPath();cx.moveTo(W,0);cx.quadraticCurveTo(W-20,50,W,80);cx.stroke();
// Puddle
cx.globalAlpha=0.3;C(500,390,20,'#334455');cx.globalAlpha=0.15;C(500,390,30,'#334455');cx.globalAlpha=1;
// Tark standing near boxes
drawTarkIdle(480,290,false);
}

function drawMaTarkRoom(){
// Tark's childhood room
R(0,0,W,H,'#6a7a8a');
// Floor
for(var fy=340;fy<H;fy+=12){for(var fx2=0;fx2<W;fx2+=80){
  R(fx2,fy,78,10,fy%24===0?'#7a5a3a':'#6a4a2a');
}}
// Door back to hallway — far left
var backH=hover==='maBack';
R(10,180,70,160,'#5a4a3a');R(12,182,66,156,'#4a3a2a');
C(72,265,3,'#aa8844');
// Sticker on inside of door
R(20,200,18,8,'#44aa44');T('LIFT',29,206,4,'#fff');
if(backH){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(8,178,74,164);T('HALL',45,350,7,'#ff6b35');}
// Mattress on floor (left area)
R(120,350,130,40,'#8a7a6a');R(122,352,126,36,'#aaa898');
R(120,340,40,12,'#888');
// Dirty laundry pile near bed
C(220,400,15,'#445588');C(210,395,12,'#cc3333');C(230,398,10,'#333');C(215,405,8,'#888');
// Quest: purse search on laundry
var _trq=S.downtown.maQuest;
if(_trq.purseUnlocked&&!_trq.purseFound&&!_trq.purseChecked.tarkRoom){
var _sp3=Math.sin(Date.now()/300)*0.3+0.5;
cx.globalAlpha=_sp3*0.4;C(215,395,3,'#ffee88');C(225,400,2,'#ffee88');cx.globalAlpha=1;
var plH=hover==='maPurseLaundry';
if(plH){cx.strokeStyle='#cc88ff';cx.lineWidth=2;cx.strokeRect(195,385,45,30);}
}
// Arnold poster — on back wall (left-center)
R(290,60,110,150,'#222');R(292,62,106,146,'#1a1a1a');
// Simple bodybuilder silhouette
R(325,100,20,55,'#d4a574');C(335,95,12,'#d4a574');
R(305,110,20,8,'#d4a574');R(345,110,20,8,'#d4a574');
T('ARNOLD',345,200,8,'#cc3333');
// Second poster — partially peeling (center)
cx.save();cx.translate(460,65);cx.rotate(0.05);
R(0,0,80,100,'#444');R(2,2,76,96,'#333');
T('PUMP',40,50,10,'#888');T('IRON',40,65,10,'#888');
cx.restore();
// Window with torn curtain (right-center)
R(590,100,90,65,'#88aacc');cx.strokeStyle='#888';cx.lineWidth=2;cx.strokeRect(590,100,90,65);
R(634,100,2,65,'#888');R(590,132,90,2,'#888');
// Torn curtain — left side only
cx.fillStyle='#445588';
cx.beginPath();cx.moveTo(592,102);cx.lineTo(592,155);cx.lineTo(612,150);cx.lineTo(607,125);cx.lineTo(622,102);cx.closePath();cx.fill();
// Desk with trophies (right area)
R(700,280,160,15,'#5a4a3a');R(710,295,4,45,'#5a4a3a');R(850,295,4,45,'#5a4a3a');
// Trophies
R(720,260,10,20,'#cc9944');C(725,258,6,'#cc9944');
R(760,265,8,15,'#cc9944');C(764,263,5,'#cc9944');
R(800,268,8,12,'#aa8833');C(804,266,4,'#aa8833');
// Dumbbells on floor near desk
R(720,360,40,12,'#555');C(718,366,8,'#666');C(762,366,8,'#666');
R(780,375,35,10,'#555');C(778,380,7,'#666');C(817,380,7,'#666');
// Tark standing center-right
drawTarkIdle(560,280,false);
}

function drawMaMaRoom(){
// Ma's bedroom — floral pink
R(0,0,W,H,'#c8a8a8');
// Faint floral pattern
cx.globalAlpha=0.1;
for(var fi=0;fi<15;fi++){
  C(60+fi*62,50+Math.sin(fi)*30,8,'#aa6666');
  C(30+fi*62,120+Math.cos(fi)*20,6,'#aa6666');
}
cx.globalAlpha=1;
// Floor — hardwood
for(var fy=340;fy<H;fy+=12){for(var fx2=0;fx2<W;fx2+=80){
  R(fx2,fy,78,10,fy%24===0?'#8a6a4a':'#7a5a3a');
}}
// Door back to hallway — far left
var backH=hover==='maBack';
R(10,180,70,160,'#5a4a3a');R(12,182,66,156,'#4a3a2a');
C(72,265,3,'#aa8844');
if(backH){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(8,178,74,164);T('HALL',45,350,7,'#ff6b35');}
// Window with lace curtains
R(140,120,100,100,'#88aacc');cx.strokeStyle='#888';cx.lineWidth=2;cx.strokeRect(140,120,100,100);
R(189,120,2,100,'#888');R(140,169,100,2,'#888');
// Lace curtains (dotted pattern)
cx.globalAlpha=0.4;
for(var li=0;li<8;li++){for(var lj=0;lj<8;lj++){
  C(146+li*12,126+lj*12,1,'#fff');
}}
cx.globalAlpha=1;
// Rocking chair near window
R(160,300,40,10,'#5a3a2a');R(165,270,30,30,'#5a3a2a');R(170,260,20,12,'#5a3a2a');
// Rockers
cx.strokeStyle='#5a3a2a';cx.lineWidth=3;
cx.beginPath();cx.arc(180,315,20,0.3,Math.PI-0.3);cx.stroke();
// Bed — double, with quilt
R(330,280,250,70,'#5a3a2a');R(330,260,250,22,'#5a3a2a');
// Quilt pattern
for(var qi=0;qi<5;qi++){for(var qj=0;qj<2;qj++){
  var qc=(qi+qj)%3===0?'#cc8888':(qi+qj)%3===1?'#88aacc':'#88cc88';
  R(335+qi*48,284+qj*30,46,28,qc);
}}
// Pillow
R(340,265,60,16,'#f0e6d3');R(410,265,60,16,'#f0e6d3');
// Medicine bottles on nightstand
R(590,300,30,30,'#5a3a2a');
var _mrq=S.downtown.maQuest;
if(!_mrq.pillsGot){
R(595,290,8,10,'#ff8844');R(605,292,6,8,'#4488cc');R(598,285,10,6,'#fff');
// Quest: pill hover highlight
if(_mrq.started){
var _pGlow=Math.sin(Date.now()/350)*0.2+0.4;
cx.globalAlpha=_pGlow*0.5;C(602,292,14,'#ffee88');cx.globalAlpha=1;
R(595,290,8,10,'#ff8844');R(605,292,6,8,'#4488cc');R(598,285,10,6,'#fff');
var pillH=hover==='maPills';
if(pillH){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(588,280,35,32);T('PILLS',606,275,7,'#ff6b35');}
}
}else{
// Pills collected — empty nightstand
T('\u2713',605,295,8,'#7fdb6a');
}
// Reading glasses
cx.strokeStyle='#888';cx.lineWidth=0.8;
cx.beginPath();cx.arc(602,328,4,0,Math.PI*2);cx.stroke();
cx.beginPath();cx.arc(612,328,4,0,Math.PI*2);cx.stroke();
cx.beginPath();cx.moveTo(606,328);cx.lineTo(608,328);cx.stroke();
// Dresser with mirror
R(680,240,120,30,'#5a3a2a');R(680,270,120,70,'#4a2a1a');
// Drawers
for(var di=0;di<3;di++){R(685,275+di*20,110,16,'#5a3a2a');C(740,283+di*20,2,'#aa8844');}
// Mirror
R(700,120,80,110,'#ddd');cx.strokeStyle='#8a6a4a';cx.lineWidth=3;cx.strokeRect(700,120,80,110);
// Tark standing near dresser
drawTarkIdle(850,290,false);
}

function drawMaBath(){
// Upstairs bathroom
// White tile walls
R(0,0,W,H,'#e8e8e0');
for(var ty=0;ty<340;ty+=25){for(var tx=0;tx<W;tx+=25){
  cx.strokeStyle='#d0d0c8';cx.lineWidth=0.5;cx.strokeRect(tx,ty,25,25);
}}
// Floor — hex tile pattern
R(0,340,W,140,'#ddd');
for(var hy=345;hy<H;hy+=15){for(var hx=0;hx<W;hx+=18){
  C(hx+(hy%30===0?9:0),hy,7,'#ccc');cx.strokeStyle='#bbb';cx.lineWidth=0.3;cx.beginPath();cx.arc(hx+(hy%30===0?9:0),hy,7,0,Math.PI*2);cx.stroke();
}}
// Door back to hallway — far left
var backH=hover==='maBack';
R(10,180,65,160,'#5a4a3a');R(12,182,61,156,'#4a3a2a');
C(67,265,3,'#aa8844');
if(backH){cx.strokeStyle='#ff6b35';cx.lineWidth=2;cx.strokeRect(8,178,69,164);T('HALL',42,350,7,'#ff6b35');}
// Toilet — left of center
R(140,300,40,40,'#f0f0e8');R(135,290,50,12,'#f0f0e8');R(140,280,20,12,'#f0f0e8');
cx.strokeStyle='#ccc';cx.lineWidth=1;cx.strokeRect(140,300,40,40);
// Quest: purse search behind toilet
var _btq=S.downtown.maQuest;
if(_btq.purseUnlocked&&!_btq.purseFound){
var _sp4=Math.sin(Date.now()/300)*0.3+0.5;
cx.globalAlpha=_sp4*0.5;C(130,310,4,'#ffee88');C(180,320,3,'#ffee88');cx.globalAlpha=1;
var ptlH=hover==='maPurseToilet';
if(ptlH){cx.strokeStyle='#cc88ff';cx.lineWidth=2;cx.strokeRect(125,278,65,65);T('CHECK',157,350,6,'#cc88ff');}
}
if(_btq.purseFound){
// Purse visible (already found — show it next to toilet as visual confirmation)
R(125,315,18,14,'#8b6f8b');R(128,313,12,3,'#6a4a5a');C(134,310,2,'#aa8844');
}
// Claw-foot tub — center
R(300,280,250,50,'#f0f0e8');R(302,260,246,22,'#f0f0e8');
cx.strokeStyle='#ccc';cx.lineWidth=2;cx.strokeRect(300,260,250,70);
// Claw feet
C(310,332,5,'#888');C(540,332,5,'#888');
// Water in tub
R(305,265,240,12,'#aaccdd');
// Rubber duck
C(420,264,6,'#ffcc00');C(424,260,3,'#ffcc00');R(426,259,4,2,'#ff8800');C(422,258,1,'#111');
// Faucet on tub
R(530,250,12,15,'#888');R(528,248,16,4,'#888');
// Drip
var drip2=(Date.now()/400)%20;
if(drip2<10)C(536,268+drip2,2,'#88aacc');
// Sink with mirror — right side
R(700,300,80,10,'#f0f0e8');R(710,310,60,30,'#f0f0e8');
R(730,290,20,12,'#888');R(728,288,24,4,'#888');
// Mirror — cracked
R(700,150,80,120,'#dde8ee');cx.strokeStyle='#888';cx.lineWidth=2;cx.strokeRect(700,150,80,120);
// Crack
cx.strokeStyle='#aabbcc';cx.lineWidth=1;
cx.beginPath();cx.moveTo(740,160);cx.lineTo(720,200);cx.lineTo(730,230);cx.lineTo(720,260);cx.stroke();
// Mildew spots
cx.globalAlpha=0.2;
C(100,50,8,'#6a8a6a');C(200,30,6,'#6a8a6a');C(150,100,5,'#6a8a6a');C(820,80,7,'#6a8a6a');
cx.globalAlpha=1;
// Towel rack
R(600,180,4,80,'#888');R(605,200,60,3,'#fff');R(605,220,50,3,'#aacccc');
// Tark standing by sink
drawTarkIdle(850,290,false);
}

// === DOWNTOWN ACTION FUNCTIONS ===

function doDowntownBar(){
if(S.busy)return;
lock();
walkTo(LAYOUT.downtown.barX,function(){
S.downtown.subMenu='bar';
S.downtown.barVisited=true;
log('Tark pushes through the heavy door. Stale beer and bad decisions.','info');
if(!S.thoughtSeen['dt_bar']){S.thoughtSeen['dt_bar']=true;narrateScene();}
unlock();updUI();renderControls();
});
}
function doDowntownBodega(){
if(S.busy)return;
lock();
walkTo(LAYOUT.downtown.bodegaX,function(){
S.downtown.subMenu='bodega';
S.downtown.bodegaVisited=true;
log('The bell jingles. Fluorescent lights and everything you need for a dollar.','info');
if(!S.thoughtSeen['dt_bodega']){S.thoughtSeen['dt_bodega']=true;narrateScene();}
unlock();updUI();renderControls();
});
}
function doDowntownHotel(){
if(S.busy)return;
lock();
walkTo(LAYOUT.downtown.hotelX,function(){
S.downtown.subMenu='hotel';
S.downtown.hotelVisited=true;
log('The lobby smells like carpet cleaner and regret.','info');
if(!S.thoughtSeen['dt_hotel']){S.thoughtSeen['dt_hotel']=true;narrateScene();}
unlock();updUI();renderControls();
});
}
function exitDowntownBuilding(){
S.downtown.subMenu=null;
updUI();renderControls();
}
// === MA'S HOUSE ACTION FUNCTIONS ===
function doDowntownMaHouse(){
if(S.busy)return;
lock();
walkTo(30,function(){
S.downtown.subMenu='ma_house';
S.downtown.maHouseVisited=true;
log("Tark heads down the block to Ma's house.","info");
if(!S.thoughtSeen['dt_ma_house']){S.thoughtSeen['dt_ma_house']=true;narrateScene();}
unlock();updUI();renderControls();
});
}
function doEnterMaLiving(){
if(S.busy)return;
S.downtown.subMenu='ma_living';
log("Tark pushes the front door open. It creaks like always.","info");
if(!S.thoughtSeen['ma_living']){S.thoughtSeen['ma_living']=true;narrateScene();}
}
function doEnterMaKitchen(){
if(S.busy)return;
S.downtown.subMenu='ma_kitchen';
log("Tark walks into the kitchen. Something's always dripping.","info");
if(!S.thoughtSeen['ma_kitchen']){S.thoughtSeen['ma_kitchen']=true;narrateScene();}
}
function doEnterMaUpstairs(){
if(S.busy)return;
S.downtown.subMenu='ma_upstairs';
log("The stairs groan under Tark's weight. Every. Single. Step.","info");
if(!S.thoughtSeen['ma_upstairs']){S.thoughtSeen['ma_upstairs']=true;narrateScene();}
}
function doEnterMaBasement(){
if(S.busy)return;
S.downtown.subMenu='ma_basement';
log("Tark opens the basement door. Cold air hits his face.","info");
if(!S.thoughtSeen['ma_basement']){S.thoughtSeen['ma_basement']=true;narrateScene();}
}
function doEnterMaTarkRoom(){
if(S.busy)return;
S.downtown.subMenu='ma_tark_room';
log("Tark opens the door to his old room. Smells like high school.","info");
if(!S.thoughtSeen['ma_tark_room']){S.thoughtSeen['ma_tark_room']=true;narrateScene();}
}
function doEnterMaMaRoom(){
if(S.busy)return;
S.downtown.subMenu='ma_ma_room';
log("Tark peeks into Ma's room. Lavender and old memories.","info");
if(!S.thoughtSeen['ma_ma_room']){S.thoughtSeen['ma_ma_room']=true;narrateScene();}
}
function doEnterMaBath(){
if(S.busy)return;
S.downtown.subMenu='ma_bath';
log("Tark opens the bathroom door. The mildew hits different.","info");
if(!S.thoughtSeen['ma_bath']){S.thoughtSeen['ma_bath']=true;narrateScene();}
}
function exitMaHouse(){
S.downtown.subMenu=null;
updUI();renderControls();
}
function maHouseBack(target){
S.downtown.subMenu=target;
updUI();renderControls();
}

// === MA'S HOUSE QUEST: Getting Ma Ready for Breakfast ===
var MA_NAG_LINES=[
'"Are you done yet?"',
'"I\'m not getting any younger, Tark."',
'"What\'s taking so long?"',
'"I could\'ve walked to the restaurant by now."',
'"TARK!"'
];
var maNagIdx=0;

function maQuestDoneCount(){
var q=S.downtown.maQuest;
return (q.stoveOff?1:0)+(q.dressGot?1:0)+(q.pillsGot?1:0)+(q.purseFound?1:0);
}
function maQuestFirstThreeDone(){
var q=S.downtown.maQuest;
return (q.stoveOff?1:0)+(q.dressGot?1:0)+(q.pillsGot?1:0);
}

function doTalkToMa(){
if(S.busy)return;
var q=S.downtown.maQuest;
if(q.complete)return;

// Quest not started — intro dialogue
if(!q.started){
lock();
S.speechBubble={text:'"TARKY! You\'re late!"',x:400,y:240,life:2.0,fontSize:10};
log('Ma: "TARKY! You\'re late!"','info');
setTimeout(function(){
S.speechBubble={text:'"My dress is in that washer. Been down there three days."',x:400,y:240,life:3.0,fontSize:8};
log('Ma: "My dress is in that washer."','info');
},2200);
setTimeout(function(){
S.speechBubble={text:'"Bring me my pills from upstairs. And TURN OFF that stove!"',x:400,y:240,life:3.0,fontSize:8};
log('Ma: "Bring me my pills. And TURN OFF that stove!"','info');
},5500);
setTimeout(function(){
float('This is gonna take a while.',450,200,'#888',10);
q.started=true;
unlock();updUI();renderControls();
},8800);
return;
}

// All 4 done — quest complete
if(q.stoveOff&&q.dressGot&&q.pillsGot&&q.purseFound){
doMaQuestComplete();
return;
}

// 2+ of first 3 done and purse not unlocked — reveal purse task
if(maQuestFirstThreeDone()>=2&&!q.purseUnlocked){
lock();
S.speechBubble={text:'"Oh! And my PURSE! Where did I put that thing?!"',x:400,y:240,life:3.0,fontSize:8};
log('Ma: "Where\'s my PURSE?!"','info');
setTimeout(function(){
q.purseUnlocked=true;
float('Find Ma\'s purse...',450,200,'#cc88ff',10);
unlock();updUI();renderControls();
},3200);
return;
}

// Nag line
S.speechBubble={text:MA_NAG_LINES[maNagIdx%MA_NAG_LINES.length],x:400,y:240,life:2.0,fontSize:9};
maNagIdx++;
}

// --- STOVE (Kitchen) ---
function doStoveClick(){
if(S.busy)return;
var q=S.downtown.maQuest;
if(!q.started||q.stoveOff)return;
q.stoveClicks++;
if(q.stoveClicks===1){
float('Knob won\'t budge.',350,200,'#888',10);
log('Tark grabs the stove knob. It\'s stuck.','info');
}else if(q.stoveClicks===2){
float('Come on...',350,200,'#ff6b35',10);
log('Tark twists harder. The knob creaks.','info');
}else if(q.stoveClicks>=3){
q.stoveOff=true;
float('STOVE OFF',350,180,'#7fdb6a',14);
log('Tark wrenches the knob. The flame dies.','hype');
}
}

// --- WASHER (Basement) ---
function doWasherClick(){
if(S.busy)return;
var q=S.downtown.maQuest;
if(!q.started||q.dressGot)return;

// Washer open — grab dress
if(q.washerOpen&&!q.dressGot){
q.dressGot=true;
float('GOT THE DRESS',220,250,'#cc88ff',14);
log('Tark pulls Ma\'s dress out of the washer. It\'s damp but it\'ll do.','hype');
return;
}

// Start kicking
if(!q.washerKicking&&!q.washerOpen){
q.washerKicking=true;
q.washerMeter=0;
q.washerStart=Date.now();
float('KICK IT!',220,250,'#ff6b35',12);
log('The washer door is jammed. Time to kick it.','info');
}
}

function doWasherKickClick(){
if(!S.downtown.maQuest.washerKicking)return;
S.downtown.maQuest.washerMeter=Math.min(1,S.downtown.maQuest.washerMeter+0.09);
}

function updateWasherKick(){
var q=S.downtown.maQuest;
if(!q.washerKicking)return;
// Drain meter
q.washerMeter=Math.max(0,q.washerMeter-0.012);
// Check success
if(q.washerMeter>=0.8){
q.washerKicking=false;
q.washerOpen=true;
float('WHAM!',220,250,'#ff6b35',16);
log('The door pops open!','hype');
}
// Check timeout (6 seconds)
if(Date.now()-q.washerStart>6000){
q.washerKicking=false;
q.washerMeter=0;
float('Not enough. Try harder.',220,280,'#ff4444',10);
log('The door held. Kick harder next time.','fail');
}
}

// --- PILLS (Ma's Room / Kitchen) ---
function doPillNoteClick(){
if(S.busy)return;
var q=S.downtown.maQuest;
if(!q.started||q.pillNoteRead)return;
q.pillNoteRead=true;
lock();
S.speechBubble={text:'TAKE ORANGE + BLUE. AM. \u2014Dr. Patel',x:450,y:200,life:3.5,fontSize:9};
float('PILLS: ORANGE + BLUE',450,160,'#cc88ff',11);
log('The note on the fridge: "Take orange + blue. AM. \u2014Dr. Patel"','info');
setTimeout(function(){unlock();},1500);
}

function doPillsClick(){
if(S.busy)return;
var q=S.downtown.maQuest;
if(!q.started||q.pillsGot)return;

if(!q.pillNoteRead){
float('Which ones? There\'s gotta be a note somewhere...',450,200,'#888',9);
log('Three bottles. Tark has no idea which ones Ma takes.','info');
return;
}

q.pillsGot=true;
float('GOT THE PILLS',450,200,'#7fdb6a',14);
log('Tark grabs the orange and blue bottles. Morning pills. Got it.','hype');
}

// --- PURSE (Multi-room search) ---
function doPurseSearch(spot){
if(S.busy)return;
var q=S.downtown.maQuest;
if(!q.purseUnlocked||q.purseFound)return;

if(spot==='couch'){
if(q.purseChecked.couch)return;
q.purseChecked.couch=true;
float('Just crumbs and a remote from 2003.',400,280,'#888',9);
log('Tark checks under the couch cushions. No purse.','info');
}else if(spot==='kitchen'){
if(q.purseChecked.kitchen)return;
q.purseChecked.kitchen=true;
float('Newspapers and a dead roach. No purse.',400,280,'#888',9);
log('Tark checks the kitchen table. No purse.','info');
}else if(spot==='tarkRoom'){
if(q.purseChecked.tarkRoom)return;
q.purseChecked.tarkRoom=true;
float('Under my old gym shorts? ...no.',400,280,'#888',9);
log('Tark digs through his old laundry pile. Nope.','info');
}else if(spot==='bathroom'){
q.purseFound=true;
float('FOUND THE PURSE',450,200,'#7fdb6a',14);
log('Behind the toilet. Of course. Classic Ma.','hype');
}
}

// --- QUEST COMPLETE ---
function doMaQuestComplete(){
if(S.busy)return;
lock();
S.speechBubble={text:'"...well? Let\'s GO before I change my mind."',x:400,y:240,life:3.0,fontSize:8};
log('Ma: "Let\'s GO before I change my mind."','hype');
setTimeout(function(){
S.speechBubble={text:'Ma slowly stands up. It takes a minute.',x:400,y:240,life:2.5,fontSize:9};
},3200);
setTimeout(function(){
S.downtown.maQuest.complete=true;
S.downtown.maQuest.maAtMeet=true;
// Narration overlay
float('Continental Breakfast. Free.',450,140,'#ffcc00',12);
log('Tark takes Ma to the Continental Breakfast at the hotel.','hype');
log('She complains the whole way. The eggs are powdered. She loves it.','rest');
},6000);
setTimeout(function(){
S.swagger=clamp(S.swagger+15,0,100);
S.focus=clamp(S.focus+10,0,100);
S.nervousness=Math.max(0,S.nervousness-10);
float('+15 SWAGGER',420,180,'#ff6b35',12);
float('+10 FOCUS',480,180,'#cc88ff',12);
float('-10 NERVES',450,200,'#7fdb6a',12);
S.downtown.subMenu='ma_house';
unlock();updUI();renderControls();
},8500);
}

// Window exports for quest functions
window.doTalkToMa=doTalkToMa;window.doStoveClick=doStoveClick;
window.doWasherClick=doWasherClick;window.doWasherKickClick=doWasherKickClick;window.updateWasherKick=updateWasherKick;
window.doPillNoteClick=doPillNoteClick;window.doPillsClick=doPillsClick;
window.doPurseSearch=doPurseSearch;window.doMaQuestComplete=doMaQuestComplete;
window.maQuestDoneCount=maQuestDoneCount;window.maQuestFirstThreeDone=maQuestFirstThreeDone;

function doDowntownExit(){
if(S.busy)return;
S.mapOpen=true;
}
function doDowntownExitChoice(dest){
if(S.busy)return;
lock();
S.downtown.subMenu=null;
if(dest==='apartment'){
log('Tark heads back to the apartment.','phase');
S.sceneTransition={
progress:0,duration:40,
midCallback:function(){
setPhase('apartment');
S.homeX=LAYOUT.apartment.homeX;
S.tX=LAYOUT.apartment.doorX;S.pose='idle';
},
endCallback:function(){
walkTo(LAYOUT.apartment.homeX,function(){
unlock();
log('Back in the apartment. The mattress beckons.','phase');
});
}
};
}else if(dest==='beach'){
log('Tark heads to Venice Beach. Sun and trouble.','phase');
S.sceneTransition={
progress:0,duration:40,
midCallback:function(){
setPhase('beach');
S.homeX=LAYOUT.beach.homeX;
S.tX=-30;S.pose='idle';
},
endCallback:function(){
walkTo(LAYOUT.beach.homeX,function(){
unlock();
log('Venice Beach. Sun, sand, strangers.','phase');
});
}
};
}else{
log('Tark heads to the gym. Time to work.','phase');
S.sceneTransition={
progress:0,duration:40,
midCallback:function(){
setPhase('gym');
S.homeX=LAYOUT.gym.homeX;
S.tX=-30;S.pose='idle';
},
endCallback:function(){
walkTo(LAYOUT.gym.homeX,function(){
unlock();
log('Tark Farley stands in his gym. The barbell awaits.','phase');
});
}
};
}
}
window.doDowntownBar=doDowntownBar;
window.doDowntownBodega=doDowntownBodega;
window.doDowntownHotel=doDowntownHotel;
window.exitDowntownBuilding=exitDowntownBuilding;
window.doDowntownExit=doDowntownExit;
window.doDowntownExitChoice=doDowntownExitChoice;
window.doDowntownMaHouse=doDowntownMaHouse;
window.doEnterMaLiving=doEnterMaLiving;
window.doEnterMaKitchen=doEnterMaKitchen;
window.doEnterMaUpstairs=doEnterMaUpstairs;
window.doEnterMaBasement=doEnterMaBasement;
window.doEnterMaTarkRoom=doEnterMaTarkRoom;
window.doEnterMaMaRoom=doEnterMaMaRoom;
window.doEnterMaBath=doEnterMaBath;
window.exitMaHouse=exitMaHouse;
window.maHouseBack=maHouseBack;

// === MAP TRAVEL FUNCTION ===
function doMapTravel(dest){
if(S.busy)return;
var currentPhase=S.phase;
var atMaHouse=(currentPhase==='downtown'&&S.downtown.subMenu&&S.downtown.subMenu.indexOf('ma_')===0);
// Can't travel to current location
if(dest===currentPhase&&!atMaHouse){S.mapOpen=false;return;}
if(dest==='ma_house'&&atMaHouse){S.mapOpen=false;return;}
// Ma's house locked before calling mother
if(dest==='ma_house'&&!(S.apartment&&S.apartment.motherMission)){
S.mapOpen=false;float('Call your mother first...',450,200,'#888',10);return;
}
// Downtown <-> Ma's House is a sub-menu change, not phase change
if(dest==='ma_house'&&currentPhase==='downtown'&&!atMaHouse){
S.mapOpen=false;doDowntownMaHouse();return;
}
if(dest==='downtown'&&atMaHouse){
S.mapOpen=false;exitMaHouse();return;
}
S.mapOpen=false;
lock();
// Departure effects based on current phase
if(currentPhase==='apartment'){
if(S.swagger>0){var nr=Math.round(S.swagger*0.3);S.nervousness=Math.max(0,S.nervousness-nr);if(nr>0)log('Swagger converted: NERVES-'+nr+'.','hype');}
if(S.hungry){S.fatigue=clamp(S.fatigue+0.1,0,1);log('Empty stomach. Fatigue will hit harder today.','fail');}
S.apartment.subMenu=null;
}
if(currentPhase==='beach'){
if(S.swagger>0){var nr2=Math.round(S.swagger*0.2);S.nervousness=Math.max(0,S.nervousness-nr2);if(nr2>0)log('Beach swagger: NERVES-'+nr2+'.','hype');}
if(S.humiliated>0){
var en=S.humiliated*5,ef=S.humiliated*3;
S.nervousness=clamp(S.nervousness+en,0,100);S.focus=Math.max(0,S.focus-ef);
log("Tark can't shake what happened at the beach. The humiliation lingers.",'fail');
if(S.humiliated>=2)log('His hands are shaking. Not from the cold.','fail');
if(S.humiliated>=3)log('He keeps replaying it. '+S.humiliatedBy+"'s laugh echoes in his head.",'fail');
}
}
if(currentPhase==='downtown'){S.downtown.subMenu=null;}
// Determine target phase
var destPhase=(dest==='ma_house')?'downtown':dest;
var travelLogs={apartment:'Tark heads back to the apartment.',beach:'Tark heads to Venice Beach. Sun and trouble.',downtown:'Tark heads downtown. Concrete and neon.',gym:'Tark heads to the gym. All business.',ma_house:"Tark heads to Ma's house."};
log(travelLogs[dest]||'Tark is on the move.','phase');
S.sceneTransition={
progress:0,duration:40,
midCallback:function(){
setPhase(destPhase);
S.homeX=LAYOUT[destPhase].homeX;
S.tX=-30;S.pose='idle';
if(dest==='ma_house'){S.downtown.subMenu='ma_house';S.downtown.maHouseVisited=true;}
},
endCallback:function(){
walkTo(LAYOUT[destPhase].homeX,function(){
unlock();
var arrLogs={apartment:'Back in the apartment. The mattress beckons.',beach:'Venice Beach. Sun, sand, strangers.',downtown:'Downtown. A dive bar, a bodega, and a hotel.',gym:'Tark Farley stands in his gym. The barbell awaits.',ma_house:"Ma's house. The porch light flickers."};
log(arrLogs[dest]||'','phase');
if(dest==='gym'){log('Click the bench, rack, shaker, or cig pack. Or use the buttons.','rest');log("When you're ready, enter the meet.",'rest');}
if(dest==='ma_house'&&!S.thoughtSeen['dt_ma_house']){S.thoughtSeen['dt_ma_house']=true;narrateScene();}
});
}
};
}
function doGymExit(){if(S.busy)return;S.mapOpen=true;}
window.doMapTravel=doMapTravel;
window.doGymExit=doGymExit;

// --- BEACH ACTION FUNCTIONS ---

function doBeachApproachCouple(idx){
  if(S.busy)return;
  var couple=S.beach.couples[idx];
  if(couple.gone||couple.cowered){log(BEACH_COUPLE_NAMES[idx]+' already dealt with.','rest');return;}
  lock();
  var destX=[LAYOUT.beach.couple0X,LAYOUT.beach.couple1X,LAYOUT.beach.couple2X][idx];
  walkTo(destX,function(){
    S.beach.subMenu='couple';
    S.beach.activeCouple=idx;
    S.pose='idle';
    unlock();updUI();renderControls();
  });
}

function doBeachCancelSubMenu(){
  S.beach.subMenu=null;
  S.beach.activeCouple=null;
  S.beach.closeupAnim=null;S.beach.closeupAnimT=0;
  S.beach.closeupDebris=[];
  walkBack(function(){unlock();updUI();renderControls();});
}

// --- INTIMIDATION SYSTEM ---
// Man's PROACTIVE counter-actions by intimidation level
// Each entry: {action: what he DOES, speech: what he SAYS}
var INTIM_ACT_CONFIDENT=[
  {a:' flexes his arms and smirks.',s:'"That\'s cute."'},
  {a:' puts his arm around his girlfriend.',s:'"Who is this clown, babe?"'},
  {a:' laughs and cracks his knuckles.',s:'"You done?"'},
  {a:' looks Tark up and down.',s:'"Check out Mr. Tough Guy."'},
  {a:' steps forward and puffs his chest.',s:'"Keep walking, buddy."'}
];
var INTIM_ACT_HOLDING=[
  {a:' crosses his arms defiantly.',s:'"I\'m not going anywhere."'},
  {a:' puffs out his chest and stands taller.',s:'"Whatever, bro."'},
  {a:' spits on the ground.',s:'"Real impressive."'},
  {a:' squares up his shoulders.',s:'"That all you got?"'},
  {a:' rolls his eyes at his girlfriend.',s:'"Can you believe this guy?"'}
];
var INTIM_ACT_NERVOUS=[
  {a:' shifts his weight nervously.',s:'"Babe, maybe we should..."'},
  {a:' looks at his girlfriend, then back at Tark.',s:'"Okay, let\'s all just..."'},
  {a:' takes a half step back.',s:'"I don\'t think—"'},
  {a:' runs his hand through his hair.',s:'"..."'},
  {a:' uncrosses his arms. Recrosses them.',s:'"Look, we don\'t want trouble."'}
];
var INTIM_ACT_BREAKING=[
  {a:' backs away, hands up.',s:'"I... okay."'},
  {a:' looks at the ground.',s:'"Please."'},
  {a:' turns halfway toward the exit.',s:'"We\'re leaving."'},
  {a:' drops his arms to his sides.',s:'"*trembling*"'},
  {a:' can barely make eye contact.',s:'"Don\'t... don\'t."'}
];
var INTIM_ACT_ANGRY=[
  {a:' steps right up to Tark\'s face.',s:'"You want to GO?"'},
  {a:' jabs a finger at Tark\'s chest.',s:'"That\'s IT."'},
  {a:' clenches his fists and squares up.',s:'"Weights. You and me. NOW."'},
  {a:' gets in Tark\'s face.',s:'"You picked the wrong couple."'},
  {a:' shoves Tark\'s shoulder.',s:'"Let\'s settle this at the rack."'}
];

function addBeachIntimidation(ci,baseAmount,actionType){
  var couple=S.beach.couples[ci];
  var toughness=couple.toughness;
  // Apply toughness modifier + small randomness
  var modifier=1.0-toughness*0.5;
  var gain=Math.round(baseAmount*modifier+(Math.random()*6-3));
  couple.intimidation=Math.max(-30,Math.min(100,couple.intimidation+gain));
  couple.actionCount++;
  var il=couple.intimidation;
  var name=BEACH_COUPLE_NAMES[ci];
  // Show intimidation change float
  if(gain>0){
    float('+'+gain+' INTIM',620,300,'#ffcc00',14);
  }else if(gain<0){
    float(gain+' INTIM',620,300,'#ff4444',14);
  }
  // Man ACTS BACK — picks a proactive counter-action based on level
  var pool;
  if(il<-5)pool=INTIM_ACT_ANGRY;
  else if(il<20)pool=INTIM_ACT_CONFIDENT;
  else if(il<40)pool=INTIM_ACT_HOLDING;
  else if(il<60)pool=INTIM_ACT_NERVOUS;
  else pool=INTIM_ACT_BREAKING;
  var react=pick(pool);
  // Log what he DOES, then what he SAYS
  log(name+react.a,'rest');
  S.speechBubble={text:react.s,x:620,y:350,life:2.0,fontSize:10};
  // Man react animation (brief pause so player sees his move)
  S.beach.closeupAnim='manReact';S.beach.closeupAnimT=0;
  setTimeout(function(){
    S.beach.closeupAnim=null;S.beach.closeupAnimT=0;
    checkBeachThresholds(ci,actionType);
  },2200);
}

function checkBeachThresholds(ci,actionType){
  var couple=S.beach.couples[ci];
  var il=couple.intimidation;
  var ac=couple.actionCount;
  // Cower threshold: intimidation >= 80
  if(il>=80){
    resolveBeachOutcome(ci,true,actionType);
    return;
  }
  // Challenge threshold: intimidation <= -20 OR too many actions without cower
  if(il<=-20||(ac>=6&&il<60)){
    resolveBeachOutcome(ci,false,actionType);
    return;
  }
  // Otherwise: continue — unlock so player can pick next action
  S.pose='idle';S.poseT=0;
  unlock();updUI();renderControls();
}

function doBeachSmoke(ci){
  if(S.busy)return;
  lock();
  try{SFX.lighterFlick();}catch(e){}
  S.pose='smoke';S.poseT=0;
  log('Tark lights up right in front of them. Casual.','smoke');
  S.speechBubble={text:pick(['"Want one?"','"Morning."','"Nice day."']),x:180,y:295,life:1.5,fontSize:10};
  setTimeout(function(){
    S.focus=clamp(S.focus+3,0,100);
    float('+3 FOC',220,310,'#cc88ff',11);
    S.pose='idle';S.poseT=0;
    // Flick the cigarette butt at him
    S.beach.closeupAnim='cigFlick';S.beach.closeupAnimT=0;
    log('Tark flicks his cigarette butt at '+BEACH_COUPLE_NAMES[ci]+'.','hype');
    setTimeout(function(){
      // Leave butt on the ground near his feet
      S.beach.closeupDebris.push({type:'cig',x:620-Math.round(Math.random()*30),y:468});
      S.beach.closeupAnim=null;S.beach.closeupAnimT=0;
      float('FLICK',500,420,'#ff8844',12);
      addBeachIntimidation(ci,15,'smoke');
    },900);
  },2200);
}

function doBeachBeer(ci){
  if(S.busy)return;
  if(S.beach.beersLeft<=0){log('No beers left.','fail');return;}
  lock();
  S.beach.beersLeft--;
  S.pose='drinking';S.poseT=0;
  log('Tark cracks one open. Drinks it without breaking eye contact.','hype');
  S.speechBubble={text:pick(['"Cheers."','"Ahhhh."','"Refreshing."']),x:180,y:295,life:1.5,fontSize:10};
  setTimeout(function(){
    S.swagger=clamp(S.swagger+4,0,100);
    S.nervousness=clamp(S.nervousness+3,0,100);
    S.focus=clamp(S.focus-2,0,100);
    float('+4 SWAG',220,290,'#ffcc00',11);
    float('+3 NERV',220,310,'#ff4444',10);
    float('-2 FOC',220,330,'#cc88ff',10);
    S.pose='idle';S.poseT=0;
    // Chuck the can at his feet
    S.beach.closeupAnim='beerChuck';S.beach.closeupAnimT=0;
    log('Tark chucks the empty can at '+BEACH_COUPLE_NAMES[ci]+'\'s feet.','hype');
    setTimeout(function(){
      // Leave can on the ground near his feet
      S.beach.closeupDebris.push({type:'can',x:560+Math.round(Math.random()*40),y:468});
      S.beach.closeupAnim=null;S.beach.closeupAnimT=0;
      float('TINK',540,440,'#cc8800',12);
      var swagBonus=Math.round(S.swagger*0.04);
      addBeachIntimidation(ci,18+swagBonus,'beer');
    },1000);
  },2500);
}

function doBeachFlirt(ci){
  if(S.busy)return;
  lock();
  S.pose='idle';S.poseT=0;
  log('Tark turns on the charm.','hype');
  S.speechBubble={text:pick(['"Hey there."','"Come here often?"','"You look like you need better company."','"Smile at me like that again."']),x:180,y:295,life:1.8,fontSize:9};
  setTimeout(function(){
    S.swagger=clamp(S.swagger+3,0,100);
    float('+3 SWAG',220,300,'#ffcc00',11);
    S.pose='idle';S.poseT=0;
    addBeachIntimidation(ci,10,'flirt');
  },2200);
}

function doBeachSituation(ci){
  if(S.busy)return;
  lock();
  S.beach.closeupAnim='shirtoff';S.beach.closeupAnimT=0;
  S.pose='idle';S.poseT=0;
  log('Tark peels off his shirt. The girlfriend stares.','hype');
  S.speechBubble={text:pick(['"Sorry, is it hot out here?"','"Don\'t mind me."','"Just getting some sun."']),x:180,y:295,life:2.0,fontSize:9};
  setTimeout(function(){
    S.beach.closeupAnim=null;S.beach.closeupAnimT=0;
    S.swagger=clamp(S.swagger+5,0,100);
    float('+5 SWAG',220,290,'#ffcc00',12);
    S.pose='idle';S.poseT=0;
    var strBonus=Math.round(S.strength*0.05);
    addBeachIntimidation(ci,22+strBonus,'situation');
  },2500);
}

function doBeachInsult(ci){
  if(S.busy)return;
  lock();
  var insults=[
    '"Nice shirt. Does it come in men\'s?"',
    '"She\'s way too hot for you, bro."',
    '"You look like you bench the bar."',
    '"Bro, even your tan is weak."',
    '"That\'s your girlfriend? My condolences... to her."',
    '"You peaked in high school, huh."',
    '"Your calves are smaller than her wrists."'
  ];
  S.speechBubble={text:pick(insults),x:180,y:290,life:2.5,fontSize:9};
  S.pose='idle';S.poseT=0;
  log('Tark drops an insult.','hype');
  S.beach.closeupAnim='manReact';S.beach.closeupAnimT=0;
  setTimeout(function(){
    S.swagger=clamp(S.swagger+4,0,100);
    float('+4 SWAG',220,290,'#ffcc00',12);
    S.beach.closeupAnim=null;S.beach.closeupAnimT=0;
    addBeachIntimidation(ci,15,'insult');
  },2500);
}

function resolveBeachOutcome(ci,cowered,actionType){
  var couple=S.beach.couples[ci];
  var name=BEACH_COUPLE_NAMES[ci];

  if(cowered){
    couple.cowered=true;
    couple.lady=true;
    log(name+' can\'t take it anymore. He grabs his towel and slinks away.','hype');
    float('HE BROKE!',450,260,'#ffcc00',18);
    // Resolution bonus stats
    S.focus=clamp(S.focus+15,0,100);
    S.nervousness=Math.max(0,S.nervousness-15);
    S.swagger=clamp(S.swagger+10,0,100);
    float('+15 FOC',400,290,'#cc88ff',12);
    float('-15 NERV',400,310,'#7fdb6a',12);
    float('+10 SWAG',400,330,'#ffcc00',12);
    // Man slumps and walks away
    S.beach.closeupAnim='manCower';S.beach.closeupAnimT=0;
    setTimeout(function(){
      // Woman walks over to Tark
      S.beach.closeupAnim='womanApproach';S.beach.closeupAnimT=0;
      S.speechBubble={text:pick(['"...wow"','"Hi there"','"That was intense"','"My hero"']),x:400,y:330,life:2.0,fontSize:10};
      setTimeout(function(){
        // Tark and woman walk off together
        S.beach.closeupAnim='coupleWalkOff';S.beach.closeupAnimT=0;
        setTimeout(function(){
          // === BATHROOM SCENE ===
          S.beach.closeupAnim='bathroomCut';S.beach.closeupAnimT=0;
          log('Meanwhile, at the beach facilities...','rest');
          setTimeout(function(){
            S.beach.closeupAnim='bathroomApproach';S.beach.closeupAnimT=0;
            S.speechBubble={text:'"Yeah, I like really deep stuff\u2026like Tarantino"',x:640,y:330,life:3.5,fontSize:9};
            log('Tark: "Yeah, I like really deep stuff...like Tarantino"','hype');
            setTimeout(function(){
              S.beach.closeupAnim='bathroomEnter';S.beach.closeupAnimT=0;
              log('They disappear into the stall. The door swings shut.','rest');
              setTimeout(function(){
                S.beach.closeupAnim='bathroomBubble';S.beach.closeupAnimT=0;
                S.speechBubble={text:'"Oh Tark..."',x:455,y:160,life:2.5,fontSize:12};
                log('"Oh Tark..."','rest');
                setTimeout(function(){
                  S.speechBubble={text:'"...oh GOD..."',x:470,y:150,life:2.5,fontSize:11};
                },2000);
                setTimeout(function(){
                  S.speechBubble={text:'"*moan*"',x:445,y:145,life:2.0,fontSize:11};
                },3800);
                setTimeout(function(){
                  S.beach.closeupAnim='tarkExit';S.beach.closeupAnimT=0;
                  S.speechBubble={text:'"Later, bro."',x:550,y:350,life:2.5,fontSize:11};
                  log('Tark walks out. Doesn\'t look back.','hype');
                  setTimeout(function(){
                    S.beach.closeupAnim='girlExit';S.beach.closeupAnimT=0;
                    S.speechBubble={text:'"Babe..."',x:300,y:370,life:2.0,fontSize:11};
                    log('She walks out. Fixes her hair.','rest');
                    setTimeout(function(){
                      S.beach.closeupAnim='coupleReunite';S.beach.closeupAnimT=0;
                      log('They walk off together. Life goes on.','rest');
                      setTimeout(function(){
                        S.beach.closeupAnim=null;S.beach.closeupAnimT=0;
                        S.beach.closeupDebris=[];
                        S.beach.canLeave=true;
                        S.beach.subMenu=null;
                        S.beach.activeCouple=null;
                        S.pose='idle';S.poseT=0;
                        unlock();updUI();renderControls();
                      },3500);
                    },3000);
                  },3500);
                },5000);
              },2000);
            },3500);
          },1500);
        },2000);
      },2000);
    },2200);
  }else{
    couple.challenged=true;
    log(name+' has had enough. He steps up. "THE RACK. NOW."','phase');
    float('CHALLENGED!',450,260,'#ff4444',18);
    S.beach.closeupAnim='manChallenge';S.beach.closeupAnimT=0;
    S.beach.canLeave=true;
    setTimeout(function(){
      S.beach.closeupAnim=null;S.beach.closeupAnimT=0;
      S.beach.closeupDebris=[];
      S.beach.subMenu=null;
      S.beach.activeCouple=null;
      startBeachGymComp(ci);
    },2500);
  }
}

// --- BEACH GYM COMPETITION LOGIC (3-attempt Clean & Jerk) ---

function getRivalTrashPool(ci){
  var t=S.beach.couples[ci].toughness;
  if(t<=0.3)return COMP_TRASH_LOW;
  if(t<=0.6)return COMP_TRASH_MED;
  return COMP_TRASH_HIGH;
}

function getRivalOpeningWeight(ci){
  var t=S.beach.couples[ci].toughness;
  var base=Math.round(110+t*120);
  return Math.round(base/5)*5;
}

function getRivalNextWeight(comp){
  // Rival bumps by 5-15 based on toughness and how far in we are
  var t=S.beach.couples[comp.rivalIdx].toughness;
  var bump=5+Math.round(t*10);
  // Occasionally rival goes conservative (just +5) or aggressive
  var roll=Math.random();
  if(roll<0.3)bump=5;
  else if(roll>0.85)bump=Math.round(bump*1.5);
  return comp.currentBar+Math.round(bump/5)*5;
}

function startBeachGymComp(ci){
  var comp=S.beach.gymComp;
  comp.active=true;
  comp.rivalIdx=ci;
  comp.round=0;
  comp.currentBar=0; // the weight that must be beaten
  comp.lastLifter=null; // 'rival' or 'tark'
  comp.liftLog=[]; // [{who:'rival',weight:200,made:true},...]
  comp.bestTark=0;comp.bestRival=0;
  comp.declaredWeight=135;comp.minWeight=135;
  comp.animPhase=null;comp.animT=0;comp.result=null;
  comp.hasGirlfriend=S.beach.couples[ci].lady||false;
  comp.rivalSpeech=null;comp.girlSpeech=null;
  comp.tarkX=200;comp.rivalX=650;
  comp.walkTarget=null;comp.walkWho=null;comp.walkCb=null;
  comp.prepUsed=false;comp.beersUsed=0;comp.smokesUsed=0;comp.chalksUsed=0;
  comp.rivalReact=null;comp.rivalReactT=0;
  // For backwards compat with scoreboard (keep arrays but dynamic size)
  comp.tarkAttempts=[];comp.rivalAttempts=[];
  log('They walk over to Muscle Beach. Clean & Jerk. Back and forth. Outdo each other till someone breaks.','phase');
  S.pose='idle';S.poseT=0;
  // Rival lifts first — opens with a weight
  var openW=getRivalOpeningWeight(ci);
  comp.rivalNextWeight=openW;
  comp.turn='rival_lifting';
  lock();updUI();renderControls();
  log(BEACH_COUPLE_NAMES[ci]+' opens at '+openW+' lbs.','lift');
  beachWalkTo('rival',450,function(){doBeachRivalLift();});
}

// --- Beach comp item interactions (during declare phase) ---
function doBeachCompBeer(){
  var comp=S.beach.gymComp;
  if(comp.turn!=='tark_declare'||S.busy||S.beach.beersLeft<=0||comp.beersUsed>=3)return;
  lock();
  comp.beersUsed++;
  S.beach.beersLeft--;
  S.pose='drinking';S.poseT=0;
  log('Tark cracks one open at the gym. No fucks given.','action');
  try{SFX.lighterFlick();}catch(e){}
  setTimeout(function(){
    S.adrenaline=clamp(S.adrenaline+4,0,100);
    S.focus=Math.max(0,S.focus-5);
    S.swagger=clamp(S.swagger+6,0,100);
    float('+4 ADR',comp.tarkX,280,'#ff6b35',11);
    float('-5 FOC',comp.tarkX,296,'#ff4444',10);
    float('+6 SWAG',comp.tarkX,312,'#ffcc00',10);
    S.pose='idle';S.poseT=0;
    unlock();updUI();renderControls();
  },1800);
}
function doBeachCompSmoke(){
  var comp=S.beach.gymComp;
  if(comp.turn!=='tark_declare'||S.busy||S.cigsLeft<=0||comp.smokesUsed>=3)return;
  lock();
  comp.smokesUsed++;
  S.cigsLeft--;
  S.pose='smoke';S.poseT=0;
  log('Tark lights up between attempts. The crowd watches.','action');
  try{SFX.lighterFlick();}catch(e){}
  setTimeout(function(){
    S.focus=clamp(S.focus+6,0,100);
    S.nervousness=Math.max(0,S.nervousness-4);
    S.grip=Math.max(0,S.grip-3);
    float('+6 FOC',comp.tarkX,280,'#7fdb6a',11);
    float('-4 NERV',comp.tarkX,296,'#7fdb6a',10);
    float('-3 GRIP',comp.tarkX,312,'#ff4444',10);
    S.pose='idle';S.poseT=0;
    unlock();updUI();renderControls();
  },2200);
}
function doBeachChalk(){
  var comp=S.beach.gymComp;
  if(comp.turn!=='tark_declare'||S.busy||S.chalkUses<=0||comp.chalksUsed>=3)return;
  lock();
  comp.chalksUsed++;
  S.chalkUses--;
  log('Tark walks over to the chalk.','action');
  // Walk to chalk table, do chalking pose, walk back
  var homeX=comp.tarkX;
  beachWalkTo('tark',130,function(){
    S.pose='chalking';S.poseT=0;
    try{SFX.chalkClap();}catch(e){}
    log('Tark chalks up. Cloud of white dust.','chalk');
    setTimeout(function(){
      S.grip=clamp(S.grip+15,0,100);
      S.chalked=true;S.chalkTimer=0;
      float('+15 GRIP',130,280,'#fff',12);
      float('CHALKED UP',130,296,'#e8e0d0',10);
      S.pose='idle';S.poseT=0;
      beachWalkTo('tark',homeX,function(){
        unlock();updUI();renderControls();
      });
    },1500);
  });
}
function doBeachGirl(){
  var comp=S.beach.gymComp;
  if(comp.turn!=='tark_declare'||S.busy||!comp.hasGirlfriend||comp.girlUsed)return;
  comp.girlUsed=true;
  S.adrenaline=clamp(S.adrenaline+10,0,100);
  S.nervousness=Math.max(0,S.nervousness-5);
  comp.girlSpeech=pick(GIRL_CHEER);
  float('+10 ADR',comp.tarkX,300,'#ff69b4',10);
  float('-5 NERV',comp.tarkX,316,'#7fdb6a',10);
  log('She whispers something in his ear. Tark is fired up.','action');
  updUI();renderControls();
}

function doBeachAdjustWeight(delta){
  var comp=S.beach.gymComp;
  if(comp.turn!=='tark_declare')return;
  var nw=comp.declaredWeight+delta;
  if(nw<comp.minWeight||nw<45)return;
  if(nw>500)return;
  comp.declaredWeight=nw;
  updUI();renderControls();
}

function doBeachCompTaunt(){
  var comp=S.beach.gymComp;
  if(comp.turn!=='tark_declare'||S.busy||comp.tauntUsed)return;
  comp.tauntUsed=true;
  S.swagger=clamp(S.swagger+3,0,100);
  float('+3 SWAG',comp.tarkX,288,'#ffcc00',11);
  var taunts=['"You\'re gonna bomb out."','"Cute opener."','"That all you got?"','"I\'ve seen grandmas lift more."','"This is my warm-up weight."'];
  S.speechBubble={text:pick(taunts),x:comp.tarkX,y:295,life:2.0,fontSize:9};
  comp.rivalSpeech=pick(['"...whatever"','"Shut up"','"You\'re dead"','"Watch me"']);
  setTimeout(function(){comp.rivalSpeech=null;},2000);
  log(pick(['Tark trash-talks.','Tark gets in his head.','Mind games.']),'hype');
  updUI();renderControls();
}

function beachWalkTo(who,destX,cb){
  var comp=S.beach.gymComp;
  comp.walkWho=who;comp.walkTarget=destX;comp.walkCb=cb;
}

function doBeachLift(){
  if(S.busy)return;
  var comp=S.beach.gymComp;
  if(comp.turn!=='tark_declare')return;
  lock();
  comp.rivalSpeech=null;comp.girlSpeech=null;
  log('Tark steps up. '+comp.declaredWeight+' lbs.','phase');
  comp.turn='tark_lifting';updUI();renderControls();
  beachWalkTo('tark',450,function(){doBeachTarkLift();});
}

function doBeachRivalLift(){
  var comp=S.beach.gymComp;
  var ci=comp.rivalIdx;
  var weight=comp.rivalNextWeight;
  comp.turn='rival_lifting';
  comp.animPhase='rival_pull';comp.animT=0;
  log(BEACH_COUPLE_NAMES[ci]+' steps up. '+weight+' lbs...','lift');
  try{SFX.metalClang();}catch(e){}
  updUI();renderControls();
  var rx=comp.rivalX;
  setTimeout(function(){
    var toughness=S.beach.couples[ci].toughness;
    // Fail chance scales with weight and rounds
    var failChance=Math.max(0.05,0.04+comp.round*0.06-toughness*0.2);
    var wf=Math.max(0,(weight-180)/150);
    failChance=Math.min(0.70,failChance+wf*0.12);
    var failed=Math.random()<failChance;
    if(failed){
      comp.animPhase='rival_fail';
      comp.rivalAttempts.push(false);
      comp.liftLog.push({who:'rival',weight:weight,made:false});
      log(BEACH_COUPLE_NAMES[ci]+' can\'t make '+weight+' lbs!','hype');
      float('NO LIFT!',rx,240,'#7fdb6a',16);
      try{SFX.barDrop();}catch(e){}
      setTimeout(function(){comp.animPhase=null;
        beachWalkTo('rival',650,function(){
          // Rival failed — TARK WINS
          resolveBeachGymComp('tark');
        });
      },1500);
    }else{
      comp.animPhase='rival_clean';
      setTimeout(function(){
        comp.animPhase='rival_jerk';
        comp.rivalAttempts.push(true);
        comp.liftLog.push({who:'rival',weight:weight,made:true});
        comp.currentBar=weight;
        comp.bestRival=weight;
        comp.lastLifter='rival';
        log(BEACH_COUPLE_NAMES[ci]+' makes '+weight+' lbs!','lift');
        float('GOOD LIFT!',rx,240,'#fff',14);
        try{SFX.crowdCheer();}catch(e){}
        comp.rivalSpeech=pick(getRivalTrashPool(ci));
        setTimeout(function(){comp.animPhase=null;
          beachWalkTo('rival',650,function(){
            // Now Tark must beat it
            comp.minWeight=comp.currentBar+5;
            comp.declaredWeight=comp.minWeight;
            comp.turn='tark_declare';comp.prepUsed=false;comp.beersUsed=0;comp.smokesUsed=0;comp.chalksUsed=0;comp.girlUsed=false;comp.tauntUsed=false;
            log('Your turn. Must beat '+comp.currentBar+' lbs. Minimum: '+comp.minWeight+' lbs.','phase');
            unlock();updUI();renderControls();
          });
        },1200);
      },700);
    }
  },1200);
}

function doBeachTarkLift(){
  var comp=S.beach.gymComp;
  var weight=comp.declaredWeight;
  comp.turn='tark_lifting';
  comp.animPhase='tark_pull';comp.animT=0;
  S.pose='pull';S.poseT=0;
  log('Tark steps up. '+weight+' lbs. Clean & Jerk.','lift');
  try{SFX.metalClang();}catch(e){}
  updUI();renderControls();
  var tx=comp.tarkX;

  var savedBW=S.barWeight;S.barWeight=weight;
  var p=ep();
  var strCost=Math.max(2,Math.round(p*4));
  S.strength=clamp(S.strength-strCost,0,100);
  S.fatigue=S.fatigue+(p*0.4);
  S.grip=clamp(S.grip-Math.max(1,Math.round(p*2)),0,100);

  var failChance=getFailChance('cj');
  S.barWeight=savedBW;

  var params=getMiniGameParams('cj',failChance);

  setTimeout(function(){
    S.pose='front_squat';S.poseT=0;
    comp.animPhase='tark_front_squat';
    startCJMiniGame(params,failChance,weight,0,'beach');
    // Store beach comp reference on mini-game for resolution
    S.miniGame._beachComp=comp;
    S.miniGame._beachTx=tx;
  },1000);
}

function advanceBeachAttempt(){
  // Legacy stub — no longer used in back-and-forth format
  // Kept for any stray calls; resolveBeachGymComp handles endings now
}

function resolveBeachGymComp(winner){
  var comp=S.beach.gymComp;
  var ci=comp.rivalIdx;
  var couple=S.beach.couples[ci];
  if(winner==='tark'){
    comp.result='tark_wins';
    couple.cowered=true;couple.lady=true;
    S.strength=clamp(S.strength+10,0,100);
    S.adrenaline=clamp(S.adrenaline+15,0,100);
    S.swagger=clamp(S.swagger+15,0,100);
    S.nervousness=Math.max(0,S.nervousness-10);
    float('+10 STR',350,200,'#ff6b35',13);
    float('+15 ADR',350,220,'#ff6b35',11);
    float('+15 SWAG',350,240,'#ffcc00',11);
    float('BEACH KING',450,180,'#ffcc00',18);
    var rivalFailed=comp.liftLog.length>0?comp.liftLog[comp.liftLog.length-1]:null;
    var failW=rivalFailed?rivalFailed.weight+'':'???';
    log(BEACH_COUPLE_NAMES[ci]+' fails at '+failW+' lbs! Tark\'s best: '+comp.bestTark+' lbs. The crowd erupts.','hype');
    if(comp.hasGirlfriend)comp.girlSpeech='"You\'re incredible!"';
    // Tark walks over and takes the girl
    setTimeout(function(){
      comp.walkoffPhase='tark_to_girl';
      comp.walkoffT=0;
    },1500);
  }else{
    comp.result='rival_wins';
    couple.gone=true;
    // --- HUMILIATION: Major stat penalties ---
    var rivalName=BEACH_COUPLE_NAMES[ci];
    var severity=Math.min(3,Math.ceil(couple.toughness*3)); // 1-3 based on how tough rival was
    S.humiliated=severity;
    S.humiliatedBy=rivalName;
    // Stat hits scale with severity
    var swagDrop=10+severity*5;   // 15-25
    var strDrop=3+severity*3;     // 6-12
    var focDrop=5+severity*5;     // 10-20
    var nervUp=10+severity*8;     // 18-34
    var fatUp=0.10+severity*0.05; // 0.15-0.25
    S.swagger=Math.max(0,S.swagger-swagDrop);
    S.strength=Math.max(0,S.strength-strDrop);
    S.focus=Math.max(0,S.focus-focDrop);
    S.nervousness=clamp(S.nervousness+nervUp,0,100);
    S.fatigue=clamp(S.fatigue+fatUp,0,1);
    S.adrenaline=Math.max(0,S.adrenaline-10);
    // Floats
    float('-'+swagDrop+' SWAG',300,190,'#ff4444',13);
    float('-'+strDrop+' STR',300,210,'#ff4444',12);
    float('-'+focDrop+' FOCUS',300,230,'#ff4444',12);
    float('+'+nervUp+' NERV',400,190,'#ff4444',13);
    float('+FATIGUE',400,210,'#ff4444',11);
    float('-10 ADR',400,230,'#ff4444',11);
    float('HUMILIATED',350,170,'#ff2222',18);
    // --- Extended humiliation: rival trash talks ---
    var trashLines=[
      '"Stick to cardio, bro."',
      '"That was embarrassing. For you."',
      '"Don\'t feel bad. Actually, do."',
      '"Maybe try yoga instead."',
      '"I barely broke a sweat."',
      '"Tell your coach I said hi."'
    ];
    comp.rivalSpeech=pick(trashLines);
    log('Tark fails at the beach gym. '+rivalName+' destroyed him.','fail');
    log(rivalName+': '+comp.rivalSpeech,'fail');
    // Girl laughs at Tark
    if(comp.hasGirlfriend){
      var girlLaughs=['"HAHAHA oh my god"','"Babe you crushed him!"','"That was pathetic lmaooo"','"Did he even try??"'];
      comp.girlSpeech=pick(girlLaughs);
      log('His girlfriend: '+comp.girlSpeech,'fail');
    }
    // Start walkoff animation after showing result for a beat
    log(rivalName+' walks over to his girl...','fail');
    if(severity>=2) log('That\'s going to stick with him. All the way to the meet.','fail');
    if(severity>=3) log('Everyone saw that. EVERYONE.','fail');
    // Trigger walkoff: rival walks to girl position
    setTimeout(function(){
      comp.walkoffPhase='rival_to_girl';
      comp.walkoffT=0;
    },1500);
  }
  comp.turn='result';
  unlock();updUI();renderControls();
}

function doBeachGymDone(){
  var comp=S.beach.gymComp;
  comp.active=false;comp.animPhase=null;comp.result=null;
  comp.turn='tark_declare';comp.rivalSpeech=null;comp.girlSpeech=null;
  comp.walkoffPhase=null;comp.walkoffT=0;comp.walkoffGirlX=750;
  S.pose='idle';S.poseT=0;
  unlock();updUI();renderControls();
}

// === BOARDWALK TRASH TOSS ===
function doBoardwalk(){
  if(S.busy)return;
  lock();
  S.beach.boardwalkAttempted=true;
  S.beach.subMenu='boardwalk';
  // Garbage items — 10 random trash items to throw
  var itemPool=[
    {name:'CRUSHED CAN',type:'crushed_can',color:'#c0c0c0'},
    {name:'ROTTEN APPLE',type:'rotten_apple',color:'#5a7a30'},
    {name:'OLD SHOE',type:'old_shoe',color:'#5a4a3a'},
    {name:'BANANA PEEL',type:'banana_peel',color:'#ccaa22'},
    {name:'FISH BONE',type:'fish_bone',color:'#e8e0d0'},
    {name:'SOGGY NEWSPAPER',type:'soggy_newspaper',color:'#d4cbb8'},
    {name:'BROKEN BOTTLE',type:'broken_bottle',color:'#4a8a4a'},
    {name:'TIN CAN',type:'tin_can',color:'#b0b0b0'},
    {name:'PIZZA CRUST',type:'pizza_crust',color:'#d4a860'},
    {name:'CRUSHED CAN',type:'crushed_can',color:'#aa8888'}
  ];
  // Shuffle
  for(var si=itemPool.length-1;si>0;si--){var j=Math.floor(Math.random()*(si+1));var tmp=itemPool[si];itemPool[si]=itemPool[j];itemPool[j]=tmp;}
  S.boardwalk={
    phase:'intro',introTimer:150,endTimer:0,
    throwsLeft:10,hits:0,currentItem:0,
    items:itemPool,
    cyclists:[],
    spawnTimer:20, // first cyclist appears almost immediately
    totalCyclists:0, // tracks how many have spawned (for stats)
    throwing:false,projectile:null,
    crashes:[],
    tarkPose:'idle',celebTimer:0,reachTimer:0,throwAnim:0
  };
  log("Tark eyes the garbage can by the boardwalk...","info");
}
window.doBoardwalk=doBoardwalk;

function doBoardwalkThrow(targetX){
  var bw=S.boardwalk;
  if(!bw||bw.throwing||bw.throwsLeft<=0)return;
  if(bw.tarkPose==='reaching')return; // still grabbing item
  bw.throwsLeft--;
  bw.throwing=true;
  bw.tarkPose='throwing';
  bw.throwAnim=0;
  var item=bw.items[bw.currentItem];
  bw.currentItem++;
  var startX=150,startY=340;
  var targetY=205; // boardwalk center
  bw.projectile={
    x:startX,y:startY,
    startX:startX,startY:startY,
    targetX:targetX,targetY:targetY,
    progress:0,speed:0.006, // ~167 frames = ~2.8 seconds
    spin:0,shadowX:startX,shadowY:targetY+12,
    itemType:item?item.type:'crushed_can',
    color:item?item.color:'#888'
  };
  try{SFX.plateClack();}catch(e){}
}
window.doBoardwalkThrow=doBoardwalkThrow;

function exitBoardwalk(){
  var bw=S.boardwalk;
  var hits=bw?bw.hits:0;
  if(hits>0){
    var swagBonus=hits*5;
    S.swagger=clamp(S.swagger+swagBonus,0,100);
    float('+'+swagBonus+' SWAGGER',450,200,'#ffcc00',14);
    log('Nailed '+hits+' cyclist'+(hits>1?'s':'')+' with garbage! SWAGGER+'+swagBonus,'good');
    if(hits>=5){
      S.adrenaline=clamp(S.adrenaline+10,0,100);
      S.nervousness=clamp(S.nervousness-10,0,100);
      float('PERFECT GAME!',450,170,'#ff6b35',16);
      float('+10 ADR',450,145,'#44aaff',11);
      float('-10 NERV',450,125,'#44ff44',11);
      log('PERFECT GAME! 5+ hits! ADR+10, NERV-10','good');
    }
  }else{
    log('Missed every shot. At least nobody called the cops.','info');
    S.nervousness=clamp(S.nervousness+5,0,100);
    float('+5 NERV',450,200,'#ff6666',11);
  }
  S.boardwalk=null;
  S.beach.subMenu=null;
  unlock();updUI();renderControls();
}
window.exitBoardwalk=exitBoardwalk;

function doBeachBathroom(){
  if(S.busy)return;
  S.beach.subMenu='bathroom';
  log("Tark heads to the beach restrooms.","info");
  if(!S.thoughtSeen['bathroom']){S.thoughtSeen['bathroom']=true;narrateScene();}
}
window.doBeachBathroom=doBeachBathroom;

function exitBeachBathroom(){
  S.beach.subMenu=null;
}
window.exitBeachBathroom=exitBeachBathroom;

function doEnterStall(){
  if(S.busy)return;
  S.beach.subMenu='stall';
  S.beach.stallEntered=true;
  log("Tark climbs through the smashed door into the stall.","info");
  if(!S.thoughtSeen['oo_stall']){S.thoughtSeen['oo_stall']=true;narrateScene();}
}
window.doEnterStall=doEnterStall;

function exitStall(){
  S.beach.subMenu='bathroom';
  log("Tark steps back out of the stall.","info");
}
window.exitStall=exitStall;

function enterSewer(){
  S.beach.subMenu='sewer';
  S.beach.sewer.visited=true;
  log("Tark drops into the sewer. The smell is... significant.","info");
  float('*splash*',450,360,'#4488bb',12);
  if(!S.thoughtSeen['sewer']){S.thoughtSeen['sewer']=true;narrateScene();}
}
window.enterSewer=enterSewer;

function exitSewer(){
  S.beach.subMenu='stall';
  log("Tark climbs back up the ladder into the stall.","info");
}
window.exitSewer=exitSewer;

function doSewerLeft(){
  if(S.busy)return;
  S.beach.sewer.leftVisited=true;
  S.beach.subMenu='sewer_left';
  log("Tark heads into the left tunnel. The green glow gets stronger...","info");
  if(!S.thoughtSeen['sewer_left']){S.thoughtSeen['sewer_left']=true;narrateScene();}
}
window.doSewerLeft=doSewerLeft;

function doSewerCenter(){
  if(S.busy)return;
  S.beach.sewer.centerVisited=true;
  S.beach.subMenu='sewer_center';
  log("Tark walks toward the warm light deep in the center tunnel...","info");
  if(!S.thoughtSeen['sewer_center']){S.thoughtSeen['sewer_center']=true;narrateScene();}
}
window.doSewerCenter=doSewerCenter;

function doSewerRight(){
  if(S.busy)return;
  S.beach.sewer.rightVisited=true;
  S.beach.subMenu='sewer_right';
  log("Tark ducks under the danger tape into the right tunnel. Steam hisses.","info");
  if(!S.thoughtSeen['sewer_right']){S.thoughtSeen['sewer_right']=true;narrateScene();}
}
window.doSewerRight=doSewerRight;

function doEnterMiddleStall(){
  if(S.busy)return;
  S.beach.subMenu='middle_stall';
  log("Tark enters the middle stall. There's a toilet in here.","info");
  if(!S.thoughtSeen['middle_stall']){S.thoughtSeen['middle_stall']=true;narrateScene();}
}
window.doEnterMiddleStall=doEnterMiddleStall;

function exitMiddleStall(){
  S.beach.subMenu='bathroom';
}
window.exitMiddleStall=exitMiddleStall;

function doEnterRightStall(){
  if(S.busy)return;
  S.beach.subMenu='right_stall';
  log("Tark enters the right stall. Smells like the last guy.","info");
  if(!S.thoughtSeen['right_stall']){S.thoughtSeen['right_stall']=true;narrateScene();}
}
window.doEnterRightStall=doEnterRightStall;

function exitRightStall(){
  S.beach.subMenu='bathroom';
}
window.exitRightStall=exitRightStall;

function doMiddleFlush(){
  if(S.busy||S.beach.middleFlooded)return;
  S.beach.middleFlushes++;
  if(S.beach.middleFlushes>=3){
    S.beach.middleFlooded=true;
    S.beach.rightStallOccupied=false;
    float('FLOODED!',450,300,'#4488bb',14);
    log("The toilet overflows everywhere!","info");
    try{SFX.plateClack();}catch(e){}
    setTimeout(function(){
      log("Angry cursing from the next stall... then a door slam.","info");
      S.beach.subMenu='bathroom';
    },1500);
  }else{
    float('FLUSH ('+S.beach.middleFlushes+'/3)',450,300,'#4488bb',11);
    log(S.beach.middleFlushes===1?"Water swirls ominously.":"Water rising...","info");
    try{SFX.plateClack();}catch(e){}
  }
}
window.doMiddleFlush=doMiddleFlush;

function doFountainDrink(){
  if(S.busy||S.beach.fountainDrunk||S.beach.fountainKicks>=7)return;
  S.beach.fountainDrunk=true;
  S.swagger=clamp(S.swagger+3,0,100);
  float('+3 SWAGGER',730,280,'#ffcc00',11);
  log("Tark takes a long drink. Refreshing.","info");
}
window.doFountainDrink=doFountainDrink;

function doPickUpPiece(){
  if(S.busy||S.beach.holdingPiece)return;
  S.beach.holdingPiece=true;
  float('HOLDING PIECE',450,300,'#ffcc00',11);
  log("Tark hoists the heavy basin chunk overhead.","info");
}
window.doPickUpPiece=doPickUpPiece;

function doSmashDoor(){
  if(S.busy||!S.beach.holdingPiece)return;
  S.beach.holdingPiece=false;
  S.beach.doorCracked=true;
  float('CRASH!',620,250,'#ff4444',14);
  log("The basin chunk smashes the door wide open!","good");
  S.swagger=clamp(S.swagger+10,0,100);
  float('+10 SWAGGER',450,320,'#ffcc00',12);
  try{SFX.metalClang();}catch(e){}
}
window.doSmashDoor=doSmashDoor;

function doPocketPaper(){
  if(S.busy||S.beach.hasPaper)return;
  S.beach.hasPaper=true;
  float('+PAPER',150,380,'#ff6b35',11);
  log("Tark pockets a wad of paper towels.","info");
}
window.doPocketPaper=doPocketPaper;

function doStuffToilet(){
  if(S.busy||!S.beach.hasPaper||S.beach.toiletStuffed)return;
  S.beach.toiletStuffed=true;
  float('STUFFED',650,300,'#ff6b35',11);
  log("Tark stuffs the paper into the clogged toilet. Disgusting.","info");
}
window.doStuffToilet=doStuffToilet;

function doFlushStuffedToilet(){
  if(S.busy||!S.beach.toiletStuffed)return;
  S.beach.rightToiletFlushed=true;
  float('*GLURGLE*',650,300,'#884422',14);
  log("The toilet makes a horrible gurgling noise. Brown water everywhere.","info");
  try{SFX.plateClack();}catch(e){}
}
window.doFlushStuffedToilet=doFlushStuffedToilet;

function doBeachExit(){
  if(S.busy)return;
  S.mapOpen=true;
}
function doBeachExitOld(){
  if(S.busy)return;
  // Convert swagger to nervousness reduction
  if(S.swagger>0){
    var nervRed=Math.round(S.swagger*0.2);
    S.nervousness=Math.max(0,S.nervousness-nervRed);
    if(nervRed>0)log('Beach swagger: NERVES-'+nervRed+'.','hype');
  }
  // Humiliation carry-over: extra nervousness, focus penalty, warning log
  if(S.humiliated>0){
    var extraNerv=S.humiliated*5;
    var extraFocDrop=S.humiliated*3;
    S.nervousness=clamp(S.nervousness+extraNerv,0,100);
    S.focus=Math.max(0,S.focus-extraFocDrop);
    log('Tark can\'t shake what happened at the beach. The humiliation lingers.','fail');
    if(S.humiliated>=2)log('His hands are shaking. Not from the cold.','fail');
    if(S.humiliated>=3)log('He keeps replaying it. '+S.humiliatedBy+'\'s laugh echoes in his head.','fail');
  }
  lock();
  log('Tark heads to the gym. Time to get serious.','phase');
  walkTo(LAYOUT.beach.exitX,function(){
    S.sceneTransition={
      progress:0,duration:40,
      midCallback:function(){
        setPhase('gym');
        S.homeX=LAYOUT.gym.homeX;
        S.tX=-30;
        S.pose='idle';
      },
      endCallback:function(){
        walkTo(LAYOUT.gym.homeX,function(){
          unlock();
          log('Tark Farley stands in his gym. The barbell awaits.','phase');
          log('Click the bench, rack, shaker, or cig pack. Or use the buttons.','rest');
          log("When you're ready, enter the meet.",'rest');
        });
      }
    };
  });
}

// ============================================================
// END BEACH PHASE
// ============================================================

// TALK TO COACH
function getBackroomCoachAdvice(){
  // Context-aware advice based on game state
  var phase=S.phase;

  // Gym phase — general tips
  if(phase==='gym'){
    return pick([
      'Don\'t overthink it. Train the way you compete.',
      'Focus on positions today. Speed will come.',
      'Remember: chest up, knees out. Every rep.',
      'Let\'s keep it light and technical in warm-ups.',
      'Listen to your body. If something\'s off, we adjust.',
      'You look good today. Trust the process.',
      'Warm up the pulls first. Don\'t rush to the bar.'
    ]);
  }

  // Warmup phase — warm-up strategy
  if(phase==='warmup'){
    var rdy=S.readiness;
    if(rdy<30)return pick([
      'Take your time. You\'re not warm yet.',
      'Don\'t jump up too fast. Build into it.',
      'A few more light ones. No rush.',
      'You\'re still cold. Patience.'
    ]);
    if(rdy>70)return pick([
      'You\'re looking sharp. Almost time.',
      'Good warm-ups. Feeling confident about our opener.',
      'You\'re ready. Don\'t overdo it now.',
      'Save some for the platform. You\'re warm enough.'
    ]);
    return pick([
      'Good. Keep building. Nice and smooth.',
      'Technique looks clean. Keep going.',
      'How\'s the grip feel? Stay chalked up.',
      'Looking solid. Let\'s get a couple more in.'
    ]);
  }

  // Competition — contextual advice based on turn state
  if(phase==='snatch'||phase==='cj'||phase==='rest_sn_cj'){
    var t=S.turn;
    // If it's tark's turn
    if(t&&t.whose==='tark'){
      return pick([
        'You\'re up soon. Head in the game.',
        'Focus. Visualize the lift.',
        'Deep breaths. You\'ve done this a hundred times.',
        'You know the weight. You know the movement. Trust it.'
      ]);
    }
    // Watching a rival — personality-aware scouting
    if(t&&t.whose==='rival'&&S.rival){
      var rn=S.rival.name.split(' ')[0];
      var rp=S.rival.personality;
      // Personality-specific scouting intel
      if(rp==='hothead'){
        var lastFailed=S.rival.currentAttempt>0&&S.rival[t.liftType==='snatch'?'snatchAttempts':'cjAttempts'][S.rival.currentAttempt-1]===false;
        if(lastFailed)return pick([rn+' is rattled. I can see it. Push him.','He missed. Watch him panic on this next one.',rn+'\'s head is gone. This is our chance.']);
        return pick([rn+' is trying to match you. Let him chase.','Don\'t let '+rn+' get in your head. He\'s emotional.',rn+' always goes for ego lifts. Wait for him to crack.']);
      }
      if(rp==='veteran')return pick([rn+' won\'t make mistakes. We have to out-lift him.',rn+' is steady. Small jumps, never misses. Respect the plan.',rn+' has been here a hundred times. Don\'t try to rattle him.']);
      if(rp==='sandbagger'){
        if(S.rival.currentAttempt<2)return pick([rn+' is sandbagging. Don\'t be fooled by the low opener.','Watch — '+rn+' is hiding his real number. Third attempt will be huge.','He\'s playing possum. Stay sharp for his final attempt.']);
        return pick([rn+' is going for the kill now. Here it comes.','This is the real '+rn+'. Big jump incoming.',rn+' saved everything for this. Hold your nerve.']);
      }
      return pick([
        'Watch '+rn+'. See how they set up.',
        'Don\'t worry about '+rn+'. Focus on your own lifts.',
        rn+' looks nervous. That\'s good for us.',
        'Stay loose. Your turn will come.'
      ]);
    }
    // Between lifters / waiting
    if(S.nervousness>60)return pick([
      'Relax. Nerves are good. Means you care.',
      'Breathe through it. Channel the adrenaline.',
      'I\'ve seen you hit bigger in the gym. This is nothing.',
      'Nervous energy is free energy. Use it.'
    ]);
    if(S.focus<40)return pick([
      'Hey. Eyes on me. Stay present.',
      'Focus up. Don\'t let your mind wander.',
      'Forget the last lift. Next one is all that matters.',
      'Lock in. This is what we came here for.'
    ]);
    return pick([
      'Good lifts so far. Stay patient.',
      'We\'re right where we want to be.',
      'Keep doing what you\'re doing.',
      'One lift at a time. That\'s all.',
      'You\'re competing well. Stay in it.',
      'Rest up. Conserve energy for the next one.'
    ]);
  }

  // Rest between snatch & cj
  return pick([
    'Shake it off. Clean slate for clean and jerk.',
    'Forget the snatches. CJ is your lift.',
    'Eat something if you can. Stay fueled.',
    'Keep moving. Don\'t get cold.'
  ]);
}

function doTalkToCoach(){
  if(S.busy)return;
  if(S.scene!=='backroom'&&!(is1v1()&&S.scene==='platform'))return;// coach in backroom or 1v1 platform
  lock();

  var advice=getBackroomCoachAdvice();
  var L=getLayout();
  var coachDest=(is1v1()&&S.scene==='platform')?(S.platformCoachX||25)+40:L.coachX-40;

  log('Coach: "'+advice+'"','coach');

  walkTo(coachDest,function(){
    // Show the temporary bubble
    if(is1v1()&&S.scene==='platform'){
      S.coachMsg=advice;S.coachBubble=Date.now()+4000;
    }else{
      S.coachBubble={text:advice,t:Date.now(),dur:4000};
    }

    // Stat effects — small focus/nerve adjustment
    var isComp=(S.phase==='snatch'||S.phase==='cj'||S.phase==='rest_sn_cj');
    if(S.phase==='gym'){
      // Cosmetic only in gym
      float('COACH',S.tX,160,'#7fdb6a',12);
    }else{
      S.focus=clamp(S.focus+8,0,100);
      S.nervousness=Math.max(0,S.nervousness-5);
      float('+8 FOC',S.tX-15,170,'#7fdb6a',12);
      float('-5 NERV',S.tX+15,185,'#6699ff',10);
      if(isComp){
        log('Coach talk: FOC+8, NERV-5.','coach');
      }else{
        log('Coach talk: FOC+8, NERV-5.','coach');
      }
    }

    setTimeout(function(){
      walkBack(function(){unlock();});
    },2000);
  });
}

// STRETCHING (warmup only)
function doStretch(){
  if(S.busy)return;
  if(S.phase!=='warmup')return;
  if(!S.warmup)return;
  lock();
  var sc=S.warmup.stretchCount;
  var rdyGain=Math.max(1,8-sc*2);
  S.readiness=clamp(S.readiness+rdyGain,0,100);
  S.focus=clamp(S.focus+3,0,100);
  float('+'+rdyGain+' RDY',S.tX,180,'#7fdb6a',14);
  float('+3 FOC',S.tX,200,'#cc88ff',11);
  if(sc===0){
    log('Tark stretches out. Feeling looser already.','lift');
    S.coachBubble={text:'Good. Get the blood flowing.',t:Date.now(),dur:3000};
  }else if(sc<3){
    log('Tark stretches again. +'+rdyGain+' RDY, +3 FOC.','lift');
  }else{
    log('Another stretch... diminishing returns. +'+rdyGain+' RDY.','rest');
  }
  S.warmup.stretchCount++;
  updUI();
  setTimeout(function(){unlock();},1200);
}

// WARM-UP LIFT
function doWarmupLift(){
  if(S.busy)return;
  if(S.phase!=='warmup')return;
  lock();

  // In backroom, use the declared weight from input (if visible)
  if(S.scene==='backroom'){
    var inp=document.getElementById('weightInput');
    if(inp&&inp.parentElement.style.display!=='none'){
      var typed=parseInt(inp.value)||45;
      typed=Math.max(45,Math.min(typed,MAX_BAR_WEIGHT||700));
      S.barWeight=typed;
      S.plateStack=calcPlatesForWeight(typed);
      showWeightDeclare(false);
    }
  }

  // Determine reps from warmup card
  var cardReps=1;
  var onCard=false;
  if(S.warmup&&S.warmup.card&&S.warmup.cardStep<S.warmup.card.length){
    var curCard=S.warmup.card[S.warmup.cardStep];
    if(S.barWeight===curCard.weight){onCard=true;cardReps=curCard.reps;}
  }
  var repLabel=cardReps===3?'triple':cardReps===2?'double':'single';
  log('Warm-up '+repLabel+' at '+S.barWeight+' lbs...','lift');

  // BACKROOM: lift in-place (no walk to platform)
  var liftX=S.scene==='backroom'?LAYOUT.backroom.homeX:LAYOUT.comp.platformX;
  walkTo(liftX,function(){

  var p=ep();
  // Strength cost scales with reps: doubles cost ~1.5x, triples ~2x
  var repCostMult=cardReps===3?2.0:cardReps===2?1.5:1.0;
  var strCost=Math.max(1,Math.round(p*5*repCostMult));
  S.strength=clamp(S.strength-strCost,0,100);
  float('-'+strCost+' STR',S.tX+30,200,'#ff4444',11);

  // Injury check — use competition fail formula to gauge overload
  var fc=getFailChance('snatch');
  var injChance=getInjuryChance(fc);
  var overload=Math.max(0,(fc-0.40)/0.50);
  var gotInjured=(injChance>0&&Math.random()<injChance);

  // Determine lift type randomly for animation
  var liftAnim=Math.random()<0.5?'snatch':'cj';
  S.currentLift=liftAnim;

  SFX.metalClang();

  // Pull phase
  S.pose='pull';S.poseT=0;

  setTimeout(function(){
    // Update overload tracking AFTER the lift
    S.lastLiftOverload=overload;

    if(gotInjured){
      triggerDNF('warmup');
      return;
    }

    // Start mini-game — result determines rep quality (green=good, yellow=decent, red=sloppy)
    var params=getMiniGameParams(liftAnim,fc);
    if(liftAnim==='snatch'){
      S.pose='overhead_squat';S.poseT=0;
      startSnatchMiniGame(params,fc,S.barWeight,0,'warmup');
    }else{
      S.pose='front_squat';S.poseT=0;
      startCJMiniGame(params,fc,S.barWeight,0,'warmup');
    }
    // Store warmup context on mini-game for resolution
    S.miniGame._warmupCardReps=cardReps;
    S.miniGame._warmupOnCard=onCard;
    S.miniGame._warmupP=p;
    S.miniGame._warmupWeight=S.barWeight;
  },700);

  }); // end walkTo callback
}

// GYM LIFT — uses fail chance like competition (lower consequences)
var GYM_FAIL_MSGS=[
  'The bar doesn\'t move. It\'s bolted to the floor. (It isn\'t.)',
  'Tark pulls. The bar says no. Gravity wins.',
  'That was ambitious. And embarrassing.',
  'The girls definitely saw that. They\'re whispering.',
  'Nope. Not today. The bar stays on the ground.',
  'Tark strains. Grunts. Nothing happens. He pretends he was stretching.',
  'The barbell wins this round.',
  'His knees buckle. The bar crashes down. Nobody claps.'
];
function doGymLift(liftType){
  if(S.busy)return;
  if(S.phase!=='gym')return;
  lock();

  S.currentLift=liftType;

  var fc=getFailChance(liftType);
  var params=getMiniGameParams(liftType,fc);
  S._pendingFailChance=fc;

  S.pose='pull';S.poseT=0;
  SFX.metalClang();

  setTimeout(function(){
    if(liftType==='snatch'){
      S.pose='overhead_squat';S.poseT=0;
      startSnatchMiniGame(params,fc,S.barWeight,0,'gym');
    }else{
      S.pose='front_squat';S.poseT=0;
      startCJMiniGame(params,fc,S.barWeight,0,'gym');
    }
  },700);
}

// CHAT UP THE LADIES
var CHATUP_LINES=[
  {tark:'Hey... do you ladies lift here often?',
   reject:'They don\'t even look up. One of them whispers "oh my god" to the other.'},
  {tark:'I\'m about to compete. Nationally. No big deal.',
   reject:'"Cool." She goes back to her phone. The other one stifles a laugh.'},
  {tark:'You should see my clean and jerk.',
   reject:'"We\'re good." The blonde one takes a step back. The other one mouths "help me."'},
  {tark:'I could deadlift both of you. At the same time. Easily.',
   reject:'"Please don\'t." They move slightly further away. Unified retreat.'},
  {tark:'These arms? All natural. Protein and discipline.',
   reject:'One of them says "that\'s crazy" in the most unimpressed tone humanly possible.'},
  {tark:'After I win today... drinks on me?',
   reject:'"We have boyfriends." They definitely do not have boyfriends. They just don\'t want Tark.'}
];
function doChatUp(){
  if(S.busy)return;
  if(S.phase!=='gym')return;
  if(S.girls.phase!=='gym_idle'){log('There\'s nobody to talk to.','rest');return;}
  if(S.girls.chatCooldown>0){log('Give it a rest, Tark. They\'re still recovering from the last one.','rest');return;}
  lock();
  var chat=pick(CHATUP_LINES);
  log('Tark walks over to the girls.','rest');
  walkTo(S.girls.x1-30,function(){
    S.pose='idle';S.poseT=0;
    log('"'+chat.tark+'"','lift');
    S.speechBubble={text:chat.tark,x:S.tX,y:140,life:2.0,fontSize:9};
    setTimeout(function(){
      log(chat.reject,'fail');
      S.speechBubble={text:'DENIED',x:S.tX,y:170,life:1.2,fontSize:14};
      S.girls.chatCooldown=600;
      setTimeout(function(){
        S.pose='idle';S.poseT=0;
        walkBack(function(){unlock();renderControls();});
      },1500);
    },2500);
  });
}

// ADD / DROP WEIGHT
function addPlate(size){
  if(S.busy)return;
  // In competition, only allow loading during declaring phase
  if((S.phase==='snatch'||S.phase==='cj')&&S.turn.phase!=='declaring')return;
  S.hints.rack=true;S.gymIdleTimer=0;
  if(S.barWeight+size*2>MAX_BAR_WEIGHT){log('Bar is maxed out. Even the rack is scared.','rest');return;}

  // In competition, check minNextWeight (= platform weight, bar never drops)
  if((S.phase==='snatch'||S.phase==='cj')&&S.barWeight+size*2<S.minNextWeight){
    log('Weight must stay at or above '+S.minNextWeight+' lbs — bar never goes down.','fail');
    return;
  }

  S.plateStack.push(size);
  recalcBar();
  SFX.plateClack();

  float(S.barWeight+' LBS',S.tX,160,'#f0e6d3',14);
  log('Loaded '+size+'s. Bar is now '+S.barWeight+' lbs.','lift');

  // Nervousness from heavy weight
  if(S.barWeight>=315){
    S.nervousness=clamp(S.nervousness+5,0,100);
    float('+5 NERVES',S.tX,210,'#ff6666',10);
  }
  if(S.barWeight>=405){
    S.nervousness=clamp(S.nervousness+5,0,100);
  }

  // Girls appear at 315+
  if(S.barWeight>=315&&S.girls.phase==='absent'){
    S.girls.phase='entering';S.girls.reactT=0;
    S.girls.x1=930;S.girls.x2=960;S.girls.result=null;
    log('Two girls just walked in. They\'re watching.','rest');
  }

  updUI();
}

function dropPlate(){
  if(S.busy)return;
  // In competition, only allow stripping during declaring phase
  if((S.phase==='snatch'||S.phase==='cj')&&S.turn.phase!=='declaring')return;
  if(S.plateStack.length===0){log('There\'s nothing left to strip, chief.','rest');return;}

  // In competition, can't go below minNextWeight (= platform weight)
  var last=S.plateStack[S.plateStack.length-1];
  var nextWeight=S.barWeight-last*2;
  if((S.phase==='snatch'||S.phase==='cj')&&nextWeight<S.minNextWeight){
    log('Can\'t go below '+S.minNextWeight+' lbs — bar never goes down.','fail');
    return;
  }

  var removed=S.plateStack.pop();
  recalcBar();
  float(S.barWeight+' LBS',S.tX,160,'#f0e6d3',14);
  log('Stripped '+removed+'s. Bar is now '+S.barWeight+' lbs.','lift');

  // Girls leave if weight drops below 315
  if(S.barWeight<315&&(S.girls.phase==='watching'||S.girls.phase==='entering')){
    S.girls.phase='leaving';
    log('The girls lost interest and started leaving.','rest');
  }

  updUI();
}

// --- PHASE TRANSITIONS ---

function enterMeet(){
  if(S.busy)return;
  // Girls leave the gym when Tark enters the meet
  if(S.girls.phase==='gym_idle'){S.girls.phase='leaving';S.girls.reactT=0;}
  setPhase('mode_select');
}

// --- TAUNT SYSTEM ---
var TAUNT_TYPES=[
  {id:'staredown',weight:30,label:'Stare Down'},
  {id:'chalk_clap',weight:25,label:'Chalk Clap'},
  {id:'trash_talk',weight:25,label:'Trash Talk'},
  {id:'grunt',weight:20,label:'Grunt & Yell'}
];
var TRASH_TALK_LINES=[
  '"That\'s your opener? My grandma warms up heavier."',
  '"You look nervous. You should be."',
  '"I\'ve seen stronger pulls from a screen door."',
  '"Nice singlet. Does it come in men\'s?"',
  '"The only thing you\'re lifting today is your expectations."',
  '"I\'d wish you luck, but it won\'t help."',
  '"You sure you\'re in the right weight class?"'
];
var COACH_TAUNT_REACTIONS=[
  {text:'Get in his head. I like it.',pos:true},
  {text:'Focus on yourself, not them.',pos:false},
  {text:'Save that energy for the platform.',pos:false},
  {text:'Good. Let him know you\'re here.',pos:true},
  {text:'Mind games won\'t help your total.',pos:false},
  {text:'That\'s the killer instinct I want to see.',pos:true}
];

function doTaunt(targetId){
  if(S.busy)return;
  if(S.phase!=='warmup')return;
  // Cooldown check
  if(S.tauntCooldown&&Date.now()<S.tauntCooldown)return;

  // 1v1 platform: target is S.rival directly
  var on1v1Platform=is1v1()&&S.scene==='platform';
  var target=null;
  if(on1v1Platform){
    target=S.rivals[0];
    if(!target||!target.active)return;
  }else{
    // Multi-rival backroom: find by ID or nearest featured
    if(targetId){
      for(var i=0;i<S.rivals.length;i++){
        if(S.rivals[i].id===targetId&&S.rivals[i].featured){target=S.rivals[i];break;}
      }
    }
    if(!target){
      var bestD=9999;
      for(var i=0;i<S.rivals.length;i++){
        var r=S.rivals[i];
        if(!r.featured||!r.active)continue;
        var dd=Math.abs(S.tX-r.featX);
        if(dd<bestD){bestD=dd;target=r;}
      }
    }
  }
  if(!target)return;

  lock();
  var rShort=target.name.split(' ')[0].toUpperCase();
  // Rival position helpers — platform uses r.x, backroom uses featX
  var rivalX=on1v1Platform?target.x:target.featX;
  var rivalY=on1v1Platform?328:target.featY;

  // Pick taunt type (weighted random)
  var totalW=0;
  for(var i=0;i<TAUNT_TYPES.length;i++)totalW+=TAUNT_TYPES[i].weight;
  var roll=Math.random()*totalW;var cum=0;var taunt=TAUNT_TYPES[0];
  for(var i=0;i<TAUNT_TYPES.length;i++){
    cum+=TAUNT_TYPES[i].weight;
    if(roll<cum){taunt=TAUNT_TYPES[i];break;}
  }

  // Walk toward rival
  var destX=on1v1Platform?rivalX-80:rivalX-40;
  walkTo(destX,function(){
    // Pick rival reaction: ignore 30%, stare 30%, laugh 20%, rattled 20%
    var rr=Math.random();
    var reaction=rr<0.3?'ignore':rr<0.6?'stare':rr<0.8?'laugh':'rattled';

    // Apply taunt effects
    if(taunt.id==='staredown'){
      S.nervousness=clamp(S.nervousness+3,0,100);
      float('+3 NERV',S.tX,180,'#ff4444',11);
      log('Tark locks eyes with '+rShort+'. Neither blinks.','phase');
      if(reaction==='rattled'){
        target.featPose='flinch';target.featPoseT=Date.now();if(on1v1Platform)target.pose='idle';
        S.focus=clamp(S.focus+5,0,100);
        float('+5 FOC',S.tX,200,'#cc88ff',12);
        log(rShort+' flinches. He looked away first.','phase');
      }else if(reaction==='stare'){
        S.nervousness=clamp(S.nervousness+5,0,100);
        target.featPose='staredown';target.featPoseT=Date.now();if(on1v1Platform)target.pose='idle';
        float('+5 NERV',S.tX,200,'#ff4444',11);
        log(rShort+' stares right back. Ice cold.','phase');
      }else if(reaction==='laugh'){
        target.featPose='laughing';target.featPoseT=Date.now();if(on1v1Platform)target.pose='idle';
        S.nervousness=clamp(S.nervousness+2,0,100);
        float('+2 NERV',S.tX,200,'#ff4444',10);
        log(rShort+' smirks and looks away. Unbothered.','phase');
      }else{
        target.featPose='idle';
        log(rShort+' doesn\'t even acknowledge Tark.','phase');
      }
    }else if(taunt.id==='chalk_clap'){
      S.nervousness=clamp(S.nervousness+2,0,100);
      float('+2 NERV',S.tX,180,'#ff4444',11);
      SFX.metalClang();
      S.screenShake=1;
      log('Tark CLAPS his chalky hands right in front of '+rShort+'. Chalk dust everywhere.','phase');
      // Chalk particle floats
      for(var ci=0;ci<3;ci++){
        S.floats.push({text:'\u2022',x:S.tX+Math.random()*40-20,y:190+ci*12,c:'#ffffff',sz:8,life:0.8});
      }
      if(reaction==='rattled'){
        target.featPose='flinch';target.featPoseT=Date.now();if(on1v1Platform)target.pose='idle';
        target.tauntRattled=true;
        log(rShort+' jumps back. He\'s rattled!','phase');
        float('RATTLED!',rivalX,rivalY-40,'#ffaa00',14);
      }else if(reaction==='stare'||reaction==='laugh'){
        target.tauntFiredUp=true;
        target.featPose='staredown';target.featPoseT=Date.now();if(on1v1Platform)target.pose='idle';
        log(rShort+' glares at Tark. That fired him up.','phase');
        float('FIRED UP!',rivalX,rivalY-40,'#ff6b35',14);
      }else{
        log(rShort+' brushes chalk off his shoulder. Unfazed.','phase');
      }
    }else if(taunt.id==='trash_talk'){
      var line=TRASH_TALK_LINES[Math.floor(Math.random()*TRASH_TALK_LINES.length)];
      log('Tark to '+rShort+': '+line,'phase');
      S.speechBubble={text:line,x:S.tX,y:130,life:2.0,fontSize:9};
      if(reaction==='rattled'){
        target.featPose='flinch';target.featPoseT=Date.now();if(on1v1Platform)target.pose='idle';
        target.tauntRattled=true;
        S.focus=clamp(S.focus+3,0,100);
        float('+3 FOC',S.tX,180,'#cc88ff',12);
        log(rShort+' looks shaken. The words landed.','phase');
      }else if(reaction==='laugh'){
        target.featPose='laughing';target.featPoseT=Date.now();if(on1v1Platform)target.pose='idle';
        S.nervousness=clamp(S.nervousness+3,0,100);
        float('+3 NERV',S.tX,180,'#ff4444',11);
        log(rShort+' LAUGHS in Tark\'s face.','phase');
      }else if(reaction==='stare'){
        target.featPose='staredown';target.featPoseT=Date.now();if(on1v1Platform)target.pose='idle';
        target.tauntFiredUp=true;
        S.nervousness=clamp(S.nervousness+4,0,100);
        float('+4 NERV',S.tX,180,'#ff4444',11);
        float('FIRED UP!',rivalX,rivalY-40,'#ff6b35',14);
        log(rShort+' says nothing. His eyes say everything. He\'s fired up.','phase');
      }else{
        log(rShort+' pretends he didn\'t hear. Or maybe he didn\'t.','phase');
      }
    }else if(taunt.id==='grunt'){
      S.focus=clamp(S.focus+5,0,100);
      S.adrenaline=clamp(S.adrenaline+5,0,100);
      S.nervousness=clamp(S.nervousness+3,0,100);
      float('+5 FOC',S.tX-15,170,'#cc88ff',12);
      float('+5 ADR',S.tX+15,185,'#ff6b35',11);
      float('+3 NERV',S.tX,200,'#ff4444',10);
      S.screenShake=3;
      SFX.siren();
      S.speechBubble={text:'RAAAAARGH!!',x:S.tX,y:140,life:1.5,fontSize:14};
      log('Tark lets out a PRIMAL YELL. The whole room stops.','phase');
      if(reaction==='rattled'){
        target.featPose='flinch';target.featPoseT=Date.now();if(on1v1Platform)target.pose='idle';
        log(rShort+' flinches hard. Everyone saw it.','phase');
      }else if(reaction==='stare'||reaction==='laugh'){
        target.tauntFiredUp=true;
        target.featPose='staredown';target.featPoseT=Date.now();if(on1v1Platform)target.pose='idle';
        float('FIRED UP!',rivalX,rivalY-40,'#ff6b35',14);
        log(rShort+' nods slowly. He\'s fired up now.','phase');
      }else{
        log('The room goes quiet. Then everyone goes back to warming up.','phase');
      }
    }

    // Coach comment (40% chance)
    if(Math.random()<0.4){
      var cr=COACH_TAUNT_REACTIONS[Math.floor(Math.random()*COACH_TAUNT_REACTIONS.length)];
      S.coachBubble={text:cr.text,t:Date.now(),dur:3500};
      log('COACH: "'+cr.text+'"','coach');
      if(cr.pos){
        S.focus=clamp(S.focus+2,0,100);
        float('+2 FOC',S.tX,220,'#7fdb6a',10);
      }else{
        S.nervousness=clamp(S.nervousness+2,0,100);
        float('+2 NERV',S.tX,220,'#ff4444',10);
      }
    }

    // Set cooldown (20 seconds)
    S.tauntCooldown=Date.now()+20000;
    updUI();

    // Walk back after a beat
    setTimeout(function(){
      walkBack(function(){unlock();});
    },1200);
  });
}

// Competition taunt — 1v1 only, during snatch/cj between turns
function doCompTaunt(){
  if(S.busy)return;
  if(!is1v1())return;
  if(S.phase!=='snatch'&&S.phase!=='cj')return;
  if(S.turn&&S.turn.whose)return; // someone's lifting
  if(S.tauntCooldown&&Date.now()<S.tauntCooldown)return;
  var target=S.rivals[0];
  if(!target||!target.active)return;

  lock();
  var rShort=target.name.split(' ')[0].toUpperCase();
  var rivalX=target.x;

  // Only staredown + trash_talk during competition
  var taunt=Math.random()<0.5?{id:'staredown'}:{id:'trash_talk'};

  // Walk toward rival
  var destX=rivalX-80;
  walkTo(destX,function(){
    var rr=Math.random();
    var reaction=rr<0.3?'ignore':rr<0.6?'stare':rr<0.8?'laugh':'rattled';

    if(taunt.id==='staredown'){
      S.nervousness=clamp(S.nervousness+4,0,100);
      float('+4 NERV',S.tX,180,'#ff4444',11);
      log('Tark STARES DOWN '+rShort+' between lifts.','phase');
      if(reaction==='rattled'){
        target.tauntRattled=true;
        float('RATTLED!',rivalX,288,'#ffaa00',14);
        log(rShort+' looks away. He\'s rattled!','phase');
      }else if(reaction==='stare'){
        target.tauntFiredUp=true;
        S.nervousness=clamp(S.nervousness+3,0,100);
        float('+3 NERV',S.tX,200,'#ff4444',11);
        float('FIRED UP!',rivalX,288,'#ff6b35',14);
        log(rShort+' stares right back. Ice cold.','phase');
      }else if(reaction==='laugh'){
        S.nervousness=clamp(S.nervousness+2,0,100);
        float('+2 NERV',S.tX,200,'#ff4444',10);
        log(rShort+' smirks. Unbothered.','phase');
      }else{
        log(rShort+' ignores it. Stone cold.','phase');
      }
    }else{
      var line=TRASH_TALK_LINES[Math.floor(Math.random()*TRASH_TALK_LINES.length)];
      log('Tark to '+rShort+': '+line,'phase');
      S.speechBubble={text:line,x:S.tX,y:130,life:2.0,fontSize:9};
      if(reaction==='rattled'){
        target.tauntRattled=true;
        S.focus=clamp(S.focus+3,0,100);
        float('+3 FOC',S.tX,180,'#cc88ff',12);
        float('RATTLED!',rivalX,288,'#ffaa00',14);
        log(rShort+' looks shaken.','phase');
      }else if(reaction==='laugh'){
        S.nervousness=clamp(S.nervousness+3,0,100);
        float('+3 NERV',S.tX,180,'#ff4444',11);
        log(rShort+' LAUGHS.','phase');
      }else if(reaction==='stare'){
        target.tauntFiredUp=true;
        S.nervousness=clamp(S.nervousness+4,0,100);
        float('+4 NERV',S.tX,180,'#ff4444',11);
        float('FIRED UP!',rivalX,288,'#ff6b35',14);
        log(rShort+' is fired up now.','phase');
      }else{
        log(rShort+' pretends he didn\'t hear.','phase');
      }
    }

    // Coach comment (40%)
    if(Math.random()<0.4){
      var msgs=['Focus on YOUR lifts!','That\'s enough. Save it for the bar.','I love it. Get in his head.','Careful. Don\'t lose focus.'];
      var cmsg=msgs[Math.floor(Math.random()*msgs.length)];
      S.coachMsg=cmsg;
      S.coachBubble=Date.now()+3500;
      log('COACH: "'+cmsg+'"','coach');
    }

    S.tauntCooldown=Date.now()+20000;
    updUI();

    setTimeout(function(){
      walkTo(LAYOUT.comp.homeX,function(){unlock();});
    },1200);
  });
}

function declareOpener(){
  if(S.busy)return;
  if(S.phase!=='warmup')return;
  lock();
  // Read weight from input
  var inp=document.getElementById('weightInput');
  var openerW=45;
  if(S.warmup&&S.warmup.card){
    var lastCard=S.warmup.card[S.warmup.card.length-1].weight;
    openerW=Math.round(lastCard*1.08/5)*5;// ~8% above last warmup
  }
  if(inp&&inp.parentElement.style.display!=='none'){
    var typed=parseInt(inp.value)||openerW;
    openerW=Math.max(45,Math.min(typed,MAX_BAR_WEIGHT||700));
  }else if(is1v1()&&S.scene==='platform'&&S.barWeight>45){
    // 1v1 platform: use loaded bar weight as opener
    openerW=S.barWeight;
  }
  if(S.warmup)S.warmup.openerDeclared=openerW;
  // Coach reaction based on warmup quality
  var coachMsg='Locked in at '+openerW+'. Let\'s go.';
  if(S.warmup&&S.warmup.maxWeight>0){
    if(openerW>S.warmup.maxWeight*1.15){
      coachMsg='That\'s aggressive — you only hit '+S.warmup.maxWeight+' in warmup. Hope you\'re ready.';
    }else if(S.warmup.sloppyHeavy>0){
      coachMsg=openerW+' locked in. We had some rough reps — stay sharp out there.';
    }else if(S.warmup.cardStep>=(S.warmup.card?S.warmup.card.length:7)){
      coachMsg=openerW+'. Perfect warmup. You\'re ready. Go get it.';
    }
  }
  log('===============================','phase');
  log('Tark declares '+openerW+' lbs for his opening snatch.','phase');
  log('COACH: "'+coachMsg+'"','coach');
  S.coachBubble={text:coachMsg,t:Date.now(),dur:3000};
  float('OPENER: '+openerW,S.tX,140,'#ffcc00',18);
  // Brief pause then begin competition
  setTimeout(function(){
    unlock();
    beginCompetition();
  },2000);
}

function beginCompetition(){
  if(S.busy)return;
  // Calculate warmup score before clearing warmup state
  var wScore=0;
  if(S.warmup){
    if(S.warmup.lifts>=5)wScore+=20;
    else if(S.warmup.lifts>=3)wScore+=10;
    var target=S.warmup.card?S.warmup.card[S.warmup.card.length-1].weight:200;
    if(S.warmup.maxWeight>=target*0.80)wScore+=20;
    if(S.readiness>50)wScore+=20;
    if(S.technique>50)wScore+=20;
    if(S.warmup.sloppyHeavy===0)wScore+=10;
    var timeUsed=Date.now()-S.warmup.startTime;
    if(timeUsed>=S.warmup.duration*0.5)wScore+=10;// used at least half the time
    wScore-=S.warmup.sloppyHeavy*10;
    if(S.readiness<25)wScore-=20;
    wScore=Math.max(0,Math.min(100,wScore));
  }
  S.warmupScore=wScore;
  // Clean up warmup state
  S.warmup=null;
  // Reset bar for competition
  S.plateStack=[];
  S.barWeight=45;
  S.minNextWeight=45;
  S.attempt=0;
  S.bestSnatch=0;
  S.lastMadeSnatch=0;
  S.snatchAttempts=[null,null,null];
  S.snatchWeights=[0,0,0];

  log('===============================','phase');
  log('SNATCHES BEGIN. 3 attempts. Make them count.','phase');
  // Warmup quality feedback
  if(S.warmupScore>=80){log('Warmup was excellent. Tark feels dialed in.','lift');}
  else if(S.warmupScore>=50){log('Decent warmup. Tark feels ready enough.','rest');}
  else if(S.warmupScore>=20){log('Warmup was rushed. Tark doesn\'t feel sharp.','fail');}
  else{log('Barely warmed up. This could get ugly.','fail');}
  log('Empty bar is 45 lbs. Load up from the rack.','rest');
  // Scouting reports from coach
  for(var si=0;si<S.rivals.length;si++){
    var sr=S.rivals[si];
    if(sr.scouting)log('COACH on '+sr.name.split(' ')[0]+': '+sr.scouting,'coach');
  }
  log('===============================','phase');
  if(is1v1()){
    // 1v1: stay on platform
    S.scene='platform';
    S.homeX=LAYOUT.comp.homeX;
    S.tX=LAYOUT.comp.homeX;
    S.coachMsg='Let\'s do this. Focus up.';
    S.coachBubble=Date.now()+5000;
    float('SNATCH',S.tX,140,'#ff6b35',24);
    float('3 ATTEMPTS',S.tX,170,'#f0e6d3',14);
  }else{
    // Multi-rival: enter backroom for competition
    generateBackroomExtras();
    S.scene='backroom';
    S.homeX=LAYOUT.backroom.homeX;
    S.tX=LAYOUT.backroom.homeX;
    S.tv.mode='leaderboard';
    S.coachMsg='Let\'s do this. Focus up.';
    float('SNATCH',S.tX,140,'#ff6b35',24);
    float('3 ATTEMPTS',S.tX,170,'#f0e6d3',14);
  }
  rivalStartPhase('snatch');
  setPhase('snatch');
  startTurnSystem('snatch');
}

function beginCJ(){
  if(S.busy)return;
  // Reset bar for C&J
  S.plateStack=[];
  S.barWeight=45;
  S.minNextWeight=45;
  S.attempt=0;
  S.bestCJ=0;
  S.lastMadeCJ=0;
  S.cjAttempts=[null,null,null];
  S.cjWeights=[0,0,0];

  // Some recovery during rest
  S.grip=clamp(S.grip+15,0,100);
  S.fatigue=Math.max(0,S.fatigue-1.0);

  log('===============================','phase');
  log('CLEAN & JERK. 3 attempts. Finish strong.','phase');
  if(S.bestSnatch>0){
    log('Best snatch was '+S.bestSnatch+' lbs. Build on it.','rest');
  }else{
    log('No snatches made. You NEED a clean & jerk total.','fail');
  }
  log('===============================','phase');
  if(is1v1()){
    // 1v1: stay on platform
    S.scene='platform';
    S.homeX=LAYOUT.comp.homeX;
    S.tX=LAYOUT.comp.homeX;
    S.coachMsg='Time for clean and jerk. Stay sharp.';
    S.coachBubble=Date.now()+5000;
    float('CLEAN & JERK',S.tX,140,'#00ccff',22);
    float('3 ATTEMPTS',S.tX,170,'#f0e6d3',14);
  }else{
    // Multi-rival: enter backroom for C&J
    generateBackroomExtras();
    S.scene='backroom';
    S.homeX=LAYOUT.backroom.homeX;
    S.tX=LAYOUT.backroom.homeX;
    S.tv.mode='leaderboard';
    S.coachMsg='Time for clean and jerk. Stay sharp.';
    float('CLEAN & JERK',S.tX,140,'#00ccff',22);
    float('3 ATTEMPTS',S.tX,170,'#f0e6d3',14);
  }
  rivalStartPhase('cj');
  setPhase('cj');
  startTurnSystem('cj');
}

// --- MINI-GAME FUNCTIONS ---

function startSnatchMiniGame(params,failChance,weight,attemptNum,context){
  resetBusyTimer();
  S.miniGame={
    type:'balance',active:true,startTime:Date.now(),
    markerPos:0.0,markerDir:1,markerSpeed:params.markerSpeed,
    greenWidth:params.greenWidth,yellowWidth:params.yellowWidth,
    resolved:false,result:null,clickPos:null,resolveTime:0,
    weight:weight,failChance:failChance,liftType:'snatch',attemptNum:attemptNum,
    context:context||'comp',
    _lastDrawTime:Date.now()
  };
}

function startCJMiniGame(params,failChance,weight,attemptNum,context){
  resetBusyTimer();
  S.miniGame={
    type:'power_pump',active:true,phase:'clean',startTime:Date.now(),
    meterFill:0.0,meterDrain:params.meterDrain,meterTarget:params.meterTarget,
    clickPower:params.clickPower,cleanDuration:params.cleanDuration,
    cleanResult:null,cleanResolveTime:0,
    jerkMarkerPos:0.0,jerkSpeed:params.jerkSpeed,
    jerkZoneCenter:params.jerkZoneCenter,jerkZoneWidth:params.jerkZoneWidth,
    jerkStartTime:0,jerkResult:null,jerkResolveTime:0,
    resolved:false,result:null,
    weight:weight,failChance:failChance,liftType:'cj',attemptNum:attemptNum,
    context:context||'comp',
    _lastDrawTime:Date.now()
  };
}

function transitionToJerkPhase(){
  var mg=S.miniGame;
  if(!mg||mg.type!=='power_pump')return;
  resetBusyTimer();
  // Stand up from front squat first
  S.pose='clean_hold';S.poseT=0;
  float('CLEAN!',S.tX,160,'#00ccff',18);
  // Brief pause in standing position, then start jerk phase
  setTimeout(function(){
    if(!S.miniGame||S.miniGame.type!=='power_pump')return;
    S.miniGame.phase='jerk';
    S.miniGame.jerkStartTime=Date.now();
    S.miniGame._lastDrawTime=Date.now();
    S.pose='jerk';S.poseT=0;
    float('JERK!',S.tX,160,'#ffcc00',20);
  },500);
}

function handleMiniGameClick(){
  var mg=S.miniGame;
  if(!mg||!mg.active)return;

  if(mg.type==='balance'){
    if(mg.resolved)return;
    mg.resolved=true;
    mg.clickPos=mg.markerPos;
    mg.resolveTime=Date.now();
    var dist=Math.abs(mg.markerPos-0.5);
    if(dist<=mg.greenWidth){
      mg.result='green';
      try{SFX.lockoutImpact();}catch(e){}
    }else if(dist<=mg.yellowWidth){
      mg.result='yellow';
      try{SFX.chalkClap();}catch(e){}
    }else{
      mg.result='red';
      try{SFX.barDrop();}catch(e){}
    }
    setTimeout(function(){resolveMiniGameResult();},600);

  }else if(mg.type==='power_pump'){
    if(mg.phase==='clean'){
      if(mg.cleanResult!==null)return;
      mg.meterFill=Math.min(1.0,mg.meterFill+mg.clickPower);
      try{SFX.plateClack();}catch(e){}
    }else if(mg.phase==='jerk'){
      if(mg.jerkResult!==null)return;
      var dist=Math.abs(mg.jerkMarkerPos-mg.jerkZoneCenter);
      if(dist<=mg.jerkZoneWidth){
        mg.jerkResult=true;
        mg.result='green';
        try{SFX.lockoutImpact();}catch(e){}
      }else{
        mg.jerkResult=false;
        mg.result='red';
        try{SFX.barDrop();}catch(e){}
      }
      mg.jerkResolveTime=Date.now();
      mg.resolved=true;
      setTimeout(function(){resolveMiniGameResult();},600);
    }
  }
}

function resolveMiniGameResult(){
  var mg=S.miniGame;
  if(!mg)return;

  // Context dispatch — non-competition contexts have their own resolve logic
  if(mg.context==='gym'){resolveGymMiniGame(mg);return;}
  if(mg.context==='beach'){resolveBeachMiniGame(mg);return;}
  if(mg.context==='warmup'){resolveWarmupMiniGame(mg);return;}

  var success=false,wobbly=false;
  if(mg.result==='green'){success=true;}
  else if(mg.result==='yellow'){success=true;wobbly=true;}

  var liftType=mg.liftType;
  var weight=mg.weight;
  var attemptNum=mg.attemptNum;
  var failChance=mg.failChance;
  var injChance=S._pendingInjChance||0;
  var overload=S._pendingOverload||0;
  var gotInjured=(!success&&injChance>0&&Math.random()<injChance);

  S.miniGame=null;
  S.lastLiftOverload=overload;

  if(gotInjured){
    if(liftType==='snatch'){
      S.snatchAttempts[attemptNum]=false;
      S.snatchWeights[attemptNum]=weight;
    }else{
      S.cjAttempts[attemptNum]=false;
      S.cjWeights[attemptNum]=weight;
    }
    triggerDNF(liftType);
    return;
  }

  if(success){
    if(liftType==='snatch'){
      S.pose='overhead';S.poseT=0;
    }else{
      S.pose='jerk';S.poseT=0;
    }

    if(liftType==='snatch'){
      S.snatchAttempts[attemptNum]=true;
      S.snatchWeights[attemptNum]=weight;
      if(weight>S.bestSnatch)S.bestSnatch=weight;
      S.lastMadeSnatch=weight;
      S.minNextWeight=weight;
    }else{
      S.cjAttempts[attemptNum]=true;
      S.cjWeights[attemptNum]=weight;
      if(weight>S.bestCJ)S.bestCJ=weight;
      S.lastMadeCJ=weight;
      S.minNextWeight=weight;
    }

    S.adrenaline=clamp(S.adrenaline+20,0,100);
    S.nervousness=Math.max(0,S.nervousness-5);
    S.strength=clamp(S.strength+2,0,100);
    S.compLiftResult='good';

    if(wobbly){
      S.technique=clamp(S.technique-5,0,100);
      S.fatigue+=0.3;
      S.grip=clamp(S.grip-5,0,100);
      float('WOBBLY SAVE',S.tX,200,'#ffcc00',14);
      log('Made it, but barely. That wobbly save took something out of Tark.','rest');
    }

    SFX.lockoutImpact();
    S.hitstop=Math.min(8,3+Math.floor(weight/80));

    var isPR=false;
    var oldBest=liftType==='snatch'?S.bestSnatch:S.bestCJ;
    if(weight>oldBest&&oldBest>0)isPR=true;

    float('GOOD LIFT!',S.tX,140,'#7fdb6a',24);
    float(weight+' LBS',S.tX,170,'#ffffff',18);

    var shakeAmt=Math.min(18,4+weight/35);
    S.screenShake=shakeAmt;
    if(isPR){
      SFX.crowdRoar();
      float('NEW PR!',S.tX,110,'#ffcc00',20);
      S.prFlash=8;
      for(var ci=0;ci<40;ci++){
        S.confetti.push({x:S.tX+Math.random()*200-100,y:100+Math.random()*60,
          vx:(Math.random()-0.5)*6,vy:-3-Math.random()*4,
          c:['#ff6b35','#7fdb6a','#ffcc00','#ff4444','#4488ff','#fff'][Math.floor(Math.random()*6)],
          life:1+Math.random()*0.5,spin:(Math.random()-0.5)*0.2,rot:0});
      }
    }else{
      SFX.crowdCheer();
    }
    var fcPct=Math.round(failChance*100);
    log('GOOD LIFT! '+weight+' lbs! ('+fcPct+'% difficulty). The crowd goes wild.','lift');
    if(S.humiliated>0&&Math.random()<0.3){
      var humGoodLines=[
        'The crowd noise shifts. Less mocking. More respect.',
        'Someone who was laughing earlier goes quiet.',
        'Tark glares at the crowd. That shut them up.',
        '"Okay maybe beach boy can lift..." \u2014 barely audible from the stands.'
      ];
      log(pick(humGoodLines),'hype');
      S.humiliated=Math.max(0,S.humiliated-0.5);
    }
    if(S.girls.phase==='watching'){S.girls.result='success';}
    setTimeout(function(){
      S.pose='idle';S.poseT=0;
      S.currentLift=null;
      tarkTurnComplete();
    },liftType==='cj'?1800:1200);

  }else{
    S.pose='failed';S.poseT=0;
    if(liftType==='snatch'){
      S.snatchAttempts[attemptNum]=false;
      S.snatchWeights[attemptNum]=weight;
    }else{
      S.cjAttempts[attemptNum]=false;
      S.cjWeights[attemptNum]=weight;
    }
    S.adrenaline=Math.max(0,S.adrenaline-15);
    S.nervousness=clamp(S.nervousness+10,0,100);
    S.compLiftResult='no_lift';
    float('NO LIFT',S.tX,140,'#ff4444',24);
    float(weight+' LBS',S.tX,170,'#ff6666',16);
    var nearMiss=failChance<0.35;
    if(nearMiss){
      float('SO CLOSE!',S.tX,200,'#ffaa44',14);
      log('NO LIFT. Missed at '+weight+' lbs. ('+Math.round(failChance*100)+'% difficulty). SO CLOSE. That one hurt.','fail');
    }else{
      log('NO LIFT. Missed at '+weight+' lbs. ('+Math.round(failChance*100)+'% difficulty). Brutal.','fail');
    }
    SFX.barDrop();SFX.crowdGroan();
    S.screenShake=Math.min(10,3+weight/60);
    if(S.humiliated>0&&Math.random()<0.4){
      var humFailLines=[
        'Someone in the crowd snickers. Tark heard it.',
        'A murmur ripples through the stands. They remember the beach.',
        '"Beach boy can\'t lift here either!" \u2014 someone yells from the crowd.',
        'Tark catches a laugh in the audience. His face burns.'
      ];
      setTimeout(function(){log(pick(humFailLines),'fail');},1500);
      S.nervousness=clamp(S.nervousness+S.humiliated,0,100);
    }
    if(S.girls.phase==='watching'){S.girls.result='fail';}
    setTimeout(function(){
      S.pose='idle';S.poseT=0;
      S.currentLift=null;
      tarkTurnComplete();
    },1200);
  }
}

// --- CONTEXT-SPECIFIC MINI-GAME RESOLVERS ---

function resolveGymMiniGame(mg){
  var success=false,wobbly=false;
  if(mg.result==='green'){success=true;}
  else if(mg.result==='yellow'){success=true;wobbly=true;}
  var weight=mg.weight;
  var liftType=mg.liftType;
  S.miniGame=null;

  if(success){
    if(liftType==='snatch'){
      S.pose='overhead';S.poseT=0;
    }else{
      S.pose='jerk';S.poseT=0;
    }
    log(pick(GYM_LIFT_MSGS),'lift');
    float('GOOD LIFT!',S.tX,140,'#7fdb6a',20);
    float(weight+' LBS',S.tX,165,'#f0e6d3',14);
    var fc=mg.failChance;
    if(fc>0.10)float(Math.round(fc*100)+'% FAIL',S.tX,185,'#ffaa44',9);
    if(wobbly){
      S.nervousness=clamp(S.nervousness+3,0,100);
      float('WOBBLY +3 NERV',S.tX,205,'#ffcc00',10);
    }
    try{SFX.lockoutImpact();}catch(e){}
    setTimeout(function(){
      S.pose='idle';S.poseT=0;
      S.currentLift=null;
      unlock();
    },1200);
  }else{
    S.pose='failed';S.poseT=0;
    log(pick(GYM_FAIL_MSGS),'fail');
    float('MISS',S.tX,140,'#ff4444',20);
    float(weight+' LBS',S.tX,165,'#ff6666',12);
    var fc2=mg.failChance;
    float(Math.round(fc2*100)+'% FAIL',S.tX,185,'#ff8888',10);
    S.nervousness=clamp(S.nervousness+3,0,100);
    float('+3 NERV',S.tX+40,205,'#ff4444',9);
    try{SFX.barDrop();}catch(e){}
    setTimeout(function(){
      S.pose='idle';S.poseT=0;
      S.currentLift=null;
      unlock();
    },1200);
  }
}

function resolveBeachMiniGame(mg){
  var success=false;
  if(mg.result==='green'||mg.result==='yellow')success=true;
  var weight=mg.weight;
  var comp=mg._beachComp;
  var tx=mg._beachTx;
  var fcPct=Math.round(mg.failChance*100);
  S.miniGame=null;

  if(success){
    comp.animPhase='tark_clean';
    setTimeout(function(){
      comp.animPhase='tark_jerk';
      comp.tarkAttempts.push(true);
      comp.liftLog.push({who:'tark',weight:weight,made:true});
      comp.currentBar=weight;
      comp.bestTark=weight;
      comp.lastLifter='tark';
      S.pose='idle';S.poseT=0;
      S.adrenaline=clamp(S.adrenaline+15,0,100);
      S.nervousness=Math.max(0,S.nervousness-5);
      float('GOOD LIFT!',tx,240,'#7fdb6a',18);
      float(weight+' LBS ('+fcPct+'%)',tx,260,'#fff',11);
      try{SFX.crowdCheer();}catch(e){}
      if(comp.hasGirlfriend){comp.girlSpeech=pick(GIRL_CHEER);}
      log('GOOD LIFT! '+weight+' lbs! ('+fcPct+'% fail chance).','lift');
      setTimeout(function(){comp.animPhase=null;
        beachWalkTo('tark',200,function(){
          comp.round++;
          comp.rivalSpeech=null;comp.girlSpeech=null;
          comp.rivalNextWeight=getRivalNextWeight(comp);
          comp.turn='rival_lifting';
          lock();updUI();renderControls();
          log(BEACH_COUPLE_NAMES[comp.rivalIdx]+' must beat '+weight+' lbs. Going for '+comp.rivalNextWeight+'.','phase');
          beachWalkTo('rival',450,function(){doBeachRivalLift();});
        });
      },1400);
    },600);
  }else{
    comp.animPhase='tark_fail';
    comp.tarkAttempts.push(false);
    comp.liftLog.push({who:'tark',weight:weight,made:false});
    S.pose='idle';S.poseT=0;
    S.adrenaline=Math.max(0,S.adrenaline-10);
    S.nervousness=clamp(S.nervousness+8,0,100);
    float('NO LIFT!',tx,240,'#ff4444',18);
    float(weight+' LBS ('+fcPct+'%)',tx,260,'#ff6666',11);
    try{SFX.barDrop();}catch(e){}
    if(comp.hasGirlfriend){comp.girlSpeech=pick(GIRL_SAD);}
    log('NO LIFT. Missed at '+weight+' lbs. ('+fcPct+'% fail chance).','fail');
    setTimeout(function(){comp.animPhase=null;
      beachWalkTo('tark',200,function(){
        resolveBeachGymComp('rival');
      });
    },1500);
  }
}

function resolveWarmupMiniGame(mg){
  var liftType=mg.liftType;
  var weight=mg.weight;
  var cardReps=mg._warmupCardReps||1;
  var onCard=mg._warmupOnCard||false;
  var goodThreshold=mg._warmupGoodThreshold||false;
  var p=mg._warmupP||0;
  var repLabel=cardReps===3?'triple':cardReps===2?'double':'single';
  S.miniGame=null;

  // Map mini-game result to rep quality
  var quality='sloppy'; // red
  if(mg.result==='green')quality='good';
  else if(mg.result==='yellow')quality='decent';

  // Pose based on lift type
  if(liftType==='snatch'){
    S.pose='overhead';S.poseT=0;
  }else{
    S.pose='clean_hold';S.poseT=0;
    setTimeout(function(){S.pose='jerk';},400);
  }

  // Calculate TECH/RDY gains based on quality
  var rdyGain=cardReps===3?18:cardReps===2?16:12;
  var techGain=0;

  if(quality==='good'){
    var techPerRep=cardReps===3?4:cardReps===2?6:(8+Math.round(p*4));
    techGain=cardReps>1?techPerRep*cardReps:techPerRep;
    S.technique=clamp(S.technique+techGain,0,100);
    float('+'+techGain+' TECH',S.tX,170,'#6699ff',14);
    if(cardReps>1){
      log('Smooth '+repLabel+' at '+weight+'! TECH+'+techGain+'.','lift');
    }else{
      log('Solid single! TECH+'+techGain+'. Tark makes it look easy.','lift');
    }
  }else if(quality==='decent'){
    var techPerRep2=cardReps===3?3:cardReps===2?4:(5+Math.round(p*2));
    techGain=cardReps>1?techPerRep2*cardReps:techPerRep2;
    S.technique=clamp(S.technique+techGain,0,100);
    float('+'+techGain+' TECH',S.tX,170,'#6699ff',12);
    float('DECENT',S.tX,155,'#ffcc00',13);
    log('Decent '+repLabel+' at '+weight+'. TECH+'+techGain+'. Not bad, not great.','rest');
  }else{
    techGain=cardReps>1?2*cardReps:2;
    S.technique=clamp(S.technique+techGain,0,100);
    float('+'+techGain+' TECH',S.tX,170,'#6699ff',11);
    float('SLOPPY',S.tX,155,'#ffaa00',13);
    log(pick(SLOPPY_MSGS)+' TECH+'+techGain+' (sloppy '+repLabel+').','rest');
  }

  S.readiness=clamp(S.readiness+rdyGain,0,100);
  float('+'+rdyGain+' RDY',S.tX,190,'#7fdb6a',12);

  // Track warmup stats + card advancement + coach suggestion
  if(S.warmup){
    S.warmup.lifts++;
    if(weight>S.warmup.maxWeight)S.warmup.maxWeight=weight;
    if(quality==='sloppy'){
      S.warmup.lastSloppyWeight=weight;
      var target=S.warmup.card?S.warmup.card[S.warmup.card.length-1].weight:200;
      if(weight>target*0.70)S.warmup.sloppyHeavy++;
    }
    if(onCard&&S.warmup.cardStep<S.warmup.card.length){
      S.warmup.card[S.warmup.cardStep].done=true;
      S.warmup.cardStep++;
    }
    setTimeout(function(){
      if(!S.warmup)return;
      var sug=getCoachWarmupSuggestion();
      S.warmup.coachSuggestion=sug.weight;
      S.coachBubble={text:sug.message,t:Date.now(),dur:4000};
      var wInp=document.getElementById('weightInput');
      if(wInp){wInp.value=sug.weight;wInp._warmupInit=false;}
      var csTxt=document.getElementById('coachSuggestion');
      if(csTxt)csTxt.textContent='Coach: "'+sug.message+'"';
    },1500);
  }

  setTimeout(function(){
    S.pose='idle';S.poseT=0;
    S.currentLift=null;
    walkBack(function(){ unlock(); });
  },1000);
}

// --- COMPETITION LIFT ---

function doCompLift(){
  if(S.busy)return;
  if(S.phase!=='snatch'&&S.phase!=='cj')return;
  if(S.turn.tarkDone)return;
  // Must be Tark's turn and in lift phase (not declaring)
  if(S.turn.whose!=='tark'){log('Wait for your turn.','rest');return;}
  if(S.turn.phase!=='idle'&&S.turn.phase!=='platform_ritual'){log('Declare your weight first.','rest');return;}
  lock();
  S.ritualCoachVisible=false;S.ritualCoachMsg='';
  executeTarkTurn();

  var liftType=S.phase;
  S.currentLift=liftType;
  var attemptNum=S.turn.tarkAttempt;
  S.attempt=attemptNum; // sync for stat cost calculations
  var weight=S.barWeight;

  log((liftType==='snatch'?'Snatch':'Clean & Jerk')+' attempt '+(attemptNum+1)+'/3 at '+weight+' lbs...','phase');

  // Walk to platform, then lift
  walkTo(LAYOUT.comp.platformX,function(){
    S.turn.tarkOnPlatform=true;

    // Costs — scale with weight (light lifts are cheap, heavy lifts punish)
    var p=ep();
    var strCost=Math.max(2,Math.round(p*6));
    S.strength=clamp(S.strength-strCost,0,100);
    S.fatigue=S.fatigue+(p*0.65);
    S.grip=clamp(S.grip-Math.max(1,Math.round(p*3)),0,100);

    if(S.girls.phase==='watching'||S.girls.phase==='entering'){
      S.nervousness=clamp(S.nervousness+3,0,100);
    }

    var failChance=getFailChance(liftType);
    // Warmup quality modifier — applies to first snatch only
    if(liftType==='snatch'&&attemptNum===0&&typeof S.warmupScore==='number'){
      if(S.warmupScore>=80)failChance=Math.max(0.02,failChance-0.05);
      else if(S.warmupScore<20)failChance=Math.min(0.92,failChance+0.20);
      else if(S.warmupScore<50)failChance=Math.min(0.92,failChance+0.10);
    }

    // Store pending values for mini-game resolution
    var params=getMiniGameParams(liftType,failChance);
    S._pendingFailChance=failChance;
    S._pendingInjChance=getInjuryChance(failChance);
    S._pendingOverload=Math.max(0,(failChance-0.40)/0.50);
    S._pendingWeight=weight;
    S._pendingLiftType=liftType;
    S._pendingAttemptNum=attemptNum;

    S.pose='pull';S.poseT=0;
    SFX.metalClang();

    // After pull animation, start mini-game instead of random roll
    setTimeout(function(){
      if(liftType==='snatch'){
        S.pose='overhead_squat';S.poseT=0;
        startSnatchMiniGame(params,failChance,weight,attemptNum);
      }else{
        S.pose='front_squat';S.poseT=0;
        startCJMiniGame(params,failChance,weight,attemptNum);
      }
    },800);
  });
}

function advanceAttempt(liftType){
  S.attempt++;

  if(liftType==='snatch'){
    if(S.attempt>=3){
      // Snatches done
      log('===============================','phase');
      log('Snatch phase complete.','phase');
      if(S.bestSnatch>0){
        log('Best snatch: '+S.bestSnatch+' lbs. Not bad.','lift');
      }else{
        log('Bombed the snatches. Zero on the board. Oof.','fail');
      }
      log('===============================','phase');

      // Transition to rest
      S.plateStack=[];
      S.barWeight=45;
      S.minNextWeight=45;
      S.attempt=0;
      setPhase('rest_sn_cj');
      unlock();
    }else{
      log('Attempt '+(S.attempt+1)+'/3 next. Adjust weight if needed.','rest');
      updUI();
      unlock();
    }
  }else{
    // C&J
    if(S.attempt>=3){
      // All done
      log('===============================','phase');
      log('Clean & Jerk phase complete.','phase');
      if(S.bestCJ>0){
        log('Best C&J: '+S.bestCJ+' lbs.','lift');
      }else{
        log('Bombed the clean & jerks too. Disaster.','fail');
      }
      log('===============================','phase');
      unlock();
      showResults();
    }else{
      log('Attempt '+(S.attempt+1)+'/3 next. Adjust weight if needed.','rest');
      updUI();
      unlock();
    }
  }
}

// --- RESULTS ---

function generateRegrets(){
  var regrets=[];
  var total=S.bestSnatch+S.bestCJ;
  var r=S.rival;
  var pakTotal=r.bestSnatch+r.bestCJ;
  var isDNF=S.dnf;
  var pb=0;
  try{pb=parseInt(localStorage.getItem('tark_pb'))||0;}catch(e){}

  // PB proximity
  if(!isDNF&&total>0&&pb>total&&(pb-total)<=20){
    regrets.push('You were '+( pb-total)+' lbs from your personal best.');
  }

  // Smoking cost
  var cigsSmoked=3-S.cigsLeft;
  if(cigsSmoked>0){
    var cost=cigsSmoked*5+Math.round(S.lungDamage*8);
    regrets.push('Smoking cost you roughly '+cost+' lbs of lifting capacity.');
  }

  // Rival comparison
  var isMulti=S.rivals&&S.rivals.length>1;
  if(isMulti&&total>0){
    // Multi-comp: compare against the winner
    var standings=getStandings();
    var tarkPlace=1;
    for(var si=0;si<standings.length;si++){if(standings[si].isTark){tarkPlace=si+1;break;}}
    var winner=null;
    for(var si=0;si<standings.length;si++){if(!standings[si].isTark&&standings[si].total>0){winner=standings[si];break;}}
    if(tarkPlace===1&&winner){
      regrets.push('You beat '+winner.name+' by '+(total-winner.total)+' lbs. Dominant.');
    }else if(tarkPlace===2&&winner){
      regrets.push(winner.name+' beat you by '+(winner.total-total)+' lbs. Silver stings.');
    }else if(tarkPlace>2&&winner){
      regrets.push(winner.name+' won with '+winner.total+' lbs. You were '+tarkPlace+getOrdinal(tarkPlace)+'.');
    }
  }else if(r.active&&pakTotal>0&&total>0){
    // 1v1: head-to-head
    var rShort=r.name?r.name.split(' ')[0]:'Pak';
    if(pakTotal>total&&S.bestSnatch>=r.bestSnatch){
      regrets.push('You were ahead after snatches. '+rShort+' beat you in clean & jerk by '+(r.bestCJ-S.bestCJ)+' lbs.');
    }
    if(pakTotal>total){
      regrets.push(rShort+' beat you by '+(pakTotal-total)+' lbs. He won\'t even remember your name.');
    }
    if(total>pakTotal){
      regrets.push('You beat '+rShort+' by '+(total-pakTotal)+' lbs. He\'ll be hearing about this at home.');
    }
  }

  // Near misses — check failed attempts that were close
  var allAttempts=S.snatchAttempts.concat(S.cjAttempts);
  var allWeights=S.snatchWeights.concat(S.cjWeights);
  for(var i=0;i<allAttempts.length;i++){
    if(allAttempts[i]===false&&allWeights[i]>0){
      // Estimate how close: lighter weight = closer miss
      var baseWeight=i<3?250:300;
      if(allWeights[i]<=baseWeight+30){
        var liftName=i<3?'Snatch':'C&J';
        regrets.push(liftName+' attempt at '+allWeights[i]+' was THIS close.');
        break; // only one "close" regret
      }
    }
  }

  // Bombed out regret
  if(!isDNF&&total===0){
    regrets.push('Zero. On the board. You flew here for this.');
  }

  // DNF regret
  if(isDNF){
    regrets.push('Your body gave out. Maybe don\'t load 315 when you can barely hold 225.');
  }

  return regrets.slice(0,3); // max 3 regrets
}

function saveToLeaderboard(total,score){
  if(total<=0&&!S.dnf)return;
  try{
    var lb=JSON.parse(localStorage.getItem('tark_leaderboard')||'[]');
    lb.push({total:total,score:score,dnf:S.dnf,date:new Date().toLocaleDateString(),
      sn:S.bestSnatch,cj:S.bestCJ,pak:(S.rival.bestSnatch+S.rival.bestCJ)});
    lb.sort(function(a,b){return(b.total||0)-(a.total||0);});
    if(lb.length>10)lb=lb.slice(0,10);
    localStorage.setItem('tark_leaderboard',JSON.stringify(lb));
  }catch(e){}
}

function renderLeaderboard(currentTotal){
  var el=document.getElementById('resLeaderboard');
  if(!el)return;
  try{
    var lb=JSON.parse(localStorage.getItem('tark_leaderboard')||'[]');
    if(lb.length===0){el.style.display='none';return;}
    el.style.display='block';
    var html='<div style="color:#666;margin-bottom:4px;letter-spacing:2px;font-size:9px">LEADERBOARD</div>';
    html+='<table style="width:100%;border-collapse:collapse;font-size:10px;color:#888">';
    html+='<tr style="color:#555"><td>#</td><td>TOTAL</td><td>SN</td><td>CJ</td><td>RIVAL</td><td></td></tr>';
    for(var i=0;i<lb.length;i++){
      var entry=lb[i];
      var isCurrent=(entry.total===currentTotal&&i===lb.map(function(e){return e.total;}).indexOf(currentTotal));
      var style=isCurrent?'color:#ff6b35;font-weight:bold':'';
      var result=entry.total>0?entry.total+(entry.dnf?' *':''):entry.dnf?'DNF':'0';
      var pakRes=entry.pak>0?entry.pak+'':'---';
      var vs=entry.total>0&&entry.pak>0?(entry.total>entry.pak?'W':entry.total<entry.pak?'L':'T'):'';
      var vsColor=vs==='W'?'#7fdb6a':vs==='L'?'#ff4444':'#cccc33';
      html+='<tr style="'+style+'"><td>'+(i+1)+'</td><td>'+result+'</td>';
      html+='<td>'+(entry.sn||'---')+'</td><td>'+(entry.cj||'---')+'</td>';
      html+='<td>'+pakRes+(vs?' <span style="color:'+vsColor+'">'+vs+'</span>':'')+'</td>';
      html+='<td>'+entry.date+'</td></tr>';
    }
    html+='</table>';
    el.innerHTML=html;
  }catch(e){el.style.display='none';}
}

function showResults(){
  console.log('[DNF] showResults() called, dnf='+S.dnf+', bestSn='+S.bestSnatch+', bestCJ='+S.bestCJ);
  var total=S.bestSnatch+S.bestCJ;
  var finalScore=Math.floor(total*S.mult);
  var isDNF=S.dnf;
  var r=S.rival;
  var isMulti=S.rivals&&S.rivals.length>1;
  var standings=getStandings();
  var tarkPlace=1;
  for(var si=0;si<standings.length;si++){if(standings[si].isTark){tarkPlace=si+1;break;}}
  var totalLifters=standings.length;
  var topRival=null;
  for(var si=0;si<standings.length;si++){if(!standings[si].isTark){topRival=standings[si];break;}}
  var pakTotal=r.active?(r.bestSnatch+r.bestCJ):0;

  // Personal best — DNF still counts if you posted a total
  var pb=0;
  try{pb=parseInt(localStorage.getItem('tark_pb'))||0;}catch(e){}
  var isRecord=(total>pb&&total>0);
  if(isRecord){
    try{localStorage.setItem('tark_pb',String(total));}catch(e){}
    pb=total;
  }

  // Save to leaderboard
  saveToLeaderboard(total,finalScore);

  // Fill results panel
  var resSnatch=document.getElementById('resSnatch');
  var resCJ=document.getElementById('resCJ');
  var resTotal=document.getElementById('resTotal');
  var resDetail=document.getElementById('resDetail');
  var resRecord=document.getElementById('resRecord');
  var resShare=document.getElementById('resShare');
  var resRival=document.getElementById('resRival');
  var resRegrets=document.getElementById('resRegrets');
  var resRestart=document.getElementById('resRestart');

  if(resSnatch)resSnatch.textContent='Best Snatch: '+(S.bestSnatch>0?S.bestSnatch+' lbs':'NONE');
  if(resCJ)resCJ.textContent='Best C&J: '+(S.bestCJ>0?S.bestCJ+' lbs':'NONE');

  if(isDNF){
    var phaseLabel=S.dnfPhase==='warmup'?'warm-up':S.dnfPhase==='snatch'?'snatches':'clean & jerk';
    if(total>0){
      if(resTotal)resTotal.textContent=total+' LBS TOTAL (INJURY)';
      if(resDetail){
        var d='Injured during '+phaseLabel+' \u2014 successful lifts still count';
        d+='\nMultiplier: '+S.mult.toFixed(1)+'x | Final Score: '+finalScore;
        if(isMulti)d+='\nPlaced '+tarkPlace+getOrdinal(tarkPlace)+' of '+totalLifters;
        d+='\nPersonal Best: '+pb+' lbs';
        resDetail.textContent=d;
      }
    }else{
      if(resTotal)resTotal.textContent='DNF \u2014 INJURY';
      if(resDetail){
        var d='Injured during '+phaseLabel+' \u2014 no successful lifts';
        if(isMulti)d+='\nPlaced '+tarkPlace+getOrdinal(tarkPlace)+' of '+totalLifters;
        d+='\nPersonal Best: '+pb+' lbs';
        resDetail.textContent=d;
      }
    }
  }else if(total>0){
    if(resTotal)resTotal.textContent=total+' LBS TOTAL';
    if(resDetail){
      var d='Multiplier: '+S.mult.toFixed(1)+'x | Final Score: '+finalScore;
      d+='\nCigs: '+(3-S.cigsLeft)+' | Shakes: '+(3-S.shakesLeft);
      if(isMulti)d+='\nPlaced '+tarkPlace+getOrdinal(tarkPlace)+' of '+totalLifters;
      d+='\nPersonal Best: '+pb+' lbs';
      resDetail.textContent=d;
    }
  }else{
    if(resTotal)resTotal.textContent='BOMBED OUT';
    if(resDetail){
      var d='Zero total. Nothing. Nada.';
      if(isMulti)d+='\nPlaced '+tarkPlace+getOrdinal(tarkPlace)+' of '+totalLifters;
      d+='\nPersonal Best: '+pb+' lbs';
      resDetail.textContent=d;
    }
  }

  // Rival comparison / standings
  if(resRival){
    if(isMulti){
      // Multi-comp: final standings table
      resRival.style.display='block';
      var medals=['\ud83e\udd47','\ud83e\udd48','\ud83e\udd49'];
      var html='<div style="text-align:center;font-size:11px;margin-bottom:4px;color:#8b7340">FINAL STANDINGS</div>';
      html+='<div style="text-align:left;font-size:10px;line-height:1.6">';
      for(var si=0;si<standings.length;si++){
        var s=standings[si];
        var medal=si<3?medals[si]+' ':'   ';
        var col=s.isTark?'#ff6b35':'#aaa';
        var arrow=s.isTark?' \u2190':'';
        var totalTxt=s.total>0?s.total+' lbs':'BOMBED';
        html+='<div style="color:'+col+'">'+medal+(si+1)+'. '+(s.flag||'')+' '+s.name+' \u2014 '+totalTxt+arrow+'</div>';
      }
      html+='</div>';
      resRival.innerHTML=html;
    }else if(r.active){
      // 1v1: classic TARK vs rival
      resRival.style.display='block';
      var tarkLabel=total>0?total+' lbs':'BOMBED';
      var rShort=r.name?r.name.split(' ')[0]:'PAK';
      var pakLabel=pakTotal>0?pakTotal+' lbs':'BOMBED';
      var winner=total>pakTotal?'tark':total<pakTotal?'rival':(total>0?'tie':'rival');
      var winColor=winner==='tark'?'#7fdb6a':winner==='rival'?'#ff4444':'#cccc33';
      var winText=winner==='tark'?'YOU WIN':winner==='rival'?rShort+' WINS':'TIE';
      resRival.innerHTML='<div style="text-align:center">'
        +'<span style="color:#f0e6d3">TARK: '+tarkLabel+'</span>'
        +' <span style="color:'+winColor+';font-weight:bold;margin:0 8px">vs</span> '
        +'<span style="color:#4a8a4a">'+rShort+': '+pakLabel+'</span>'
        +'<div style="color:'+winColor+';font-size:14px;font-weight:bold;margin-top:4px">'+winText+'</div>'
        +'</div>';
    }
  }

  // Regrets
  if(resRegrets){
    var regrets=generateRegrets();
    if(regrets.length>0){
      resRegrets.innerHTML=regrets.map(function(r){return '\u2022 '+r;}).join('<br>');
    }else{
      resRegrets.innerHTML='';
    }
  }

  if(resRecord)resRecord.style.display=isRecord?'block':'none';

  // Leaderboard
  renderLeaderboard(total);

  // Enhanced restart button
  if(resRestart){
    var btnText='COMPETE AGAIN';
    if(isMulti){
      if(tarkPlace===1&&!isDNF)btnText='DEFEND YOUR TITLE';
      else if(tarkPlace<=3&&!isDNF)btnText='GO FOR GOLD';
      else if(isDNF)btnText='TRY AGAIN. STAY HEALTHY.';
      else if(total===0)btnText="YOU CAN'T DO WORSE. TRY AGAIN.";
      else btnText='TRY AGAIN. CLIMB THE RANKINGS.';
    }else{
      var rShort=r.name?r.name.split(' ')[0]:'PAK';
      if(r.active&&pakTotal>total&&!isDNF)btnText='TRY AGAIN. BEAT '+rShort+'.';
      else if(isDNF)btnText='TRY AGAIN. STAY HEALTHY.';
      else if(total>0&&total>pakTotal)btnText='DEFEND YOUR TITLE';
      else if(total===0)btnText="YOU CAN'T DO WORSE. TRY AGAIN.";
    }
    resRestart.textContent=btnText;
  }

  // Share text
  if(resShare){
    var shareLines='';
    var rName=r.name||'Pak Chol-Min';
    if(isMulti){
      // Multi-comp share text
      if(isDNF&&total>0){
        var phaseLabel=S.dnfPhase==='warmup'?'warm-up':S.dnfPhase==='snatch'?'snatches':'clean & jerk';
        shareLines='TARK FARLEY: WEIGHTLIFTER \u2014'+total+' LBS (INJURY)\n';
        shareLines+='Placed '+tarkPlace+getOrdinal(tarkPlace)+' of '+totalLifters+'\n';
        shareLines+='Snatch: '+(S.bestSnatch||'---')+' + C&J: '+(S.bestCJ||'---')+'\n';
        shareLines+='Injured during '+phaseLabel+' but the total stands.\n';
        shareLines+=isRecord?'NEW PERSONAL RECORD!\n':'';
        shareLines+='stupidlibary.com/pages/weightlifting';
      }else if(isDNF){
        var phaseLabel=S.dnfPhase==='warmup'?'warm-up':S.dnfPhase==='snatch'?'snatches':'clean & jerk';
        shareLines='TARK FARLEY: WEIGHTLIFTER \u2014DNF\n';
        shareLines+='Tark got injured during '+phaseLabel+' in a '+totalLifters+'-man meet.\n';
        shareLines+='Somebody call an ambulance.\nstupidlibary.com/pages/weightlifting';
      }else if(total>0){
        shareLines='TARK FARLEY: WEIGHTLIFTER \u2014'+total+' LBS\n';
        shareLines+='Placed '+tarkPlace+getOrdinal(tarkPlace)+' of '+totalLifters+'\n';
        shareLines+='Snatch: '+(S.bestSnatch||'---')+' + C&J: '+(S.bestCJ||'---')+'\n';
        if(tarkPlace===1)shareLines+='Gold medal. Champion.\n';
        else if(topRival)shareLines+='Winner: '+topRival.name+' ('+topRival.total+' lbs)\n';
        shareLines+=isRecord?'NEW PERSONAL RECORD!\n':'';
        shareLines+='stupidlibary.com/pages/weightlifting';
      }else{
        shareLines='TARK FARLEY: WEIGHTLIFTER \u2014BOMBED OUT\nTark totaled 0 lbs in a '+totalLifters+'-man meet.\n';
        shareLines+='Last place. Can\'t do worse.\nstupidlibary.com/pages/weightlifting';
      }
    }else{
      // 1v1 share text
      if(isDNF&&total>0){
        var phaseLabel=S.dnfPhase==='warmup'?'warm-up':S.dnfPhase==='snatch'?'snatches':'clean & jerk';
        shareLines='TARK FARLEY: WEIGHTLIFTER \u2014'+total+' LBS (INJURY)\n';
        shareLines+='Snatch: '+(S.bestSnatch||'---')+' + C&J: '+(S.bestCJ||'---')+'\n';
        shareLines+='Injured during '+phaseLabel+' but the total stands.\n';
        if(r.active&&pakTotal>0){
          shareLines+=(total>pakTotal?'Beat':'Lost to')+' '+rName+' ('+pakTotal+' lbs)\n';
        }
        shareLines+=isRecord?'NEW PERSONAL RECORD!\n':'';
        shareLines+='stupidlibary.com/pages/weightlifting';
      }else if(isDNF){
        var phaseLabel=S.dnfPhase==='warmup'?'warm-up':S.dnfPhase==='snatch'?'snatches':'clean & jerk';
        shareLines='TARK FARLEY: WEIGHTLIFTER \u2014DNF\n';
        shareLines+='Tark Farley got injured during '+phaseLabel+'.\n';
        shareLines+='Somebody call an ambulance.';
      }else if(total>0){
        shareLines='TARK FARLEY: WEIGHTLIFTER \u2014'+total+' LBS\n';
        shareLines+='Snatch: '+(S.bestSnatch||'---')+' + C&J: '+(S.bestCJ||'---')+'\n';
        if(r.active&&pakTotal>0){
          shareLines+=(total>pakTotal?'Beat':'Lost to')+' '+rName+' ('+pakTotal+' lbs)\n';
        }
        shareLines+=isRecord?'NEW PERSONAL RECORD!\n':'';
        shareLines+='stupidlibary.com/pages/weightlifting';
      }else{
        shareLines='TARK FARLEY: WEIGHTLIFTER \u2014BOMBED OUT\nTark Farley totaled 0 lbs.\nSomehow still cooler than you.\nstupidlibary.com/pages/weightlifting';
      }
    }
    resShare.textContent=shareLines;
  }

  log('===============================','phase');
  if(isDNF){
    var phaseLabel=S.dnfPhase==='warmup'?'warm-up':S.dnfPhase==='snatch'?'snatches':'clean & jerk';
    log('DNF \u2014 INJURY during '+phaseLabel+'.','injury');
    if(total>0)log('Partial total: '+total+' lbs.','rest');
    log('Tark is wheeled out on a stretcher. He gives a thumbs up.','rest');
  }else if(total>0){
    log('TOTAL: '+total+' LBS (Snatch '+S.bestSnatch+' + C&J '+S.bestCJ+')','phase');
    log('FINAL SCORE: '+finalScore+' ('+S.mult.toFixed(1)+'x multiplier)','phase');
  }else{
    log('BOMBED OUT. 0 total. Tark stares into the void.','fail');
  }
  // Multi-comp: log all standings
  if(isMulti){
    log('FINAL STANDINGS:','phase');
    for(var si=0;si<standings.length;si++){
      var s=standings[si];
      var posStr=(si+1)+'. '+(s.flag||'')+' '+s.name+': '+(s.total>0?s.total+' lbs':'BOMBED');
      log(posStr,s.isTark?'lift':'phase');
    }
    if(tarkPlace===1)log('GOLD MEDAL! Tark stands atop the podium.','lift');
    else if(tarkPlace===2)log('Silver medal. So close to glory.','rest');
    else if(tarkPlace===3)log('Bronze. At least you\'re on the podium.','rest');
    else log('Tark finishes '+tarkPlace+getOrdinal(tarkPlace)+'. The crowd is silent.','fail');
  }else{
    // 1v1 logs
    var rName=r.name||'Pak Chol-Min';
    if(r.active&&pakTotal>0){
      log(rName+' totaled '+pakTotal+' lbs (SN: '+r.bestSnatch+' CJ: '+r.bestCJ+')','phase');
      if(total>pakTotal)log('YOU WIN. '+rName.split(' ')[0]+' bows. Victory.','lift');
      else if(total<pakTotal)log(rName.split(' ')[0]+' wins. No celebration. Just leaves.','fail');
      else if(total===pakTotal)log('Tied with '+rName.split(' ')[0]+'. A nod. Respect.','phase');
    }else if(r.active&&pakTotal===0&&total>0){
      log(rName.split(' ')[0]+' bombed out. Tark wins by default.','lift');
    }
  }
  if(isRecord){
    log('*** NEW PERSONAL RECORD! '+total+' LBS ***','phase');
    float('NEW RECORD!',S.tX,120,'#ffcc00',28);
  }
  log('===============================','phase');

  // Regret logs
  var regrets=generateRegrets();
  for(var i=0;i<regrets.length;i++){
    log(regrets[i],'rest');
  }

  // Floats and sounds
  if(total>0){
    float(total+' LBS',S.tX,150,'#ffffff',22);
    if(isMulti){
      if(tarkPlace===1)float('GOLD MEDAL!',S.tX,180,'#ffcc00',18);
      else if(tarkPlace===2)float('SILVER MEDAL',S.tX,180,'#c0c0c0',18);
      else if(tarkPlace===3)float('BRONZE MEDAL',S.tX,180,'#cd7f32',18);
      else float(tarkPlace+getOrdinal(tarkPlace)+' PLACE',S.tX,180,'#ff4444',18);
    }else if(r.active&&pakTotal>0){
      var didWin=total>pakTotal;
      var rShort=r.name?r.name.split(' ')[0]:'PAK';
      float(didWin?'YOU WIN':rShort+' WINS',S.tX,180,didWin?'#7fdb6a':'#ff4444',18);
    }else{
      float('SCORE: '+finalScore,S.tX,180,'#ffcc00',16);
    }
    if(isDNF){SFX.sadTrombone();}
    else if(isMulti&&tarkPlace>3){SFX.sadTrombone();}
    else{SFX.triumph();}
  }else{
    float('BOMBED OUT',S.tX,140,'#ff4444',24);
    float('0 TOTAL',S.tX,170,'#ff6666',16);
    SFX.sadTrombone();
  }

  console.log('[DNF] showResults complete, calling setPhase(results)');
  S.scene='none'; // Leave backroom for results screen
  S.coachMsg='';
  S.tv.mode='off';
  setPhase('results');
}

function copyShare(){
  var resShare=document.getElementById('resShare');
  if(!resShare)return;
  var text=resShare.textContent;
  if(navigator.clipboard&&navigator.clipboard.writeText){
    navigator.clipboard.writeText(text).then(function(){
      float('COPIED!',S.tX,160,'#7fdb6a',16);
      log('Share text copied to clipboard!','shake');
    }).catch(function(){
      fallbackCopy(text);
    });
  }else{
    fallbackCopy(text);
  }
}
function fallbackCopy(text){
  var ta=document.createElement('textarea');
  ta.value=text;
  ta.style.position='fixed';ta.style.left='-9999px';
  document.body.appendChild(ta);
  ta.select();
  try{
    document.execCommand('copy');
    float('COPIED!',S.tX,160,'#7fdb6a',16);
    log('Copied!','shake');
  }catch(e){
    log('Copy failed. Just screenshot it like a caveman.','rest');
  }
  document.body.removeChild(ta);
}

function restart(){
  stopReadinessDecay();
  initState();
  // Clear results panel
  var results=document.getElementById('results');
  if(results)results.style.display='none';
  // Clear log
  var tl=document.getElementById('tl');
  if(tl)tl.innerHTML='';
  setPhase('gym');
  log('Tark wakes up. Another day, another meet.','phase');
  log('Click on things. Press buttons. Become legend.','rest');
}

// --- MODE SELECT & ROSTER PICK SCREENS ---

var _modeHover=null; // 'mode1'|'mode3'|'mode12'|null
var _rosterHover=null; // competitor id or 'confirm' or null

function drawModeSelect(){
  R(0,0,W,H,'#0a0a0a');
  T('CHOOSE YOUR FORMAT',W/2,60,20,'#ff6b35');
  T('How many lifters on the platform today?',W/2,85,10,'#666');

  var modes=[
    {id:'mode1',label:'1v1 CHALLENGE',desc:'Pick one rival. Head to head.',y:150},
    {id:'mode3',label:'3-MAN MEET',desc:'Pick two opponents. Intimate competition.',y:250},
    {id:'mode12',label:'WORLD CHAMPIONSHIP',desc:'All 12 lifters. The full show.',y:350}
  ];
  for(var i=0;i<modes.length;i++){
    var m=modes[i];
    var bx=W/2-180,by=m.y,bw=360,bh=70;
    var hov=(_modeHover===m.id);
    R(bx,by,bw,bh,hov?'#1a1a1a':'#111');
    cx.strokeStyle=hov?'#ff6b35':'#333';cx.lineWidth=2;cx.strokeRect(bx,by,bw,bh);
    T(m.label,W/2,by+28,16,hov?'#ff6b35':'#f0e6d3');
    T(m.desc,W/2,by+50,10,hov?'#999':'#555');
  }
  // Draw Tark idle at bottom-left
  drawTarkIdle(120,400,false);
}

function handleModeSelectHover(mx,my){
  _modeHover=null;
  var modes=[{id:'mode1',y:150},{id:'mode3',y:250},{id:'mode12',y:350}];
  var bx=W/2-180,bw=360,bh=70;
  for(var i=0;i<modes.length;i++){
    var m=modes[i];
    if(mx>=bx&&mx<=bx+bw&&my>=m.y&&my<=m.y+bh){_modeHover=m.id;return;}
  }
}

function handleModeSelectClick(){
  if(_modeHover==='mode1'){S.compMode=1;setupRosterPick();setPhase('roster_pick');}
  else if(_modeHover==='mode3'){S.compMode=3;setupRosterPick();setPhase('roster_pick');}
  else if(_modeHover==='mode12'){S.compMode=12;setupRosterPick();setPhase('roster_pick');}
}

function setupRosterPick(){
  S.rosterSelections={};
  if(S.compMode===12){
    for(var i=0;i<COMPETITORS.length;i++)S.rosterSelections[COMPETITORS[i].id]=true;
  }
}

function getRosterNeeded(){return S.compMode===1?1:S.compMode===3?2:11;}
function getRosterCount(){var c=0;for(var k in S.rosterSelections)if(S.rosterSelections[k])c++;return c;}

function drawRosterPick(){
  R(0,0,W,H,'#0a0a0a');
  var needed=getRosterNeeded();
  var count=getRosterCount();
  var modeLabel=S.compMode===1?'1v1 CHALLENGE':S.compMode===3?'3-MAN MEET':'WORLD CHAMPIONSHIP';
  T(modeLabel+' \u2014 PICK YOUR OPPONENTS',W/2,35,14,'#ff6b35');
  T('Select '+needed+' opponent'+(needed>1?'s':''),W/2,55,10,'#666');

  // Grid: 4 columns, 3 rows
  var cols=4,cardW=200,cardH=100,padX=12,padY=10;
  var gridW=cols*cardW+(cols-1)*padX;
  var startX=(W-gridW)/2;
  var startY=72;

  for(var i=0;i<COMPETITORS.length;i++){
    var comp=COMPETITORS[i];
    var col=i%cols,row=Math.floor(i/cols);
    var cx2=startX+col*(cardW+padX);
    var cy2=startY+row*(cardH+padY);
    var sel=!!S.rosterSelections[comp.id];
    var hov=(_rosterHover===comp.id);

    R(cx2,cy2,cardW,cardH,sel?'#1a2a1a':hov?'#1a1a1a':'#111');
    cx.strokeStyle=sel?'#7fdb6a':hov?'#ff6b35':'#2a2a2a';cx.lineWidth=sel?2:1;cx.strokeRect(cx2,cy2,cardW,cardH);

    T(comp.flag,cx2+18,cy2+25,16,'#fff');
    T(comp.name,cx2+cardW/2+12,cy2+22,9,sel?'#7fdb6a':'#f0e6d3');
    T(comp.country,cx2+cardW/2+12,cy2+38,8,'#666');

    var stars=comp.tier==='A'?'\u2605\u2605\u2605':comp.tier==='B'?'\u2605\u2605':'\u2605';
    var tierCol=comp.tier==='A'?'#ffcc00':comp.tier==='B'?'#aaaaaa':'#886633';
    T(stars,cx2+cardW/2+12,cy2+54,10,tierCol);

    R(cx2+cardW-28,cy2+10,16,30,comp.singlet);
    cx.strokeStyle='#333';cx.lineWidth=1;cx.strokeRect(cx2+cardW-28,cy2+10,16,30);

    if(sel)T('\u2713',cx2+12,cy2+cardH-12,14,'#7fdb6a');

    C(cx2+cardW-20,cy2+55,8,comp.skin);
    R(cx2+cardW-26,cy2+42,12,4,comp.hair);
  }

  // Confirm button
  var canConfirm=(count===needed);
  var btnY=startY+3*(cardH+padY)+8;
  var btnW=280,btnH=44;
  var btnX=(W-btnW)/2;
  var btnHov=(_rosterHover==='confirm');
  R(btnX,btnY,btnW,btnH,canConfirm?(btnHov?'#2a4a2a':'#1a3a1a'):'#1a1a1a');
  cx.strokeStyle=canConfirm?(btnHov?'#7fdb6a':'#4a8a4a'):'#333';cx.lineWidth=2;cx.strokeRect(btnX,btnY,btnW,btnH);
  T('ENTER THE MEET',W/2,btnY+22,14,canConfirm?(btnHov?'#7fdb6a':'#4a8a4a'):'#444');
  T(count+'/'+needed+' selected',W/2,btnY+38,9,canConfirm?'#666':'#444');
}

function handleRosterHover(mx,my){
  _rosterHover=null;
  var cols=4,cardW=200,cardH=100,padX=12,padY=10;
  var gridW=cols*cardW+(cols-1)*padX;
  var startX=(W-gridW)/2;
  var startY=72;
  for(var i=0;i<COMPETITORS.length;i++){
    var col=i%cols,row=Math.floor(i/cols);
    var cx2=startX+col*(cardW+padX);
    var cy2=startY+row*(cardH+padY);
    if(mx>=cx2&&mx<=cx2+cardW&&my>=cy2&&my<=cy2+cardH){_rosterHover=COMPETITORS[i].id;return;}
  }
  var btnY=startY+3*(cardH+padY)+8;
  var btnW=280,btnH=44,btnX=(W-btnW)/2;
  if(mx>=btnX&&mx<=btnX+btnW&&my>=btnY&&my<=btnY+btnH){_rosterHover='confirm';}
}

function handleRosterClick(){
  if(_rosterHover==='confirm'){
    if(getRosterCount()===getRosterNeeded()){initSelectedRivals();enterMeetFromRoster();}
    return;
  }
  if(_rosterHover){
    var needed=getRosterNeeded();
    var count=getRosterCount();
    if(S.rosterSelections[_rosterHover]){
      delete S.rosterSelections[_rosterHover];
    }else if(count<needed){
      S.rosterSelections[_rosterHover]=true;
    }else if(needed===1){
      S.rosterSelections={};
      S.rosterSelections[_rosterHover]=true;
    }
  }
}

function initSelectedRivals(){
  S.rivals=[];
  for(var i=0;i<COMPETITORS.length;i++){
    if(S.rosterSelections[COMPETITORS[i].id]){
      S.rivals.push(createRivalState(COMPETITORS[i]));
    }
  }
  if(S.rivals.length>0)swapRival(S.rivals[0]);
}

function enterMeetFromRoster(){
  try{localStorage.setItem('tark_played','1');}catch(e){}
  S.hints.meet=true;
  log('===============================','phase');
  log('Tark Farley walks into the competition venue.','phase');
  log('The air smells like chalk, ammonia, and bad decisions.','rest');
  if(S.rivals.length===1){
    log(S.rivals[0].name+' is warming up on the other platform.','phase');
  }else{
    log(S.rivals.length+' competitors are warming up. The crowd buzzes.','phase');
  }
  log('Time to warm up. Build your stats. Don\'t blow your strength.','rest');
  // Humiliation carry-over: crowd remembers
  if(S.humiliated>0){
    log('','rest');
    var humEntryLines=[
      ['Someone in the crowd: "Hey isn\'t that the guy from the beach?"','You hear whispering. You know what it\'s about.'],
      ['"Wait, isn\'t that the dude who got embarrassed at Muscle Beach?"','The word has spread. People are looking. Tark tries to ignore it.'],
      ['"Oh THAT\'S the guy. '+S.humiliatedBy+' made him look like a fool."','The whole venue knows. Tark\'s jaw clenches. This is going to be a long day.']
    ];
    var hLines=humEntryLines[Math.min(S.humiliated-1,2)];
    log(hLines[0],'fail');
    log(hLines[1],'fail');
  }
  log('===============================','phase');
  // Initialize warmup state
  S.warmup={lifts:0,maxWeight:0,nextRivalLift:Date.now()+5000,nextEvent:Date.now()+12000,
    stretchCount:0,coachSuggestion:45,announcements:0,firedEvents:[],lastSloppyWeight:0,
    startTime:Date.now(),duration:180000,warned2min:false,warned1min:false,warned30s:false,
    expired:false,openerDeclared:0,sloppyHeavy:0,cardStep:0,card:null};
  // Initialize rival warmup plans
  for(var wi=0;wi<S.rivals.length;wi++){
    var wr=S.rivals[wi];
    var wBase=wr.snTargets?wr.snTargets[0]:250;
    wr.warmupPlan=[
      Math.round(wBase*0.40/5)*5,
      Math.round(wBase*0.55/5)*5,
      Math.round(wBase*0.65/5)*5,
      Math.round(wBase*0.75/5)*5,
      Math.round(wBase*0.85/5)*5
    ];
    wr.warmupStep=0;wr.warmupDone=false;
    wr.featured=false;wr.featPose='idle';wr.featPoseT=0;wr.featX=0;wr.featY=0;
    wr.featAnimDone=true;wr.tauntRattled=false;wr.tauntFiredUp=false;wr._liftWeight=0;
  }
  // Designate top 2 rivals (by snatch opener) as featured foreground characters
  var sortedFeat=S.rivals.slice().sort(function(a,b){
    return (b.snTargets?b.snTargets[0]:0)-(a.snTargets?a.snTargets[0]:0);
  });
  if(sortedFeat.length>=1){
    sortedFeat[0].featured=true;sortedFeat[0].featX=560;sortedFeat[0].featY=328;
  }
  if(sortedFeat.length>=2){
    sortedFeat[1].featured=true;sortedFeat[1].featX=770;sortedFeat[1].featY=328;
  }
  S.warmup.card=buildWarmupCard();
  S.warmup.coachSuggestion=S.warmup.card[0].weight;
  if(is1v1()){
    // 1v1: everything on the competition platform
    S.scene='platform';
    S.homeX=LAYOUT.comp.homeX;
    S.tX=LAYOUT.comp.homeX;
    S.rival=S.rivals[0];
    S.rival.x=LAYOUT.comp.pakHomeX;
    S.rival.active=true;
    S.rival.pose='idle';
    S.platformCoachVisible=true;
    S.platformCoachX=25;
    S.coachMsg='Warm up smart. Don\'t burn yourself out.';
    S.coachBubble=Date.now()+6000;
    float('THE MEET',S.tX,140,'#ff6b35',18);
    float('WARM UP!',S.tX,170,'#ffcc00',16);
    float('1 v 1',450,120,'#ff4444',20);
  }else{
    // Multi-rival: backroom warmup
    generateBackroomExtras();
    S.scene='backroom';
    S.homeX=LAYOUT.backroom.homeX;
    S.tX=LAYOUT.backroom.homeX;
    S.tv.mode='warmup_board';
    S.coachMsg='Warm up smart. Don\'t burn yourself out.';
    float('THE MEET',S.tX,140,'#ff6b35',18);
    float('WARM UP!',S.tX,170,'#ffcc00',16);
  }
  setPhase('warmup');
}

// --- MINI-GAME OVERLAY (shared across all scene paths) ---
function renderMiniGameOverlay(){
if(!S.miniGame||!S.miniGame.active)return;
if(S.miniGame.type==='balance'){
drawBalanceBar();
}else if(S.miniGame.type==='power_pump'){
drawPowerPump();
// Auto-resolve clean phase on timer expiry
if(S.miniGame.phase==='clean'&&S.miniGame.cleanResult===null){
var mgElapsed=Date.now()-S.miniGame.startTime;
if(mgElapsed>=S.miniGame.cleanDuration){
S.miniGame.cleanResult=S.miniGame.meterFill>=S.miniGame.meterTarget;
S.miniGame.cleanResolveTime=Date.now();
if(!S.miniGame.cleanResult){
S.miniGame.resolved=true;
S.miniGame.result='red';
try{SFX.barDrop();}catch(e){}
setTimeout(function(){resolveMiniGameResult();},600);
}else{
try{SFX.metalClang();}catch(e){}
setTimeout(function(){transitionToJerkPhase();},800);
}
}
}
}
}

// --- DRAW LOOP ---

function draw(){
  try{
  cx.clearRect(0,0,W,H);

  // Intro phase — completely different render
  if(S.phase==='intro'){
    drawIntro();
    requestAnimationFrame(draw);
    return;
  }

  // Apartment phase — separate render path
  if(S.phase==='apartment'){
    drawApartmentScene();
    drawSpeechBubbleOverlay();
    drawThoughtBubble();drawHelpButton();
    drawMapIcon();
    if(S.mapOpen)drawMapOverlay();
    requestAnimationFrame(draw);
    return;
  }

  // Beach phase — separate render path
  if(S.phase==='beach'){
    drawBeachScene();
    renderMiniGameOverlay();
    drawSpeechBubbleOverlay();
    drawThoughtBubble();drawHelpButton();
    drawMapIcon();
    if(S.mapOpen)drawMapOverlay();
    requestAnimationFrame(draw);
    return;
  }

  // Downtown phase — separate render path
  if(S.phase==='downtown'){
    drawDowntownScene();
    drawSpeechBubbleOverlay();
    drawThoughtBubble();drawHelpButton();
    drawMapIcon();
    if(S.mapOpen)drawMapOverlay();
    requestAnimationFrame(draw);
    return;
  }

  // Mode select / roster pick — full-screen UI
  if(S.phase==='mode_select'){
    drawModeSelect();
    requestAnimationFrame(draw);
    return;
  }
  if(S.phase==='roster_pick'){
    drawRosterPick();
    requestAnimationFrame(draw);
    return;
  }

  // Back room scene — completely different render path
  if(S.scene==='backroom'){
    drawBackroomScene();
    renderMiniGameOverlay();
    drawSpeechBubbleOverlay();
    requestAnimationFrame(draw);
    return;
  }

  // Hitstop — freeze rendering for impact frames
  if(S.hitstop>0){
    S.hitstop--;
    requestAnimationFrame(draw);
    return;
  }

  // Screen shake — apply canvas translate
  var shX=0,shY=0;
  if(S.screenShake>0){
    shX=Math.sin(Date.now()*0.05)*S.screenShake;
    shY=Math.cos(Date.now()*0.07)*S.screenShake*0.6;
    S.screenShake*=0.88;
    if(S.screenShake<0.3)S.screenShake=0;
  }
  cx.save();
  cx.translate(shX,shY);

  R(0,0,W,H,'#111');
  // Scene background
  drawGymBackground();
  drawVenueBackground();
  drawCrowdSilhouettes();
  drawFloor();
  drawPlatform();
  // Furniture — bench draws in all phases, rack/table gym-only
  drawBench();
  if(S.phase==='gym'){drawWeightRack();drawTable();}
  drawTarkSideTable();
  drawShaker();
  drawCigPack();
  drawChalkBucket();
  if(S.phase==='gym')drawDumbbells();
  drawPakArea();
  drawBigScoreboard();

  // NPCs — wrapped so crashes here can't kill Tark
  try{updateGirls();drawGirls();}catch(e){cx.globalAlpha=1;if(!window._npcErr)window._npcErr='girls:'+e.message;}
  try{updateWimp();drawWimp();}catch(e){cx.globalAlpha=1;if(!window._npcErr)window._npcErr='wimp:'+e.message;}
  try{updateRival();drawRival();}catch(e){cx.globalAlpha=1;if(!window._npcErr)window._npcErr='rival:'+e.message;}

  // Platform ritual coach (multi-rival mode)
  if(S.ritualCoachVisible){
    try{drawCoachNPC(S.ritualCoachX,330);
    if(S.ritualCoachMsg)drawCoachSpeechBubble(S.ritualCoachX,280,S.ritualCoachMsg);}catch(e){cx.globalAlpha=1;}
  }
  // 1v1 persistent coach on platform
  if(is1v1()&&S.platformCoachVisible&&!S.ritualCoachVisible){
    try{
      drawCoachNPC(S.platformCoachX||25,340);
      // Speech bubble from S.coachMsg or S.coachBubble
      var cbMsg=null;
      if(S.coachBubble&&typeof S.coachBubble==='object'&&Date.now()<S.coachBubble.t+S.coachBubble.dur){
        cbMsg=S.coachBubble.text;
      }else if(S.coachBubble&&typeof S.coachBubble==='number'&&Date.now()<S.coachBubble&&S.coachMsg){
        cbMsg=S.coachMsg;
      }
      if(cbMsg)drawCoachSpeechBubble(S.platformCoachX||25,290,cbMsg);
    }catch(e){cx.globalAlpha=1;}
  }

  // Walk update
  try{updateWalk();}catch(e){}

  // Safety: fix NaN or out-of-bounds position
  if(isNaN(S.tX)||S.tX<-50||S.tX>W+50){S.tX=S.homeX||300;}
  // Safety: force unlock if stuck busy
  checkStuck();

  // Reset canvas state before drawing Tark (in case NPC drawing left it dirty)
  cx.globalAlpha=1;

  var isComp=S.phase!=='gym'&&S.phase!=='intro';
  var x=S.tX,y=328;
  var p=S.pose;

  // Increment poseT for timed poses
  if(p==='shake'||p==='smoke'||p==='chalking'){S.poseT+=0.016;}
  // Chalk fade timer
  if(S.chalked){S.chalkTimer++;if(S.chalkTimer>600)S.chalked=false;}

  // Draw Tark + barbell
  var barbellHome=isComp?LAYOUT.comp.platformX:S.homeX;
  // Hide platform barbell when Pak is actively lifting it
  var pakLifting=isComp&&S.rival&&(S.rival.pose==='pull'||S.rival.pose==='overhead'||S.rival.pose==='overhead_squat'||S.rival.pose==='front_squat'||S.rival.pose==='clean_hold'||S.rival.pose==='jerk'||S.rival.pose==='failed');
  if(p==='idle'){
    drawTarkIdle(x,y,S.strength<25);
    if(!pakLifting)drawBarbell(barbellHome,FY-14);
  }
  else if(p==='walking'){
    drawTarkWalking(x,y);
    if(!pakLifting)drawBarbell(barbellHome,FY-14);
  }
  else if(p==='pull'){
    if(S.currentLift==='snatch'){drawTarkSnatchPull(x,y);}else{drawTarkPull(x,y);}
    drawBarbell(x,y+30);
  }
  else if(p==='overhead'){
    if(S.currentLift==='snatch'){drawTarkSnatchOverhead(x,y);}else{drawTarkOverhead(x,y);}
    drawBarbell(x,y-56);
  }
  else if(p==='overhead_squat'){drawTarkOverheadSquat(x,y);drawBarbell(x,y-40);}
  else if(p==='front_squat'){drawTarkFrontSquat(x,y);drawBarbell(x,y+2);}
  else if(p==='clean_hold'){drawTarkClean(x,y);drawBarbell(x,y-6);}
  else if(p==='jerk'){drawTarkJerk(x,y);drawBarbell(x,y-60);}
  else if(p==='sitting'){if(!pakLifting)drawBarbell(barbellHome,FY-14);drawTarkSitting(isComp?S.tX:getLayout().benchX,360);}
  else if(p==='injured'){if(!pakLifting)drawBarbell(barbellHome,FY-14);drawTarkInjured(isComp?S.tX:getLayout().benchX,360);}
  else if(p==='shake'){if(!pakLifting)drawBarbell(barbellHome,FY-14);drawTarkShaking(x,y,S.poseT);}
  else if(p==='smoke'){if(!pakLifting)drawBarbell(barbellHome,FY-14);drawTarkSmoking(x,y,S.poseT);}
  else if(p==='chalking'){if(!pakLifting)drawBarbell(barbellHome,FY-14);drawTarkChalking(x,y,S.poseT);}
  else if(p==='failed'){
    var sh=Math.sin(Date.now()/80)*6;
    drawTarkIdle(x+sh,y,true);
    drawBarbell(barbellHome+sh*2,FY-10);
  }
  else{
    // fallback
    drawTarkIdle(x,y,S.strength<25);
    if(!pakLifting)drawBarbell(barbellHome,FY-14);
  }

  // Floating text
  for(var i=S.floats.length-1;i>=0;i--){
    var f=S.floats[i];
    f.y-=1.2;
    f.life-=0.018;
    if(f.life>0){
      cx.globalAlpha=f.life;
      T(f.text,f.x,f.y,f.sz,f.c);
    }
  }
  cx.globalAlpha=1;
  S.floats=S.floats.filter(function(f){return f.life>0;});

  // Heartbeat during competition
  if((S.phase==='snatch'||S.phase==='cj')&&!S.busy&&S.barWeight>45&&S.turn.whose==='tark'){
    var hbFc=window.getFailChance?window.getFailChance(S.phase):0;
    if(hbFc>0.30){
      // Beat interval: 1200ms at 30% → 400ms at 100%
      var interval=1200-hbFc*800;
      if(!S._lastHB)S._lastHB=0;
      if(Date.now()-S._lastHB>interval){
        SFX.heartbeat();
        S._lastHB=Date.now();
      }
    }
  }

  // Venue overlays
  try{drawJudgesTable();drawScoreboard();drawTurnTimer();drawPakTurnLabel();}catch(e){if(!window._npcErr)window._npcErr='venue:'+e.message;}
  try{updateTurnTimer();}catch(e){if(!window._npcErr)window._npcErr='timer:'+e.message;}

  // 1v1 platform warmup ticks
  if(is1v1()&&S.phase==='warmup'&&S.warmup){
    updateWarmupTimer();
    updateRivalWarmupPlatform();
    updateWarmupEvents();
  }

  // Canvas HUD
  drawHUD();

  // Mini-game overlay rendering + logic
  renderMiniGameOverlay();

  // Scene transition overlay (renders on top of everything)
  if(S.sceneTransition)drawSceneTransition();

  // Restore screen shake translate
  cx.restore();

  // PR flash overlay (full-screen white flash that fades)
  if(S.prFlash>0){
    cx.globalAlpha=Math.min(0.6,S.prFlash/10);
    R(0,0,W,H,'#fff');
    cx.globalAlpha=1;
    S.prFlash-=0.5;
    if(S.prFlash<0)S.prFlash=0;
  }

  // Confetti particles (drawn outside screen shake for stability)
  for(var ci=S.confetti.length-1;ci>=0;ci--){
    var cp=S.confetti[ci];
    cp.x+=cp.vx;cp.y+=cp.vy;cp.vy+=0.12;cp.life-=0.012;
    cp.rot=(cp.rot||0)+cp.spin;
    if(cp.life>0){
      cx.globalAlpha=Math.min(1,cp.life*2);
      cx.save();cx.translate(cp.x,cp.y);cx.rotate(cp.rot);
      cx.fillStyle=cp.c;cx.fillRect(-3,-1.5,6,3);
      cx.restore();
    }
  }
  cx.globalAlpha=1;
  S.confetti=S.confetti.filter(function(c){return c.life>0;});

  }catch(e){
    cx.globalAlpha=1;
    // Show error on canvas so we can debug
    if(!window._drawErrShown){
      window._drawErrShown=true;
      window._drawErr=e.message+' @ '+(e.stack||'').split('\n').slice(0,3).join(' | ');
    }
  }
  // Show persistent error banner if draw or NPC crashed
  if(window._drawErr||window._npcErr){
    var errMsg=window._drawErr?'DRAW: '+window._drawErr:'NPC: '+window._npcErr;
    cx.fillStyle='rgba(180,0,0,0.9)';cx.fillRect(0,0,W,60);
    cx.font='bold 14px monospace';cx.textAlign='left';cx.fillStyle='#fff';
    cx.fillText('ERROR: '+errMsg.slice(0,80),8,20);
    cx.font='11px monospace';
    cx.fillText(errMsg.slice(80,160),8,38);
    cx.fillText('Build: '+BUILD_V+'  Phase: '+S.phase+'  Pose: '+S.pose,8,54);
    cx.textAlign='center';
  }
  // Universal speech bubble overlay (works in ALL phases)
  drawSpeechBubbleOverlay();
  drawThoughtBubble();drawHelpButton();
  if(S.phase==='gym'){drawMapIcon();if(S.mapOpen)drawMapOverlay();}
  // Version stamp (bottom-right corner, always visible)
  cx.globalAlpha=0.3;cx.font='9px monospace';cx.textAlign='right';cx.fillStyle='#666';
  cx.fillText('v'+BUILD_V,W-4,H-4);cx.textAlign='center';cx.globalAlpha=1;
  // ALWAYS schedule next frame, even if this frame errored
  requestAnimationFrame(draw);
}

// --- INTRO SEQUENCE ---

var INTRO_LINES=[
  {text:'TARK FARLEY.',delay:0,dur:1200},
  {text:'285 LBS.',delay:1400,dur:800},
  {text:'LUNGS OF A CHIMNEY.',delay:2400,dur:1200},
  {text:'TODAY IS MEET DAY.',delay:4200,dur:1200},
  {text:"HE'S NOT READY.",delay:5800,dur:1200}
];
var INTRO_TITLE_T=7200; // ms when title slams in
var INTRO_END_T=8800;   // ms when intro ends

function skipIntro(){
  if(S.phase!=='intro')return;
  S.intro.skipped=true;
  S.screenShake=0;
  setPhase('apartment');
  S.homeX=LAYOUT.apartment.homeX;
  S.tX=LAYOUT.apartment.homeX;
  log('Tark wakes up. Meet day. The apartment smells like ambition and stale cigarettes.','phase');
  log('Click objects to interact. Leave when ready.','rest');
}

function drawIntro(){
  var i=S.intro;
  if(!i.started){i.started=true;i.t=Date.now();}
  var elapsed=Date.now()-i.t;

  // Screen shake offset
  var shX=0,shY=0;
  if(S.screenShake>0){
    shX=Math.sin(Date.now()*0.05)*S.screenShake;
    shY=Math.cos(Date.now()*0.07)*S.screenShake*0.6;
    S.screenShake*=0.92;
    if(S.screenShake<0.5)S.screenShake=0;
  }

  cx.save();
  cx.translate(shX,shY);

  // Black background
  R(0,0,W,H,'#000');

  // Typewriter lines
  var lineY=160;
  for(var li=0;li<INTRO_LINES.length;li++){
    var ln=INTRO_LINES[li];
    var lineElapsed=elapsed-ln.delay;
    if(lineElapsed<=0)continue;

    // Typewriter: reveal chars over time
    var progress=Math.min(1,lineElapsed/ln.dur);
    var chars=Math.floor(progress*ln.text.length);
    var displayText=ln.text.substring(0,chars);

    // Color: first 3 lines white, line 4 yellow, line 5 red
    var color='#e0d8c8';
    if(li===3)color='#ff6b35';
    if(li===4)color='#ff4444';

    // Fade in
    var alpha=Math.min(1,lineElapsed/400);
    cx.globalAlpha=alpha;
    T(displayText,W/2,lineY+li*40,li<3?16:18,color);
  }
  cx.globalAlpha=1;

  // Silhouette — fade in around line 2-3
  if(elapsed>1400){
    var silAlpha=Math.min(0.6,(elapsed-1400)/2000);
    cx.globalAlpha=silAlpha;
    // Simple silhouette: large dark figure with cigarette glow
    cx.fillStyle='#1a1a1a';
    // Body
    cx.beginPath();
    cx.ellipse(W/2,380,40,60,0,0,Math.PI*2);
    cx.fill();
    // Head
    cx.beginPath();
    cx.arc(W/2,310,22,0,Math.PI*2);
    cx.fill();
    // Shoulders
    R(W/2-50,340,100,20,'#1a1a1a');
    // Cigarette glow
    if(elapsed>2400){
      cx.globalAlpha=0.5+Math.sin(Date.now()/300)*0.3;
      C(W/2+30,335,3,'#ff4400');
      // Smoke curl
      var smokeT=Date.now()*0.002;
      cx.globalAlpha=0.15+Math.sin(smokeT)*0.1;
      for(var s=0;s<5;s++){
        var sy=330-s*12;
        var sx=W/2+30+Math.sin(smokeT+s*0.8)*8+s*3;
        C(sx,sy,2+s*0.8,'#888');
      }
    }
    cx.globalAlpha=1;
  }

  // Title slam
  if(elapsed>=INTRO_TITLE_T){
    if(!i.titleSlam){
      i.titleSlam=true;
      S.screenShake=12;
      SFX.init();
      SFX.metalClang();
      SFX.musicPlay('intro');
    }
    var titleAge=elapsed-INTRO_TITLE_T;
    var titleScale=titleAge<200?1+Math.max(0,(200-titleAge)/200)*0.3:1;
    var titleAlpha=Math.min(1,titleAge/300);
    cx.globalAlpha=titleAlpha;
    cx.save();
    cx.translate(W/2,80);
    cx.scale(titleScale,titleScale);
    T('TARK FARLEY: WEIGHTLIFTER',0,0,24,'#ff6b35');
    cx.restore();
    cx.globalAlpha=1;
  }

  // Skip prompt — always visible
  var skipAlpha=0.3+Math.sin(Date.now()/500)*0.15;
  cx.globalAlpha=skipAlpha;
  T('CLICK TO SKIP',W/2,H-25,10,'#555');
  cx.globalAlpha=1;

  cx.restore();

  // Auto-advance
  if(elapsed>=INTRO_END_T){
    skipIntro();
  }
}

function drawDangerMeter(mx,my,fc,inj){
// Horizontal bar: green→yellow→red based on fail chance
var mw=160,mh=12;
// Background
cx.fillStyle='#1a1a1a';cx.fillRect(mx,my,mw,mh);
cx.strokeStyle='#333';cx.lineWidth=1;cx.strokeRect(mx,my,mw,mh);
// Filled portion
var fill=Math.min(1,fc)*mw;
var grd=cx.createLinearGradient(mx,my,mx+mw,my);
grd.addColorStop(0,'#40a040');grd.addColorStop(0.33,'#cccc33');grd.addColorStop(0.66,'#ff6b35');grd.addColorStop(1,'#ff2222');
cx.fillStyle=grd;cx.fillRect(mx,my,fill,mh);
// Pulse when danger high
if(fc>0.60){
  var pulse=Math.sin(Date.now()/150)*0.3;
  cx.globalAlpha=0.3+pulse;
  cx.fillStyle='#ff2222';cx.fillRect(mx,my,fill,mh);
  cx.globalAlpha=1;
}
// Label
T('RISK',mx+mw/2,my-3,8,'#888');
T(Math.round(fc*100)+'%',mx+mw+20,my+10,10,fc<0.3?'#7fdb6a':fc<0.6?'#cccc33':'#ff4444','left');
// Injury skull
if(inj>0){
  var injPct=Math.round(inj*100);
  var sk=mx+mw+55;
  var skulPulse=Math.sin(Date.now()/200)*0.3;
  cx.globalAlpha=0.7+skulPulse;
  T('\u2620',sk,my+11,14,inj>0.3?'#ff2222':'#ffaa00','left');
  cx.globalAlpha=1;
  T(injPct+'%',sk+16,my+10,9,inj>0.3?'#ff2222':'#ffaa00','left');
}
}

function drawBalanceBar(){
  var mg=S.miniGame;
  if(!mg||mg.type!=='balance')return;
  var barX=250,barY=80,barW=400,barH=28;
  var now=Date.now();

  // Update marker position (frame-independent)
  if(!mg.resolved){
    var dt=(now-mg._lastDrawTime)/1000;
    mg._lastDrawTime=now;
    if(dt>0.1)dt=0.016; // cap for tab-switch spikes
    mg.markerPos+=mg.markerDir*mg.markerSpeed*dt;
    if(mg.markerPos>=1){mg.markerPos=1;mg.markerDir=-1;}
    if(mg.markerPos<=0){mg.markerPos=0;mg.markerDir=1;}
  }

  // Background panel
  cx.globalAlpha=0.85;
  R(barX-20,barY-38,barW+40,barH+62,'#0a0a0a');
  cx.strokeStyle='#333';cx.lineWidth=2;
  cx.strokeRect(barX-20,barY-38,barW+40,barH+62);
  cx.globalAlpha=1;

  // Title
  T('BALANCE',barX+barW/2,barY-18,14,'#ff6b35');

  // Bar track
  R(barX,barY,barW,barH,'#1a1a1a');
  cx.strokeStyle='#444';cx.lineWidth=1;
  cx.strokeRect(barX,barY,barW,barH);

  // Zones
  var centerPx=barW/2;
  var greenHalfPx=mg.greenWidth*barW;
  var yellowHalfPx=mg.yellowWidth*barW;

  // Red gradient tint at edges
  var redGrd=cx.createLinearGradient(barX,barY,barX+barW,barY);
  redGrd.addColorStop(0,'rgba(255,34,34,0.5)');
  redGrd.addColorStop(0.15,'rgba(255,34,34,0.3)');
  redGrd.addColorStop(0.35,'rgba(255,34,34,0)');
  redGrd.addColorStop(0.65,'rgba(255,34,34,0)');
  redGrd.addColorStop(0.85,'rgba(255,34,34,0.3)');
  redGrd.addColorStop(1,'rgba(255,34,34,0.5)');
  cx.fillStyle=redGrd;cx.fillRect(barX,barY,barW,barH);

  // Yellow zone
  R(barX+centerPx-yellowHalfPx,barY,yellowHalfPx*2,barH,'rgba(204,204,51,0.35)');

  // Green zone
  R(barX+centerPx-greenHalfPx,barY,greenHalfPx*2,barH,'rgba(80,200,80,0.45)');

  // Zone border lines
  cx.strokeStyle='#7fdb6a';cx.lineWidth=2;
  cx.beginPath();
  cx.moveTo(barX+centerPx-greenHalfPx,barY);cx.lineTo(barX+centerPx-greenHalfPx,barY+barH);
  cx.moveTo(barX+centerPx+greenHalfPx,barY);cx.lineTo(barX+centerPx+greenHalfPx,barY+barH);
  cx.stroke();
  cx.strokeStyle='#cccc33';cx.lineWidth=1;
  cx.beginPath();
  cx.moveTo(barX+centerPx-yellowHalfPx,barY);cx.lineTo(barX+centerPx-yellowHalfPx,barY+barH);
  cx.moveTo(barX+centerPx+yellowHalfPx,barY);cx.lineTo(barX+centerPx+yellowHalfPx,barY+barH);
  cx.stroke();

  // Marker
  if(!mg.resolved){
    var mX=barX+mg.markerPos*barW;
    var pulse=0.7+Math.sin(now/100)*0.3;
    cx.globalAlpha=pulse;
    R(mX-2,barY-4,4,barH+8,'#ffffff');
    cx.globalAlpha=1;
    R(mX-1,barY-2,2,barH+4,'#fff');
    // Arrow above
    cx.fillStyle='#fff';cx.beginPath();
    cx.moveTo(mX,barY-6);cx.lineTo(mX-6,barY-14);cx.lineTo(mX+6,barY-14);
    cx.closePath();cx.fill();
  }else{
    var mX=barX+mg.clickPos*barW;
    var resultColor=mg.result==='green'?'#7fdb6a':mg.result==='yellow'?'#ffcc00':'#ff4444';
    R(mX-2,barY-4,4,barH+8,resultColor);
    var txt=mg.result==='green'?'LOCKED!':mg.result==='yellow'?'WOBBLY...':'DUMPED!';
    var fadeTime=(now-mg.resolveTime)/1000;
    if(fadeTime<1.5){
      cx.globalAlpha=Math.max(0,1-fadeTime/1.5);
      T(txt,barX+barW/2,barY+barH+22,16,resultColor);
      cx.globalAlpha=1;
    }
  }

  // "CLICK!" prompt
  if(!mg.resolved){
    var blink=Math.sin(now/200)>0;
    if(blink)T('CLICK!',barX+barW/2,barY+barH+20,12,'#fff');
  }

  // Weight label
  T(mg.weight+' LBS',barX+barW/2,barY-30,10,'#888');
}

function drawPowerPump(){
  var mg=S.miniGame;
  if(!mg||mg.type!=='power_pump')return;
  var now=Date.now();

  if(mg.phase==='clean'){
    var mX=760,mY=60,mW=50,mH=300;

    // Update drain (frame-independent)
    if(mg.cleanResult===null){
      var dt=(now-mg._lastDrawTime)/1000;
      mg._lastDrawTime=now;
      if(dt>0.1)dt=0.016;
      mg.meterFill=Math.max(0,mg.meterFill-mg.meterDrain*dt);
    }

    // Background panel
    cx.globalAlpha=0.85;
    R(mX-15,mY-30,mW+30,mH+55,'#0a0a0a');
    cx.strokeStyle='#333';cx.lineWidth=2;
    cx.strokeRect(mX-15,mY-30,mW+30,mH+55);
    cx.globalAlpha=1;

    // Title
    T('CLEAN',mX+mW/2,mY-12,14,'#ff6b35');

    // Meter track
    R(mX,mY,mW,mH,'#1a1a1a');
    cx.strokeStyle='#444';cx.lineWidth=1;
    cx.strokeRect(mX,mY,mW,mH);

    // Filled portion (bottom-up)
    var fillH=mg.meterFill*mH;
    var fillColor=mg.meterFill>=mg.meterTarget?'#7fdb6a':'#ff6b35';
    if(fillH>0)R(mX+2,mY+mH-fillH,mW-4,fillH,fillColor);

    // Target line
    var targetY=mY+mH-(mg.meterTarget*mH);
    cx.strokeStyle='#fff';cx.lineWidth=2;
    cx.setLineDash([4,4]);
    cx.beginPath();cx.moveTo(mX-5,targetY);cx.lineTo(mX+mW+5,targetY);cx.stroke();
    cx.setLineDash([]);
    T('TARGET',mX+mW+12,targetY+4,8,'#fff','left');

    // Timer bar
    if(mg.cleanResult===null){
      var elapsed=(now-mg.startTime)/1000;
      var timeLeft=Math.max(0,1-(elapsed/(mg.cleanDuration/1000)));
      R(mX,mY+mH+8,mW,6,'#1a1a1a');
      R(mX,mY+mH+8,mW*timeLeft,6,timeLeft<0.3?'#ff2222':'#cccc33');
    }

    // Prompt
    if(mg.cleanResult===null){
      var blink=Math.sin(now/150)>0;
      if(blink)T('TAP!',mX+mW/2,mY+mH+24,12,'#fff');
    }else{
      var txt=mg.cleanResult?'RACKED!':'DROPPED!';
      var col=mg.cleanResult?'#7fdb6a':'#ff4444';
      T(txt,mX+mW/2,mY+mH+24,14,col);
    }

    // Weight label
    T(mg.weight+' LBS',mX+mW/2,mY-24,10,'#888');

  }else if(mg.phase==='jerk'){
    var barX=250,barY=80,barW=400,barH=28;

    // Update jerk marker (one sweep left to right)
    if(mg.jerkResult===null){
      var dt=(now-mg._lastDrawTime)/1000;
      mg._lastDrawTime=now;
      if(dt>0.1)dt=0.016;
      mg.jerkMarkerPos=Math.min(1,mg.jerkMarkerPos+mg.jerkSpeed*dt);
      // Auto-fail if marker reaches end
      if(mg.jerkMarkerPos>=1&&mg.jerkResult===null){
        mg.jerkResult=false;
        mg.jerkResolveTime=now;
        mg.resolved=true;
        mg.result='red';
        try{SFX.barDrop();}catch(e){}
        setTimeout(function(){resolveMiniGameResult();},600);
      }
    }

    // Background panel
    cx.globalAlpha=0.85;
    R(barX-20,barY-38,barW+40,barH+62,'#0a0a0a');
    cx.strokeStyle='#333';cx.lineWidth=2;
    cx.strokeRect(barX-20,barY-38,barW+40,barH+62);
    cx.globalAlpha=1;

    // Title
    T('JERK',barX+barW/2,barY-18,14,'#ff6b35');

    // Bar track
    R(barX,barY,barW,barH,'#1a1a1a');
    cx.strokeStyle='#444';cx.lineWidth=1;
    cx.strokeRect(barX,barY,barW,barH);

    // Success zone
    var zCenterPx=mg.jerkZoneCenter*barW;
    var zHalfPx=mg.jerkZoneWidth*barW;
    R(barX+zCenterPx-zHalfPx,barY,zHalfPx*2,barH,'rgba(80,200,80,0.45)');
    cx.strokeStyle='#7fdb6a';cx.lineWidth=2;
    cx.beginPath();
    cx.moveTo(barX+zCenterPx-zHalfPx,barY);cx.lineTo(barX+zCenterPx-zHalfPx,barY+barH);
    cx.moveTo(barX+zCenterPx+zHalfPx,barY);cx.lineTo(barX+zCenterPx+zHalfPx,barY+barH);
    cx.stroke();

    // Marker
    if(mg.jerkResult===null){
      var mXJ=barX+mg.jerkMarkerPos*barW;
      var pulse=0.7+Math.sin(now/100)*0.3;
      cx.globalAlpha=pulse;
      R(mXJ-2,barY-4,4,barH+8,'#ffffff');
      cx.globalAlpha=1;
      R(mXJ-1,barY-2,2,barH+4,'#fff');
      cx.fillStyle='#fff';cx.beginPath();
      cx.moveTo(mXJ,barY-6);cx.lineTo(mXJ-6,barY-14);cx.lineTo(mXJ+6,barY-14);
      cx.closePath();cx.fill();
    }else{
      var mXJ=barX+mg.jerkMarkerPos*barW;
      var col=mg.jerkResult?'#7fdb6a':'#ff4444';
      R(mXJ-2,barY-4,4,barH+8,col);
      var txt=mg.jerkResult?'LOCKED!':'MISSED!';
      var fadeTime=(now-mg.jerkResolveTime)/1000;
      if(fadeTime<1.5){
        cx.globalAlpha=Math.max(0,1-fadeTime/1.5);
        T(txt,barX+barW/2,barY+barH+22,16,col);
        cx.globalAlpha=1;
      }
    }

    // "CLICK!" prompt
    if(mg.jerkResult===null){
      var blink=Math.sin(now/200)>0;
      if(blink)T('CLICK!',barX+barW/2,barY+barH+20,12,'#fff');
    }

    // Weight label
    T(mg.weight+' LBS',barX+barW/2,barY-30,10,'#888');
  }
}

function drawHUD(){
  if(S.phase==='gym'){
    T(S.barWeight+' LBS',S.homeX,FY+30,10,'#555');
    // First-game hints
    if(S.firstGame){
      var t=Date.now();
      var hintAlpha=0.4+Math.sin(t/600)*0.2;
      cx.globalAlpha=hintAlpha;
      if(!S.hints.rack)T('CLICK RACK TO LOAD WEIGHT \u2192',390,220,9,'#ff6b35','right');
      if(!S.hints.bench)T('\u2190 CLICK BENCH TO REST',220,330,9,'#ff6b35','left');
      T('SHAKER \u2192',620,260,8,'#7fdb6a','right');
      T('CIGS \u2192',700,260,8,'#cc88ff','right');
      cx.globalAlpha=1;
    }
    // Pulsing "ENTER THE MEET" after 10s idle
    S.gymIdleTimer++;
    if(S.gymIdleTimer>600){
      var pulse=0.4+Math.sin(Date.now()/400)*0.3;
      cx.globalAlpha=pulse;
      T('ENTER THE MEET \u25B6',W/2,H-20,14,'#ff6b35');
      cx.globalAlpha=1;
    }
    // Gym exit arrow
    var geH=hover==='gymExit';
    cx.globalAlpha=geH?0.9:0.4;
    T('\u2190 EXIT',870,385,8,geH?'#ff6b35':'#888');
    cx.globalAlpha=1;
  }else if(S.phase==='warmup'){
    // Danger meter during warmup
    var wuFc=getFailChance('snatch');
    var wuInj=getInjuryChance(wuFc);
    if(S.barWeight>45)drawDangerMeter(is1v1()?680:680,16,wuFc,wuInj);
    var bh=(S.phase!=='gym'&&S.phase!=='intro')?LAYOUT.comp.platformX:S.homeX;
    T(S.barWeight+' LBS',bh,FY+30,10,'#555');
    // 1v1 platform warmup HUD
    if(is1v1()&&S.warmup){
      var wElapsed=Date.now()-S.warmup.startTime;
      var wRemain=Math.max(0,Math.ceil((S.warmup.duration-wElapsed)/1000));
      var wMin=Math.floor(wRemain/60),wSec=wRemain%60;
      var wTimerStr=wMin+':'+(wSec<10?'0':'')+wSec;
      T('WARMUP',450,22,14,'#fff');
      T(wTimerStr,450,40,12,wRemain<30?'#ff4444':'#ccc');
      var wStep=S.warmup.cardStep||0;
      T('Set '+wStep+'/5',150,22,10,'#aaa');
      var rStep=S.rivals[0].warmupStep||0;
      T('Set '+rStep+'/5',750,22,10,'#aaa');
    }
  }else if(S.phase==='snatch'||S.phase==='cj'){
    var fc=getFailChance(S.phase==='snatch'?'snatch':'cj');
    var compInj=getInjuryChance(fc);
    // Attempt indicator
    T((S.phase==='snatch'?'SNATCH':'C&J')+' '+(S.turn.tarkAttempt+1)+'/3',70,26,11,'#ff6b35','left');
    // Danger meter — the main risk display
    drawDangerMeter(220,16,fc,compInj);
    T(S.barWeight+' LBS',LAYOUT.comp.platformX,FY+30,11,'#f0e6d3');
  }else if(S.phase==='rest_sn_cj'){
    T('REST PERIOD',W/2,26,13,'#ff6b35');
    T('Best Snatch: '+(S.bestSnatch>0?S.bestSnatch+' lbs':'NONE'),W/2,H-15,11,S.bestSnatch>0?'#7fdb6a':'#ff4444');
  }
  // Rival HUD
  try{drawRivalHUD();}catch(e){}

  // Mute toggle icon — top-right
  var mx=868,my=18;
  cx.globalAlpha=hover==='mute'?1:0.5;
  if(SFX.muted){
    // Muted — speaker with X
    T('\uD83D\uDD07',mx,my+6,16,'#ff4444','left');
  }else{
    // Unmuted — speaker with waves
    T('\uD83D\uDD0A',mx,my+6,16,'#7fdb6a','left');
  }
  cx.globalAlpha=1;
}

// --- RIVAL: PAK CHOL-MIN ---

var PAK_SNATCH_MSGS=[
  "Pak Chol-Min snatches WEIGHT. He didn't even blink.",
  "Pak makes WEIGHT look easy. The crowd is silent.",
  "WEIGHT goes up. Pak stares at the judges like they owe him money.",
  "Pak snatches WEIGHT with perfect form. Textbook.",
  "WEIGHT. Good lift. Pak walks off like he's catching a bus."
];
var PAK_CJ_MSGS=[
  "Pak cleans WEIGHT and jerks it overhead. Stone cold.",
  "WEIGHT. Pak barely reacts. Just another day at the office.",
  "Pak puts WEIGHT overhead like it's personal. No celebration.",
  "WEIGHT goes up smooth. Pak's coach nods once. That's it.",
  "Clean & jerk at WEIGHT. Pak is a machine."
];
var PAK_FAIL_MSGS=[
  "Pak drops WEIGHT. He stares at the bar like it betrayed his country.",
  "WEIGHT crashes down. Pak's jaw tightens. That's his only tell.",
  "No lift for Pak at WEIGHT. He turns and walks away. No emotion.",
  "Pak misses WEIGHT. The North Korean coaches exchange a glance."
];

function initRival(){
  var r=S.rival;
  r.active=true;
  r.attempt=0;
  r.bestSnatch=0;r.bestCJ=0;
  r.snatchAttempts=[null,null,null];
  r.cjAttempts=[null,null,null];
  r.snatchWeights=[0,0,0];
  r.cjWeights=[0,0,0];
  r.pose='idle';r.poseT=0;
  r.timer=0;r.nextLiftAt=0;
  r.liftType=null;

  // Generate Pak's target weights based on Tark's stats
  // Pak opens conservative, builds up. Strong but beatable.
  // Snatch targets: 265-285-300 range
  var snBase=255+Math.floor(Math.random()*20); // 255-275
  r.snTargets=[snBase,snBase+15+Math.floor(Math.random()*10),snBase+30+Math.floor(Math.random()*15)];
  // CJ targets: 315-335-350 range
  var cjBase=305+Math.floor(Math.random()*20); // 305-325
  r.cjTargets=[cjBase,cjBase+15+Math.floor(Math.random()*10),cjBase+30+Math.floor(Math.random()*15)];
}

function rivalStartPhase(phase){
  var r=S.rival;
  if(!r.active)return;
  r.attempt=0;
  r.pose='idle';r.poseT=0;
  // First lift comes 3-6 seconds into the phase
  r.nextLiftAt=Date.now()+3000+Math.floor(Math.random()*3000);
  r.liftType=phase==='snatch'?'snatch':'cj';
}

function updateRival(){
  var r=S.rival;
  if(!r.active)return;
  // Only animate pose timers — no autonomous lifting anymore
  if(r.pose!=='idle'&&r.pose!=='walking')r.poseT++;
  // Return to idle after lift animation (used by turn system)
  if(r.pose==='overhead'&&r.poseT>80){r.pose='idle';r.poseT=0;}
  if(r.pose==='jerk'&&r.poseT>80){r.pose='idle';r.poseT=0;}
  if(r.pose==='clean_hold'&&r.poseT>60){r.pose='idle';r.poseT=0;}
  if(r.pose==='failed'&&r.poseT>60){r.pose='idle';r.poseT=0;}
  // Pak walk engine
  updatePakWalk();
}

// --- PAK WALK ENGINE ---
var pakWalkDest=null,pakWalkCb=null,pakWalkSpeed=3;
function pakWalkTo(destX,cb){
  pakWalkDest=destX;pakWalkCb=cb;
  S.rival.pose='walking';S.rival.poseT=0;
}
function updatePakWalk(){
  if(pakWalkDest===null)return;
  var r=S.rival;
  var dx=pakWalkDest-r.x;
  if(Math.abs(dx)<=pakWalkSpeed){
    r.x=pakWalkDest;
    r.pose='idle';r.poseT=0;
    pakWalkDest=null;
    var cb=pakWalkCb;pakWalkCb=null;
    if(cb)cb();
  }else{
    r.x+=dx>0?pakWalkSpeed:-pakWalkSpeed;
  }
}

// --- TURN-BASED COMPETITION (Olympic rules: bar never drops) ---

function startTurnSystem(liftType){
  var t=S.turn;
  t.liftType=liftType;
  t.platformWeight=45;
  t.tarkDeclared=0;
  t.tarkAttempt=0;
  t.tarkDone=false;
  t.whose=null;
  t.phase='idle';
  t.timer=0;
  t.tarkOnPlatform=false;
  t.pakOnPlatform=false;
  // Compat: keep pakDeclared/pakAttempt/pakDone for 1v1 scoreboard
  t.pakDeclared=0;t.pakAttempt=0;t.pakDone=false;
  // Reset all rivals for this lift type
  for(var i=0;i<S.rivals.length;i++){
    var rv=S.rivals[i];
    rv.declared=0;rv.done=false;rv.currentAttempt=0;
    rv.liftType=liftType;
  }
  // All rivals auto-declare, then prompt Tark
  autoDeclareAll();
  promptTarkDeclare();
}

function autoDeclareAll(){
  var t=S.turn;
  for(var i=0;i<S.rivals.length;i++){
    var rv=S.rivals[i];
    if(rv.done)continue;
    var targets=t.liftType==='snatch'?rv.snTargets:rv.cjTargets;
    var baseTarget=targets[rv.currentAttempt]||targets[2];
    var targetWeight=baseTarget;

    // === PERSONALITY-DRIVEN DECLARATIONS ===
    if(rv.personality==='hothead'){
      // Matches Tark's weight or goes above — ego-driven
      if(t.tarkDeclared>0&&t.tarkDeclared>=targetWeight){
        targetWeight=t.tarkDeclared+5; // always tries to one-up Tark
      }
      // Gets rattled after a miss — declares lower, higher fail chance
      var lastAttemptFailed=rv.currentAttempt>0&&rv[t.liftType==='snatch'?'snatchAttempts':'cjAttempts'][rv.currentAttempt-1]===false;
      if(lastAttemptFailed){
        targetWeight=Math.max(baseTarget-10,targetWeight-15); // scared, drops weight
        rv.failBase=Math.min(0.25,(rv.failBase||0.06)+0.06); // rattled — higher fail rate
      }
    }else if(rv.personality==='veteran'){
      // Conservative, small jumps — never more than +10 between attempts
      if(rv.currentAttempt>0){
        var prevWeight=rv[t.liftType==='snatch'?'snatchWeights':'cjWeights'][rv.currentAttempt-1];
        if(prevWeight>0&&targetWeight>prevWeight+10)targetWeight=prevWeight+10;
      }
      // Never chases Tark — sticks to own plan
      // Slightly lower fail base — steady hands
      rv.failBase=Math.max(0.03,(rv.failBase||0.05)-0.01);
    }else if(rv.personality==='sandbagger'){
      // Opens very low, saves big number for 3rd attempt
      if(rv.currentAttempt===0){
        targetWeight=targets[0]-20; // opens well below capability
      }else if(rv.currentAttempt===1){
        targetWeight=targets[0]-5; // still conservative
      }else{
        // 3rd attempt: goes BIG — jumps to max or above Tark
        targetWeight=targets[2]+10;
        if(t.tarkDeclared>0&&targets[2]<t.tarkDeclared+5){
          targetWeight=t.tarkDeclared+5; // tries to leapfrog on final attempt
        }
      }
    }

    // Floor: can't go below platform weight
    if(targetWeight<t.platformWeight)targetWeight=t.platformWeight;
    // Round to nearest 5
    targetWeight=Math.round(targetWeight/5)*5;
    rv.declared=targetWeight;
  }
  // Log lightest rival declaration
  var lightest=getLightestRivalDeclared();
  if(lightest){
    if(S.rivals.length===1){
      log(lightest.name+' DECLARES: '+lightest.declared+' LBS','phase');
    }else{
      log('Rivals have declared. Lightest: '+lightest.name+' at '+lightest.declared+' lbs.','phase');
    }
  }
  // Compat: sync pakDeclared for 1v1 scoreboard
  if(S.rivals.length===1){t.pakDeclared=S.rivals[0].declared;t.pakAttempt=S.rivals[0].currentAttempt;t.pakDone=S.rivals[0].done;}
}

function getLightestRivalDeclared(){
  var best=null;
  for(var i=0;i<S.rivals.length;i++){
    var rv=S.rivals[i];
    if(rv.done||rv.declared<=0)continue;
    if(!best||rv.declared<best.declared)best=rv;
  }
  return best;
}
function getHeaviestRivalDeclared(){
  var best=null;
  for(var i=0;i<S.rivals.length;i++){
    var rv=S.rivals[i];
    if(rv.done||rv.declared<=0)continue;
    if(!best||rv.declared>best.declared)best=rv;
  }
  return best;
}

function allRivalsDone(){
  for(var i=0;i<S.rivals.length;i++)if(!S.rivals[i].done)return false;
  return true;
}

// --- PLATFORM RITUAL: Coach Advice ---
function getRitualCoachAdvice(){
  var t=S.turn;
  var fc=getFailChance(S.phase==='snatch'?'snatch':'cj');
  var attemptNum=t.tarkAttempt;
  // High risk
  if(fc>0.5)return pick([
    'Stay tight off the floor. Don\'t rush it.',
    'This is heavy. Breathe. Trust your pull.',
    'Patience off the floor. Aggressive at the top.',
    'Don\'t muscle it. Let technique do the work.',
    'Easy off the ground. Explode at the hip.'
  ]);
  // Rival pressure
  var topRival=null;
  for(var i=0;i<S.rivals.length;i++){
    var rv=S.rivals[i];
    if(!rv.done&&rv.declared>0&&(!topRival||rv.declared>topRival.declared))topRival=rv;
  }
  if(topRival&&t.tarkDeclared>topRival.declared){
    var rn=topRival.name.split(' ')[0];
    return pick([
      rn+' can\'t match you if you make this.',
      'This puts you ahead of '+rn+'. Send it.',
      rn+' is watching. Show him what you\'ve got.',
      'Make this and '+rn+' is done.'
    ]);
  }
  // Last attempt
  if(attemptNum>=2)return pick([
    'Last attempt. Leave nothing on the platform.',
    'Everything you\'ve got. Right here, right now.',
    'This is what we trained for. Empty the tank.',
    'No regrets. Full send.'
  ]);
  // Default
  return pick([
    'Nice and easy. You own this weight.',
    'Smooth pull. You\'ve done this a thousand times.',
    'Nothing special. Just make the lift.',
    'Routine weight. Stay focused.',
    'You\'ve got this. Just like in training.'
  ]);
}

// --- BACK ROOM: Weight Declaration + Coach ---

function getCoachSuggestion(liftType,attemptNum){
  var t=S.turn;
  var base=t.platformWeight;
  var prevMade=liftType==='snatch'?S.lastMadeSnatch:S.lastMadeCJ;
  var prevWeights=liftType==='snatch'?S.snatchWeights:S.cjWeights;
  var prevResults=liftType==='snatch'?S.snatchAttempts:S.cjAttempts;
  var prevAttempted=attemptNum>0?prevWeights[attemptNum-1]:0;
  var prevSuccess=attemptNum>0?prevResults[attemptNum-1]:null;
  var suggestion=0,msg='';
  // Opener strength estimate: stronger Tark = heavier opener
  var sEst=Math.round(180+S.strength*0.8+S.technique*0.3);
  if(liftType==='cj')sEst=Math.round(sEst*1.22);
  sEst=Math.round(sEst/5)*5;

  if(attemptNum===0){
    suggestion=Math.max(base,sEst-15);
    suggestion=Math.round(suggestion/5)*5;
    msg=pick(["I'd open at "+suggestion+". Safe and easy.","Let's start with "+suggestion+". Nothing stupid.","Open at "+suggestion+". Feel the bar, get on the board.",""+suggestion+" to start. Conservative but smart."]);
  }else if(attemptNum===1){
    if(prevSuccess&&prevMade>0){
      suggestion=prevMade+10;
      msg=pick(["Nice lift. Let's go "+suggestion+".","Good. Now "+suggestion+". You got this.","Bump to "+suggestion+". Keep the momentum.",""+suggestion+" next. You looked solid."]);
    }else{
      suggestion=Math.max(base,prevAttempted||sEst-15);
      msg=pick(["We need this. Same weight, "+suggestion+".","Take "+suggestion+" again. Focus this time.",""+suggestion+". Stay calm, don't rush the pull.","Retry "+suggestion+". Breathe."]);
    }
  }else{
    if(prevSuccess&&prevMade>0){
      suggestion=prevMade+15;
      var topRival=null;
      for(var i=0;i<S.rivals.length;i++){
        if(S.rivals[i].declared>0&&(!topRival||S.rivals[i].declared>topRival.declared))topRival=S.rivals[i];
      }
      if(topRival&&topRival.declared>=suggestion){
        suggestion=topRival.declared+5;
        var rShort=topRival.name.split(' ')[0];
        msg=pick([rShort+" went "+topRival.declared+". I'd go "+suggestion+".",rShort+" declared "+topRival.declared+". Beat that with "+suggestion+".",suggestion+" beats "+rShort+". Send it."]);
      }else{
        msg=pick(["Last attempt. Go big \u2014 "+suggestion+".","Final lift. Leave it all out there. "+suggestion+".",""+suggestion+". Swing for the fences.","This is it. "+suggestion+" or nothing."]);
      }
    }else{
      suggestion=Math.max(base,prevAttempted||sEst-15);
      msg=pick(["We need a lift. Try "+suggestion+" again.",""+suggestion+". No heroics. Just make this one.","Last chance. "+suggestion+". Lock it in.",""+suggestion+". Calm down and make a lift."]);
    }
  }
  suggestion=Math.max(base,Math.round(suggestion/5)*5);
  return {weight:suggestion,message:msg};
}

function showWeightDeclare(show){
  var el=document.getElementById('weightDeclare');
  if(el)el.style.display=show?'block':'none';
}

function declareTypedWeight(){
  if(S.busy)return;
  var t=S.turn;
  if(t.tarkDone)return;
  var inp=document.getElementById('weightInput');
  if(!inp)return;
  var weight=parseInt(inp.value,10);
  if(isNaN(weight)||weight<45){log('Invalid weight.','fail');return;}
  if(weight<t.platformWeight){
    log("Can't go below "+t.platformWeight+' lbs \u2014 bar never goes down.','fail');
    return;
  }
  if(weight>MAX_BAR_WEIGHT){
    log("Max weight is "+MAX_BAR_WEIGHT+' lbs.','fail');
    return;
  }
  // Round to nearest whole number
  weight=Math.round(weight);
  // Set bar weight and plate stack
  S.barWeight=weight;
  S.plateStack=calcPlatesForWeight(weight);
  // Declare
  t.tarkDeclared=weight;
  log('TARK DECLARES: '+weight+' LBS','phase');
  float('DECLARED '+weight,S.tX,140,'#ffcc00',18);
  S.coachMsg='';
  showWeightDeclare(false);
  resolveNextLifter();
}

function calcPlatesForWeight(weight){
  var plates=[];
  var remaining=(weight-45)/2; // per side
  var sizes=[45,25,10,5,2.5,1.25];
  for(var i=0;i<sizes.length;i++){
    while(remaining>=sizes[i]-0.01){
      plates.push(sizes[i]);
      remaining-=sizes[i];
    }
  }
  return plates;
}

function walkToPlatformAndLift(){
  if(S.busy)return;
  S.coachMsg='';
  showWeightDeclare(false);
  S.turn.phase='walking_to_platform';
  S.turn.rituals={chalk:false,coach:false,psyche:false};
  // 1v1: already on platform — walk to center directly
  if(is1v1()&&S.scene==='platform'){
    walkTo(LAYOUT.comp.platformX,function(){
      var t=S.turn;
      t.tarkOnPlatform=true;
      t.phase='platform_ritual';
      var remaining=Math.ceil(t.timer);
      log('ON THE PLATFORM. '+remaining+' seconds left.','phase');
      float(remaining+'s LEFT',S.tX,160,'#ffaa00',18);
      updUI();
    });
    return;
  }
  // Multi-rival: transition from backroom
  transitionToPlatform(function(){
    walkTo(LAYOUT.comp.homeX,function(){
      var t=S.turn;
      t.phase='platform_ritual';
      var remaining=Math.ceil(t.timer);
      log('ON THE PLATFORM. '+remaining+' seconds left.','phase');
      float(remaining+'s LEFT',S.tX,160,'#ffaa00',18);
      updUI();
    });
  });
}

function promptTarkDeclare(){
  var t=S.turn;
  if(t.tarkDone){resolveNextLifter();return;}
  t.whose='tark';
  t.phase='declaring';
  autoDeclareAll();
  var lightest=getLightestRivalDeclared();

  var heaviest=getHeaviestRivalDeclared();
  if(S.scene==='backroom'){
    // Back room — show weight input with coach suggestion
    var suggestion=getCoachSuggestion(t.liftType,t.tarkAttempt);
    var inp=document.getElementById('weightInput');
    if(inp){inp.value=suggestion.weight;inp.min=t.platformWeight;inp._warmupInit=false;}
    var coachEl=document.getElementById('coachSuggestion');
    if(coachEl){
      var coachText='Coach: "'+suggestion.message+'"';
      if(lightest&&heaviest&&lightest!==heaviest){
        coachText+=' (Lightest: '+lightest.name.split(' ')[0]+' at '+lightest.declared+' | Heaviest: '+heaviest.name.split(' ')[0]+' at '+heaviest.declared+')';
      }else if(lightest){
        coachText+=' ('+lightest.name.split(' ')[0]+' declared '+lightest.declared+')';
      }
      coachEl.textContent=coachText;
    }
    S.coachMsg=suggestion.message;
    showWeightDeclare(true);
    log('Your turn to declare. Coach suggests '+suggestion.weight+' lbs.','phase');
  }else{
    var msg='DECLARE YOUR WEIGHT. Load the bar and click DECLARE.';
    if(lightest&&heaviest&&lightest!==heaviest)msg+=' Lightest: '+lightest.declared+' | Heaviest: '+heaviest.declared+' lbs.';
    else if(lightest)msg+=' Rival declared: '+lightest.declared+' lbs.';
    else if(allRivalsDone())msg+=' All rivals are done.';
    log(msg,'phase');
  }
  updUI();
}

function declareWeight(){
  if(S.busy)return;
  var t=S.turn;
  if(t.tarkDone)return;
  var weight=S.barWeight;
  if(weight<t.platformWeight){
    log('Can\'t declare below '+t.platformWeight+' lbs \u2014 bar never goes down.','fail');
    return;
  }
  t.tarkDeclared=weight;
  log('TARK DECLARES: '+weight+' LBS','phase');
  float('DECLARED '+weight,S.tX,140,'#ffcc00',18);
  resolveNextLifter();
}

function resolveNextLifter(){
  var t=S.turn;
  var allDone=allRivalsDone();
  // Everyone done?
  if(t.tarkDone&&allDone){finishLiftPhase();return;}
  // Only Tark has attempts?
  if(!t.tarkDone&&allDone){
    if(t.tarkDeclared===0){promptTarkDeclare();return;}
    startTarkTurn();return;
  }
  // Only rivals have attempts?
  if(t.tarkDone&&!allDone){
    autoDeclareAll();
    var next=getNextRivalToLift();
    if(next)startRivalLift(next);
    return;
  }
  // Both Tark and rivals have attempts — need Tark's declaration
  if(t.tarkDeclared===0){promptTarkDeclare();return;}
  autoDeclareAll();
  // Find lightest declared rival
  var nextRival=getNextRivalToLift();
  if(!nextRival){startTarkTurn();return;}
  // Compare: lower weight goes first, ties to Tark
  if(t.tarkDeclared<=nextRival.declared){
    startTarkTurn();
  }else{
    startRivalLift(nextRival);
  }
}

function getNextRivalToLift(){
  // Return the undone rival with the lowest declared weight
  var best=null;
  for(var i=0;i<S.rivals.length;i++){
    var rv=S.rivals[i];
    if(rv.done||rv.declared<=0)continue;
    if(!best||rv.declared<best.declared)best=rv;
  }
  return best;
}

function startTarkTurn(){
  var t=S.turn;
  t.whose='tark';
  t.phase='idle';
  t.timer=60;
  t.timerStart=Date.now(); // Timer starts NOW — includes backroom time
  t.rituals={chalk:false,coach:false,psyche:false};
  log('YOUR TURN \u2014 '+t.tarkDeclared+' lbs. 60 SECONDS. GO!','phase');
  // Big alert
  SFX.turnBuzzer();
  S.turnAlert=Date.now(); // triggers pulsing overlay in backroom HUD
  S.screenShake=6;
  // BACKROOM: "YOUR TURN" announcement, coach urges, door glows
  if(S.scene==='backroom'){
    S.coachMsg=pick(['GO GO GO! Get to that platform!','You\'re up! MOVE!','60 seconds! Get out there NOW!','Clock is ticking! DOOR!']);
    S.tv.mode='leaderboard';
    // Door glow is handled by drawBackroomDoor checking t.whose==='tark'
    float('YOUR TURN!',S.tX,130,'#ffaa00',32);
    float('60 SECONDS!',S.tX,165,'#ff4444',18);
  }else if(is1v1()){
    // 1v1 platform: already there, just prompt
    S.coachMsg=pick(['You\'re up! Let\'s go!','Your turn. Show them.','Step up! 60 seconds!','Time to lift!']);
    S.coachBubble=Date.now()+4000;
    float('YOUR TURN!',S.tX,130,'#ffaa00',32);
    float('60 SECONDS!',S.tX,165,'#ff4444',18);
  }
  updUI();
}

function startRivalLift(rivalObj){
  var t=S.turn;
  // Swap this rival into the display slot
  swapRival(rivalObj);
  var r=S.rival;
  t.whose='rival';
  var speed=getAnimSpeed();

  // BACKROOM: Show rival lift on TV instead of walking to platform
  if(S.scene==='backroom'){
    t.phase='pak_lifting';
    setTVLifting(r,r.declared);
    log(r.name+' approaches the platform at '+r.declared+' lbs...','phase');
    S.coachMsg='Watch the TV. '+r.name.split(' ')[0]+' is up.';
    var entry={who:r.id,attempt:r.currentAttempt,liftType:t.liftType,weight:r.declared};
    rivalAttemptLiftTurnBased(entry,function(){
      // Show result on TV
      var rName=r.name.split(' ')[0];
      var rResult=S.compLiftResult==='good';
      setTVResult(rResult?'good':'no_lift');
      t.pakOnPlatform=false;
      t.platformWeight=Math.max(t.platformWeight,r.declared);
      S.minNextWeight=t.platformWeight;
      r.currentAttempt++;
      r.declared=0;
      if(r.currentAttempt>=3)r.done=true;
      syncBack();
      if(S.rivals.length===1){t.pakAttempt=r.currentAttempt;t.pakDone=r.done;}
      t.phase='between';
      t.whose=null;
      // Coach reacts to rival's result on TV
      if(rResult){
        S.coachMsg=pick([rName+' made that look easy.','Damn. '+rName+' is strong.',rName+' nailed it. We gotta match that.','Good lift by '+rName+'. Stay focused.']);
      }else{
        S.coachMsg=pick([rName+' missed! That\'s good for us.',rName+' couldn\'t hold it. Advantage us.','Ha! '+rName+' choked.','Missed lift. The pressure\'s getting to them.']);
      }
      if(!r.done)autoDeclareAll();
      // Wait for TV result display then resolve next
      var delay=Math.round(2500/speed);
      setTimeout(function(){
        S.compLiftResult=null;
        try{resolveNextLifter();}catch(e){log('ERR rivalResolve: '+e.message,'fail');}
      },delay);
    });
    return;
  }

  // PLATFORM: existing walk-to-platform flow
  t.phase='pak_walking';
  pakWalkSpeed=Math.round(3*speed);
  log(r.name+' approaches the platform at '+r.declared+' lbs...','phase');
  var platX=LAYOUT.comp.platformX;
  pakWalkTo(platX,function(){
    t.phase='pak_lifting';
    t.pakOnPlatform=true;
    var entry={who:r.id,attempt:r.currentAttempt,liftType:t.liftType,weight:r.declared};
    rivalAttemptLiftTurnBased(entry,function(){
      t.pakOnPlatform=false;
      t.phase='pak_returning';
      t.platformWeight=Math.max(t.platformWeight,r.declared);
      S.minNextWeight=t.platformWeight;
      // Advance this rival
      r.currentAttempt++;
      r.declared=0;
      if(r.currentAttempt>=3)r.done=true;
      // Sync back to S.rivals array
      syncBack();
      // Compat for 1v1
      if(S.rivals.length===1){t.pakAttempt=r.currentAttempt;t.pakDone=r.done;}
      // 1v1 coach commentary on platform after rival lift
      if(is1v1()){
        var rn1v1=r.name.split(' ')[0];
        var res1v1=S.compLiftResult==='good';
        if(res1v1){
          S.coachMsg=pick([rn1v1+' made that look easy.','Damn. '+rn1v1+' is strong.',rn1v1+' nailed it. We gotta match that.','Good lift by '+rn1v1+'. Stay focused.']);
        }else{
          S.coachMsg=pick([rn1v1+' missed! That\'s good for us.',rn1v1+' couldn\'t hold it. Advantage us.','Ha! '+rn1v1+' choked.','Missed lift. The pressure\'s getting to them.']);
        }
        S.coachBubble=Date.now()+4000;
      }
      pakWalkTo(LAYOUT.comp.pakHomeX,function(){
        t.phase='between';
        t.whose=null;
        pakWalkSpeed=3; // reset walk speed
        if(!r.done)autoDeclareAll();
        var delay=Math.round(800/speed);
        setTimeout(function(){resolveNextLifter();},delay);
      });
    });
  });
}

function executeTarkTurn(){
  var t=S.turn;
  if(t.whose!=='tark')return;
  t.phase='tark_lifting';
  t.tarkOnPlatform=true;
}

function tarkTurnComplete(){
  var t=S.turn;
  t.tarkOnPlatform=false;
  t.phase='between';
  t.whose=null;
  t.timer=0;
  // Clear ritual coach state
  S.ritualCoachVisible=false;
  S.ritualCoachMsg='';
  // Update platform weight (bar was loaded to this weight)
  t.platformWeight=Math.max(t.platformWeight,t.tarkDeclared);
  S.minNextWeight=t.platformWeight;
  // Advance Tark's attempt
  t.tarkAttempt++;
  t.tarkDeclared=0;
  if(t.tarkAttempt>=3)t.tarkDone=true;
  // 1v1: Stay on platform, walk back to home position
  if(is1v1()&&S.scene==='platform'){
    walkTo(LAYOUT.comp.homeX,function(){
      var wasGood=S.compLiftResult==='good';
      S.compLiftResult=null;
      S.coachMsg=wasGood?pick(['Great lift!','That\'s how it\'s done!','Beautiful!','Money!','Let\'s go!'])
        :pick(['Shake it off.','Next one.','Stay focused.','Forget about it.']);
      S.coachBubble=Date.now()+4000;
      unlock();
      setTimeout(function(){try{resolveNextLifter();}catch(e2){log('ERR resolveNext: '+e2.message,'fail');unlock();}},600);
    });
    return;
  }
  // MULTI-RIVAL: Transition back to back room after platform lift
  if(S.scene==='platform'){
    transitionToBackroom(function(){
      try{
        S.tv.mode='leaderboard';
        var wasGood=S.compLiftResult==='good';
        S.compLiftResult=null;
        S.coachMsg=wasGood?pick(['Great lift!','That\'s how it\'s done!','Beautiful!','Money!','Let\'s go!'])
          :pick(['Shake it off.','Next one.','Stay focused.','Forget about it.']);
        unlock();
        setTimeout(function(){try{resolveNextLifter();}catch(e2){log('ERR resolveNext: '+e2.message,'fail');unlock();}},600);
      }catch(e){log('ERR tarkComplete cb: '+e.message,'fail');S.busy=false;unlock();}
    });
    return;
  }
  // Fallback: walk back on platform screen (non-backroom mode)
  walkBack(function(){
    unlock();
    setTimeout(function(){try{resolveNextLifter();}catch(e){log('ERR resolveNext: '+e.message,'fail');unlock();}},600);
  });
}

function rivalAttemptLiftTurnBased(entry,callback){
  var r=S.rival;
  var phase=entry.liftType;
  var weight=entry.weight;
  var attemptNum=entry.attempt;
  var speed=getAnimSpeed();

  // Fail chance uses rival's failBase
  var fb=r.failBase||0.08;
  var baseFail=fb+attemptNum*0.12;
  var weightFactor=phase==='snatch'?Math.max(0,(weight-250)/100):Math.max(0,(weight-300)/100);
  var failChance=Math.min(0.55,baseFail+weightFactor*0.15);
  // Fired-up rivals are harder to beat — reduce fail chance
  if(r.tauntFiredUp){
    failChance=Math.max(0.02,failChance-0.10);
    // One-time target bump: +5 lbs on all remaining targets
    if(phase==='snatch'&&r.snTargets){
      for(var ti=attemptNum;ti<r.snTargets.length;ti++)r.snTargets[ti]+=5;
    }else if(phase==='cj'&&r.cjTargets){
      for(var ti=attemptNum;ti<r.cjTargets.length;ti++)r.cjTargets[ti]+=5;
    }
    r.tauntFiredUp=false;// consumed
  }

  var success=Math.random()>=failChance;
  var isCJ=(phase==='cj');
  var isPak=(r.id==='pak');

  r.pose='pull';r.poseT=0;
  SFX.metalClang();

  function recordSuccess(){
    if(phase==='snatch'){
      r.snatchAttempts[attemptNum]=true;
      r.snatchWeights[attemptNum]=weight;
      if(weight>r.bestSnatch)r.bestSnatch=weight;
    }else{
      r.cjAttempts[attemptNum]=true;
      r.cjWeights[attemptNum]=weight;
      if(weight>r.bestCJ)r.bestCJ=weight;
    }
    SFX.crowdCheer();
    SFX.lockoutImpact();
    S.compLiftResult='good';
    S.screenShake=Math.min(14,4+weight/40);
    S.hitstop=Math.min(6,2+Math.floor(weight/100));
    var msgs=isPak?(phase==='snatch'?PAK_SNATCH_MSGS:PAK_CJ_MSGS):(phase==='snatch'?RIVAL_SNATCH_MSGS:RIVAL_CJ_MSGS);
    var msg=pick(msgs).replace('WEIGHT',weight+' lbs').replace('NAME',r.name);
    log(msg,'phase');
    float(r.name+': '+weight,r.x,140,'#7fdb6a',14);
  }

  function recordFail(){
    r.pose='failed';r.poseT=0;
    if(phase==='snatch'){
      r.snatchAttempts[attemptNum]=false;
      r.snatchWeights[attemptNum]=weight;
    }else{
      r.cjAttempts[attemptNum]=false;
      r.cjWeights[attemptNum]=weight;
    }
    SFX.barDrop();
    S.compLiftResult='no_lift';
    S.screenShake=Math.min(8,2+weight/70);
    var msgs=isPak?PAK_FAIL_MSGS:RIVAL_FAIL_MSGS;
    var msg=pick(msgs).replace('WEIGHT',weight+' lbs').replace('NAME',r.name);
    log(msg,'fail');
    float(r.name+': NO LIFT',r.x,140,'#ff4444',13);
  }

  function finish(){
    r.attempt++;
    var finishDelay=Math.round(1200/speed);
    setTimeout(function(){
      r.pose='idle';r.poseT=0;
      if(callback)callback();
      S.compLiftResult=null;
    },finishDelay);
  }

  var pullDelay=Math.round(800/speed);
  var jerkDelay=Math.round(700/speed);

  if(isCJ){
    setTimeout(function(){
      if(success){
        r.pose='clean_hold';r.poseT=0;
        setTimeout(function(){
          r.pose='jerk';r.poseT=0;
          recordSuccess();
          finish();
        },jerkDelay);
      }else{
        recordFail();
        finish();
      }
    },pullDelay);
  }else{
    setTimeout(function(){
      if(success){
        r.pose='overhead';r.poseT=0;
        recordSuccess();
      }else{
        recordFail();
      }
      finish();
    },pullDelay);
  }
}

// Animate Pak's remaining lifts after Tark DNF
// Simple approach: walk to platform once, do all lifts, walk home once
function autoCompletePakLifts(onDone){
  // Generalized: auto-complete ALL active rivals' remaining lifts
  console.log('[DNF] autoCompleteRivalLifts called, rivals='+S.rivals.length+', dnfPhase='+S.dnfPhase);
  var t=S.turn;
  var allRivals=S.rivals&&S.rivals.length>0?S.rivals:[S.rival];
  var activeRivals=[];
  for(var i=0;i<allRivals.length;i++){
    if(allRivals[i].active)activeRivals.push(allRivals[i]);
  }
  if(activeRivals.length===0){if(onDone)onDone();return;}

  var currentPhase=t.liftType||S.dnfPhase||'snatch';
  if(currentPhase==='warmup')currentPhase='snatch';
  if(S.phase!=='snatch'&&S.phase!=='cj')S.phase=currentPhase;

  var platX=LAYOUT.comp.platformX;
  var homeX=LAYOUT.comp.pakHomeX;
  var speedMult=getAnimSpeed();
  var ri=0; // rival index
  var _safetyDone=false;

  function allDone(){
    if(_safetyDone)return;
    _safetyDone=true;
    // Sync all rivals back
    for(var i=0;i<activeRivals.length;i++){
      swapRival(activeRivals[i]);
      syncBack();
    }
    if(onDone)onDone();
  }

  // Nuclear safety: 45s for multi, 30s for 1v1
  var safetyMs=activeRivals.length>1?45000:30000;
  var _safetyTimer=setTimeout(function(){
    if(!_safetyDone){
      log('(Rivals finish up)','phase');
      // Silently resolve remaining
      for(var si=ri;si<activeRivals.length;si++){
        var rv=activeRivals[si];
        silentResolve(rv,currentPhase);
      }
      allDone();
    }
  },safetyMs);

  function silentResolve(rv,startPhase){
    var phases=startPhase==='cj'?['cj']:['snatch','cj'];
    for(var pi=0;pi<phases.length;pi++){
      var ph=phases[pi];
      var tgts=ph==='snatch'?rv.snTargets:rv.cjTargets;
      var startAtt=ph===startPhase?rv.currentAttempt:0;
      for(var a=startAtt;a<3;a++){
        var w=tgts[a]||tgts[2];
        var bf=(rv.failBase||0.08)+a*0.12;
        var wf=ph==='snatch'?Math.max(0,(w-250)/100):Math.max(0,(w-300)/100);
        var fc=Math.min(0.55,bf+wf*0.15);
        var ok=Math.random()>=fc;
        if(ph==='snatch'){
          rv.snatchAttempts[a]=ok;rv.snatchWeights[a]=w;
          if(ok&&w>rv.bestSnatch)rv.bestSnatch=w;
        }else{
          rv.cjAttempts[a]=ok;rv.cjWeights[a]=w;
          if(ok&&w>rv.bestCJ)rv.bestCJ=w;
        }
      }
    }
  }

  function processNextRival(){
    if(ri>=activeRivals.length){
      clearTimeout(_safetyTimer);
      allDone();
      return;
    }
    var rv=activeRivals[ri];
    swapRival(rv);
    var rShort=rv.name.split(' ')[0];

    // Build queue for this rival
    var queue=[];
    function addPhaseLifts(phase,targets,startAttempt){
      for(var i=startAttempt;i<3;i++){
        var targetWeight=targets[i]||targets[2];
        queue.push({phase:phase,attempt:i,weight:targetWeight});
      }
    }
    var rvStart=rv.currentAttempt||0;
    if(currentPhase==='snatch'){
      if(rvStart<3)addPhaseLifts('snatch',rv.snTargets,rvStart);
      addPhaseLifts('cj',rv.cjTargets,0);
    }else{
      if(rvStart<3)addPhaseLifts('cj',rv.cjTargets,rvStart);
    }

    if(queue.length===0){
      ri++;
      processNextRival();
      return;
    }

    // Silently resolve: multi-comp (>2 rivals) OR DNF (backroom, can't animate on platform)
    if(activeRivals.length>2 || S.dnf){
      log(rShort+' finishes his remaining lifts...','phase');
      silentResolve(rv,currentPhase);
      var rvTotal=(rv.bestSnatch||0)+(rv.bestCJ||0);
      if(rvTotal>0){log(rShort+' totals '+rvTotal+' ('+(rv.bestSnatch||0)+' + '+(rv.bestCJ||0)+').','phase');}
      else{log(rShort+' bombed out.','fail');}
      syncBack();
      ri++;
      setTimeout(processNextRival,S.dnf?800:300);
      return;
    }

    // Animate for 1v1 or 3-man
    log(rShort+' takes the platform...','phase');
    var qi=0;
    var switchedToCJ=false;

    function doLift(){
      if(qi>=queue.length){
        syncBack();
        t.pakDeclared=0;
        pakWalkTo(homeX,function(){
          S.rival.pose='idle';S.rival.poseT=0;
          ri++;
          setTimeout(processNextRival,300);
        });
        return;
      }
      var lift=queue[qi];
      if(!switchedToCJ&&lift.phase==='cj'){
        switchedToCJ=true;
        t.platformWeight=45;
        S.phase='cj';
        log('--- '+rShort+' moves to clean & jerk ---','phase');
      }
      if(lift.weight<t.platformWeight)lift.weight=t.platformWeight;
      S.rival.liftType=lift.phase;
      t.liftType=lift.phase;
      t.pakDeclared=lift.weight;
      t.pakAttempt=lift.attempt;
      var entry={who:'pak',attempt:lift.attempt,liftType:lift.phase,weight:lift.weight};
      rivalAttemptLiftTurnBased(entry,function(){
        t.platformWeight=Math.max(t.platformWeight,lift.weight);
        qi++;
        setTimeout(doLift,Math.round(600/speedMult));
      });
    }

    pakWalkTo(platX,function(){
      S.rival.pose='idle';S.rival.poseT=0;
      setTimeout(doLift,Math.round(400/speedMult));
    });
  }

  processNextRival();
}

function finishLiftPhase(){
  var t=S.turn;
  var liftType=t.liftType||'snatch';
  t.whose=null;t.phase='idle';t.timer=0;
  S.attempt=3;
  // Sync all rivals back
  for(var i=0;i<S.rivals.length;i++){
    S.rivals[i].attempt=S.rivals[i].currentAttempt;
  }
  if(S.rivals.length===1)S.rival.attempt=t.pakAttempt;
  advanceAttempt(liftType);
}

// Check turn timer each frame
var lastTimerSec=-1;
function updateTurnTimer(){
  var t=S.turn;
  if(t.whose!=='tark')return;
  if(t.phase!=='idle'&&t.phase!=='platform_ritual')return;
  if(!t.timerStart)return; // Timer not started yet (still in backroom)
  var elapsed=(Date.now()-t.timerStart)/1000;
  t.timer=Math.max(0,60-elapsed);
  var sec=Math.ceil(t.timer);
  if(sec!==lastTimerSec){lastTimerSec=sec;renderPrimaryButton();}
  if(t.timer<=0){
    log('TIME\'S UP! Tark ran out the clock. No lift.','fail');
    float('TIME OUT',S.tX,140,'#ff4444',20);
    var liftType=t.liftType||S.phase;
    var attemptNum=t.tarkAttempt;
    if(liftType==='snatch'){
      S.snatchAttempts[attemptNum]=false;
      S.snatchWeights[attemptNum]=S.barWeight;
    }else{
      S.cjAttempts[attemptNum]=false;
      S.cjWeights[attemptNum]=S.barWeight;
    }
    // Update platform weight (bar was loaded)
    t.platformWeight=Math.max(t.platformWeight,t.tarkDeclared);
    S.minNextWeight=t.platformWeight;
    t.tarkAttempt++;
    t.tarkDeclared=0;
    if(t.tarkAttempt>=3)t.tarkDone=true;
    // Force unlock if mid-ritual
    if(t.phase==='platform_ritual')S.busy=false;
    S.ritualCoachVisible=false;S.ritualCoachMsg='';
    t.whose=null;t.phase='between';t.timer=0;
    if(S.scene==='backroom'){
      S.coachMsg=pick(['What happened?!','You gotta get out there!','That\'s a missed attempt...','Clock ran out. Unacceptable.']);
      showWeightDeclare(false);
    }
    // If on platform, transition back to backroom
    if(S.scene==='platform'){
      transitionToBackroom(function(){
        S.tv.mode='leaderboard';
        setTimeout(function(){resolveNextLifter();},600);
      });
    }else{
      setTimeout(function(){resolveNextLifter();},1500);
    }
  }
}

function drawTurnTimer(){
  var t=S.turn;
  if(S.phase!=='snatch'&&S.phase!=='cj')return;
  var platX=LAYOUT.comp.platformX;
  // Declaring phase: pulsing prompt
  if(t.whose==='tark'&&t.phase==='declaring'){
    cx.globalAlpha=0.6+Math.sin(Date.now()/300)*0.3;
    T('DECLARE YOUR WEIGHT',platX,FY-48,11,'#ffcc00');
    cx.globalAlpha=1;
    if(t.pakDeclared>0&&!t.pakDone){
      T('PAK: '+t.pakDeclared+' LBS',platX,FY-62,9,'#7fdb6a');
    }
    return;
  }
  // Lift phase: 60s timer bar
  if(t.whose!=='tark'||(t.phase!=='idle'&&t.phase!=='platform_ritual'))return;
  if(!t.timerStart)return;
  var barW=120,barH=8;
  var pct=t.timer/60;
  var col=pct>0.5?'#40a040':pct>0.17?'#cccc33':'#ff4444';
  R(platX-barW/2,FY-30,barW,barH,'#222');
  R(platX-barW/2,FY-30,Math.round(barW*pct),barH,col);
  cx.strokeStyle='#444';cx.lineWidth=1;cx.strokeRect(platX-barW/2,FY-30,barW,barH);
  var secs=Math.ceil(t.timer);
  var timerCol=secs<=10?'#ff4444':'#fff';
  if(secs<=10){cx.globalAlpha=0.6+Math.sin(Date.now()/150)*0.4;}
  T(secs+'s',platX,FY-36,secs<=10?14:10,timerCol);
  cx.globalAlpha=1;
  var header=t.phase==='platform_ritual'?'PREPARE \u2014 '+t.tarkDeclared+' LBS':'YOUR TURN \u2014 '+t.tarkDeclared+' LBS';
  T(header,platX,FY-48,9,'#ffcc00');
}

function drawPakTurnLabel(){
  var t=S.turn;
  if(t.whose!=='pak')return;
  if(S.phase!=='snatch'&&S.phase!=='cj')return;
  T('PAK\'S TURN — '+t.pakDeclared+' LBS',LAYOUT.comp.platformX,FY-42,10,'#ff6b35');
}

// --- RIVAL DRAWING ---

function calcRivalPlates(){
  // Use Pak's declared weight from the turn system
  var weight=S.turn.pakDeclared||45;
  var remaining=(weight-45)/2;
  var plateSizes=[45,35,25,10,1];
  var plates=[];
  for(var i=0;i<plateSizes.length;i++){while(remaining>=plateSizes[i]){plates.push(plateSizes[i]);remaining-=plateSizes[i];}}
  return plates;
}

function drawRival(){
  var r=S.rival;
  if(!r.active)return;
  if(S.phase!=='snatch'&&S.phase!=='cj'&&S.phase!=='rest_sn_cj'&&S.phase!=='warmup')return;

  var rx=r.x,ry=328;

  var isSn=(r.liftType==='snatch');
  if(r.pose==='idle'){drawRivalIdle(rx,ry);}
  else if(r.pose==='walking'){drawRivalWalking(rx,ry);}
  else if(r.pose==='pull'){if(isSn){drawRivalSnatchPull(rx,ry);}else{drawRivalPull(rx,ry);}}
  else if(r.pose==='overhead'){if(isSn){drawRivalSnatchOverhead(rx,ry);}else{drawRivalOverhead(rx,ry);}}
  else if(r.pose==='clean_hold'){drawRivalCleanHold(rx,ry);}
  else if(r.pose==='jerk'){drawRivalJerk(rx,ry);}
  else if(r.pose==='failed'){drawRivalFailed(rx,ry);}
  else{drawRivalIdle(rx,ry);}

  // Barbell position per pose
  var pakPlates=calcRivalPlates();
  if(r.pose==='pull'){drawBarbell(rx,ry+30,pakPlates);}
  else if(r.pose==='overhead'||r.pose==='jerk'){drawBarbell(rx,ry-56,pakPlates);}
  else if(r.pose==='front_squat'){drawBarbell(rx,ry+2,pakPlates);}
  else if(r.pose==='clean_hold'){drawBarbell(rx,ry-6,pakPlates);}
  else if(r.pose==='failed'){drawBarbell(rx,FY-10,pakPlates);}
  else if(r.pose==='idle'||!r.pose){drawBarbell(rx,FY-14,pakPlates);}// resting barbell
}

function drawRivalIdle(x,y){
  var rv=S.rival;
  R(x-10,y+30,10,36,'#2a2a2a');R(x+0,y+30,10,36,'#2a2a2a');
  R(x-12,y+66,14,6,'#111');R(x-2,y+66,14,6,'#111');
  R(x-15,y-10,30,42,rv.singlet);
  R(x-22,y-6,9,28,rv.skin);R(x+13,y-6,9,28,rv.skin);
  C(x,y-22,15,rv.skin);
  R(x-14,y-32,28,6,rv.hair);
  R(x-6,y-24,5,2,'#111');R(x+1,y-24,5,2,'#111');
  R(x-3,y-17,6,1,rv.skinDark);
}

function drawRivalPull(x,y){
  var rv=S.rival;
  cx.save();cx.translate(x,y);cx.rotate(-0.15);cx.translate(-x,-y);
  R(x-12,y+20,12,30,'#2a2a2a');R(x+0,y+20,12,30,'#2a2a2a');
  R(x-14,y+48,14,6,'#111');R(x+0,y+48,14,6,'#111');
  R(x-15,y-5,30,28,rv.singlet);
  R(x-21,y+2,8,26,rv.skin);R(x+13,y+2,8,26,rv.skin);
  C(x+2,y-16,15,rv.skin);
  R(x-12,y-28,28,6,rv.hair);
  R(x-5,y-18,5,2,'#111');R(x+2,y-18,5,2,'#111');
  R(x-3,y-12,6,3,rv.mouthStrain);
  cx.restore();
}

function drawRivalOverhead(x,y){
  var rv=S.rival;
  R(x-10,y+30,10,36,'#2a2a2a');R(x+0,y+30,10,36,'#2a2a2a');
  R(x-12,y+66,14,6,'#111');R(x-2,y+66,14,6,'#111');
  R(x-15,y-10,30,42,rv.singlet);
  R(x-21,y-50,8,44,rv.skin);R(x+13,y-50,8,44,rv.skin);
  C(x-17,y-52,5,rv.skin);C(x+17,y-52,5,rv.skin);
  C(x,y-22,15,rv.skin);
  R(x-14,y-32,28,6,rv.hair);
  R(x-6,y-24,5,2,'#111');R(x+1,y-24,5,2,'#111');
  R(x-3,y-17,6,1,rv.skinDark);
}

function drawRivalFailed(x,y){
  var rv=S.rival;
  var sh=Math.sin(Date.now()/100)*4;
  R(x-10+sh,y+30,10,36,'#2a2a2a');R(x+0+sh,y+30,10,36,'#2a2a2a');
  R(x-15+sh,y-8,30,40,rv.singlet);
  R(x-22+sh,y-4,8,24,rv.skin);R(x+14+sh,y-4,8,24,rv.skin);
  C(x+sh,y-22,15,rv.skin);
  R(x-14+sh,y-32,28,6,rv.hair);
  R(x-6+sh,y-24,5,2,'#111');R(x+1+sh,y-24,5,2,'#111');
  R(x-3+sh,y-17,6,2,rv.skinDark);
}

function drawRivalWalking(x,y){
var rv=S.rival;
var t=Date.now()/200;
var bob=Math.sin(t*3)*2;
var leg=Math.sin(t*3)*6;
R(x-10,y+30+bob,10,36,'#2a2a2a');R(x+0,y+30+bob,10,36,'#2a2a2a');
cx.save();cx.translate(x-5,y+30);cx.rotate(Math.sin(t*3)*0.2);
R(-5,0,10,36,'#2a2a2a');cx.restore();
cx.save();cx.translate(x+5,y+30);cx.rotate(-Math.sin(t*3)*0.2);
R(-5,0,10,36,'#2a2a2a');cx.restore();
R(x-12,y+66+bob,14,6,'#111');R(x-2,y+66+bob,14,6,'#111');
R(x-15,y-10+bob,30,42,rv.singlet);
R(x-22,y-6+bob+leg*0.3,9,28,rv.skin);R(x+13,y-6+bob-leg*0.3,9,28,rv.skin);
C(x,y-22+bob,15,rv.skin);
R(x-14,y-32+bob,28,6,rv.hair);
R(x-6,y-24+bob,5,2,'#111');R(x+1,y-24+bob,5,2,'#111');
R(x-3,y-17+bob,6,1,rv.skinDark);
}

// Snatch-specific poses (wider grip than C&J)
function drawRivalSnatchPull(x,y){
  var rv=S.rival;
  cx.save();cx.translate(x,y);cx.rotate(-0.15);cx.translate(-x,-y);
  R(x-12,y+20,12,30,'#2a2a2a');R(x+0,y+20,12,30,'#2a2a2a');
  R(x-14,y+48,14,6,'#111');R(x+0,y+48,14,6,'#111');
  R(x-15,y-5,30,28,rv.singlet);
  R(x-27,y+2,8,26,rv.skin);R(x+19,y+2,8,26,rv.skin);
  C(x+2,y-16,15,rv.skin);
  R(x-12,y-28,28,6,rv.hair);
  R(x-5,y-18,5,2,'#111');R(x+2,y-18,5,2,'#111');
  R(x-3,y-12,6,3,rv.mouthStrain);
  cx.restore();
}

function drawRivalSnatchOverhead(x,y){
  var rv=S.rival;
  R(x-10,y+30,10,36,'#2a2a2a');R(x+0,y+30,10,36,'#2a2a2a');
  R(x-12,y+66,14,6,'#111');R(x-2,y+66,14,6,'#111');
  R(x-15,y-10,30,42,rv.singlet);
  R(x-29,y-48,10,42,rv.skin);R(x+19,y-48,10,42,rv.skin);
  C(x-29,y-50,5,rv.skin);C(x+25,y-50,5,rv.skin);
  C(x-27,y-18,7,rv.shoulderHighlight);C(x+27,y-18,7,rv.shoulderHighlight);
  C(x,y-22,15,rv.skin);
  R(x-14,y-32,28,6,rv.hair);
  R(x-6,y-24,5,2,'#111');R(x+1,y-24,5,2,'#111');
  R(x-3,y-17,6,1,rv.skinDark);
}

// C&J-specific poses
function drawRivalCleanHold(x,y){
  var rv=S.rival;
  R(x-12,y+28,10,40,'#2a2a2a');R(x+0,y+28,10,40,'#2a2a2a');
  R(x-12,y+66,14,6,'#111');R(x-2,y+66,14,6,'#111');
  R(x-15,y-10,30,38,rv.singlet);
  R(x-23,y-10,10,14,rv.skin);R(x+13,y-10,10,14,rv.skin);
  C(x-19,y-2,6,rv.shoulderHighlight);C(x+19,y-2,6,rv.shoulderHighlight);
  C(x,y-22,15,rv.skin);
  R(x-14,y-32,28,6,rv.hair);
  R(x-6,y-24,5,2,'#111');R(x+1,y-24,5,2,'#111');
  R(x-3,y-17,6,2,rv.skinDark);
}

function drawRivalJerk(x,y){
  var rv=S.rival;
  R(x-8,y+28,10,42,'#2a2a2a');
  cx.save();cx.translate(x+10,y+28);cx.rotate(0.3);R(-5,0,10,44,'#2a2a2a');cx.restore();
  R(x-10,y+68,14,6,'#111');R(x+16,y+66,14,6,'#111');
  R(x-15,y-10,30,40,rv.singlet);
  R(x-21,y-55,8,48,rv.skin);R(x+13,y-55,8,48,rv.skin);
  C(x-17,y-57,5,rv.skin);C(x+17,y-57,5,rv.skin);
  C(x-19,y-24,7,rv.shoulderHighlight);C(x+19,y-24,7,rv.shoulderHighlight);
  C(x,y-22,15,rv.skin);
  R(x-14,y-32,28,6,rv.hair);
  R(x-6,y-24,5,2,'#111');R(x+1,y-24,5,2,'#111');
  R(x-3,y-17,6,1,rv.skinDark);
}

function drawRivalBarbell(bx,by,scale){
  scale=scale||1.0;
  var r=S.rival;
  var phase=r.liftType||S.phase;
  var targets=phase==='snatch'?r.snTargets:r.cjTargets;
  var weight=45;
  if(r.attempt<3)weight=targets[r.attempt]||265;
  else weight=targets[2]||265;
  // Bar
  var barW=Math.round(130*scale),barH=Math.round(3*scale);
  R(bx-barW/2,by-barH/2,barW,barH,'#888');
  // Collars
  var colW=Math.round(6*scale),colH=Math.round(10*scale);
  R(bx-barW/2-colW,by-colH/2,colW,colH,'#555');
  R(bx+barW/2,by-colH/2,colW,colH,'#555');
  // Calculate plates per side
  var remaining=(weight-45)/2;
  var plateSizes=[45,35,25,10,1];
  var plates=[];
  for(var i=0;i<plateSizes.length;i++){while(remaining>=plateSizes[i]){plates.push(plateSizes[i]);remaining-=plateSizes[i];}}
  // Draw plates inside-out
  var lOff=Math.round(70*scale),rOff=Math.round(70*scale);
  for(var pi=0;pi<plates.length;pi++){
    var ps=plates[pi];
    var col=ps>=45?'#cc3333':ps>=35?'#cccc33':ps>=25?'#3355cc':ps>=10?'#40a040':'#aaaaaa';
    var pw=Math.round((ps>=45?7:ps>=35?6:ps>=25?6:ps>=10?5:3)*scale);
    var ph=Math.round((ps>=45?28:ps>=35?24:ps>=25?20:ps>=10?14:8)*scale);
    R(bx-lOff-pw,by-ph/2,pw,ph,col);R(bx+rOff,by-ph/2,pw,ph,col);
    lOff+=pw+1;rOff+=pw+1;
  }
  // Weight label below bar
  if(weight>45){T(weight+'',bx,by+12,Math.round(8*scale),'#666');}
}

function drawRivalHUD(){
  var r=S.rival;
  if(!r.active)return;
  if(S.phase!=='snatch'&&S.phase!=='cj'&&S.phase!=='rest_sn_cj')return;

  // In multi-comp, leaderboard replaces the HUD
  if(S.rivals&&S.rivals.length>1)return;

  // 1v1: Rival score in top-right area
  var hx=780,hy=8;
  var rName=r.name||'PAK CHOL-MIN';
  cx.globalAlpha=0.8;
  T(rName,hx,hy+10,8,'#4a8a4a','left');

  if(S.phase==='snatch'||S.phase==='rest_sn_cj'){
    var snTxt=r.bestSnatch>0?r.bestSnatch+'':'---';
    T('SN: '+snTxt,hx,hy+22,9,r.bestSnatch>0?'#7fdb6a':'#666','left');
    // Attempt dots
    for(var i=0;i<3;i++){
      var dotColor=r.snatchAttempts[i]===null?'#333':r.snatchAttempts[i]?'#7fdb6a':'#ff4444';
      C(hx+60+i*10,hy+20,3,dotColor);
    }
  }
  if(S.phase==='cj'){
    var cjTxt=r.bestCJ>0?r.bestCJ+'':'---';
    T('CJ: '+cjTxt,hx,hy+22,9,r.bestCJ>0?'#7fdb6a':'#666','left');
    for(var i=0;i<3;i++){
      var dotColor=r.cjAttempts[i]===null?'#333':r.cjAttempts[i]?'#7fdb6a':'#ff4444';
      C(hx+60+i*10,hy+20,3,dotColor);
    }
    // Also show snatch result
    if(r.bestSnatch>0){
      T('SN: '+r.bestSnatch,hx,hy+34,8,'#555','left');
    }
  }
  if(S.phase==='rest_sn_cj'){
    // Show comparison
    var rShort=rName.split(' ')[0];
    var tarkSn=S.bestSnatch>0?S.bestSnatch+'':'---';
    T('YOU: '+tarkSn+' vs '+rShort+': '+(r.bestSnatch>0?r.bestSnatch:'---'),W/2,H-30,10,
      S.bestSnatch>r.bestSnatch?'#7fdb6a':S.bestSnatch<r.bestSnatch?'#ff4444':'#cccc33');
  }
  cx.globalAlpha=1;
}

// --- BOOT ---

function boot(){
  cv=document.getElementById('tc');
  if(!cv)return;
  cx=cv.getContext('2d');

  // Make canvas globals available to drawing functions
  window.cv=cv;
  window.cx=cx;

  initState();

  // Mouse events
  cv.addEventListener('mousemove',function(e){
    var rect=cv.getBoundingClientRect();
    var scaleX=W/rect.width;
    var mx=(e.clientX-rect.left)*scaleX;
    var my=(e.clientY-rect.top)*(H/rect.height);

    hover=null;
    window.hover=null;
    mouseX=mx;mouseY=my;
    window.mouseX=mx;window.mouseY=my;

    // Apartment — block hover only for wardrobe sub-menu (fridge/bathroom use canvas zones)
    if(S.phase==='apartment'&&S.apartment.subMenu&&S.apartment.subMenu==='wardrobe'){cv.style.cursor='default';return;}

    // Mode select / roster pick hover
    if(S.phase==='mode_select'){handleModeSelectHover(mx,my);cv.style.cursor=_modeHover?'pointer':'default';return;}
    if(S.phase==='roster_pick'){handleRosterHover(mx,my);cv.style.cursor=_rosterHover?'pointer':'default';return;}

    var curZones=getZones();
    for(var z in curZones){
      var zone=curZones[z];
      if(mx>=zone.x&&mx<=zone.x+zone.w&&my>=zone.y&&my<=zone.y+zone.h){
        hover=z;
        window.hover=z;
        break;
      }
    }
    cv.style.cursor=(hover&&!S.busy)||(hover==='mute')?'pointer':'default';
  });

  // Pickpocket hold-to-reach + Dog chase sprint handlers
  cv.addEventListener('mousedown',function(e){
    if(S.pickpocket){var pk=S.pickpocket;
      if(pk.phase==='picking'){
        // Check bail button first
        if(pk.grabbed>=1&&mouseX>=300&&mouseX<=600&&mouseY>=455&&mouseY<=475){exitPickpocket('escaped');return;}
        // Find closest ungrabbed cig within 20px
        var best=-1,bestD=20;
        for(var ci=0;ci<pk.cigarettes.length;ci++){if(pk.cigarettes[ci].grabbed)continue;var dx=mouseX-pk.cigarettes[ci].cx,dy=mouseY-pk.cigarettes[ci].cy,d=Math.sqrt(dx*dx+dy*dy);if(d<bestD){bestD=d;best=ci;}}
        if(best>=0){pk.targetIdx=best;pk.holding=true;pk.phase='reaching';pk.reach=0;}
      }else if(pk.phase==='reaching'){pk.holding=true;}}
    if(S.dogChase&&S.dogChase.phase==='chasing'){S.dogChase.sprinting=true;}
  });
  cv.addEventListener('mouseup',function(){
    if(S.pickpocket){S.pickpocket.holding=false;if(S.pickpocket.phase==='reaching')S.pickpocket.phase='retracting';}
    if(S.dogChase)S.dogChase.sprinting=false;
  });
  cv.addEventListener('mouseleave',function(){
    if(S.pickpocket){S.pickpocket.holding=false;if(S.pickpocket.phase==='reaching')S.pickpocket.phase='retracting';}
    if(S.dogChase)S.dogChase.sprinting=false;
  });
  cv.addEventListener('touchstart',function(e){
    // Compute touch coords and set hover + mouseX/mouseY (enables click handler on mobile)
    var rect=cv.getBoundingClientRect();
    var tx=(e.touches[0].clientX-rect.left)*(W/rect.width);
    var ty=(e.touches[0].clientY-rect.top)*(H/rect.height);
    mouseX=tx;mouseY=ty;window.mouseX=tx;window.mouseY=ty;
    hover=null;window.hover=null;
    if(S.phase==='mode_select'){handleModeSelectHover(tx,ty);}
    if(S.phase==='roster_pick'){handleRosterHover(tx,ty);}
    var curZones=getZones();
    for(var z in curZones){var zone=curZones[z];
      if(tx>=zone.x&&tx<=zone.x+zone.w&&ty>=zone.y&&ty<=zone.y+zone.h){hover=z;window.hover=z;break;}
    }
    // Dismiss thought bar early on touch (non-blocking)
    if(S.thought)S.thought=null;
    // Special touch-hold handlers (pickpocket, boardwalk, dog chase)
    if(S.pickpocket){var pk=S.pickpocket;
      if(pk.phase==='picking'){
        if(pk.grabbed>=1&&tx>=300&&tx<=600&&ty>=455&&ty<=475){exitPickpocket('escaped');e.preventDefault();return;}
        var best=-1,bestD=25;
        for(var ci=0;ci<pk.cigarettes.length;ci++){if(pk.cigarettes[ci].grabbed)continue;var dx=tx-pk.cigarettes[ci].cx,dy=ty-pk.cigarettes[ci].cy,d=Math.sqrt(dx*dx+dy*dy);if(d<bestD){bestD=d;best=ci;}}
        if(best>=0){pk.targetIdx=best;pk.holding=true;pk.phase='reaching';pk.reach=0;}
      }else if(pk.phase==='reaching'){pk.holding=true;}
      e.preventDefault();return;
    }
    if(S.boardwalk&&S.boardwalk.phase==='playing'&&!S.boardwalk.throwing){
      if(tx>=740&&tx<=870&&ty>=440&&ty<=470){exitBoardwalk();e.preventDefault();return;}
      if(ty>=170&&ty<=240&&tx>=180&&tx<=850&&S.boardwalk.throwsLeft>0){
        doBoardwalkThrow(tx);e.preventDefault();return;
      }
      e.preventDefault();return;
    }
    if(S.dogChase&&S.dogChase.phase==='chasing'){S.dogChase.sprinting=true;e.preventDefault();return;}
    // General touch — trigger click handler with hover already set
    cv.click();
    e.preventDefault();
  },{passive:false});
  cv.addEventListener('touchend',function(e){
    if(S.pickpocket){S.pickpocket.holding=false;if(S.pickpocket.phase==='reaching')S.pickpocket.phase='retracting';}
    if(S.dogChase)S.dogChase.sprinting=false;
    e.preventDefault();
  },{passive:false});

  cv.addEventListener('click',function(){
    SFX.init();
    // MAP overlay — highest priority (data-driven dispatch)
    if(S.mapOpen){
      if(hover==='mapCancel'){S.mapOpen=false;return;}
      for(var mci=0;mci<MAP_LOCATIONS.length;mci++){
        if(hover===MAP_LOCATIONS[mci].zone){doMapTravel(MAP_LOCATIONS[mci].id);break;}
      }
      return;
    }
    // Dismiss thought bar early on click (non-blocking)
    if(S.thought)S.thought=null;
    // ? help button — re-show narration
    if(hover==='helpBtn'){narrateScene();return;}
    // MAP button — open map from any exploration phase
    if(hover==='mapBtn'){S.mapOpen=true;return;}
    // Mini-game click intercept — before all other handlers
    if(S.miniGame&&S.miniGame.active){handleMiniGameClick();return;}
    // Intro skip — any click
    if(S.phase==='intro'){skipIntro();return;}
    // Apartment clicks
    if(S.phase==='apartment'){
      if(hover==='mute'){SFX.toggleMute();return;}
      // Fridge interior clicks
      if(S.apartment.subMenu==='fridge'){
        if(!hover)return;
        if(hover==='eggs')doBreakfastChoice('eggs');
        else if(hover==='pizza')doBreakfastChoice('pizza');
        else if(hover==='coffee')doBreakfastChoice('coffee');
        else if(hover==='shake')doBreakfastChoice('shake');
        else if(hover==='skip')doBreakfastChoice('skip');
        else if(hover==='closeFridge')cancelSubMenu();
        return;
      }
      // Bathroom interior clicks
      if(S.apartment.subMenu==='bathroom'){
        if(!hover)return;
        if(hover==='cold')doBathroomChoice('cold');
        else if(hover==='hot')doBathroomChoice('hot');
        else if(hover==='mirror')doBathroomChoice('mirror');
        else if(hover==='closeBathroom')cancelSubMenu();
        return;
      }
      // VHS selection clicks
      if(S.apartment.subMenu==='vhs'){
        if(!hover)return;
        if(hover==='pumping')doVHSChoice('pumping');
        else if(hover==='predator')doVHSChoice('predator');
        else if(hover==='predator2')doVHSChoice('predator2');
        else if(hover==='rumping')doVHSChoice('rumping');
        else if(hover==='closeVHS')cancelSubMenu();
        return;
      }
      // Phone menu clicks
      if(S.apartment.subMenu==='phone'){
        if(!hover)return;
        if(hover==='callGym')doCallGym();
        else if(hover==='callCoach')doCallCoach();
        else if(hover==='callMother')doCallMother();
        else if(hover==='callRandom1'||hover==='callRandom2'||hover==='callRandom3'){
          float('COMING SOON',450,200,'#888',12);
        }
        else if(hover==='closePhone')cancelSubMenu();
        return;
      }
      // Door choice clicks
      if(S.apartment.subMenu==='door'){
        if(!hover)return;
        if(hover==='hoboZone'&&!S.apartment.pickpocketAttempted){doPickpocket();return;}
        if(hover==='dogZone'&&!S.apartment.dogChaseAttempted){doDogChase();return;}
        if(hover==='doorBeach')doApartmentDoorChoice('beach');
        else if(hover==='doorDowntown')doApartmentDoorChoice('downtown');
        else if(hover==='doorGym')doApartmentDoorChoice('gym');
        else if(hover==='doorCancel')cancelSubMenu();
        return;
      }
      if(S.apartment.subMenu||S.busy)return;
      if(!hover)return;
      if(hover==='fridge')doApartmentFridge();
      else if(hover==='bathroom')doApartmentBathroom();
      else if(hover==='wardrobe')doApartmentWardrobe();
      else if(hover==='cig')doApartmentSmoke();
      else if(hover==='tv')doApartmentTV();
      else if(hover==='phone')doApartmentPhone();
      else if(hover==='dumbbells')doApartmentDumbbells();
      else if(hover==='door')doApartmentDoor();
      else if(hover==='mattress')doApartmentMattress();
      return;
    }
    // Downtown clicks
    if(S.phase==='downtown'){
      // Interior back button
      if(S.downtown.subMenu==='bar'||S.downtown.subMenu==='bodega'||S.downtown.subMenu==='hotel'){
        if(hover==='dtBack')exitDowntownBuilding();
        return;
      }
      // Ma's House exterior
      if(S.downtown.subMenu==='ma_house'){
        if(hover==='helpBtn'){narrateScene();return;}
        if(hover==='mapBtn'){S.mapOpen=true;return;}
        if(hover==='maBack'){exitMaHouse();return;}
        if(hover==='maFrontDoor'){doEnterMaLiving();return;}
        return;
      }
      // Ma's Living Room
      if(S.downtown.subMenu==='ma_living'){
        if(hover==='helpBtn'){narrateScene();return;}
        if(hover==='maTalkToMa'){doTalkToMa();return;}
        if(hover==='maPurseCouch'){doPurseSearch('couch');return;}
        if(hover==='maBack'){maHouseBack('ma_house');return;}
        if(hover==='maKitchenDoor'){doEnterMaKitchen();return;}
        if(hover==='maStaircase'){doEnterMaUpstairs();return;}
        if(hover==='maBasementDoor'){doEnterMaBasement();return;}
        return;
      }
      // Ma's Kitchen
      if(S.downtown.subMenu==='ma_kitchen'){
        if(hover==='helpBtn'){narrateScene();return;}
        if(hover==='maStove'){doStoveClick();return;}
        if(hover==='maFridgeNote'){doPillNoteClick();return;}
        if(hover==='maPurseTable'){doPurseSearch('kitchen');return;}
        if(hover==='maBack'){maHouseBack('ma_living');return;}
        return;
      }
      // Ma's Upstairs Hallway
      if(S.downtown.subMenu==='ma_upstairs'){
        if(hover==='helpBtn'){narrateScene();return;}
        if(hover==='maBack'){maHouseBack('ma_living');return;}
        if(hover==='maTarkDoor'){doEnterMaTarkRoom();return;}
        if(hover==='maMaDoor'){doEnterMaMaRoom();return;}
        if(hover==='maBathDoor'){doEnterMaBath();return;}
        return;
      }
      // Ma's Basement
      if(S.downtown.subMenu==='ma_basement'){
        // During washer kicking, any click adds power
        if(S.downtown.maQuest.washerKicking){doWasherKickClick();return;}
        if(hover==='helpBtn'){narrateScene();return;}
        if(hover==='maWasher'){doWasherClick();return;}
        if(hover==='maBack'){maHouseBack('ma_living');return;}
        return;
      }
      // Tark's Old Room
      if(S.downtown.subMenu==='ma_tark_room'){
        if(hover==='helpBtn'){narrateScene();return;}
        if(hover==='maPurseLaundry'){doPurseSearch('tarkRoom');return;}
        if(hover==='maBack'){maHouseBack('ma_upstairs');return;}
        return;
      }
      // Ma's Bedroom
      if(S.downtown.subMenu==='ma_ma_room'){
        if(hover==='helpBtn'){narrateScene();return;}
        if(hover==='maPills'){doPillsClick();return;}
        if(hover==='maBack'){maHouseBack('ma_upstairs');return;}
        return;
      }
      // Upstairs Bathroom
      if(S.downtown.subMenu==='ma_bath'){
        if(hover==='helpBtn'){narrateScene();return;}
        if(hover==='maPurseToilet'){doPurseSearch('bathroom');return;}
        if(hover==='maBack'){maHouseBack('ma_upstairs');return;}
        return;
      }
      // Exit choice
      if(S.downtown.subMenu==='exit'){
        if(!hover)return;
        if(hover==='exitApt')doDowntownExitChoice('apartment');
        else if(hover==='exitBeach')doDowntownExitChoice('beach');
        else if(hover==='exitGym')doDowntownExitChoice('gym');
        else if(hover==='exitCancel'){S.downtown.subMenu=null;updUI();renderControls();}
        return;
      }
      // Main downtown view
      if(S.busy)return;
      if(!hover)return;
      if(hover==='downtownBar')doDowntownBar();
      else if(hover==='downtownBodega')doDowntownBodega();
      else if(hover==='downtownHotel')doDowntownHotel();
      // downtownMaHouse removed — map handles Ma's house navigation
      else if(hover==='downtownExit')doDowntownExit();
      return;
    }
    // Beach clicks
    if(S.phase==='beach'){
      if(hover==='mute'){SFX.toggleMute();return;}
      // Boardwalk trash toss — click spot on boardwalk
      if(S.beach.subMenu==='boardwalk'){
        var bw=S.boardwalk;
        if(!bw)return;
        if(mouseX>=740&&mouseX<=870&&mouseY>=440&&mouseY<=470){exitBoardwalk();return;}
        if(bw.phase!=='playing'||bw.throwsLeft<=0||bw.throwing)return;
        // Click on boardwalk area to throw
        if(mouseY>=170&&mouseY<=240&&mouseX>=180&&mouseX<=850){
          doBoardwalkThrow(mouseX);
        }
        return;
      }
      // Sewer hub
      if(S.beach.subMenu==='sewer'){
        if(mouseX>=20&&mouseX<=140&&mouseY>=440&&mouseY<=470){exitSewer();return;}
        if(S.busy)return;
        if(mouseX>=70&&mouseX<=190&&mouseY>=100&&mouseY<=220){doSewerLeft();return;}
        if(mouseX>=360&&mouseX<=540&&mouseY>=60&&mouseY<=220){doSewerCenter();return;}
        if(mouseX>=710&&mouseX<=830&&mouseY>=100&&mouseY<=220){doSewerRight();return;}
        // Ladder click (alternate back)
        if(mouseX>=815&&mouseX<=865&&mouseY>=160&&mouseY<=400){exitSewer();return;}
        return;
      }
      // Sewer sub-tunnels (placeholder back)
      if(S.beach.subMenu==='sewer_left'||S.beach.subMenu==='sewer_center'||S.beach.subMenu==='sewer_right'){
        if(mouseX>=20&&mouseX<=140&&mouseY>=440&&mouseY<=470){S.beach.subMenu='sewer';return;}
        return;
      }
      // Middle stall interior
      if(S.beach.subMenu==='middle_stall'){
        if(mouseX>=20&&mouseX<=140&&mouseY>=440&&mouseY<=470){exitMiddleStall();return;}
        if(S.beach.middleFlooded)return;
        if(mouseX>=380&&mouseX<=520&&mouseY>=280&&mouseY<=420){doMiddleFlush();return;}
        return;
      }
      // Right stall interior
      if(S.beach.subMenu==='right_stall'){
        if(mouseX>=20&&mouseX<=140&&mouseY>=440&&mouseY<=470){exitRightStall();return;}
        if(S.beach.rightPaperPulling)return;
        if(mouseX>=110&&mouseX<=250&&mouseY>=90&&mouseY<=175&&S.beach.rightPaperPulls<12){
          S.beach.rightPaperPulling=true;S.beach.rightPaperPullT=0;return;
        }
        if(S.beach.rightPaperEmpty&&!S.beach.hasPaper&&mouseX>=80&&mouseX<=230&&mouseY>=380&&mouseY<=420){
          doPocketPaper();return;
        }
        if(S.beach.hasPaper&&!S.beach.toiletStuffed&&mouseX>=580&&mouseX<=720&&mouseY>=280&&mouseY<=420){
          doStuffToilet();return;
        }
        if(S.beach.toiletStuffed&&!S.beach.rightToiletFlushed&&mouseX>=580&&mouseX<=720&&mouseY>=280&&mouseY<=420){
          doFlushStuffedToilet();return;
        }
        return;
      }
      // Out-of-order stall interior (hole to sewer)
      if(S.beach.subMenu==='stall'){
        if(mouseX>=20&&mouseX<=140&&mouseY>=440&&mouseY<=470){exitStall();return;}
        if(S.beach.holeDescending)return;
        if(mouseX>=560&&mouseX<=680&&mouseY>=350&&mouseY<=420){
          if(!S.beach.holeExamined){
            S.beach.holeExamined=true;
            log("A gaping hole where the toilet should be. Broken pipes. It goes deep.","info");
            float('???',620,340,'#ffcc00',14);
          }else{
            S.beach.holeDescending=true;S.beach.holeDescendT=0;
          }
          return;
        }
        return;
      }
      // Beach bathroom exterior sub-menu
      if(S.beach.subMenu==='bathroom'){
        if(mouseX>=20&&mouseX<=140&&mouseY>=440&&mouseY<=470){exitBeachBathroom();return;}
        if(S.beach.fountainKicking)return;
        // Middle stall door (open until flooded)
        if(!S.beach.middleFlooded&&mouseX>=340&&mouseX<=424&&mouseY>=190&&mouseY<=400){
          doEnterMiddleStall();return;
        }
        // Right stall door (after man leaves)
        if(!S.beach.rightStallOccupied&&mouseX>=480&&mouseX<=564&&mouseY>=190&&mouseY<=400){
          doEnterRightStall();return;
        }
        // Fountain drink (before drunk, before broken)
        if(!S.beach.fountainDrunk&&S.beach.fountainKicks<7&&mouseX>=710&&mouseX<=760&&mouseY>=280&&mouseY<=410){
          doFountainDrink();return;
        }
        // Kick fountain
        if(S.beach.fountainKicks<7&&mouseX>=710&&mouseX<=760&&mouseY>=280&&mouseY<=410){
          S.beach.fountainKicking=true;S.beach.fountainKickT=0;return;
        }
        // Pick up fountain piece
        if(S.beach.fountainKicks>=7&&!S.beach.holdingPiece&&!S.beach.doorCracked&&mouseX>=700&&mouseX<=750&&mouseY>=388&&mouseY<=410){
          doPickUpPiece();return;
        }
        // Smash out-of-order door (holding piece)
        if(S.beach.holdingPiece&&!S.beach.doorCracked&&mouseX>=620&&mouseX<=704&&mouseY>=190&&mouseY<=400){
          doSmashDoor();return;
        }
        // Enter out-of-order stall (after smashed)
        if(S.beach.doorCracked&&mouseX>=620&&mouseX<=704&&mouseY>=190&&mouseY<=400){
          doEnterStall();return;
        }
        return;
      }
      // Couple close-up sub-menu
      if(S.beach.subMenu==='couple'){
        if(!hover)return;
        if(hover==='closeCouple'){doBeachCancelSubMenu();return;}
        if(S.beach.closeupAnim||S.busy)return;
        var bci=S.beach.activeCouple;
        if(hover==='beachBeerZone')doBeachBeer(bci);
        else if(hover==='beachShirtZone')doBeachSituation(bci);
        else if(hover==='beachWomanZone')doBeachFlirt(bci);
        else if(hover==='beachManZone')doBeachInsult(bci);
        return;
      }
      // Beach gym competition (C&J 3-attempt)
      if(S.beach.gymComp.active){
        if(!hover)return;
        // Item + taunt zones during Tark's declare phase
        if(hover==='beerZone'){doBeachCompBeer();return;}
        if(hover==='cigZone'){doBeachCompSmoke();return;}
        if(hover==='chalkZone'){doBeachChalk();return;}
        if(hover==='girlZone'){doBeachGirl();return;}
        if(hover==='tauntZone'){doBeachCompTaunt();return;}
        return;
      }
      if(S.busy)return;
      if(!hover)return;
      if(hover==='couple0')doBeachApproachCouple(0);
      else if(hover==='couple1')doBeachApproachCouple(1);
      else if(hover==='couple2')doBeachApproachCouple(2);
      else if(hover==='boardwalkZone')doBoardwalk();
      else if(hover==='beachBathroom')doBeachBathroom();
      else if(hover==='beachExit')doBeachExit();
      return;
    }
    // Mode select / roster pick clicks
    if(S.phase==='mode_select'){handleModeSelectClick();return;}
    if(S.phase==='roster_pick'){handleRosterClick();return;}
    // Mute toggle — always works, even when busy
    if(hover==='mute'){SFX.toggleMute();return;}
    if(!hover||S.busy)return;

    // Rack click adds plates (all phases)
    if(hover==='rack'){
      var shelf=getShelfAt(mouseY);
      if(shelf)addPlate(shelf.size);
      return;
    }

    if(S.phase==='gym'){
      if(hover==='gymExit')doGymExit();
      else if(hover==='bench')doBench();
      else if(hover==='shake')doShake();
      else if(hover==='cig')doSmoke();
      else if(hover==='chalk')doChalk();
      else if(hover==='coach')doTalkToCoach();
    }else if(S.phase==='warmup'){
      if(hover&&hover.indexOf('feat_')===0){doTaunt(hover.replace('feat_',''));return;}
      if(hover==='platform_rival'&&is1v1()){doTaunt(S.rivals[0].id);return;}
      if(hover==='bench')doBench();
      else if(hover==='shake')doShake();
      else if(hover==='cig')doSmoke();
      else if(hover==='chalk')doChalk();
      else if(hover==='coach')doTalkToCoach();
    }else if(S.phase==='snatch'||S.phase==='cj'){
      if(hover==='comp_rival'&&is1v1()){doCompTaunt();return;}
      if(hover==='bench')doBench();
      else if(hover==='shake')doShake();
      else if(hover==='cig')doSmoke();
      else if(hover==='chalk')doChalk();
      else if(hover==='coach')doTalkToCoach();
    }else if(S.phase==='rest_sn_cj'){
      if(hover==='bench')doBench();
      else if(hover==='shake')doShake();
      else if(hover==='cig')doSmoke();
      else if(hover==='chalk')doChalk();
      else if(hover==='coach')doTalkToCoach();
    }
  });

  // Start — returning players get condensed intro (2s), new players get full (8s)
  if(S.firstGame){
    setPhase('intro');
  }else{
    // Condensed intro: just title slam for 2s
    S.intro.started=true;
    S.intro.t=Date.now()-6500; // skip to near the title
    setPhase('intro');
  }
  draw();
}

function safeBoot(){
  try{boot();
    // Flash green bar briefly to confirm JS loaded
    if(cx){cx.fillStyle='#0a0';cx.fillRect(0,0,W,3);}
  }catch(e){
    var d=document.createElement('div');
    d.style.cssText='position:fixed;top:0;left:0;right:0;background:red;color:white;padding:16px;font:14px monospace;z-index:99999';
    d.textContent='BOOT CRASH ('+BUILD_V+'): '+e.message+' @ '+(e.stack||'').split('\n').slice(0,2).join(' | ');
    document.body.appendChild(d);
  }
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',safeBoot);}else{safeBoot();}

// --- PUBLIC API ---
return {
  doBench:doBench, doShake:doShake, doSmoke:doSmoke, doChalk:doChalk,
  doGymLift:doGymLift, doWarmupLift:doWarmupLift, doChatUp:doChatUp,
  addPlate:addPlate, dropPlate:dropPlate,
  enterMeet:enterMeet,
  beginCompetition:beginCompetition, beginCJ:beginCJ,
  doCompLift:doCompLift,
  declareWeight:declareWeight,
  declareTypedWeight:declareTypedWeight,
  walkToPlatformAndLift:walkToPlatformAndLift,
  doRitualChalk:doRitualChalk, doRitualCoach:doRitualCoach, doRitualPsyche:doRitualPsyche,
  doStretch:doStretch,
  declareOpener:declareOpener,
  doTaunt:doTaunt,
  doCompTaunt:doCompTaunt,
  copyShare:copyShare, restart:restart,
  doApartmentFridge:doApartmentFridge, doBreakfastChoice:doBreakfastChoice,
  doApartmentBathroom:doApartmentBathroom, doBathroomChoice:doBathroomChoice,
  doApartmentWardrobe:doApartmentWardrobe, doHeadbandChoice:doHeadbandChoice, doShirtChoice:doShirtChoice,
  doApartmentTV:doApartmentTV, doVHSChoice:doVHSChoice, doApartmentPhone:doApartmentPhone,
  doApartmentDumbbells:doApartmentDumbbells, doApartmentSmoke:doApartmentSmoke,
  doApartmentMattress:doApartmentMattress, doApartmentDoor:doApartmentDoor, doApartmentDoorChoice:doApartmentDoorChoice,
  cancelSubMenu:cancelSubMenu,
  // Downtown phase
  doDowntownBar:doDowntownBar, doDowntownBodega:doDowntownBodega, doDowntownHotel:doDowntownHotel,
  doDowntownExit:doDowntownExit, doDowntownExitChoice:doDowntownExitChoice, exitDowntownBuilding:exitDowntownBuilding,
  // Beach phase
  doBeachApproachCouple:doBeachApproachCouple, doBeachCancelSubMenu:doBeachCancelSubMenu,
  doBeachSmoke:doBeachSmoke, doBeachBeer:doBeachBeer, doBeachFlirt:doBeachFlirt,
  doBeachSituation:doBeachSituation, doBeachInsult:doBeachInsult,
  doBeachAdjustWeight:doBeachAdjustWeight, doBeachLift:doBeachLift, doBeachGymDone:doBeachGymDone,
  doBeachCompBeer:doBeachCompBeer, doBeachCompSmoke:doBeachCompSmoke, doBeachCompTaunt:doBeachCompTaunt,
  doBeachChalk:doBeachChalk, doBeachGirl:doBeachGirl,
  doBeachExit:doBeachExit,
  doBoardwalk:doBoardwalk, doBoardwalkThrow:doBoardwalkThrow, exitBoardwalk:exitBoardwalk,
  doBeachBathroom:doBeachBathroom, exitBeachBathroom:exitBeachBathroom,
  doEnterStall:doEnterStall, exitStall:exitStall,
  enterSewer:enterSewer, exitSewer:exitSewer,
  doSewerLeft:doSewerLeft, doSewerCenter:doSewerCenter, doSewerRight:doSewerRight
};

})();